// Auto-generated HARD-CODED progress data (no runtime generation).
// Each project_GUID maps to an array of weekly ProgressPoint rows.
// baseline_complete/actual_complete/forecast_complete are all populated for all reporting_dates; your UI can enforce rules like
// 'actual_complete stops at today' and 'forecast_complete starts after today' at render time.

export type ProgressPoint = {
  project_GUID: string;
  reporting_date: string; // YYYY-MM-DD
  baseline_complete: number;
  actual_complete: number;
  forecast_complete: number;
};

export const progressByProjectGUID: Record<string, ProgressPoint[]> = {
  "f3b1d569-688c-4756-fc75-ecdd332b3147": [
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-08-18",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-08-25",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-09-01",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-09-08",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-09-15",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-09-22",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-09-29",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-10-06",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-10-13",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-10-20",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-10-27",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-11-03",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-11-10",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-11-17",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-11-24",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-12-01",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-12-08",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-12-15",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-12-22",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2024-12-29",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-01-05",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-01-12",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-01-19",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-01-26",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-02-02",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-02-09",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-02-16",
      baseline_complete: 2.6,
      actual_complete: 0.6,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-02-23",
      baseline_complete: 2.7,
      actual_complete: 0.6,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-03-02",
      baseline_complete: 2.9,
      actual_complete: 0.6,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-03-09",
      baseline_complete: 3.0,
      actual_complete: 0.6,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-03-16",
      baseline_complete: 3.2,
      actual_complete: 0.6,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-03-23",
      baseline_complete: 3.3,
      actual_complete: 0.6,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-03-30",
      baseline_complete: 3.5,
      actual_complete: 0.6,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-04-06",
      baseline_complete: 3.7,
      actual_complete: 0.6,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-04-13",
      baseline_complete: 3.9,
      actual_complete: 0.6,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-04-20",
      baseline_complete: 4.1,
      actual_complete: 1.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-04-27",
      baseline_complete: 4.3,
      actual_complete: 1.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-05-04",
      baseline_complete: 4.6,
      actual_complete: 1.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-05-11",
      baseline_complete: 4.8,
      actual_complete: 2.9,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-05-18",
      baseline_complete: 5.1,
      actual_complete: 2.9,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-05-25",
      baseline_complete: 5.3,
      actual_complete: 2.9,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-06-01",
      baseline_complete: 5.6,
      actual_complete: 3.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-06-08",
      baseline_complete: 5.9,
      actual_complete: 3.7,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-06-15",
      baseline_complete: 6.2,
      actual_complete: 3.7,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-06-22",
      baseline_complete: 6.5,
      actual_complete: 3.7,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-06-29",
      baseline_complete: 6.9,
      actual_complete: 3.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-07-06",
      baseline_complete: 7.2,
      actual_complete: 3.7,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-07-13",
      baseline_complete: 7.6,
      actual_complete: 5.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-07-20",
      baseline_complete: 8.0,
      actual_complete: 5.5,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-07-27",
      baseline_complete: 8.4,
      actual_complete: 5.5,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-08-03",
      baseline_complete: 8.8,
      actual_complete: 5.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-08-10",
      baseline_complete: 9.2,
      actual_complete: 8.7,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-08-17",
      baseline_complete: 9.7,
      actual_complete: 8.7,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-08-24",
      baseline_complete: 10.2,
      actual_complete: 8.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-08-31",
      baseline_complete: 10.7,
      actual_complete: 9.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-09-07",
      baseline_complete: 11.2,
      actual_complete: 9.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-09-14",
      baseline_complete: 11.8,
      actual_complete: 9.3,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-09-21",
      baseline_complete: 12.3,
      actual_complete: 10.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-09-28",
      baseline_complete: 12.9,
      actual_complete: 10.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-10-05",
      baseline_complete: 13.5,
      actual_complete: 10.6,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-10-12",
      baseline_complete: 14.2,
      actual_complete: 12.7,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-10-19",
      baseline_complete: 14.8,
      actual_complete: 12.7,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-10-26",
      baseline_complete: 15.5,
      actual_complete: 14.8,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-11-02",
      baseline_complete: 16.3,
      actual_complete: 14.8,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-11-09",
      baseline_complete: 17.0,
      actual_complete: 15.4,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-11-16",
      baseline_complete: 17.8,
      actual_complete: 15.4,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-11-23",
      baseline_complete: 18.6,
      actual_complete: 15.4,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-11-30",
      baseline_complete: 19.4,
      actual_complete: 15.4,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-12-07",
      baseline_complete: 20.3,
      actual_complete: 15.4,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-12-14",
      baseline_complete: 21.2,
      actual_complete: 21.6,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-12-21",
      baseline_complete: 22.1,
      actual_complete: 21.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2025-12-28",
      baseline_complete: 23.0,
      actual_complete: 21.9,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-01-04",
      baseline_complete: 24.0,
      actual_complete: 21.9,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-01-11",
      baseline_complete: 25.0,
      actual_complete: 21.9,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-01-18",
      baseline_complete: 26.0,
      actual_complete: 21.9,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-01-25",
      baseline_complete: 27.0,
      actual_complete: 24.4,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-02-01",
      baseline_complete: 28.1,
      actual_complete: 24.4,
      forecast_complete: 12.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-02-08",
      baseline_complete: 29.2,
      actual_complete: 26.8,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-02-15",
      baseline_complete: 30.3,
      actual_complete: 26.8,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-02-22",
      baseline_complete: 31.5,
      actual_complete: 28.3,
      forecast_complete: 14.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-03-01",
      baseline_complete: 32.7,
      actual_complete: 28.3,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-03-08",
      baseline_complete: 33.9,
      actual_complete: 28.3,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-03-15",
      baseline_complete: 35.1,
      actual_complete: 32.6,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-03-22",
      baseline_complete: 36.3,
      actual_complete: 32.6,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-03-29",
      baseline_complete: 37.6,
      actual_complete: 32.8,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-04-05",
      baseline_complete: 38.8,
      actual_complete: 33.3,
      forecast_complete: 18.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-04-12",
      baseline_complete: 40.1,
      actual_complete: 39.4,
      forecast_complete: 19.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-04-19",
      baseline_complete: 41.4,
      actual_complete: 39.8,
      forecast_complete: 20.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-04-26",
      baseline_complete: 42.7,
      actual_complete: 41.4,
      forecast_complete: 21.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-05-03",
      baseline_complete: 44.1,
      actual_complete: 43.5,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-05-10",
      baseline_complete: 45.4,
      actual_complete: 43.5,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-05-17",
      baseline_complete: 46.7,
      actual_complete: 46.5,
      forecast_complete: 24.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-05-24",
      baseline_complete: 48.1,
      actual_complete: 47.1,
      forecast_complete: 25.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-05-31",
      baseline_complete: 49.4,
      actual_complete: 48.1,
      forecast_complete: 26.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-06-07",
      baseline_complete: 50.8,
      actual_complete: 49.8,
      forecast_complete: 27.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-06-14",
      baseline_complete: 52.1,
      actual_complete: 49.8,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-06-21",
      baseline_complete: 53.4,
      actual_complete: 51.4,
      forecast_complete: 29.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-06-28",
      baseline_complete: 54.8,
      actual_complete: 54.0,
      forecast_complete: 30.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-07-05",
      baseline_complete: 56.1,
      actual_complete: 54.0,
      forecast_complete: 31.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-07-12",
      baseline_complete: 57.4,
      actual_complete: 57.3,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-07-19",
      baseline_complete: 58.7,
      actual_complete: 58.1,
      forecast_complete: 33.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-07-26",
      baseline_complete: 60.0,
      actual_complete: 58.1,
      forecast_complete: 34.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-08-02",
      baseline_complete: 61.3,
      actual_complete: 58.1,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-08-09",
      baseline_complete: 62.6,
      actual_complete: 64.6,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-08-16",
      baseline_complete: 63.9,
      actual_complete: 64.6,
      forecast_complete: 37.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-08-23",
      baseline_complete: 65.1,
      actual_complete: 64.6,
      forecast_complete: 38.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-08-30",
      baseline_complete: 66.3,
      actual_complete: 64.6,
      forecast_complete: 39.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-09-06",
      baseline_complete: 67.5,
      actual_complete: 64.6,
      forecast_complete: 40.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-09-13",
      baseline_complete: 68.7,
      actual_complete: 64.6,
      forecast_complete: 41.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-09-20",
      baseline_complete: 69.8,
      actual_complete: 66.7,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-09-27",
      baseline_complete: 70.9,
      actual_complete: 66.7,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-10-04",
      baseline_complete: 72.0,
      actual_complete: 71.9,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-10-11",
      baseline_complete: 73.1,
      actual_complete: 72.0,
      forecast_complete: 46.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-10-18",
      baseline_complete: 74.1,
      actual_complete: 72.0,
      forecast_complete: 47.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-10-25",
      baseline_complete: 75.2,
      actual_complete: 75.2,
      forecast_complete: 48.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-11-01",
      baseline_complete: 76.2,
      actual_complete: 75.2,
      forecast_complete: 49.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-11-08",
      baseline_complete: 77.1,
      actual_complete: 75.2,
      forecast_complete: 50.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-11-15",
      baseline_complete: 78.1,
      actual_complete: 76.5,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-11-22",
      baseline_complete: 79.0,
      actual_complete: 76.5,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-11-29",
      baseline_complete: 79.8,
      actual_complete: 76.7,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-12-06",
      baseline_complete: 80.7,
      actual_complete: 80.3,
      forecast_complete: 54.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-12-13",
      baseline_complete: 81.5,
      actual_complete: 81.3,
      forecast_complete: 55.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-12-20",
      baseline_complete: 82.3,
      actual_complete: 81.3,
      forecast_complete: 56.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2026-12-27",
      baseline_complete: 83.1,
      actual_complete: 83.2,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-01-03",
      baseline_complete: 83.8,
      actual_complete: 83.2,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-01-10",
      baseline_complete: 84.6,
      actual_complete: 85.6,
      forecast_complete: 59.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-01-17",
      baseline_complete: 85.2,
      actual_complete: 85.6,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-01-24",
      baseline_complete: 85.9,
      actual_complete: 88.7,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-01-31",
      baseline_complete: 86.5,
      actual_complete: 88.7,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-02-07",
      baseline_complete: 87.2,
      actual_complete: 88.7,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-02-14",
      baseline_complete: 87.8,
      actual_complete: 89.1,
      forecast_complete: 64.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-02-21",
      baseline_complete: 88.3,
      actual_complete: 89.1,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-02-28",
      baseline_complete: 88.9,
      actual_complete: 90.0,
      forecast_complete: 66.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-03-07",
      baseline_complete: 89.4,
      actual_complete: 90.0,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-03-14",
      baseline_complete: 89.9,
      actual_complete: 90.0,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-03-21",
      baseline_complete: 90.4,
      actual_complete: 91.6,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-03-28",
      baseline_complete: 90.8,
      actual_complete: 91.6,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-04-04",
      baseline_complete: 91.3,
      actual_complete: 93.5,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-04-11",
      baseline_complete: 91.7,
      actual_complete: 94.3,
      forecast_complete: 73.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-04-18",
      baseline_complete: 92.1,
      actual_complete: 94.3,
      forecast_complete: 75.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-04-25",
      baseline_complete: 92.5,
      actual_complete: 94.3,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-05-02",
      baseline_complete: 92.8,
      actual_complete: 94.3,
      forecast_complete: 77.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-05-09",
      baseline_complete: 93.2,
      actual_complete: 94.3,
      forecast_complete: 78.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-05-16",
      baseline_complete: 93.5,
      actual_complete: 94.3,
      forecast_complete: 80.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-05-23",
      baseline_complete: 93.8,
      actual_complete: 94.3,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-05-30",
      baseline_complete: 94.1,
      actual_complete: 94.3,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-06-06",
      baseline_complete: 94.4,
      actual_complete: 97.5,
      forecast_complete: 83.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-06-13",
      baseline_complete: 94.7,
      actual_complete: 97.5,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-06-20",
      baseline_complete: 95.0,
      actual_complete: 97.5,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-06-27",
      baseline_complete: 95.2,
      actual_complete: 97.7,
      forecast_complete: 86.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-07-04",
      baseline_complete: 95.5,
      actual_complete: 97.7,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-07-11",
      baseline_complete: 95.7,
      actual_complete: 97.7,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-07-18",
      baseline_complete: 95.9,
      actual_complete: 97.7,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-07-25",
      baseline_complete: 96.1,
      actual_complete: 100.0,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-08-01",
      baseline_complete: 96.3,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-08-08",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-08-15",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-08-22",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-08-29",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-09-05",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-09-12",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-09-19",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-09-26",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-10-03",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-10-10",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-10-17",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-10-24",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-10-31",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-11-07",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-11-14",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-11-21",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-11-28",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-12-05",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-12-12",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-12-19",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2027-12-26",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2028-01-02",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2028-01-09",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2028-01-16",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "f3b1d569-688c-4756-fc75-ecdd332b3147",
      reporting_date: "2028-01-18",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "cf344fa3-2497-b57f-489a-dd77068c77ff": [
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-09-02",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-09-09",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-09-16",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-09-23",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-09-30",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-10-07",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-10-14",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-10-21",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-10-28",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-11-04",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-11-11",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-11-18",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-11-25",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-12-02",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-12-09",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-12-16",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-12-23",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2023-12-30",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-01-06",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-01-13",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-01-20",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-01-27",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-02-03",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-02-10",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-02-17",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-02-24",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-03-02",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-03-09",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-03-16",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-03-23",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-03-30",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-04-06",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-04-13",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-04-20",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-04-27",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-05-04",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-05-11",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-05-18",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-05-25",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-06-01",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-06-08",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-06-15",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-06-22",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-06-29",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-07-06",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-07-13",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-07-20",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-07-27",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-08-03",
      baseline_complete: 3.7,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-08-10",
      baseline_complete: 4.0,
      actual_complete: 0.1,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-08-17",
      baseline_complete: 4.2,
      actual_complete: 0.1,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-08-24",
      baseline_complete: 4.4,
      actual_complete: 0.1,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-08-31",
      baseline_complete: 4.7,
      actual_complete: 0.1,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-09-07",
      baseline_complete: 5.0,
      actual_complete: 0.1,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-09-14",
      baseline_complete: 5.2,
      actual_complete: 0.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-09-21",
      baseline_complete: 5.5,
      actual_complete: 1.9,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-09-28",
      baseline_complete: 5.9,
      actual_complete: 3.9,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-10-05",
      baseline_complete: 6.2,
      actual_complete: 3.9,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-10-12",
      baseline_complete: 6.5,
      actual_complete: 4.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-10-19",
      baseline_complete: 6.9,
      actual_complete: 4.5,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-10-26",
      baseline_complete: 7.3,
      actual_complete: 5.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-11-02",
      baseline_complete: 7.7,
      actual_complete: 5.2,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-11-09",
      baseline_complete: 8.1,
      actual_complete: 5.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-11-16",
      baseline_complete: 8.6,
      actual_complete: 5.2,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-11-23",
      baseline_complete: 9.1,
      actual_complete: 5.2,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-11-30",
      baseline_complete: 9.6,
      actual_complete: 6.2,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-12-07",
      baseline_complete: 10.1,
      actual_complete: 6.2,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-12-14",
      baseline_complete: 10.6,
      actual_complete: 7.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-12-21",
      baseline_complete: 11.2,
      actual_complete: 7.0,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2024-12-28",
      baseline_complete: 11.8,
      actual_complete: 7.0,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-01-04",
      baseline_complete: 12.4,
      actual_complete: 7.0,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-01-11",
      baseline_complete: 13.1,
      actual_complete: 10.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-01-18",
      baseline_complete: 13.8,
      actual_complete: 10.2,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-01-25",
      baseline_complete: 14.5,
      actual_complete: 10.5,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-02-01",
      baseline_complete: 15.2,
      actual_complete: 10.6,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-02-08",
      baseline_complete: 16.0,
      actual_complete: 10.6,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-02-15",
      baseline_complete: 16.8,
      actual_complete: 10.6,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-02-22",
      baseline_complete: 17.6,
      actual_complete: 14.8,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-03-01",
      baseline_complete: 18.5,
      actual_complete: 16.0,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-03-08",
      baseline_complete: 19.4,
      actual_complete: 16.0,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-03-15",
      baseline_complete: 20.4,
      actual_complete: 16.0,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-03-22",
      baseline_complete: 21.3,
      actual_complete: 17.7,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-03-29",
      baseline_complete: 22.3,
      actual_complete: 20.5,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-04-05",
      baseline_complete: 23.4,
      actual_complete: 20.5,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-04-12",
      baseline_complete: 24.4,
      actual_complete: 21.4,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-04-19",
      baseline_complete: 25.6,
      actual_complete: 21.4,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-04-26",
      baseline_complete: 26.7,
      actual_complete: 25.2,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-05-03",
      baseline_complete: 27.9,
      actual_complete: 25.2,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-05-10",
      baseline_complete: 29.1,
      actual_complete: 25.2,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-05-17",
      baseline_complete: 30.3,
      actual_complete: 27.9,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-05-24",
      baseline_complete: 31.5,
      actual_complete: 27.9,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-05-31",
      baseline_complete: 32.8,
      actual_complete: 29.4,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-06-07",
      baseline_complete: 34.1,
      actual_complete: 32.6,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-06-14",
      baseline_complete: 35.5,
      actual_complete: 32.6,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-06-21",
      baseline_complete: 36.8,
      actual_complete: 35.2,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-06-28",
      baseline_complete: 38.2,
      actual_complete: 35.2,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-07-05",
      baseline_complete: 39.6,
      actual_complete: 35.2,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-07-12",
      baseline_complete: 41.0,
      actual_complete: 39.0,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-07-19",
      baseline_complete: 42.5,
      actual_complete: 39.0,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-07-26",
      baseline_complete: 43.9,
      actual_complete: 41.0,
      forecast_complete: 20.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-08-02",
      baseline_complete: 45.4,
      actual_complete: 42.2,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-08-09",
      baseline_complete: 46.8,
      actual_complete: 42.8,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-08-16",
      baseline_complete: 48.3,
      actual_complete: 47.3,
      forecast_complete: 22.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-08-23",
      baseline_complete: 49.8,
      actual_complete: 47.3,
      forecast_complete: 23.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-08-30",
      baseline_complete: 51.2,
      actual_complete: 47.3,
      forecast_complete: 24.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-09-06",
      baseline_complete: 52.7,
      actual_complete: 52.1,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-09-13",
      baseline_complete: 54.2,
      actual_complete: 52.1,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-09-20",
      baseline_complete: 55.6,
      actual_complete: 52.1,
      forecast_complete: 27.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-09-27",
      baseline_complete: 57.1,
      actual_complete: 57.3,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-10-04",
      baseline_complete: 58.5,
      actual_complete: 57.5,
      forecast_complete: 29.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-10-11",
      baseline_complete: 59.9,
      actual_complete: 57.5,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-10-18",
      baseline_complete: 61.4,
      actual_complete: 58.9,
      forecast_complete: 31.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-10-25",
      baseline_complete: 62.7,
      actual_complete: 60.7,
      forecast_complete: 31.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-11-01",
      baseline_complete: 64.1,
      actual_complete: 60.7,
      forecast_complete: 32.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-11-08",
      baseline_complete: 65.4,
      actual_complete: 60.7,
      forecast_complete: 33.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-11-15",
      baseline_complete: 66.8,
      actual_complete: 63.4,
      forecast_complete: 34.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-11-22",
      baseline_complete: 68.1,
      actual_complete: 65.7,
      forecast_complete: 35.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-11-29",
      baseline_complete: 69.3,
      actual_complete: 65.7,
      forecast_complete: 36.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-12-06",
      baseline_complete: 70.6,
      actual_complete: 66.5,
      forecast_complete: 37.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-12-13",
      baseline_complete: 71.8,
      actual_complete: 66.5,
      forecast_complete: 38.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-12-20",
      baseline_complete: 73.0,
      actual_complete: 73.4,
      forecast_complete: 39.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2025-12-27",
      baseline_complete: 74.1,
      actual_complete: 73.4,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-01-03",
      baseline_complete: 75.2,
      actual_complete: 73.4,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-01-10",
      baseline_complete: 76.3,
      actual_complete: 73.4,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-01-17",
      baseline_complete: 77.3,
      actual_complete: 77.6,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-01-24",
      baseline_complete: 78.4,
      actual_complete: 77.6,
      forecast_complete: 44.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-01-31",
      baseline_complete: 79.3,
      actual_complete: 77.6,
      forecast_complete: 45.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-02-07",
      baseline_complete: 80.3,
      actual_complete: 77.6,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-02-14",
      baseline_complete: 81.2,
      actual_complete: 78.8,
      forecast_complete: 46.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-02-21",
      baseline_complete: 82.1,
      actual_complete: 81.8,
      forecast_complete: 47.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-02-28",
      baseline_complete: 82.9,
      actual_complete: 81.8,
      forecast_complete: 48.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-03-07",
      baseline_complete: 83.8,
      actual_complete: 81.8,
      forecast_complete: 49.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-03-14",
      baseline_complete: 84.5,
      actual_complete: 85.6,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-03-21",
      baseline_complete: 85.3,
      actual_complete: 85.6,
      forecast_complete: 51.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-03-28",
      baseline_complete: 86.0,
      actual_complete: 85.6,
      forecast_complete: 51.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-04-04",
      baseline_complete: 86.7,
      actual_complete: 85.6,
      forecast_complete: 52.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-04-11",
      baseline_complete: 87.4,
      actual_complete: 85.6,
      forecast_complete: 53.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-04-18",
      baseline_complete: 88.0,
      actual_complete: 88.4,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-04-25",
      baseline_complete: 88.6,
      actual_complete: 88.4,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-05-02",
      baseline_complete: 89.2,
      actual_complete: 89.7,
      forecast_complete: 55.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-05-09",
      baseline_complete: 89.8,
      actual_complete: 89.7,
      forecast_complete: 56.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-05-16",
      baseline_complete: 90.3,
      actual_complete: 91.5,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-05-23",
      baseline_complete: 90.8,
      actual_complete: 91.5,
      forecast_complete: 57.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-05-30",
      baseline_complete: 91.3,
      actual_complete: 91.5,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-06-06",
      baseline_complete: 91.7,
      actual_complete: 91.5,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-06-13",
      baseline_complete: 92.2,
      actual_complete: 91.5,
      forecast_complete: 59.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-06-20",
      baseline_complete: 92.6,
      actual_complete: 91.5,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-06-27",
      baseline_complete: 93.0,
      actual_complete: 91.5,
      forecast_complete: 61.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-07-04",
      baseline_complete: 93.3,
      actual_complete: 91.5,
      forecast_complete: 61.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-07-11",
      baseline_complete: 93.7,
      actual_complete: 91.5,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-07-18",
      baseline_complete: 94.0,
      actual_complete: 91.5,
      forecast_complete: 63.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-07-25",
      baseline_complete: 94.4,
      actual_complete: 94.9,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-08-01",
      baseline_complete: 94.7,
      actual_complete: 94.9,
      forecast_complete: 64.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-08-08",
      baseline_complete: 95.0,
      actual_complete: 94.9,
      forecast_complete: 65.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-08-15",
      baseline_complete: 95.2,
      actual_complete: 94.9,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-08-22",
      baseline_complete: 95.5,
      actual_complete: 94.9,
      forecast_complete: 66.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-08-29",
      baseline_complete: 95.7,
      actual_complete: 94.9,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-09-05",
      baseline_complete: 96.0,
      actual_complete: 94.9,
      forecast_complete: 67.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-09-12",
      baseline_complete: 96.2,
      actual_complete: 94.9,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-09-19",
      baseline_complete: 96.4,
      actual_complete: 94.9,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-09-26",
      baseline_complete: 96.6,
      actual_complete: 99.7,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-10-03",
      baseline_complete: 96.8,
      actual_complete: 99.7,
      forecast_complete: 69.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-10-10",
      baseline_complete: 97.0,
      actual_complete: 99.7,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-10-17",
      baseline_complete: 97.1,
      actual_complete: 99.7,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-10-24",
      baseline_complete: 97.3,
      actual_complete: 99.7,
      forecast_complete: 71.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-10-31",
      baseline_complete: 97.4,
      actual_complete: 99.7,
      forecast_complete: 71.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-11-07",
      baseline_complete: 97.6,
      actual_complete: 99.7,
      forecast_complete: 72.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-11-14",
      baseline_complete: 97.7,
      actual_complete: 99.7,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-11-21",
      baseline_complete: 97.9,
      actual_complete: 99.7,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-11-28",
      baseline_complete: 98.0,
      actual_complete: 99.7,
      forecast_complete: 74.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-12-05",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 74.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-12-12",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 75.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-12-19",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 76.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2026-12-26",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 77.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-01-02",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 78.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-01-09",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 79.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-01-16",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 79.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-01-23",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 80.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-01-30",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 81.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-02-06",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-02-13",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-02-20",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-02-27",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-03-06",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-03-13",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-03-20",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 86.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-03-27",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-04-03",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-04-10",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 88.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-04-17",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-04-24",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 90.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-05-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-05-08",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-05-15",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-05-22",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-05-29",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-06-05",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-06-12",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-06-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-06-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-07-03",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-07-10",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-07-17",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-07-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-07-31",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-08-07",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-08-14",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-08-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-08-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-09-04",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-09-11",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-09-18",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-09-25",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-10-02",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-10-09",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-10-16",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-10-23",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-10-30",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-11-06",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-11-13",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-11-20",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-11-27",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-12-04",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-12-11",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-12-18",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2027-12-25",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2028-01-01",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cf344fa3-2497-b57f-489a-dd77068c77ff",
      reporting_date: "2028-01-02",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "b250c591-6837-1010-2906-15befec3d292": [
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-07-08",
      baseline_complete: 0.3,
      actual_complete: 3.8,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-07-15",
      baseline_complete: 0.4,
      actual_complete: 6.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-07-22",
      baseline_complete: 0.4,
      actual_complete: 6.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-07-29",
      baseline_complete: 0.5,
      actual_complete: 6.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-08-05",
      baseline_complete: 0.5,
      actual_complete: 6.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-08-12",
      baseline_complete: 0.6,
      actual_complete: 6.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-08-19",
      baseline_complete: 0.6,
      actual_complete: 6.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-08-26",
      baseline_complete: 0.7,
      actual_complete: 6.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-09-02",
      baseline_complete: 0.8,
      actual_complete: 6.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-09-09",
      baseline_complete: 0.8,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-09-16",
      baseline_complete: 0.9,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-09-23",
      baseline_complete: 1.0,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-09-30",
      baseline_complete: 1.1,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-10-07",
      baseline_complete: 1.3,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-10-14",
      baseline_complete: 1.4,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-10-21",
      baseline_complete: 1.5,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-10-28",
      baseline_complete: 1.7,
      actual_complete: 7.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-11-04",
      baseline_complete: 1.9,
      actual_complete: 7.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-11-11",
      baseline_complete: 2.1,
      actual_complete: 7.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-11-18",
      baseline_complete: 2.3,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-11-25",
      baseline_complete: 2.5,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-12-02",
      baseline_complete: 2.8,
      actual_complete: 8.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-12-09",
      baseline_complete: 3.1,
      actual_complete: 9.0,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-12-16",
      baseline_complete: 3.4,
      actual_complete: 9.0,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-12-23",
      baseline_complete: 3.8,
      actual_complete: 9.0,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2025-12-30",
      baseline_complete: 4.2,
      actual_complete: 9.0,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-01-06",
      baseline_complete: 4.6,
      actual_complete: 9.0,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-01-13",
      baseline_complete: 5.1,
      actual_complete: 11.1,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-01-20",
      baseline_complete: 5.6,
      actual_complete: 11.1,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-01-27",
      baseline_complete: 6.2,
      actual_complete: 11.1,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-02-03",
      baseline_complete: 6.8,
      actual_complete: 11.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-02-10",
      baseline_complete: 7.5,
      actual_complete: 12.8,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-02-17",
      baseline_complete: 8.2,
      actual_complete: 12.8,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-02-24",
      baseline_complete: 9.0,
      actual_complete: 13.9,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-03-03",
      baseline_complete: 9.9,
      actual_complete: 13.9,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-03-10",
      baseline_complete: 10.8,
      actual_complete: 16.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-03-17",
      baseline_complete: 11.9,
      actual_complete: 16.9,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-03-24",
      baseline_complete: 13.0,
      actual_complete: 19.0,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-03-31",
      baseline_complete: 14.2,
      actual_complete: 19.3,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-04-07",
      baseline_complete: 15.5,
      actual_complete: 19.3,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-04-14",
      baseline_complete: 16.9,
      actual_complete: 21.7,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-04-21",
      baseline_complete: 18.3,
      actual_complete: 21.7,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-04-28",
      baseline_complete: 19.9,
      actual_complete: 22.2,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-05-05",
      baseline_complete: 21.6,
      actual_complete: 26.9,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-05-12",
      baseline_complete: 23.4,
      actual_complete: 29.3,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-05-19",
      baseline_complete: 25.3,
      actual_complete: 29.3,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-05-26",
      baseline_complete: 27.3,
      actual_complete: 30.9,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-06-02",
      baseline_complete: 29.3,
      actual_complete: 33.7,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-06-09",
      baseline_complete: 31.5,
      actual_complete: 35.0,
      forecast_complete: 14.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-06-16",
      baseline_complete: 33.8,
      actual_complete: 37.6,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-06-23",
      baseline_complete: 36.1,
      actual_complete: 38.4,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-06-30",
      baseline_complete: 38.5,
      actual_complete: 41.3,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-07-07",
      baseline_complete: 40.9,
      actual_complete: 43.2,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-07-14",
      baseline_complete: 43.4,
      actual_complete: 48.2,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-07-21",
      baseline_complete: 46.0,
      actual_complete: 48.2,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-07-28",
      baseline_complete: 48.5,
      actual_complete: 50.3,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-08-04",
      baseline_complete: 51.1,
      actual_complete: 53.0,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-08-11",
      baseline_complete: 53.6,
      actual_complete: 59.1,
      forecast_complete: 26.1,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-08-18",
      baseline_complete: 56.2,
      actual_complete: 59.7,
      forecast_complete: 27.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-08-25",
      baseline_complete: 58.7,
      actual_complete: 63.0,
      forecast_complete: 29.1,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-09-01",
      baseline_complete: 61.1,
      actual_complete: 65.7,
      forecast_complete: 30.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-09-08",
      baseline_complete: 63.5,
      actual_complete: 68.6,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-09-15",
      baseline_complete: 65.9,
      actual_complete: 68.6,
      forecast_complete: 33.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-09-22",
      baseline_complete: 68.2,
      actual_complete: 72.4,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-09-29",
      baseline_complete: 70.3,
      actual_complete: 74.0,
      forecast_complete: 36.9,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-10-06",
      baseline_complete: 72.4,
      actual_complete: 75.9,
      forecast_complete: 38.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-10-13",
      baseline_complete: 74.4,
      actual_complete: 77.9,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-10-20",
      baseline_complete: 76.3,
      actual_complete: 81.5,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-10-27",
      baseline_complete: 78.1,
      actual_complete: 81.9,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-11-03",
      baseline_complete: 79.8,
      actual_complete: 82.1,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-11-10",
      baseline_complete: 81.4,
      actual_complete: 85.5,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-11-17",
      baseline_complete: 82.9,
      actual_complete: 85.5,
      forecast_complete: 47.3,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-11-24",
      baseline_complete: 84.3,
      actual_complete: 87.8,
      forecast_complete: 48.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-12-01",
      baseline_complete: 85.6,
      actual_complete: 87.8,
      forecast_complete: 50.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-12-08",
      baseline_complete: 86.9,
      actual_complete: 91.5,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-12-15",
      baseline_complete: 88.0,
      actual_complete: 91.5,
      forecast_complete: 52.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-12-22",
      baseline_complete: 89.0,
      actual_complete: 92.2,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2026-12-29",
      baseline_complete: 90.0,
      actual_complete: 92.2,
      forecast_complete: 55.1,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-01-05",
      baseline_complete: 90.9,
      actual_complete: 94.3,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-01-12",
      baseline_complete: 91.7,
      actual_complete: 95.3,
      forecast_complete: 57.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-01-19",
      baseline_complete: 92.4,
      actual_complete: 96.1,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-01-26",
      baseline_complete: 93.1,
      actual_complete: 96.8,
      forecast_complete: 59.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-02-02",
      baseline_complete: 93.7,
      actual_complete: 96.8,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-02-09",
      baseline_complete: 94.3,
      actual_complete: 98.6,
      forecast_complete: 61.7,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-02-16",
      baseline_complete: 94.8,
      actual_complete: 98.6,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-02-23",
      baseline_complete: 95.3,
      actual_complete: 99.0,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-03-02",
      baseline_complete: 95.8,
      actual_complete: 100.0,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-03-09",
      baseline_complete: 96.2,
      actual_complete: 100.0,
      forecast_complete: 65.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-03-16",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 66.7,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-03-23",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 67.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-03-30",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-04-06",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 69.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-04-13",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 70.3,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-04-20",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-04-27",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 72.1,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-05-04",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-05-11",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 73.7,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-05-18",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 74.6,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-05-25",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 75.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-06-01",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 76.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-06-08",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 78.3,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-06-15",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 79.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-06-22",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-06-29",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 82.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-07-06",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-07-13",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 85.1,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-07-20",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-07-27",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 87.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-08-03",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-08-10",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-08-17",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 90.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-08-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-08-31",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-09-07",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-09-14",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-09-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-09-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-10-05",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-10-12",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-10-19",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-10-26",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-11-02",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-11-09",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-11-16",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-11-23",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-11-30",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-12-07",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-12-14",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-12-21",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2027-12-28",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2028-01-04",
      baseline_complete: 100.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b250c591-6837-1010-2906-15befec3d292",
      reporting_date: "2028-01-08",
      baseline_complete: 100.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "6910fba4-f427-eea0-bf5a-2c67edd88589": [
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-01-09",
      baseline_complete: 1.5,
      actual_complete: 9.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-01-16",
      baseline_complete: 1.6,
      actual_complete: 9.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-01-23",
      baseline_complete: 1.7,
      actual_complete: 9.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-01-30",
      baseline_complete: 1.9,
      actual_complete: 9.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-02-06",
      baseline_complete: 2.0,
      actual_complete: 9.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-02-13",
      baseline_complete: 2.1,
      actual_complete: 9.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-02-20",
      baseline_complete: 2.3,
      actual_complete: 9.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-02-27",
      baseline_complete: 2.4,
      actual_complete: 9.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-03-06",
      baseline_complete: 2.6,
      actual_complete: 9.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-03-13",
      baseline_complete: 2.7,
      actual_complete: 9.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-03-20",
      baseline_complete: 2.9,
      actual_complete: 9.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-03-27",
      baseline_complete: 3.1,
      actual_complete: 10.5,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-04-03",
      baseline_complete: 3.3,
      actual_complete: 10.5,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-04-10",
      baseline_complete: 3.5,
      actual_complete: 12.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-04-17",
      baseline_complete: 3.7,
      actual_complete: 12.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-04-24",
      baseline_complete: 4.0,
      actual_complete: 12.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-05-01",
      baseline_complete: 4.2,
      actual_complete: 12.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-05-08",
      baseline_complete: 4.5,
      actual_complete: 12.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-05-15",
      baseline_complete: 4.8,
      actual_complete: 12.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-05-22",
      baseline_complete: 5.1,
      actual_complete: 12.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-05-29",
      baseline_complete: 5.4,
      actual_complete: 12.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-06-05",
      baseline_complete: 5.8,
      actual_complete: 12.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-06-12",
      baseline_complete: 6.1,
      actual_complete: 13.9,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-06-19",
      baseline_complete: 6.5,
      actual_complete: 13.9,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-06-26",
      baseline_complete: 6.9,
      actual_complete: 13.9,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-07-03",
      baseline_complete: 7.3,
      actual_complete: 15.2,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-07-10",
      baseline_complete: 7.8,
      actual_complete: 15.2,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-07-17",
      baseline_complete: 8.3,
      actual_complete: 15.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-07-24",
      baseline_complete: 8.8,
      actual_complete: 15.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-07-31",
      baseline_complete: 9.3,
      actual_complete: 15.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-08-07",
      baseline_complete: 9.9,
      actual_complete: 15.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-08-14",
      baseline_complete: 10.5,
      actual_complete: 15.8,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-08-21",
      baseline_complete: 11.1,
      actual_complete: 15.8,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-08-28",
      baseline_complete: 11.8,
      actual_complete: 17.9,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-09-04",
      baseline_complete: 12.5,
      actual_complete: 17.9,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-09-11",
      baseline_complete: 13.2,
      actual_complete: 17.9,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-09-18",
      baseline_complete: 13.9,
      actual_complete: 17.9,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-09-25",
      baseline_complete: 14.7,
      actual_complete: 21.5,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-10-02",
      baseline_complete: 15.6,
      actual_complete: 21.5,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-10-09",
      baseline_complete: 16.4,
      actual_complete: 23.9,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-10-16",
      baseline_complete: 17.4,
      actual_complete: 23.9,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-10-23",
      baseline_complete: 18.3,
      actual_complete: 23.9,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-10-30",
      baseline_complete: 19.3,
      actual_complete: 23.9,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-11-06",
      baseline_complete: 20.3,
      actual_complete: 23.9,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-11-13",
      baseline_complete: 21.4,
      actual_complete: 23.9,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-11-20",
      baseline_complete: 22.5,
      actual_complete: 27.3,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-11-27",
      baseline_complete: 23.7,
      actual_complete: 28.2,
      forecast_complete: 14.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-12-04",
      baseline_complete: 24.9,
      actual_complete: 28.8,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-12-11",
      baseline_complete: 26.1,
      actual_complete: 33.3,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-12-18",
      baseline_complete: 27.4,
      actual_complete: 33.9,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2025-12-25",
      baseline_complete: 28.7,
      actual_complete: 33.9,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-01-01",
      baseline_complete: 30.0,
      actual_complete: 35.1,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-01-08",
      baseline_complete: 31.4,
      actual_complete: 35.1,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-01-15",
      baseline_complete: 32.8,
      actual_complete: 37.1,
      forecast_complete: 18.4,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-01-22",
      baseline_complete: 34.3,
      actual_complete: 40.9,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-01-29",
      baseline_complete: 35.8,
      actual_complete: 40.9,
      forecast_complete: 19.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-02-05",
      baseline_complete: 37.3,
      actual_complete: 42.0,
      forecast_complete: 20.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-02-12",
      baseline_complete: 38.8,
      actual_complete: 45.7,
      forecast_complete: 21.4,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-02-19",
      baseline_complete: 40.4,
      actual_complete: 47.0,
      forecast_complete: 22.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-02-26",
      baseline_complete: 41.9,
      actual_complete: 47.0,
      forecast_complete: 23.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-03-05",
      baseline_complete: 43.5,
      actual_complete: 48.2,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-03-12",
      baseline_complete: 45.1,
      actual_complete: 48.2,
      forecast_complete: 24.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-03-19",
      baseline_complete: 46.7,
      actual_complete: 51.1,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-03-26",
      baseline_complete: 48.4,
      actual_complete: 53.3,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-04-02",
      baseline_complete: 50.0,
      actual_complete: 53.3,
      forecast_complete: 27.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-04-09",
      baseline_complete: 51.6,
      actual_complete: 57.7,
      forecast_complete: 28.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-04-16",
      baseline_complete: 53.2,
      actual_complete: 57.7,
      forecast_complete: 29.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-04-23",
      baseline_complete: 54.9,
      actual_complete: 57.9,
      forecast_complete: 30.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-04-30",
      baseline_complete: 56.5,
      actual_complete: 59.9,
      forecast_complete: 31.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-05-07",
      baseline_complete: 58.0,
      actual_complete: 59.9,
      forecast_complete: 32.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-05-14",
      baseline_complete: 59.6,
      actual_complete: 65.2,
      forecast_complete: 33.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-05-21",
      baseline_complete: 61.2,
      actual_complete: 65.2,
      forecast_complete: 34.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-05-28",
      baseline_complete: 62.7,
      actual_complete: 66.7,
      forecast_complete: 35.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-06-04",
      baseline_complete: 64.2,
      actual_complete: 66.7,
      forecast_complete: 37.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-06-11",
      baseline_complete: 65.7,
      actual_complete: 69.9,
      forecast_complete: 38.1,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-06-18",
      baseline_complete: 67.1,
      actual_complete: 72.8,
      forecast_complete: 39.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-06-25",
      baseline_complete: 68.6,
      actual_complete: 72.8,
      forecast_complete: 40.4,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-07-02",
      baseline_complete: 69.9,
      actual_complete: 72.8,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-07-09",
      baseline_complete: 71.3,
      actual_complete: 75.3,
      forecast_complete: 42.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-07-16",
      baseline_complete: 72.6,
      actual_complete: 75.3,
      forecast_complete: 43.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-07-23",
      baseline_complete: 73.9,
      actual_complete: 75.3,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-07-30",
      baseline_complete: 75.1,
      actual_complete: 77.0,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-08-06",
      baseline_complete: 76.3,
      actual_complete: 82.2,
      forecast_complete: 47.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-08-13",
      baseline_complete: 77.5,
      actual_complete: 82.2,
      forecast_complete: 48.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-08-20",
      baseline_complete: 78.6,
      actual_complete: 82.2,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-08-27",
      baseline_complete: 79.7,
      actual_complete: 82.2,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-09-03",
      baseline_complete: 80.7,
      actual_complete: 87.0,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-09-10",
      baseline_complete: 81.7,
      actual_complete: 87.4,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-09-17",
      baseline_complete: 82.6,
      actual_complete: 87.4,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-09-24",
      baseline_complete: 83.5,
      actual_complete: 89.8,
      forecast_complete: 54.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-10-01",
      baseline_complete: 84.4,
      actual_complete: 89.8,
      forecast_complete: 55.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-10-08",
      baseline_complete: 85.3,
      actual_complete: 89.8,
      forecast_complete: 56.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-10-15",
      baseline_complete: 86.1,
      actual_complete: 90.8,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-10-22",
      baseline_complete: 86.8,
      actual_complete: 91.9,
      forecast_complete: 58.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-10-29",
      baseline_complete: 87.5,
      actual_complete: 94.4,
      forecast_complete: 59.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-11-05",
      baseline_complete: 88.2,
      actual_complete: 94.4,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-11-12",
      baseline_complete: 88.9,
      actual_complete: 94.4,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-11-19",
      baseline_complete: 89.5,
      actual_complete: 94.4,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-11-26",
      baseline_complete: 90.1,
      actual_complete: 94.4,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-12-03",
      baseline_complete: 90.7,
      actual_complete: 94.4,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-12-10",
      baseline_complete: 91.2,
      actual_complete: 94.4,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-12-17",
      baseline_complete: 91.7,
      actual_complete: 94.4,
      forecast_complete: 66.1,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-12-24",
      baseline_complete: 92.2,
      actual_complete: 94.4,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2026-12-31",
      baseline_complete: 92.7,
      actual_complete: 95.9,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-01-07",
      baseline_complete: 93.1,
      actual_complete: 95.9,
      forecast_complete: 68.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-01-14",
      baseline_complete: 93.5,
      actual_complete: 97.8,
      forecast_complete: 69.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-01-21",
      baseline_complete: 93.9,
      actual_complete: 98.8,
      forecast_complete: 70.4,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-01-28",
      baseline_complete: 94.2,
      actual_complete: 99.3,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-02-04",
      baseline_complete: 94.6,
      actual_complete: 99.3,
      forecast_complete: 72.1,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-02-11",
      baseline_complete: 94.9,
      actual_complete: 99.3,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-02-18",
      baseline_complete: 95.2,
      actual_complete: 99.3,
      forecast_complete: 73.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-02-25",
      baseline_complete: 95.5,
      actual_complete: 100.0,
      forecast_complete: 74.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-03-04",
      baseline_complete: 95.8,
      actual_complete: 100.0,
      forecast_complete: 76.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-03-11",
      baseline_complete: 96.0,
      actual_complete: 100.0,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-03-18",
      baseline_complete: 96.3,
      actual_complete: 100.0,
      forecast_complete: 78.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-03-25",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 80.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-04-01",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-04-08",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 82.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-04-15",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-04-22",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 84.8,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-04-29",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 85.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-05-06",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-05-13",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 87.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-05-20",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-05-27",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 89.8,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-06-03",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 90.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-06-10",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-06-17",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-06-24",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-07-01",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-07-08",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-07-15",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-07-22",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-07-29",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-08-05",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-08-12",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-08-19",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-08-26",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-09-02",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-09-09",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-09-16",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-09-23",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-09-30",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-10-07",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-10-14",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-10-21",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-10-28",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-11-04",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6910fba4-f427-eea0-bf5a-2c67edd88589",
      reporting_date: "2027-11-09",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "b137fa56-8d39-5cc8-0466-5d960c7eb297": [
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-01-10",
      baseline_complete: 0.4,
      actual_complete: 1.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-01-17",
      baseline_complete: 0.4,
      actual_complete: 5.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-01-24",
      baseline_complete: 0.4,
      actual_complete: 5.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-01-31",
      baseline_complete: 0.5,
      actual_complete: 5.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-02-07",
      baseline_complete: 0.5,
      actual_complete: 5.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-02-14",
      baseline_complete: 0.6,
      actual_complete: 5.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-02-21",
      baseline_complete: 0.6,
      actual_complete: 5.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-02-28",
      baseline_complete: 0.7,
      actual_complete: 5.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-03-07",
      baseline_complete: 0.7,
      actual_complete: 5.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-03-14",
      baseline_complete: 0.8,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-03-21",
      baseline_complete: 0.9,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-03-28",
      baseline_complete: 0.9,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-04-04",
      baseline_complete: 1.0,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-04-11",
      baseline_complete: 1.1,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-04-18",
      baseline_complete: 1.2,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-04-25",
      baseline_complete: 1.3,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-05-02",
      baseline_complete: 1.4,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-05-09",
      baseline_complete: 1.5,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-05-16",
      baseline_complete: 1.7,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-05-23",
      baseline_complete: 1.8,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-05-30",
      baseline_complete: 1.9,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-06-06",
      baseline_complete: 2.1,
      actual_complete: 6.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-06-13",
      baseline_complete: 2.3,
      actual_complete: 7.6,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-06-20",
      baseline_complete: 2.5,
      actual_complete: 7.6,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-06-27",
      baseline_complete: 2.7,
      actual_complete: 7.6,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-07-04",
      baseline_complete: 2.9,
      actual_complete: 7.6,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-07-11",
      baseline_complete: 3.1,
      actual_complete: 7.6,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-07-18",
      baseline_complete: 3.4,
      actual_complete: 9.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-07-25",
      baseline_complete: 3.7,
      actual_complete: 9.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-08-01",
      baseline_complete: 4.0,
      actual_complete: 9.1,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-08-08",
      baseline_complete: 4.3,
      actual_complete: 9.1,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-08-15",
      baseline_complete: 4.7,
      actual_complete: 9.1,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-08-22",
      baseline_complete: 5.0,
      actual_complete: 9.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-08-29",
      baseline_complete: 5.5,
      actual_complete: 9.1,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-09-05",
      baseline_complete: 5.9,
      actual_complete: 9.1,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-09-12",
      baseline_complete: 6.4,
      actual_complete: 12.1,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-09-19",
      baseline_complete: 6.9,
      actual_complete: 12.1,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-09-26",
      baseline_complete: 7.4,
      actual_complete: 12.1,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-10-03",
      baseline_complete: 8.0,
      actual_complete: 12.1,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-10-10",
      baseline_complete: 8.6,
      actual_complete: 13.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-10-17",
      baseline_complete: 9.3,
      actual_complete: 13.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-10-24",
      baseline_complete: 10.0,
      actual_complete: 13.0,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-10-31",
      baseline_complete: 10.8,
      actual_complete: 13.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-11-07",
      baseline_complete: 11.6,
      actual_complete: 13.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-11-14",
      baseline_complete: 12.5,
      actual_complete: 13.0,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-11-21",
      baseline_complete: 13.4,
      actual_complete: 13.0,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-11-28",
      baseline_complete: 14.4,
      actual_complete: 19.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-12-05",
      baseline_complete: 15.4,
      actual_complete: 19.1,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-12-12",
      baseline_complete: 16.5,
      actual_complete: 19.1,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-12-19",
      baseline_complete: 17.7,
      actual_complete: 20.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2026-12-26",
      baseline_complete: 18.9,
      actual_complete: 20.9,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-01-02",
      baseline_complete: 20.2,
      actual_complete: 20.9,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-01-09",
      baseline_complete: 21.6,
      actual_complete: 25.1,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-01-16",
      baseline_complete: 23.0,
      actual_complete: 25.1,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-01-23",
      baseline_complete: 24.5,
      actual_complete: 25.1,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-01-30",
      baseline_complete: 26.0,
      actual_complete: 30.1,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-02-06",
      baseline_complete: 27.6,
      actual_complete: 30.1,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-02-13",
      baseline_complete: 29.3,
      actual_complete: 32.9,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-02-20",
      baseline_complete: 31.0,
      actual_complete: 34.1,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-02-27",
      baseline_complete: 32.8,
      actual_complete: 36.8,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-03-06",
      baseline_complete: 34.7,
      actual_complete: 36.8,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-03-13",
      baseline_complete: 36.6,
      actual_complete: 38.8,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-03-20",
      baseline_complete: 38.5,
      actual_complete: 38.8,
      forecast_complete: 18.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-03-27",
      baseline_complete: 40.4,
      actual_complete: 42.1,
      forecast_complete: 19.4,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-04-03",
      baseline_complete: 42.4,
      actual_complete: 43.2,
      forecast_complete: 20.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-04-10",
      baseline_complete: 44.5,
      actual_complete: 48.6,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-04-17",
      baseline_complete: 46.5,
      actual_complete: 48.6,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-04-24",
      baseline_complete: 48.5,
      actual_complete: 54.3,
      forecast_complete: 24.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-05-01",
      baseline_complete: 50.6,
      actual_complete: 54.3,
      forecast_complete: 26.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-05-08",
      baseline_complete: 52.6,
      actual_complete: 57.1,
      forecast_complete: 27.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-05-15",
      baseline_complete: 54.7,
      actual_complete: 57.1,
      forecast_complete: 29.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-05-22",
      baseline_complete: 56.7,
      actual_complete: 58.5,
      forecast_complete: 30.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-05-29",
      baseline_complete: 58.7,
      actual_complete: 64.0,
      forecast_complete: 32.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-06-05",
      baseline_complete: 60.7,
      actual_complete: 64.9,
      forecast_complete: 33.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-06-12",
      baseline_complete: 62.6,
      actual_complete: 64.9,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-06-19",
      baseline_complete: 64.5,
      actual_complete: 68.5,
      forecast_complete: 36.8,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-06-26",
      baseline_complete: 66.4,
      actual_complete: 68.9,
      forecast_complete: 38.4,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-07-03",
      baseline_complete: 68.2,
      actual_complete: 68.9,
      forecast_complete: 39.9,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-07-10",
      baseline_complete: 70.0,
      actual_complete: 70.3,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-07-17",
      baseline_complete: 71.7,
      actual_complete: 71.0,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-07-24",
      baseline_complete: 73.3,
      actual_complete: 74.3,
      forecast_complete: 44.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-07-31",
      baseline_complete: 74.9,
      actual_complete: 75.7,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-08-07",
      baseline_complete: 76.4,
      actual_complete: 80.2,
      forecast_complete: 47.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-08-14",
      baseline_complete: 77.8,
      actual_complete: 82.4,
      forecast_complete: 49.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-08-21",
      baseline_complete: 79.2,
      actual_complete: 82.4,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-08-28",
      baseline_complete: 80.5,
      actual_complete: 82.4,
      forecast_complete: 52.0,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-09-04",
      baseline_complete: 81.8,
      actual_complete: 83.3,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-09-11",
      baseline_complete: 83.0,
      actual_complete: 86.9,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-09-18",
      baseline_complete: 84.1,
      actual_complete: 86.9,
      forecast_complete: 56.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-09-25",
      baseline_complete: 85.2,
      actual_complete: 86.9,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-10-02",
      baseline_complete: 86.2,
      actual_complete: 88.5,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-10-09",
      baseline_complete: 87.1,
      actual_complete: 88.5,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-10-16",
      baseline_complete: 88.0,
      actual_complete: 88.5,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-10-23",
      baseline_complete: 88.9,
      actual_complete: 90.0,
      forecast_complete: 62.8,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-10-30",
      baseline_complete: 89.7,
      actual_complete: 90.0,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-11-06",
      baseline_complete: 90.4,
      actual_complete: 90.0,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-11-13",
      baseline_complete: 91.1,
      actual_complete: 93.6,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-11-20",
      baseline_complete: 91.7,
      actual_complete: 93.6,
      forecast_complete: 67.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-11-27",
      baseline_complete: 92.3,
      actual_complete: 93.6,
      forecast_complete: 68.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-12-04",
      baseline_complete: 92.9,
      actual_complete: 94.8,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-12-11",
      baseline_complete: 93.4,
      actual_complete: 99.0,
      forecast_complete: 72.5,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-12-18",
      baseline_complete: 93.9,
      actual_complete: 99.0,
      forecast_complete: 74.3,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2027-12-25",
      baseline_complete: 94.4,
      actual_complete: 99.0,
      forecast_complete: 76.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-01-01",
      baseline_complete: 94.8,
      actual_complete: 99.0,
      forecast_complete: 77.8,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-01-08",
      baseline_complete: 95.2,
      actual_complete: 99.0,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-01-15",
      baseline_complete: 95.5,
      actual_complete: 99.0,
      forecast_complete: 80.9,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-01-22",
      baseline_complete: 95.9,
      actual_complete: 99.0,
      forecast_complete: 82.5,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-01-29",
      baseline_complete: 96.2,
      actual_complete: 99.0,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-02-05",
      baseline_complete: 96.5,
      actual_complete: 99.0,
      forecast_complete: 85.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-02-12",
      baseline_complete: 96.7,
      actual_complete: 99.0,
      forecast_complete: 86.4,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-02-19",
      baseline_complete: 97.0,
      actual_complete: 99.0,
      forecast_complete: 87.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-02-26",
      baseline_complete: 97.2,
      actual_complete: 99.8,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-03-04",
      baseline_complete: 97.4,
      actual_complete: 99.8,
      forecast_complete: 89.8,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-03-11",
      baseline_complete: 97.6,
      actual_complete: 99.8,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-03-18",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-03-25",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-04-01",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-04-08",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-04-15",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-04-22",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-04-29",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-05-06",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-05-13",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-05-20",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-05-27",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-06-03",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-06-10",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-06-17",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-06-24",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-07-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-07-08",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "b137fa56-8d39-5cc8-0466-5d960c7eb297",
      reporting_date: "2028-07-10",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
  ],
  "ce3e308a-b0e3-8a45-0a18-6576ee110d5f": [
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-01-24",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-01-31",
      baseline_complete: 0.1,
      actual_complete: 0.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-02-07",
      baseline_complete: 0.1,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-02-14",
      baseline_complete: 0.2,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-02-21",
      baseline_complete: 0.2,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-02-28",
      baseline_complete: 0.2,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-03-06",
      baseline_complete: 0.2,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-03-13",
      baseline_complete: 0.2,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-03-20",
      baseline_complete: 0.2,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-03-27",
      baseline_complete: 0.2,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-04-03",
      baseline_complete: 0.3,
      actual_complete: 1.9,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-04-10",
      baseline_complete: 0.3,
      actual_complete: 1.9,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-04-17",
      baseline_complete: 0.3,
      actual_complete: 1.9,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-04-24",
      baseline_complete: 0.3,
      actual_complete: 1.9,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-05-01",
      baseline_complete: 0.4,
      actual_complete: 1.9,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-05-08",
      baseline_complete: 0.4,
      actual_complete: 1.9,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-05-15",
      baseline_complete: 0.4,
      actual_complete: 2.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-05-22",
      baseline_complete: 0.5,
      actual_complete: 2.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-05-29",
      baseline_complete: 0.5,
      actual_complete: 2.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-06-05",
      baseline_complete: 0.5,
      actual_complete: 2.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-06-12",
      baseline_complete: 0.6,
      actual_complete: 2.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-06-19",
      baseline_complete: 0.6,
      actual_complete: 2.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-06-26",
      baseline_complete: 0.7,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-07-03",
      baseline_complete: 0.7,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-07-10",
      baseline_complete: 0.8,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-07-17",
      baseline_complete: 0.9,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-07-24",
      baseline_complete: 1.0,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-07-31",
      baseline_complete: 1.0,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-08-07",
      baseline_complete: 1.1,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-08-14",
      baseline_complete: 1.2,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-08-21",
      baseline_complete: 1.3,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-08-28",
      baseline_complete: 1.4,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-09-04",
      baseline_complete: 1.5,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-09-11",
      baseline_complete: 1.7,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-09-18",
      baseline_complete: 1.8,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-09-25",
      baseline_complete: 1.9,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-10-02",
      baseline_complete: 2.1,
      actual_complete: 3.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-10-09",
      baseline_complete: 2.3,
      actual_complete: 4.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-10-16",
      baseline_complete: 2.5,
      actual_complete: 4.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-10-23",
      baseline_complete: 2.7,
      actual_complete: 4.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-10-30",
      baseline_complete: 2.9,
      actual_complete: 4.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-11-06",
      baseline_complete: 3.1,
      actual_complete: 5.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-11-13",
      baseline_complete: 3.4,
      actual_complete: 5.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-11-20",
      baseline_complete: 3.7,
      actual_complete: 5.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-11-27",
      baseline_complete: 3.9,
      actual_complete: 6.9,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-12-04",
      baseline_complete: 4.3,
      actual_complete: 7.1,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-12-11",
      baseline_complete: 4.6,
      actual_complete: 7.1,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-12-18",
      baseline_complete: 5.0,
      actual_complete: 7.1,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2024-12-25",
      baseline_complete: 5.4,
      actual_complete: 7.1,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-01-01",
      baseline_complete: 5.8,
      actual_complete: 7.1,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-01-08",
      baseline_complete: 6.2,
      actual_complete: 7.1,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-01-15",
      baseline_complete: 6.7,
      actual_complete: 8.6,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-01-22",
      baseline_complete: 7.3,
      actual_complete: 8.6,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-01-29",
      baseline_complete: 7.8,
      actual_complete: 8.6,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-02-05",
      baseline_complete: 8.4,
      actual_complete: 8.6,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-02-12",
      baseline_complete: 9.1,
      actual_complete: 8.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-02-19",
      baseline_complete: 9.8,
      actual_complete: 8.6,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-02-26",
      baseline_complete: 10.5,
      actual_complete: 13.1,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-03-05",
      baseline_complete: 11.3,
      actual_complete: 13.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-03-12",
      baseline_complete: 12.1,
      actual_complete: 14.7,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-03-19",
      baseline_complete: 13.0,
      actual_complete: 15.1,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-03-26",
      baseline_complete: 13.9,
      actual_complete: 15.1,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-04-02",
      baseline_complete: 14.9,
      actual_complete: 15.1,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-04-09",
      baseline_complete: 16.0,
      actual_complete: 15.1,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-04-16",
      baseline_complete: 17.1,
      actual_complete: 16.3,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-04-23",
      baseline_complete: 18.3,
      actual_complete: 21.2,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-04-30",
      baseline_complete: 19.5,
      actual_complete: 21.2,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-05-07",
      baseline_complete: 20.8,
      actual_complete: 21.2,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-05-14",
      baseline_complete: 22.2,
      actual_complete: 21.2,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-05-21",
      baseline_complete: 23.6,
      actual_complete: 25.2,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-05-28",
      baseline_complete: 25.1,
      actual_complete: 28.5,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-06-04",
      baseline_complete: 26.6,
      actual_complete: 28.9,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-06-11",
      baseline_complete: 28.2,
      actual_complete: 28.9,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-06-18",
      baseline_complete: 29.9,
      actual_complete: 30.4,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-06-25",
      baseline_complete: 31.6,
      actual_complete: 30.7,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-07-02",
      baseline_complete: 33.4,
      actual_complete: 32.6,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-07-09",
      baseline_complete: 35.2,
      actual_complete: 34.6,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-07-16",
      baseline_complete: 37.1,
      actual_complete: 38.7,
      forecast_complete: 17.6,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-07-23",
      baseline_complete: 39.0,
      actual_complete: 40.1,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-07-30",
      baseline_complete: 40.9,
      actual_complete: 40.1,
      forecast_complete: 20.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-08-06",
      baseline_complete: 42.9,
      actual_complete: 43.3,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-08-13",
      baseline_complete: 44.8,
      actual_complete: 46.9,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-08-20",
      baseline_complete: 46.8,
      actual_complete: 46.9,
      forecast_complete: 24.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-08-27",
      baseline_complete: 48.9,
      actual_complete: 46.9,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-09-03",
      baseline_complete: 50.9,
      actual_complete: 48.8,
      forecast_complete: 26.8,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-09-10",
      baseline_complete: 52.9,
      actual_complete: 54.2,
      forecast_complete: 28.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-09-17",
      baseline_complete: 54.9,
      actual_complete: 54.2,
      forecast_complete: 29.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-09-24",
      baseline_complete: 56.9,
      actual_complete: 57.7,
      forecast_complete: 31.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-10-01",
      baseline_complete: 58.8,
      actual_complete: 57.7,
      forecast_complete: 32.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-10-08",
      baseline_complete: 60.8,
      actual_complete: 63.4,
      forecast_complete: 34.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-10-15",
      baseline_complete: 62.7,
      actual_complete: 63.4,
      forecast_complete: 35.8,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-10-22",
      baseline_complete: 64.6,
      actual_complete: 67.2,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-10-29",
      baseline_complete: 66.4,
      actual_complete: 67.2,
      forecast_complete: 38.8,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-11-05",
      baseline_complete: 68.2,
      actual_complete: 67.8,
      forecast_complete: 40.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-11-12",
      baseline_complete: 69.9,
      actual_complete: 68.4,
      forecast_complete: 41.8,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-11-19",
      baseline_complete: 71.6,
      actual_complete: 72.2,
      forecast_complete: 43.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-11-26",
      baseline_complete: 73.2,
      actual_complete: 74.1,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-12-03",
      baseline_complete: 74.7,
      actual_complete: 74.1,
      forecast_complete: 46.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-12-10",
      baseline_complete: 76.2,
      actual_complete: 74.1,
      forecast_complete: 47.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-12-17",
      baseline_complete: 77.6,
      actual_complete: 82.2,
      forecast_complete: 49.1,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-12-24",
      baseline_complete: 79.0,
      actual_complete: 82.2,
      forecast_complete: 50.5,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2025-12-31",
      baseline_complete: 80.3,
      actual_complete: 82.2,
      forecast_complete: 51.9,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-01-07",
      baseline_complete: 81.6,
      actual_complete: 82.2,
      forecast_complete: 53.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-01-14",
      baseline_complete: 82.7,
      actual_complete: 84.0,
      forecast_complete: 54.6,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-01-21",
      baseline_complete: 83.9,
      actual_complete: 84.2,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-01-28",
      baseline_complete: 84.9,
      actual_complete: 85.0,
      forecast_complete: 57.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-02-04",
      baseline_complete: 85.9,
      actual_complete: 85.0,
      forecast_complete: 58.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-02-11",
      baseline_complete: 86.9,
      actual_complete: 88.7,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-02-18",
      baseline_complete: 87.8,
      actual_complete: 88.7,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-02-25",
      baseline_complete: 88.6,
      actual_complete: 90.1,
      forecast_complete: 62.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-03-04",
      baseline_complete: 89.4,
      actual_complete: 91.9,
      forecast_complete: 63.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-03-11",
      baseline_complete: 90.1,
      actual_complete: 91.9,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-03-18",
      baseline_complete: 90.8,
      actual_complete: 91.9,
      forecast_complete: 65.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-03-25",
      baseline_complete: 91.5,
      actual_complete: 93.1,
      forecast_complete: 66.5,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-04-01",
      baseline_complete: 92.1,
      actual_complete: 94.5,
      forecast_complete: 67.5,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-04-08",
      baseline_complete: 92.7,
      actual_complete: 94.5,
      forecast_complete: 68.8,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-04-15",
      baseline_complete: 93.2,
      actual_complete: 94.8,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-04-22",
      baseline_complete: 93.7,
      actual_complete: 94.8,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-04-29",
      baseline_complete: 94.1,
      actual_complete: 98.2,
      forecast_complete: 73.8,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-05-06",
      baseline_complete: 94.6,
      actual_complete: 98.2,
      forecast_complete: 75.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-05-13",
      baseline_complete: 95.0,
      actual_complete: 98.2,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-05-20",
      baseline_complete: 95.3,
      actual_complete: 98.2,
      forecast_complete: 78.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-05-27",
      baseline_complete: 95.7,
      actual_complete: 98.2,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-06-03",
      baseline_complete: 96.0,
      actual_complete: 98.2,
      forecast_complete: 81.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-06-10",
      baseline_complete: 96.3,
      actual_complete: 98.6,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-06-17",
      baseline_complete: 96.6,
      actual_complete: 100.0,
      forecast_complete: 83.5,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-06-24",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-07-01",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 85.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-07-08",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 86.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-07-15",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-07-22",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-07-29",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-08-05",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-08-12",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-08-19",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-08-26",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-09-02",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-09-09",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-09-16",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-09-23",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-09-30",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-10-07",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-10-14",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-10-21",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-10-28",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-11-04",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-11-11",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-11-18",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-11-25",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-12-02",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-12-09",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-12-16",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-12-23",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "ce3e308a-b0e3-8a45-0a18-6576ee110d5f",
      reporting_date: "2026-12-24",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
  ],
  "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89": [
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-06-02",
      baseline_complete: 0.4,
      actual_complete: 0.5,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-06-09",
      baseline_complete: 0.4,
      actual_complete: 3.6,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-06-16",
      baseline_complete: 0.4,
      actual_complete: 3.6,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-06-23",
      baseline_complete: 0.5,
      actual_complete: 4.7,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-06-30",
      baseline_complete: 0.5,
      actual_complete: 6.3,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-07-07",
      baseline_complete: 0.5,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-07-14",
      baseline_complete: 0.6,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-07-21",
      baseline_complete: 0.6,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-07-28",
      baseline_complete: 0.7,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-08-04",
      baseline_complete: 0.7,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-08-11",
      baseline_complete: 0.8,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-08-18",
      baseline_complete: 0.8,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-08-25",
      baseline_complete: 0.9,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-09-01",
      baseline_complete: 1.0,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-09-08",
      baseline_complete: 1.0,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-09-15",
      baseline_complete: 1.1,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-09-22",
      baseline_complete: 1.2,
      actual_complete: 6.4,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-09-29",
      baseline_complete: 1.3,
      actual_complete: 6.7,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-10-06",
      baseline_complete: 1.4,
      actual_complete: 6.7,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-10-13",
      baseline_complete: 1.5,
      actual_complete: 6.7,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-10-20",
      baseline_complete: 1.6,
      actual_complete: 6.7,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-10-27",
      baseline_complete: 1.7,
      actual_complete: 6.7,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-11-03",
      baseline_complete: 1.8,
      actual_complete: 6.7,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-11-10",
      baseline_complete: 2.0,
      actual_complete: 6.7,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-11-17",
      baseline_complete: 2.1,
      actual_complete: 6.7,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-11-24",
      baseline_complete: 2.3,
      actual_complete: 7.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-12-01",
      baseline_complete: 2.5,
      actual_complete: 7.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-12-08",
      baseline_complete: 2.6,
      actual_complete: 7.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-12-15",
      baseline_complete: 2.8,
      actual_complete: 8.9,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-12-22",
      baseline_complete: 3.1,
      actual_complete: 8.9,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2025-12-29",
      baseline_complete: 3.3,
      actual_complete: 8.9,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-01-05",
      baseline_complete: 3.5,
      actual_complete: 8.9,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-01-12",
      baseline_complete: 3.8,
      actual_complete: 8.9,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-01-19",
      baseline_complete: 4.1,
      actual_complete: 9.5,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-01-26",
      baseline_complete: 4.3,
      actual_complete: 10.1,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-02-02",
      baseline_complete: 4.7,
      actual_complete: 10.1,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-02-09",
      baseline_complete: 5.0,
      actual_complete: 10.1,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-02-16",
      baseline_complete: 5.4,
      actual_complete: 10.1,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-02-23",
      baseline_complete: 5.8,
      actual_complete: 10.1,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-03-02",
      baseline_complete: 6.2,
      actual_complete: 10.1,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-03-09",
      baseline_complete: 6.6,
      actual_complete: 10.1,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-03-16",
      baseline_complete: 7.1,
      actual_complete: 10.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-03-23",
      baseline_complete: 7.6,
      actual_complete: 10.1,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-03-30",
      baseline_complete: 8.1,
      actual_complete: 10.2,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-04-06",
      baseline_complete: 8.7,
      actual_complete: 10.7,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-04-13",
      baseline_complete: 9.3,
      actual_complete: 10.7,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-04-20",
      baseline_complete: 9.9,
      actual_complete: 11.7,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-04-27",
      baseline_complete: 10.6,
      actual_complete: 11.7,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-05-04",
      baseline_complete: 11.3,
      actual_complete: 16.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-05-11",
      baseline_complete: 12.1,
      actual_complete: 16.7,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-05-18",
      baseline_complete: 12.9,
      actual_complete: 16.7,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-05-25",
      baseline_complete: 13.7,
      actual_complete: 20.1,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-06-01",
      baseline_complete: 14.6,
      actual_complete: 20.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-06-08",
      baseline_complete: 15.6,
      actual_complete: 21.3,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-06-15",
      baseline_complete: 16.5,
      actual_complete: 21.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-06-22",
      baseline_complete: 17.6,
      actual_complete: 21.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-06-29",
      baseline_complete: 18.7,
      actual_complete: 24.3,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-07-06",
      baseline_complete: 19.8,
      actual_complete: 24.3,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-07-13",
      baseline_complete: 21.0,
      actual_complete: 24.3,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-07-20",
      baseline_complete: 22.3,
      actual_complete: 26.8,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-07-27",
      baseline_complete: 23.6,
      actual_complete: 28.5,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-08-03",
      baseline_complete: 24.9,
      actual_complete: 28.5,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-08-10",
      baseline_complete: 26.3,
      actual_complete: 28.5,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-08-17",
      baseline_complete: 27.8,
      actual_complete: 28.5,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-08-24",
      baseline_complete: 29.3,
      actual_complete: 33.9,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-08-31",
      baseline_complete: 30.8,
      actual_complete: 33.9,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-09-07",
      baseline_complete: 32.4,
      actual_complete: 37.9,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-09-14",
      baseline_complete: 34.0,
      actual_complete: 38.3,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-09-21",
      baseline_complete: 35.7,
      actual_complete: 38.5,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-09-28",
      baseline_complete: 37.4,
      actual_complete: 38.5,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-10-05",
      baseline_complete: 39.2,
      actual_complete: 40.3,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-10-12",
      baseline_complete: 40.9,
      actual_complete: 42.1,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-10-19",
      baseline_complete: 42.7,
      actual_complete: 46.7,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-10-26",
      baseline_complete: 44.5,
      actual_complete: 49.6,
      forecast_complete: 22.2,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-11-02",
      baseline_complete: 46.4,
      actual_complete: 49.6,
      forecast_complete: 23.4,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-11-09",
      baseline_complete: 48.2,
      actual_complete: 49.6,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-11-16",
      baseline_complete: 50.0,
      actual_complete: 50.5,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-11-23",
      baseline_complete: 51.9,
      actual_complete: 53.1,
      forecast_complete: 27.2,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-11-30",
      baseline_complete: 53.7,
      actual_complete: 56.8,
      forecast_complete: 28.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-12-07",
      baseline_complete: 55.5,
      actual_complete: 56.8,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-12-14",
      baseline_complete: 57.3,
      actual_complete: 56.8,
      forecast_complete: 31.2,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-12-21",
      baseline_complete: 59.1,
      actual_complete: 58.2,
      forecast_complete: 32.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2026-12-28",
      baseline_complete: 60.9,
      actual_complete: 60.6,
      forecast_complete: 33.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-01-04",
      baseline_complete: 62.6,
      actual_complete: 65.9,
      forecast_complete: 35.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-01-11",
      baseline_complete: 64.3,
      actual_complete: 65.9,
      forecast_complete: 36.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-01-18",
      baseline_complete: 66.0,
      actual_complete: 71.4,
      forecast_complete: 38.1,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-01-25",
      baseline_complete: 67.7,
      actual_complete: 71.7,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-02-01",
      baseline_complete: 69.2,
      actual_complete: 72.4,
      forecast_complete: 40.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-02-08",
      baseline_complete: 70.8,
      actual_complete: 72.5,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-02-15",
      baseline_complete: 72.3,
      actual_complete: 74.5,
      forecast_complete: 43.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-02-22",
      baseline_complete: 73.7,
      actual_complete: 75.4,
      forecast_complete: 45.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-03-01",
      baseline_complete: 75.1,
      actual_complete: 78.7,
      forecast_complete: 46.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-03-08",
      baseline_complete: 76.5,
      actual_complete: 79.7,
      forecast_complete: 47.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-03-15",
      baseline_complete: 77.8,
      actual_complete: 79.7,
      forecast_complete: 49.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-03-22",
      baseline_complete: 79.0,
      actual_complete: 79.7,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-03-29",
      baseline_complete: 80.2,
      actual_complete: 86.1,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-04-05",
      baseline_complete: 81.4,
      actual_complete: 86.1,
      forecast_complete: 52.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-04-12",
      baseline_complete: 82.5,
      actual_complete: 86.1,
      forecast_complete: 54.2,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-04-19",
      baseline_complete: 83.5,
      actual_complete: 86.1,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-04-26",
      baseline_complete: 84.5,
      actual_complete: 86.1,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-05-03",
      baseline_complete: 85.4,
      actual_complete: 86.1,
      forecast_complete: 57.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-05-10",
      baseline_complete: 86.3,
      actual_complete: 86.1,
      forecast_complete: 59.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-05-17",
      baseline_complete: 87.2,
      actual_complete: 90.1,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-05-24",
      baseline_complete: 88.0,
      actual_complete: 90.1,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-05-31",
      baseline_complete: 88.7,
      actual_complete: 93.7,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-06-07",
      baseline_complete: 89.4,
      actual_complete: 93.7,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-06-14",
      baseline_complete: 90.1,
      actual_complete: 93.7,
      forecast_complete: 64.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-06-21",
      baseline_complete: 90.8,
      actual_complete: 95.1,
      forecast_complete: 65.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-06-28",
      baseline_complete: 91.4,
      actual_complete: 95.1,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-07-05",
      baseline_complete: 91.9,
      actual_complete: 95.2,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-07-12",
      baseline_complete: 92.4,
      actual_complete: 95.7,
      forecast_complete: 68.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-07-19",
      baseline_complete: 92.9,
      actual_complete: 95.7,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-07-26",
      baseline_complete: 93.4,
      actual_complete: 95.7,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-08-02",
      baseline_complete: 93.9,
      actual_complete: 96.7,
      forecast_complete: 73.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-08-09",
      baseline_complete: 94.3,
      actual_complete: 99.6,
      forecast_complete: 74.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-08-16",
      baseline_complete: 94.6,
      actual_complete: 99.6,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-08-23",
      baseline_complete: 95.0,
      actual_complete: 99.6,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-08-30",
      baseline_complete: 95.3,
      actual_complete: 99.6,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-09-06",
      baseline_complete: 95.7,
      actual_complete: 99.6,
      forecast_complete: 80.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-09-13",
      baseline_complete: 96.0,
      actual_complete: 100.0,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-09-20",
      baseline_complete: 96.2,
      actual_complete: 100.0,
      forecast_complete: 83.4,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-09-27",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-10-04",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-10-11",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-10-18",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-10-25",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 89.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-11-01",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-11-08",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-11-15",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-11-22",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-11-29",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-12-06",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-12-13",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-12-20",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2027-12-27",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-01-03",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-01-10",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-01-17",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-01-24",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-01-31",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-02-07",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-02-14",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-02-21",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-02-28",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-03-06",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-03-13",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-03-20",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-03-27",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "1974e552-2e3e-7b8a-8ae7-00a25d8dbe89",
      reporting_date: "2028-04-02",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "23ecf456-a7f5-a4de-f448-d94c04843c84": [
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-03-22",
      baseline_complete: 0.1,
      actual_complete: 5.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-03-29",
      baseline_complete: 0.1,
      actual_complete: 5.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-04-05",
      baseline_complete: 0.1,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-04-12",
      baseline_complete: 0.1,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-04-19",
      baseline_complete: 0.1,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-04-26",
      baseline_complete: 0.2,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-05-03",
      baseline_complete: 0.2,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-05-10",
      baseline_complete: 0.2,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-05-17",
      baseline_complete: 0.2,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-05-24",
      baseline_complete: 0.2,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-05-31",
      baseline_complete: 0.2,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-06-07",
      baseline_complete: 0.2,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-06-14",
      baseline_complete: 0.3,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-06-21",
      baseline_complete: 0.3,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-06-28",
      baseline_complete: 0.3,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-07-05",
      baseline_complete: 0.3,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-07-12",
      baseline_complete: 0.4,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-07-19",
      baseline_complete: 0.4,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-07-26",
      baseline_complete: 0.4,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-08-02",
      baseline_complete: 0.4,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-08-09",
      baseline_complete: 0.5,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-08-16",
      baseline_complete: 0.5,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-08-23",
      baseline_complete: 0.6,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-08-30",
      baseline_complete: 0.6,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-09-06",
      baseline_complete: 0.6,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-09-13",
      baseline_complete: 0.7,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-09-20",
      baseline_complete: 0.8,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-09-27",
      baseline_complete: 0.8,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-10-04",
      baseline_complete: 0.9,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-10-11",
      baseline_complete: 0.9,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-10-18",
      baseline_complete: 1.0,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-10-25",
      baseline_complete: 1.1,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-11-01",
      baseline_complete: 1.2,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-11-08",
      baseline_complete: 1.3,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-11-15",
      baseline_complete: 1.4,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-11-22",
      baseline_complete: 1.5,
      actual_complete: 6.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-11-29",
      baseline_complete: 1.6,
      actual_complete: 6.7,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-12-06",
      baseline_complete: 1.7,
      actual_complete: 6.7,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-12-13",
      baseline_complete: 1.8,
      actual_complete: 7.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-12-20",
      baseline_complete: 2.0,
      actual_complete: 7.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2025-12-27",
      baseline_complete: 2.1,
      actual_complete: 7.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-01-03",
      baseline_complete: 2.3,
      actual_complete: 7.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-01-10",
      baseline_complete: 2.5,
      actual_complete: 7.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-01-17",
      baseline_complete: 2.6,
      actual_complete: 7.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-01-24",
      baseline_complete: 2.8,
      actual_complete: 7.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-01-31",
      baseline_complete: 3.1,
      actual_complete: 7.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-02-07",
      baseline_complete: 3.3,
      actual_complete: 7.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-02-14",
      baseline_complete: 3.5,
      actual_complete: 8.2,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-02-21",
      baseline_complete: 3.8,
      actual_complete: 8.2,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-02-28",
      baseline_complete: 4.1,
      actual_complete: 8.7,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-03-07",
      baseline_complete: 4.4,
      actual_complete: 9.1,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-03-14",
      baseline_complete: 4.7,
      actual_complete: 9.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-03-21",
      baseline_complete: 5.1,
      actual_complete: 9.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-03-28",
      baseline_complete: 5.4,
      actual_complete: 10.1,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-04-04",
      baseline_complete: 5.8,
      actual_complete: 10.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-04-11",
      baseline_complete: 6.3,
      actual_complete: 11.0,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-04-18",
      baseline_complete: 6.7,
      actual_complete: 11.0,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-04-25",
      baseline_complete: 7.2,
      actual_complete: 11.6,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-05-02",
      baseline_complete: 7.7,
      actual_complete: 11.6,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-05-09",
      baseline_complete: 8.3,
      actual_complete: 13.0,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-05-16",
      baseline_complete: 8.9,
      actual_complete: 14.2,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-05-23",
      baseline_complete: 9.5,
      actual_complete: 14.3,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-05-30",
      baseline_complete: 10.2,
      actual_complete: 14.3,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-06-06",
      baseline_complete: 10.9,
      actual_complete: 14.3,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-06-13",
      baseline_complete: 11.6,
      actual_complete: 15.9,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-06-20",
      baseline_complete: 12.4,
      actual_complete: 16.7,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-06-27",
      baseline_complete: 13.2,
      actual_complete: 17.9,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-07-04",
      baseline_complete: 14.1,
      actual_complete: 17.9,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-07-11",
      baseline_complete: 15.1,
      actual_complete: 19.6,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-07-18",
      baseline_complete: 16.1,
      actual_complete: 19.7,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-07-25",
      baseline_complete: 17.1,
      actual_complete: 21.9,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-08-01",
      baseline_complete: 18.2,
      actual_complete: 21.9,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-08-08",
      baseline_complete: 19.3,
      actual_complete: 23.1,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-08-15",
      baseline_complete: 20.5,
      actual_complete: 24.7,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-08-22",
      baseline_complete: 21.8,
      actual_complete: 24.7,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-08-29",
      baseline_complete: 23.1,
      actual_complete: 26.8,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-09-05",
      baseline_complete: 24.4,
      actual_complete: 28.5,
      forecast_complete: 18.2,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-09-12",
      baseline_complete: 25.8,
      actual_complete: 29.9,
      forecast_complete: 19.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-09-19",
      baseline_complete: 27.3,
      actual_complete: 29.9,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-09-26",
      baseline_complete: 28.8,
      actual_complete: 33.2,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-10-03",
      baseline_complete: 30.4,
      actual_complete: 34.8,
      forecast_complete: 21.7,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-10-10",
      baseline_complete: 32.0,
      actual_complete: 37.1,
      forecast_complete: 22.7,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-10-17",
      baseline_complete: 33.7,
      actual_complete: 37.1,
      forecast_complete: 23.7,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-10-24",
      baseline_complete: 35.3,
      actual_complete: 38.8,
      forecast_complete: 24.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-10-31",
      baseline_complete: 37.1,
      actual_complete: 39.9,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-11-07",
      baseline_complete: 38.8,
      actual_complete: 42.2,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-11-14",
      baseline_complete: 40.6,
      actual_complete: 45.3,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-11-21",
      baseline_complete: 42.5,
      actual_complete: 45.7,
      forecast_complete: 29.5,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-11-28",
      baseline_complete: 44.3,
      actual_complete: 47.9,
      forecast_complete: 30.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-12-05",
      baseline_complete: 46.2,
      actual_complete: 49.4,
      forecast_complete: 32.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-12-12",
      baseline_complete: 48.0,
      actual_complete: 50.7,
      forecast_complete: 33.4,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-12-19",
      baseline_complete: 49.9,
      actual_complete: 54.4,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2026-12-26",
      baseline_complete: 51.8,
      actual_complete: 54.4,
      forecast_complete: 36.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-01-02",
      baseline_complete: 53.7,
      actual_complete: 55.1,
      forecast_complete: 37.6,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-01-09",
      baseline_complete: 55.5,
      actual_complete: 60.3,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-01-16",
      baseline_complete: 57.4,
      actual_complete: 61.6,
      forecast_complete: 40.4,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-01-23",
      baseline_complete: 59.2,
      actual_complete: 61.6,
      forecast_complete: 41.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-01-30",
      baseline_complete: 61.0,
      actual_complete: 62.7,
      forecast_complete: 43.3,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-02-06",
      baseline_complete: 62.8,
      actual_complete: 65.0,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-02-13",
      baseline_complete: 64.5,
      actual_complete: 67.6,
      forecast_complete: 46.2,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-02-20",
      baseline_complete: 66.2,
      actual_complete: 69.4,
      forecast_complete: 47.7,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-02-27",
      baseline_complete: 67.8,
      actual_complete: 72.4,
      forecast_complete: 49.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-03-06",
      baseline_complete: 69.5,
      actual_complete: 72.4,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-03-13",
      baseline_complete: 71.0,
      actual_complete: 72.6,
      forecast_complete: 52.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-03-20",
      baseline_complete: 72.6,
      actual_complete: 76.5,
      forecast_complete: 53.4,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-03-27",
      baseline_complete: 74.0,
      actual_complete: 77.3,
      forecast_complete: 54.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-04-03",
      baseline_complete: 75.4,
      actual_complete: 77.3,
      forecast_complete: 56.2,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-04-10",
      baseline_complete: 76.8,
      actual_complete: 79.4,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-04-17",
      baseline_complete: 78.1,
      actual_complete: 81.2,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-04-24",
      baseline_complete: 79.4,
      actual_complete: 83.4,
      forecast_complete: 60.3,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-05-01",
      baseline_complete: 80.6,
      actual_complete: 83.8,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-05-08",
      baseline_complete: 81.7,
      actual_complete: 83.8,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-05-15",
      baseline_complete: 82.8,
      actual_complete: 84.3,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-05-22",
      baseline_complete: 83.9,
      actual_complete: 86.9,
      forecast_complete: 65.4,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-05-29",
      baseline_complete: 84.8,
      actual_complete: 86.9,
      forecast_complete: 66.6,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-06-05",
      baseline_complete: 85.8,
      actual_complete: 88.2,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-06-12",
      baseline_complete: 86.7,
      actual_complete: 89.6,
      forecast_complete: 69.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-06-19",
      baseline_complete: 87.5,
      actual_complete: 89.6,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-06-26",
      baseline_complete: 88.3,
      actual_complete: 91.4,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-07-03",
      baseline_complete: 89.1,
      actual_complete: 91.4,
      forecast_complete: 73.3,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-07-10",
      baseline_complete: 89.8,
      actual_complete: 93.4,
      forecast_complete: 75.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-07-17",
      baseline_complete: 90.4,
      actual_complete: 93.4,
      forecast_complete: 76.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-07-24",
      baseline_complete: 91.1,
      actual_complete: 93.6,
      forecast_complete: 78.5,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-07-31",
      baseline_complete: 91.7,
      actual_complete: 93.6,
      forecast_complete: 80.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-08-07",
      baseline_complete: 92.2,
      actual_complete: 93.8,
      forecast_complete: 81.6,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-08-14",
      baseline_complete: 92.7,
      actual_complete: 95.1,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-08-21",
      baseline_complete: 93.2,
      actual_complete: 95.1,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-08-28",
      baseline_complete: 93.7,
      actual_complete: 95.2,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-09-04",
      baseline_complete: 94.1,
      actual_complete: 96.6,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-09-11",
      baseline_complete: 94.5,
      actual_complete: 97.2,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-09-18",
      baseline_complete: 94.9,
      actual_complete: 97.2,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-09-25",
      baseline_complete: 95.2,
      actual_complete: 97.3,
      forecast_complete: 90.5,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-10-02",
      baseline_complete: 95.6,
      actual_complete: 97.3,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-10-09",
      baseline_complete: 95.9,
      actual_complete: 99.2,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-10-16",
      baseline_complete: 96.2,
      actual_complete: 99.2,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-10-23",
      baseline_complete: 96.4,
      actual_complete: 99.2,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-10-30",
      baseline_complete: 96.7,
      actual_complete: 99.2,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-11-06",
      baseline_complete: 96.9,
      actual_complete: 99.2,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-11-13",
      baseline_complete: 97.1,
      actual_complete: 99.2,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-11-20",
      baseline_complete: 97.3,
      actual_complete: 99.9,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-11-27",
      baseline_complete: 97.5,
      actual_complete: 99.9,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-12-04",
      baseline_complete: 97.7,
      actual_complete: 99.9,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-12-11",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-12-18",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2027-12-25",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-01-01",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-01-08",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-01-15",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-01-22",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-01-29",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-02-05",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-02-12",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-02-19",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-02-26",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-03-04",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-03-11",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-03-18",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "23ecf456-a7f5-a4de-f448-d94c04843c84",
      reporting_date: "2028-03-22",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "8b5921c6-9d15-f318-c136-acb492469ab7": [
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-05-04",
      baseline_complete: 1.1,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-05-11",
      baseline_complete: 1.2,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-05-18",
      baseline_complete: 1.2,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-05-25",
      baseline_complete: 1.3,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-06-01",
      baseline_complete: 1.3,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-06-08",
      baseline_complete: 1.3,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-06-15",
      baseline_complete: 1.4,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-06-22",
      baseline_complete: 1.4,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-06-29",
      baseline_complete: 1.5,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-07-06",
      baseline_complete: 1.5,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-07-13",
      baseline_complete: 1.6,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-07-20",
      baseline_complete: 1.6,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-07-27",
      baseline_complete: 1.7,
      actual_complete: 5.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-08-03",
      baseline_complete: 1.7,
      actual_complete: 5.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-08-10",
      baseline_complete: 1.8,
      actual_complete: 5.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-08-17",
      baseline_complete: 1.9,
      actual_complete: 5.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-08-24",
      baseline_complete: 1.9,
      actual_complete: 5.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-08-31",
      baseline_complete: 2.0,
      actual_complete: 5.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-09-07",
      baseline_complete: 2.0,
      actual_complete: 5.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-09-14",
      baseline_complete: 2.1,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-09-21",
      baseline_complete: 2.2,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-09-28",
      baseline_complete: 2.3,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-10-05",
      baseline_complete: 2.3,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-10-12",
      baseline_complete: 2.4,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-10-19",
      baseline_complete: 2.5,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-10-26",
      baseline_complete: 2.6,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-11-02",
      baseline_complete: 2.7,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-11-09",
      baseline_complete: 2.7,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-11-16",
      baseline_complete: 2.8,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-11-23",
      baseline_complete: 2.9,
      actual_complete: 6.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-11-30",
      baseline_complete: 3.0,
      actual_complete: 6.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-12-07",
      baseline_complete: 3.1,
      actual_complete: 6.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-12-14",
      baseline_complete: 3.2,
      actual_complete: 6.8,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-12-21",
      baseline_complete: 3.3,
      actual_complete: 6.8,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2023-12-28",
      baseline_complete: 3.4,
      actual_complete: 6.8,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-01-04",
      baseline_complete: 3.5,
      actual_complete: 6.8,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-01-11",
      baseline_complete: 3.7,
      actual_complete: 6.8,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-01-18",
      baseline_complete: 3.8,
      actual_complete: 7.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-01-25",
      baseline_complete: 3.9,
      actual_complete: 7.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-02-01",
      baseline_complete: 4.0,
      actual_complete: 7.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-02-08",
      baseline_complete: 4.2,
      actual_complete: 7.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-02-15",
      baseline_complete: 4.3,
      actual_complete: 7.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-02-22",
      baseline_complete: 4.4,
      actual_complete: 7.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-02-29",
      baseline_complete: 4.6,
      actual_complete: 7.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-03-07",
      baseline_complete: 4.7,
      actual_complete: 7.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-03-14",
      baseline_complete: 4.9,
      actual_complete: 7.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-03-21",
      baseline_complete: 5.0,
      actual_complete: 7.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-03-28",
      baseline_complete: 5.2,
      actual_complete: 7.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-04-04",
      baseline_complete: 5.3,
      actual_complete: 9.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-04-11",
      baseline_complete: 5.5,
      actual_complete: 9.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-04-18",
      baseline_complete: 5.7,
      actual_complete: 9.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-04-25",
      baseline_complete: 5.9,
      actual_complete: 9.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-05-02",
      baseline_complete: 6.1,
      actual_complete: 9.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-05-09",
      baseline_complete: 6.3,
      actual_complete: 9.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-05-16",
      baseline_complete: 6.5,
      actual_complete: 9.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-05-23",
      baseline_complete: 6.7,
      actual_complete: 10.2,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-05-30",
      baseline_complete: 6.9,
      actual_complete: 10.2,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-06-06",
      baseline_complete: 7.1,
      actual_complete: 10.2,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-06-13",
      baseline_complete: 7.3,
      actual_complete: 10.2,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-06-20",
      baseline_complete: 7.5,
      actual_complete: 10.2,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-06-27",
      baseline_complete: 7.8,
      actual_complete: 10.2,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-07-04",
      baseline_complete: 8.0,
      actual_complete: 10.2,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-07-11",
      baseline_complete: 8.2,
      actual_complete: 10.2,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-07-18",
      baseline_complete: 8.5,
      actual_complete: 10.2,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-07-25",
      baseline_complete: 8.8,
      actual_complete: 11.5,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-08-01",
      baseline_complete: 9.0,
      actual_complete: 11.5,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-08-08",
      baseline_complete: 9.3,
      actual_complete: 11.5,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-08-15",
      baseline_complete: 9.6,
      actual_complete: 11.5,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-08-22",
      baseline_complete: 9.9,
      actual_complete: 11.5,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-08-29",
      baseline_complete: 10.2,
      actual_complete: 11.5,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-09-05",
      baseline_complete: 10.5,
      actual_complete: 11.5,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-09-12",
      baseline_complete: 10.8,
      actual_complete: 14.4,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-09-19",
      baseline_complete: 11.1,
      actual_complete: 14.4,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-09-26",
      baseline_complete: 11.5,
      actual_complete: 14.4,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-10-03",
      baseline_complete: 11.8,
      actual_complete: 14.9,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-10-10",
      baseline_complete: 12.2,
      actual_complete: 14.9,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-10-17",
      baseline_complete: 12.5,
      actual_complete: 15.3,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-10-24",
      baseline_complete: 12.9,
      actual_complete: 15.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-10-31",
      baseline_complete: 13.3,
      actual_complete: 15.5,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-11-07",
      baseline_complete: 13.6,
      actual_complete: 15.5,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-11-14",
      baseline_complete: 14.0,
      actual_complete: 15.9,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-11-21",
      baseline_complete: 14.4,
      actual_complete: 15.9,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-11-28",
      baseline_complete: 14.9,
      actual_complete: 18.6,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-12-05",
      baseline_complete: 15.3,
      actual_complete: 18.6,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-12-12",
      baseline_complete: 15.7,
      actual_complete: 18.6,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-12-19",
      baseline_complete: 16.2,
      actual_complete: 18.6,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2024-12-26",
      baseline_complete: 16.6,
      actual_complete: 18.6,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-01-02",
      baseline_complete: 17.1,
      actual_complete: 20.6,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-01-09",
      baseline_complete: 17.5,
      actual_complete: 20.6,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-01-16",
      baseline_complete: 18.0,
      actual_complete: 20.6,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-01-23",
      baseline_complete: 18.5,
      actual_complete: 22.6,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-01-30",
      baseline_complete: 19.0,
      actual_complete: 22.6,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-02-06",
      baseline_complete: 19.5,
      actual_complete: 22.6,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-02-13",
      baseline_complete: 20.1,
      actual_complete: 22.6,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-02-20",
      baseline_complete: 20.6,
      actual_complete: 22.6,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-02-27",
      baseline_complete: 21.2,
      actual_complete: 22.9,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-03-06",
      baseline_complete: 21.7,
      actual_complete: 25.4,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-03-13",
      baseline_complete: 22.3,
      actual_complete: 25.4,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-03-20",
      baseline_complete: 22.9,
      actual_complete: 25.4,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-03-27",
      baseline_complete: 23.5,
      actual_complete: 25.4,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-04-03",
      baseline_complete: 24.1,
      actual_complete: 26.0,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-04-10",
      baseline_complete: 24.7,
      actual_complete: 27.2,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-04-17",
      baseline_complete: 25.3,
      actual_complete: 29.0,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-04-24",
      baseline_complete: 25.9,
      actual_complete: 29.0,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-05-01",
      baseline_complete: 26.6,
      actual_complete: 29.0,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-05-08",
      baseline_complete: 27.2,
      actual_complete: 29.0,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-05-15",
      baseline_complete: 27.9,
      actual_complete: 29.0,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-05-22",
      baseline_complete: 28.5,
      actual_complete: 30.4,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-05-29",
      baseline_complete: 29.2,
      actual_complete: 30.4,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-06-05",
      baseline_complete: 29.9,
      actual_complete: 30.7,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-06-12",
      baseline_complete: 30.6,
      actual_complete: 34.6,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-06-19",
      baseline_complete: 31.3,
      actual_complete: 34.6,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-06-26",
      baseline_complete: 32.0,
      actual_complete: 35.5,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-07-03",
      baseline_complete: 32.8,
      actual_complete: 35.5,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-07-10",
      baseline_complete: 33.5,
      actual_complete: 35.5,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-07-17",
      baseline_complete: 34.2,
      actual_complete: 37.3,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-07-24",
      baseline_complete: 35.0,
      actual_complete: 37.3,
      forecast_complete: 16.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-07-31",
      baseline_complete: 35.8,
      actual_complete: 38.2,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-08-07",
      baseline_complete: 36.5,
      actual_complete: 38.2,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-08-14",
      baseline_complete: 37.3,
      actual_complete: 40.7,
      forecast_complete: 18.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-08-21",
      baseline_complete: 38.1,
      actual_complete: 40.7,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-08-28",
      baseline_complete: 38.8,
      actual_complete: 40.7,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-09-04",
      baseline_complete: 39.6,
      actual_complete: 40.7,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-09-11",
      baseline_complete: 40.4,
      actual_complete: 40.7,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-09-18",
      baseline_complete: 41.2,
      actual_complete: 43.6,
      forecast_complete: 20.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-09-25",
      baseline_complete: 42.0,
      actual_complete: 44.0,
      forecast_complete: 21.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-10-02",
      baseline_complete: 42.9,
      actual_complete: 46.0,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-10-09",
      baseline_complete: 43.7,
      actual_complete: 46.5,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-10-16",
      baseline_complete: 44.5,
      actual_complete: 48.6,
      forecast_complete: 23.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-10-23",
      baseline_complete: 45.3,
      actual_complete: 48.6,
      forecast_complete: 23.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-10-30",
      baseline_complete: 46.1,
      actual_complete: 48.6,
      forecast_complete: 24.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-11-06",
      baseline_complete: 46.9,
      actual_complete: 49.2,
      forecast_complete: 24.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-11-13",
      baseline_complete: 47.8,
      actual_complete: 51.5,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-11-20",
      baseline_complete: 48.6,
      actual_complete: 51.5,
      forecast_complete: 26.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-11-27",
      baseline_complete: 49.4,
      actual_complete: 51.6,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-12-04",
      baseline_complete: 50.3,
      actual_complete: 51.7,
      forecast_complete: 27.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-12-11",
      baseline_complete: 51.1,
      actual_complete: 54.4,
      forecast_complete: 27.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-12-18",
      baseline_complete: 51.9,
      actual_complete: 54.4,
      forecast_complete: 28.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2025-12-25",
      baseline_complete: 52.7,
      actual_complete: 54.9,
      forecast_complete: 29.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-01-01",
      baseline_complete: 53.6,
      actual_complete: 54.9,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-01-08",
      baseline_complete: 54.4,
      actual_complete: 54.9,
      forecast_complete: 30.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-01-15",
      baseline_complete: 55.2,
      actual_complete: 56.4,
      forecast_complete: 31.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-01-22",
      baseline_complete: 56.0,
      actual_complete: 57.1,
      forecast_complete: 31.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-01-29",
      baseline_complete: 56.8,
      actual_complete: 58.6,
      forecast_complete: 32.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-02-05",
      baseline_complete: 57.7,
      actual_complete: 58.8,
      forecast_complete: 33.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-02-12",
      baseline_complete: 58.5,
      actual_complete: 59.1,
      forecast_complete: 33.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-02-19",
      baseline_complete: 59.3,
      actual_complete: 60.8,
      forecast_complete: 34.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-02-26",
      baseline_complete: 60.1,
      actual_complete: 61.6,
      forecast_complete: 35.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-03-05",
      baseline_complete: 60.9,
      actual_complete: 61.9,
      forecast_complete: 35.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-03-12",
      baseline_complete: 61.6,
      actual_complete: 62.5,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-03-19",
      baseline_complete: 62.4,
      actual_complete: 66.8,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-03-26",
      baseline_complete: 63.2,
      actual_complete: 67.2,
      forecast_complete: 37.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-04-02",
      baseline_complete: 64.0,
      actual_complete: 67.2,
      forecast_complete: 38.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-04-09",
      baseline_complete: 64.7,
      actual_complete: 68.0,
      forecast_complete: 39.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-04-16",
      baseline_complete: 65.5,
      actual_complete: 68.0,
      forecast_complete: 39.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-04-23",
      baseline_complete: 66.2,
      actual_complete: 68.5,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-04-30",
      baseline_complete: 67.0,
      actual_complete: 69.8,
      forecast_complete: 41.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-05-07",
      baseline_complete: 67.7,
      actual_complete: 70.1,
      forecast_complete: 41.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-05-14",
      baseline_complete: 68.4,
      actual_complete: 70.2,
      forecast_complete: 42.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-05-21",
      baseline_complete: 69.1,
      actual_complete: 70.2,
      forecast_complete: 43.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-05-28",
      baseline_complete: 69.8,
      actual_complete: 71.3,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-06-04",
      baseline_complete: 70.5,
      actual_complete: 71.6,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-06-11",
      baseline_complete: 71.2,
      actual_complete: 74.4,
      forecast_complete: 45.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-06-18",
      baseline_complete: 71.9,
      actual_complete: 74.4,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-06-25",
      baseline_complete: 72.5,
      actual_complete: 75.4,
      forecast_complete: 46.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-07-02",
      baseline_complete: 73.2,
      actual_complete: 75.4,
      forecast_complete: 47.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-07-09",
      baseline_complete: 73.8,
      actual_complete: 75.4,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-07-16",
      baseline_complete: 74.5,
      actual_complete: 76.2,
      forecast_complete: 48.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-07-23",
      baseline_complete: 75.1,
      actual_complete: 76.9,
      forecast_complete: 49.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-07-30",
      baseline_complete: 75.7,
      actual_complete: 78.2,
      forecast_complete: 50.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-08-06",
      baseline_complete: 76.3,
      actual_complete: 79.1,
      forecast_complete: 50.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-08-13",
      baseline_complete: 76.9,
      actual_complete: 79.1,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-08-20",
      baseline_complete: 77.5,
      actual_complete: 79.1,
      forecast_complete: 52.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-08-27",
      baseline_complete: 78.1,
      actual_complete: 79.1,
      forecast_complete: 53.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-09-03",
      baseline_complete: 78.6,
      actual_complete: 80.8,
      forecast_complete: 53.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-09-10",
      baseline_complete: 79.2,
      actual_complete: 80.8,
      forecast_complete: 54.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-09-17",
      baseline_complete: 79.7,
      actual_complete: 81.5,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-09-24",
      baseline_complete: 80.3,
      actual_complete: 81.5,
      forecast_complete: 55.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-10-01",
      baseline_complete: 80.8,
      actual_complete: 83.6,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-10-08",
      baseline_complete: 81.3,
      actual_complete: 83.6,
      forecast_complete: 56.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-10-15",
      baseline_complete: 81.8,
      actual_complete: 83.6,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-10-22",
      baseline_complete: 82.3,
      actual_complete: 85.1,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-10-29",
      baseline_complete: 82.8,
      actual_complete: 85.1,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-11-05",
      baseline_complete: 83.2,
      actual_complete: 85.9,
      forecast_complete: 59.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-11-12",
      baseline_complete: 83.7,
      actual_complete: 86.7,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-11-19",
      baseline_complete: 84.1,
      actual_complete: 86.7,
      forecast_complete: 60.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-11-26",
      baseline_complete: 84.6,
      actual_complete: 87.0,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-12-03",
      baseline_complete: 85.0,
      actual_complete: 87.1,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-12-10",
      baseline_complete: 85.4,
      actual_complete: 87.1,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-12-17",
      baseline_complete: 85.8,
      actual_complete: 87.1,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-12-24",
      baseline_complete: 86.2,
      actual_complete: 87.5,
      forecast_complete: 63.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2026-12-31",
      baseline_complete: 86.6,
      actual_complete: 88.1,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-01-07",
      baseline_complete: 87.0,
      actual_complete: 88.1,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-01-14",
      baseline_complete: 87.4,
      actual_complete: 89.4,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-01-21",
      baseline_complete: 87.7,
      actual_complete: 89.4,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-01-28",
      baseline_complete: 88.1,
      actual_complete: 91.1,
      forecast_complete: 68.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-02-04",
      baseline_complete: 88.4,
      actual_complete: 91.1,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-02-11",
      baseline_complete: 88.7,
      actual_complete: 91.2,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-02-18",
      baseline_complete: 89.1,
      actual_complete: 91.2,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-02-25",
      baseline_complete: 89.4,
      actual_complete: 91.3,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-03-04",
      baseline_complete: 89.7,
      actual_complete: 91.3,
      forecast_complete: 73.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-03-11",
      baseline_complete: 90.0,
      actual_complete: 91.3,
      forecast_complete: 74.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-03-18",
      baseline_complete: 90.3,
      actual_complete: 92.3,
      forecast_complete: 75.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-03-25",
      baseline_complete: 90.6,
      actual_complete: 92.3,
      forecast_complete: 76.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-04-01",
      baseline_complete: 90.9,
      actual_complete: 93.9,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-04-08",
      baseline_complete: 91.1,
      actual_complete: 94.8,
      forecast_complete: 77.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-04-15",
      baseline_complete: 91.4,
      actual_complete: 94.8,
      forecast_complete: 78.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-04-22",
      baseline_complete: 91.7,
      actual_complete: 94.8,
      forecast_complete: 79.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-04-29",
      baseline_complete: 91.9,
      actual_complete: 94.8,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-05-06",
      baseline_complete: 92.2,
      actual_complete: 94.8,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-05-13",
      baseline_complete: 92.4,
      actual_complete: 94.8,
      forecast_complete: 81.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-05-20",
      baseline_complete: 92.6,
      actual_complete: 94.8,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-05-27",
      baseline_complete: 92.8,
      actual_complete: 94.8,
      forecast_complete: 83.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-06-03",
      baseline_complete: 93.1,
      actual_complete: 96.2,
      forecast_complete: 84.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-06-10",
      baseline_complete: 93.3,
      actual_complete: 96.2,
      forecast_complete: 84.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-06-17",
      baseline_complete: 93.5,
      actual_complete: 96.2,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-06-24",
      baseline_complete: 93.7,
      actual_complete: 96.7,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-07-01",
      baseline_complete: 93.9,
      actual_complete: 96.7,
      forecast_complete: 86.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-07-08",
      baseline_complete: 94.1,
      actual_complete: 97.0,
      forecast_complete: 87.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-07-15",
      baseline_complete: 94.2,
      actual_complete: 97.0,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-07-22",
      baseline_complete: 94.4,
      actual_complete: 97.5,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-07-29",
      baseline_complete: 94.6,
      actual_complete: 97.5,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-08-05",
      baseline_complete: 94.8,
      actual_complete: 97.5,
      forecast_complete: 89.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-08-12",
      baseline_complete: 94.9,
      actual_complete: 97.5,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-08-19",
      baseline_complete: 95.1,
      actual_complete: 97.5,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-08-26",
      baseline_complete: 95.2,
      actual_complete: 97.5,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-09-02",
      baseline_complete: 95.4,
      actual_complete: 97.5,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-09-09",
      baseline_complete: 95.5,
      actual_complete: 97.5,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-09-16",
      baseline_complete: 95.7,
      actual_complete: 97.5,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-09-23",
      baseline_complete: 95.8,
      actual_complete: 97.5,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-09-30",
      baseline_complete: 95.9,
      actual_complete: 97.8,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-10-07",
      baseline_complete: 96.1,
      actual_complete: 97.8,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-10-14",
      baseline_complete: 96.2,
      actual_complete: 97.8,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-10-21",
      baseline_complete: 96.3,
      actual_complete: 97.8,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-10-28",
      baseline_complete: 96.4,
      actual_complete: 98.9,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-11-04",
      baseline_complete: 96.5,
      actual_complete: 98.9,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-11-11",
      baseline_complete: 96.6,
      actual_complete: 98.9,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-11-18",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-11-25",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-12-02",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-12-09",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-12-16",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-12-23",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2027-12-30",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-01-06",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-01-13",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-01-20",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-01-27",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-02-03",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-02-10",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-02-17",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-02-24",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-03-02",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-03-09",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-03-16",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-03-23",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-03-30",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "8b5921c6-9d15-f318-c136-acb492469ab7",
      reporting_date: "2028-04-04",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
  ],
  "ad3036a1-888e-e195-c943-cb2b5c991ccd": [
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-03-04",
      baseline_complete: 0.2,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-03-11",
      baseline_complete: 0.2,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-03-18",
      baseline_complete: 0.2,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-03-25",
      baseline_complete: 0.2,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-04-01",
      baseline_complete: 0.3,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-04-08",
      baseline_complete: 0.3,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-04-15",
      baseline_complete: 0.3,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-04-22",
      baseline_complete: 0.3,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-04-29",
      baseline_complete: 0.4,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-05-06",
      baseline_complete: 0.4,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-05-13",
      baseline_complete: 0.4,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-05-20",
      baseline_complete: 0.5,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-05-27",
      baseline_complete: 0.5,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-06-03",
      baseline_complete: 0.5,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-06-10",
      baseline_complete: 0.6,
      actual_complete: 0.8,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-06-17",
      baseline_complete: 0.6,
      actual_complete: 1.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-06-24",
      baseline_complete: 0.7,
      actual_complete: 1.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-07-01",
      baseline_complete: 0.7,
      actual_complete: 1.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-07-08",
      baseline_complete: 0.8,
      actual_complete: 1.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-07-15",
      baseline_complete: 0.8,
      actual_complete: 1.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-07-22",
      baseline_complete: 0.9,
      actual_complete: 1.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-07-29",
      baseline_complete: 1.0,
      actual_complete: 1.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-08-05",
      baseline_complete: 1.1,
      actual_complete: 1.5,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-08-12",
      baseline_complete: 1.2,
      actual_complete: 1.5,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-08-19",
      baseline_complete: 1.2,
      actual_complete: 1.5,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-08-26",
      baseline_complete: 1.3,
      actual_complete: 2.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-09-02",
      baseline_complete: 1.4,
      actual_complete: 2.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-09-09",
      baseline_complete: 1.6,
      actual_complete: 2.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-09-16",
      baseline_complete: 1.7,
      actual_complete: 2.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-09-23",
      baseline_complete: 1.8,
      actual_complete: 2.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-09-30",
      baseline_complete: 2.0,
      actual_complete: 2.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-10-07",
      baseline_complete: 2.1,
      actual_complete: 2.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-10-14",
      baseline_complete: 2.3,
      actual_complete: 2.6,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-10-21",
      baseline_complete: 2.5,
      actual_complete: 2.6,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-10-28",
      baseline_complete: 2.7,
      actual_complete: 2.6,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-11-04",
      baseline_complete: 2.9,
      actual_complete: 3.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-11-11",
      baseline_complete: 3.1,
      actual_complete: 3.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-11-18",
      baseline_complete: 3.3,
      actual_complete: 3.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-11-25",
      baseline_complete: 3.6,
      actual_complete: 3.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-12-02",
      baseline_complete: 3.9,
      actual_complete: 3.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-12-09",
      baseline_complete: 4.2,
      actual_complete: 4.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-12-16",
      baseline_complete: 4.5,
      actual_complete: 4.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-12-23",
      baseline_complete: 4.8,
      actual_complete: 4.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2024-12-30",
      baseline_complete: 5.2,
      actual_complete: 4.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-01-06",
      baseline_complete: 5.6,
      actual_complete: 4.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-01-13",
      baseline_complete: 6.0,
      actual_complete: 6.6,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-01-20",
      baseline_complete: 6.5,
      actual_complete: 6.6,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-01-27",
      baseline_complete: 7.0,
      actual_complete: 6.6,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-02-03",
      baseline_complete: 7.5,
      actual_complete: 8.4,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-02-10",
      baseline_complete: 8.1,
      actual_complete: 8.4,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-02-17",
      baseline_complete: 8.7,
      actual_complete: 8.4,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-02-24",
      baseline_complete: 9.3,
      actual_complete: 8.4,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-03-03",
      baseline_complete: 10.0,
      actual_complete: 8.4,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-03-10",
      baseline_complete: 10.7,
      actual_complete: 10.4,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-03-17",
      baseline_complete: 11.5,
      actual_complete: 11.1,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-03-24",
      baseline_complete: 12.3,
      actual_complete: 14.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-03-31",
      baseline_complete: 13.1,
      actual_complete: 14.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-04-07",
      baseline_complete: 14.0,
      actual_complete: 14.0,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-04-14",
      baseline_complete: 15.0,
      actual_complete: 17.0,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-04-21",
      baseline_complete: 16.0,
      actual_complete: 17.0,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-04-28",
      baseline_complete: 17.1,
      actual_complete: 17.0,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-05-05",
      baseline_complete: 18.2,
      actual_complete: 20.8,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-05-12",
      baseline_complete: 19.4,
      actual_complete: 20.8,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-05-19",
      baseline_complete: 20.7,
      actual_complete: 20.8,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-05-26",
      baseline_complete: 22.0,
      actual_complete: 21.4,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-06-02",
      baseline_complete: 23.3,
      actual_complete: 22.1,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-06-09",
      baseline_complete: 24.7,
      actual_complete: 24.1,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-06-16",
      baseline_complete: 26.2,
      actual_complete: 24.1,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-06-23",
      baseline_complete: 27.8,
      actual_complete: 25.6,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-06-30",
      baseline_complete: 29.3,
      actual_complete: 30.3,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-07-07",
      baseline_complete: 31.0,
      actual_complete: 30.3,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-07-14",
      baseline_complete: 32.7,
      actual_complete: 30.9,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-07-21",
      baseline_complete: 34.4,
      actual_complete: 34.7,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-07-28",
      baseline_complete: 36.2,
      actual_complete: 34.7,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-08-04",
      baseline_complete: 38.0,
      actual_complete: 34.7,
      forecast_complete: 18.9,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-08-11",
      baseline_complete: 39.8,
      actual_complete: 39.4,
      forecast_complete: 20.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-08-18",
      baseline_complete: 41.7,
      actual_complete: 39.4,
      forecast_complete: 21.4,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-08-25",
      baseline_complete: 43.6,
      actual_complete: 47.1,
      forecast_complete: 22.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-09-01",
      baseline_complete: 45.5,
      actual_complete: 47.1,
      forecast_complete: 24.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-09-08",
      baseline_complete: 47.5,
      actual_complete: 47.1,
      forecast_complete: 25.6,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-09-15",
      baseline_complete: 49.4,
      actual_complete: 47.4,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-09-22",
      baseline_complete: 51.3,
      actual_complete: 53.1,
      forecast_complete: 28.4,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-09-29",
      baseline_complete: 53.3,
      actual_complete: 53.1,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-10-06",
      baseline_complete: 55.2,
      actual_complete: 53.8,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-10-13",
      baseline_complete: 57.1,
      actual_complete: 54.7,
      forecast_complete: 33.0,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-10-20",
      baseline_complete: 59.0,
      actual_complete: 59.5,
      forecast_complete: 34.6,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-10-27",
      baseline_complete: 60.9,
      actual_complete: 60.3,
      forecast_complete: 36.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-11-03",
      baseline_complete: 62.7,
      actual_complete: 61.0,
      forecast_complete: 37.7,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-11-10",
      baseline_complete: 64.5,
      actual_complete: 63.3,
      forecast_complete: 39.3,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-11-17",
      baseline_complete: 66.3,
      actual_complete: 63.3,
      forecast_complete: 40.9,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-11-24",
      baseline_complete: 68.0,
      actual_complete: 65.8,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-12-01",
      baseline_complete: 69.6,
      actual_complete: 68.6,
      forecast_complete: 43.9,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-12-08",
      baseline_complete: 71.3,
      actual_complete: 70.9,
      forecast_complete: 45.6,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-12-15",
      baseline_complete: 72.8,
      actual_complete: 71.3,
      forecast_complete: 47.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-12-22",
      baseline_complete: 74.3,
      actual_complete: 77.1,
      forecast_complete: 48.6,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2025-12-29",
      baseline_complete: 75.8,
      actual_complete: 77.5,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-01-05",
      baseline_complete: 77.2,
      actual_complete: 77.5,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-01-12",
      baseline_complete: 78.5,
      actual_complete: 77.6,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-01-19",
      baseline_complete: 79.8,
      actual_complete: 77.6,
      forecast_complete: 54.5,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-01-26",
      baseline_complete: 81.0,
      actual_complete: 84.6,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-02-02",
      baseline_complete: 82.2,
      actual_complete: 84.6,
      forecast_complete: 57.4,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-02-09",
      baseline_complete: 83.3,
      actual_complete: 85.1,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-02-16",
      baseline_complete: 84.4,
      actual_complete: 85.1,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-02-23",
      baseline_complete: 85.4,
      actual_complete: 87.5,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-03-02",
      baseline_complete: 86.3,
      actual_complete: 89.9,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-03-09",
      baseline_complete: 87.2,
      actual_complete: 89.9,
      forecast_complete: 64.0,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-03-16",
      baseline_complete: 88.0,
      actual_complete: 91.8,
      forecast_complete: 66.2,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-03-23",
      baseline_complete: 88.8,
      actual_complete: 92.5,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-03-30",
      baseline_complete: 89.6,
      actual_complete: 94.5,
      forecast_complete: 70.4,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-04-06",
      baseline_complete: 90.3,
      actual_complete: 94.5,
      forecast_complete: 72.3,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-04-13",
      baseline_complete: 90.9,
      actual_complete: 94.5,
      forecast_complete: 74.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-04-20",
      baseline_complete: 91.6,
      actual_complete: 94.5,
      forecast_complete: 75.9,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-04-27",
      baseline_complete: 92.1,
      actual_complete: 94.5,
      forecast_complete: 77.5,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-05-04",
      baseline_complete: 92.7,
      actual_complete: 96.0,
      forecast_complete: 79.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-05-11",
      baseline_complete: 93.2,
      actual_complete: 96.0,
      forecast_complete: 80.6,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-05-18",
      baseline_complete: 93.7,
      actual_complete: 96.0,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-05-25",
      baseline_complete: 94.1,
      actual_complete: 96.0,
      forecast_complete: 83.4,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-06-01",
      baseline_complete: 94.5,
      actual_complete: 96.0,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-06-08",
      baseline_complete: 94.9,
      actual_complete: 98.9,
      forecast_complete: 85.9,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-06-15",
      baseline_complete: 95.3,
      actual_complete: 98.9,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-06-22",
      baseline_complete: 95.6,
      actual_complete: 98.9,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-06-29",
      baseline_complete: 95.9,
      actual_complete: 98.9,
      forecast_complete: 89.2,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-07-06",
      baseline_complete: 96.2,
      actual_complete: 98.9,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-07-13",
      baseline_complete: 96.5,
      actual_complete: 99.9,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-07-20",
      baseline_complete: 96.8,
      actual_complete: 99.9,
      forecast_complete: 91.9,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-07-27",
      baseline_complete: 97.0,
      actual_complete: 99.9,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-08-03",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-08-10",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-08-17",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-08-24",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-08-31",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-09-07",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-09-14",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-09-21",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-09-28",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-10-05",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-10-12",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-10-19",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-10-26",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-11-02",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "ad3036a1-888e-e195-c943-cb2b5c991ccd",
      reporting_date: "2026-11-04",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
  ],
  "d1090b0c-2298-4042-2e6e-36d4f0266c9e": [
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2024-10-16",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2024-10-23",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2024-10-30",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2024-11-06",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2024-11-13",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2024-11-20",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2024-11-27",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2024-12-04",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2024-12-11",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2024-12-18",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2024-12-25",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-01-01",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-01-08",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-01-15",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-01-22",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-01-29",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-02-05",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-02-12",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-02-19",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-02-26",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-03-05",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-03-12",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-03-19",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-03-26",
      baseline_complete: 3.5,
      actual_complete: 0.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-04-02",
      baseline_complete: 3.7,
      actual_complete: 0.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-04-09",
      baseline_complete: 3.9,
      actual_complete: 0.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-04-16",
      baseline_complete: 4.1,
      actual_complete: 0.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-04-23",
      baseline_complete: 4.4,
      actual_complete: 0.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-04-30",
      baseline_complete: 4.6,
      actual_complete: 0.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-05-07",
      baseline_complete: 4.8,
      actual_complete: 0.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-05-14",
      baseline_complete: 5.1,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-05-21",
      baseline_complete: 5.4,
      actual_complete: 1.9,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-05-28",
      baseline_complete: 5.7,
      actual_complete: 2.9,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-06-04",
      baseline_complete: 6.0,
      actual_complete: 3.2,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-06-11",
      baseline_complete: 6.3,
      actual_complete: 3.2,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-06-18",
      baseline_complete: 6.6,
      actual_complete: 3.2,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-06-25",
      baseline_complete: 6.9,
      actual_complete: 3.2,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-07-02",
      baseline_complete: 7.3,
      actual_complete: 4.7,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-07-09",
      baseline_complete: 7.7,
      actual_complete: 4.7,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-07-16",
      baseline_complete: 8.1,
      actual_complete: 4.7,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-07-23",
      baseline_complete: 8.5,
      actual_complete: 5.6,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-07-30",
      baseline_complete: 8.9,
      actual_complete: 5.6,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-08-06",
      baseline_complete: 9.4,
      actual_complete: 5.6,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-08-13",
      baseline_complete: 9.9,
      actual_complete: 8.1,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-08-20",
      baseline_complete: 10.4,
      actual_complete: 8.1,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-08-27",
      baseline_complete: 10.9,
      actual_complete: 8.1,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-09-03",
      baseline_complete: 11.4,
      actual_complete: 8.1,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-09-10",
      baseline_complete: 12.0,
      actual_complete: 8.5,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-09-17",
      baseline_complete: 12.6,
      actual_complete: 8.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-09-24",
      baseline_complete: 13.2,
      actual_complete: 10.4,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-10-01",
      baseline_complete: 13.9,
      actual_complete: 10.4,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-10-08",
      baseline_complete: 14.5,
      actual_complete: 13.2,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-10-15",
      baseline_complete: 15.2,
      actual_complete: 13.2,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-10-22",
      baseline_complete: 15.9,
      actual_complete: 13.9,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-10-29",
      baseline_complete: 16.7,
      actual_complete: 15.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-11-05",
      baseline_complete: 17.5,
      actual_complete: 15.6,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-11-12",
      baseline_complete: 18.3,
      actual_complete: 15.6,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-11-19",
      baseline_complete: 19.1,
      actual_complete: 17.2,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-11-26",
      baseline_complete: 20.0,
      actual_complete: 18.8,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-12-03",
      baseline_complete: 20.9,
      actual_complete: 18.8,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-12-10",
      baseline_complete: 21.8,
      actual_complete: 18.9,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-12-17",
      baseline_complete: 22.7,
      actual_complete: 19.8,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-12-24",
      baseline_complete: 23.7,
      actual_complete: 21.9,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2025-12-31",
      baseline_complete: 24.7,
      actual_complete: 23.0,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-01-07",
      baseline_complete: 25.8,
      actual_complete: 23.0,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-01-14",
      baseline_complete: 26.8,
      actual_complete: 23.3,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-01-21",
      baseline_complete: 27.9,
      actual_complete: 23.3,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-01-28",
      baseline_complete: 29.0,
      actual_complete: 27.0,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-02-04",
      baseline_complete: 30.2,
      actual_complete: 28.7,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-02-11",
      baseline_complete: 31.3,
      actual_complete: 28.7,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-02-18",
      baseline_complete: 32.5,
      actual_complete: 30.0,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-02-25",
      baseline_complete: 33.8,
      actual_complete: 30.1,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-03-04",
      baseline_complete: 35.0,
      actual_complete: 30.1,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-03-11",
      baseline_complete: 36.3,
      actual_complete: 32.0,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-03-18",
      baseline_complete: 37.5,
      actual_complete: 35.1,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-03-25",
      baseline_complete: 38.8,
      actual_complete: 35.6,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-04-01",
      baseline_complete: 40.1,
      actual_complete: 38.2,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-04-08",
      baseline_complete: 41.5,
      actual_complete: 38.2,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-04-15",
      baseline_complete: 42.8,
      actual_complete: 39.1,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-04-22",
      baseline_complete: 44.2,
      actual_complete: 40.9,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-04-29",
      baseline_complete: 45.5,
      actual_complete: 40.9,
      forecast_complete: 18.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-05-06",
      baseline_complete: 46.9,
      actual_complete: 43.7,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-05-13",
      baseline_complete: 48.2,
      actual_complete: 44.5,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-05-20",
      baseline_complete: 49.6,
      actual_complete: 48.7,
      forecast_complete: 21.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-05-27",
      baseline_complete: 51.0,
      actual_complete: 48.7,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-06-03",
      baseline_complete: 52.4,
      actual_complete: 51.9,
      forecast_complete: 23.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-06-10",
      baseline_complete: 53.7,
      actual_complete: 53.2,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-06-17",
      baseline_complete: 55.1,
      actual_complete: 53.2,
      forecast_complete: 24.8,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-06-24",
      baseline_complete: 56.4,
      actual_complete: 56.0,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-07-01",
      baseline_complete: 57.8,
      actual_complete: 56.0,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-07-08",
      baseline_complete: 59.1,
      actual_complete: 58.1,
      forecast_complete: 27.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-07-15",
      baseline_complete: 60.4,
      actual_complete: 58.1,
      forecast_complete: 28.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-07-22",
      baseline_complete: 61.7,
      actual_complete: 59.1,
      forecast_complete: 29.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-07-29",
      baseline_complete: 63.0,
      actual_complete: 62.8,
      forecast_complete: 30.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-08-05",
      baseline_complete: 64.3,
      actual_complete: 62.8,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-08-12",
      baseline_complete: 65.6,
      actual_complete: 66.6,
      forecast_complete: 32.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-08-19",
      baseline_complete: 66.8,
      actual_complete: 66.6,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-08-26",
      baseline_complete: 68.0,
      actual_complete: 66.6,
      forecast_complete: 34.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-09-02",
      baseline_complete: 69.2,
      actual_complete: 66.6,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-09-09",
      baseline_complete: 70.3,
      actual_complete: 67.6,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-09-16",
      baseline_complete: 71.5,
      actual_complete: 68.8,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-09-23",
      baseline_complete: 72.6,
      actual_complete: 69.3,
      forecast_complete: 38.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-09-30",
      baseline_complete: 73.6,
      actual_complete: 73.3,
      forecast_complete: 39.3,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-10-07",
      baseline_complete: 74.7,
      actual_complete: 73.3,
      forecast_complete: 40.3,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-10-14",
      baseline_complete: 75.7,
      actual_complete: 73.8,
      forecast_complete: 41.3,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-10-21",
      baseline_complete: 76.7,
      actual_complete: 77.2,
      forecast_complete: 42.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-10-28",
      baseline_complete: 77.7,
      actual_complete: 77.2,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-11-04",
      baseline_complete: 78.6,
      actual_complete: 79.9,
      forecast_complete: 44.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-11-11",
      baseline_complete: 79.5,
      actual_complete: 79.9,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-11-18",
      baseline_complete: 80.4,
      actual_complete: 79.9,
      forecast_complete: 46.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-11-25",
      baseline_complete: 81.3,
      actual_complete: 80.3,
      forecast_complete: 47.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-12-02",
      baseline_complete: 82.1,
      actual_complete: 83.9,
      forecast_complete: 47.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-12-09",
      baseline_complete: 82.9,
      actual_complete: 83.9,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-12-16",
      baseline_complete: 83.6,
      actual_complete: 85.3,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-12-23",
      baseline_complete: 84.4,
      actual_complete: 85.3,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2026-12-30",
      baseline_complete: 85.1,
      actual_complete: 87.0,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-01-06",
      baseline_complete: 85.8,
      actual_complete: 87.0,
      forecast_complete: 52.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-01-13",
      baseline_complete: 86.4,
      actual_complete: 87.0,
      forecast_complete: 53.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-01-20",
      baseline_complete: 87.1,
      actual_complete: 88.3,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-01-27",
      baseline_complete: 87.7,
      actual_complete: 88.3,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-02-03",
      baseline_complete: 88.2,
      actual_complete: 88.3,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-02-10",
      baseline_complete: 88.8,
      actual_complete: 88.3,
      forecast_complete: 56.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-02-17",
      baseline_complete: 89.3,
      actual_complete: 89.1,
      forecast_complete: 57.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-02-24",
      baseline_complete: 89.8,
      actual_complete: 89.7,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-03-03",
      baseline_complete: 90.3,
      actual_complete: 89.7,
      forecast_complete: 59.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-03-10",
      baseline_complete: 90.8,
      actual_complete: 91.6,
      forecast_complete: 59.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-03-17",
      baseline_complete: 91.3,
      actual_complete: 91.6,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-03-24",
      baseline_complete: 91.7,
      actual_complete: 91.6,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-03-31",
      baseline_complete: 92.1,
      actual_complete: 91.6,
      forecast_complete: 62.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-04-07",
      baseline_complete: 92.5,
      actual_complete: 92.6,
      forecast_complete: 63.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-04-14",
      baseline_complete: 92.9,
      actual_complete: 93.6,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-04-21",
      baseline_complete: 93.2,
      actual_complete: 93.6,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-04-28",
      baseline_complete: 93.6,
      actual_complete: 93.6,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-05-05",
      baseline_complete: 93.9,
      actual_complete: 93.6,
      forecast_complete: 66.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-05-12",
      baseline_complete: 94.2,
      actual_complete: 95.7,
      forecast_complete: 66.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-05-19",
      baseline_complete: 94.5,
      actual_complete: 95.7,
      forecast_complete: 67.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-05-26",
      baseline_complete: 94.8,
      actual_complete: 96.8,
      forecast_complete: 68.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-06-02",
      baseline_complete: 95.0,
      actual_complete: 96.8,
      forecast_complete: 68.8,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-06-09",
      baseline_complete: 95.3,
      actual_complete: 97.0,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-06-16",
      baseline_complete: 95.5,
      actual_complete: 97.0,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-06-23",
      baseline_complete: 95.7,
      actual_complete: 97.0,
      forecast_complete: 70.8,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-06-30",
      baseline_complete: 96.0,
      actual_complete: 97.0,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-07-07",
      baseline_complete: 96.2,
      actual_complete: 97.0,
      forecast_complete: 73.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-07-14",
      baseline_complete: 96.4,
      actual_complete: 97.0,
      forecast_complete: 74.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-07-21",
      baseline_complete: 96.6,
      actual_complete: 97.0,
      forecast_complete: 75.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-07-28",
      baseline_complete: 96.7,
      actual_complete: 97.0,
      forecast_complete: 76.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-08-04",
      baseline_complete: 96.9,
      actual_complete: 97.0,
      forecast_complete: 77.8,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-08-11",
      baseline_complete: 97.1,
      actual_complete: 97.7,
      forecast_complete: 78.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-08-18",
      baseline_complete: 97.2,
      actual_complete: 97.7,
      forecast_complete: 79.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-08-25",
      baseline_complete: 97.4,
      actual_complete: 98.4,
      forecast_complete: 81.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-09-01",
      baseline_complete: 97.5,
      actual_complete: 99.4,
      forecast_complete: 81.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-09-08",
      baseline_complete: 97.6,
      actual_complete: 99.4,
      forecast_complete: 82.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-09-15",
      baseline_complete: 97.8,
      actual_complete: 99.4,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-09-22",
      baseline_complete: 97.9,
      actual_complete: 99.4,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-09-29",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-10-06",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 86.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-10-13",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 87.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-10-20",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-10-27",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-11-03",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-11-10",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-11-17",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-11-24",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-12-01",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-12-08",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-12-15",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-12-22",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2027-12-29",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-01-05",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-01-12",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-01-19",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-01-26",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-02-02",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-02-09",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-02-16",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-02-23",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-03-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-03-08",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-03-15",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-03-22",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-03-29",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-04-05",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-04-12",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-04-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-04-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-05-03",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-05-10",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "d1090b0c-2298-4042-2e6e-36d4f0266c9e",
      reporting_date: "2028-05-16",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
  ],
  "d98a0c4b-9b50-7018-8a94-1a09f057806b": [
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-04-03",
      baseline_complete: 0.2,
      actual_complete: 0.4,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-04-10",
      baseline_complete: 0.2,
      actual_complete: 0.4,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-04-17",
      baseline_complete: 0.2,
      actual_complete: 0.8,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-04-24",
      baseline_complete: 0.3,
      actual_complete: 0.8,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-05-01",
      baseline_complete: 0.3,
      actual_complete: 0.8,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-05-08",
      baseline_complete: 0.3,
      actual_complete: 0.8,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-05-15",
      baseline_complete: 0.3,
      actual_complete: 0.8,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-05-22",
      baseline_complete: 0.3,
      actual_complete: 0.8,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-05-29",
      baseline_complete: 0.3,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-06-05",
      baseline_complete: 0.3,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-06-12",
      baseline_complete: 0.4,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-06-19",
      baseline_complete: 0.4,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-06-26",
      baseline_complete: 0.4,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-07-03",
      baseline_complete: 0.4,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-07-10",
      baseline_complete: 0.4,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-07-17",
      baseline_complete: 0.5,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-07-24",
      baseline_complete: 0.5,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-07-31",
      baseline_complete: 0.5,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-08-07",
      baseline_complete: 0.5,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-08-14",
      baseline_complete: 0.6,
      actual_complete: 1.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-08-21",
      baseline_complete: 0.6,
      actual_complete: 1.1,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-08-28",
      baseline_complete: 0.6,
      actual_complete: 1.1,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-09-04",
      baseline_complete: 0.7,
      actual_complete: 1.1,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-09-11",
      baseline_complete: 0.7,
      actual_complete: 1.1,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-09-18",
      baseline_complete: 0.7,
      actual_complete: 1.1,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-09-25",
      baseline_complete: 0.8,
      actual_complete: 1.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-10-02",
      baseline_complete: 0.8,
      actual_complete: 1.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-10-09",
      baseline_complete: 0.8,
      actual_complete: 1.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-10-16",
      baseline_complete: 0.9,
      actual_complete: 1.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-10-23",
      baseline_complete: 0.9,
      actual_complete: 1.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-10-30",
      baseline_complete: 1.0,
      actual_complete: 1.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-11-06",
      baseline_complete: 1.0,
      actual_complete: 1.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-11-13",
      baseline_complete: 1.1,
      actual_complete: 1.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-11-20",
      baseline_complete: 1.1,
      actual_complete: 1.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-11-27",
      baseline_complete: 1.2,
      actual_complete: 1.8,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-12-04",
      baseline_complete: 1.2,
      actual_complete: 1.8,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-12-11",
      baseline_complete: 1.3,
      actual_complete: 1.8,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-12-18",
      baseline_complete: 1.4,
      actual_complete: 1.8,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2023-12-25",
      baseline_complete: 1.4,
      actual_complete: 1.8,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-01-01",
      baseline_complete: 1.5,
      actual_complete: 2.4,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-01-08",
      baseline_complete: 1.6,
      actual_complete: 2.4,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-01-15",
      baseline_complete: 1.7,
      actual_complete: 2.4,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-01-22",
      baseline_complete: 1.7,
      actual_complete: 2.4,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-01-29",
      baseline_complete: 1.8,
      actual_complete: 2.7,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-02-05",
      baseline_complete: 1.9,
      actual_complete: 2.7,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-02-12",
      baseline_complete: 2.0,
      actual_complete: 2.7,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-02-19",
      baseline_complete: 2.1,
      actual_complete: 2.8,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-02-26",
      baseline_complete: 2.2,
      actual_complete: 2.8,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-03-04",
      baseline_complete: 2.3,
      actual_complete: 2.8,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-03-11",
      baseline_complete: 2.5,
      actual_complete: 2.8,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-03-18",
      baseline_complete: 2.6,
      actual_complete: 3.3,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-03-25",
      baseline_complete: 2.7,
      actual_complete: 3.3,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-04-01",
      baseline_complete: 2.8,
      actual_complete: 3.3,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-04-08",
      baseline_complete: 3.0,
      actual_complete: 3.3,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-04-15",
      baseline_complete: 3.1,
      actual_complete: 3.6,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-04-22",
      baseline_complete: 3.3,
      actual_complete: 4.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-04-29",
      baseline_complete: 3.4,
      actual_complete: 4.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-05-06",
      baseline_complete: 3.6,
      actual_complete: 4.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-05-13",
      baseline_complete: 3.8,
      actual_complete: 4.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-05-20",
      baseline_complete: 4.0,
      actual_complete: 4.5,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-05-27",
      baseline_complete: 4.2,
      actual_complete: 4.8,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-06-03",
      baseline_complete: 4.4,
      actual_complete: 5.6,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-06-10",
      baseline_complete: 4.6,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-06-17",
      baseline_complete: 4.8,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-06-24",
      baseline_complete: 5.0,
      actual_complete: 5.7,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-07-01",
      baseline_complete: 5.3,
      actual_complete: 5.7,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-07-08",
      baseline_complete: 5.5,
      actual_complete: 5.7,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-07-15",
      baseline_complete: 5.8,
      actual_complete: 6.1,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-07-22",
      baseline_complete: 6.1,
      actual_complete: 6.1,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-07-29",
      baseline_complete: 6.4,
      actual_complete: 6.1,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-08-05",
      baseline_complete: 6.7,
      actual_complete: 6.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-08-12",
      baseline_complete: 7.0,
      actual_complete: 6.9,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-08-19",
      baseline_complete: 7.3,
      actual_complete: 7.9,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-08-26",
      baseline_complete: 7.6,
      actual_complete: 8.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-09-02",
      baseline_complete: 8.0,
      actual_complete: 9.0,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-09-09",
      baseline_complete: 8.4,
      actual_complete: 9.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-09-16",
      baseline_complete: 8.8,
      actual_complete: 9.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-09-23",
      baseline_complete: 9.2,
      actual_complete: 9.8,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-09-30",
      baseline_complete: 9.6,
      actual_complete: 9.8,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-10-07",
      baseline_complete: 10.0,
      actual_complete: 11.5,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-10-14",
      baseline_complete: 10.5,
      actual_complete: 11.5,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-10-21",
      baseline_complete: 11.0,
      actual_complete: 11.5,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-10-28",
      baseline_complete: 11.4,
      actual_complete: 11.5,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-11-04",
      baseline_complete: 12.0,
      actual_complete: 12.1,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-11-11",
      baseline_complete: 12.5,
      actual_complete: 13.4,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-11-18",
      baseline_complete: 13.0,
      actual_complete: 13.9,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-11-25",
      baseline_complete: 13.6,
      actual_complete: 14.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-12-02",
      baseline_complete: 14.2,
      actual_complete: 14.4,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-12-09",
      baseline_complete: 14.8,
      actual_complete: 14.4,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-12-16",
      baseline_complete: 15.5,
      actual_complete: 15.4,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-12-23",
      baseline_complete: 16.1,
      actual_complete: 17.2,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2024-12-30",
      baseline_complete: 16.8,
      actual_complete: 17.2,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-01-06",
      baseline_complete: 17.5,
      actual_complete: 18.8,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-01-13",
      baseline_complete: 18.2,
      actual_complete: 19.0,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-01-20",
      baseline_complete: 19.0,
      actual_complete: 19.1,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-01-27",
      baseline_complete: 19.8,
      actual_complete: 20.9,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-02-03",
      baseline_complete: 20.6,
      actual_complete: 22.0,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-02-10",
      baseline_complete: 21.4,
      actual_complete: 22.1,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-02-17",
      baseline_complete: 22.2,
      actual_complete: 22.1,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-02-24",
      baseline_complete: 23.1,
      actual_complete: 23.3,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-03-03",
      baseline_complete: 24.0,
      actual_complete: 24.7,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-03-10",
      baseline_complete: 24.9,
      actual_complete: 24.7,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-03-17",
      baseline_complete: 25.9,
      actual_complete: 26.0,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-03-24",
      baseline_complete: 26.8,
      actual_complete: 27.7,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-03-31",
      baseline_complete: 27.8,
      actual_complete: 28.2,
      forecast_complete: 12.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-04-07",
      baseline_complete: 28.8,
      actual_complete: 28.7,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-04-14",
      baseline_complete: 29.8,
      actual_complete: 30.3,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-04-21",
      baseline_complete: 30.9,
      actual_complete: 31.5,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-04-28",
      baseline_complete: 31.9,
      actual_complete: 33.6,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-05-05",
      baseline_complete: 33.0,
      actual_complete: 34.3,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-05-12",
      baseline_complete: 34.1,
      actual_complete: 34.8,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-05-19",
      baseline_complete: 35.3,
      actual_complete: 35.3,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-05-26",
      baseline_complete: 36.4,
      actual_complete: 35.6,
      forecast_complete: 17.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-06-02",
      baseline_complete: 37.6,
      actual_complete: 38.5,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-06-09",
      baseline_complete: 38.7,
      actual_complete: 40.4,
      forecast_complete: 18.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-06-16",
      baseline_complete: 39.9,
      actual_complete: 41.4,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-06-23",
      baseline_complete: 41.1,
      actual_complete: 41.4,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-06-30",
      baseline_complete: 42.3,
      actual_complete: 43.5,
      forecast_complete: 20.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-07-07",
      baseline_complete: 43.5,
      actual_complete: 43.5,
      forecast_complete: 21.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-07-14",
      baseline_complete: 44.8,
      actual_complete: 44.9,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-07-21",
      baseline_complete: 46.0,
      actual_complete: 46.5,
      forecast_complete: 22.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-07-28",
      baseline_complete: 47.2,
      actual_complete: 47.5,
      forecast_complete: 23.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-08-04",
      baseline_complete: 48.5,
      actual_complete: 48.0,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-08-11",
      baseline_complete: 49.7,
      actual_complete: 49.3,
      forecast_complete: 25.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-08-18",
      baseline_complete: 50.9,
      actual_complete: 51.0,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-08-25",
      baseline_complete: 52.2,
      actual_complete: 53.0,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-09-01",
      baseline_complete: 53.4,
      actual_complete: 54.6,
      forecast_complete: 27.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-09-08",
      baseline_complete: 54.6,
      actual_complete: 55.4,
      forecast_complete: 28.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-09-15",
      baseline_complete: 55.9,
      actual_complete: 56.2,
      forecast_complete: 29.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-09-22",
      baseline_complete: 57.1,
      actual_complete: 58.1,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-09-29",
      baseline_complete: 58.3,
      actual_complete: 58.1,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-10-06",
      baseline_complete: 59.5,
      actual_complete: 59.6,
      forecast_complete: 31.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-10-13",
      baseline_complete: 60.7,
      actual_complete: 60.4,
      forecast_complete: 32.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-10-20",
      baseline_complete: 61.9,
      actual_complete: 62.5,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-10-27",
      baseline_complete: 63.0,
      actual_complete: 63.5,
      forecast_complete: 34.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-11-03",
      baseline_complete: 64.2,
      actual_complete: 64.1,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-11-10",
      baseline_complete: 65.3,
      actual_complete: 66.0,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-11-17",
      baseline_complete: 66.4,
      actual_complete: 66.5,
      forecast_complete: 36.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-11-24",
      baseline_complete: 67.5,
      actual_complete: 67.1,
      forecast_complete: 37.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-12-01",
      baseline_complete: 68.6,
      actual_complete: 67.9,
      forecast_complete: 38.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-12-08",
      baseline_complete: 69.7,
      actual_complete: 70.7,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-12-15",
      baseline_complete: 70.7,
      actual_complete: 71.6,
      forecast_complete: 40.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-12-22",
      baseline_complete: 71.7,
      actual_complete: 71.7,
      forecast_complete: 41.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2025-12-29",
      baseline_complete: 72.7,
      actual_complete: 72.7,
      forecast_complete: 42.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-01-05",
      baseline_complete: 73.7,
      actual_complete: 75.2,
      forecast_complete: 42.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-01-12",
      baseline_complete: 74.6,
      actual_complete: 75.2,
      forecast_complete: 43.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-01-19",
      baseline_complete: 75.6,
      actual_complete: 75.9,
      forecast_complete: 44.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-01-26",
      baseline_complete: 76.5,
      actual_complete: 77.2,
      forecast_complete: 45.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-02-02",
      baseline_complete: 77.3,
      actual_complete: 78.9,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-02-09",
      baseline_complete: 78.2,
      actual_complete: 78.9,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-02-16",
      baseline_complete: 79.0,
      actual_complete: 79.8,
      forecast_complete: 47.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-02-23",
      baseline_complete: 79.8,
      actual_complete: 80.7,
      forecast_complete: 48.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-03-02",
      baseline_complete: 80.6,
      actual_complete: 80.7,
      forecast_complete: 49.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-03-09",
      baseline_complete: 81.4,
      actual_complete: 83.3,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-03-16",
      baseline_complete: 82.1,
      actual_complete: 83.8,
      forecast_complete: 50.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-03-23",
      baseline_complete: 82.8,
      actual_complete: 84.9,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-03-30",
      baseline_complete: 83.5,
      actual_complete: 85.4,
      forecast_complete: 52.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-04-06",
      baseline_complete: 84.2,
      actual_complete: 85.4,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-04-13",
      baseline_complete: 84.9,
      actual_complete: 86.3,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-04-20",
      baseline_complete: 85.5,
      actual_complete: 86.3,
      forecast_complete: 54.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-04-27",
      baseline_complete: 86.1,
      actual_complete: 86.4,
      forecast_complete: 55.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-05-04",
      baseline_complete: 86.7,
      actual_complete: 87.5,
      forecast_complete: 56.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-05-11",
      baseline_complete: 87.2,
      actual_complete: 89.4,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-05-18",
      baseline_complete: 87.8,
      actual_complete: 89.4,
      forecast_complete: 57.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-05-25",
      baseline_complete: 88.3,
      actual_complete: 89.4,
      forecast_complete: 58.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-06-01",
      baseline_complete: 88.8,
      actual_complete: 89.4,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-06-08",
      baseline_complete: 89.3,
      actual_complete: 90.7,
      forecast_complete: 59.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-06-15",
      baseline_complete: 89.8,
      actual_complete: 91.2,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-06-22",
      baseline_complete: 90.2,
      actual_complete: 91.2,
      forecast_complete: 60.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-06-29",
      baseline_complete: 90.6,
      actual_complete: 92.6,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-07-06",
      baseline_complete: 91.0,
      actual_complete: 92.6,
      forecast_complete: 62.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-07-13",
      baseline_complete: 91.4,
      actual_complete: 92.8,
      forecast_complete: 62.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-07-20",
      baseline_complete: 91.8,
      actual_complete: 92.8,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-07-27",
      baseline_complete: 92.2,
      actual_complete: 92.8,
      forecast_complete: 63.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-08-03",
      baseline_complete: 92.5,
      actual_complete: 93.1,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-08-10",
      baseline_complete: 92.9,
      actual_complete: 93.2,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-08-17",
      baseline_complete: 93.2,
      actual_complete: 95.1,
      forecast_complete: 65.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-08-24",
      baseline_complete: 93.5,
      actual_complete: 95.2,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-08-31",
      baseline_complete: 93.8,
      actual_complete: 95.6,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-09-07",
      baseline_complete: 94.1,
      actual_complete: 96.0,
      forecast_complete: 67.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-09-14",
      baseline_complete: 94.3,
      actual_complete: 96.0,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-09-21",
      baseline_complete: 94.6,
      actual_complete: 96.0,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-09-28",
      baseline_complete: 94.9,
      actual_complete: 96.0,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-10-05",
      baseline_complete: 95.1,
      actual_complete: 97.2,
      forecast_complete: 69.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-10-12",
      baseline_complete: 95.3,
      actual_complete: 97.2,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-10-19",
      baseline_complete: 95.5,
      actual_complete: 97.2,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-10-26",
      baseline_complete: 95.7,
      actual_complete: 97.2,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-11-02",
      baseline_complete: 95.9,
      actual_complete: 98.1,
      forecast_complete: 71.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-11-09",
      baseline_complete: 96.1,
      actual_complete: 98.1,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-11-16",
      baseline_complete: 96.3,
      actual_complete: 98.1,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-11-23",
      baseline_complete: 96.5,
      actual_complete: 98.1,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-11-30",
      baseline_complete: 96.6,
      actual_complete: 98.7,
      forecast_complete: 74.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-12-07",
      baseline_complete: 96.8,
      actual_complete: 98.7,
      forecast_complete: 75.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-12-14",
      baseline_complete: 97.0,
      actual_complete: 99.5,
      forecast_complete: 76.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-12-21",
      baseline_complete: 97.1,
      actual_complete: 99.8,
      forecast_complete: 77.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2026-12-28",
      baseline_complete: 97.2,
      actual_complete: 99.8,
      forecast_complete: 77.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-01-04",
      baseline_complete: 97.4,
      actual_complete: 99.8,
      forecast_complete: 78.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-01-11",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 79.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-01-18",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-01-25",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 81.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-02-01",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 81.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-02-08",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 82.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-02-15",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 83.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-02-22",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 84.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-03-01",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-03-08",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 85.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-03-15",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 86.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-03-22",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 86.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-03-29",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 87.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-04-05",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 87.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-04-12",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 88.5,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-04-19",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 89.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-04-26",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-05-03",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-05-10",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 90.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-05-17",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-05-24",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-05-31",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-06-07",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-06-14",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-06-21",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-06-28",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-07-05",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-07-12",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-07-19",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-07-26",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-08-02",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-08-09",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-08-16",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-08-23",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-08-30",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-09-06",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-09-13",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-09-20",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-09-27",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-10-04",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-10-11",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-10-18",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-10-25",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-11-01",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-11-08",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-11-15",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-11-22",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-11-29",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-12-06",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-12-13",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-12-20",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2027-12-27",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2028-01-03",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2028-01-10",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2028-01-17",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2028-01-24",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2028-01-31",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d98a0c4b-9b50-7018-8a94-1a09f057806b",
      reporting_date: "2028-02-03",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "0f995026-ec95-2d71-5c89-868b1e1547ff": [
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-06-24",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-07-01",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-07-08",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-07-15",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-07-22",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-07-29",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-08-05",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-08-12",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-08-19",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-08-26",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-09-02",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-09-09",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-09-16",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-09-23",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-09-30",
      baseline_complete: 4.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-10-07",
      baseline_complete: 4.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-10-14",
      baseline_complete: 4.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-10-21",
      baseline_complete: 5.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-10-28",
      baseline_complete: 5.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-11-04",
      baseline_complete: 6.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-11-11",
      baseline_complete: 6.6,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-11-18",
      baseline_complete: 7.0,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-11-25",
      baseline_complete: 7.6,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-12-02",
      baseline_complete: 8.1,
      actual_complete: 3.7,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-12-09",
      baseline_complete: 8.7,
      actual_complete: 3.7,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-12-16",
      baseline_complete: 9.4,
      actual_complete: 3.7,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-12-23",
      baseline_complete: 10.1,
      actual_complete: 3.7,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2025-12-30",
      baseline_complete: 10.8,
      actual_complete: 3.7,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-01-06",
      baseline_complete: 11.6,
      actual_complete: 6.2,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-01-13",
      baseline_complete: 12.4,
      actual_complete: 6.2,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-01-20",
      baseline_complete: 13.3,
      actual_complete: 7.5,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-01-27",
      baseline_complete: 14.2,
      actual_complete: 7.5,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-02-03",
      baseline_complete: 15.2,
      actual_complete: 7.5,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-02-10",
      baseline_complete: 16.2,
      actual_complete: 10.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-02-17",
      baseline_complete: 17.3,
      actual_complete: 10.1,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-02-24",
      baseline_complete: 18.5,
      actual_complete: 15.1,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-03-03",
      baseline_complete: 19.7,
      actual_complete: 15.1,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-03-10",
      baseline_complete: 21.0,
      actual_complete: 15.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-03-17",
      baseline_complete: 22.3,
      actual_complete: 15.3,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-03-24",
      baseline_complete: 23.7,
      actual_complete: 18.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-03-31",
      baseline_complete: 25.1,
      actual_complete: 18.5,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-04-07",
      baseline_complete: 26.6,
      actual_complete: 21.6,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-04-14",
      baseline_complete: 28.2,
      actual_complete: 24.8,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-04-21",
      baseline_complete: 29.8,
      actual_complete: 26.8,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-04-28",
      baseline_complete: 31.4,
      actual_complete: 26.8,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-05-05",
      baseline_complete: 33.1,
      actual_complete: 28.3,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-05-12",
      baseline_complete: 34.9,
      actual_complete: 29.7,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-05-19",
      baseline_complete: 36.7,
      actual_complete: 32.8,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-05-26",
      baseline_complete: 38.5,
      actual_complete: 32.8,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-06-02",
      baseline_complete: 40.4,
      actual_complete: 33.7,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-06-09",
      baseline_complete: 42.3,
      actual_complete: 38.1,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-06-16",
      baseline_complete: 44.2,
      actual_complete: 39.8,
      forecast_complete: 16.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-06-23",
      baseline_complete: 46.1,
      actual_complete: 40.5,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-06-30",
      baseline_complete: 48.1,
      actual_complete: 45.1,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-07-07",
      baseline_complete: 50.0,
      actual_complete: 45.1,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-07-14",
      baseline_complete: 52.0,
      actual_complete: 46.5,
      forecast_complete: 21.5,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-07-21",
      baseline_complete: 53.9,
      actual_complete: 47.3,
      forecast_complete: 22.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-07-28",
      baseline_complete: 55.9,
      actual_complete: 54.1,
      forecast_complete: 24.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-08-04",
      baseline_complete: 57.8,
      actual_complete: 55.2,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-08-11",
      baseline_complete: 59.7,
      actual_complete: 55.2,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-08-18",
      baseline_complete: 61.6,
      actual_complete: 55.2,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-08-25",
      baseline_complete: 63.4,
      actual_complete: 62.8,
      forecast_complete: 29.5,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-09-01",
      baseline_complete: 65.2,
      actual_complete: 62.8,
      forecast_complete: 30.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-09-08",
      baseline_complete: 66.9,
      actual_complete: 64.7,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-09-15",
      baseline_complete: 68.7,
      actual_complete: 64.7,
      forecast_complete: 33.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-09-22",
      baseline_complete: 70.3,
      actual_complete: 68.9,
      forecast_complete: 35.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-09-29",
      baseline_complete: 71.9,
      actual_complete: 68.9,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-10-06",
      baseline_complete: 73.5,
      actual_complete: 69.1,
      forecast_complete: 37.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-10-13",
      baseline_complete: 75.0,
      actual_complete: 72.1,
      forecast_complete: 39.2,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-10-20",
      baseline_complete: 76.4,
      actual_complete: 72.1,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-10-27",
      baseline_complete: 77.8,
      actual_complete: 73.5,
      forecast_complete: 41.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-11-03",
      baseline_complete: 79.1,
      actual_complete: 74.6,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-11-10",
      baseline_complete: 80.4,
      actual_complete: 75.4,
      forecast_complete: 44.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-11-17",
      baseline_complete: 81.6,
      actual_complete: 75.6,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-11-24",
      baseline_complete: 82.7,
      actual_complete: 80.2,
      forecast_complete: 47.2,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-12-01",
      baseline_complete: 83.8,
      actual_complete: 80.2,
      forecast_complete: 48.5,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-12-08",
      baseline_complete: 84.8,
      actual_complete: 84.0,
      forecast_complete: 49.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-12-15",
      baseline_complete: 85.8,
      actual_complete: 85.4,
      forecast_complete: 51.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-12-22",
      baseline_complete: 86.7,
      actual_complete: 85.4,
      forecast_complete: 52.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2026-12-29",
      baseline_complete: 87.6,
      actual_complete: 86.7,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-01-05",
      baseline_complete: 88.4,
      actual_complete: 86.7,
      forecast_complete: 54.7,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-01-12",
      baseline_complete: 89.2,
      actual_complete: 88.2,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-01-19",
      baseline_complete: 90.0,
      actual_complete: 88.2,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-01-26",
      baseline_complete: 90.6,
      actual_complete: 88.2,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-02-02",
      baseline_complete: 91.3,
      actual_complete: 90.1,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-02-09",
      baseline_complete: 91.9,
      actual_complete: 90.5,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-02-16",
      baseline_complete: 92.4,
      actual_complete: 90.5,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-02-23",
      baseline_complete: 93.0,
      actual_complete: 94.0,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-03-02",
      baseline_complete: 93.5,
      actual_complete: 95.2,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-03-09",
      baseline_complete: 93.9,
      actual_complete: 95.2,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-03-16",
      baseline_complete: 94.4,
      actual_complete: 95.2,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-03-23",
      baseline_complete: 94.8,
      actual_complete: 95.2,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-03-30",
      baseline_complete: 95.1,
      actual_complete: 95.2,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-04-06",
      baseline_complete: 95.5,
      actual_complete: 97.1,
      forecast_complete: 68.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-04-13",
      baseline_complete: 95.8,
      actual_complete: 97.1,
      forecast_complete: 69.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-04-20",
      baseline_complete: 96.1,
      actual_complete: 97.1,
      forecast_complete: 70.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-04-27",
      baseline_complete: 96.4,
      actual_complete: 97.1,
      forecast_complete: 72.5,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-05-04",
      baseline_complete: 96.7,
      actual_complete: 97.1,
      forecast_complete: 74.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-05-11",
      baseline_complete: 96.9,
      actual_complete: 97.6,
      forecast_complete: 76.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-05-18",
      baseline_complete: 97.1,
      actual_complete: 97.6,
      forecast_complete: 77.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-05-25",
      baseline_complete: 97.3,
      actual_complete: 97.6,
      forecast_complete: 79.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-06-01",
      baseline_complete: 97.5,
      actual_complete: 97.6,
      forecast_complete: 80.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-06-08",
      baseline_complete: 97.7,
      actual_complete: 98.1,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-06-15",
      baseline_complete: 97.9,
      actual_complete: 98.1,
      forecast_complete: 83.4,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-06-22",
      baseline_complete: 98.0,
      actual_complete: 98.1,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-06-29",
      baseline_complete: 98.2,
      actual_complete: 98.1,
      forecast_complete: 86.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-07-06",
      baseline_complete: 98.3,
      actual_complete: 98.9,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-07-13",
      baseline_complete: 98.4,
      actual_complete: 99.6,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-07-20",
      baseline_complete: 98.6,
      actual_complete: 99.6,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-07-27",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-08-03",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 91.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-08-10",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-08-17",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-08-24",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-08-31",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-09-07",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-09-14",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-09-21",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-09-28",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-10-05",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-10-12",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-10-19",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-10-26",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-11-02",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-11-09",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-11-16",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-11-23",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "0f995026-ec95-2d71-5c89-868b1e1547ff",
      reporting_date: "2027-11-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
  ],
  "5968cf91-6ab5-388f-5bd9-c1d58f31b615": [
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-01-25",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-02-01",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-02-08",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-02-15",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-02-22",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-02-29",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-03-07",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-03-14",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-03-21",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-03-28",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-04-04",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-04-11",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-04-18",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-04-25",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-05-02",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-05-09",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-05-16",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-05-23",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-05-30",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-06-06",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-06-13",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-06-20",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-06-27",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-07-04",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-07-11",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-07-18",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-07-25",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-08-01",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-08-08",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-08-15",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-08-22",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-08-29",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-09-05",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-09-12",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-09-19",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-09-26",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-10-03",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-10-10",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-10-17",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-10-24",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-10-31",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-11-07",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-11-14",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-11-21",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-11-28",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-12-05",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-12-12",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-12-19",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2024-12-26",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-01-02",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-01-09",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-01-16",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-01-23",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-01-30",
      baseline_complete: 3.8,
      actual_complete: 0.0,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-02-06",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-02-13",
      baseline_complete: 4.1,
      actual_complete: 0.0,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-02-20",
      baseline_complete: 4.3,
      actual_complete: 0.0,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-02-27",
      baseline_complete: 4.5,
      actual_complete: 0.0,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-03-06",
      baseline_complete: 4.7,
      actual_complete: 0.8,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-03-13",
      baseline_complete: 4.8,
      actual_complete: 0.8,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-03-20",
      baseline_complete: 5.1,
      actual_complete: 1.4,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-03-27",
      baseline_complete: 5.3,
      actual_complete: 1.4,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-04-03",
      baseline_complete: 5.5,
      actual_complete: 2.2,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-04-10",
      baseline_complete: 5.7,
      actual_complete: 2.2,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-04-17",
      baseline_complete: 5.9,
      actual_complete: 2.2,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-04-24",
      baseline_complete: 6.2,
      actual_complete: 2.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-05-01",
      baseline_complete: 6.5,
      actual_complete: 3.1,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-05-08",
      baseline_complete: 6.7,
      actual_complete: 3.1,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-05-15",
      baseline_complete: 7.0,
      actual_complete: 3.1,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-05-22",
      baseline_complete: 7.3,
      actual_complete: 3.1,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-05-29",
      baseline_complete: 7.6,
      actual_complete: 4.7,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-06-05",
      baseline_complete: 7.9,
      actual_complete: 4.7,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-06-12",
      baseline_complete: 8.2,
      actual_complete: 4.7,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-06-19",
      baseline_complete: 8.5,
      actual_complete: 4.7,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-06-26",
      baseline_complete: 8.9,
      actual_complete: 6.8,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-07-03",
      baseline_complete: 9.2,
      actual_complete: 6.8,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-07-10",
      baseline_complete: 9.6,
      actual_complete: 7.0,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-07-17",
      baseline_complete: 10.0,
      actual_complete: 7.0,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-07-24",
      baseline_complete: 10.4,
      actual_complete: 7.0,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-07-31",
      baseline_complete: 10.8,
      actual_complete: 7.8,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-08-07",
      baseline_complete: 11.2,
      actual_complete: 7.8,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-08-14",
      baseline_complete: 11.7,
      actual_complete: 8.8,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-08-21",
      baseline_complete: 12.1,
      actual_complete: 10.0,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-08-28",
      baseline_complete: 12.6,
      actual_complete: 10.4,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-09-04",
      baseline_complete: 13.1,
      actual_complete: 10.4,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-09-11",
      baseline_complete: 13.6,
      actual_complete: 10.4,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-09-18",
      baseline_complete: 14.1,
      actual_complete: 10.4,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-09-25",
      baseline_complete: 14.6,
      actual_complete: 11.6,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-10-02",
      baseline_complete: 15.2,
      actual_complete: 11.6,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-10-09",
      baseline_complete: 15.7,
      actual_complete: 11.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-10-16",
      baseline_complete: 16.3,
      actual_complete: 11.6,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-10-23",
      baseline_complete: 16.9,
      actual_complete: 14.6,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-10-30",
      baseline_complete: 17.5,
      actual_complete: 14.6,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-11-06",
      baseline_complete: 18.2,
      actual_complete: 14.6,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-11-13",
      baseline_complete: 18.8,
      actual_complete: 14.6,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-11-20",
      baseline_complete: 19.5,
      actual_complete: 16.3,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-11-27",
      baseline_complete: 20.2,
      actual_complete: 16.6,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-12-04",
      baseline_complete: 20.9,
      actual_complete: 16.6,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-12-11",
      baseline_complete: 21.6,
      actual_complete: 18.8,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-12-18",
      baseline_complete: 22.4,
      actual_complete: 18.8,
      forecast_complete: 12.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2025-12-25",
      baseline_complete: 23.1,
      actual_complete: 19.4,
      forecast_complete: 12.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-01-01",
      baseline_complete: 23.9,
      actual_complete: 19.9,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-01-08",
      baseline_complete: 24.7,
      actual_complete: 22.7,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-01-15",
      baseline_complete: 25.5,
      actual_complete: 22.8,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-01-22",
      baseline_complete: 26.3,
      actual_complete: 22.8,
      forecast_complete: 14.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-01-29",
      baseline_complete: 27.2,
      actual_complete: 25.0,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-02-05",
      baseline_complete: 28.1,
      actual_complete: 25.0,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-02-12",
      baseline_complete: 28.9,
      actual_complete: 28.1,
      forecast_complete: 15.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-02-19",
      baseline_complete: 29.8,
      actual_complete: 28.1,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-02-26",
      baseline_complete: 30.7,
      actual_complete: 28.1,
      forecast_complete: 16.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-03-05",
      baseline_complete: 31.7,
      actual_complete: 28.1,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-03-12",
      baseline_complete: 32.6,
      actual_complete: 29.3,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-03-19",
      baseline_complete: 33.6,
      actual_complete: 29.3,
      forecast_complete: 18.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-03-26",
      baseline_complete: 34.6,
      actual_complete: 33.0,
      forecast_complete: 19.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-04-02",
      baseline_complete: 35.5,
      actual_complete: 33.4,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-04-09",
      baseline_complete: 36.5,
      actual_complete: 34.4,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-04-16",
      baseline_complete: 37.5,
      actual_complete: 34.4,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-04-23",
      baseline_complete: 38.6,
      actual_complete: 36.1,
      forecast_complete: 21.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-04-30",
      baseline_complete: 39.6,
      actual_complete: 38.8,
      forecast_complete: 22.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-05-07",
      baseline_complete: 40.6,
      actual_complete: 39.6,
      forecast_complete: 22.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-05-14",
      baseline_complete: 41.7,
      actual_complete: 39.6,
      forecast_complete: 23.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-05-21",
      baseline_complete: 42.7,
      actual_complete: 39.6,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-05-28",
      baseline_complete: 43.8,
      actual_complete: 39.6,
      forecast_complete: 25.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-06-04",
      baseline_complete: 44.9,
      actual_complete: 42.0,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-06-11",
      baseline_complete: 45.9,
      actual_complete: 42.0,
      forecast_complete: 26.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-06-18",
      baseline_complete: 47.0,
      actual_complete: 44.3,
      forecast_complete: 27.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-06-25",
      baseline_complete: 48.1,
      actual_complete: 45.0,
      forecast_complete: 27.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-07-02",
      baseline_complete: 49.2,
      actual_complete: 46.2,
      forecast_complete: 28.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-07-09",
      baseline_complete: 50.3,
      actual_complete: 46.2,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-07-16",
      baseline_complete: 51.4,
      actual_complete: 46.4,
      forecast_complete: 30.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-07-23",
      baseline_complete: 52.4,
      actual_complete: 51.0,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-07-30",
      baseline_complete: 53.5,
      actual_complete: 51.0,
      forecast_complete: 31.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-08-06",
      baseline_complete: 54.6,
      actual_complete: 53.1,
      forecast_complete: 32.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-08-13",
      baseline_complete: 55.7,
      actual_complete: 54.9,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-08-20",
      baseline_complete: 56.7,
      actual_complete: 56.2,
      forecast_complete: 34.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-08-27",
      baseline_complete: 57.8,
      actual_complete: 56.2,
      forecast_complete: 34.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-09-03",
      baseline_complete: 58.8,
      actual_complete: 56.2,
      forecast_complete: 35.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-09-10",
      baseline_complete: 59.9,
      actual_complete: 57.4,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-09-17",
      baseline_complete: 60.9,
      actual_complete: 58.0,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-09-24",
      baseline_complete: 61.9,
      actual_complete: 59.1,
      forecast_complete: 38.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-10-01",
      baseline_complete: 63.0,
      actual_complete: 61.7,
      forecast_complete: 39.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-10-08",
      baseline_complete: 64.0,
      actual_complete: 63.2,
      forecast_complete: 39.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-10-15",
      baseline_complete: 65.0,
      actual_complete: 64.8,
      forecast_complete: 40.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-10-22",
      baseline_complete: 65.9,
      actual_complete: 64.8,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-10-29",
      baseline_complete: 66.9,
      actual_complete: 64.8,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-11-05",
      baseline_complete: 67.8,
      actual_complete: 67.6,
      forecast_complete: 43.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-11-12",
      baseline_complete: 68.8,
      actual_complete: 67.6,
      forecast_complete: 43.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-11-19",
      baseline_complete: 69.7,
      actual_complete: 67.6,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-11-26",
      baseline_complete: 70.6,
      actual_complete: 69.0,
      forecast_complete: 45.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-12-03",
      baseline_complete: 71.5,
      actual_complete: 69.1,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-12-10",
      baseline_complete: 72.4,
      actual_complete: 71.5,
      forecast_complete: 47.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-12-17",
      baseline_complete: 73.2,
      actual_complete: 73.5,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-12-24",
      baseline_complete: 74.1,
      actual_complete: 73.5,
      forecast_complete: 48.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2026-12-31",
      baseline_complete: 74.9,
      actual_complete: 73.5,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-01-07",
      baseline_complete: 75.7,
      actual_complete: 76.1,
      forecast_complete: 50.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-01-14",
      baseline_complete: 76.5,
      actual_complete: 76.1,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-01-21",
      baseline_complete: 77.3,
      actual_complete: 76.1,
      forecast_complete: 52.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-01-28",
      baseline_complete: 78.0,
      actual_complete: 76.1,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-02-04",
      baseline_complete: 78.7,
      actual_complete: 76.1,
      forecast_complete: 53.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-02-11",
      baseline_complete: 79.5,
      actual_complete: 80.6,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-02-18",
      baseline_complete: 80.2,
      actual_complete: 80.6,
      forecast_complete: 55.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-02-25",
      baseline_complete: 80.8,
      actual_complete: 81.4,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-03-04",
      baseline_complete: 81.5,
      actual_complete: 81.4,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-03-11",
      baseline_complete: 82.1,
      actual_complete: 81.4,
      forecast_complete: 57.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-03-18",
      baseline_complete: 82.8,
      actual_complete: 81.4,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-03-25",
      baseline_complete: 83.4,
      actual_complete: 83.1,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-04-01",
      baseline_complete: 84.0,
      actual_complete: 83.1,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-04-08",
      baseline_complete: 84.5,
      actual_complete: 85.0,
      forecast_complete: 60.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-04-15",
      baseline_complete: 85.1,
      actual_complete: 85.0,
      forecast_complete: 61.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-04-22",
      baseline_complete: 85.6,
      actual_complete: 85.0,
      forecast_complete: 61.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-04-29",
      baseline_complete: 86.2,
      actual_complete: 85.0,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-05-06",
      baseline_complete: 86.7,
      actual_complete: 86.5,
      forecast_complete: 63.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-05-13",
      baseline_complete: 87.2,
      actual_complete: 86.5,
      forecast_complete: 63.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-05-20",
      baseline_complete: 87.6,
      actual_complete: 86.5,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-05-27",
      baseline_complete: 88.1,
      actual_complete: 89.4,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-06-03",
      baseline_complete: 88.6,
      actual_complete: 89.4,
      forecast_complete: 66.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-06-10",
      baseline_complete: 89.0,
      actual_complete: 89.4,
      forecast_complete: 66.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-06-17",
      baseline_complete: 89.4,
      actual_complete: 90.0,
      forecast_complete: 67.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-06-24",
      baseline_complete: 89.8,
      actual_complete: 90.0,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-07-01",
      baseline_complete: 90.2,
      actual_complete: 90.0,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-07-08",
      baseline_complete: 90.6,
      actual_complete: 90.0,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-07-15",
      baseline_complete: 90.9,
      actual_complete: 90.7,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-07-22",
      baseline_complete: 91.3,
      actual_complete: 90.7,
      forecast_complete: 70.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-07-29",
      baseline_complete: 91.6,
      actual_complete: 91.4,
      forecast_complete: 71.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-08-05",
      baseline_complete: 92.0,
      actual_complete: 91.4,
      forecast_complete: 71.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-08-12",
      baseline_complete: 92.3,
      actual_complete: 93.1,
      forecast_complete: 72.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-08-19",
      baseline_complete: 92.6,
      actual_complete: 93.1,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-08-26",
      baseline_complete: 92.9,
      actual_complete: 93.1,
      forecast_complete: 74.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-09-02",
      baseline_complete: 93.1,
      actual_complete: 93.6,
      forecast_complete: 75.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-09-09",
      baseline_complete: 93.4,
      actual_complete: 94.2,
      forecast_complete: 76.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-09-16",
      baseline_complete: 93.7,
      actual_complete: 94.2,
      forecast_complete: 77.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-09-23",
      baseline_complete: 93.9,
      actual_complete: 94.2,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-09-30",
      baseline_complete: 94.2,
      actual_complete: 94.4,
      forecast_complete: 79.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-10-07",
      baseline_complete: 94.4,
      actual_complete: 94.4,
      forecast_complete: 79.9,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-10-14",
      baseline_complete: 94.6,
      actual_complete: 94.4,
      forecast_complete: 80.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-10-21",
      baseline_complete: 94.8,
      actual_complete: 94.4,
      forecast_complete: 81.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-10-28",
      baseline_complete: 95.1,
      actual_complete: 94.4,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-11-04",
      baseline_complete: 95.3,
      actual_complete: 96.6,
      forecast_complete: 83.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-11-11",
      baseline_complete: 95.4,
      actual_complete: 96.6,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-11-18",
      baseline_complete: 95.6,
      actual_complete: 96.6,
      forecast_complete: 85.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-11-25",
      baseline_complete: 95.8,
      actual_complete: 96.6,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-12-02",
      baseline_complete: 96.0,
      actual_complete: 96.6,
      forecast_complete: 86.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-12-09",
      baseline_complete: 96.1,
      actual_complete: 96.8,
      forecast_complete: 87.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-12-16",
      baseline_complete: 96.3,
      actual_complete: 96.8,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-12-23",
      baseline_complete: 96.4,
      actual_complete: 97.0,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2027-12-30",
      baseline_complete: 96.6,
      actual_complete: 97.0,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-01-06",
      baseline_complete: 96.7,
      actual_complete: 97.0,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-01-13",
      baseline_complete: 96.9,
      actual_complete: 97.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-01-20",
      baseline_complete: 97.0,
      actual_complete: 99.8,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-01-27",
      baseline_complete: 97.1,
      actual_complete: 99.8,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-02-03",
      baseline_complete: 97.2,
      actual_complete: 99.8,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-02-10",
      baseline_complete: 97.4,
      actual_complete: 99.8,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-02-17",
      baseline_complete: 97.5,
      actual_complete: 99.8,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-02-24",
      baseline_complete: 97.6,
      actual_complete: 99.8,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-03-02",
      baseline_complete: 97.7,
      actual_complete: 99.8,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-03-09",
      baseline_complete: 97.8,
      actual_complete: 99.8,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-03-16",
      baseline_complete: 97.9,
      actual_complete: 99.8,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-03-23",
      baseline_complete: 97.9,
      actual_complete: 99.8,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-03-30",
      baseline_complete: 98.0,
      actual_complete: 99.8,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-04-06",
      baseline_complete: 98.1,
      actual_complete: 99.8,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-04-13",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-04-20",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-04-27",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-05-04",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-05-11",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-05-18",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-05-25",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-06-01",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-06-08",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-06-15",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-06-22",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-06-29",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-07-06",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-07-13",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-07-20",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-07-27",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-08-03",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-08-10",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-08-17",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-08-24",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-08-31",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-09-07",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-09-14",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-09-21",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-09-28",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-10-05",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-10-12",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-10-19",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5968cf91-6ab5-388f-5bd9-c1d58f31b615",
      reporting_date: "2028-10-25",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "6f194d80-0d28-92ac-e9a5-9d35edd17239": [
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-04-03",
      baseline_complete: 0.3,
      actual_complete: 3.4,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-04-10",
      baseline_complete: 0.4,
      actual_complete: 3.9,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-04-17",
      baseline_complete: 0.4,
      actual_complete: 6.7,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-04-24",
      baseline_complete: 0.4,
      actual_complete: 6.7,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-05-01",
      baseline_complete: 0.5,
      actual_complete: 7.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-05-08",
      baseline_complete: 0.5,
      actual_complete: 7.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-05-15",
      baseline_complete: 0.6,
      actual_complete: 7.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-05-22",
      baseline_complete: 0.6,
      actual_complete: 7.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-05-29",
      baseline_complete: 0.7,
      actual_complete: 7.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-06-05",
      baseline_complete: 0.8,
      actual_complete: 7.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-06-12",
      baseline_complete: 0.8,
      actual_complete: 7.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-06-19",
      baseline_complete: 0.9,
      actual_complete: 7.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-06-26",
      baseline_complete: 1.0,
      actual_complete: 7.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-07-03",
      baseline_complete: 1.1,
      actual_complete: 7.7,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-07-10",
      baseline_complete: 1.2,
      actual_complete: 7.7,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-07-17",
      baseline_complete: 1.3,
      actual_complete: 8.8,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-07-24",
      baseline_complete: 1.4,
      actual_complete: 8.8,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-07-31",
      baseline_complete: 1.6,
      actual_complete: 8.8,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-08-07",
      baseline_complete: 1.7,
      actual_complete: 8.8,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-08-14",
      baseline_complete: 1.9,
      actual_complete: 9.2,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-08-21",
      baseline_complete: 2.0,
      actual_complete: 9.2,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-08-28",
      baseline_complete: 2.2,
      actual_complete: 9.2,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-09-04",
      baseline_complete: 2.4,
      actual_complete: 9.4,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-09-11",
      baseline_complete: 2.7,
      actual_complete: 9.4,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-09-18",
      baseline_complete: 2.9,
      actual_complete: 9.4,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-09-25",
      baseline_complete: 3.2,
      actual_complete: 9.4,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-10-02",
      baseline_complete: 3.5,
      actual_complete: 9.4,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-10-09",
      baseline_complete: 3.8,
      actual_complete: 9.4,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-10-16",
      baseline_complete: 4.1,
      actual_complete: 9.4,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-10-23",
      baseline_complete: 4.5,
      actual_complete: 9.4,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-10-30",
      baseline_complete: 4.9,
      actual_complete: 11.2,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-11-06",
      baseline_complete: 5.4,
      actual_complete: 11.2,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-11-13",
      baseline_complete: 5.9,
      actual_complete: 11.6,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-11-20",
      baseline_complete: 6.4,
      actual_complete: 11.6,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-11-27",
      baseline_complete: 7.0,
      actual_complete: 12.6,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-12-04",
      baseline_complete: 7.6,
      actual_complete: 12.6,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-12-11",
      baseline_complete: 8.2,
      actual_complete: 12.6,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-12-18",
      baseline_complete: 8.9,
      actual_complete: 12.6,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2026-12-25",
      baseline_complete: 9.7,
      actual_complete: 12.6,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-01-01",
      baseline_complete: 10.6,
      actual_complete: 12.6,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-01-08",
      baseline_complete: 11.4,
      actual_complete: 13.7,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-01-15",
      baseline_complete: 12.4,
      actual_complete: 16.2,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-01-22",
      baseline_complete: 13.4,
      actual_complete: 17.5,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-01-29",
      baseline_complete: 14.5,
      actual_complete: 17.7,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-02-05",
      baseline_complete: 15.7,
      actual_complete: 21.5,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-02-12",
      baseline_complete: 17.0,
      actual_complete: 21.5,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-02-19",
      baseline_complete: 18.3,
      actual_complete: 24.4,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-02-26",
      baseline_complete: 19.7,
      actual_complete: 24.4,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-03-05",
      baseline_complete: 21.2,
      actual_complete: 26.0,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-03-12",
      baseline_complete: 22.7,
      actual_complete: 28.0,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-03-19",
      baseline_complete: 24.4,
      actual_complete: 28.0,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-03-26",
      baseline_complete: 26.1,
      actual_complete: 28.0,
      forecast_complete: 14.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-04-02",
      baseline_complete: 27.9,
      actual_complete: 32.7,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-04-09",
      baseline_complete: 29.8,
      actual_complete: 32.7,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-04-16",
      baseline_complete: 31.7,
      actual_complete: 36.9,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-04-23",
      baseline_complete: 33.8,
      actual_complete: 36.9,
      forecast_complete: 18.4,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-04-30",
      baseline_complete: 35.8,
      actual_complete: 42.5,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-05-07",
      baseline_complete: 38.0,
      actual_complete: 42.5,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-05-14",
      baseline_complete: 40.1,
      actual_complete: 42.5,
      forecast_complete: 21.9,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-05-21",
      baseline_complete: 42.3,
      actual_complete: 48.3,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-05-28",
      baseline_complete: 44.6,
      actual_complete: 48.3,
      forecast_complete: 24.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-06-04",
      baseline_complete: 46.9,
      actual_complete: 48.3,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-06-11",
      baseline_complete: 49.1,
      actual_complete: 50.9,
      forecast_complete: 27.3,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-06-18",
      baseline_complete: 51.4,
      actual_complete: 54.6,
      forecast_complete: 28.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-06-25",
      baseline_complete: 53.7,
      actual_complete: 55.8,
      forecast_complete: 30.3,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-07-02",
      baseline_complete: 56.0,
      actual_complete: 58.8,
      forecast_complete: 31.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-07-09",
      baseline_complete: 58.2,
      actual_complete: 61.3,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-07-16",
      baseline_complete: 60.4,
      actual_complete: 62.1,
      forecast_complete: 34.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-07-23",
      baseline_complete: 62.6,
      actual_complete: 67.4,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-07-30",
      baseline_complete: 64.7,
      actual_complete: 68.7,
      forecast_complete: 38.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-08-06",
      baseline_complete: 66.7,
      actual_complete: 69.0,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-08-13",
      baseline_complete: 68.7,
      actual_complete: 69.0,
      forecast_complete: 41.1,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-08-20",
      baseline_complete: 70.7,
      actual_complete: 72.9,
      forecast_complete: 42.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-08-27",
      baseline_complete: 72.5,
      actual_complete: 74.3,
      forecast_complete: 44.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-09-03",
      baseline_complete: 74.3,
      actual_complete: 76.7,
      forecast_complete: 45.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-09-10",
      baseline_complete: 76.0,
      actual_complete: 80.2,
      forecast_complete: 47.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-09-17",
      baseline_complete: 77.6,
      actual_complete: 80.2,
      forecast_complete: 48.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-09-24",
      baseline_complete: 79.2,
      actual_complete: 80.2,
      forecast_complete: 50.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-10-01",
      baseline_complete: 80.7,
      actual_complete: 83.9,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-10-08",
      baseline_complete: 82.0,
      actual_complete: 83.9,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-10-15",
      baseline_complete: 83.4,
      actual_complete: 83.9,
      forecast_complete: 54.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-10-22",
      baseline_complete: 84.6,
      actual_complete: 91.3,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-10-29",
      baseline_complete: 85.7,
      actual_complete: 91.3,
      forecast_complete: 57.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-11-05",
      baseline_complete: 86.8,
      actual_complete: 93.3,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-11-12",
      baseline_complete: 87.8,
      actual_complete: 93.3,
      forecast_complete: 59.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-11-19",
      baseline_complete: 88.8,
      actual_complete: 93.6,
      forecast_complete: 61.1,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-11-26",
      baseline_complete: 89.7,
      actual_complete: 94.1,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-12-03",
      baseline_complete: 90.5,
      actual_complete: 94.1,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-12-10",
      baseline_complete: 91.2,
      actual_complete: 96.5,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-12-17",
      baseline_complete: 91.9,
      actual_complete: 96.5,
      forecast_complete: 65.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-12-24",
      baseline_complete: 92.6,
      actual_complete: 96.5,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2027-12-31",
      baseline_complete: 93.2,
      actual_complete: 96.5,
      forecast_complete: 68.1,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-01-07",
      baseline_complete: 93.7,
      actual_complete: 98.2,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-01-14",
      baseline_complete: 94.3,
      actual_complete: 98.2,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-01-21",
      baseline_complete: 94.7,
      actual_complete: 98.2,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-01-28",
      baseline_complete: 95.2,
      actual_complete: 98.2,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-02-04",
      baseline_complete: 95.6,
      actual_complete: 99.6,
      forecast_complete: 73.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-02-11",
      baseline_complete: 96.0,
      actual_complete: 99.6,
      forecast_complete: 74.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-02-18",
      baseline_complete: 96.3,
      actual_complete: 99.6,
      forecast_complete: 75.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-02-25",
      baseline_complete: 96.6,
      actual_complete: 99.6,
      forecast_complete: 76.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-03-03",
      baseline_complete: 96.9,
      actual_complete: 99.6,
      forecast_complete: 78.4,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-03-10",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 80.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-03-17",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 81.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-03-24",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-03-31",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-04-07",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-04-14",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-04-21",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-04-28",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-05-05",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-05-12",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-05-19",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-05-26",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-06-02",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-06-09",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-06-16",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-06-23",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-06-30",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-07-07",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-07-14",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-07-21",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-07-28",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-08-04",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-08-11",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-08-18",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-08-25",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-09-01",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-09-08",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-09-15",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-09-22",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-09-29",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6f194d80-0d28-92ac-e9a5-9d35edd17239",
      reporting_date: "2028-10-03",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "c15a7c83-9cab-4fba-129c-be649e9e74a4": [
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-01-09",
      baseline_complete: 0.7,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-01-16",
      baseline_complete: 0.7,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-01-23",
      baseline_complete: 0.8,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-01-30",
      baseline_complete: 0.8,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-02-06",
      baseline_complete: 0.9,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-02-13",
      baseline_complete: 0.9,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-02-20",
      baseline_complete: 0.9,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-02-27",
      baseline_complete: 1.0,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-03-06",
      baseline_complete: 1.0,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-03-13",
      baseline_complete: 1.1,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-03-20",
      baseline_complete: 1.1,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-03-27",
      baseline_complete: 1.2,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-04-03",
      baseline_complete: 1.2,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-04-10",
      baseline_complete: 1.3,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-04-17",
      baseline_complete: 1.4,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-04-24",
      baseline_complete: 1.4,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-05-01",
      baseline_complete: 1.5,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-05-08",
      baseline_complete: 1.6,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-05-15",
      baseline_complete: 1.6,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-05-22",
      baseline_complete: 1.7,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-05-29",
      baseline_complete: 1.8,
      actual_complete: 2.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-06-05",
      baseline_complete: 1.9,
      actual_complete: 2.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-06-12",
      baseline_complete: 2.0,
      actual_complete: 2.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-06-19",
      baseline_complete: 2.0,
      actual_complete: 2.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-06-26",
      baseline_complete: 2.1,
      actual_complete: 4.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-07-03",
      baseline_complete: 2.2,
      actual_complete: 4.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-07-10",
      baseline_complete: 2.3,
      actual_complete: 4.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-07-17",
      baseline_complete: 2.5,
      actual_complete: 4.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-07-24",
      baseline_complete: 2.6,
      actual_complete: 4.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-07-31",
      baseline_complete: 2.7,
      actual_complete: 4.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-08-07",
      baseline_complete: 2.8,
      actual_complete: 4.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-08-14",
      baseline_complete: 2.9,
      actual_complete: 4.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-08-21",
      baseline_complete: 3.1,
      actual_complete: 4.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-08-28",
      baseline_complete: 3.2,
      actual_complete: 4.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-09-04",
      baseline_complete: 3.4,
      actual_complete: 5.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-09-11",
      baseline_complete: 3.5,
      actual_complete: 5.7,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-09-18",
      baseline_complete: 3.7,
      actual_complete: 5.7,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-09-25",
      baseline_complete: 3.9,
      actual_complete: 6.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-10-02",
      baseline_complete: 4.0,
      actual_complete: 6.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-10-09",
      baseline_complete: 4.2,
      actual_complete: 6.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-10-16",
      baseline_complete: 4.4,
      actual_complete: 6.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-10-23",
      baseline_complete: 4.6,
      actual_complete: 6.9,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-10-30",
      baseline_complete: 4.8,
      actual_complete: 6.9,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-11-06",
      baseline_complete: 5.1,
      actual_complete: 6.9,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-11-13",
      baseline_complete: 5.3,
      actual_complete: 6.9,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-11-20",
      baseline_complete: 5.5,
      actual_complete: 6.9,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-11-27",
      baseline_complete: 5.8,
      actual_complete: 7.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-12-04",
      baseline_complete: 6.0,
      actual_complete: 7.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-12-11",
      baseline_complete: 6.3,
      actual_complete: 7.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-12-18",
      baseline_complete: 6.6,
      actual_complete: 9.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2023-12-25",
      baseline_complete: 6.9,
      actual_complete: 9.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-01-01",
      baseline_complete: 7.2,
      actual_complete: 9.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-01-08",
      baseline_complete: 7.5,
      actual_complete: 9.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-01-15",
      baseline_complete: 7.8,
      actual_complete: 9.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-01-22",
      baseline_complete: 8.2,
      actual_complete: 9.9,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-01-29",
      baseline_complete: 8.5,
      actual_complete: 9.9,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-02-05",
      baseline_complete: 8.9,
      actual_complete: 9.9,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-02-12",
      baseline_complete: 9.3,
      actual_complete: 9.9,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-02-19",
      baseline_complete: 9.7,
      actual_complete: 9.9,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-02-26",
      baseline_complete: 10.1,
      actual_complete: 12.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-03-04",
      baseline_complete: 10.6,
      actual_complete: 12.9,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-03-11",
      baseline_complete: 11.0,
      actual_complete: 13.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-03-18",
      baseline_complete: 11.5,
      actual_complete: 13.2,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-03-25",
      baseline_complete: 12.0,
      actual_complete: 13.2,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-04-01",
      baseline_complete: 12.5,
      actual_complete: 13.2,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-04-08",
      baseline_complete: 13.0,
      actual_complete: 13.2,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-04-15",
      baseline_complete: 13.5,
      actual_complete: 14.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-04-22",
      baseline_complete: 14.1,
      actual_complete: 14.6,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-04-29",
      baseline_complete: 14.6,
      actual_complete: 16.8,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-05-06",
      baseline_complete: 15.2,
      actual_complete: 16.8,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-05-13",
      baseline_complete: 15.8,
      actual_complete: 19.4,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-05-20",
      baseline_complete: 16.5,
      actual_complete: 19.4,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-05-27",
      baseline_complete: 17.1,
      actual_complete: 19.4,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-06-03",
      baseline_complete: 17.8,
      actual_complete: 20.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-06-10",
      baseline_complete: 18.5,
      actual_complete: 20.4,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-06-17",
      baseline_complete: 19.2,
      actual_complete: 20.4,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-06-24",
      baseline_complete: 20.0,
      actual_complete: 20.4,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-07-01",
      baseline_complete: 20.7,
      actual_complete: 20.4,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-07-08",
      baseline_complete: 21.5,
      actual_complete: 20.4,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-07-15",
      baseline_complete: 22.3,
      actual_complete: 20.6,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-07-22",
      baseline_complete: 23.1,
      actual_complete: 26.2,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-07-29",
      baseline_complete: 24.0,
      actual_complete: 26.2,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-08-05",
      baseline_complete: 24.8,
      actual_complete: 26.2,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-08-12",
      baseline_complete: 25.7,
      actual_complete: 26.2,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-08-19",
      baseline_complete: 26.6,
      actual_complete: 28.0,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-08-26",
      baseline_complete: 27.5,
      actual_complete: 30.9,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-09-02",
      baseline_complete: 28.5,
      actual_complete: 30.9,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-09-09",
      baseline_complete: 29.4,
      actual_complete: 30.9,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-09-16",
      baseline_complete: 30.4,
      actual_complete: 30.9,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-09-23",
      baseline_complete: 31.4,
      actual_complete: 32.2,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-09-30",
      baseline_complete: 32.4,
      actual_complete: 33.1,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-10-07",
      baseline_complete: 33.5,
      actual_complete: 36.2,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-10-14",
      baseline_complete: 34.5,
      actual_complete: 36.2,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-10-21",
      baseline_complete: 35.6,
      actual_complete: 39.3,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-10-28",
      baseline_complete: 36.7,
      actual_complete: 39.3,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-11-04",
      baseline_complete: 37.8,
      actual_complete: 39.9,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-11-11",
      baseline_complete: 38.9,
      actual_complete: 39.9,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-11-18",
      baseline_complete: 40.0,
      actual_complete: 39.9,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-11-25",
      baseline_complete: 41.1,
      actual_complete: 39.9,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-12-02",
      baseline_complete: 42.2,
      actual_complete: 41.0,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-12-09",
      baseline_complete: 43.4,
      actual_complete: 41.7,
      forecast_complete: 17.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-12-16",
      baseline_complete: 44.5,
      actual_complete: 42.1,
      forecast_complete: 18.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-12-23",
      baseline_complete: 45.7,
      actual_complete: 48.8,
      forecast_complete: 18.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2024-12-30",
      baseline_complete: 46.9,
      actual_complete: 48.8,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-01-06",
      baseline_complete: 48.0,
      actual_complete: 49.4,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-01-13",
      baseline_complete: 49.2,
      actual_complete: 51.1,
      forecast_complete: 20.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-01-20",
      baseline_complete: 50.4,
      actual_complete: 51.1,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-01-27",
      baseline_complete: 51.5,
      actual_complete: 53.3,
      forecast_complete: 22.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-02-03",
      baseline_complete: 52.7,
      actual_complete: 53.8,
      forecast_complete: 23.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-02-10",
      baseline_complete: 53.9,
      actual_complete: 54.0,
      forecast_complete: 23.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-02-17",
      baseline_complete: 55.0,
      actual_complete: 57.7,
      forecast_complete: 24.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-02-24",
      baseline_complete: 56.2,
      actual_complete: 58.8,
      forecast_complete: 25.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-03-03",
      baseline_complete: 57.3,
      actual_complete: 58.8,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-03-10",
      baseline_complete: 58.5,
      actual_complete: 60.0,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-03-17",
      baseline_complete: 59.6,
      actual_complete: 60.0,
      forecast_complete: 27.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-03-24",
      baseline_complete: 60.7,
      actual_complete: 60.0,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-03-31",
      baseline_complete: 61.8,
      actual_complete: 61.5,
      forecast_complete: 28.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-04-07",
      baseline_complete: 62.9,
      actual_complete: 62.9,
      forecast_complete: 29.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-04-14",
      baseline_complete: 64.0,
      actual_complete: 63.6,
      forecast_complete: 30.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-04-21",
      baseline_complete: 65.1,
      actual_complete: 67.0,
      forecast_complete: 31.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-04-28",
      baseline_complete: 66.1,
      actual_complete: 70.1,
      forecast_complete: 31.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-05-05",
      baseline_complete: 67.2,
      actual_complete: 70.1,
      forecast_complete: 32.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-05-12",
      baseline_complete: 68.2,
      actual_complete: 70.1,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-05-19",
      baseline_complete: 69.2,
      actual_complete: 70.1,
      forecast_complete: 34.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-05-26",
      baseline_complete: 70.2,
      actual_complete: 73.5,
      forecast_complete: 35.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-06-02",
      baseline_complete: 71.2,
      actual_complete: 73.5,
      forecast_complete: 35.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-06-09",
      baseline_complete: 72.1,
      actual_complete: 73.5,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-06-16",
      baseline_complete: 73.0,
      actual_complete: 73.5,
      forecast_complete: 37.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-06-23",
      baseline_complete: 74.0,
      actual_complete: 75.8,
      forecast_complete: 38.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-06-30",
      baseline_complete: 74.8,
      actual_complete: 77.2,
      forecast_complete: 38.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-07-07",
      baseline_complete: 75.7,
      actual_complete: 77.9,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-07-14",
      baseline_complete: 76.6,
      actual_complete: 78.9,
      forecast_complete: 40.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-07-21",
      baseline_complete: 77.4,
      actual_complete: 78.9,
      forecast_complete: 41.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-07-28",
      baseline_complete: 78.2,
      actual_complete: 78.9,
      forecast_complete: 41.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-08-04",
      baseline_complete: 79.0,
      actual_complete: 82.2,
      forecast_complete: 42.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-08-11",
      baseline_complete: 79.8,
      actual_complete: 82.2,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-08-18",
      baseline_complete: 80.5,
      actual_complete: 82.2,
      forecast_complete: 43.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-08-25",
      baseline_complete: 81.2,
      actual_complete: 82.2,
      forecast_complete: 44.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-09-01",
      baseline_complete: 81.9,
      actual_complete: 82.2,
      forecast_complete: 45.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-09-08",
      baseline_complete: 82.6,
      actual_complete: 82.2,
      forecast_complete: 46.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-09-15",
      baseline_complete: 83.3,
      actual_complete: 84.9,
      forecast_complete: 46.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-09-22",
      baseline_complete: 83.9,
      actual_complete: 84.9,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-09-29",
      baseline_complete: 84.5,
      actual_complete: 84.9,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-10-06",
      baseline_complete: 85.1,
      actual_complete: 87.8,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-10-13",
      baseline_complete: 85.7,
      actual_complete: 87.8,
      forecast_complete: 49.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-10-20",
      baseline_complete: 86.3,
      actual_complete: 87.8,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-10-27",
      baseline_complete: 86.8,
      actual_complete: 87.8,
      forecast_complete: 50.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-11-03",
      baseline_complete: 87.4,
      actual_complete: 87.8,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-11-10",
      baseline_complete: 87.9,
      actual_complete: 90.6,
      forecast_complete: 52.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-11-17",
      baseline_complete: 88.4,
      actual_complete: 92.5,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-11-24",
      baseline_complete: 88.8,
      actual_complete: 92.5,
      forecast_complete: 53.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-12-01",
      baseline_complete: 89.3,
      actual_complete: 92.5,
      forecast_complete: 54.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-12-08",
      baseline_complete: 89.7,
      actual_complete: 93.8,
      forecast_complete: 54.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-12-15",
      baseline_complete: 90.1,
      actual_complete: 93.8,
      forecast_complete: 55.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-12-22",
      baseline_complete: 90.6,
      actual_complete: 93.8,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2025-12-29",
      baseline_complete: 90.9,
      actual_complete: 93.8,
      forecast_complete: 56.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-01-05",
      baseline_complete: 91.3,
      actual_complete: 93.8,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-01-12",
      baseline_complete: 91.7,
      actual_complete: 93.8,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-01-19",
      baseline_complete: 92.0,
      actual_complete: 93.8,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-01-26",
      baseline_complete: 92.4,
      actual_complete: 95.8,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-02-02",
      baseline_complete: 92.7,
      actual_complete: 95.8,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-02-09",
      baseline_complete: 93.0,
      actual_complete: 96.6,
      forecast_complete: 59.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-02-16",
      baseline_complete: 93.3,
      actual_complete: 96.6,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-02-23",
      baseline_complete: 93.6,
      actual_complete: 96.6,
      forecast_complete: 61.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-03-02",
      baseline_complete: 93.9,
      actual_complete: 97.4,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-03-09",
      baseline_complete: 94.1,
      actual_complete: 97.4,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-03-16",
      baseline_complete: 94.4,
      actual_complete: 97.4,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-03-23",
      baseline_complete: 94.6,
      actual_complete: 99.0,
      forecast_complete: 63.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-03-30",
      baseline_complete: 94.9,
      actual_complete: 99.0,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-04-06",
      baseline_complete: 95.1,
      actual_complete: 99.0,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-04-13",
      baseline_complete: 95.3,
      actual_complete: 99.0,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-04-20",
      baseline_complete: 95.5,
      actual_complete: 99.0,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-04-27",
      baseline_complete: 95.7,
      actual_complete: 99.0,
      forecast_complete: 65.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-05-04",
      baseline_complete: 95.9,
      actual_complete: 99.0,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-05-11",
      baseline_complete: 96.1,
      actual_complete: 99.0,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-05-18",
      baseline_complete: 96.2,
      actual_complete: 99.0,
      forecast_complete: 67.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-05-25",
      baseline_complete: 96.4,
      actual_complete: 99.2,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-06-01",
      baseline_complete: 96.6,
      actual_complete: 99.2,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-06-08",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 68.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-06-15",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 69.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-06-22",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-06-29",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-07-06",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-07-13",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-07-20",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 71.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-07-27",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 72.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-08-03",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 72.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-08-10",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-08-17",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 74.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-08-24",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 75.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-08-31",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 76.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-09-07",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 76.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-09-14",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 77.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-09-21",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 78.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-09-28",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 79.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-10-05",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 79.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-10-12",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 80.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-10-19",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-10-26",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 82.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-11-02",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-11-09",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 83.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-11-16",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 84.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-11-23",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-11-30",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 85.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-12-07",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-12-14",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 86.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-12-21",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2026-12-28",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-01-04",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-01-11",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-01-18",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-01-25",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-02-01",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-02-08",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-02-15",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-02-22",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-03-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 91.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-03-08",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-03-15",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-03-22",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-03-29",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-04-05",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-04-12",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-04-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-04-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-05-03",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-05-10",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-05-17",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-05-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-05-31",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-06-07",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-06-14",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-06-21",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-06-28",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-07-05",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-07-12",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-07-19",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-07-26",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-08-02",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-08-09",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-08-16",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-08-23",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-08-30",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-09-06",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-09-13",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-09-20",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-09-27",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-10-04",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "c15a7c83-9cab-4fba-129c-be649e9e74a4",
      reporting_date: "2027-10-09",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
  ],
  "e85448d3-7bad-acc3-91e1-c9c66d00492b": [
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-07-16",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-07-23",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-07-30",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-08-06",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-08-13",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-08-20",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-08-27",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-09-03",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-09-10",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-09-17",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-09-24",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-10-01",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-10-08",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-10-15",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-10-22",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-10-29",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-11-05",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-11-12",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-11-19",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-11-26",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-12-03",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-12-10",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-12-17",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-12-24",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2023-12-31",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-01-07",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-01-14",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-01-21",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-01-28",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-02-04",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-02-11",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-02-18",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-02-25",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-03-03",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-03-10",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-03-17",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-03-24",
      baseline_complete: 3.3,
      actual_complete: 0.5,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-03-31",
      baseline_complete: 3.6,
      actual_complete: 0.5,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-04-07",
      baseline_complete: 4.1,
      actual_complete: 1.9,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-04-14",
      baseline_complete: 4.5,
      actual_complete: 2.2,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-04-21",
      baseline_complete: 5.1,
      actual_complete: 4.0,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-04-28",
      baseline_complete: 5.6,
      actual_complete: 4.0,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-05-05",
      baseline_complete: 6.3,
      actual_complete: 4.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-05-12",
      baseline_complete: 7.0,
      actual_complete: 5.1,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-05-19",
      baseline_complete: 7.8,
      actual_complete: 7.0,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-05-26",
      baseline_complete: 8.6,
      actual_complete: 7.0,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-06-02",
      baseline_complete: 9.6,
      actual_complete: 9.0,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-06-09",
      baseline_complete: 10.6,
      actual_complete: 9.0,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-06-16",
      baseline_complete: 11.8,
      actual_complete: 10.0,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-06-23",
      baseline_complete: 13.0,
      actual_complete: 11.1,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-06-30",
      baseline_complete: 14.3,
      actual_complete: 12.0,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-07-07",
      baseline_complete: 15.8,
      actual_complete: 14.5,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-07-14",
      baseline_complete: 17.4,
      actual_complete: 14.9,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-07-21",
      baseline_complete: 19.1,
      actual_complete: 16.4,
      forecast_complete: 12.8,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-07-28",
      baseline_complete: 20.9,
      actual_complete: 17.3,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-08-04",
      baseline_complete: 22.9,
      actual_complete: 19.9,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-08-11",
      baseline_complete: 25.0,
      actual_complete: 21.9,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-08-18",
      baseline_complete: 27.2,
      actual_complete: 24.3,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-08-25",
      baseline_complete: 29.5,
      actual_complete: 26.3,
      forecast_complete: 19.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-09-01",
      baseline_complete: 31.9,
      actual_complete: 29.6,
      forecast_complete: 20.5,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-09-08",
      baseline_complete: 34.5,
      actual_complete: 31.2,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-09-15",
      baseline_complete: 37.1,
      actual_complete: 33.8,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-09-22",
      baseline_complete: 39.8,
      actual_complete: 38.9,
      forecast_complete: 25.6,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-09-29",
      baseline_complete: 42.6,
      actual_complete: 41.8,
      forecast_complete: 27.5,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-10-06",
      baseline_complete: 45.4,
      actual_complete: 41.9,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-10-13",
      baseline_complete: 48.2,
      actual_complete: 49.1,
      forecast_complete: 31.4,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-10-20",
      baseline_complete: 51.1,
      actual_complete: 49.1,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-10-27",
      baseline_complete: 53.9,
      actual_complete: 50.9,
      forecast_complete: 35.6,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-11-03",
      baseline_complete: 56.8,
      actual_complete: 55.4,
      forecast_complete: 37.8,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-11-10",
      baseline_complete: 59.6,
      actual_complete: 57.9,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-11-17",
      baseline_complete: 62.3,
      actual_complete: 60.5,
      forecast_complete: 42.2,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-11-24",
      baseline_complete: 64.9,
      actual_complete: 65.0,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-12-01",
      baseline_complete: 67.5,
      actual_complete: 67.4,
      forecast_complete: 46.6,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-12-08",
      baseline_complete: 69.9,
      actual_complete: 69.3,
      forecast_complete: 48.7,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-12-15",
      baseline_complete: 72.3,
      actual_complete: 72.2,
      forecast_complete: 50.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-12-22",
      baseline_complete: 74.5,
      actual_complete: 74.0,
      forecast_complete: 53.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2024-12-29",
      baseline_complete: 76.6,
      actual_complete: 75.5,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-01-05",
      baseline_complete: 78.6,
      actual_complete: 78.0,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-01-12",
      baseline_complete: 80.5,
      actual_complete: 79.3,
      forecast_complete: 59.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-01-19",
      baseline_complete: 82.2,
      actual_complete: 81.3,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-01-26",
      baseline_complete: 83.8,
      actual_complete: 84.3,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-02-02",
      baseline_complete: 85.3,
      actual_complete: 84.8,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-02-09",
      baseline_complete: 86.7,
      actual_complete: 87.1,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-02-16",
      baseline_complete: 88.0,
      actual_complete: 87.1,
      forecast_complete: 68.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-02-23",
      baseline_complete: 89.1,
      actual_complete: 87.5,
      forecast_complete: 69.6,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-03-02",
      baseline_complete: 90.2,
      actual_complete: 92.2,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-03-09",
      baseline_complete: 91.2,
      actual_complete: 93.0,
      forecast_complete: 73.3,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-03-16",
      baseline_complete: 92.0,
      actual_complete: 93.0,
      forecast_complete: 75.7,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-03-23",
      baseline_complete: 92.8,
      actual_complete: 93.8,
      forecast_complete: 78.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-03-30",
      baseline_complete: 93.6,
      actual_complete: 94.9,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-04-06",
      baseline_complete: 94.2,
      actual_complete: 94.9,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-04-13",
      baseline_complete: 94.8,
      actual_complete: 97.2,
      forecast_complete: 84.3,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-04-20",
      baseline_complete: 95.3,
      actual_complete: 97.2,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-04-27",
      baseline_complete: 95.8,
      actual_complete: 97.2,
      forecast_complete: 87.8,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-05-04",
      baseline_complete: 96.3,
      actual_complete: 97.2,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-05-11",
      baseline_complete: 96.6,
      actual_complete: 97.2,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-05-18",
      baseline_complete: 97.0,
      actual_complete: 98.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-05-25",
      baseline_complete: 97.3,
      actual_complete: 98.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-06-01",
      baseline_complete: 97.6,
      actual_complete: 98.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-06-08",
      baseline_complete: 97.9,
      actual_complete: 98.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-06-15",
      baseline_complete: 98.1,
      actual_complete: 98.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-06-22",
      baseline_complete: 98.3,
      actual_complete: 99.8,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-06-29",
      baseline_complete: 98.5,
      actual_complete: 99.8,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-07-06",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-07-13",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-07-20",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-07-27",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-08-03",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-08-10",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-08-17",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-08-24",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-08-31",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-09-07",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-09-14",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e85448d3-7bad-acc3-91e1-c9c66d00492b",
      reporting_date: "2025-09-16",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f": [
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2024-12-27",
      baseline_complete: 0.1,
      actual_complete: 2.3,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-01-03",
      baseline_complete: 0.2,
      actual_complete: 3.8,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-01-10",
      baseline_complete: 0.2,
      actual_complete: 3.8,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-01-17",
      baseline_complete: 0.2,
      actual_complete: 3.8,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-01-24",
      baseline_complete: 0.2,
      actual_complete: 3.8,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-01-31",
      baseline_complete: 0.3,
      actual_complete: 3.8,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-02-07",
      baseline_complete: 0.3,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-02-14",
      baseline_complete: 0.3,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-02-21",
      baseline_complete: 0.4,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-02-28",
      baseline_complete: 0.4,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-03-07",
      baseline_complete: 0.4,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-03-14",
      baseline_complete: 0.5,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-03-21",
      baseline_complete: 0.6,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-03-28",
      baseline_complete: 0.6,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-04-04",
      baseline_complete: 0.7,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-04-11",
      baseline_complete: 0.8,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-04-18",
      baseline_complete: 0.9,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-04-25",
      baseline_complete: 1.0,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-05-02",
      baseline_complete: 1.1,
      actual_complete: 4.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-05-09",
      baseline_complete: 1.2,
      actual_complete: 5.3,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-05-16",
      baseline_complete: 1.4,
      actual_complete: 5.3,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-05-23",
      baseline_complete: 1.5,
      actual_complete: 5.3,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-05-30",
      baseline_complete: 1.7,
      actual_complete: 5.3,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-06-06",
      baseline_complete: 1.9,
      actual_complete: 6.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-06-13",
      baseline_complete: 2.1,
      actual_complete: 6.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-06-20",
      baseline_complete: 2.4,
      actual_complete: 6.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-06-27",
      baseline_complete: 2.7,
      actual_complete: 6.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-07-04",
      baseline_complete: 3.0,
      actual_complete: 6.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-07-11",
      baseline_complete: 3.3,
      actual_complete: 6.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-07-18",
      baseline_complete: 3.7,
      actual_complete: 6.8,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-07-25",
      baseline_complete: 4.2,
      actual_complete: 7.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-08-01",
      baseline_complete: 4.6,
      actual_complete: 7.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-08-08",
      baseline_complete: 5.2,
      actual_complete: 7.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-08-15",
      baseline_complete: 5.8,
      actual_complete: 7.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-08-22",
      baseline_complete: 6.4,
      actual_complete: 9.6,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-08-29",
      baseline_complete: 7.1,
      actual_complete: 9.6,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-09-05",
      baseline_complete: 7.9,
      actual_complete: 11.8,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-09-12",
      baseline_complete: 8.8,
      actual_complete: 11.8,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-09-19",
      baseline_complete: 9.8,
      actual_complete: 11.8,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-09-26",
      baseline_complete: 10.8,
      actual_complete: 15.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-10-03",
      baseline_complete: 11.9,
      actual_complete: 15.0,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-10-10",
      baseline_complete: 13.2,
      actual_complete: 16.5,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-10-17",
      baseline_complete: 14.6,
      actual_complete: 16.5,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-10-24",
      baseline_complete: 16.0,
      actual_complete: 19.8,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-10-31",
      baseline_complete: 17.6,
      actual_complete: 21.1,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-11-07",
      baseline_complete: 19.3,
      actual_complete: 21.1,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-11-14",
      baseline_complete: 21.2,
      actual_complete: 21.7,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-11-21",
      baseline_complete: 23.1,
      actual_complete: 22.9,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-11-28",
      baseline_complete: 25.2,
      actual_complete: 26.7,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-12-05",
      baseline_complete: 27.4,
      actual_complete: 29.8,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-12-12",
      baseline_complete: 29.8,
      actual_complete: 33.1,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-12-19",
      baseline_complete: 32.2,
      actual_complete: 36.0,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2025-12-26",
      baseline_complete: 34.7,
      actual_complete: 36.9,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-01-02",
      baseline_complete: 37.4,
      actual_complete: 37.6,
      forecast_complete: 17.1,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-01-09",
      baseline_complete: 40.1,
      actual_complete: 44.0,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-01-16",
      baseline_complete: 42.8,
      actual_complete: 44.0,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-01-23",
      baseline_complete: 45.6,
      actual_complete: 45.6,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-01-30",
      baseline_complete: 48.5,
      actual_complete: 50.1,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-02-06",
      baseline_complete: 51.3,
      actual_complete: 53.9,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-02-13",
      baseline_complete: 54.1,
      actual_complete: 54.4,
      forecast_complete: 27.6,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-02-20",
      baseline_complete: 57.0,
      actual_complete: 57.1,
      forecast_complete: 29.6,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-02-27",
      baseline_complete: 59.7,
      actual_complete: 60.2,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-03-06",
      baseline_complete: 62.4,
      actual_complete: 63.1,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-03-13",
      baseline_complete: 65.1,
      actual_complete: 65.1,
      forecast_complete: 35.5,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-03-20",
      baseline_complete: 67.6,
      actual_complete: 67.4,
      forecast_complete: 37.5,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-03-27",
      baseline_complete: 70.0,
      actual_complete: 70.0,
      forecast_complete: 39.4,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-04-03",
      baseline_complete: 72.4,
      actual_complete: 72.8,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-04-10",
      baseline_complete: 74.6,
      actual_complete: 74.0,
      forecast_complete: 43.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-04-17",
      baseline_complete: 76.7,
      actual_complete: 76.3,
      forecast_complete: 45.2,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-04-24",
      baseline_complete: 78.7,
      actual_complete: 81.5,
      forecast_complete: 47.0,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-05-01",
      baseline_complete: 80.5,
      actual_complete: 84.3,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-05-08",
      baseline_complete: 82.2,
      actual_complete: 85.3,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-05-15",
      baseline_complete: 83.8,
      actual_complete: 87.8,
      forecast_complete: 52.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-05-22",
      baseline_complete: 85.3,
      actual_complete: 87.8,
      forecast_complete: 54.0,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-05-29",
      baseline_complete: 86.7,
      actual_complete: 88.5,
      forecast_complete: 55.6,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-06-05",
      baseline_complete: 88.0,
      actual_complete: 92.1,
      forecast_complete: 57.2,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-06-12",
      baseline_complete: 89.1,
      actual_complete: 92.1,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-06-19",
      baseline_complete: 90.2,
      actual_complete: 93.5,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-06-26",
      baseline_complete: 91.1,
      actual_complete: 94.2,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-07-03",
      baseline_complete: 92.0,
      actual_complete: 95.8,
      forecast_complete: 63.0,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-07-10",
      baseline_complete: 92.8,
      actual_complete: 95.8,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-07-17",
      baseline_complete: 93.5,
      actual_complete: 96.2,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-07-24",
      baseline_complete: 94.2,
      actual_complete: 96.2,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-07-31",
      baseline_complete: 94.8,
      actual_complete: 96.2,
      forecast_complete: 68.2,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-08-07",
      baseline_complete: 95.3,
      actual_complete: 96.2,
      forecast_complete: 69.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-08-14",
      baseline_complete: 95.8,
      actual_complete: 96.2,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-08-21",
      baseline_complete: 96.2,
      actual_complete: 97.5,
      forecast_complete: 72.1,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-08-28",
      baseline_complete: 96.6,
      actual_complete: 97.9,
      forecast_complete: 74.1,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-09-04",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 76.1,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-09-11",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 77.9,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-09-18",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-09-25",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 81.2,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-10-02",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 82.8,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-10-09",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-10-16",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-10-23",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-10-30",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-11-06",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-11-13",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-11-20",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 91.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-11-27",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-12-04",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-12-11",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-12-18",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2026-12-25",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2027-01-01",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2027-01-08",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2027-01-15",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2027-01-22",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2027-01-29",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2027-02-05",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2027-02-12",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2027-02-19",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2027-02-26",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "c0bd7c98-10e4-86b4-4ffd-32d2c791e59f",
      reporting_date: "2027-02-27",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
  ],
  "71004bd7-fc1a-255d-7f17-5076f32a86c7": [
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-04-10",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-04-17",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-04-24",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-05-01",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-05-08",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-05-15",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-05-22",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-05-29",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-06-05",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-06-12",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-06-19",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-06-26",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-07-03",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-07-10",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-07-17",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-07-24",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-07-31",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-08-07",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-08-14",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-08-21",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-08-28",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-09-04",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-09-11",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-09-18",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-09-25",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-10-02",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-10-09",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-10-16",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-10-23",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-10-30",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-11-06",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-11-13",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-11-20",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-11-27",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-12-04",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-12-11",
      baseline_complete: 4.1,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-12-18",
      baseline_complete: 4.4,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2024-12-25",
      baseline_complete: 4.7,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-01-01",
      baseline_complete: 5.0,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-01-08",
      baseline_complete: 5.3,
      actual_complete: 0.7,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-01-15",
      baseline_complete: 5.7,
      actual_complete: 1.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-01-22",
      baseline_complete: 6.0,
      actual_complete: 1.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-01-29",
      baseline_complete: 6.4,
      actual_complete: 3.2,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-02-05",
      baseline_complete: 6.9,
      actual_complete: 3.2,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-02-12",
      baseline_complete: 7.3,
      actual_complete: 3.2,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-02-19",
      baseline_complete: 7.8,
      actual_complete: 3.2,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-02-26",
      baseline_complete: 8.3,
      actual_complete: 4.1,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-03-05",
      baseline_complete: 8.8,
      actual_complete: 4.1,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-03-12",
      baseline_complete: 9.3,
      actual_complete: 4.4,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-03-19",
      baseline_complete: 9.9,
      actual_complete: 5.1,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-03-26",
      baseline_complete: 10.5,
      actual_complete: 6.1,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-04-02",
      baseline_complete: 11.2,
      actual_complete: 7.5,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-04-09",
      baseline_complete: 11.8,
      actual_complete: 7.5,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-04-16",
      baseline_complete: 12.6,
      actual_complete: 7.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-04-23",
      baseline_complete: 13.3,
      actual_complete: 10.2,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-04-30",
      baseline_complete: 14.1,
      actual_complete: 10.7,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-05-07",
      baseline_complete: 14.9,
      actual_complete: 10.8,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-05-14",
      baseline_complete: 15.8,
      actual_complete: 12.8,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-05-21",
      baseline_complete: 16.7,
      actual_complete: 12.8,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-05-28",
      baseline_complete: 17.7,
      actual_complete: 13.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-06-04",
      baseline_complete: 18.6,
      actual_complete: 15.6,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-06-11",
      baseline_complete: 19.7,
      actual_complete: 15.6,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-06-18",
      baseline_complete: 20.8,
      actual_complete: 17.3,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-06-25",
      baseline_complete: 21.9,
      actual_complete: 17.3,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-07-02",
      baseline_complete: 23.0,
      actual_complete: 18.9,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-07-09",
      baseline_complete: 24.3,
      actual_complete: 20.4,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-07-16",
      baseline_complete: 25.5,
      actual_complete: 20.5,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-07-23",
      baseline_complete: 26.8,
      actual_complete: 23.6,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-07-30",
      baseline_complete: 28.1,
      actual_complete: 26.6,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-08-06",
      baseline_complete: 29.5,
      actual_complete: 26.6,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-08-13",
      baseline_complete: 30.9,
      actual_complete: 26.6,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-08-20",
      baseline_complete: 32.3,
      actual_complete: 29.4,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-08-27",
      baseline_complete: 33.8,
      actual_complete: 31.5,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-09-03",
      baseline_complete: 35.3,
      actual_complete: 32.2,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-09-10",
      baseline_complete: 36.9,
      actual_complete: 35.1,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-09-17",
      baseline_complete: 38.4,
      actual_complete: 35.5,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-09-24",
      baseline_complete: 40.0,
      actual_complete: 38.7,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-10-01",
      baseline_complete: 41.7,
      actual_complete: 41.0,
      forecast_complete: 20.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-10-08",
      baseline_complete: 43.3,
      actual_complete: 41.0,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-10-15",
      baseline_complete: 44.9,
      actual_complete: 43.9,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-10-22",
      baseline_complete: 46.6,
      actual_complete: 43.9,
      forecast_complete: 24.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-10-29",
      baseline_complete: 48.3,
      actual_complete: 46.1,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-11-05",
      baseline_complete: 49.9,
      actual_complete: 48.3,
      forecast_complete: 26.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-11-12",
      baseline_complete: 51.6,
      actual_complete: 48.3,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-11-19",
      baseline_complete: 53.3,
      actual_complete: 49.1,
      forecast_complete: 29.5,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-11-26",
      baseline_complete: 54.9,
      actual_complete: 50.0,
      forecast_complete: 30.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-12-03",
      baseline_complete: 56.6,
      actual_complete: 52.5,
      forecast_complete: 32.1,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-12-10",
      baseline_complete: 58.2,
      actual_complete: 53.7,
      forecast_complete: 33.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-12-17",
      baseline_complete: 59.8,
      actual_complete: 59.9,
      forecast_complete: 34.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-12-24",
      baseline_complete: 61.4,
      actual_complete: 61.6,
      forecast_complete: 36.1,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2025-12-31",
      baseline_complete: 63.0,
      actual_complete: 62.5,
      forecast_complete: 37.5,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-01-07",
      baseline_complete: 64.5,
      actual_complete: 64.5,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-01-14",
      baseline_complete: 66.1,
      actual_complete: 64.5,
      forecast_complete: 40.3,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-01-21",
      baseline_complete: 67.5,
      actual_complete: 67.6,
      forecast_complete: 41.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-01-28",
      baseline_complete: 69.0,
      actual_complete: 67.6,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-02-04",
      baseline_complete: 70.4,
      actual_complete: 67.6,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-02-11",
      baseline_complete: 71.8,
      actual_complete: 70.8,
      forecast_complete: 45.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-02-18",
      baseline_complete: 73.1,
      actual_complete: 70.8,
      forecast_complete: 47.1,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-02-25",
      baseline_complete: 74.4,
      actual_complete: 73.5,
      forecast_complete: 48.5,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-03-04",
      baseline_complete: 75.6,
      actual_complete: 73.6,
      forecast_complete: 49.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-03-11",
      baseline_complete: 76.9,
      actual_complete: 76.8,
      forecast_complete: 51.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-03-18",
      baseline_complete: 78.0,
      actual_complete: 76.8,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-03-25",
      baseline_complete: 79.1,
      actual_complete: 76.8,
      forecast_complete: 53.7,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-04-01",
      baseline_complete: 80.2,
      actual_complete: 79.4,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-04-08",
      baseline_complete: 81.3,
      actual_complete: 79.4,
      forecast_complete: 56.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-04-15",
      baseline_complete: 82.3,
      actual_complete: 80.6,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-04-22",
      baseline_complete: 83.2,
      actual_complete: 83.3,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-04-29",
      baseline_complete: 84.1,
      actual_complete: 84.0,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-05-06",
      baseline_complete: 85.0,
      actual_complete: 86.6,
      forecast_complete: 61.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-05-13",
      baseline_complete: 85.8,
      actual_complete: 86.6,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-05-20",
      baseline_complete: 86.6,
      actual_complete: 86.6,
      forecast_complete: 63.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-05-27",
      baseline_complete: 87.4,
      actual_complete: 86.8,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-06-03",
      baseline_complete: 88.1,
      actual_complete: 90.0,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-06-10",
      baseline_complete: 88.8,
      actual_complete: 90.0,
      forecast_complete: 68.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-06-17",
      baseline_complete: 89.4,
      actual_complete: 90.0,
      forecast_complete: 70.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-06-24",
      baseline_complete: 90.1,
      actual_complete: 90.2,
      forecast_complete: 72.5,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-07-01",
      baseline_complete: 90.6,
      actual_complete: 90.2,
      forecast_complete: 74.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-07-08",
      baseline_complete: 91.2,
      actual_complete: 92.4,
      forecast_complete: 75.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-07-15",
      baseline_complete: 91.7,
      actual_complete: 92.9,
      forecast_complete: 77.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-07-22",
      baseline_complete: 92.2,
      actual_complete: 93.2,
      forecast_complete: 78.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-07-29",
      baseline_complete: 92.7,
      actual_complete: 93.2,
      forecast_complete: 80.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-08-05",
      baseline_complete: 93.1,
      actual_complete: 96.1,
      forecast_complete: 81.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-08-12",
      baseline_complete: 93.5,
      actual_complete: 96.1,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-08-19",
      baseline_complete: 93.9,
      actual_complete: 96.1,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-08-26",
      baseline_complete: 94.3,
      actual_complete: 96.1,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-09-02",
      baseline_complete: 94.6,
      actual_complete: 96.1,
      forecast_complete: 86.7,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-09-09",
      baseline_complete: 95.0,
      actual_complete: 96.1,
      forecast_complete: 87.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-09-16",
      baseline_complete: 95.3,
      actual_complete: 97.6,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-09-23",
      baseline_complete: 95.6,
      actual_complete: 97.6,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-09-30",
      baseline_complete: 95.8,
      actual_complete: 97.6,
      forecast_complete: 90.7,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-10-07",
      baseline_complete: 96.1,
      actual_complete: 98.3,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-10-14",
      baseline_complete: 96.3,
      actual_complete: 98.3,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-10-21",
      baseline_complete: 96.6,
      actual_complete: 98.6,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-10-28",
      baseline_complete: 96.8,
      actual_complete: 98.6,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-11-04",
      baseline_complete: 97.0,
      actual_complete: 98.6,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-11-11",
      baseline_complete: 97.2,
      actual_complete: 98.6,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-11-18",
      baseline_complete: 97.4,
      actual_complete: 98.6,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-11-25",
      baseline_complete: 97.5,
      actual_complete: 98.6,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-12-02",
      baseline_complete: 97.7,
      actual_complete: 98.6,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-12-09",
      baseline_complete: 97.8,
      actual_complete: 98.6,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-12-16",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-12-23",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2026-12-30",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2027-01-06",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2027-01-13",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2027-01-20",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2027-01-27",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2027-02-03",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "71004bd7-fc1a-255d-7f17-5076f32a86c7",
      reporting_date: "2027-02-10",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
  ],
  "4486f271-45a4-63ce-eb67-0c1d45ba4986": [
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-05-22",
      baseline_complete: 0.9,
      actual_complete: 6.7,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-05-29",
      baseline_complete: 1.0,
      actual_complete: 6.7,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-06-05",
      baseline_complete: 1.0,
      actual_complete: 6.7,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-06-12",
      baseline_complete: 1.1,
      actual_complete: 6.8,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-06-19",
      baseline_complete: 1.1,
      actual_complete: 6.8,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-06-26",
      baseline_complete: 1.2,
      actual_complete: 6.8,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-07-03",
      baseline_complete: 1.2,
      actual_complete: 7.0,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-07-10",
      baseline_complete: 1.3,
      actual_complete: 7.0,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-07-17",
      baseline_complete: 1.3,
      actual_complete: 7.0,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-07-24",
      baseline_complete: 1.4,
      actual_complete: 7.0,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-07-31",
      baseline_complete: 1.4,
      actual_complete: 7.0,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-08-07",
      baseline_complete: 1.5,
      actual_complete: 7.0,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-08-14",
      baseline_complete: 1.6,
      actual_complete: 7.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-08-21",
      baseline_complete: 1.6,
      actual_complete: 7.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-08-28",
      baseline_complete: 1.7,
      actual_complete: 8.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-09-04",
      baseline_complete: 1.8,
      actual_complete: 8.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-09-11",
      baseline_complete: 1.9,
      actual_complete: 8.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-09-18",
      baseline_complete: 2.0,
      actual_complete: 8.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-09-25",
      baseline_complete: 2.1,
      actual_complete: 8.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-10-02",
      baseline_complete: 2.1,
      actual_complete: 8.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-10-09",
      baseline_complete: 2.2,
      actual_complete: 8.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-10-16",
      baseline_complete: 2.3,
      actual_complete: 8.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-10-23",
      baseline_complete: 2.5,
      actual_complete: 8.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-10-30",
      baseline_complete: 2.6,
      actual_complete: 8.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-11-06",
      baseline_complete: 2.7,
      actual_complete: 8.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-11-13",
      baseline_complete: 2.8,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-11-20",
      baseline_complete: 2.9,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-11-27",
      baseline_complete: 3.1,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-12-04",
      baseline_complete: 3.2,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-12-11",
      baseline_complete: 3.3,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-12-18",
      baseline_complete: 3.5,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2023-12-25",
      baseline_complete: 3.6,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-01-01",
      baseline_complete: 3.8,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-01-08",
      baseline_complete: 4.0,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-01-15",
      baseline_complete: 4.1,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-01-22",
      baseline_complete: 4.3,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-01-29",
      baseline_complete: 4.5,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-02-05",
      baseline_complete: 4.7,
      actual_complete: 9.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-02-12",
      baseline_complete: 4.9,
      actual_complete: 11.2,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-02-19",
      baseline_complete: 5.1,
      actual_complete: 11.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-02-26",
      baseline_complete: 5.4,
      actual_complete: 11.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-03-04",
      baseline_complete: 5.6,
      actual_complete: 11.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-03-11",
      baseline_complete: 5.9,
      actual_complete: 11.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-03-18",
      baseline_complete: 6.1,
      actual_complete: 11.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-03-25",
      baseline_complete: 6.4,
      actual_complete: 11.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-04-01",
      baseline_complete: 6.6,
      actual_complete: 11.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-04-08",
      baseline_complete: 6.9,
      actual_complete: 11.5,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-04-15",
      baseline_complete: 7.2,
      actual_complete: 11.5,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-04-22",
      baseline_complete: 7.5,
      actual_complete: 13.8,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-04-29",
      baseline_complete: 7.9,
      actual_complete: 13.8,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-05-06",
      baseline_complete: 8.2,
      actual_complete: 13.8,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-05-13",
      baseline_complete: 8.5,
      actual_complete: 13.8,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-05-20",
      baseline_complete: 8.9,
      actual_complete: 13.8,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-05-27",
      baseline_complete: 9.3,
      actual_complete: 13.8,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-06-03",
      baseline_complete: 9.7,
      actual_complete: 13.8,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-06-10",
      baseline_complete: 10.1,
      actual_complete: 15.1,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-06-17",
      baseline_complete: 10.5,
      actual_complete: 15.1,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-06-24",
      baseline_complete: 10.9,
      actual_complete: 15.1,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-07-01",
      baseline_complete: 11.4,
      actual_complete: 16.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-07-08",
      baseline_complete: 11.8,
      actual_complete: 16.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-07-15",
      baseline_complete: 12.3,
      actual_complete: 16.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-07-22",
      baseline_complete: 12.8,
      actual_complete: 18.4,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-07-29",
      baseline_complete: 13.3,
      actual_complete: 18.4,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-08-05",
      baseline_complete: 13.8,
      actual_complete: 18.4,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-08-12",
      baseline_complete: 14.4,
      actual_complete: 20.1,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-08-19",
      baseline_complete: 15.0,
      actual_complete: 20.1,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-08-26",
      baseline_complete: 15.5,
      actual_complete: 20.1,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-09-02",
      baseline_complete: 16.1,
      actual_complete: 21.2,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-09-09",
      baseline_complete: 16.8,
      actual_complete: 22.4,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-09-16",
      baseline_complete: 17.4,
      actual_complete: 22.9,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-09-23",
      baseline_complete: 18.1,
      actual_complete: 24.0,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-09-30",
      baseline_complete: 18.7,
      actual_complete: 24.0,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-10-07",
      baseline_complete: 19.4,
      actual_complete: 24.9,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-10-14",
      baseline_complete: 20.2,
      actual_complete: 25.3,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-10-21",
      baseline_complete: 20.9,
      actual_complete: 25.3,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-10-28",
      baseline_complete: 21.7,
      actual_complete: 25.3,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-11-04",
      baseline_complete: 22.4,
      actual_complete: 26.5,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-11-11",
      baseline_complete: 23.2,
      actual_complete: 28.2,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-11-18",
      baseline_complete: 24.0,
      actual_complete: 28.2,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-11-25",
      baseline_complete: 24.9,
      actual_complete: 28.3,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-12-02",
      baseline_complete: 25.7,
      actual_complete: 28.3,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-12-09",
      baseline_complete: 26.6,
      actual_complete: 28.3,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-12-16",
      baseline_complete: 27.5,
      actual_complete: 29.7,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-12-23",
      baseline_complete: 28.4,
      actual_complete: 29.9,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2024-12-30",
      baseline_complete: 29.3,
      actual_complete: 35.5,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-01-06",
      baseline_complete: 30.3,
      actual_complete: 35.5,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-01-13",
      baseline_complete: 31.3,
      actual_complete: 35.5,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-01-20",
      baseline_complete: 32.2,
      actual_complete: 35.5,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-01-27",
      baseline_complete: 33.2,
      actual_complete: 37.4,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-02-03",
      baseline_complete: 34.2,
      actual_complete: 37.4,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-02-10",
      baseline_complete: 35.3,
      actual_complete: 40.0,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-02-17",
      baseline_complete: 36.3,
      actual_complete: 40.0,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-02-24",
      baseline_complete: 37.4,
      actual_complete: 40.1,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-03-03",
      baseline_complete: 38.4,
      actual_complete: 41.6,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-03-10",
      baseline_complete: 39.5,
      actual_complete: 43.2,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-03-17",
      baseline_complete: 40.6,
      actual_complete: 43.2,
      forecast_complete: 18.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-03-24",
      baseline_complete: 41.7,
      actual_complete: 44.7,
      forecast_complete: 18.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-03-31",
      baseline_complete: 42.8,
      actual_complete: 44.7,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-04-07",
      baseline_complete: 43.9,
      actual_complete: 48.0,
      forecast_complete: 20.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-04-14",
      baseline_complete: 45.0,
      actual_complete: 48.0,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-04-21",
      baseline_complete: 46.1,
      actual_complete: 51.5,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-04-28",
      baseline_complete: 47.3,
      actual_complete: 51.5,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-05-05",
      baseline_complete: 48.4,
      actual_complete: 51.5,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-05-12",
      baseline_complete: 49.5,
      actual_complete: 52.7,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-05-19",
      baseline_complete: 50.6,
      actual_complete: 53.1,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-05-26",
      baseline_complete: 51.8,
      actual_complete: 53.2,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-06-02",
      baseline_complete: 52.9,
      actual_complete: 54.6,
      forecast_complete: 25.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-06-09",
      baseline_complete: 54.0,
      actual_complete: 57.6,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-06-16",
      baseline_complete: 55.2,
      actual_complete: 57.6,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-06-23",
      baseline_complete: 56.3,
      actual_complete: 59.4,
      forecast_complete: 27.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-06-30",
      baseline_complete: 57.4,
      actual_complete: 60.3,
      forecast_complete: 28.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-07-07",
      baseline_complete: 58.5,
      actual_complete: 61.7,
      forecast_complete: 28.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-07-14",
      baseline_complete: 59.6,
      actual_complete: 63.0,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-07-21",
      baseline_complete: 60.7,
      actual_complete: 63.0,
      forecast_complete: 30.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-07-28",
      baseline_complete: 61.7,
      actual_complete: 63.0,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-08-04",
      baseline_complete: 62.8,
      actual_complete: 65.8,
      forecast_complete: 31.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-08-11",
      baseline_complete: 63.8,
      actual_complete: 67.5,
      forecast_complete: 32.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-08-18",
      baseline_complete: 64.9,
      actual_complete: 68.9,
      forecast_complete: 33.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-08-25",
      baseline_complete: 65.9,
      actual_complete: 69.3,
      forecast_complete: 33.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-09-01",
      baseline_complete: 66.9,
      actual_complete: 69.3,
      forecast_complete: 34.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-09-08",
      baseline_complete: 67.9,
      actual_complete: 72.5,
      forecast_complete: 35.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-09-15",
      baseline_complete: 68.9,
      actual_complete: 73.7,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-09-22",
      baseline_complete: 69.8,
      actual_complete: 74.8,
      forecast_complete: 36.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-09-29",
      baseline_complete: 70.8,
      actual_complete: 74.8,
      forecast_complete: 37.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-10-06",
      baseline_complete: 71.7,
      actual_complete: 74.8,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-10-13",
      baseline_complete: 72.6,
      actual_complete: 74.8,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-10-20",
      baseline_complete: 73.5,
      actual_complete: 76.8,
      forecast_complete: 39.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-10-27",
      baseline_complete: 74.4,
      actual_complete: 80.5,
      forecast_complete: 40.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-11-03",
      baseline_complete: 75.2,
      actual_complete: 80.5,
      forecast_complete: 41.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-11-10",
      baseline_complete: 76.1,
      actual_complete: 80.5,
      forecast_complete: 41.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-11-17",
      baseline_complete: 76.9,
      actual_complete: 80.5,
      forecast_complete: 42.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-11-24",
      baseline_complete: 77.7,
      actual_complete: 80.5,
      forecast_complete: 43.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-12-01",
      baseline_complete: 78.5,
      actual_complete: 80.5,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-12-08",
      baseline_complete: 79.2,
      actual_complete: 82.6,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-12-15",
      baseline_complete: 79.9,
      actual_complete: 82.6,
      forecast_complete: 45.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-12-22",
      baseline_complete: 80.7,
      actual_complete: 85.6,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2025-12-29",
      baseline_complete: 81.4,
      actual_complete: 85.6,
      forecast_complete: 46.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-01-05",
      baseline_complete: 82.0,
      actual_complete: 85.7,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-01-12",
      baseline_complete: 82.7,
      actual_complete: 85.7,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-01-19",
      baseline_complete: 83.3,
      actual_complete: 85.7,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-01-26",
      baseline_complete: 83.9,
      actual_complete: 85.7,
      forecast_complete: 49.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-02-02",
      baseline_complete: 84.5,
      actual_complete: 88.1,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-02-09",
      baseline_complete: 85.1,
      actual_complete: 88.1,
      forecast_complete: 50.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-02-16",
      baseline_complete: 85.7,
      actual_complete: 89.9,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-02-23",
      baseline_complete: 86.2,
      actual_complete: 91.4,
      forecast_complete: 52.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-03-02",
      baseline_complete: 86.8,
      actual_complete: 91.5,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-03-09",
      baseline_complete: 87.3,
      actual_complete: 91.5,
      forecast_complete: 53.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-03-16",
      baseline_complete: 87.8,
      actual_complete: 91.5,
      forecast_complete: 54.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-03-23",
      baseline_complete: 88.2,
      actual_complete: 91.5,
      forecast_complete: 54.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-03-30",
      baseline_complete: 88.7,
      actual_complete: 91.5,
      forecast_complete: 55.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-04-06",
      baseline_complete: 89.2,
      actual_complete: 91.5,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-04-13",
      baseline_complete: 89.6,
      actual_complete: 94.1,
      forecast_complete: 56.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-04-20",
      baseline_complete: 90.0,
      actual_complete: 95.1,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-04-27",
      baseline_complete: 90.4,
      actual_complete: 95.1,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-05-04",
      baseline_complete: 90.8,
      actual_complete: 95.1,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-05-11",
      baseline_complete: 91.2,
      actual_complete: 95.1,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-05-18",
      baseline_complete: 91.5,
      actual_complete: 96.0,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-05-25",
      baseline_complete: 91.9,
      actual_complete: 96.0,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-06-01",
      baseline_complete: 92.2,
      actual_complete: 96.0,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-06-08",
      baseline_complete: 92.5,
      actual_complete: 96.0,
      forecast_complete: 61.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-06-15",
      baseline_complete: 92.8,
      actual_complete: 96.0,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-06-22",
      baseline_complete: 93.1,
      actual_complete: 96.0,
      forecast_complete: 62.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-06-29",
      baseline_complete: 93.4,
      actual_complete: 96.9,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-07-06",
      baseline_complete: 93.7,
      actual_complete: 96.9,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-07-13",
      baseline_complete: 93.9,
      actual_complete: 96.9,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-07-20",
      baseline_complete: 94.2,
      actual_complete: 97.9,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-07-27",
      baseline_complete: 94.4,
      actual_complete: 99.7,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-08-03",
      baseline_complete: 94.7,
      actual_complete: 99.7,
      forecast_complete: 65.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-08-10",
      baseline_complete: 94.9,
      actual_complete: 99.7,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-08-17",
      baseline_complete: 95.1,
      actual_complete: 99.7,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-08-24",
      baseline_complete: 95.3,
      actual_complete: 99.7,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-08-31",
      baseline_complete: 95.5,
      actual_complete: 99.7,
      forecast_complete: 67.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-09-07",
      baseline_complete: 95.7,
      actual_complete: 99.7,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-09-14",
      baseline_complete: 95.9,
      actual_complete: 99.7,
      forecast_complete: 68.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-09-21",
      baseline_complete: 96.1,
      actual_complete: 99.7,
      forecast_complete: 68.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-09-28",
      baseline_complete: 96.2,
      actual_complete: 99.7,
      forecast_complete: 69.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-10-05",
      baseline_complete: 96.4,
      actual_complete: 99.7,
      forecast_complete: 69.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-10-12",
      baseline_complete: 96.5,
      actual_complete: 99.7,
      forecast_complete: 70.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-10-19",
      baseline_complete: 96.7,
      actual_complete: 99.7,
      forecast_complete: 70.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-10-26",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 71.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-11-02",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 71.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-11-09",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-11-16",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 72.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-11-23",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 73.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-11-30",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 74.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-12-07",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 74.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-12-14",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 75.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-12-21",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 76.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2026-12-28",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-01-04",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 78.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-01-11",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 78.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-01-18",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-01-25",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-02-01",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 81.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-02-08",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 81.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-02-15",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-02-22",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-03-01",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-03-08",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 84.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-03-15",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 85.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-03-22",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-03-29",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-04-05",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 86.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-04-12",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 87.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-04-19",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 87.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-04-26",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-05-03",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-05-10",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-05-17",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-05-24",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-05-31",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-06-07",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 91.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-06-14",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-06-21",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-06-28",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-07-05",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-07-12",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-07-19",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-07-26",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-08-02",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-08-09",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-08-16",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-08-23",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-08-30",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-09-06",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-09-13",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-09-20",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-09-27",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-10-04",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-10-11",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-10-18",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-10-25",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-11-01",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-11-08",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-11-15",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-11-22",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-11-29",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-12-06",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-12-13",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-12-20",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2027-12-27",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2028-01-03",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2028-01-10",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2028-01-17",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "4486f271-45a4-63ce-eb67-0c1d45ba4986",
      reporting_date: "2028-01-22",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
  ],
  "54f20686-b8f7-7639-9a51-7df3f54dcf6b": [
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-07-31",
      baseline_complete: 0.9,
      actual_complete: 0.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-08-07",
      baseline_complete: 1.0,
      actual_complete: 0.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-08-14",
      baseline_complete: 1.0,
      actual_complete: 0.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-08-21",
      baseline_complete: 1.1,
      actual_complete: 0.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-08-28",
      baseline_complete: 1.2,
      actual_complete: 0.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-09-04",
      baseline_complete: 1.2,
      actual_complete: 0.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-09-11",
      baseline_complete: 1.3,
      actual_complete: 0.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-09-18",
      baseline_complete: 1.4,
      actual_complete: 0.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-09-25",
      baseline_complete: 1.4,
      actual_complete: 2.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-10-02",
      baseline_complete: 1.5,
      actual_complete: 2.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-10-09",
      baseline_complete: 1.6,
      actual_complete: 2.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-10-16",
      baseline_complete: 1.7,
      actual_complete: 2.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-10-23",
      baseline_complete: 1.8,
      actual_complete: 2.5,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-10-30",
      baseline_complete: 1.9,
      actual_complete: 2.5,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-11-06",
      baseline_complete: 2.0,
      actual_complete: 2.7,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-11-13",
      baseline_complete: 2.1,
      actual_complete: 2.7,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-11-20",
      baseline_complete: 2.2,
      actual_complete: 2.7,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-11-27",
      baseline_complete: 2.3,
      actual_complete: 3.7,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-12-04",
      baseline_complete: 2.4,
      actual_complete: 3.7,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-12-11",
      baseline_complete: 2.5,
      actual_complete: 3.7,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-12-18",
      baseline_complete: 2.7,
      actual_complete: 4.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2023-12-25",
      baseline_complete: 2.8,
      actual_complete: 4.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-01-01",
      baseline_complete: 3.0,
      actual_complete: 4.1,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-01-08",
      baseline_complete: 3.1,
      actual_complete: 4.8,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-01-15",
      baseline_complete: 3.3,
      actual_complete: 4.8,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-01-22",
      baseline_complete: 3.5,
      actual_complete: 4.8,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-01-29",
      baseline_complete: 3.7,
      actual_complete: 4.9,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-02-05",
      baseline_complete: 3.8,
      actual_complete: 4.9,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-02-12",
      baseline_complete: 4.0,
      actual_complete: 4.9,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-02-19",
      baseline_complete: 4.3,
      actual_complete: 4.9,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-02-26",
      baseline_complete: 4.5,
      actual_complete: 6.1,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-03-04",
      baseline_complete: 4.7,
      actual_complete: 6.1,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-03-11",
      baseline_complete: 5.0,
      actual_complete: 6.1,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-03-18",
      baseline_complete: 5.2,
      actual_complete: 6.1,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-03-25",
      baseline_complete: 5.5,
      actual_complete: 6.1,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-04-01",
      baseline_complete: 5.8,
      actual_complete: 6.1,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-04-08",
      baseline_complete: 6.1,
      actual_complete: 6.8,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-04-15",
      baseline_complete: 6.4,
      actual_complete: 6.8,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-04-22",
      baseline_complete: 6.7,
      actual_complete: 6.8,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-04-29",
      baseline_complete: 7.0,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-05-06",
      baseline_complete: 7.4,
      actual_complete: 8.8,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-05-13",
      baseline_complete: 7.8,
      actual_complete: 8.8,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-05-20",
      baseline_complete: 8.2,
      actual_complete: 8.8,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-05-27",
      baseline_complete: 8.6,
      actual_complete: 8.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-06-03",
      baseline_complete: 9.0,
      actual_complete: 8.8,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-06-10",
      baseline_complete: 9.4,
      actual_complete: 10.7,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-06-17",
      baseline_complete: 9.9,
      actual_complete: 10.7,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-06-24",
      baseline_complete: 10.4,
      actual_complete: 10.7,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-07-01",
      baseline_complete: 10.9,
      actual_complete: 10.7,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-07-08",
      baseline_complete: 11.4,
      actual_complete: 12.4,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-07-15",
      baseline_complete: 12.0,
      actual_complete: 12.4,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-07-22",
      baseline_complete: 12.5,
      actual_complete: 12.7,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-07-29",
      baseline_complete: 13.1,
      actual_complete: 12.7,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-08-05",
      baseline_complete: 13.8,
      actual_complete: 12.7,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-08-12",
      baseline_complete: 14.4,
      actual_complete: 15.8,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-08-19",
      baseline_complete: 15.1,
      actual_complete: 15.8,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-08-26",
      baseline_complete: 15.8,
      actual_complete: 15.8,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-09-02",
      baseline_complete: 16.5,
      actual_complete: 17.8,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-09-09",
      baseline_complete: 17.2,
      actual_complete: 19.4,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-09-16",
      baseline_complete: 18.0,
      actual_complete: 19.4,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-09-23",
      baseline_complete: 18.8,
      actual_complete: 19.4,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-09-30",
      baseline_complete: 19.6,
      actual_complete: 19.4,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-10-07",
      baseline_complete: 20.5,
      actual_complete: 19.7,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-10-14",
      baseline_complete: 21.4,
      actual_complete: 19.7,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-10-21",
      baseline_complete: 22.3,
      actual_complete: 23.5,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-10-28",
      baseline_complete: 23.2,
      actual_complete: 23.5,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-11-04",
      baseline_complete: 24.2,
      actual_complete: 23.5,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-11-11",
      baseline_complete: 25.2,
      actual_complete: 23.5,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-11-18",
      baseline_complete: 26.2,
      actual_complete: 23.5,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-11-25",
      baseline_complete: 27.2,
      actual_complete: 27.6,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-12-02",
      baseline_complete: 28.3,
      actual_complete: 27.6,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-12-09",
      baseline_complete: 29.4,
      actual_complete: 27.6,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-12-16",
      baseline_complete: 30.5,
      actual_complete: 31.2,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-12-23",
      baseline_complete: 31.6,
      actual_complete: 31.2,
      forecast_complete: 16.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2024-12-30",
      baseline_complete: 32.8,
      actual_complete: 35.1,
      forecast_complete: 16.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-01-06",
      baseline_complete: 34.0,
      actual_complete: 35.1,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-01-13",
      baseline_complete: 35.2,
      actual_complete: 35.1,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-01-20",
      baseline_complete: 36.4,
      actual_complete: 35.1,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-01-27",
      baseline_complete: 37.6,
      actual_complete: 37.2,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-02-03",
      baseline_complete: 38.9,
      actual_complete: 41.3,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-02-10",
      baseline_complete: 40.2,
      actual_complete: 41.3,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-02-17",
      baseline_complete: 41.5,
      actual_complete: 41.3,
      forecast_complete: 21.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-02-24",
      baseline_complete: 42.7,
      actual_complete: 41.3,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-03-03",
      baseline_complete: 44.1,
      actual_complete: 44.1,
      forecast_complete: 23.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-03-10",
      baseline_complete: 45.4,
      actual_complete: 45.7,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-03-17",
      baseline_complete: 46.7,
      actual_complete: 45.7,
      forecast_complete: 25.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-03-24",
      baseline_complete: 48.0,
      actual_complete: 45.7,
      forecast_complete: 26.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-03-31",
      baseline_complete: 49.4,
      actual_complete: 45.7,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-04-07",
      baseline_complete: 50.7,
      actual_complete: 47.8,
      forecast_complete: 27.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-04-14",
      baseline_complete: 52.0,
      actual_complete: 53.1,
      forecast_complete: 28.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-04-21",
      baseline_complete: 53.3,
      actual_complete: 53.4,
      forecast_complete: 29.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-04-28",
      baseline_complete: 54.7,
      actual_complete: 53.4,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-05-05",
      baseline_complete: 56.0,
      actual_complete: 54.4,
      forecast_complete: 31.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-05-12",
      baseline_complete: 57.3,
      actual_complete: 54.4,
      forecast_complete: 32.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-05-19",
      baseline_complete: 58.6,
      actual_complete: 62.2,
      forecast_complete: 33.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-05-26",
      baseline_complete: 59.9,
      actual_complete: 62.3,
      forecast_complete: 34.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-06-02",
      baseline_complete: 61.1,
      actual_complete: 62.3,
      forecast_complete: 35.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-06-09",
      baseline_complete: 62.4,
      actual_complete: 63.4,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-06-16",
      baseline_complete: 63.6,
      actual_complete: 63.4,
      forecast_complete: 37.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-06-23",
      baseline_complete: 64.9,
      actual_complete: 68.1,
      forecast_complete: 38.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-06-30",
      baseline_complete: 66.1,
      actual_complete: 68.1,
      forecast_complete: 39.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-07-07",
      baseline_complete: 67.2,
      actual_complete: 68.1,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-07-14",
      baseline_complete: 68.4,
      actual_complete: 68.1,
      forecast_complete: 41.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-07-21",
      baseline_complete: 69.5,
      actual_complete: 68.3,
      forecast_complete: 42.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-07-28",
      baseline_complete: 70.7,
      actual_complete: 71.3,
      forecast_complete: 43.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-08-04",
      baseline_complete: 71.7,
      actual_complete: 73.8,
      forecast_complete: 44.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-08-11",
      baseline_complete: 72.8,
      actual_complete: 75.4,
      forecast_complete: 45.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-08-18",
      baseline_complete: 73.9,
      actual_complete: 75.4,
      forecast_complete: 46.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-08-25",
      baseline_complete: 74.9,
      actual_complete: 75.4,
      forecast_complete: 47.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-09-01",
      baseline_complete: 75.9,
      actual_complete: 77.2,
      forecast_complete: 48.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-09-08",
      baseline_complete: 76.8,
      actual_complete: 77.2,
      forecast_complete: 49.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-09-15",
      baseline_complete: 77.8,
      actual_complete: 77.3,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-09-22",
      baseline_complete: 78.7,
      actual_complete: 78.9,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-09-29",
      baseline_complete: 79.5,
      actual_complete: 83.3,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-10-06",
      baseline_complete: 80.4,
      actual_complete: 83.3,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-10-13",
      baseline_complete: 81.2,
      actual_complete: 83.3,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-10-20",
      baseline_complete: 82.0,
      actual_complete: 83.3,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-10-27",
      baseline_complete: 82.8,
      actual_complete: 84.8,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-11-03",
      baseline_complete: 83.5,
      actual_complete: 84.8,
      forecast_complete: 57.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-11-10",
      baseline_complete: 84.3,
      actual_complete: 84.8,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-11-17",
      baseline_complete: 84.9,
      actual_complete: 86.4,
      forecast_complete: 59.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-11-24",
      baseline_complete: 85.6,
      actual_complete: 86.4,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-12-01",
      baseline_complete: 86.3,
      actual_complete: 89.0,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-12-08",
      baseline_complete: 86.9,
      actual_complete: 89.0,
      forecast_complete: 61.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-12-15",
      baseline_complete: 87.5,
      actual_complete: 89.0,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-12-22",
      baseline_complete: 88.0,
      actual_complete: 89.9,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2025-12-29",
      baseline_complete: 88.6,
      actual_complete: 89.9,
      forecast_complete: 64.4,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-01-05",
      baseline_complete: 89.1,
      actual_complete: 89.9,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-01-12",
      baseline_complete: 89.6,
      actual_complete: 90.2,
      forecast_complete: 66.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-01-19",
      baseline_complete: 90.1,
      actual_complete: 91.8,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-01-26",
      baseline_complete: 90.6,
      actual_complete: 91.8,
      forecast_complete: 67.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-02-02",
      baseline_complete: 91.0,
      actual_complete: 92.5,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-02-09",
      baseline_complete: 91.4,
      actual_complete: 92.5,
      forecast_complete: 69.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-02-16",
      baseline_complete: 91.9,
      actual_complete: 93.9,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-02-23",
      baseline_complete: 92.2,
      actual_complete: 95.7,
      forecast_complete: 70.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-03-02",
      baseline_complete: 92.6,
      actual_complete: 95.7,
      forecast_complete: 71.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-03-09",
      baseline_complete: 93.0,
      actual_complete: 95.7,
      forecast_complete: 72.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-03-16",
      baseline_complete: 93.3,
      actual_complete: 96.4,
      forecast_complete: 73.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-03-23",
      baseline_complete: 93.6,
      actual_complete: 96.4,
      forecast_complete: 74.4,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-03-30",
      baseline_complete: 93.9,
      actual_complete: 96.4,
      forecast_complete: 75.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-04-06",
      baseline_complete: 94.2,
      actual_complete: 97.7,
      forecast_complete: 77.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-04-13",
      baseline_complete: 94.5,
      actual_complete: 98.5,
      forecast_complete: 78.4,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-04-20",
      baseline_complete: 94.8,
      actual_complete: 98.5,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-04-27",
      baseline_complete: 95.0,
      actual_complete: 98.5,
      forecast_complete: 80.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-05-04",
      baseline_complete: 95.3,
      actual_complete: 98.5,
      forecast_complete: 82.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-05-11",
      baseline_complete: 95.5,
      actual_complete: 98.5,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-05-18",
      baseline_complete: 95.7,
      actual_complete: 98.5,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-05-25",
      baseline_complete: 96.0,
      actual_complete: 98.5,
      forecast_complete: 85.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-06-01",
      baseline_complete: 96.2,
      actual_complete: 99.7,
      forecast_complete: 86.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-06-08",
      baseline_complete: 96.4,
      actual_complete: 99.7,
      forecast_complete: 87.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-06-15",
      baseline_complete: 96.5,
      actual_complete: 99.7,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-06-22",
      baseline_complete: 96.7,
      actual_complete: 99.7,
      forecast_complete: 89.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-06-29",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-07-06",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-07-13",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-07-20",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-07-27",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-08-03",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-08-10",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-08-17",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-08-24",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-08-31",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-09-07",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-09-14",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-09-21",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-09-28",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-10-05",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-10-12",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-10-19",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-10-26",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-11-02",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-11-09",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-11-16",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-11-23",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-11-30",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-12-07",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-12-14",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-12-21",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2026-12-28",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2027-01-04",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2027-01-11",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2027-01-18",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2027-01-25",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "54f20686-b8f7-7639-9a51-7df3f54dcf6b",
      reporting_date: "2027-01-31",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "514c56bc-9f55-e5e3-fc2c-23a26c874435": [
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-10-01",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-10-08",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-10-15",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-10-22",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-10-29",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-11-05",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-11-12",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-11-19",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-11-26",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-12-03",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-12-10",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-12-17",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-12-24",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2023-12-31",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-01-07",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-01-14",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-01-21",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-01-28",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-02-04",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-02-11",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-02-18",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-02-25",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-03-03",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-03-10",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-03-17",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-03-24",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-03-31",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-04-07",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-04-14",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-04-21",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-04-28",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-05-05",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-05-12",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-05-19",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-05-26",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-06-02",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-06-09",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-06-16",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-06-23",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-06-30",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-07-07",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-07-14",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-07-21",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-07-28",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-08-04",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-08-11",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-08-18",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-08-25",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-09-01",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-09-08",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-09-15",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-09-22",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-09-29",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-10-06",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-10-13",
      baseline_complete: 4.1,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-10-20",
      baseline_complete: 4.4,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-10-27",
      baseline_complete: 4.7,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-11-03",
      baseline_complete: 5.1,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-11-10",
      baseline_complete: 5.4,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-11-17",
      baseline_complete: 5.8,
      actual_complete: 0.6,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-11-24",
      baseline_complete: 6.2,
      actual_complete: 0.6,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-12-01",
      baseline_complete: 6.6,
      actual_complete: 0.6,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-12-08",
      baseline_complete: 7.1,
      actual_complete: 0.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-12-15",
      baseline_complete: 7.6,
      actual_complete: 1.3,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-12-22",
      baseline_complete: 8.1,
      actual_complete: 1.3,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2024-12-29",
      baseline_complete: 8.6,
      actual_complete: 4.3,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-01-05",
      baseline_complete: 9.2,
      actual_complete: 4.3,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-01-12",
      baseline_complete: 9.8,
      actual_complete: 5.3,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-01-19",
      baseline_complete: 10.5,
      actual_complete: 5.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-01-26",
      baseline_complete: 11.1,
      actual_complete: 5.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-02-02",
      baseline_complete: 11.9,
      actual_complete: 7.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-02-09",
      baseline_complete: 12.6,
      actual_complete: 8.5,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-02-16",
      baseline_complete: 13.4,
      actual_complete: 9.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-02-23",
      baseline_complete: 14.3,
      actual_complete: 9.4,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-03-02",
      baseline_complete: 15.2,
      actual_complete: 11.4,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-03-09",
      baseline_complete: 16.1,
      actual_complete: 11.4,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-03-16",
      baseline_complete: 17.1,
      actual_complete: 13.2,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-03-23",
      baseline_complete: 18.1,
      actual_complete: 13.2,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-03-30",
      baseline_complete: 19.2,
      actual_complete: 14.4,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-04-06",
      baseline_complete: 20.4,
      actual_complete: 16.2,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-04-13",
      baseline_complete: 21.5,
      actual_complete: 17.9,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-04-20",
      baseline_complete: 22.8,
      actual_complete: 18.2,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-04-27",
      baseline_complete: 24.0,
      actual_complete: 18.2,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-05-04",
      baseline_complete: 25.4,
      actual_complete: 19.7,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-05-11",
      baseline_complete: 26.7,
      actual_complete: 23.0,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-05-18",
      baseline_complete: 28.2,
      actual_complete: 24.4,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-05-25",
      baseline_complete: 29.6,
      actual_complete: 24.9,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-06-01",
      baseline_complete: 31.1,
      actual_complete: 27.1,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-06-08",
      baseline_complete: 32.7,
      actual_complete: 27.1,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-06-15",
      baseline_complete: 34.3,
      actual_complete: 30.4,
      forecast_complete: 16.8,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-06-22",
      baseline_complete: 35.9,
      actual_complete: 31.6,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-06-29",
      baseline_complete: 37.5,
      actual_complete: 31.7,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-07-06",
      baseline_complete: 39.2,
      actual_complete: 35.7,
      forecast_complete: 19.9,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-07-13",
      baseline_complete: 40.9,
      actual_complete: 37.3,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-07-20",
      baseline_complete: 42.6,
      actual_complete: 40.0,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-07-27",
      baseline_complete: 44.4,
      actual_complete: 40.0,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-08-03",
      baseline_complete: 46.2,
      actual_complete: 42.3,
      forecast_complete: 24.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-08-10",
      baseline_complete: 47.9,
      actual_complete: 43.2,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-08-17",
      baseline_complete: 49.7,
      actual_complete: 48.1,
      forecast_complete: 26.9,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-08-24",
      baseline_complete: 51.5,
      actual_complete: 48.1,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-08-31",
      baseline_complete: 53.3,
      actual_complete: 51.4,
      forecast_complete: 29.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-09-07",
      baseline_complete: 55.0,
      actual_complete: 52.1,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-09-14",
      baseline_complete: 56.8,
      actual_complete: 53.9,
      forecast_complete: 32.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-09-21",
      baseline_complete: 58.5,
      actual_complete: 55.9,
      forecast_complete: 33.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-09-28",
      baseline_complete: 60.2,
      actual_complete: 57.2,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-10-05",
      baseline_complete: 61.9,
      actual_complete: 58.5,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-10-12",
      baseline_complete: 63.6,
      actual_complete: 59.6,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-10-19",
      baseline_complete: 65.2,
      actual_complete: 63.9,
      forecast_complete: 38.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-10-26",
      baseline_complete: 66.8,
      actual_complete: 63.9,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-11-02",
      baseline_complete: 68.4,
      actual_complete: 66.2,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-11-09",
      baseline_complete: 69.9,
      actual_complete: 66.2,
      forecast_complete: 42.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-11-16",
      baseline_complete: 71.4,
      actual_complete: 69.2,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-11-23",
      baseline_complete: 72.8,
      actual_complete: 70.5,
      forecast_complete: 45.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-11-30",
      baseline_complete: 74.2,
      actual_complete: 71.4,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-12-07",
      baseline_complete: 75.5,
      actual_complete: 72.5,
      forecast_complete: 47.8,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-12-14",
      baseline_complete: 76.8,
      actual_complete: 74.8,
      forecast_complete: 49.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-12-21",
      baseline_complete: 78.1,
      actual_complete: 75.6,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2025-12-28",
      baseline_complete: 79.3,
      actual_complete: 77.7,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-01-04",
      baseline_complete: 80.4,
      actual_complete: 79.1,
      forecast_complete: 52.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-01-11",
      baseline_complete: 81.5,
      actual_complete: 79.1,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-01-18",
      baseline_complete: 82.6,
      actual_complete: 79.5,
      forecast_complete: 55.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-01-25",
      baseline_complete: 83.6,
      actual_complete: 80.7,
      forecast_complete: 56.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-02-01",
      baseline_complete: 84.5,
      actual_complete: 81.5,
      forecast_complete: 57.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-02-08",
      baseline_complete: 85.4,
      actual_complete: 83.6,
      forecast_complete: 58.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-02-15",
      baseline_complete: 86.3,
      actual_complete: 83.6,
      forecast_complete: 59.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-02-22",
      baseline_complete: 87.1,
      actual_complete: 85.6,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-03-01",
      baseline_complete: 87.9,
      actual_complete: 87.3,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-03-08",
      baseline_complete: 88.6,
      actual_complete: 87.5,
      forecast_complete: 62.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-03-15",
      baseline_complete: 89.3,
      actual_complete: 87.5,
      forecast_complete: 63.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-03-22",
      baseline_complete: 90.0,
      actual_complete: 87.5,
      forecast_complete: 64.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-03-29",
      baseline_complete: 90.6,
      actual_complete: 90.7,
      forecast_complete: 65.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-04-05",
      baseline_complete: 91.2,
      actual_complete: 90.7,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-04-12",
      baseline_complete: 91.8,
      actual_complete: 92.0,
      forecast_complete: 67.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-04-19",
      baseline_complete: 92.3,
      actual_complete: 92.0,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-04-26",
      baseline_complete: 92.8,
      actual_complete: 92.0,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-05-03",
      baseline_complete: 93.2,
      actual_complete: 92.2,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-05-10",
      baseline_complete: 93.7,
      actual_complete: 92.9,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-05-17",
      baseline_complete: 94.1,
      actual_complete: 92.9,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-05-24",
      baseline_complete: 94.5,
      actual_complete: 94.0,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-05-31",
      baseline_complete: 94.8,
      actual_complete: 94.0,
      forecast_complete: 76.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-06-07",
      baseline_complete: 95.2,
      actual_complete: 95.7,
      forecast_complete: 77.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-06-14",
      baseline_complete: 95.5,
      actual_complete: 95.7,
      forecast_complete: 78.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-06-21",
      baseline_complete: 95.8,
      actual_complete: 96.8,
      forecast_complete: 79.9,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-06-28",
      baseline_complete: 96.1,
      actual_complete: 96.8,
      forecast_complete: 81.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-07-05",
      baseline_complete: 96.3,
      actual_complete: 96.8,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-07-12",
      baseline_complete: 96.6,
      actual_complete: 96.8,
      forecast_complete: 83.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-07-19",
      baseline_complete: 96.8,
      actual_complete: 96.8,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-07-26",
      baseline_complete: 97.0,
      actual_complete: 96.8,
      forecast_complete: 85.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-08-02",
      baseline_complete: 97.2,
      actual_complete: 97.0,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-08-09",
      baseline_complete: 97.4,
      actual_complete: 97.0,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-08-16",
      baseline_complete: 97.6,
      actual_complete: 97.0,
      forecast_complete: 87.9,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-08-23",
      baseline_complete: 97.7,
      actual_complete: 97.9,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-08-30",
      baseline_complete: 97.9,
      actual_complete: 98.1,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-09-06",
      baseline_complete: 98.0,
      actual_complete: 98.1,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-09-13",
      baseline_complete: 98.2,
      actual_complete: 98.1,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-09-20",
      baseline_complete: 98.3,
      actual_complete: 98.1,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-09-27",
      baseline_complete: 98.4,
      actual_complete: 98.1,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-10-04",
      baseline_complete: 98.5,
      actual_complete: 99.2,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-10-11",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-10-18",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-10-25",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-11-01",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-11-08",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-11-15",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-11-22",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-11-29",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-12-06",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-12-13",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-12-20",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2026-12-27",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2027-01-03",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2027-01-10",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2027-01-17",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2027-01-24",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2027-01-31",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2027-02-07",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2027-02-14",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2027-02-21",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2027-02-28",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "514c56bc-9f55-e5e3-fc2c-23a26c874435",
      reporting_date: "2027-03-01",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
  ],
  "3ecccb69-0c52-22e2-29c0-c3ef99050062": [
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2023-12-24",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2023-12-31",
      baseline_complete: 1.0,
      actual_complete: 3.4,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-01-07",
      baseline_complete: 1.1,
      actual_complete: 3.4,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-01-14",
      baseline_complete: 1.2,
      actual_complete: 3.4,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-01-21",
      baseline_complete: 1.2,
      actual_complete: 3.4,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-01-28",
      baseline_complete: 1.3,
      actual_complete: 3.4,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-02-04",
      baseline_complete: 1.3,
      actual_complete: 3.4,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-02-11",
      baseline_complete: 1.4,
      actual_complete: 4.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-02-18",
      baseline_complete: 1.5,
      actual_complete: 4.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-02-25",
      baseline_complete: 1.5,
      actual_complete: 4.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-03-03",
      baseline_complete: 1.6,
      actual_complete: 4.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-03-10",
      baseline_complete: 1.7,
      actual_complete: 4.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-03-17",
      baseline_complete: 1.8,
      actual_complete: 4.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-03-24",
      baseline_complete: 1.9,
      actual_complete: 4.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-03-31",
      baseline_complete: 2.0,
      actual_complete: 4.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-04-07",
      baseline_complete: 2.0,
      actual_complete: 4.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-04-14",
      baseline_complete: 2.1,
      actual_complete: 4.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-04-21",
      baseline_complete: 2.2,
      actual_complete: 4.9,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-04-28",
      baseline_complete: 2.4,
      actual_complete: 4.9,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-05-05",
      baseline_complete: 2.5,
      actual_complete: 4.9,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-05-12",
      baseline_complete: 2.6,
      actual_complete: 4.9,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-05-19",
      baseline_complete: 2.7,
      actual_complete: 4.9,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-05-26",
      baseline_complete: 2.8,
      actual_complete: 4.9,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-06-02",
      baseline_complete: 3.0,
      actual_complete: 4.9,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-06-09",
      baseline_complete: 3.1,
      actual_complete: 4.9,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-06-16",
      baseline_complete: 3.3,
      actual_complete: 5.6,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-06-23",
      baseline_complete: 3.4,
      actual_complete: 5.6,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-06-30",
      baseline_complete: 3.6,
      actual_complete: 5.6,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-07-07",
      baseline_complete: 3.8,
      actual_complete: 5.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-07-14",
      baseline_complete: 4.0,
      actual_complete: 5.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-07-21",
      baseline_complete: 4.1,
      actual_complete: 5.6,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-07-28",
      baseline_complete: 4.3,
      actual_complete: 5.6,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-08-04",
      baseline_complete: 4.5,
      actual_complete: 7.3,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-08-11",
      baseline_complete: 4.8,
      actual_complete: 7.3,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-08-18",
      baseline_complete: 5.0,
      actual_complete: 7.3,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-08-25",
      baseline_complete: 5.2,
      actual_complete: 7.3,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-09-01",
      baseline_complete: 5.5,
      actual_complete: 7.3,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-09-08",
      baseline_complete: 5.7,
      actual_complete: 7.3,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-09-15",
      baseline_complete: 6.0,
      actual_complete: 7.3,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-09-22",
      baseline_complete: 6.3,
      actual_complete: 7.3,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-09-29",
      baseline_complete: 6.6,
      actual_complete: 7.3,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-10-06",
      baseline_complete: 6.9,
      actual_complete: 7.3,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-10-13",
      baseline_complete: 7.2,
      actual_complete: 10.6,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-10-20",
      baseline_complete: 7.5,
      actual_complete: 10.6,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-10-27",
      baseline_complete: 7.9,
      actual_complete: 11.1,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-11-03",
      baseline_complete: 8.2,
      actual_complete: 11.1,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-11-10",
      baseline_complete: 8.6,
      actual_complete: 11.1,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-11-17",
      baseline_complete: 9.0,
      actual_complete: 11.1,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-11-24",
      baseline_complete: 9.4,
      actual_complete: 11.1,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-12-01",
      baseline_complete: 9.8,
      actual_complete: 13.3,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-12-08",
      baseline_complete: 10.2,
      actual_complete: 13.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-12-15",
      baseline_complete: 10.7,
      actual_complete: 13.3,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-12-22",
      baseline_complete: 11.2,
      actual_complete: 13.3,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2024-12-29",
      baseline_complete: 11.6,
      actual_complete: 14.6,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-01-05",
      baseline_complete: 12.2,
      actual_complete: 14.6,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-01-12",
      baseline_complete: 12.7,
      actual_complete: 14.6,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-01-19",
      baseline_complete: 13.2,
      actual_complete: 14.6,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-01-26",
      baseline_complete: 13.8,
      actual_complete: 17.1,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-02-02",
      baseline_complete: 14.4,
      actual_complete: 17.1,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-02-09",
      baseline_complete: 15.0,
      actual_complete: 17.9,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-02-16",
      baseline_complete: 15.6,
      actual_complete: 17.9,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-02-23",
      baseline_complete: 16.3,
      actual_complete: 17.9,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-03-02",
      baseline_complete: 16.9,
      actual_complete: 17.9,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-03-09",
      baseline_complete: 17.6,
      actual_complete: 20.3,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-03-16",
      baseline_complete: 18.3,
      actual_complete: 20.3,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-03-23",
      baseline_complete: 19.1,
      actual_complete: 20.3,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-03-30",
      baseline_complete: 19.8,
      actual_complete: 22.8,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-04-06",
      baseline_complete: 20.6,
      actual_complete: 22.8,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-04-13",
      baseline_complete: 21.4,
      actual_complete: 24.7,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-04-20",
      baseline_complete: 22.3,
      actual_complete: 24.7,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-04-27",
      baseline_complete: 23.1,
      actual_complete: 24.7,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-05-04",
      baseline_complete: 24.0,
      actual_complete: 27.4,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-05-11",
      baseline_complete: 24.9,
      actual_complete: 27.4,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-05-18",
      baseline_complete: 25.8,
      actual_complete: 27.4,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-05-25",
      baseline_complete: 26.7,
      actual_complete: 27.4,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-06-01",
      baseline_complete: 27.7,
      actual_complete: 27.4,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-06-08",
      baseline_complete: 28.7,
      actual_complete: 31.0,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-06-15",
      baseline_complete: 29.7,
      actual_complete: 31.0,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-06-22",
      baseline_complete: 30.7,
      actual_complete: 31.0,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-06-29",
      baseline_complete: 31.7,
      actual_complete: 31.0,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-07-06",
      baseline_complete: 32.8,
      actual_complete: 36.2,
      forecast_complete: 16.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-07-13",
      baseline_complete: 33.9,
      actual_complete: 36.2,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-07-20",
      baseline_complete: 35.0,
      actual_complete: 36.2,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-07-27",
      baseline_complete: 36.1,
      actual_complete: 39.2,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-08-03",
      baseline_complete: 37.2,
      actual_complete: 41.0,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-08-10",
      baseline_complete: 38.4,
      actual_complete: 41.0,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-08-17",
      baseline_complete: 39.5,
      actual_complete: 41.0,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-08-24",
      baseline_complete: 40.7,
      actual_complete: 41.0,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-08-31",
      baseline_complete: 41.8,
      actual_complete: 41.0,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-09-07",
      baseline_complete: 43.0,
      actual_complete: 46.3,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-09-14",
      baseline_complete: 44.2,
      actual_complete: 46.3,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-09-21",
      baseline_complete: 45.4,
      actual_complete: 48.5,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-09-28",
      baseline_complete: 46.6,
      actual_complete: 48.5,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-10-05",
      baseline_complete: 47.8,
      actual_complete: 48.5,
      forecast_complete: 24.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-10-12",
      baseline_complete: 49.0,
      actual_complete: 48.5,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-10-19",
      baseline_complete: 50.3,
      actual_complete: 53.3,
      forecast_complete: 26.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-10-26",
      baseline_complete: 51.5,
      actual_complete: 53.3,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-11-02",
      baseline_complete: 52.7,
      actual_complete: 53.3,
      forecast_complete: 27.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-11-09",
      baseline_complete: 53.9,
      actual_complete: 56.7,
      forecast_complete: 28.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-11-16",
      baseline_complete: 55.1,
      actual_complete: 56.7,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-11-23",
      baseline_complete: 56.3,
      actual_complete: 58.4,
      forecast_complete: 30.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-11-30",
      baseline_complete: 57.5,
      actual_complete: 60.5,
      forecast_complete: 31.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-12-07",
      baseline_complete: 58.7,
      actual_complete: 60.5,
      forecast_complete: 31.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-12-14",
      baseline_complete: 59.8,
      actual_complete: 61.2,
      forecast_complete: 32.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-12-21",
      baseline_complete: 61.0,
      actual_complete: 61.2,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2025-12-28",
      baseline_complete: 62.1,
      actual_complete: 61.3,
      forecast_complete: 34.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-01-04",
      baseline_complete: 63.3,
      actual_complete: 62.8,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-01-11",
      baseline_complete: 64.4,
      actual_complete: 62.9,
      forecast_complete: 36.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-01-18",
      baseline_complete: 65.5,
      actual_complete: 65.7,
      forecast_complete: 36.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-01-25",
      baseline_complete: 66.6,
      actual_complete: 69.0,
      forecast_complete: 37.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-02-01",
      baseline_complete: 67.6,
      actual_complete: 69.0,
      forecast_complete: 38.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-02-08",
      baseline_complete: 68.7,
      actual_complete: 69.8,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-02-15",
      baseline_complete: 69.7,
      actual_complete: 69.8,
      forecast_complete: 40.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-02-22",
      baseline_complete: 70.7,
      actual_complete: 71.0,
      forecast_complete: 41.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-03-01",
      baseline_complete: 71.7,
      actual_complete: 73.8,
      forecast_complete: 42.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-03-08",
      baseline_complete: 72.7,
      actual_complete: 73.8,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-03-15",
      baseline_complete: 73.7,
      actual_complete: 74.6,
      forecast_complete: 43.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-03-22",
      baseline_complete: 74.6,
      actual_complete: 74.6,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-03-29",
      baseline_complete: 75.5,
      actual_complete: 77.2,
      forecast_complete: 45.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-04-05",
      baseline_complete: 76.4,
      actual_complete: 77.2,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-04-12",
      baseline_complete: 77.2,
      actual_complete: 80.1,
      forecast_complete: 47.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-04-19",
      baseline_complete: 78.1,
      actual_complete: 80.1,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-04-26",
      baseline_complete: 78.9,
      actual_complete: 80.3,
      forecast_complete: 48.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-05-03",
      baseline_complete: 79.7,
      actual_complete: 80.3,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-05-10",
      baseline_complete: 80.5,
      actual_complete: 84.5,
      forecast_complete: 50.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-05-17",
      baseline_complete: 81.2,
      actual_complete: 84.5,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-05-24",
      baseline_complete: 82.0,
      actual_complete: 84.6,
      forecast_complete: 52.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-05-31",
      baseline_complete: 82.7,
      actual_complete: 85.0,
      forecast_complete: 53.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-06-07",
      baseline_complete: 83.3,
      actual_complete: 85.0,
      forecast_complete: 53.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-06-14",
      baseline_complete: 84.0,
      actual_complete: 86.9,
      forecast_complete: 54.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-06-21",
      baseline_complete: 84.6,
      actual_complete: 88.6,
      forecast_complete: 55.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-06-28",
      baseline_complete: 85.3,
      actual_complete: 88.6,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-07-05",
      baseline_complete: 85.9,
      actual_complete: 88.6,
      forecast_complete: 56.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-07-12",
      baseline_complete: 86.4,
      actual_complete: 88.6,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-07-19",
      baseline_complete: 87.0,
      actual_complete: 88.6,
      forecast_complete: 58.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-07-26",
      baseline_complete: 87.5,
      actual_complete: 88.6,
      forecast_complete: 59.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-08-02",
      baseline_complete: 88.1,
      actual_complete: 89.0,
      forecast_complete: 59.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-08-09",
      baseline_complete: 88.6,
      actual_complete: 91.6,
      forecast_complete: 60.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-08-16",
      baseline_complete: 89.0,
      actual_complete: 91.6,
      forecast_complete: 61.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-08-23",
      baseline_complete: 89.5,
      actual_complete: 91.6,
      forecast_complete: 62.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-08-30",
      baseline_complete: 90.0,
      actual_complete: 91.6,
      forecast_complete: 62.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-09-06",
      baseline_complete: 90.4,
      actual_complete: 91.6,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-09-13",
      baseline_complete: 90.8,
      actual_complete: 92.7,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-09-20",
      baseline_complete: 91.2,
      actual_complete: 93.1,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-09-27",
      baseline_complete: 91.6,
      actual_complete: 93.1,
      forecast_complete: 65.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-10-04",
      baseline_complete: 91.9,
      actual_complete: 93.1,
      forecast_complete: 66.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-10-11",
      baseline_complete: 92.3,
      actual_complete: 93.1,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-10-18",
      baseline_complete: 92.6,
      actual_complete: 95.8,
      forecast_complete: 67.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-10-25",
      baseline_complete: 93.0,
      actual_complete: 97.1,
      forecast_complete: 68.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-11-01",
      baseline_complete: 93.3,
      actual_complete: 97.1,
      forecast_complete: 68.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-11-08",
      baseline_complete: 93.6,
      actual_complete: 97.1,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-11-15",
      baseline_complete: 93.9,
      actual_complete: 97.1,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-11-22",
      baseline_complete: 94.1,
      actual_complete: 97.1,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-11-29",
      baseline_complete: 94.4,
      actual_complete: 97.1,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-12-06",
      baseline_complete: 94.6,
      actual_complete: 97.1,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-12-13",
      baseline_complete: 94.9,
      actual_complete: 97.6,
      forecast_complete: 72.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-12-20",
      baseline_complete: 95.1,
      actual_complete: 97.6,
      forecast_complete: 73.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2026-12-27",
      baseline_complete: 95.3,
      actual_complete: 97.6,
      forecast_complete: 73.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-01-03",
      baseline_complete: 95.5,
      actual_complete: 97.8,
      forecast_complete: 74.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-01-10",
      baseline_complete: 95.7,
      actual_complete: 97.8,
      forecast_complete: 75.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-01-17",
      baseline_complete: 95.9,
      actual_complete: 98.4,
      forecast_complete: 75.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-01-24",
      baseline_complete: 96.1,
      actual_complete: 98.4,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-01-31",
      baseline_complete: 96.3,
      actual_complete: 98.4,
      forecast_complete: 77.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-02-07",
      baseline_complete: 96.5,
      actual_complete: 98.4,
      forecast_complete: 78.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-02-14",
      baseline_complete: 96.6,
      actual_complete: 98.4,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-02-21",
      baseline_complete: 96.8,
      actual_complete: 99.1,
      forecast_complete: 80.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-02-28",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 81.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-03-07",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-03-14",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 83.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-03-21",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-03-28",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 85.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-04-04",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-04-11",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-04-18",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 87.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-04-25",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-05-02",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-05-09",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-05-16",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-05-23",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-05-30",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-06-06",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-06-13",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-06-20",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-06-27",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-07-04",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-07-11",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-07-18",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-07-25",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-08-01",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-08-08",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-08-15",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-08-22",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-08-29",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-09-05",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-09-12",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-09-19",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-09-26",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-10-03",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-10-10",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-10-17",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-10-24",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-10-31",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-11-07",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-11-14",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-11-21",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-11-28",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-12-05",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-12-12",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-12-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2027-12-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2028-01-02",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2028-01-09",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2028-01-16",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2028-01-23",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3ecccb69-0c52-22e2-29c0-c3ef99050062",
      reporting_date: "2028-01-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "b4731b43-6916-680b-7703-d4d6cbdd6ec3": [
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-06-08",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-06-15",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-06-22",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-06-29",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-07-06",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-07-13",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-07-20",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-07-27",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-08-03",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-08-10",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-08-17",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-08-24",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-08-31",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-09-07",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-09-14",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-09-21",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-09-28",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-10-05",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-10-12",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-10-19",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-10-26",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-11-02",
      baseline_complete: 1.1,
      actual_complete: 0.6,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-11-09",
      baseline_complete: 1.2,
      actual_complete: 0.6,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-11-16",
      baseline_complete: 1.4,
      actual_complete: 0.6,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-11-23",
      baseline_complete: 1.6,
      actual_complete: 0.6,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-11-30",
      baseline_complete: 1.8,
      actual_complete: 1.2,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-12-07",
      baseline_complete: 2.0,
      actual_complete: 1.2,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-12-14",
      baseline_complete: 2.3,
      actual_complete: 1.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-12-21",
      baseline_complete: 2.6,
      actual_complete: 1.2,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2024-12-28",
      baseline_complete: 2.9,
      actual_complete: 1.2,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-01-04",
      baseline_complete: 3.2,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-01-11",
      baseline_complete: 3.7,
      actual_complete: 1.2,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-01-18",
      baseline_complete: 4.1,
      actual_complete: 4.2,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-01-25",
      baseline_complete: 4.6,
      actual_complete: 5.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-02-01",
      baseline_complete: 5.2,
      actual_complete: 6.4,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-02-08",
      baseline_complete: 5.9,
      actual_complete: 6.4,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-02-15",
      baseline_complete: 6.6,
      actual_complete: 6.4,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-02-22",
      baseline_complete: 7.4,
      actual_complete: 8.6,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-03-01",
      baseline_complete: 8.3,
      actual_complete: 8.6,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-03-08",
      baseline_complete: 9.3,
      actual_complete: 8.6,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-03-15",
      baseline_complete: 10.4,
      actual_complete: 10.5,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-03-22",
      baseline_complete: 11.6,
      actual_complete: 10.5,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-03-29",
      baseline_complete: 12.9,
      actual_complete: 13.1,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-04-05",
      baseline_complete: 14.3,
      actual_complete: 14.6,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-04-12",
      baseline_complete: 15.9,
      actual_complete: 16.4,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-04-19",
      baseline_complete: 17.6,
      actual_complete: 16.4,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-04-26",
      baseline_complete: 19.5,
      actual_complete: 17.1,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-05-03",
      baseline_complete: 21.5,
      actual_complete: 21.3,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-05-10",
      baseline_complete: 23.7,
      actual_complete: 21.3,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-05-17",
      baseline_complete: 26.0,
      actual_complete: 26.9,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-05-24",
      baseline_complete: 28.4,
      actual_complete: 28.5,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-05-31",
      baseline_complete: 31.0,
      actual_complete: 28.5,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-06-07",
      baseline_complete: 33.7,
      actual_complete: 30.6,
      forecast_complete: 16.9,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-06-14",
      baseline_complete: 36.5,
      actual_complete: 33.2,
      forecast_complete: 18.6,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-06-21",
      baseline_complete: 39.5,
      actual_complete: 38.1,
      forecast_complete: 20.5,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-06-28",
      baseline_complete: 42.4,
      actual_complete: 39.6,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-07-05",
      baseline_complete: 45.5,
      actual_complete: 45.9,
      forecast_complete: 24.5,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-07-12",
      baseline_complete: 48.6,
      actual_complete: 49.7,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-07-19",
      baseline_complete: 51.7,
      actual_complete: 49.7,
      forecast_complete: 28.8,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-07-26",
      baseline_complete: 54.7,
      actual_complete: 56.7,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-08-02",
      baseline_complete: 57.8,
      actual_complete: 59.8,
      forecast_complete: 33.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-08-09",
      baseline_complete: 60.8,
      actual_complete: 59.8,
      forecast_complete: 35.5,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-08-16",
      baseline_complete: 63.7,
      actual_complete: 62.4,
      forecast_complete: 37.8,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-08-23",
      baseline_complete: 66.5,
      actual_complete: 69.2,
      forecast_complete: 40.1,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-08-30",
      baseline_complete: 69.2,
      actual_complete: 69.2,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-09-06",
      baseline_complete: 71.7,
      actual_complete: 70.2,
      forecast_complete: 44.6,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-09-13",
      baseline_complete: 74.2,
      actual_complete: 74.6,
      forecast_complete: 46.8,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-09-20",
      baseline_complete: 76.5,
      actual_complete: 74.6,
      forecast_complete: 49.0,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-09-27",
      baseline_complete: 78.6,
      actual_complete: 74.6,
      forecast_complete: 51.1,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-10-04",
      baseline_complete: 80.6,
      actual_complete: 79.9,
      forecast_complete: 53.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-10-11",
      baseline_complete: 82.5,
      actual_complete: 79.9,
      forecast_complete: 55.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-10-18",
      baseline_complete: 84.2,
      actual_complete: 79.9,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-10-25",
      baseline_complete: 85.8,
      actual_complete: 84.9,
      forecast_complete: 59.0,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-11-01",
      baseline_complete: 87.2,
      actual_complete: 86.9,
      forecast_complete: 60.8,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-11-08",
      baseline_complete: 88.5,
      actual_complete: 90.0,
      forecast_complete: 62.6,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-11-15",
      baseline_complete: 89.7,
      actual_complete: 91.2,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-11-22",
      baseline_complete: 90.8,
      actual_complete: 91.2,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-11-29",
      baseline_complete: 91.8,
      actual_complete: 94.5,
      forecast_complete: 67.5,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-12-06",
      baseline_complete: 92.7,
      actual_complete: 94.5,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-12-13",
      baseline_complete: 93.5,
      actual_complete: 95.5,
      forecast_complete: 70.8,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-12-20",
      baseline_complete: 94.2,
      actual_complete: 95.5,
      forecast_complete: 73.3,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2025-12-27",
      baseline_complete: 94.8,
      actual_complete: 99.9,
      forecast_complete: 75.6,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-01-03",
      baseline_complete: 95.4,
      actual_complete: 99.9,
      forecast_complete: 77.9,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-01-10",
      baseline_complete: 95.9,
      actual_complete: 99.9,
      forecast_complete: 79.9,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-01-17",
      baseline_complete: 96.4,
      actual_complete: 99.9,
      forecast_complete: 81.9,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-01-24",
      baseline_complete: 96.8,
      actual_complete: 99.9,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-01-31",
      baseline_complete: 97.1,
      actual_complete: 99.9,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-02-07",
      baseline_complete: 97.5,
      actual_complete: 99.9,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-02-14",
      baseline_complete: 97.8,
      actual_complete: 99.9,
      forecast_complete: 88.5,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-02-21",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-02-28",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-03-07",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-03-14",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-03-21",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-03-28",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-04-04",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-04-11",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-04-18",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-04-25",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-05-02",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-05-09",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-05-16",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-05-23",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-05-30",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-06-06",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b4731b43-6916-680b-7703-d4d6cbdd6ec3",
      reporting_date: "2026-06-08",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "09758415-c112-23a3-e351-0a962d07e9bf": [
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-04-21",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-04-28",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-05-05",
      baseline_complete: 0.5,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-05-12",
      baseline_complete: 0.5,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-05-19",
      baseline_complete: 0.6,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-05-26",
      baseline_complete: 0.6,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-06-02",
      baseline_complete: 0.6,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-06-09",
      baseline_complete: 0.7,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-06-16",
      baseline_complete: 0.7,
      actual_complete: 1.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-06-23",
      baseline_complete: 0.8,
      actual_complete: 1.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-06-30",
      baseline_complete: 0.8,
      actual_complete: 1.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-07-07",
      baseline_complete: 0.9,
      actual_complete: 1.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-07-14",
      baseline_complete: 0.9,
      actual_complete: 1.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-07-21",
      baseline_complete: 1.0,
      actual_complete: 1.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-07-28",
      baseline_complete: 1.0,
      actual_complete: 1.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-08-04",
      baseline_complete: 1.1,
      actual_complete: 1.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-08-11",
      baseline_complete: 1.1,
      actual_complete: 1.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-08-18",
      baseline_complete: 1.2,
      actual_complete: 1.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-08-25",
      baseline_complete: 1.3,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-09-01",
      baseline_complete: 1.3,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-09-08",
      baseline_complete: 1.4,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-09-15",
      baseline_complete: 1.5,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-09-22",
      baseline_complete: 1.6,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-09-29",
      baseline_complete: 1.7,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-10-06",
      baseline_complete: 1.8,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-10-13",
      baseline_complete: 1.9,
      actual_complete: 2.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-10-20",
      baseline_complete: 2.0,
      actual_complete: 2.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-10-27",
      baseline_complete: 2.1,
      actual_complete: 3.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-11-03",
      baseline_complete: 2.2,
      actual_complete: 3.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-11-10",
      baseline_complete: 2.3,
      actual_complete: 3.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-11-17",
      baseline_complete: 2.5,
      actual_complete: 3.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-11-24",
      baseline_complete: 2.6,
      actual_complete: 3.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-12-01",
      baseline_complete: 2.7,
      actual_complete: 3.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-12-08",
      baseline_complete: 2.9,
      actual_complete: 3.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-12-15",
      baseline_complete: 3.1,
      actual_complete: 3.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-12-22",
      baseline_complete: 3.2,
      actual_complete: 3.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2025-12-29",
      baseline_complete: 3.4,
      actual_complete: 3.6,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-01-05",
      baseline_complete: 3.6,
      actual_complete: 3.6,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-01-12",
      baseline_complete: 3.8,
      actual_complete: 5.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-01-19",
      baseline_complete: 4.0,
      actual_complete: 5.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-01-26",
      baseline_complete: 4.2,
      actual_complete: 5.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-02-02",
      baseline_complete: 4.5,
      actual_complete: 5.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-02-09",
      baseline_complete: 4.7,
      actual_complete: 5.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-02-16",
      baseline_complete: 5.0,
      actual_complete: 5.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-02-23",
      baseline_complete: 5.3,
      actual_complete: 5.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-03-02",
      baseline_complete: 5.6,
      actual_complete: 5.5,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-03-09",
      baseline_complete: 5.9,
      actual_complete: 7.3,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-03-16",
      baseline_complete: 6.2,
      actual_complete: 7.3,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-03-23",
      baseline_complete: 6.5,
      actual_complete: 7.3,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-03-30",
      baseline_complete: 6.9,
      actual_complete: 7.3,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-04-06",
      baseline_complete: 7.3,
      actual_complete: 8.5,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-04-13",
      baseline_complete: 7.6,
      actual_complete: 8.5,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-04-20",
      baseline_complete: 8.1,
      actual_complete: 8.9,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-04-27",
      baseline_complete: 8.5,
      actual_complete: 9.5,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-05-04",
      baseline_complete: 8.9,
      actual_complete: 9.5,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-05-11",
      baseline_complete: 9.4,
      actual_complete: 9.5,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-05-18",
      baseline_complete: 9.9,
      actual_complete: 10.4,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-05-25",
      baseline_complete: 10.4,
      actual_complete: 10.4,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-06-01",
      baseline_complete: 11.0,
      actual_complete: 11.6,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-06-08",
      baseline_complete: 11.5,
      actual_complete: 11.6,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-06-15",
      baseline_complete: 12.1,
      actual_complete: 11.6,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-06-22",
      baseline_complete: 12.7,
      actual_complete: 12.2,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-06-29",
      baseline_complete: 13.4,
      actual_complete: 15.1,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-07-06",
      baseline_complete: 14.0,
      actual_complete: 15.1,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-07-13",
      baseline_complete: 14.7,
      actual_complete: 15.1,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-07-20",
      baseline_complete: 15.5,
      actual_complete: 15.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-07-27",
      baseline_complete: 16.2,
      actual_complete: 15.6,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-08-03",
      baseline_complete: 17.0,
      actual_complete: 15.6,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-08-10",
      baseline_complete: 17.8,
      actual_complete: 15.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-08-17",
      baseline_complete: 18.7,
      actual_complete: 18.7,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-08-24",
      baseline_complete: 19.5,
      actual_complete: 20.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-08-31",
      baseline_complete: 20.5,
      actual_complete: 20.9,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-09-07",
      baseline_complete: 21.4,
      actual_complete: 21.1,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-09-14",
      baseline_complete: 22.4,
      actual_complete: 23.7,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-09-21",
      baseline_complete: 23.4,
      actual_complete: 23.7,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-09-28",
      baseline_complete: 24.4,
      actual_complete: 23.7,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-10-05",
      baseline_complete: 25.4,
      actual_complete: 26.4,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-10-12",
      baseline_complete: 26.5,
      actual_complete: 26.4,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-10-19",
      baseline_complete: 27.7,
      actual_complete: 29.7,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-10-26",
      baseline_complete: 28.8,
      actual_complete: 29.7,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-11-02",
      baseline_complete: 30.0,
      actual_complete: 30.8,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-11-09",
      baseline_complete: 31.2,
      actual_complete: 30.8,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-11-16",
      baseline_complete: 32.4,
      actual_complete: 32.4,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-11-23",
      baseline_complete: 33.7,
      actual_complete: 32.7,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-11-30",
      baseline_complete: 34.9,
      actual_complete: 32.9,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-12-07",
      baseline_complete: 36.2,
      actual_complete: 34.5,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-12-14",
      baseline_complete: 37.6,
      actual_complete: 37.2,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-12-21",
      baseline_complete: 38.9,
      actual_complete: 40.1,
      forecast_complete: 17.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2026-12-28",
      baseline_complete: 40.3,
      actual_complete: 40.1,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-01-04",
      baseline_complete: 41.6,
      actual_complete: 43.4,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-01-11",
      baseline_complete: 43.0,
      actual_complete: 43.4,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-01-18",
      baseline_complete: 44.4,
      actual_complete: 44.2,
      forecast_complete: 20.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-01-25",
      baseline_complete: 45.8,
      actual_complete: 45.6,
      forecast_complete: 21.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-02-01",
      baseline_complete: 47.2,
      actual_complete: 46.5,
      forecast_complete: 22.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-02-08",
      baseline_complete: 48.6,
      actual_complete: 49.8,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-02-15",
      baseline_complete: 50.0,
      actual_complete: 52.2,
      forecast_complete: 24.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-02-22",
      baseline_complete: 51.5,
      actual_complete: 52.2,
      forecast_complete: 25.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-03-01",
      baseline_complete: 52.9,
      actual_complete: 54.5,
      forecast_complete: 26.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-03-08",
      baseline_complete: 54.3,
      actual_complete: 55.2,
      forecast_complete: 27.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-03-15",
      baseline_complete: 55.7,
      actual_complete: 57.4,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-03-22",
      baseline_complete: 57.1,
      actual_complete: 58.5,
      forecast_complete: 29.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-03-29",
      baseline_complete: 58.5,
      actual_complete: 58.7,
      forecast_complete: 30.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-04-05",
      baseline_complete: 59.8,
      actual_complete: 60.4,
      forecast_complete: 31.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-04-12",
      baseline_complete: 61.2,
      actual_complete: 60.4,
      forecast_complete: 32.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-04-19",
      baseline_complete: 62.5,
      actual_complete: 63.1,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-04-26",
      baseline_complete: 63.8,
      actual_complete: 63.1,
      forecast_complete: 34.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-05-03",
      baseline_complete: 65.1,
      actual_complete: 66.0,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-05-10",
      baseline_complete: 66.4,
      actual_complete: 69.2,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-05-17",
      baseline_complete: 67.7,
      actual_complete: 69.2,
      forecast_complete: 37.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-05-24",
      baseline_complete: 68.9,
      actual_complete: 69.2,
      forecast_complete: 38.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-05-31",
      baseline_complete: 70.1,
      actual_complete: 71.4,
      forecast_complete: 39.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-06-07",
      baseline_complete: 71.3,
      actual_complete: 72.6,
      forecast_complete: 40.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-06-14",
      baseline_complete: 72.4,
      actual_complete: 73.9,
      forecast_complete: 41.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-06-21",
      baseline_complete: 73.5,
      actual_complete: 73.9,
      forecast_complete: 42.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-06-28",
      baseline_complete: 74.6,
      actual_complete: 74.0,
      forecast_complete: 43.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-07-05",
      baseline_complete: 75.7,
      actual_complete: 75.9,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-07-12",
      baseline_complete: 76.7,
      actual_complete: 77.4,
      forecast_complete: 45.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-07-19",
      baseline_complete: 77.7,
      actual_complete: 78.2,
      forecast_complete: 46.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-07-26",
      baseline_complete: 78.7,
      actual_complete: 80.1,
      forecast_complete: 47.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-08-02",
      baseline_complete: 79.6,
      actual_complete: 80.1,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-08-09",
      baseline_complete: 80.5,
      actual_complete: 80.1,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-08-16",
      baseline_complete: 81.4,
      actual_complete: 82.2,
      forecast_complete: 50.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-08-23",
      baseline_complete: 82.2,
      actual_complete: 82.6,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-08-30",
      baseline_complete: 83.0,
      actual_complete: 84.0,
      forecast_complete: 52.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-09-06",
      baseline_complete: 83.8,
      actual_complete: 84.3,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-09-13",
      baseline_complete: 84.6,
      actual_complete: 85.1,
      forecast_complete: 54.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-09-20",
      baseline_complete: 85.3,
      actual_complete: 86.6,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-09-27",
      baseline_complete: 86.0,
      actual_complete: 86.6,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-10-04",
      baseline_complete: 86.7,
      actual_complete: 86.6,
      forecast_complete: 57.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-10-11",
      baseline_complete: 87.3,
      actual_complete: 89.8,
      forecast_complete: 58.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-10-18",
      baseline_complete: 87.9,
      actual_complete: 89.8,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-10-25",
      baseline_complete: 88.5,
      actual_complete: 89.8,
      forecast_complete: 59.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-11-01",
      baseline_complete: 89.1,
      actual_complete: 89.8,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-11-08",
      baseline_complete: 89.6,
      actual_complete: 92.2,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-11-15",
      baseline_complete: 90.1,
      actual_complete: 92.8,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-11-22",
      baseline_complete: 90.6,
      actual_complete: 93.0,
      forecast_complete: 63.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-11-29",
      baseline_complete: 91.1,
      actual_complete: 93.0,
      forecast_complete: 64.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-12-06",
      baseline_complete: 91.5,
      actual_complete: 93.0,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-12-13",
      baseline_complete: 92.0,
      actual_complete: 93.2,
      forecast_complete: 65.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-12-20",
      baseline_complete: 92.4,
      actual_complete: 93.5,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2027-12-27",
      baseline_complete: 92.8,
      actual_complete: 93.5,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-01-03",
      baseline_complete: 93.1,
      actual_complete: 93.5,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-01-10",
      baseline_complete: 93.5,
      actual_complete: 93.5,
      forecast_complete: 68.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-01-17",
      baseline_complete: 93.8,
      actual_complete: 95.0,
      forecast_complete: 69.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-01-24",
      baseline_complete: 94.1,
      actual_complete: 97.1,
      forecast_complete: 70.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-01-31",
      baseline_complete: 94.5,
      actual_complete: 97.1,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-02-07",
      baseline_complete: 94.7,
      actual_complete: 97.6,
      forecast_complete: 72.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-02-14",
      baseline_complete: 95.0,
      actual_complete: 97.6,
      forecast_complete: 73.9,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-02-21",
      baseline_complete: 95.3,
      actual_complete: 97.6,
      forecast_complete: 75.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-02-28",
      baseline_complete: 95.5,
      actual_complete: 97.6,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-03-06",
      baseline_complete: 95.8,
      actual_complete: 99.5,
      forecast_complete: 77.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-03-13",
      baseline_complete: 96.0,
      actual_complete: 99.5,
      forecast_complete: 78.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-03-20",
      baseline_complete: 96.2,
      actual_complete: 99.5,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-03-27",
      baseline_complete: 96.4,
      actual_complete: 99.5,
      forecast_complete: 80.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-04-03",
      baseline_complete: 96.6,
      actual_complete: 99.5,
      forecast_complete: 81.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-04-10",
      baseline_complete: 96.8,
      actual_complete: 99.5,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-04-17",
      baseline_complete: 96.9,
      actual_complete: 99.5,
      forecast_complete: 83.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-04-24",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-05-01",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 85.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-05-08",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-05-15",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-05-22",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 87.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-05-29",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 88.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-06-05",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 89.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-06-12",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-06-19",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-06-26",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-07-03",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 91.9,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-07-10",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-07-17",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-07-24",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-07-31",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-08-07",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-08-14",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-08-21",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-08-28",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-09-04",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-09-11",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-09-18",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-09-25",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-10-02",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-10-09",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-10-16",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-10-23",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-10-30",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-11-06",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-11-13",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-11-20",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-11-27",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-12-04",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-12-11",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-12-18",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "09758415-c112-23a3-e351-0a962d07e9bf",
      reporting_date: "2028-12-21",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
  ],
  "d28ece04-ff2d-0a19-37d7-62ba28fcaa35": [
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-03-09",
      baseline_complete: 0.3,
      actual_complete: 6.5,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-03-16",
      baseline_complete: 0.4,
      actual_complete: 7.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-03-23",
      baseline_complete: 0.4,
      actual_complete: 7.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-03-30",
      baseline_complete: 0.4,
      actual_complete: 7.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-04-06",
      baseline_complete: 0.5,
      actual_complete: 7.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-04-13",
      baseline_complete: 0.5,
      actual_complete: 7.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-04-20",
      baseline_complete: 0.6,
      actual_complete: 7.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-04-27",
      baseline_complete: 0.6,
      actual_complete: 7.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-05-04",
      baseline_complete: 0.7,
      actual_complete: 7.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-05-11",
      baseline_complete: 0.7,
      actual_complete: 7.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-05-18",
      baseline_complete: 0.8,
      actual_complete: 7.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-05-25",
      baseline_complete: 0.9,
      actual_complete: 7.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-06-01",
      baseline_complete: 1.0,
      actual_complete: 7.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-06-08",
      baseline_complete: 1.1,
      actual_complete: 7.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-06-15",
      baseline_complete: 1.2,
      actual_complete: 7.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-06-22",
      baseline_complete: 1.3,
      actual_complete: 7.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-06-29",
      baseline_complete: 1.4,
      actual_complete: 7.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-07-06",
      baseline_complete: 1.6,
      actual_complete: 7.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-07-13",
      baseline_complete: 1.7,
      actual_complete: 7.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-07-20",
      baseline_complete: 1.9,
      actual_complete: 7.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-07-27",
      baseline_complete: 2.1,
      actual_complete: 7.9,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-08-03",
      baseline_complete: 2.3,
      actual_complete: 7.9,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-08-10",
      baseline_complete: 2.5,
      actual_complete: 7.9,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-08-17",
      baseline_complete: 2.8,
      actual_complete: 7.9,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-08-24",
      baseline_complete: 3.0,
      actual_complete: 9.4,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-08-31",
      baseline_complete: 3.3,
      actual_complete: 9.4,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-09-07",
      baseline_complete: 3.7,
      actual_complete: 9.4,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-09-14",
      baseline_complete: 4.0,
      actual_complete: 9.4,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-09-21",
      baseline_complete: 4.4,
      actual_complete: 10.0,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-09-28",
      baseline_complete: 4.8,
      actual_complete: 10.1,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-10-05",
      baseline_complete: 5.3,
      actual_complete: 10.1,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-10-12",
      baseline_complete: 5.8,
      actual_complete: 10.4,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-10-19",
      baseline_complete: 6.3,
      actual_complete: 11.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-10-26",
      baseline_complete: 6.9,
      actual_complete: 11.4,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-11-02",
      baseline_complete: 7.5,
      actual_complete: 11.8,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-11-09",
      baseline_complete: 8.2,
      actual_complete: 11.9,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-11-16",
      baseline_complete: 9.0,
      actual_complete: 14.0,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-11-23",
      baseline_complete: 9.8,
      actual_complete: 15.4,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-11-30",
      baseline_complete: 10.6,
      actual_complete: 15.4,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-12-07",
      baseline_complete: 11.6,
      actual_complete: 17.6,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-12-14",
      baseline_complete: 12.6,
      actual_complete: 17.6,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-12-21",
      baseline_complete: 13.7,
      actual_complete: 17.6,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2026-12-28",
      baseline_complete: 14.8,
      actual_complete: 19.5,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-01-04",
      baseline_complete: 16.1,
      actual_complete: 20.5,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-01-11",
      baseline_complete: 17.4,
      actual_complete: 21.5,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-01-18",
      baseline_complete: 18.8,
      actual_complete: 24.5,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-01-25",
      baseline_complete: 20.3,
      actual_complete: 24.5,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-02-01",
      baseline_complete: 21.9,
      actual_complete: 26.4,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-02-08",
      baseline_complete: 23.6,
      actual_complete: 27.6,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-02-15",
      baseline_complete: 25.3,
      actual_complete: 31.0,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-02-22",
      baseline_complete: 27.2,
      actual_complete: 31.0,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-03-01",
      baseline_complete: 29.1,
      actual_complete: 32.3,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-03-08",
      baseline_complete: 31.1,
      actual_complete: 36.5,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-03-15",
      baseline_complete: 33.2,
      actual_complete: 37.9,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-03-22",
      baseline_complete: 35.3,
      actual_complete: 40.1,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-03-29",
      baseline_complete: 37.5,
      actual_complete: 41.9,
      forecast_complete: 19.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-04-05",
      baseline_complete: 39.8,
      actual_complete: 43.2,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-04-12",
      baseline_complete: 42.1,
      actual_complete: 47.2,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-04-19",
      baseline_complete: 44.4,
      actual_complete: 49.1,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-04-26",
      baseline_complete: 46.8,
      actual_complete: 50.1,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-05-03",
      baseline_complete: 49.1,
      actual_complete: 52.2,
      forecast_complete: 25.1,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-05-10",
      baseline_complete: 51.5,
      actual_complete: 55.7,
      forecast_complete: 26.5,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-05-17",
      baseline_complete: 53.9,
      actual_complete: 56.7,
      forecast_complete: 27.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-05-24",
      baseline_complete: 56.2,
      actual_complete: 59.8,
      forecast_complete: 29.2,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-05-31",
      baseline_complete: 58.6,
      actual_complete: 61.4,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-06-07",
      baseline_complete: 60.9,
      actual_complete: 65.2,
      forecast_complete: 32.1,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-06-14",
      baseline_complete: 63.1,
      actual_complete: 65.7,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-06-21",
      baseline_complete: 65.3,
      actual_complete: 68.4,
      forecast_complete: 35.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-06-28",
      baseline_complete: 67.4,
      actual_complete: 72.1,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-07-05",
      baseline_complete: 69.5,
      actual_complete: 74.9,
      forecast_complete: 37.9,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-07-12",
      baseline_complete: 71.4,
      actual_complete: 74.9,
      forecast_complete: 39.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-07-19",
      baseline_complete: 73.3,
      actual_complete: 77.9,
      forecast_complete: 40.7,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-07-26",
      baseline_complete: 75.2,
      actual_complete: 79.6,
      forecast_complete: 42.2,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-08-02",
      baseline_complete: 76.9,
      actual_complete: 82.3,
      forecast_complete: 43.6,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-08-09",
      baseline_complete: 78.5,
      actual_complete: 82.3,
      forecast_complete: 44.9,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-08-16",
      baseline_complete: 80.1,
      actual_complete: 84.4,
      forecast_complete: 46.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-08-23",
      baseline_complete: 81.6,
      actual_complete: 84.4,
      forecast_complete: 47.6,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-08-30",
      baseline_complete: 83.0,
      actual_complete: 86.8,
      forecast_complete: 48.9,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-09-06",
      baseline_complete: 84.3,
      actual_complete: 88.2,
      forecast_complete: 50.2,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-09-13",
      baseline_complete: 85.5,
      actual_complete: 89.6,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-09-20",
      baseline_complete: 86.6,
      actual_complete: 89.9,
      forecast_complete: 52.6,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-09-27",
      baseline_complete: 87.7,
      actual_complete: 91.0,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-10-04",
      baseline_complete: 88.7,
      actual_complete: 91.9,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-10-11",
      baseline_complete: 89.6,
      actual_complete: 91.9,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-10-18",
      baseline_complete: 90.5,
      actual_complete: 93.6,
      forecast_complete: 57.2,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-10-25",
      baseline_complete: 91.2,
      actual_complete: 93.9,
      forecast_complete: 58.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-11-01",
      baseline_complete: 92.0,
      actual_complete: 94.9,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-11-08",
      baseline_complete: 92.7,
      actual_complete: 96.1,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-11-15",
      baseline_complete: 93.3,
      actual_complete: 96.2,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-11-22",
      baseline_complete: 93.8,
      actual_complete: 97.5,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-11-29",
      baseline_complete: 94.4,
      actual_complete: 98.0,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-12-06",
      baseline_complete: 94.9,
      actual_complete: 98.0,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-12-13",
      baseline_complete: 95.3,
      actual_complete: 98.0,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-12-20",
      baseline_complete: 95.7,
      actual_complete: 98.1,
      forecast_complete: 66.1,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2027-12-27",
      baseline_complete: 96.1,
      actual_complete: 98.8,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-01-03",
      baseline_complete: 96.4,
      actual_complete: 99.4,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-01-10",
      baseline_complete: 96.7,
      actual_complete: 99.7,
      forecast_complete: 68.7,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-01-17",
      baseline_complete: 97.0,
      actual_complete: 99.7,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-01-24",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 70.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-01-31",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-02-07",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-02-14",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-02-21",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 73.6,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-02-28",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 74.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-03-06",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 75.2,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-03-13",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 75.9,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-03-20",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-03-27",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 78.7,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-04-03",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 80.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-04-10",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-04-17",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-04-24",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-05-01",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 84.9,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-05-08",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 86.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-05-15",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-05-22",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-05-29",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-06-05",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 90.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-06-12",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-06-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-06-26",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-07-03",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-07-10",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-07-17",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-07-24",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-07-31",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-08-07",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-08-14",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-08-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-08-28",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-09-04",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-09-11",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-09-18",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-09-25",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-10-02",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-10-09",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-10-16",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-10-23",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-10-30",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-11-06",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d28ece04-ff2d-0a19-37d7-62ba28fcaa35",
      reporting_date: "2028-11-09",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "ec0d619a-6991-f4d4-9103-95119e69d7a1": [
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-01-31",
      baseline_complete: 0.3,
      actual_complete: 1.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-02-07",
      baseline_complete: 0.3,
      actual_complete: 1.9,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-02-14",
      baseline_complete: 0.3,
      actual_complete: 3.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-02-21",
      baseline_complete: 0.3,
      actual_complete: 3.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-02-28",
      baseline_complete: 0.4,
      actual_complete: 3.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-03-06",
      baseline_complete: 0.4,
      actual_complete: 3.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-03-13",
      baseline_complete: 0.4,
      actual_complete: 3.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-03-20",
      baseline_complete: 0.5,
      actual_complete: 3.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-03-27",
      baseline_complete: 0.5,
      actual_complete: 3.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-04-03",
      baseline_complete: 0.5,
      actual_complete: 3.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-04-10",
      baseline_complete: 0.6,
      actual_complete: 3.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-04-17",
      baseline_complete: 0.6,
      actual_complete: 3.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-04-24",
      baseline_complete: 0.7,
      actual_complete: 3.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-05-01",
      baseline_complete: 0.7,
      actual_complete: 3.5,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-05-08",
      baseline_complete: 0.8,
      actual_complete: 3.5,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-05-15",
      baseline_complete: 0.8,
      actual_complete: 3.5,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-05-22",
      baseline_complete: 0.9,
      actual_complete: 3.8,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-05-29",
      baseline_complete: 1.0,
      actual_complete: 3.8,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-06-05",
      baseline_complete: 1.1,
      actual_complete: 4.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-06-12",
      baseline_complete: 1.1,
      actual_complete: 4.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-06-19",
      baseline_complete: 1.2,
      actual_complete: 4.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-06-26",
      baseline_complete: 1.3,
      actual_complete: 4.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-07-03",
      baseline_complete: 1.4,
      actual_complete: 4.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-07-10",
      baseline_complete: 1.5,
      actual_complete: 4.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-07-17",
      baseline_complete: 1.7,
      actual_complete: 4.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-07-24",
      baseline_complete: 1.8,
      actual_complete: 4.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-07-31",
      baseline_complete: 1.9,
      actual_complete: 4.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-08-07",
      baseline_complete: 2.1,
      actual_complete: 4.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-08-14",
      baseline_complete: 2.2,
      actual_complete: 4.9,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-08-21",
      baseline_complete: 2.4,
      actual_complete: 5.1,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-08-28",
      baseline_complete: 2.6,
      actual_complete: 5.1,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-09-04",
      baseline_complete: 2.8,
      actual_complete: 5.1,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-09-11",
      baseline_complete: 3.0,
      actual_complete: 5.4,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-09-18",
      baseline_complete: 3.3,
      actual_complete: 5.4,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-09-25",
      baseline_complete: 3.5,
      actual_complete: 6.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-10-02",
      baseline_complete: 3.8,
      actual_complete: 6.7,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-10-09",
      baseline_complete: 4.1,
      actual_complete: 6.7,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-10-16",
      baseline_complete: 4.4,
      actual_complete: 6.7,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-10-23",
      baseline_complete: 4.7,
      actual_complete: 7.3,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-10-30",
      baseline_complete: 5.1,
      actual_complete: 7.4,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-11-06",
      baseline_complete: 5.4,
      actual_complete: 7.4,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-11-13",
      baseline_complete: 5.8,
      actual_complete: 7.4,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-11-20",
      baseline_complete: 6.3,
      actual_complete: 7.5,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-11-27",
      baseline_complete: 6.7,
      actual_complete: 9.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-12-04",
      baseline_complete: 7.2,
      actual_complete: 9.5,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-12-11",
      baseline_complete: 7.8,
      actual_complete: 10.8,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-12-18",
      baseline_complete: 8.3,
      actual_complete: 10.8,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2024-12-25",
      baseline_complete: 8.9,
      actual_complete: 10.8,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-01-01",
      baseline_complete: 9.6,
      actual_complete: 11.5,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-01-08",
      baseline_complete: 10.2,
      actual_complete: 12.1,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-01-15",
      baseline_complete: 11.0,
      actual_complete: 12.8,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-01-22",
      baseline_complete: 11.7,
      actual_complete: 14.6,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-01-29",
      baseline_complete: 12.5,
      actual_complete: 14.6,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-02-05",
      baseline_complete: 13.4,
      actual_complete: 14.6,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-02-12",
      baseline_complete: 14.3,
      actual_complete: 15.0,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-02-19",
      baseline_complete: 15.3,
      actual_complete: 18.5,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-02-26",
      baseline_complete: 16.3,
      actual_complete: 18.5,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-03-05",
      baseline_complete: 17.4,
      actual_complete: 18.5,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-03-12",
      baseline_complete: 18.5,
      actual_complete: 20.1,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-03-19",
      baseline_complete: 19.7,
      actual_complete: 20.1,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-03-26",
      baseline_complete: 20.9,
      actual_complete: 21.9,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-04-02",
      baseline_complete: 22.2,
      actual_complete: 25.6,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-04-09",
      baseline_complete: 23.5,
      actual_complete: 25.6,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-04-16",
      baseline_complete: 24.9,
      actual_complete: 26.8,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-04-23",
      baseline_complete: 26.4,
      actual_complete: 28.2,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-04-30",
      baseline_complete: 27.9,
      actual_complete: 28.7,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-05-07",
      baseline_complete: 29.5,
      actual_complete: 31.0,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-05-14",
      baseline_complete: 31.1,
      actual_complete: 31.8,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-05-21",
      baseline_complete: 32.7,
      actual_complete: 36.2,
      forecast_complete: 19.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-05-28",
      baseline_complete: 34.4,
      actual_complete: 36.2,
      forecast_complete: 20.8,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-06-04",
      baseline_complete: 36.2,
      actual_complete: 37.2,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-06-11",
      baseline_complete: 37.9,
      actual_complete: 39.9,
      forecast_complete: 23.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-06-18",
      baseline_complete: 39.8,
      actual_complete: 41.0,
      forecast_complete: 24.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-06-25",
      baseline_complete: 41.6,
      actual_complete: 44.8,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-07-02",
      baseline_complete: 43.5,
      actual_complete: 44.8,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-07-09",
      baseline_complete: 45.4,
      actual_complete: 48.4,
      forecast_complete: 28.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-07-16",
      baseline_complete: 47.2,
      actual_complete: 49.7,
      forecast_complete: 29.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-07-23",
      baseline_complete: 49.2,
      actual_complete: 50.6,
      forecast_complete: 31.2,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-07-30",
      baseline_complete: 51.1,
      actual_complete: 50.9,
      forecast_complete: 32.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-08-06",
      baseline_complete: 53.0,
      actual_complete: 53.6,
      forecast_complete: 34.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-08-13",
      baseline_complete: 54.9,
      actual_complete: 58.3,
      forecast_complete: 35.6,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-08-20",
      baseline_complete: 56.7,
      actual_complete: 58.3,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-08-27",
      baseline_complete: 58.6,
      actual_complete: 61.6,
      forecast_complete: 38.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-09-03",
      baseline_complete: 60.4,
      actual_complete: 62.4,
      forecast_complete: 40.2,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-09-10",
      baseline_complete: 62.2,
      actual_complete: 62.4,
      forecast_complete: 41.8,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-09-17",
      baseline_complete: 64.0,
      actual_complete: 66.0,
      forecast_complete: 43.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-09-24",
      baseline_complete: 65.8,
      actual_complete: 67.0,
      forecast_complete: 45.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-10-01",
      baseline_complete: 67.5,
      actual_complete: 69.4,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-10-08",
      baseline_complete: 69.1,
      actual_complete: 71.4,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-10-15",
      baseline_complete: 70.7,
      actual_complete: 73.3,
      forecast_complete: 49.6,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-10-22",
      baseline_complete: 72.3,
      actual_complete: 74.4,
      forecast_complete: 51.2,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-10-29",
      baseline_complete: 73.8,
      actual_complete: 75.7,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-11-05",
      baseline_complete: 75.2,
      actual_complete: 75.7,
      forecast_complete: 54.2,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-11-12",
      baseline_complete: 76.6,
      actual_complete: 76.5,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-11-19",
      baseline_complete: 78.0,
      actual_complete: 80.9,
      forecast_complete: 57.3,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-11-26",
      baseline_complete: 79.2,
      actual_complete: 80.9,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-12-03",
      baseline_complete: 80.5,
      actual_complete: 81.9,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-12-10",
      baseline_complete: 81.6,
      actual_complete: 81.9,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-12-17",
      baseline_complete: 82.8,
      actual_complete: 85.1,
      forecast_complete: 63.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-12-24",
      baseline_complete: 83.8,
      actual_complete: 85.1,
      forecast_complete: 64.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2025-12-31",
      baseline_complete: 84.8,
      actual_complete: 86.3,
      forecast_complete: 65.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-01-07",
      baseline_complete: 85.8,
      actual_complete: 86.7,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-01-14",
      baseline_complete: 86.7,
      actual_complete: 89.2,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-01-21",
      baseline_complete: 87.5,
      actual_complete: 89.2,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-01-28",
      baseline_complete: 88.4,
      actual_complete: 89.4,
      forecast_complete: 73.6,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-02-04",
      baseline_complete: 89.1,
      actual_complete: 90.6,
      forecast_complete: 75.6,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-02-11",
      baseline_complete: 89.8,
      actual_complete: 92.6,
      forecast_complete: 77.5,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-02-18",
      baseline_complete: 90.5,
      actual_complete: 92.6,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-02-25",
      baseline_complete: 91.1,
      actual_complete: 94.5,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-03-04",
      baseline_complete: 91.7,
      actual_complete: 94.5,
      forecast_complete: 82.8,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-03-11",
      baseline_complete: 92.3,
      actual_complete: 94.5,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-03-18",
      baseline_complete: 92.8,
      actual_complete: 94.5,
      forecast_complete: 85.9,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-03-25",
      baseline_complete: 93.3,
      actual_complete: 94.5,
      forecast_complete: 87.3,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-04-01",
      baseline_complete: 93.8,
      actual_complete: 96.1,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-04-08",
      baseline_complete: 94.2,
      actual_complete: 96.1,
      forecast_complete: 90.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-04-15",
      baseline_complete: 94.6,
      actual_complete: 96.1,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-04-22",
      baseline_complete: 95.0,
      actual_complete: 96.5,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-04-29",
      baseline_complete: 95.3,
      actual_complete: 98.5,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-05-06",
      baseline_complete: 95.7,
      actual_complete: 98.5,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-05-13",
      baseline_complete: 96.0,
      actual_complete: 98.5,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-05-20",
      baseline_complete: 96.3,
      actual_complete: 98.5,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-05-27",
      baseline_complete: 96.5,
      actual_complete: 98.5,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-06-03",
      baseline_complete: 96.8,
      actual_complete: 98.5,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-06-10",
      baseline_complete: 97.0,
      actual_complete: 98.5,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-06-17",
      baseline_complete: 97.2,
      actual_complete: 98.6,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-06-24",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-07-01",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-07-08",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-07-15",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-07-22",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-07-29",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-08-05",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-08-12",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-08-19",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-08-26",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec0d619a-6991-f4d4-9103-95119e69d7a1",
      reporting_date: "2026-08-31",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "b63ea0dc-0fe1-966e-86c1-642a2da66518": [
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-01-27",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-02-03",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-02-10",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-02-17",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-02-24",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-03-03",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-03-10",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-03-17",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-03-24",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-03-31",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-04-07",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-04-14",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-04-21",
      baseline_complete: 0.2,
      actual_complete: 0.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-04-28",
      baseline_complete: 0.2,
      actual_complete: 0.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-05-05",
      baseline_complete: 0.3,
      actual_complete: 0.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-05-12",
      baseline_complete: 0.3,
      actual_complete: 0.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-05-19",
      baseline_complete: 0.3,
      actual_complete: 0.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-05-26",
      baseline_complete: 0.3,
      actual_complete: 0.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-06-02",
      baseline_complete: 0.4,
      actual_complete: 0.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-06-09",
      baseline_complete: 0.4,
      actual_complete: 0.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-06-16",
      baseline_complete: 0.4,
      actual_complete: 0.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-06-23",
      baseline_complete: 0.5,
      actual_complete: 0.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-06-30",
      baseline_complete: 0.5,
      actual_complete: 0.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-07-07",
      baseline_complete: 0.6,
      actual_complete: 0.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-07-14",
      baseline_complete: 0.6,
      actual_complete: 0.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-07-21",
      baseline_complete: 0.7,
      actual_complete: 0.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-07-28",
      baseline_complete: 0.7,
      actual_complete: 0.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-08-04",
      baseline_complete: 0.8,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-08-11",
      baseline_complete: 0.9,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-08-18",
      baseline_complete: 0.9,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-08-25",
      baseline_complete: 1.0,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-09-01",
      baseline_complete: 1.1,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-09-08",
      baseline_complete: 1.2,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-09-15",
      baseline_complete: 1.3,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-09-22",
      baseline_complete: 1.4,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-09-29",
      baseline_complete: 1.5,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-10-06",
      baseline_complete: 1.7,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-10-13",
      baseline_complete: 1.8,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-10-20",
      baseline_complete: 2.0,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-10-27",
      baseline_complete: 2.2,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-11-03",
      baseline_complete: 2.4,
      actual_complete: 1.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-11-10",
      baseline_complete: 2.6,
      actual_complete: 1.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-11-17",
      baseline_complete: 2.8,
      actual_complete: 1.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-11-24",
      baseline_complete: 3.0,
      actual_complete: 2.1,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-12-01",
      baseline_complete: 3.3,
      actual_complete: 2.1,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-12-08",
      baseline_complete: 3.6,
      actual_complete: 4.5,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-12-15",
      baseline_complete: 3.9,
      actual_complete: 4.5,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-12-22",
      baseline_complete: 4.3,
      actual_complete: 4.5,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2026-12-29",
      baseline_complete: 4.6,
      actual_complete: 4.5,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-01-05",
      baseline_complete: 5.0,
      actual_complete: 4.5,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-01-12",
      baseline_complete: 5.5,
      actual_complete: 4.5,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-01-19",
      baseline_complete: 5.9,
      actual_complete: 4.5,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-01-26",
      baseline_complete: 6.4,
      actual_complete: 5.5,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-02-02",
      baseline_complete: 7.0,
      actual_complete: 7.1,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-02-09",
      baseline_complete: 7.5,
      actual_complete: 7.1,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-02-16",
      baseline_complete: 8.2,
      actual_complete: 7.1,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-02-23",
      baseline_complete: 8.8,
      actual_complete: 7.1,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-03-02",
      baseline_complete: 9.6,
      actual_complete: 8.5,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-03-09",
      baseline_complete: 10.3,
      actual_complete: 8.5,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-03-16",
      baseline_complete: 11.2,
      actual_complete: 10.7,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-03-23",
      baseline_complete: 12.1,
      actual_complete: 10.7,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-03-30",
      baseline_complete: 13.0,
      actual_complete: 14.1,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-04-06",
      baseline_complete: 14.0,
      actual_complete: 14.1,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-04-13",
      baseline_complete: 15.1,
      actual_complete: 14.1,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-04-20",
      baseline_complete: 16.2,
      actual_complete: 14.4,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-04-27",
      baseline_complete: 17.4,
      actual_complete: 15.4,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-05-04",
      baseline_complete: 18.7,
      actual_complete: 16.9,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-05-11",
      baseline_complete: 20.1,
      actual_complete: 16.9,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-05-18",
      baseline_complete: 21.5,
      actual_complete: 21.4,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-05-25",
      baseline_complete: 23.0,
      actual_complete: 23.0,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-06-01",
      baseline_complete: 24.6,
      actual_complete: 25.5,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-06-08",
      baseline_complete: 26.2,
      actual_complete: 25.5,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-06-15",
      baseline_complete: 27.9,
      actual_complete: 28.8,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-06-22",
      baseline_complete: 29.7,
      actual_complete: 29.7,
      forecast_complete: 14.4,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-06-29",
      baseline_complete: 31.5,
      actual_complete: 29.7,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-07-06",
      baseline_complete: 33.4,
      actual_complete: 31.3,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-07-13",
      baseline_complete: 35.4,
      actual_complete: 33.1,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-07-20",
      baseline_complete: 37.4,
      actual_complete: 37.9,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-07-27",
      baseline_complete: 39.5,
      actual_complete: 41.2,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-08-03",
      baseline_complete: 41.5,
      actual_complete: 43.9,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-08-10",
      baseline_complete: 43.7,
      actual_complete: 43.9,
      forecast_complete: 23.6,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-08-17",
      baseline_complete: 45.8,
      actual_complete: 46.8,
      forecast_complete: 25.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-08-24",
      baseline_complete: 48.0,
      actual_complete: 46.8,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-08-31",
      baseline_complete: 50.1,
      actual_complete: 51.5,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-09-07",
      baseline_complete: 52.3,
      actual_complete: 51.5,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-09-14",
      baseline_complete: 54.4,
      actual_complete: 56.6,
      forecast_complete: 31.4,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-09-21",
      baseline_complete: 56.6,
      actual_complete: 56.6,
      forecast_complete: 33.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-09-28",
      baseline_complete: 58.7,
      actual_complete: 57.1,
      forecast_complete: 34.8,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-10-05",
      baseline_complete: 60.8,
      actual_complete: 62.8,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-10-12",
      baseline_complete: 62.8,
      actual_complete: 62.8,
      forecast_complete: 38.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-10-19",
      baseline_complete: 64.8,
      actual_complete: 66.7,
      forecast_complete: 39.8,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-10-26",
      baseline_complete: 66.8,
      actual_complete: 69.7,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-11-02",
      baseline_complete: 68.7,
      actual_complete: 69.7,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-11-09",
      baseline_complete: 70.5,
      actual_complete: 72.8,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-11-16",
      baseline_complete: 72.3,
      actual_complete: 72.8,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-11-23",
      baseline_complete: 74.0,
      actual_complete: 75.5,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-11-30",
      baseline_complete: 75.6,
      actual_complete: 75.5,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-12-07",
      baseline_complete: 77.2,
      actual_complete: 79.0,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-12-14",
      baseline_complete: 78.7,
      actual_complete: 79.0,
      forecast_complete: 52.9,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-12-21",
      baseline_complete: 80.1,
      actual_complete: 80.2,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2027-12-28",
      baseline_complete: 81.4,
      actual_complete: 82.2,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-01-04",
      baseline_complete: 82.7,
      actual_complete: 82.9,
      forecast_complete: 57.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-01-11",
      baseline_complete: 83.9,
      actual_complete: 86.0,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-01-18",
      baseline_complete: 85.0,
      actual_complete: 86.1,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-01-25",
      baseline_complete: 86.1,
      actual_complete: 87.6,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-02-01",
      baseline_complete: 87.1,
      actual_complete: 87.6,
      forecast_complete: 62.8,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-02-08",
      baseline_complete: 88.0,
      actual_complete: 89.3,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-02-15",
      baseline_complete: 88.9,
      actual_complete: 92.0,
      forecast_complete: 65.4,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-02-22",
      baseline_complete: 89.8,
      actual_complete: 92.4,
      forecast_complete: 66.6,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-02-29",
      baseline_complete: 90.5,
      actual_complete: 92.4,
      forecast_complete: 68.7,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-03-07",
      baseline_complete: 91.2,
      actual_complete: 92.4,
      forecast_complete: 70.6,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-03-14",
      baseline_complete: 91.9,
      actual_complete: 92.4,
      forecast_complete: 72.6,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-03-21",
      baseline_complete: 92.5,
      actual_complete: 92.4,
      forecast_complete: 74.4,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-03-28",
      baseline_complete: 93.1,
      actual_complete: 93.5,
      forecast_complete: 76.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-04-04",
      baseline_complete: 93.6,
      actual_complete: 93.5,
      forecast_complete: 77.7,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-04-11",
      baseline_complete: 94.1,
      actual_complete: 96.8,
      forecast_complete: 79.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-04-18",
      baseline_complete: 94.6,
      actual_complete: 96.8,
      forecast_complete: 80.8,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-04-25",
      baseline_complete: 95.0,
      actual_complete: 96.8,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-05-02",
      baseline_complete: 95.4,
      actual_complete: 96.8,
      forecast_complete: 83.5,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-05-09",
      baseline_complete: 95.8,
      actual_complete: 96.8,
      forecast_complete: 84.8,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-05-16",
      baseline_complete: 96.1,
      actual_complete: 96.8,
      forecast_complete: 86.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-05-23",
      baseline_complete: 96.4,
      actual_complete: 96.8,
      forecast_complete: 87.2,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-05-30",
      baseline_complete: 96.7,
      actual_complete: 97.3,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-06-06",
      baseline_complete: 97.0,
      actual_complete: 97.3,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-06-13",
      baseline_complete: 97.2,
      actual_complete: 99.7,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-06-20",
      baseline_complete: 97.4,
      actual_complete: 99.7,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-06-27",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-07-04",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-07-11",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-07-18",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-07-25",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-08-01",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-08-08",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-08-15",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-08-22",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-08-29",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-09-05",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-09-12",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-09-19",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-09-26",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-10-03",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-10-10",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-10-17",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-10-24",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "b63ea0dc-0fe1-966e-86c1-642a2da66518",
      reporting_date: "2028-10-27",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
  ],
  "6c632848-4365-9cc9-6d3e-98b0966204e1": [
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-04-29",
      baseline_complete: 0.2,
      actual_complete: 0.7,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-05-06",
      baseline_complete: 0.2,
      actual_complete: 0.7,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-05-13",
      baseline_complete: 0.2,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-05-20",
      baseline_complete: 0.2,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-05-27",
      baseline_complete: 0.2,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-06-03",
      baseline_complete: 0.2,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-06-10",
      baseline_complete: 0.3,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-06-17",
      baseline_complete: 0.3,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-06-24",
      baseline_complete: 0.3,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-07-01",
      baseline_complete: 0.3,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-07-08",
      baseline_complete: 0.3,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-07-15",
      baseline_complete: 0.4,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-07-22",
      baseline_complete: 0.4,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-07-29",
      baseline_complete: 0.4,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-08-05",
      baseline_complete: 0.4,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-08-12",
      baseline_complete: 0.5,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-08-19",
      baseline_complete: 0.5,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-08-26",
      baseline_complete: 0.5,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-09-02",
      baseline_complete: 0.6,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-09-09",
      baseline_complete: 0.6,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-09-16",
      baseline_complete: 0.7,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-09-23",
      baseline_complete: 0.7,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-09-30",
      baseline_complete: 0.7,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-10-07",
      baseline_complete: 0.8,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-10-14",
      baseline_complete: 0.9,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-10-21",
      baseline_complete: 0.9,
      actual_complete: 1.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-10-28",
      baseline_complete: 1.0,
      actual_complete: 1.2,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-11-04",
      baseline_complete: 1.0,
      actual_complete: 1.2,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-11-11",
      baseline_complete: 1.1,
      actual_complete: 1.9,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-11-18",
      baseline_complete: 1.2,
      actual_complete: 1.9,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-11-25",
      baseline_complete: 1.3,
      actual_complete: 2.2,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-12-02",
      baseline_complete: 1.4,
      actual_complete: 2.2,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-12-09",
      baseline_complete: 1.4,
      actual_complete: 2.2,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-12-16",
      baseline_complete: 1.5,
      actual_complete: 2.2,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-12-23",
      baseline_complete: 1.6,
      actual_complete: 2.2,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2023-12-30",
      baseline_complete: 1.8,
      actual_complete: 2.2,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-01-06",
      baseline_complete: 1.9,
      actual_complete: 2.2,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-01-13",
      baseline_complete: 2.0,
      actual_complete: 3.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-01-20",
      baseline_complete: 2.1,
      actual_complete: 3.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-01-27",
      baseline_complete: 2.3,
      actual_complete: 3.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-02-03",
      baseline_complete: 2.4,
      actual_complete: 3.1,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-02-10",
      baseline_complete: 2.6,
      actual_complete: 3.7,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-02-17",
      baseline_complete: 2.8,
      actual_complete: 3.7,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-02-24",
      baseline_complete: 3.0,
      actual_complete: 3.7,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-03-02",
      baseline_complete: 3.2,
      actual_complete: 4.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-03-09",
      baseline_complete: 3.4,
      actual_complete: 4.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-03-16",
      baseline_complete: 3.6,
      actual_complete: 4.6,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-03-23",
      baseline_complete: 3.8,
      actual_complete: 4.6,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-03-30",
      baseline_complete: 4.1,
      actual_complete: 5.3,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-04-06",
      baseline_complete: 4.4,
      actual_complete: 5.3,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-04-13",
      baseline_complete: 4.6,
      actual_complete: 5.3,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-04-20",
      baseline_complete: 5.0,
      actual_complete: 5.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-04-27",
      baseline_complete: 5.3,
      actual_complete: 5.3,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-05-04",
      baseline_complete: 5.6,
      actual_complete: 5.3,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-05-11",
      baseline_complete: 6.0,
      actual_complete: 6.9,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-05-18",
      baseline_complete: 6.4,
      actual_complete: 6.9,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-05-25",
      baseline_complete: 6.8,
      actual_complete: 6.9,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-06-01",
      baseline_complete: 7.2,
      actual_complete: 8.5,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-06-08",
      baseline_complete: 7.7,
      actual_complete: 8.5,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-06-15",
      baseline_complete: 8.2,
      actual_complete: 10.0,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-06-22",
      baseline_complete: 8.7,
      actual_complete: 10.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-06-29",
      baseline_complete: 9.2,
      actual_complete: 10.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-07-06",
      baseline_complete: 9.8,
      actual_complete: 10.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-07-13",
      baseline_complete: 10.4,
      actual_complete: 12.0,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-07-20",
      baseline_complete: 11.0,
      actual_complete: 12.0,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-07-27",
      baseline_complete: 11.7,
      actual_complete: 13.5,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-08-03",
      baseline_complete: 12.4,
      actual_complete: 13.5,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-08-10",
      baseline_complete: 13.2,
      actual_complete: 14.1,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-08-17",
      baseline_complete: 14.0,
      actual_complete: 14.1,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-08-24",
      baseline_complete: 14.8,
      actual_complete: 15.8,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-08-31",
      baseline_complete: 15.6,
      actual_complete: 16.4,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-09-07",
      baseline_complete: 16.5,
      actual_complete: 17.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-09-14",
      baseline_complete: 17.5,
      actual_complete: 17.9,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-09-21",
      baseline_complete: 18.5,
      actual_complete: 20.3,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-09-28",
      baseline_complete: 19.5,
      actual_complete: 20.3,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-10-05",
      baseline_complete: 20.6,
      actual_complete: 20.3,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-10-12",
      baseline_complete: 21.7,
      actual_complete: 23.0,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-10-19",
      baseline_complete: 22.8,
      actual_complete: 23.0,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-10-26",
      baseline_complete: 24.0,
      actual_complete: 23.0,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-11-02",
      baseline_complete: 25.3,
      actual_complete: 23.9,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-11-09",
      baseline_complete: 26.6,
      actual_complete: 26.3,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-11-16",
      baseline_complete: 27.9,
      actual_complete: 28.8,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-11-23",
      baseline_complete: 29.2,
      actual_complete: 30.3,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-11-30",
      baseline_complete: 30.6,
      actual_complete: 31.7,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-12-07",
      baseline_complete: 32.1,
      actual_complete: 33.2,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-12-14",
      baseline_complete: 33.6,
      actual_complete: 33.2,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-12-21",
      baseline_complete: 35.1,
      actual_complete: 34.9,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2024-12-28",
      baseline_complete: 36.6,
      actual_complete: 38.8,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-01-04",
      baseline_complete: 38.2,
      actual_complete: 38.8,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-01-11",
      baseline_complete: 39.7,
      actual_complete: 41.3,
      forecast_complete: 18.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-01-18",
      baseline_complete: 41.4,
      actual_complete: 41.3,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-01-25",
      baseline_complete: 43.0,
      actual_complete: 43.0,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-02-01",
      baseline_complete: 44.6,
      actual_complete: 46.4,
      forecast_complete: 21.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-02-08",
      baseline_complete: 46.3,
      actual_complete: 47.5,
      forecast_complete: 22.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-02-15",
      baseline_complete: 48.0,
      actual_complete: 48.2,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-02-22",
      baseline_complete: 49.6,
      actual_complete: 50.1,
      forecast_complete: 24.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-03-01",
      baseline_complete: 51.3,
      actual_complete: 51.1,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-03-08",
      baseline_complete: 53.0,
      actual_complete: 53.2,
      forecast_complete: 26.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-03-15",
      baseline_complete: 54.6,
      actual_complete: 56.0,
      forecast_complete: 27.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-03-22",
      baseline_complete: 56.3,
      actual_complete: 58.2,
      forecast_complete: 28.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-03-29",
      baseline_complete: 57.9,
      actual_complete: 58.2,
      forecast_complete: 29.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-04-05",
      baseline_complete: 59.5,
      actual_complete: 59.5,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-04-12",
      baseline_complete: 61.1,
      actual_complete: 60.1,
      forecast_complete: 31.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-04-19",
      baseline_complete: 62.7,
      actual_complete: 61.9,
      forecast_complete: 32.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-04-26",
      baseline_complete: 64.2,
      actual_complete: 65.9,
      forecast_complete: 34.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-05-03",
      baseline_complete: 65.8,
      actual_complete: 65.9,
      forecast_complete: 35.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-05-10",
      baseline_complete: 67.3,
      actual_complete: 68.9,
      forecast_complete: 36.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-05-17",
      baseline_complete: 68.7,
      actual_complete: 70.4,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-05-24",
      baseline_complete: 70.1,
      actual_complete: 71.4,
      forecast_complete: 38.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-05-31",
      baseline_complete: 71.5,
      actual_complete: 72.5,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-06-07",
      baseline_complete: 72.9,
      actual_complete: 72.9,
      forecast_complete: 40.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-06-14",
      baseline_complete: 74.2,
      actual_complete: 75.1,
      forecast_complete: 41.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-06-21",
      baseline_complete: 75.4,
      actual_complete: 78.0,
      forecast_complete: 42.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-06-28",
      baseline_complete: 76.6,
      actual_complete: 78.0,
      forecast_complete: 43.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-07-05",
      baseline_complete: 77.8,
      actual_complete: 79.9,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-07-12",
      baseline_complete: 78.9,
      actual_complete: 80.3,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-07-19",
      baseline_complete: 80.0,
      actual_complete: 80.3,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-07-26",
      baseline_complete: 81.1,
      actual_complete: 80.7,
      forecast_complete: 47.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-08-02",
      baseline_complete: 82.1,
      actual_complete: 83.6,
      forecast_complete: 48.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-08-09",
      baseline_complete: 83.0,
      actual_complete: 83.6,
      forecast_complete: 49.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-08-16",
      baseline_complete: 84.0,
      actual_complete: 84.6,
      forecast_complete: 50.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-08-23",
      baseline_complete: 84.8,
      actual_complete: 86.6,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-08-30",
      baseline_complete: 85.7,
      actual_complete: 87.1,
      forecast_complete: 52.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-09-06",
      baseline_complete: 86.5,
      actual_complete: 87.1,
      forecast_complete: 53.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-09-13",
      baseline_complete: 87.2,
      actual_complete: 88.9,
      forecast_complete: 54.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-09-20",
      baseline_complete: 88.0,
      actual_complete: 88.9,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-09-27",
      baseline_complete: 88.7,
      actual_complete: 89.9,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-10-04",
      baseline_complete: 89.3,
      actual_complete: 90.6,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-10-11",
      baseline_complete: 89.9,
      actual_complete: 90.6,
      forecast_complete: 57.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-10-18",
      baseline_complete: 90.5,
      actual_complete: 92.0,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-10-25",
      baseline_complete: 91.1,
      actual_complete: 92.0,
      forecast_complete: 59.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-11-01",
      baseline_complete: 91.6,
      actual_complete: 92.5,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-11-08",
      baseline_complete: 92.1,
      actual_complete: 92.7,
      forecast_complete: 61.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-11-15",
      baseline_complete: 92.6,
      actual_complete: 93.7,
      forecast_complete: 61.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-11-22",
      baseline_complete: 93.0,
      actual_complete: 93.7,
      forecast_complete: 62.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-11-29",
      baseline_complete: 93.4,
      actual_complete: 93.7,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-12-06",
      baseline_complete: 93.8,
      actual_complete: 93.7,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-12-13",
      baseline_complete: 94.2,
      actual_complete: 96.7,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-12-20",
      baseline_complete: 94.6,
      actual_complete: 96.9,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2025-12-27",
      baseline_complete: 94.9,
      actual_complete: 96.9,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-01-03",
      baseline_complete: 95.2,
      actual_complete: 96.9,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-01-10",
      baseline_complete: 95.5,
      actual_complete: 96.9,
      forecast_complete: 67.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-01-17",
      baseline_complete: 95.8,
      actual_complete: 98.6,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-01-24",
      baseline_complete: 96.1,
      actual_complete: 98.6,
      forecast_complete: 69.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-01-31",
      baseline_complete: 96.3,
      actual_complete: 98.6,
      forecast_complete: 69.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-02-07",
      baseline_complete: 96.5,
      actual_complete: 98.6,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-02-14",
      baseline_complete: 96.7,
      actual_complete: 98.6,
      forecast_complete: 70.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-02-21",
      baseline_complete: 97.0,
      actual_complete: 98.6,
      forecast_complete: 71.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-02-28",
      baseline_complete: 97.1,
      actual_complete: 98.6,
      forecast_complete: 72.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-03-07",
      baseline_complete: 97.3,
      actual_complete: 98.7,
      forecast_complete: 72.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-03-14",
      baseline_complete: 97.5,
      actual_complete: 98.7,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-03-21",
      baseline_complete: 97.6,
      actual_complete: 99.1,
      forecast_complete: 74.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-03-28",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 75.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-04-04",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-04-11",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-04-18",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 78.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-04-25",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 79.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-05-02",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-05-09",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 81.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-05-16",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-05-23",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-05-30",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-06-06",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 84.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-06-13",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 85.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-06-20",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 86.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-06-27",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-07-04",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 87.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-07-11",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-07-18",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-07-25",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 90.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-08-01",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-08-08",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 91.3,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-08-15",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 91.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-08-22",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-08-29",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-09-05",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-09-12",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-09-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-09-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-10-03",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-10-10",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-10-17",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-10-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-10-31",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-11-07",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-11-14",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-11-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-11-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-12-05",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-12-12",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-12-19",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2026-12-26",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2027-01-02",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2027-01-09",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2027-01-16",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2027-01-23",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2027-01-30",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2027-02-06",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2027-02-13",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2027-02-20",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2027-02-27",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "6c632848-4365-9cc9-6d3e-98b0966204e1",
      reporting_date: "2027-02-28",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "0b698afd-36c6-4235-9402-a2857a687c72": [
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-10-11",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-10-18",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-10-25",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-11-01",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-11-08",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-11-15",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-11-22",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-11-29",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-12-06",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-12-13",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-12-20",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2023-12-27",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-01-03",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-01-10",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-01-17",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-01-24",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-01-31",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-02-07",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-02-14",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-02-21",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-02-28",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-03-06",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-03-13",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-03-20",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-03-27",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-04-03",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-04-10",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-04-17",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-04-24",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-05-01",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-05-08",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-05-15",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-05-22",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-05-29",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-06-05",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-06-12",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-06-19",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-06-26",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-07-03",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-07-10",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-07-17",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-07-24",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-07-31",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-08-07",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-08-14",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-08-21",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-08-28",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-09-04",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-09-11",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-09-18",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-09-25",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-10-02",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-10-09",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-10-16",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-10-23",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-10-30",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-11-06",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-11-13",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-11-20",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-11-27",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-12-04",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-12-11",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-12-18",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2024-12-25",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-01-01",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-01-08",
      baseline_complete: 2.8,
      actual_complete: 0.5,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-01-15",
      baseline_complete: 3.0,
      actual_complete: 0.5,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-01-22",
      baseline_complete: 3.1,
      actual_complete: 0.5,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-01-29",
      baseline_complete: 3.3,
      actual_complete: 0.5,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-02-05",
      baseline_complete: 3.5,
      actual_complete: 0.5,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-02-12",
      baseline_complete: 3.7,
      actual_complete: 0.5,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-02-19",
      baseline_complete: 3.9,
      actual_complete: 0.5,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-02-26",
      baseline_complete: 4.2,
      actual_complete: 0.5,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-03-05",
      baseline_complete: 4.4,
      actual_complete: 1.9,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-03-12",
      baseline_complete: 4.7,
      actual_complete: 2.3,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-03-19",
      baseline_complete: 5.0,
      actual_complete: 2.3,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-03-26",
      baseline_complete: 5.3,
      actual_complete: 2.3,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-04-02",
      baseline_complete: 5.6,
      actual_complete: 2.3,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-04-09",
      baseline_complete: 5.9,
      actual_complete: 2.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-04-16",
      baseline_complete: 6.2,
      actual_complete: 2.3,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-04-23",
      baseline_complete: 6.6,
      actual_complete: 4.9,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-04-30",
      baseline_complete: 7.0,
      actual_complete: 4.9,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-05-07",
      baseline_complete: 7.4,
      actual_complete: 4.9,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-05-14",
      baseline_complete: 7.8,
      actual_complete: 4.9,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-05-21",
      baseline_complete: 8.2,
      actual_complete: 4.9,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-05-28",
      baseline_complete: 8.7,
      actual_complete: 4.9,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-06-04",
      baseline_complete: 9.2,
      actual_complete: 6.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-06-11",
      baseline_complete: 9.7,
      actual_complete: 7.3,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-06-18",
      baseline_complete: 10.2,
      actual_complete: 7.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-06-25",
      baseline_complete: 10.8,
      actual_complete: 8.5,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-07-02",
      baseline_complete: 11.4,
      actual_complete: 10.2,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-07-09",
      baseline_complete: 12.0,
      actual_complete: 10.9,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-07-16",
      baseline_complete: 12.6,
      actual_complete: 10.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-07-23",
      baseline_complete: 13.3,
      actual_complete: 10.9,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-07-30",
      baseline_complete: 14.0,
      actual_complete: 12.0,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-08-06",
      baseline_complete: 14.7,
      actual_complete: 12.3,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-08-13",
      baseline_complete: 15.5,
      actual_complete: 12.3,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-08-20",
      baseline_complete: 16.3,
      actual_complete: 13.4,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-08-27",
      baseline_complete: 17.1,
      actual_complete: 13.4,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-09-03",
      baseline_complete: 18.0,
      actual_complete: 18.1,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-09-10",
      baseline_complete: 18.9,
      actual_complete: 18.1,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-09-17",
      baseline_complete: 19.8,
      actual_complete: 18.8,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-09-24",
      baseline_complete: 20.8,
      actual_complete: 18.8,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-10-01",
      baseline_complete: 21.8,
      actual_complete: 20.4,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-10-08",
      baseline_complete: 22.8,
      actual_complete: 20.4,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-10-15",
      baseline_complete: 23.9,
      actual_complete: 21.3,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-10-22",
      baseline_complete: 25.0,
      actual_complete: 21.3,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-10-29",
      baseline_complete: 26.2,
      actual_complete: 21.3,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-11-05",
      baseline_complete: 27.3,
      actual_complete: 22.3,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-11-12",
      baseline_complete: 28.5,
      actual_complete: 26.9,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-11-19",
      baseline_complete: 29.8,
      actual_complete: 27.1,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-11-26",
      baseline_complete: 31.0,
      actual_complete: 27.1,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-12-03",
      baseline_complete: 32.3,
      actual_complete: 27.1,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-12-10",
      baseline_complete: 33.7,
      actual_complete: 29.8,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-12-17",
      baseline_complete: 35.0,
      actual_complete: 34.1,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-12-24",
      baseline_complete: 36.4,
      actual_complete: 34.1,
      forecast_complete: 18.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2025-12-31",
      baseline_complete: 37.8,
      actual_complete: 34.1,
      forecast_complete: 19.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-01-07",
      baseline_complete: 39.2,
      actual_complete: 38.7,
      forecast_complete: 20.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-01-14",
      baseline_complete: 40.6,
      actual_complete: 38.7,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-01-21",
      baseline_complete: 42.1,
      actual_complete: 40.6,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-01-28",
      baseline_complete: 43.5,
      actual_complete: 42.6,
      forecast_complete: 23.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-02-04",
      baseline_complete: 45.0,
      actual_complete: 42.6,
      forecast_complete: 24.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-02-11",
      baseline_complete: 46.5,
      actual_complete: 43.2,
      forecast_complete: 25.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-02-18",
      baseline_complete: 48.0,
      actual_complete: 47.8,
      forecast_complete: 26.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-02-25",
      baseline_complete: 49.5,
      actual_complete: 47.8,
      forecast_complete: 27.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-03-04",
      baseline_complete: 51.0,
      actual_complete: 47.9,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-03-11",
      baseline_complete: 52.5,
      actual_complete: 52.8,
      forecast_complete: 29.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-03-18",
      baseline_complete: 54.0,
      actual_complete: 52.8,
      forecast_complete: 30.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-03-25",
      baseline_complete: 55.4,
      actual_complete: 55.5,
      forecast_complete: 31.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-04-01",
      baseline_complete: 56.9,
      actual_complete: 56.3,
      forecast_complete: 32.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-04-08",
      baseline_complete: 58.4,
      actual_complete: 56.9,
      forecast_complete: 33.7,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-04-15",
      baseline_complete: 59.8,
      actual_complete: 56.9,
      forecast_complete: 34.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-04-22",
      baseline_complete: 61.3,
      actual_complete: 60.9,
      forecast_complete: 35.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-04-29",
      baseline_complete: 62.7,
      actual_complete: 60.9,
      forecast_complete: 37.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-05-06",
      baseline_complete: 64.1,
      actual_complete: 60.9,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-05-13",
      baseline_complete: 65.4,
      actual_complete: 63.1,
      forecast_complete: 39.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-05-20",
      baseline_complete: 66.8,
      actual_complete: 63.1,
      forecast_complete: 40.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-05-27",
      baseline_complete: 68.1,
      actual_complete: 64.7,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-06-03",
      baseline_complete: 69.4,
      actual_complete: 69.4,
      forecast_complete: 42.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-06-10",
      baseline_complete: 70.6,
      actual_complete: 69.4,
      forecast_complete: 43.7,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-06-17",
      baseline_complete: 71.8,
      actual_complete: 70.1,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-06-24",
      baseline_complete: 73.0,
      actual_complete: 72.7,
      forecast_complete: 45.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-07-01",
      baseline_complete: 74.2,
      actual_complete: 72.7,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-07-08",
      baseline_complete: 75.3,
      actual_complete: 75.4,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-07-15",
      baseline_complete: 76.4,
      actual_complete: 75.4,
      forecast_complete: 49.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-07-22",
      baseline_complete: 77.5,
      actual_complete: 77.7,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-07-29",
      baseline_complete: 78.5,
      actual_complete: 79.8,
      forecast_complete: 51.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-08-05",
      baseline_complete: 79.5,
      actual_complete: 79.8,
      forecast_complete: 52.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-08-12",
      baseline_complete: 80.5,
      actual_complete: 80.2,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-08-19",
      baseline_complete: 81.4,
      actual_complete: 80.3,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-08-26",
      baseline_complete: 82.3,
      actual_complete: 84.5,
      forecast_complete: 55.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-09-02",
      baseline_complete: 83.1,
      actual_complete: 84.5,
      forecast_complete: 56.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-09-09",
      baseline_complete: 84.0,
      actual_complete: 85.9,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-09-16",
      baseline_complete: 84.7,
      actual_complete: 86.3,
      forecast_complete: 57.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-09-23",
      baseline_complete: 85.5,
      actual_complete: 86.3,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-09-30",
      baseline_complete: 86.2,
      actual_complete: 86.4,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-10-07",
      baseline_complete: 86.9,
      actual_complete: 86.4,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-10-14",
      baseline_complete: 87.6,
      actual_complete: 86.4,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-10-21",
      baseline_complete: 88.2,
      actual_complete: 89.6,
      forecast_complete: 62.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-10-28",
      baseline_complete: 88.8,
      actual_complete: 89.6,
      forecast_complete: 63.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-11-04",
      baseline_complete: 89.4,
      actual_complete: 90.0,
      forecast_complete: 63.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-11-11",
      baseline_complete: 90.0,
      actual_complete: 92.6,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-11-18",
      baseline_complete: 90.5,
      actual_complete: 92.6,
      forecast_complete: 65.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-11-25",
      baseline_complete: 91.0,
      actual_complete: 93.1,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-12-02",
      baseline_complete: 91.5,
      actual_complete: 93.7,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-12-09",
      baseline_complete: 91.9,
      actual_complete: 94.8,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-12-16",
      baseline_complete: 92.4,
      actual_complete: 94.8,
      forecast_complete: 68.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-12-23",
      baseline_complete: 92.8,
      actual_complete: 94.8,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2026-12-30",
      baseline_complete: 93.2,
      actual_complete: 94.8,
      forecast_complete: 70.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-01-06",
      baseline_complete: 93.5,
      actual_complete: 94.8,
      forecast_complete: 71.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-01-13",
      baseline_complete: 93.9,
      actual_complete: 96.1,
      forecast_complete: 73.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-01-20",
      baseline_complete: 94.2,
      actual_complete: 96.1,
      forecast_complete: 74.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-01-27",
      baseline_complete: 94.5,
      actual_complete: 96.1,
      forecast_complete: 75.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-02-03",
      baseline_complete: 94.8,
      actual_complete: 96.1,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-02-10",
      baseline_complete: 95.1,
      actual_complete: 96.1,
      forecast_complete: 77.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-02-17",
      baseline_complete: 95.4,
      actual_complete: 96.1,
      forecast_complete: 78.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-02-24",
      baseline_complete: 95.7,
      actual_complete: 96.1,
      forecast_complete: 79.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-03-03",
      baseline_complete: 95.9,
      actual_complete: 96.1,
      forecast_complete: 80.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-03-10",
      baseline_complete: 96.1,
      actual_complete: 96.7,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-03-17",
      baseline_complete: 96.3,
      actual_complete: 96.7,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-03-24",
      baseline_complete: 96.5,
      actual_complete: 96.7,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-03-31",
      baseline_complete: 96.7,
      actual_complete: 96.7,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-04-07",
      baseline_complete: 96.9,
      actual_complete: 96.7,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-04-14",
      baseline_complete: 97.1,
      actual_complete: 97.9,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-04-21",
      baseline_complete: 97.3,
      actual_complete: 97.9,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-04-28",
      baseline_complete: 97.4,
      actual_complete: 99.5,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-05-05",
      baseline_complete: 97.6,
      actual_complete: 99.5,
      forecast_complete: 87.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-05-12",
      baseline_complete: 97.7,
      actual_complete: 99.5,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-05-19",
      baseline_complete: 97.8,
      actual_complete: 99.5,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-05-26",
      baseline_complete: 98.0,
      actual_complete: 99.5,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-06-02",
      baseline_complete: 98.1,
      actual_complete: 99.5,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-06-09",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-06-16",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-06-23",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 91.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-06-30",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-07-07",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-07-14",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-07-21",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-07-28",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-08-04",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-08-11",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-08-18",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-08-25",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-09-01",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-09-08",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-09-15",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-09-22",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-09-29",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-10-06",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-10-13",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-10-20",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-10-27",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-11-03",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-11-10",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-11-17",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-11-24",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-12-01",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-12-08",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-12-15",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-12-22",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2027-12-29",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2028-01-05",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "0b698afd-36c6-4235-9402-a2857a687c72",
      reporting_date: "2028-01-11",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
  ],
  "74623a58-22b7-cb06-b3d9-9e88fe32967f": [
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-09-14",
      baseline_complete: 0.4,
      actual_complete: 3.8,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-09-21",
      baseline_complete: 0.4,
      actual_complete: 5.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-09-28",
      baseline_complete: 0.4,
      actual_complete: 5.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-10-05",
      baseline_complete: 0.4,
      actual_complete: 5.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-10-12",
      baseline_complete: 0.4,
      actual_complete: 5.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-10-19",
      baseline_complete: 0.5,
      actual_complete: 5.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-10-26",
      baseline_complete: 0.5,
      actual_complete: 6.1,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-11-02",
      baseline_complete: 0.5,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-11-09",
      baseline_complete: 0.5,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-11-16",
      baseline_complete: 0.6,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-11-23",
      baseline_complete: 0.6,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-11-30",
      baseline_complete: 0.6,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-12-07",
      baseline_complete: 0.6,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-12-14",
      baseline_complete: 0.7,
      actual_complete: 7.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-12-21",
      baseline_complete: 0.7,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2023-12-28",
      baseline_complete: 0.7,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-01-04",
      baseline_complete: 0.8,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-01-11",
      baseline_complete: 0.8,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-01-18",
      baseline_complete: 0.8,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-01-25",
      baseline_complete: 0.9,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-02-01",
      baseline_complete: 0.9,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-02-08",
      baseline_complete: 1.0,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-02-15",
      baseline_complete: 1.0,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-02-22",
      baseline_complete: 1.1,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-02-29",
      baseline_complete: 1.1,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-03-07",
      baseline_complete: 1.2,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-03-14",
      baseline_complete: 1.2,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-03-21",
      baseline_complete: 1.3,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-03-28",
      baseline_complete: 1.3,
      actual_complete: 8.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-04-04",
      baseline_complete: 1.4,
      actual_complete: 8.5,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-04-11",
      baseline_complete: 1.5,
      actual_complete: 8.5,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-04-18",
      baseline_complete: 1.5,
      actual_complete: 8.5,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-04-25",
      baseline_complete: 1.6,
      actual_complete: 8.5,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-05-02",
      baseline_complete: 1.7,
      actual_complete: 8.5,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-05-09",
      baseline_complete: 1.8,
      actual_complete: 8.5,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-05-16",
      baseline_complete: 1.9,
      actual_complete: 8.5,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-05-23",
      baseline_complete: 1.9,
      actual_complete: 9.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-05-30",
      baseline_complete: 2.0,
      actual_complete: 9.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-06-06",
      baseline_complete: 2.1,
      actual_complete: 9.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-06-13",
      baseline_complete: 2.2,
      actual_complete: 9.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-06-20",
      baseline_complete: 2.3,
      actual_complete: 9.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-06-27",
      baseline_complete: 2.4,
      actual_complete: 9.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-07-04",
      baseline_complete: 2.6,
      actual_complete: 9.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-07-11",
      baseline_complete: 2.7,
      actual_complete: 9.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-07-18",
      baseline_complete: 2.8,
      actual_complete: 9.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-07-25",
      baseline_complete: 2.9,
      actual_complete: 9.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-08-01",
      baseline_complete: 3.1,
      actual_complete: 9.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-08-08",
      baseline_complete: 3.2,
      actual_complete: 9.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-08-15",
      baseline_complete: 3.3,
      actual_complete: 9.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-08-22",
      baseline_complete: 3.5,
      actual_complete: 10.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-08-29",
      baseline_complete: 3.7,
      actual_complete: 10.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-09-05",
      baseline_complete: 3.8,
      actual_complete: 10.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-09-12",
      baseline_complete: 4.0,
      actual_complete: 10.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-09-19",
      baseline_complete: 4.2,
      actual_complete: 10.2,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-09-26",
      baseline_complete: 4.4,
      actual_complete: 10.8,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-10-03",
      baseline_complete: 4.6,
      actual_complete: 10.8,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-10-10",
      baseline_complete: 4.8,
      actual_complete: 10.8,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-10-17",
      baseline_complete: 5.0,
      actual_complete: 10.8,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-10-24",
      baseline_complete: 5.2,
      actual_complete: 10.8,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-10-31",
      baseline_complete: 5.5,
      actual_complete: 10.8,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-11-07",
      baseline_complete: 5.7,
      actual_complete: 10.8,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-11-14",
      baseline_complete: 6.0,
      actual_complete: 10.8,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-11-21",
      baseline_complete: 6.2,
      actual_complete: 10.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-11-28",
      baseline_complete: 6.5,
      actual_complete: 10.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-12-05",
      baseline_complete: 6.8,
      actual_complete: 10.8,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-12-12",
      baseline_complete: 7.1,
      actual_complete: 10.8,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-12-19",
      baseline_complete: 7.4,
      actual_complete: 13.2,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2024-12-26",
      baseline_complete: 7.7,
      actual_complete: 13.5,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-01-02",
      baseline_complete: 8.1,
      actual_complete: 13.5,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-01-09",
      baseline_complete: 8.4,
      actual_complete: 13.5,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-01-16",
      baseline_complete: 8.8,
      actual_complete: 13.5,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-01-23",
      baseline_complete: 9.2,
      actual_complete: 14.9,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-01-30",
      baseline_complete: 9.6,
      actual_complete: 15.0,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-02-06",
      baseline_complete: 10.0,
      actual_complete: 15.7,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-02-13",
      baseline_complete: 10.4,
      actual_complete: 15.7,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-02-20",
      baseline_complete: 10.9,
      actual_complete: 15.7,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-02-27",
      baseline_complete: 11.3,
      actual_complete: 15.7,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-03-06",
      baseline_complete: 11.8,
      actual_complete: 15.7,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-03-13",
      baseline_complete: 12.3,
      actual_complete: 17.8,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-03-20",
      baseline_complete: 12.8,
      actual_complete: 17.8,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-03-27",
      baseline_complete: 13.3,
      actual_complete: 19.4,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-04-03",
      baseline_complete: 13.9,
      actual_complete: 19.4,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-04-10",
      baseline_complete: 14.5,
      actual_complete: 19.4,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-04-17",
      baseline_complete: 15.0,
      actual_complete: 19.4,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-04-24",
      baseline_complete: 15.6,
      actual_complete: 19.4,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-05-01",
      baseline_complete: 16.3,
      actual_complete: 20.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-05-08",
      baseline_complete: 16.9,
      actual_complete: 22.3,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-05-15",
      baseline_complete: 17.6,
      actual_complete: 22.3,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-05-22",
      baseline_complete: 18.3,
      actual_complete: 23.9,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-05-29",
      baseline_complete: 19.0,
      actual_complete: 24.0,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-06-05",
      baseline_complete: 19.7,
      actual_complete: 24.0,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-06-12",
      baseline_complete: 20.4,
      actual_complete: 24.2,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-06-19",
      baseline_complete: 21.2,
      actual_complete: 24.5,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-06-26",
      baseline_complete: 22.0,
      actual_complete: 26.6,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-07-03",
      baseline_complete: 22.8,
      actual_complete: 26.6,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-07-10",
      baseline_complete: 23.6,
      actual_complete: 27.0,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-07-17",
      baseline_complete: 24.5,
      actual_complete: 27.0,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-07-24",
      baseline_complete: 25.4,
      actual_complete: 30.3,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-07-31",
      baseline_complete: 26.3,
      actual_complete: 30.3,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-08-07",
      baseline_complete: 27.2,
      actual_complete: 32.2,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-08-14",
      baseline_complete: 28.1,
      actual_complete: 32.2,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-08-21",
      baseline_complete: 29.1,
      actual_complete: 34.6,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-08-28",
      baseline_complete: 30.0,
      actual_complete: 35.2,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-09-04",
      baseline_complete: 31.0,
      actual_complete: 35.2,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-09-11",
      baseline_complete: 32.0,
      actual_complete: 35.2,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-09-18",
      baseline_complete: 33.0,
      actual_complete: 36.0,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-09-25",
      baseline_complete: 34.1,
      actual_complete: 36.7,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-10-02",
      baseline_complete: 35.1,
      actual_complete: 36.7,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-10-09",
      baseline_complete: 36.2,
      actual_complete: 39.5,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-10-16",
      baseline_complete: 37.3,
      actual_complete: 39.5,
      forecast_complete: 20.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-10-23",
      baseline_complete: 38.4,
      actual_complete: 41.7,
      forecast_complete: 21.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-10-30",
      baseline_complete: 39.5,
      actual_complete: 42.2,
      forecast_complete: 21.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-11-06",
      baseline_complete: 40.6,
      actual_complete: 43.5,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-11-13",
      baseline_complete: 41.7,
      actual_complete: 43.5,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-11-20",
      baseline_complete: 42.9,
      actual_complete: 49.0,
      forecast_complete: 24.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-11-27",
      baseline_complete: 44.0,
      actual_complete: 49.0,
      forecast_complete: 24.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-12-04",
      baseline_complete: 45.2,
      actual_complete: 49.9,
      forecast_complete: 25.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-12-11",
      baseline_complete: 46.3,
      actual_complete: 50.2,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-12-18",
      baseline_complete: 47.5,
      actual_complete: 53.4,
      forecast_complete: 27.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2025-12-25",
      baseline_complete: 48.7,
      actual_complete: 53.4,
      forecast_complete: 27.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-01-01",
      baseline_complete: 49.8,
      actual_complete: 53.4,
      forecast_complete: 28.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-01-08",
      baseline_complete: 51.0,
      actual_complete: 53.4,
      forecast_complete: 29.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-01-15",
      baseline_complete: 52.2,
      actual_complete: 53.9,
      forecast_complete: 30.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-01-22",
      baseline_complete: 53.3,
      actual_complete: 55.9,
      forecast_complete: 31.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-01-29",
      baseline_complete: 54.5,
      actual_complete: 57.9,
      forecast_complete: 32.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-02-05",
      baseline_complete: 55.6,
      actual_complete: 57.9,
      forecast_complete: 32.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-02-12",
      baseline_complete: 56.8,
      actual_complete: 59.4,
      forecast_complete: 33.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-02-19",
      baseline_complete: 57.9,
      actual_complete: 64.4,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-02-26",
      baseline_complete: 59.1,
      actual_complete: 64.4,
      forecast_complete: 35.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-03-05",
      baseline_complete: 60.2,
      actual_complete: 64.9,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-03-12",
      baseline_complete: 61.3,
      actual_complete: 64.9,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-03-19",
      baseline_complete: 62.4,
      actual_complete: 65.5,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-03-26",
      baseline_complete: 63.5,
      actual_complete: 67.2,
      forecast_complete: 39.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-04-02",
      baseline_complete: 64.5,
      actual_complete: 70.4,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-04-09",
      baseline_complete: 65.6,
      actual_complete: 70.4,
      forecast_complete: 40.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-04-16",
      baseline_complete: 66.7,
      actual_complete: 70.8,
      forecast_complete: 41.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-04-23",
      baseline_complete: 67.7,
      actual_complete: 70.8,
      forecast_complete: 42.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-04-30",
      baseline_complete: 68.7,
      actual_complete: 72.7,
      forecast_complete: 43.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-05-07",
      baseline_complete: 69.7,
      actual_complete: 72.7,
      forecast_complete: 44.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-05-14",
      baseline_complete: 70.7,
      actual_complete: 73.2,
      forecast_complete: 45.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-05-21",
      baseline_complete: 71.6,
      actual_complete: 75.0,
      forecast_complete: 46.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-05-28",
      baseline_complete: 72.6,
      actual_complete: 75.0,
      forecast_complete: 47.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-06-04",
      baseline_complete: 73.5,
      actual_complete: 78.5,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-06-11",
      baseline_complete: 74.4,
      actual_complete: 78.5,
      forecast_complete: 48.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-06-18",
      baseline_complete: 75.2,
      actual_complete: 78.5,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-06-25",
      baseline_complete: 76.1,
      actual_complete: 78.5,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-07-02",
      baseline_complete: 76.9,
      actual_complete: 81.9,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-07-09",
      baseline_complete: 77.8,
      actual_complete: 81.9,
      forecast_complete: 52.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-07-16",
      baseline_complete: 78.6,
      actual_complete: 81.9,
      forecast_complete: 53.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-07-23",
      baseline_complete: 79.3,
      actual_complete: 81.9,
      forecast_complete: 54.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-07-30",
      baseline_complete: 80.1,
      actual_complete: 81.9,
      forecast_complete: 54.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-08-06",
      baseline_complete: 80.8,
      actual_complete: 83.8,
      forecast_complete: 55.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-08-13",
      baseline_complete: 81.5,
      actual_complete: 83.8,
      forecast_complete: 56.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-08-20",
      baseline_complete: 82.2,
      actual_complete: 84.0,
      forecast_complete: 57.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-08-27",
      baseline_complete: 82.9,
      actual_complete: 85.1,
      forecast_complete: 58.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-09-03",
      baseline_complete: 83.5,
      actual_complete: 85.9,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-09-10",
      baseline_complete: 84.2,
      actual_complete: 88.8,
      forecast_complete: 59.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-09-17",
      baseline_complete: 84.8,
      actual_complete: 88.8,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-09-24",
      baseline_complete: 85.4,
      actual_complete: 88.8,
      forecast_complete: 61.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-10-01",
      baseline_complete: 85.9,
      actual_complete: 88.8,
      forecast_complete: 61.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-10-08",
      baseline_complete: 86.5,
      actual_complete: 90.0,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-10-15",
      baseline_complete: 87.0,
      actual_complete: 90.8,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-10-22",
      baseline_complete: 87.6,
      actual_complete: 90.8,
      forecast_complete: 64.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-10-29",
      baseline_complete: 88.1,
      actual_complete: 90.8,
      forecast_complete: 64.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-11-05",
      baseline_complete: 88.5,
      actual_complete: 92.8,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-11-12",
      baseline_complete: 89.0,
      actual_complete: 92.8,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-11-19",
      baseline_complete: 89.4,
      actual_complete: 92.8,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-11-26",
      baseline_complete: 89.9,
      actual_complete: 92.8,
      forecast_complete: 67.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-12-03",
      baseline_complete: 90.3,
      actual_complete: 92.8,
      forecast_complete: 68.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-12-10",
      baseline_complete: 90.7,
      actual_complete: 95.1,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-12-17",
      baseline_complete: 91.1,
      actual_complete: 96.0,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-12-24",
      baseline_complete: 91.5,
      actual_complete: 96.0,
      forecast_complete: 70.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2026-12-31",
      baseline_complete: 91.8,
      actual_complete: 96.0,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-01-07",
      baseline_complete: 92.2,
      actual_complete: 96.0,
      forecast_complete: 73.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-01-14",
      baseline_complete: 92.5,
      actual_complete: 96.0,
      forecast_complete: 74.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-01-21",
      baseline_complete: 92.8,
      actual_complete: 96.0,
      forecast_complete: 75.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-01-28",
      baseline_complete: 93.1,
      actual_complete: 96.0,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-02-04",
      baseline_complete: 93.4,
      actual_complete: 96.0,
      forecast_complete: 77.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-02-11",
      baseline_complete: 93.7,
      actual_complete: 98.4,
      forecast_complete: 78.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-02-18",
      baseline_complete: 94.0,
      actual_complete: 98.4,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-02-25",
      baseline_complete: 94.2,
      actual_complete: 98.4,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-03-04",
      baseline_complete: 94.5,
      actual_complete: 98.4,
      forecast_complete: 81.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-03-11",
      baseline_complete: 94.7,
      actual_complete: 98.4,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-03-18",
      baseline_complete: 94.9,
      actual_complete: 99.2,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-03-25",
      baseline_complete: 95.1,
      actual_complete: 99.2,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-04-01",
      baseline_complete: 95.4,
      actual_complete: 99.2,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-04-08",
      baseline_complete: 95.6,
      actual_complete: 99.2,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-04-15",
      baseline_complete: 95.8,
      actual_complete: 99.2,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-04-22",
      baseline_complete: 95.9,
      actual_complete: 99.2,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-04-29",
      baseline_complete: 96.1,
      actual_complete: 99.2,
      forecast_complete: 87.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-05-06",
      baseline_complete: 96.3,
      actual_complete: 99.5,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-05-13",
      baseline_complete: 96.5,
      actual_complete: 99.5,
      forecast_complete: 89.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-05-20",
      baseline_complete: 96.6,
      actual_complete: 99.5,
      forecast_complete: 89.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-05-27",
      baseline_complete: 96.8,
      actual_complete: 99.6,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-06-03",
      baseline_complete: 96.9,
      actual_complete: 99.6,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-06-10",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-06-17",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-06-24",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-07-01",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-07-08",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-07-15",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-07-22",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-07-29",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-08-05",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-08-12",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-08-19",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-08-26",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-09-02",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-09-09",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-09-16",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-09-23",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-09-30",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-10-07",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-10-14",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-10-21",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-10-28",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-11-04",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-11-11",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-11-18",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-11-25",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-12-02",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-12-09",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-12-16",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-12-23",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2027-12-30",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2028-01-06",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2028-01-13",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "74623a58-22b7-cb06-b3d9-9e88fe32967f",
      reporting_date: "2028-01-14",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "31a15793-a76e-d05e-8807-f79871ea0eed": [
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-07-08",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-07-15",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-07-22",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-07-29",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-08-05",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-08-12",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-08-19",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-08-26",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-09-02",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-09-09",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-09-16",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-09-23",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-09-30",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-10-07",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-10-14",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-10-21",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-10-28",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-11-04",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-11-11",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-11-18",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-11-25",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-12-02",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-12-09",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-12-16",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-12-23",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2025-12-30",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-01-06",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-01-13",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-01-20",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-01-27",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-02-03",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-02-10",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-02-17",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-02-24",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-03-03",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-03-10",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-03-17",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-03-24",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-03-31",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-04-07",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-04-14",
      baseline_complete: 2.9,
      actual_complete: 0.9,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-04-21",
      baseline_complete: 3.1,
      actual_complete: 0.9,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-04-28",
      baseline_complete: 3.3,
      actual_complete: 0.9,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-05-05",
      baseline_complete: 3.5,
      actual_complete: 0.9,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-05-12",
      baseline_complete: 3.7,
      actual_complete: 1.3,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-05-19",
      baseline_complete: 3.9,
      actual_complete: 1.3,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-05-26",
      baseline_complete: 4.1,
      actual_complete: 1.3,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-06-02",
      baseline_complete: 4.4,
      actual_complete: 3.1,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-06-09",
      baseline_complete: 4.6,
      actual_complete: 3.1,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-06-16",
      baseline_complete: 4.9,
      actual_complete: 3.2,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-06-23",
      baseline_complete: 5.2,
      actual_complete: 3.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-06-30",
      baseline_complete: 5.5,
      actual_complete: 3.4,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-07-07",
      baseline_complete: 5.8,
      actual_complete: 3.4,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-07-14",
      baseline_complete: 6.2,
      actual_complete: 3.6,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-07-21",
      baseline_complete: 6.5,
      actual_complete: 3.6,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-07-28",
      baseline_complete: 6.9,
      actual_complete: 5.4,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-08-04",
      baseline_complete: 7.3,
      actual_complete: 5.4,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-08-11",
      baseline_complete: 7.7,
      actual_complete: 5.4,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-08-18",
      baseline_complete: 8.2,
      actual_complete: 6.7,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-08-25",
      baseline_complete: 8.6,
      actual_complete: 6.7,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-09-01",
      baseline_complete: 9.1,
      actual_complete: 7.2,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-09-08",
      baseline_complete: 9.6,
      actual_complete: 7.2,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-09-15",
      baseline_complete: 10.2,
      actual_complete: 7.7,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-09-22",
      baseline_complete: 10.7,
      actual_complete: 7.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-09-29",
      baseline_complete: 11.3,
      actual_complete: 7.7,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-10-06",
      baseline_complete: 12.0,
      actual_complete: 11.3,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-10-13",
      baseline_complete: 12.6,
      actual_complete: 11.5,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-10-20",
      baseline_complete: 13.3,
      actual_complete: 12.2,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-10-27",
      baseline_complete: 14.0,
      actual_complete: 12.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-11-03",
      baseline_complete: 14.7,
      actual_complete: 12.2,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-11-10",
      baseline_complete: 15.5,
      actual_complete: 13.9,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-11-17",
      baseline_complete: 16.3,
      actual_complete: 13.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-11-24",
      baseline_complete: 17.2,
      actual_complete: 15.4,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-12-01",
      baseline_complete: 18.1,
      actual_complete: 16.7,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-12-08",
      baseline_complete: 19.0,
      actual_complete: 16.7,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-12-15",
      baseline_complete: 19.9,
      actual_complete: 16.7,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-12-22",
      baseline_complete: 20.9,
      actual_complete: 20.4,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2026-12-29",
      baseline_complete: 21.9,
      actual_complete: 20.4,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-01-05",
      baseline_complete: 22.9,
      actual_complete: 20.7,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-01-12",
      baseline_complete: 24.0,
      actual_complete: 20.7,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-01-19",
      baseline_complete: 25.2,
      actual_complete: 22.9,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-01-26",
      baseline_complete: 26.3,
      actual_complete: 26.0,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-02-02",
      baseline_complete: 27.5,
      actual_complete: 26.0,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-02-09",
      baseline_complete: 28.7,
      actual_complete: 26.1,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-02-16",
      baseline_complete: 30.0,
      actual_complete: 26.9,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-02-23",
      baseline_complete: 31.2,
      actual_complete: 29.8,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-03-02",
      baseline_complete: 32.6,
      actual_complete: 31.8,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-03-09",
      baseline_complete: 33.9,
      actual_complete: 31.8,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-03-16",
      baseline_complete: 35.3,
      actual_complete: 33.5,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-03-23",
      baseline_complete: 36.7,
      actual_complete: 35.9,
      forecast_complete: 18.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-03-30",
      baseline_complete: 38.1,
      actual_complete: 37.2,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-04-06",
      baseline_complete: 39.5,
      actual_complete: 37.5,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-04-13",
      baseline_complete: 40.9,
      actual_complete: 38.7,
      forecast_complete: 21.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-04-20",
      baseline_complete: 42.4,
      actual_complete: 39.7,
      forecast_complete: 22.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-04-27",
      baseline_complete: 43.9,
      actual_complete: 44.1,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-05-04",
      baseline_complete: 45.4,
      actual_complete: 44.1,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-05-11",
      baseline_complete: 46.9,
      actual_complete: 47.8,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-05-18",
      baseline_complete: 48.4,
      actual_complete: 47.8,
      forecast_complete: 26.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-05-25",
      baseline_complete: 49.9,
      actual_complete: 47.8,
      forecast_complete: 27.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-06-01",
      baseline_complete: 51.4,
      actual_complete: 50.4,
      forecast_complete: 28.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-06-08",
      baseline_complete: 52.9,
      actual_complete: 50.4,
      forecast_complete: 29.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-06-15",
      baseline_complete: 54.4,
      actual_complete: 52.6,
      forecast_complete: 31.1,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-06-22",
      baseline_complete: 55.9,
      actual_complete: 55.8,
      forecast_complete: 32.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-06-29",
      baseline_complete: 57.4,
      actual_complete: 55.8,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-07-06",
      baseline_complete: 58.9,
      actual_complete: 57.7,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-07-13",
      baseline_complete: 60.3,
      actual_complete: 59.3,
      forecast_complete: 35.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-07-20",
      baseline_complete: 61.8,
      actual_complete: 59.8,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-07-27",
      baseline_complete: 63.2,
      actual_complete: 60.5,
      forecast_complete: 38.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-08-03",
      baseline_complete: 64.6,
      actual_complete: 64.8,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-08-10",
      baseline_complete: 65.9,
      actual_complete: 65.8,
      forecast_complete: 40.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-08-17",
      baseline_complete: 67.3,
      actual_complete: 65.8,
      forecast_complete: 42.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-08-24",
      baseline_complete: 68.6,
      actual_complete: 69.0,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-08-31",
      baseline_complete: 69.9,
      actual_complete: 69.8,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-09-07",
      baseline_complete: 71.1,
      actual_complete: 69.8,
      forecast_complete: 45.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-09-14",
      baseline_complete: 72.4,
      actual_complete: 73.1,
      forecast_complete: 46.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-09-21",
      baseline_complete: 73.5,
      actual_complete: 73.1,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-09-28",
      baseline_complete: 74.7,
      actual_complete: 75.4,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-10-05",
      baseline_complete: 75.8,
      actual_complete: 76.3,
      forecast_complete: 50.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-10-12",
      baseline_complete: 76.9,
      actual_complete: 76.3,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-10-19",
      baseline_complete: 78.0,
      actual_complete: 76.3,
      forecast_complete: 52.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-10-26",
      baseline_complete: 79.0,
      actual_complete: 78.7,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-11-02",
      baseline_complete: 80.0,
      actual_complete: 79.8,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-11-09",
      baseline_complete: 80.9,
      actual_complete: 79.8,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-11-16",
      baseline_complete: 81.8,
      actual_complete: 83.0,
      forecast_complete: 57.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-11-23",
      baseline_complete: 82.7,
      actual_complete: 83.0,
      forecast_complete: 58.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-11-30",
      baseline_complete: 83.6,
      actual_complete: 83.0,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-12-07",
      baseline_complete: 84.4,
      actual_complete: 83.7,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-12-14",
      baseline_complete: 85.2,
      actual_complete: 85.6,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-12-21",
      baseline_complete: 85.9,
      actual_complete: 87.6,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2027-12-28",
      baseline_complete: 86.6,
      actual_complete: 87.6,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-01-04",
      baseline_complete: 87.3,
      actual_complete: 87.6,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-01-11",
      baseline_complete: 88.0,
      actual_complete: 88.6,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-01-18",
      baseline_complete: 88.6,
      actual_complete: 88.6,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-01-25",
      baseline_complete: 89.2,
      actual_complete: 91.0,
      forecast_complete: 68.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-02-01",
      baseline_complete: 89.7,
      actual_complete: 91.0,
      forecast_complete: 70.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-02-08",
      baseline_complete: 90.3,
      actual_complete: 91.0,
      forecast_complete: 71.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-02-15",
      baseline_complete: 90.8,
      actual_complete: 92.3,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-02-22",
      baseline_complete: 91.3,
      actual_complete: 93.2,
      forecast_complete: 74.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-02-29",
      baseline_complete: 91.8,
      actual_complete: 93.2,
      forecast_complete: 76.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-03-07",
      baseline_complete: 92.2,
      actual_complete: 93.4,
      forecast_complete: 77.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-03-14",
      baseline_complete: 92.6,
      actual_complete: 93.4,
      forecast_complete: 78.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-03-21",
      baseline_complete: 93.0,
      actual_complete: 94.4,
      forecast_complete: 80.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-03-28",
      baseline_complete: 93.4,
      actual_complete: 94.5,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-04-04",
      baseline_complete: 93.8,
      actual_complete: 94.5,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-04-11",
      baseline_complete: 94.1,
      actual_complete: 95.6,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-04-18",
      baseline_complete: 94.4,
      actual_complete: 95.6,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-04-25",
      baseline_complete: 94.8,
      actual_complete: 95.6,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-05-02",
      baseline_complete: 95.0,
      actual_complete: 97.1,
      forecast_complete: 86.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-05-09",
      baseline_complete: 95.3,
      actual_complete: 97.1,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-05-16",
      baseline_complete: 95.6,
      actual_complete: 98.1,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-05-23",
      baseline_complete: 95.8,
      actual_complete: 98.1,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-05-30",
      baseline_complete: 96.1,
      actual_complete: 98.1,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-06-06",
      baseline_complete: 96.3,
      actual_complete: 98.1,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-06-13",
      baseline_complete: 96.5,
      actual_complete: 98.4,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-06-20",
      baseline_complete: 96.7,
      actual_complete: 98.4,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-06-27",
      baseline_complete: 96.9,
      actual_complete: 98.4,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-07-04",
      baseline_complete: 97.1,
      actual_complete: 98.4,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-07-11",
      baseline_complete: 97.2,
      actual_complete: 98.4,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-07-18",
      baseline_complete: 97.4,
      actual_complete: 98.7,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-07-25",
      baseline_complete: 97.5,
      actual_complete: 98.7,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-08-01",
      baseline_complete: 97.7,
      actual_complete: 98.7,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-08-08",
      baseline_complete: 97.8,
      actual_complete: 98.7,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-08-15",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-08-22",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-08-29",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-09-05",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-09-12",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-09-19",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-09-26",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-10-03",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-10-10",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-10-17",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-10-24",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-10-31",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-11-07",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "31a15793-a76e-d05e-8807-f79871ea0eed",
      reporting_date: "2028-11-08",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
  ],
  "161fea57-5db2-e08b-9f55-7859e6e5fad3": [
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-03-03",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-03-10",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-03-17",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-03-24",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-03-31",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-04-07",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-04-14",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-04-21",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-04-28",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-05-05",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-05-12",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-05-19",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-05-26",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-06-02",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-06-09",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-06-16",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-06-23",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-06-30",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-07-07",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-07-14",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-07-21",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-07-28",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-08-04",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-08-11",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-08-18",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-08-25",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-09-01",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-09-08",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-09-15",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-09-22",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-09-29",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-10-06",
      baseline_complete: 3.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-10-13",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-10-20",
      baseline_complete: 4.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-10-27",
      baseline_complete: 4.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-11-03",
      baseline_complete: 4.6,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-11-10",
      baseline_complete: 4.8,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-11-17",
      baseline_complete: 5.1,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-11-24",
      baseline_complete: 5.3,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-12-01",
      baseline_complete: 5.6,
      actual_complete: 0.5,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-12-08",
      baseline_complete: 5.9,
      actual_complete: 0.6,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-12-15",
      baseline_complete: 6.2,
      actual_complete: 0.6,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-12-22",
      baseline_complete: 6.5,
      actual_complete: 0.6,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2024-12-29",
      baseline_complete: 6.8,
      actual_complete: 0.6,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-01-05",
      baseline_complete: 7.2,
      actual_complete: 3.3,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-01-12",
      baseline_complete: 7.6,
      actual_complete: 3.3,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-01-19",
      baseline_complete: 7.9,
      actual_complete: 4.8,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-01-26",
      baseline_complete: 8.3,
      actual_complete: 4.8,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-02-02",
      baseline_complete: 8.8,
      actual_complete: 4.8,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-02-09",
      baseline_complete: 9.2,
      actual_complete: 4.8,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-02-16",
      baseline_complete: 9.6,
      actual_complete: 6.3,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-02-23",
      baseline_complete: 10.1,
      actual_complete: 6.3,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-03-02",
      baseline_complete: 10.6,
      actual_complete: 6.3,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-03-09",
      baseline_complete: 11.1,
      actual_complete: 6.3,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-03-16",
      baseline_complete: 11.7,
      actual_complete: 6.3,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-03-23",
      baseline_complete: 12.2,
      actual_complete: 8.4,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-03-30",
      baseline_complete: 12.8,
      actual_complete: 10.5,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-04-06",
      baseline_complete: 13.4,
      actual_complete: 10.5,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-04-13",
      baseline_complete: 14.1,
      actual_complete: 10.5,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-04-20",
      baseline_complete: 14.7,
      actual_complete: 11.3,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-04-27",
      baseline_complete: 15.4,
      actual_complete: 11.3,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-05-04",
      baseline_complete: 16.1,
      actual_complete: 13.8,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-05-11",
      baseline_complete: 16.9,
      actual_complete: 13.8,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-05-18",
      baseline_complete: 17.6,
      actual_complete: 13.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-05-25",
      baseline_complete: 18.4,
      actual_complete: 16.4,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-06-01",
      baseline_complete: 19.2,
      actual_complete: 16.4,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-06-08",
      baseline_complete: 20.1,
      actual_complete: 16.4,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-06-15",
      baseline_complete: 21.0,
      actual_complete: 17.4,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-06-22",
      baseline_complete: 21.9,
      actual_complete: 19.3,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-06-29",
      baseline_complete: 22.8,
      actual_complete: 20.1,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-07-06",
      baseline_complete: 23.8,
      actual_complete: 20.1,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-07-13",
      baseline_complete: 24.7,
      actual_complete: 20.1,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-07-20",
      baseline_complete: 25.7,
      actual_complete: 21.8,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-07-27",
      baseline_complete: 26.8,
      actual_complete: 21.8,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-08-03",
      baseline_complete: 27.8,
      actual_complete: 22.6,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-08-10",
      baseline_complete: 28.9,
      actual_complete: 25.8,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-08-17",
      baseline_complete: 30.0,
      actual_complete: 25.8,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-08-24",
      baseline_complete: 31.2,
      actual_complete: 27.7,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-08-31",
      baseline_complete: 32.3,
      actual_complete: 27.9,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-09-07",
      baseline_complete: 33.5,
      actual_complete: 30.4,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-09-14",
      baseline_complete: 34.7,
      actual_complete: 30.4,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-09-21",
      baseline_complete: 36.0,
      actual_complete: 30.9,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-09-28",
      baseline_complete: 37.2,
      actual_complete: 33.8,
      forecast_complete: 17.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-10-05",
      baseline_complete: 38.5,
      actual_complete: 33.8,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-10-12",
      baseline_complete: 39.7,
      actual_complete: 36.1,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-10-19",
      baseline_complete: 41.0,
      actual_complete: 37.0,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-10-26",
      baseline_complete: 42.3,
      actual_complete: 37.1,
      forecast_complete: 20.5,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-11-02",
      baseline_complete: 43.6,
      actual_complete: 43.5,
      forecast_complete: 21.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-11-09",
      baseline_complete: 44.9,
      actual_complete: 43.6,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-11-16",
      baseline_complete: 46.3,
      actual_complete: 43.6,
      forecast_complete: 23.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-11-23",
      baseline_complete: 47.6,
      actual_complete: 45.7,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-11-30",
      baseline_complete: 48.9,
      actual_complete: 45.7,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-12-07",
      baseline_complete: 50.3,
      actual_complete: 47.2,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-12-14",
      baseline_complete: 51.6,
      actual_complete: 50.5,
      forecast_complete: 27.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-12-21",
      baseline_complete: 53.0,
      actual_complete: 50.5,
      forecast_complete: 28.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2025-12-28",
      baseline_complete: 54.3,
      actual_complete: 53.6,
      forecast_complete: 29.5,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-01-04",
      baseline_complete: 55.6,
      actual_complete: 53.6,
      forecast_complete: 30.5,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-01-11",
      baseline_complete: 56.9,
      actual_complete: 54.5,
      forecast_complete: 31.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-01-18",
      baseline_complete: 58.2,
      actual_complete: 55.2,
      forecast_complete: 32.7,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-01-25",
      baseline_complete: 59.5,
      actual_complete: 55.2,
      forecast_complete: 33.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-02-01",
      baseline_complete: 60.8,
      actual_complete: 56.3,
      forecast_complete: 34.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-02-08",
      baseline_complete: 62.1,
      actual_complete: 56.3,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-02-15",
      baseline_complete: 63.3,
      actual_complete: 60.2,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-02-22",
      baseline_complete: 64.6,
      actual_complete: 60.2,
      forecast_complete: 38.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-03-01",
      baseline_complete: 65.8,
      actual_complete: 61.8,
      forecast_complete: 39.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-03-08",
      baseline_complete: 67.0,
      actual_complete: 64.4,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-03-15",
      baseline_complete: 68.2,
      actual_complete: 66.4,
      forecast_complete: 41.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-03-22",
      baseline_complete: 69.3,
      actual_complete: 66.4,
      forecast_complete: 42.7,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-03-29",
      baseline_complete: 70.4,
      actual_complete: 66.4,
      forecast_complete: 43.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-04-05",
      baseline_complete: 71.5,
      actual_complete: 67.2,
      forecast_complete: 45.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-04-12",
      baseline_complete: 72.6,
      actual_complete: 69.7,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-04-19",
      baseline_complete: 73.7,
      actual_complete: 69.7,
      forecast_complete: 47.2,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-04-26",
      baseline_complete: 74.7,
      actual_complete: 69.7,
      forecast_complete: 48.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-05-03",
      baseline_complete: 75.7,
      actual_complete: 73.6,
      forecast_complete: 49.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-05-10",
      baseline_complete: 76.7,
      actual_complete: 77.6,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-05-17",
      baseline_complete: 77.6,
      actual_complete: 77.6,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-05-24",
      baseline_complete: 78.5,
      actual_complete: 77.6,
      forecast_complete: 52.7,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-05-31",
      baseline_complete: 79.4,
      actual_complete: 80.8,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-06-07",
      baseline_complete: 80.3,
      actual_complete: 80.8,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-06-14",
      baseline_complete: 81.1,
      actual_complete: 80.8,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-06-21",
      baseline_complete: 81.9,
      actual_complete: 80.8,
      forecast_complete: 56.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-06-28",
      baseline_complete: 82.7,
      actual_complete: 84.1,
      forecast_complete: 58.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-07-05",
      baseline_complete: 83.4,
      actual_complete: 84.1,
      forecast_complete: 59.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-07-12",
      baseline_complete: 84.2,
      actual_complete: 84.1,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-07-19",
      baseline_complete: 84.9,
      actual_complete: 85.0,
      forecast_complete: 61.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-07-26",
      baseline_complete: 85.5,
      actual_complete: 85.0,
      forecast_complete: 62.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-08-02",
      baseline_complete: 86.2,
      actual_complete: 85.0,
      forecast_complete: 63.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-08-09",
      baseline_complete: 86.8,
      actual_complete: 85.0,
      forecast_complete: 64.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-08-16",
      baseline_complete: 87.4,
      actual_complete: 85.3,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-08-23",
      baseline_complete: 88.0,
      actual_complete: 85.3,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-08-30",
      baseline_complete: 88.5,
      actual_complete: 86.6,
      forecast_complete: 68.7,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-09-06",
      baseline_complete: 89.1,
      actual_complete: 86.6,
      forecast_complete: 70.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-09-13",
      baseline_complete: 89.6,
      actual_complete: 87.9,
      forecast_complete: 71.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-09-20",
      baseline_complete: 90.1,
      actual_complete: 91.3,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-09-27",
      baseline_complete: 90.5,
      actual_complete: 91.3,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-10-04",
      baseline_complete: 91.0,
      actual_complete: 91.3,
      forecast_complete: 76.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-10-11",
      baseline_complete: 91.4,
      actual_complete: 91.8,
      forecast_complete: 77.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-10-18",
      baseline_complete: 91.8,
      actual_complete: 91.8,
      forecast_complete: 78.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-10-25",
      baseline_complete: 92.2,
      actual_complete: 95.2,
      forecast_complete: 80.2,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-11-01",
      baseline_complete: 92.6,
      actual_complete: 95.2,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-11-08",
      baseline_complete: 93.0,
      actual_complete: 95.2,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-11-15",
      baseline_complete: 93.3,
      actual_complete: 95.2,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-11-22",
      baseline_complete: 93.6,
      actual_complete: 95.2,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-11-29",
      baseline_complete: 93.9,
      actual_complete: 95.2,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-12-06",
      baseline_complete: 94.2,
      actual_complete: 96.0,
      forecast_complete: 86.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-12-13",
      baseline_complete: 94.5,
      actual_complete: 96.0,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-12-20",
      baseline_complete: 94.8,
      actual_complete: 96.0,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2026-12-27",
      baseline_complete: 95.1,
      actual_complete: 96.0,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-01-03",
      baseline_complete: 95.3,
      actual_complete: 97.5,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-01-10",
      baseline_complete: 95.5,
      actual_complete: 97.5,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-01-17",
      baseline_complete: 95.8,
      actual_complete: 97.5,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-01-24",
      baseline_complete: 96.0,
      actual_complete: 97.5,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-01-31",
      baseline_complete: 96.2,
      actual_complete: 99.3,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-02-07",
      baseline_complete: 96.4,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-02-14",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-02-21",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-02-28",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-03-07",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-03-14",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-03-21",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-03-28",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-04-04",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-04-11",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-04-18",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-04-25",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-05-02",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-05-09",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-05-16",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-05-23",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-05-30",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "161fea57-5db2-e08b-9f55-7859e6e5fad3",
      reporting_date: "2027-06-03",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
  ],
  "e976743b-f55b-12fb-ed5f-9f4687bba65c": [
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-02-19",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-02-26",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-03-04",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-03-11",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-03-18",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-03-25",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-04-01",
      baseline_complete: 1.3,
      actual_complete: 0.4,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-04-08",
      baseline_complete: 1.4,
      actual_complete: 0.4,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-04-15",
      baseline_complete: 1.5,
      actual_complete: 1.1,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-04-22",
      baseline_complete: 1.6,
      actual_complete: 1.1,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-04-29",
      baseline_complete: 1.7,
      actual_complete: 1.1,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-05-06",
      baseline_complete: 1.8,
      actual_complete: 1.1,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-05-13",
      baseline_complete: 1.9,
      actual_complete: 1.1,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-05-20",
      baseline_complete: 2.1,
      actual_complete: 2.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-05-27",
      baseline_complete: 2.2,
      actual_complete: 2.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-06-03",
      baseline_complete: 2.4,
      actual_complete: 2.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-06-10",
      baseline_complete: 2.5,
      actual_complete: 2.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-06-17",
      baseline_complete: 2.7,
      actual_complete: 2.2,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-06-24",
      baseline_complete: 2.9,
      actual_complete: 2.2,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-07-01",
      baseline_complete: 3.0,
      actual_complete: 2.2,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-07-08",
      baseline_complete: 3.2,
      actual_complete: 2.3,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-07-15",
      baseline_complete: 3.4,
      actual_complete: 2.3,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-07-22",
      baseline_complete: 3.7,
      actual_complete: 2.3,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-07-29",
      baseline_complete: 3.9,
      actual_complete: 2.3,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-08-05",
      baseline_complete: 4.2,
      actual_complete: 2.3,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-08-12",
      baseline_complete: 4.4,
      actual_complete: 2.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-08-19",
      baseline_complete: 4.7,
      actual_complete: 2.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-08-26",
      baseline_complete: 5.0,
      actual_complete: 5.3,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-09-02",
      baseline_complete: 5.3,
      actual_complete: 5.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-09-09",
      baseline_complete: 5.7,
      actual_complete: 5.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-09-16",
      baseline_complete: 6.1,
      actual_complete: 5.3,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-09-23",
      baseline_complete: 6.4,
      actual_complete: 5.3,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-09-30",
      baseline_complete: 6.8,
      actual_complete: 5.3,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-10-07",
      baseline_complete: 7.3,
      actual_complete: 5.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-10-14",
      baseline_complete: 7.7,
      actual_complete: 6.0,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-10-21",
      baseline_complete: 8.2,
      actual_complete: 9.0,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-10-28",
      baseline_complete: 8.7,
      actual_complete: 9.0,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-11-04",
      baseline_complete: 9.2,
      actual_complete: 9.0,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-11-11",
      baseline_complete: 9.8,
      actual_complete: 9.0,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-11-18",
      baseline_complete: 10.4,
      actual_complete: 9.0,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-11-25",
      baseline_complete: 11.0,
      actual_complete: 9.0,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-12-02",
      baseline_complete: 11.7,
      actual_complete: 11.8,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-12-09",
      baseline_complete: 12.4,
      actual_complete: 13.2,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-12-16",
      baseline_complete: 13.1,
      actual_complete: 13.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-12-23",
      baseline_complete: 13.9,
      actual_complete: 13.8,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2024-12-30",
      baseline_complete: 14.7,
      actual_complete: 13.8,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-01-06",
      baseline_complete: 15.5,
      actual_complete: 14.4,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-01-13",
      baseline_complete: 16.4,
      actual_complete: 14.4,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-01-20",
      baseline_complete: 17.3,
      actual_complete: 14.4,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-01-27",
      baseline_complete: 18.3,
      actual_complete: 15.7,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-02-03",
      baseline_complete: 19.3,
      actual_complete: 15.7,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-02-10",
      baseline_complete: 20.3,
      actual_complete: 21.3,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-02-17",
      baseline_complete: 21.4,
      actual_complete: 21.3,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-02-24",
      baseline_complete: 22.5,
      actual_complete: 23.1,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-03-03",
      baseline_complete: 23.7,
      actual_complete: 23.4,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-03-10",
      baseline_complete: 24.9,
      actual_complete: 23.4,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-03-17",
      baseline_complete: 26.1,
      actual_complete: 27.4,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-03-24",
      baseline_complete: 27.4,
      actual_complete: 28.5,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-03-31",
      baseline_complete: 28.7,
      actual_complete: 29.2,
      forecast_complete: 12.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-04-07",
      baseline_complete: 30.1,
      actual_complete: 29.3,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-04-14",
      baseline_complete: 31.5,
      actual_complete: 30.5,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-04-21",
      baseline_complete: 32.9,
      actual_complete: 30.5,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-04-28",
      baseline_complete: 34.4,
      actual_complete: 35.9,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-05-05",
      baseline_complete: 35.9,
      actual_complete: 35.9,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-05-12",
      baseline_complete: 37.4,
      actual_complete: 38.4,
      forecast_complete: 17.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-05-19",
      baseline_complete: 39.0,
      actual_complete: 38.4,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-05-26",
      baseline_complete: 40.5,
      actual_complete: 38.8,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-06-02",
      baseline_complete: 42.1,
      actual_complete: 43.8,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-06-09",
      baseline_complete: 43.7,
      actual_complete: 43.8,
      forecast_complete: 20.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-06-16",
      baseline_complete: 45.3,
      actual_complete: 46.9,
      forecast_complete: 21.4,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-06-23",
      baseline_complete: 47.0,
      actual_complete: 48.6,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-06-30",
      baseline_complete: 48.6,
      actual_complete: 48.6,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-07-07",
      baseline_complete: 50.2,
      actual_complete: 52.4,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-07-14",
      baseline_complete: 51.9,
      actual_complete: 52.4,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-07-21",
      baseline_complete: 53.5,
      actual_complete: 52.4,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-07-28",
      baseline_complete: 55.1,
      actual_complete: 53.9,
      forecast_complete: 27.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-08-04",
      baseline_complete: 56.7,
      actual_complete: 56.5,
      forecast_complete: 28.4,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-08-11",
      baseline_complete: 58.3,
      actual_complete: 56.5,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-08-18",
      baseline_complete: 59.9,
      actual_complete: 60.6,
      forecast_complete: 30.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-08-25",
      baseline_complete: 61.5,
      actual_complete: 60.6,
      forecast_complete: 31.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-09-01",
      baseline_complete: 63.0,
      actual_complete: 60.8,
      forecast_complete: 32.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-09-08",
      baseline_complete: 64.5,
      actual_complete: 60.8,
      forecast_complete: 33.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-09-15",
      baseline_complete: 66.0,
      actual_complete: 61.3,
      forecast_complete: 34.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-09-22",
      baseline_complete: 67.5,
      actual_complete: 63.7,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-09-29",
      baseline_complete: 68.9,
      actual_complete: 65.8,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-10-06",
      baseline_complete: 70.3,
      actual_complete: 70.8,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-10-13",
      baseline_complete: 71.6,
      actual_complete: 74.1,
      forecast_complete: 39.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-10-20",
      baseline_complete: 72.9,
      actual_complete: 75.7,
      forecast_complete: 40.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-10-27",
      baseline_complete: 74.2,
      actual_complete: 75.9,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-11-03",
      baseline_complete: 75.5,
      actual_complete: 75.9,
      forecast_complete: 42.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-11-10",
      baseline_complete: 76.6,
      actual_complete: 75.9,
      forecast_complete: 43.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-11-17",
      baseline_complete: 77.8,
      actual_complete: 79.6,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-11-24",
      baseline_complete: 78.9,
      actual_complete: 79.6,
      forecast_complete: 45.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-12-01",
      baseline_complete: 80.0,
      actual_complete: 80.6,
      forecast_complete: 46.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-12-08",
      baseline_complete: 81.0,
      actual_complete: 80.6,
      forecast_complete: 47.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-12-15",
      baseline_complete: 82.0,
      actual_complete: 83.1,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-12-22",
      baseline_complete: 82.9,
      actual_complete: 83.1,
      forecast_complete: 49.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2025-12-29",
      baseline_complete: 83.8,
      actual_complete: 84.7,
      forecast_complete: 50.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-01-05",
      baseline_complete: 84.7,
      actual_complete: 85.3,
      forecast_complete: 51.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-01-12",
      baseline_complete: 85.5,
      actual_complete: 86.4,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-01-19",
      baseline_complete: 86.3,
      actual_complete: 86.4,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-01-26",
      baseline_complete: 87.1,
      actual_complete: 86.4,
      forecast_complete: 54.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-02-02",
      baseline_complete: 87.8,
      actual_complete: 86.4,
      forecast_complete: 55.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-02-09",
      baseline_complete: 88.5,
      actual_complete: 89.7,
      forecast_complete: 56.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-02-16",
      baseline_complete: 89.1,
      actual_complete: 89.7,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-02-23",
      baseline_complete: 89.8,
      actual_complete: 91.2,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-03-02",
      baseline_complete: 90.3,
      actual_complete: 92.6,
      forecast_complete: 59.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-03-09",
      baseline_complete: 90.9,
      actual_complete: 92.7,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-03-16",
      baseline_complete: 91.4,
      actual_complete: 92.7,
      forecast_complete: 61.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-03-23",
      baseline_complete: 91.9,
      actual_complete: 94.1,
      forecast_complete: 61.9,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-03-30",
      baseline_complete: 92.4,
      actual_complete: 94.1,
      forecast_complete: 62.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-04-06",
      baseline_complete: 92.9,
      actual_complete: 94.1,
      forecast_complete: 63.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-04-13",
      baseline_complete: 93.3,
      actual_complete: 94.1,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-04-20",
      baseline_complete: 93.7,
      actual_complete: 96.9,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-04-27",
      baseline_complete: 94.1,
      actual_complete: 96.9,
      forecast_complete: 66.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-05-04",
      baseline_complete: 94.4,
      actual_complete: 96.9,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-05-11",
      baseline_complete: 94.7,
      actual_complete: 96.9,
      forecast_complete: 67.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-05-18",
      baseline_complete: 95.1,
      actual_complete: 96.9,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-05-25",
      baseline_complete: 95.4,
      actual_complete: 96.9,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-06-01",
      baseline_complete: 95.6,
      actual_complete: 98.9,
      forecast_complete: 69.9,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-06-08",
      baseline_complete: 95.9,
      actual_complete: 98.9,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-06-15",
      baseline_complete: 96.2,
      actual_complete: 98.9,
      forecast_complete: 71.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-06-22",
      baseline_complete: 96.4,
      actual_complete: 98.9,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-06-29",
      baseline_complete: 96.6,
      actual_complete: 100.0,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-07-06",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 73.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-07-13",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 74.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-07-20",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 75.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-07-27",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 75.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-08-03",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 76.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-08-10",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 78.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-08-17",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 79.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-08-24",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 80.5,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-08-31",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 81.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-09-07",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 82.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-09-14",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-09-21",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 85.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-09-28",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-10-05",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-10-12",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-10-19",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 89.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-10-26",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-11-02",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-11-09",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-11-16",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-11-23",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-11-30",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-12-07",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-12-14",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-12-21",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2026-12-28",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-01-04",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-01-11",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-01-18",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-01-25",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-02-01",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-02-08",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-02-15",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-02-22",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-03-01",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-03-08",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-03-15",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-03-22",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-03-29",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-04-05",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-04-12",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-04-19",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-04-26",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-05-03",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-05-10",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-05-17",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e976743b-f55b-12fb-ed5f-9f4687bba65c",
      reporting_date: "2027-05-19",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "3992f128-09f6-9021-4634-d7804c356132": [
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-04-23",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-04-30",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-05-07",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-05-14",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-05-21",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-05-28",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-06-04",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-06-11",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-06-18",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-06-25",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-07-02",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-07-09",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-07-16",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-07-23",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-07-30",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-08-06",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-08-13",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-08-20",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-08-27",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-09-03",
      baseline_complete: 0.8,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-09-10",
      baseline_complete: 0.8,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-09-17",
      baseline_complete: 0.9,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-09-24",
      baseline_complete: 1.0,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-10-01",
      baseline_complete: 1.1,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-10-08",
      baseline_complete: 1.2,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-10-15",
      baseline_complete: 1.3,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-10-22",
      baseline_complete: 1.4,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-10-29",
      baseline_complete: 1.5,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-11-05",
      baseline_complete: 1.6,
      actual_complete: 1.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-11-12",
      baseline_complete: 1.8,
      actual_complete: 1.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-11-19",
      baseline_complete: 1.9,
      actual_complete: 1.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-11-26",
      baseline_complete: 2.1,
      actual_complete: 1.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-12-03",
      baseline_complete: 2.2,
      actual_complete: 1.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-12-10",
      baseline_complete: 2.4,
      actual_complete: 1.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-12-17",
      baseline_complete: 2.6,
      actual_complete: 1.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-12-24",
      baseline_complete: 2.8,
      actual_complete: 1.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2024-12-31",
      baseline_complete: 3.1,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-01-07",
      baseline_complete: 3.3,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-01-14",
      baseline_complete: 3.6,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-01-21",
      baseline_complete: 3.9,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-01-28",
      baseline_complete: 4.2,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-02-04",
      baseline_complete: 4.6,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-02-11",
      baseline_complete: 4.9,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-02-18",
      baseline_complete: 5.4,
      actual_complete: 2.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-02-25",
      baseline_complete: 5.8,
      actual_complete: 4.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-03-04",
      baseline_complete: 6.2,
      actual_complete: 4.6,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-03-11",
      baseline_complete: 6.7,
      actual_complete: 6.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-03-18",
      baseline_complete: 7.3,
      actual_complete: 6.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-03-25",
      baseline_complete: 7.9,
      actual_complete: 6.1,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-04-01",
      baseline_complete: 8.5,
      actual_complete: 6.1,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-04-08",
      baseline_complete: 9.1,
      actual_complete: 6.2,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-04-15",
      baseline_complete: 9.8,
      actual_complete: 6.2,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-04-22",
      baseline_complete: 10.6,
      actual_complete: 8.4,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-04-29",
      baseline_complete: 11.4,
      actual_complete: 11.7,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-05-06",
      baseline_complete: 12.3,
      actual_complete: 12.7,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-05-13",
      baseline_complete: 13.2,
      actual_complete: 12.7,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-05-20",
      baseline_complete: 14.1,
      actual_complete: 12.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-05-27",
      baseline_complete: 15.2,
      actual_complete: 13.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-06-03",
      baseline_complete: 16.2,
      actual_complete: 16.8,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-06-10",
      baseline_complete: 17.4,
      actual_complete: 16.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-06-17",
      baseline_complete: 18.6,
      actual_complete: 16.8,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-06-24",
      baseline_complete: 19.9,
      actual_complete: 18.7,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-07-01",
      baseline_complete: 21.2,
      actual_complete: 18.7,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-07-08",
      baseline_complete: 22.6,
      actual_complete: 18.7,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-07-15",
      baseline_complete: 24.1,
      actual_complete: 18.8,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-07-22",
      baseline_complete: 25.6,
      actual_complete: 21.1,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-07-29",
      baseline_complete: 27.2,
      actual_complete: 26.1,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-08-05",
      baseline_complete: 28.9,
      actual_complete: 26.1,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-08-12",
      baseline_complete: 30.6,
      actual_complete: 28.1,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-08-19",
      baseline_complete: 32.4,
      actual_complete: 30.2,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-08-26",
      baseline_complete: 34.2,
      actual_complete: 33.3,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-09-02",
      baseline_complete: 36.1,
      actual_complete: 33.3,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-09-09",
      baseline_complete: 38.0,
      actual_complete: 35.5,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-09-16",
      baseline_complete: 39.9,
      actual_complete: 41.5,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-09-23",
      baseline_complete: 41.9,
      actual_complete: 41.5,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-09-30",
      baseline_complete: 43.9,
      actual_complete: 41.5,
      forecast_complete: 20.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-10-07",
      baseline_complete: 46.0,
      actual_complete: 43.1,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-10-14",
      baseline_complete: 48.0,
      actual_complete: 43.1,
      forecast_complete: 22.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-10-21",
      baseline_complete: 50.1,
      actual_complete: 48.2,
      forecast_complete: 24.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-10-28",
      baseline_complete: 52.1,
      actual_complete: 49.4,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-11-04",
      baseline_complete: 54.2,
      actual_complete: 49.4,
      forecast_complete: 26.9,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-11-11",
      baseline_complete: 56.2,
      actual_complete: 57.3,
      forecast_complete: 28.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-11-18",
      baseline_complete: 58.2,
      actual_complete: 57.3,
      forecast_complete: 29.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-11-25",
      baseline_complete: 60.2,
      actual_complete: 57.3,
      forecast_complete: 31.2,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-12-02",
      baseline_complete: 62.2,
      actual_complete: 57.8,
      forecast_complete: 32.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-12-09",
      baseline_complete: 64.1,
      actual_complete: 64.6,
      forecast_complete: 34.2,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-12-16",
      baseline_complete: 65.9,
      actual_complete: 64.6,
      forecast_complete: 35.6,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-12-23",
      baseline_complete: 67.8,
      actual_complete: 64.6,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2025-12-30",
      baseline_complete: 69.5,
      actual_complete: 67.9,
      forecast_complete: 38.6,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-01-06",
      baseline_complete: 71.2,
      actual_complete: 71.7,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-01-13",
      baseline_complete: 72.9,
      actual_complete: 73.8,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-01-20",
      baseline_complete: 74.5,
      actual_complete: 74.9,
      forecast_complete: 42.9,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-01-27",
      baseline_complete: 76.0,
      actual_complete: 76.2,
      forecast_complete: 44.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-02-03",
      baseline_complete: 77.5,
      actual_complete: 76.2,
      forecast_complete: 45.8,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-02-10",
      baseline_complete: 78.9,
      actual_complete: 77.4,
      forecast_complete: 47.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-02-17",
      baseline_complete: 80.2,
      actual_complete: 80.1,
      forecast_complete: 48.5,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-02-24",
      baseline_complete: 81.5,
      actual_complete: 82.9,
      forecast_complete: 49.8,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-03-03",
      baseline_complete: 82.7,
      actual_complete: 82.9,
      forecast_complete: 51.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-03-10",
      baseline_complete: 83.8,
      actual_complete: 82.9,
      forecast_complete: 52.4,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-03-17",
      baseline_complete: 84.9,
      actual_complete: 82.9,
      forecast_complete: 53.6,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-03-24",
      baseline_complete: 85.9,
      actual_complete: 83.3,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-03-31",
      baseline_complete: 86.9,
      actual_complete: 84.5,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-04-07",
      baseline_complete: 87.8,
      actual_complete: 88.5,
      forecast_complete: 57.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-04-14",
      baseline_complete: 88.7,
      actual_complete: 89.6,
      forecast_complete: 58.4,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-04-21",
      baseline_complete: 89.5,
      actual_complete: 89.6,
      forecast_complete: 59.6,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-04-28",
      baseline_complete: 90.2,
      actual_complete: 89.6,
      forecast_complete: 60.6,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-05-05",
      baseline_complete: 90.9,
      actual_complete: 92.8,
      forecast_complete: 61.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-05-12",
      baseline_complete: 91.6,
      actual_complete: 92.8,
      forecast_complete: 62.8,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-05-19",
      baseline_complete: 92.2,
      actual_complete: 92.8,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-05-26",
      baseline_complete: 92.8,
      actual_complete: 92.8,
      forecast_complete: 64.9,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-06-02",
      baseline_complete: 93.3,
      actual_complete: 92.8,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-06-09",
      baseline_complete: 93.8,
      actual_complete: 93.4,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-06-16",
      baseline_complete: 94.3,
      actual_complete: 94.5,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-06-23",
      baseline_complete: 94.7,
      actual_complete: 95.0,
      forecast_complete: 68.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-06-30",
      baseline_complete: 95.1,
      actual_complete: 98.3,
      forecast_complete: 69.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-07-07",
      baseline_complete: 95.5,
      actual_complete: 98.3,
      forecast_complete: 71.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-07-14",
      baseline_complete: 95.8,
      actual_complete: 98.3,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-07-21",
      baseline_complete: 96.1,
      actual_complete: 98.3,
      forecast_complete: 74.4,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-07-28",
      baseline_complete: 96.4,
      actual_complete: 98.3,
      forecast_complete: 75.8,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-08-04",
      baseline_complete: 96.7,
      actual_complete: 98.3,
      forecast_complete: 77.2,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-08-11",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 78.5,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-08-18",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 79.9,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-08-25",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-09-01",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 82.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-09-08",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 83.4,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-09-15",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 84.5,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-09-22",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-09-29",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 86.6,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-10-06",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-10-13",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-10-20",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-10-27",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-11-03",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-11-10",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-11-17",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-11-24",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-12-01",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-12-08",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-12-15",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-12-22",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2026-12-29",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-01-05",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-01-12",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-01-19",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-01-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-02-02",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-02-09",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-02-16",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-02-23",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-03-02",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-03-09",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-03-16",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "3992f128-09f6-9021-4634-d7804c356132",
      reporting_date: "2027-03-23",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
  ],
  "c890619a-de6e-88a3-fd53-ccc630ae5ae7": [
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-03-16",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-03-23",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-03-30",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-04-06",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-04-13",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-04-20",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-04-27",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-05-04",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-05-11",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-05-18",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-05-25",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-06-01",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-06-08",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-06-15",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-06-22",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-06-29",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-07-06",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-07-13",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-07-20",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-07-27",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-08-03",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-08-10",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-08-17",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-08-24",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-08-31",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-09-07",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-09-14",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-09-21",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-09-28",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-10-05",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-10-12",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-10-19",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-10-26",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-11-02",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-11-09",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-11-16",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-11-23",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-11-30",
      baseline_complete: 2.2,
      actual_complete: 0.1,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-12-07",
      baseline_complete: 2.3,
      actual_complete: 0.1,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-12-14",
      baseline_complete: 2.4,
      actual_complete: 0.1,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-12-21",
      baseline_complete: 2.5,
      actual_complete: 0.1,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2023-12-28",
      baseline_complete: 2.6,
      actual_complete: 0.1,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-01-04",
      baseline_complete: 2.7,
      actual_complete: 0.1,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-01-11",
      baseline_complete: 2.8,
      actual_complete: 0.1,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-01-18",
      baseline_complete: 2.9,
      actual_complete: 0.1,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-01-25",
      baseline_complete: 3.0,
      actual_complete: 0.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-02-01",
      baseline_complete: 3.1,
      actual_complete: 0.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-02-08",
      baseline_complete: 3.2,
      actual_complete: 0.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-02-15",
      baseline_complete: 3.3,
      actual_complete: 0.9,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-02-22",
      baseline_complete: 3.5,
      actual_complete: 0.9,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-02-29",
      baseline_complete: 3.6,
      actual_complete: 0.9,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-03-07",
      baseline_complete: 3.7,
      actual_complete: 1.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-03-14",
      baseline_complete: 3.8,
      actual_complete: 1.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-03-21",
      baseline_complete: 4.0,
      actual_complete: 2.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-03-28",
      baseline_complete: 4.1,
      actual_complete: 2.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-04-04",
      baseline_complete: 4.3,
      actual_complete: 2.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-04-11",
      baseline_complete: 4.4,
      actual_complete: 2.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-04-18",
      baseline_complete: 4.6,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-04-25",
      baseline_complete: 4.8,
      actual_complete: 2.5,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-05-02",
      baseline_complete: 4.9,
      actual_complete: 3.3,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-05-09",
      baseline_complete: 5.1,
      actual_complete: 3.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-05-16",
      baseline_complete: 5.3,
      actual_complete: 3.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-05-23",
      baseline_complete: 5.5,
      actual_complete: 3.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-05-30",
      baseline_complete: 5.7,
      actual_complete: 3.3,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-06-06",
      baseline_complete: 5.9,
      actual_complete: 3.9,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-06-13",
      baseline_complete: 6.1,
      actual_complete: 4.2,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-06-20",
      baseline_complete: 6.3,
      actual_complete: 4.2,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-06-27",
      baseline_complete: 6.5,
      actual_complete: 4.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-07-04",
      baseline_complete: 6.8,
      actual_complete: 4.2,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-07-11",
      baseline_complete: 7.0,
      actual_complete: 5.7,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-07-18",
      baseline_complete: 7.3,
      actual_complete: 5.7,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-07-25",
      baseline_complete: 7.5,
      actual_complete: 5.7,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-08-01",
      baseline_complete: 7.8,
      actual_complete: 5.7,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-08-08",
      baseline_complete: 8.0,
      actual_complete: 5.8,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-08-15",
      baseline_complete: 8.3,
      actual_complete: 7.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-08-22",
      baseline_complete: 8.6,
      actual_complete: 7.2,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-08-29",
      baseline_complete: 8.9,
      actual_complete: 7.2,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-09-05",
      baseline_complete: 9.2,
      actual_complete: 7.2,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-09-12",
      baseline_complete: 9.5,
      actual_complete: 7.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-09-19",
      baseline_complete: 9.9,
      actual_complete: 7.6,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-09-26",
      baseline_complete: 10.2,
      actual_complete: 8.2,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-10-03",
      baseline_complete: 10.5,
      actual_complete: 8.5,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-10-10",
      baseline_complete: 10.9,
      actual_complete: 8.5,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-10-17",
      baseline_complete: 11.3,
      actual_complete: 8.5,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-10-24",
      baseline_complete: 11.6,
      actual_complete: 9.4,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-10-31",
      baseline_complete: 12.0,
      actual_complete: 9.7,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-11-07",
      baseline_complete: 12.4,
      actual_complete: 10.6,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-11-14",
      baseline_complete: 12.8,
      actual_complete: 10.6,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-11-21",
      baseline_complete: 13.3,
      actual_complete: 10.9,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-11-28",
      baseline_complete: 13.7,
      actual_complete: 11.2,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-12-05",
      baseline_complete: 14.2,
      actual_complete: 11.9,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-12-12",
      baseline_complete: 14.6,
      actual_complete: 13.7,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-12-19",
      baseline_complete: 15.1,
      actual_complete: 14.2,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2024-12-26",
      baseline_complete: 15.6,
      actual_complete: 14.2,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-01-02",
      baseline_complete: 16.1,
      actual_complete: 14.2,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-01-09",
      baseline_complete: 16.6,
      actual_complete: 14.2,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-01-16",
      baseline_complete: 17.1,
      actual_complete: 14.2,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-01-23",
      baseline_complete: 17.6,
      actual_complete: 15.2,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-01-30",
      baseline_complete: 18.2,
      actual_complete: 15.3,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-02-06",
      baseline_complete: 18.7,
      actual_complete: 16.3,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-02-13",
      baseline_complete: 19.3,
      actual_complete: 17.5,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-02-20",
      baseline_complete: 19.9,
      actual_complete: 19.2,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-02-27",
      baseline_complete: 20.5,
      actual_complete: 19.7,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-03-06",
      baseline_complete: 21.1,
      actual_complete: 19.7,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-03-13",
      baseline_complete: 21.7,
      actual_complete: 19.9,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-03-20",
      baseline_complete: 22.4,
      actual_complete: 19.9,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-03-27",
      baseline_complete: 23.0,
      actual_complete: 20.4,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-04-03",
      baseline_complete: 23.7,
      actual_complete: 21.3,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-04-10",
      baseline_complete: 24.4,
      actual_complete: 21.6,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-04-17",
      baseline_complete: 25.1,
      actual_complete: 22.5,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-04-24",
      baseline_complete: 25.8,
      actual_complete: 24.3,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-05-01",
      baseline_complete: 26.5,
      actual_complete: 25.9,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-05-08",
      baseline_complete: 27.2,
      actual_complete: 25.9,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-05-15",
      baseline_complete: 28.0,
      actual_complete: 25.9,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-05-22",
      baseline_complete: 28.7,
      actual_complete: 27.9,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-05-29",
      baseline_complete: 29.5,
      actual_complete: 27.9,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-06-05",
      baseline_complete: 30.3,
      actual_complete: 28.0,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-06-12",
      baseline_complete: 31.1,
      actual_complete: 29.3,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-06-19",
      baseline_complete: 31.9,
      actual_complete: 30.9,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-06-26",
      baseline_complete: 32.7,
      actual_complete: 30.9,
      forecast_complete: 18.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-07-03",
      baseline_complete: 33.5,
      actual_complete: 31.5,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-07-10",
      baseline_complete: 34.3,
      actual_complete: 32.3,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-07-17",
      baseline_complete: 35.2,
      actual_complete: 34.4,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-07-24",
      baseline_complete: 36.0,
      actual_complete: 35.2,
      forecast_complete: 20.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-07-31",
      baseline_complete: 36.9,
      actual_complete: 36.6,
      forecast_complete: 21.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-08-07",
      baseline_complete: 37.8,
      actual_complete: 36.9,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-08-14",
      baseline_complete: 38.6,
      actual_complete: 37.7,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-08-21",
      baseline_complete: 39.5,
      actual_complete: 38.3,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-08-28",
      baseline_complete: 40.4,
      actual_complete: 39.1,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-09-04",
      baseline_complete: 41.3,
      actual_complete: 39.1,
      forecast_complete: 24.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-09-11",
      baseline_complete: 42.2,
      actual_complete: 40.3,
      forecast_complete: 25.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-09-18",
      baseline_complete: 43.1,
      actual_complete: 41.4,
      forecast_complete: 25.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-09-25",
      baseline_complete: 44.1,
      actual_complete: 42.0,
      forecast_complete: 26.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-10-02",
      baseline_complete: 45.0,
      actual_complete: 44.2,
      forecast_complete: 27.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-10-09",
      baseline_complete: 45.9,
      actual_complete: 44.2,
      forecast_complete: 27.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-10-16",
      baseline_complete: 46.8,
      actual_complete: 46.2,
      forecast_complete: 28.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-10-23",
      baseline_complete: 47.8,
      actual_complete: 47.4,
      forecast_complete: 29.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-10-30",
      baseline_complete: 48.7,
      actual_complete: 48.0,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-11-06",
      baseline_complete: 49.6,
      actual_complete: 49.5,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-11-13",
      baseline_complete: 50.6,
      actual_complete: 49.5,
      forecast_complete: 31.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-11-20",
      baseline_complete: 51.5,
      actual_complete: 51.5,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-11-27",
      baseline_complete: 52.4,
      actual_complete: 51.5,
      forecast_complete: 32.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-12-04",
      baseline_complete: 53.3,
      actual_complete: 52.5,
      forecast_complete: 33.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-12-11",
      baseline_complete: 54.3,
      actual_complete: 52.5,
      forecast_complete: 34.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-12-18",
      baseline_complete: 55.2,
      actual_complete: 56.0,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2025-12-25",
      baseline_complete: 56.1,
      actual_complete: 56.0,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-01-01",
      baseline_complete: 57.0,
      actual_complete: 56.0,
      forecast_complete: 36.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-01-08",
      baseline_complete: 57.9,
      actual_complete: 56.7,
      forecast_complete: 37.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-01-15",
      baseline_complete: 58.8,
      actual_complete: 59.3,
      forecast_complete: 38.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-01-22",
      baseline_complete: 59.7,
      actual_complete: 59.3,
      forecast_complete: 39.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-01-29",
      baseline_complete: 60.6,
      actual_complete: 61.0,
      forecast_complete: 39.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-02-05",
      baseline_complete: 61.5,
      actual_complete: 62.1,
      forecast_complete: 40.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-02-12",
      baseline_complete: 62.4,
      actual_complete: 62.1,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-02-19",
      baseline_complete: 63.3,
      actual_complete: 62.1,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-02-26",
      baseline_complete: 64.1,
      actual_complete: 63.9,
      forecast_complete: 43.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-03-05",
      baseline_complete: 65.0,
      actual_complete: 63.9,
      forecast_complete: 43.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-03-12",
      baseline_complete: 65.8,
      actual_complete: 64.1,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-03-19",
      baseline_complete: 66.6,
      actual_complete: 66.2,
      forecast_complete: 45.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-03-26",
      baseline_complete: 67.5,
      actual_complete: 68.8,
      forecast_complete: 46.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-04-02",
      baseline_complete: 68.3,
      actual_complete: 68.8,
      forecast_complete: 47.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-04-09",
      baseline_complete: 69.1,
      actual_complete: 69.4,
      forecast_complete: 47.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-04-16",
      baseline_complete: 69.9,
      actual_complete: 70.0,
      forecast_complete: 48.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-04-23",
      baseline_complete: 70.7,
      actual_complete: 70.9,
      forecast_complete: 49.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-04-30",
      baseline_complete: 71.4,
      actual_complete: 72.4,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-05-07",
      baseline_complete: 72.2,
      actual_complete: 72.4,
      forecast_complete: 51.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-05-14",
      baseline_complete: 72.9,
      actual_complete: 72.4,
      forecast_complete: 51.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-05-21",
      baseline_complete: 73.6,
      actual_complete: 73.0,
      forecast_complete: 52.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-05-28",
      baseline_complete: 74.4,
      actual_complete: 74.0,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-06-04",
      baseline_complete: 75.1,
      actual_complete: 75.9,
      forecast_complete: 54.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-06-11",
      baseline_complete: 75.8,
      actual_complete: 75.9,
      forecast_complete: 55.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-06-18",
      baseline_complete: 76.4,
      actual_complete: 75.9,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-06-25",
      baseline_complete: 77.1,
      actual_complete: 76.8,
      forecast_complete: 56.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-07-02",
      baseline_complete: 77.7,
      actual_complete: 76.8,
      forecast_complete: 57.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-07-09",
      baseline_complete: 78.4,
      actual_complete: 79.8,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-07-16",
      baseline_complete: 79.0,
      actual_complete: 79.8,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-07-23",
      baseline_complete: 79.6,
      actual_complete: 81.8,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-07-30",
      baseline_complete: 80.2,
      actual_complete: 81.8,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-08-06",
      baseline_complete: 80.8,
      actual_complete: 81.8,
      forecast_complete: 61.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-08-13",
      baseline_complete: 81.4,
      actual_complete: 81.8,
      forecast_complete: 62.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-08-20",
      baseline_complete: 81.9,
      actual_complete: 82.1,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-08-27",
      baseline_complete: 82.5,
      actual_complete: 82.1,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-09-03",
      baseline_complete: 83.0,
      actual_complete: 82.1,
      forecast_complete: 64.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-09-10",
      baseline_complete: 83.5,
      actual_complete: 83.3,
      forecast_complete: 64.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-09-17",
      baseline_complete: 84.0,
      actual_complete: 84.8,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-09-24",
      baseline_complete: 84.5,
      actual_complete: 84.8,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-10-01",
      baseline_complete: 85.0,
      actual_complete: 85.4,
      forecast_complete: 68.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-10-08",
      baseline_complete: 85.5,
      actual_complete: 85.4,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-10-15",
      baseline_complete: 85.9,
      actual_complete: 85.4,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-10-22",
      baseline_complete: 86.4,
      actual_complete: 85.6,
      forecast_complete: 71.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-10-29",
      baseline_complete: 86.8,
      actual_complete: 87.4,
      forecast_complete: 73.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-11-05",
      baseline_complete: 87.2,
      actual_complete: 87.4,
      forecast_complete: 74.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-11-12",
      baseline_complete: 87.6,
      actual_complete: 87.5,
      forecast_complete: 75.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-11-19",
      baseline_complete: 88.0,
      actual_complete: 88.0,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-11-26",
      baseline_complete: 88.4,
      actual_complete: 89.2,
      forecast_complete: 77.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-12-03",
      baseline_complete: 88.8,
      actual_complete: 90.6,
      forecast_complete: 78.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-12-10",
      baseline_complete: 89.2,
      actual_complete: 90.6,
      forecast_complete: 79.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-12-17",
      baseline_complete: 89.5,
      actual_complete: 90.6,
      forecast_complete: 80.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-12-24",
      baseline_complete: 89.9,
      actual_complete: 90.6,
      forecast_complete: 81.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2026-12-31",
      baseline_complete: 90.2,
      actual_complete: 90.6,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-01-07",
      baseline_complete: 90.5,
      actual_complete: 90.9,
      forecast_complete: 83.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-01-14",
      baseline_complete: 90.8,
      actual_complete: 90.9,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-01-21",
      baseline_complete: 91.1,
      actual_complete: 90.9,
      forecast_complete: 85.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-01-28",
      baseline_complete: 91.4,
      actual_complete: 92.9,
      forecast_complete: 85.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-02-04",
      baseline_complete: 91.7,
      actual_complete: 92.9,
      forecast_complete: 86.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-02-11",
      baseline_complete: 92.0,
      actual_complete: 92.9,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-02-18",
      baseline_complete: 92.3,
      actual_complete: 92.9,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-02-25",
      baseline_complete: 92.5,
      actual_complete: 93.3,
      forecast_complete: 89.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-03-04",
      baseline_complete: 92.8,
      actual_complete: 93.3,
      forecast_complete: 89.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-03-11",
      baseline_complete: 93.0,
      actual_complete: 93.3,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-03-18",
      baseline_complete: 93.3,
      actual_complete: 94.6,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-03-25",
      baseline_complete: 93.5,
      actual_complete: 94.6,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-04-01",
      baseline_complete: 93.7,
      actual_complete: 95.1,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-04-08",
      baseline_complete: 93.9,
      actual_complete: 95.1,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-04-15",
      baseline_complete: 94.1,
      actual_complete: 95.1,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-04-22",
      baseline_complete: 94.3,
      actual_complete: 96.1,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-04-29",
      baseline_complete: 94.5,
      actual_complete: 96.1,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-05-06",
      baseline_complete: 94.7,
      actual_complete: 96.1,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-05-13",
      baseline_complete: 94.9,
      actual_complete: 96.1,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-05-20",
      baseline_complete: 95.1,
      actual_complete: 96.1,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-05-27",
      baseline_complete: 95.3,
      actual_complete: 97.2,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-06-03",
      baseline_complete: 95.4,
      actual_complete: 97.2,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-06-10",
      baseline_complete: 95.6,
      actual_complete: 97.2,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-06-17",
      baseline_complete: 95.7,
      actual_complete: 97.2,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-06-24",
      baseline_complete: 95.9,
      actual_complete: 97.2,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-07-01",
      baseline_complete: 96.0,
      actual_complete: 98.8,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-07-08",
      baseline_complete: 96.2,
      actual_complete: 98.8,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-07-15",
      baseline_complete: 96.3,
      actual_complete: 98.8,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-07-22",
      baseline_complete: 96.4,
      actual_complete: 98.8,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-07-29",
      baseline_complete: 96.6,
      actual_complete: 98.8,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-08-05",
      baseline_complete: 96.7,
      actual_complete: 99.8,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-08-12",
      baseline_complete: 96.8,
      actual_complete: 99.8,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-08-19",
      baseline_complete: 96.9,
      actual_complete: 99.8,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-08-26",
      baseline_complete: 97.0,
      actual_complete: 99.8,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-09-02",
      baseline_complete: 97.1,
      actual_complete: 99.8,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-09-09",
      baseline_complete: 97.2,
      actual_complete: 99.8,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-09-16",
      baseline_complete: 97.3,
      actual_complete: 99.8,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-09-23",
      baseline_complete: 97.4,
      actual_complete: 99.8,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-09-30",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-10-07",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-10-14",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-10-21",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-10-28",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-11-04",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-11-11",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "c890619a-de6e-88a3-fd53-ccc630ae5ae7",
      reporting_date: "2027-11-16",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "84530e7d-f865-267a-4337-a72285000773": [
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2023-10-28",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2023-11-04",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2023-11-11",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2023-11-18",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2023-11-25",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2023-12-02",
      baseline_complete: 0.5,
      actual_complete: 1.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2023-12-09",
      baseline_complete: 0.5,
      actual_complete: 1.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2023-12-16",
      baseline_complete: 0.5,
      actual_complete: 1.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2023-12-23",
      baseline_complete: 0.6,
      actual_complete: 1.7,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2023-12-30",
      baseline_complete: 0.6,
      actual_complete: 1.7,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-01-06",
      baseline_complete: 0.6,
      actual_complete: 1.7,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-01-13",
      baseline_complete: 0.7,
      actual_complete: 2.6,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-01-20",
      baseline_complete: 0.7,
      actual_complete: 2.6,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-01-27",
      baseline_complete: 0.8,
      actual_complete: 2.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-02-03",
      baseline_complete: 0.8,
      actual_complete: 2.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-02-10",
      baseline_complete: 0.9,
      actual_complete: 2.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-02-17",
      baseline_complete: 1.0,
      actual_complete: 2.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-02-24",
      baseline_complete: 1.0,
      actual_complete: 2.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-03-02",
      baseline_complete: 1.1,
      actual_complete: 2.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-03-09",
      baseline_complete: 1.2,
      actual_complete: 2.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-03-16",
      baseline_complete: 1.3,
      actual_complete: 2.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-03-23",
      baseline_complete: 1.3,
      actual_complete: 2.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-03-30",
      baseline_complete: 1.4,
      actual_complete: 2.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-04-06",
      baseline_complete: 1.5,
      actual_complete: 2.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-04-13",
      baseline_complete: 1.6,
      actual_complete: 2.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-04-20",
      baseline_complete: 1.8,
      actual_complete: 2.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-04-27",
      baseline_complete: 1.9,
      actual_complete: 2.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-05-04",
      baseline_complete: 2.0,
      actual_complete: 2.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-05-11",
      baseline_complete: 2.1,
      actual_complete: 2.6,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-05-18",
      baseline_complete: 2.3,
      actual_complete: 2.6,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-05-25",
      baseline_complete: 2.5,
      actual_complete: 2.6,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-06-01",
      baseline_complete: 2.6,
      actual_complete: 4.3,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-06-08",
      baseline_complete: 2.8,
      actual_complete: 4.4,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-06-15",
      baseline_complete: 3.0,
      actual_complete: 4.4,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-06-22",
      baseline_complete: 3.2,
      actual_complete: 4.4,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-06-29",
      baseline_complete: 3.4,
      actual_complete: 4.9,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-07-06",
      baseline_complete: 3.6,
      actual_complete: 4.9,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-07-13",
      baseline_complete: 3.9,
      actual_complete: 4.9,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-07-20",
      baseline_complete: 4.2,
      actual_complete: 5.3,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-07-27",
      baseline_complete: 4.4,
      actual_complete: 5.3,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-08-03",
      baseline_complete: 4.7,
      actual_complete: 5.3,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-08-10",
      baseline_complete: 5.1,
      actual_complete: 6.9,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-08-17",
      baseline_complete: 5.4,
      actual_complete: 6.9,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-08-24",
      baseline_complete: 5.7,
      actual_complete: 7.1,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-08-31",
      baseline_complete: 6.1,
      actual_complete: 7.1,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-09-07",
      baseline_complete: 6.5,
      actual_complete: 8.9,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-09-14",
      baseline_complete: 7.0,
      actual_complete: 8.9,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-09-21",
      baseline_complete: 7.4,
      actual_complete: 9.4,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-09-28",
      baseline_complete: 7.9,
      actual_complete: 9.4,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-10-05",
      baseline_complete: 8.4,
      actual_complete: 9.4,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-10-12",
      baseline_complete: 9.0,
      actual_complete: 9.4,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-10-19",
      baseline_complete: 9.5,
      actual_complete: 9.4,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-10-26",
      baseline_complete: 10.1,
      actual_complete: 11.1,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-11-02",
      baseline_complete: 10.8,
      actual_complete: 11.1,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-11-09",
      baseline_complete: 11.4,
      actual_complete: 13.1,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-11-16",
      baseline_complete: 12.2,
      actual_complete: 14.2,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-11-23",
      baseline_complete: 12.9,
      actual_complete: 14.9,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-11-30",
      baseline_complete: 13.7,
      actual_complete: 14.9,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-12-07",
      baseline_complete: 14.5,
      actual_complete: 14.9,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-12-14",
      baseline_complete: 15.4,
      actual_complete: 16.2,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-12-21",
      baseline_complete: 16.3,
      actual_complete: 16.2,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2024-12-28",
      baseline_complete: 17.2,
      actual_complete: 16.2,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-01-04",
      baseline_complete: 18.2,
      actual_complete: 20.1,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-01-11",
      baseline_complete: 19.3,
      actual_complete: 20.1,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-01-18",
      baseline_complete: 20.4,
      actual_complete: 21.2,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-01-25",
      baseline_complete: 21.5,
      actual_complete: 21.2,
      forecast_complete: 12.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-02-01",
      baseline_complete: 22.7,
      actual_complete: 22.4,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-02-08",
      baseline_complete: 23.9,
      actual_complete: 22.4,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-02-15",
      baseline_complete: 25.1,
      actual_complete: 23.3,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-02-22",
      baseline_complete: 26.5,
      actual_complete: 28.2,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-03-01",
      baseline_complete: 27.8,
      actual_complete: 30.6,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-03-08",
      baseline_complete: 29.2,
      actual_complete: 30.6,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-03-15",
      baseline_complete: 30.6,
      actual_complete: 33.4,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-03-22",
      baseline_complete: 32.1,
      actual_complete: 33.4,
      forecast_complete: 18.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-03-29",
      baseline_complete: 33.6,
      actual_complete: 33.5,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-04-05",
      baseline_complete: 35.1,
      actual_complete: 36.5,
      forecast_complete: 20.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-04-12",
      baseline_complete: 36.7,
      actual_complete: 36.5,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-04-19",
      baseline_complete: 38.3,
      actual_complete: 36.5,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-04-26",
      baseline_complete: 39.9,
      actual_complete: 41.5,
      forecast_complete: 23.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-05-03",
      baseline_complete: 41.6,
      actual_complete: 41.5,
      forecast_complete: 24.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-05-10",
      baseline_complete: 43.2,
      actual_complete: 43.3,
      forecast_complete: 25.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-05-17",
      baseline_complete: 44.9,
      actual_complete: 45.1,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-05-24",
      baseline_complete: 46.6,
      actual_complete: 50.1,
      forecast_complete: 27.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-05-31",
      baseline_complete: 48.3,
      actual_complete: 50.1,
      forecast_complete: 28.6,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-06-07",
      baseline_complete: 50.0,
      actual_complete: 50.1,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-06-14",
      baseline_complete: 51.7,
      actual_complete: 50.3,
      forecast_complete: 31.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-06-21",
      baseline_complete: 53.4,
      actual_complete: 54.9,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-06-28",
      baseline_complete: 55.1,
      actual_complete: 56.3,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-07-05",
      baseline_complete: 56.8,
      actual_complete: 56.3,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-07-12",
      baseline_complete: 58.5,
      actual_complete: 59.4,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-07-19",
      baseline_complete: 60.1,
      actual_complete: 62.1,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-07-26",
      baseline_complete: 61.7,
      actual_complete: 62.1,
      forecast_complete: 38.6,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-08-02",
      baseline_complete: 63.3,
      actual_complete: 62.2,
      forecast_complete: 39.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-08-09",
      baseline_complete: 64.9,
      actual_complete: 67.0,
      forecast_complete: 41.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-08-16",
      baseline_complete: 66.5,
      actual_complete: 69.9,
      forecast_complete: 42.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-08-23",
      baseline_complete: 68.0,
      actual_complete: 69.9,
      forecast_complete: 43.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-08-30",
      baseline_complete: 69.4,
      actual_complete: 69.9,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-09-06",
      baseline_complete: 70.9,
      actual_complete: 71.1,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-09-13",
      baseline_complete: 72.2,
      actual_complete: 73.4,
      forecast_complete: 47.6,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-09-20",
      baseline_complete: 73.6,
      actual_complete: 74.4,
      forecast_complete: 49.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-09-27",
      baseline_complete: 74.9,
      actual_complete: 76.9,
      forecast_complete: 50.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-10-04",
      baseline_complete: 76.2,
      actual_complete: 77.5,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-10-11",
      baseline_complete: 77.4,
      actual_complete: 77.5,
      forecast_complete: 52.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-10-18",
      baseline_complete: 78.5,
      actual_complete: 78.1,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-10-25",
      baseline_complete: 79.7,
      actual_complete: 79.6,
      forecast_complete: 55.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-11-01",
      baseline_complete: 80.8,
      actual_complete: 80.1,
      forecast_complete: 56.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-11-08",
      baseline_complete: 81.8,
      actual_complete: 84.4,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-11-15",
      baseline_complete: 82.8,
      actual_complete: 84.4,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-11-22",
      baseline_complete: 83.7,
      actual_complete: 87.5,
      forecast_complete: 59.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-11-29",
      baseline_complete: 84.6,
      actual_complete: 87.5,
      forecast_complete: 61.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-12-06",
      baseline_complete: 85.5,
      actual_complete: 87.5,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-12-13",
      baseline_complete: 86.3,
      actual_complete: 87.5,
      forecast_complete: 63.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-12-20",
      baseline_complete: 87.1,
      actual_complete: 88.9,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2025-12-27",
      baseline_complete: 87.9,
      actual_complete: 89.2,
      forecast_complete: 65.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-01-03",
      baseline_complete: 88.6,
      actual_complete: 89.4,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-01-10",
      baseline_complete: 89.3,
      actual_complete: 89.4,
      forecast_complete: 67.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-01-17",
      baseline_complete: 89.9,
      actual_complete: 90.7,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-01-24",
      baseline_complete: 90.5,
      actual_complete: 91.4,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-01-31",
      baseline_complete: 91.1,
      actual_complete: 93.1,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-02-07",
      baseline_complete: 91.6,
      actual_complete: 93.1,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-02-14",
      baseline_complete: 92.1,
      actual_complete: 93.4,
      forecast_complete: 72.3,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-02-21",
      baseline_complete: 92.6,
      actual_complete: 93.7,
      forecast_complete: 73.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-02-28",
      baseline_complete: 93.0,
      actual_complete: 94.8,
      forecast_complete: 75.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-03-07",
      baseline_complete: 93.5,
      actual_complete: 94.8,
      forecast_complete: 76.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-03-14",
      baseline_complete: 93.9,
      actual_complete: 97.7,
      forecast_complete: 78.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-03-21",
      baseline_complete: 94.3,
      actual_complete: 97.7,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-03-28",
      baseline_complete: 94.6,
      actual_complete: 97.7,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-04-04",
      baseline_complete: 95.0,
      actual_complete: 97.9,
      forecast_complete: 82.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-04-11",
      baseline_complete: 95.3,
      actual_complete: 97.9,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-04-18",
      baseline_complete: 95.6,
      actual_complete: 97.9,
      forecast_complete: 85.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-04-25",
      baseline_complete: 95.9,
      actual_complete: 99.6,
      forecast_complete: 86.3,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-05-02",
      baseline_complete: 96.1,
      actual_complete: 99.6,
      forecast_complete: 87.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-05-09",
      baseline_complete: 96.4,
      actual_complete: 99.6,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-05-16",
      baseline_complete: 96.6,
      actual_complete: 99.6,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-05-23",
      baseline_complete: 96.8,
      actual_complete: 99.6,
      forecast_complete: 90.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-05-30",
      baseline_complete: 97.0,
      actual_complete: 99.6,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-06-06",
      baseline_complete: 97.2,
      actual_complete: 99.6,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-06-13",
      baseline_complete: 97.4,
      actual_complete: 99.6,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-06-20",
      baseline_complete: 97.6,
      actual_complete: 99.6,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-06-27",
      baseline_complete: 97.7,
      actual_complete: 99.6,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-07-04",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-07-11",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-07-18",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-07-25",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-08-01",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-08-08",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-08-15",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-08-22",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-08-29",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-09-05",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-09-12",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-09-19",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-09-26",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-10-03",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-10-10",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-10-17",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-10-24",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-10-31",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-11-07",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-11-14",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-11-21",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "84530e7d-f865-267a-4337-a72285000773",
      reporting_date: "2026-11-28",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "176df13d-87bc-ae46-4373-2d93129d5f9d": [
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-05-16",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-05-23",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-05-30",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-06-06",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-06-13",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-06-20",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-06-27",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-07-04",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-07-11",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-07-18",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-07-25",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-08-01",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-08-08",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-08-15",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-08-22",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-08-29",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-09-05",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-09-12",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-09-19",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-09-26",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-10-03",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-10-10",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-10-17",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-10-24",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-10-31",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-11-07",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-11-14",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-11-21",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-11-28",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-12-05",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-12-12",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-12-19",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2023-12-26",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-01-02",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-01-09",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-01-16",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-01-23",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-01-30",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-02-06",
      baseline_complete: 3.7,
      actual_complete: 0.4,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-02-13",
      baseline_complete: 3.9,
      actual_complete: 0.8,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-02-20",
      baseline_complete: 4.2,
      actual_complete: 0.8,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-02-27",
      baseline_complete: 4.5,
      actual_complete: 0.8,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-03-05",
      baseline_complete: 4.8,
      actual_complete: 0.8,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-03-12",
      baseline_complete: 5.2,
      actual_complete: 1.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-03-19",
      baseline_complete: 5.6,
      actual_complete: 1.5,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-03-26",
      baseline_complete: 5.9,
      actual_complete: 1.5,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-04-02",
      baseline_complete: 6.4,
      actual_complete: 1.8,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-04-09",
      baseline_complete: 6.8,
      actual_complete: 3.5,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-04-16",
      baseline_complete: 7.3,
      actual_complete: 4.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-04-23",
      baseline_complete: 7.8,
      actual_complete: 4.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-04-30",
      baseline_complete: 8.3,
      actual_complete: 4.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-05-07",
      baseline_complete: 8.9,
      actual_complete: 4.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-05-14",
      baseline_complete: 9.5,
      actual_complete: 5.9,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-05-21",
      baseline_complete: 10.2,
      actual_complete: 5.9,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-05-28",
      baseline_complete: 10.8,
      actual_complete: 8.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-06-04",
      baseline_complete: 11.6,
      actual_complete: 8.0,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-06-11",
      baseline_complete: 12.3,
      actual_complete: 8.2,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-06-18",
      baseline_complete: 13.1,
      actual_complete: 10.9,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-06-25",
      baseline_complete: 14.0,
      actual_complete: 10.9,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-07-02",
      baseline_complete: 14.9,
      actual_complete: 11.8,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-07-09",
      baseline_complete: 15.8,
      actual_complete: 11.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-07-16",
      baseline_complete: 16.8,
      actual_complete: 11.8,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-07-23",
      baseline_complete: 17.9,
      actual_complete: 12.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-07-30",
      baseline_complete: 19.0,
      actual_complete: 15.6,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-08-06",
      baseline_complete: 20.1,
      actual_complete: 16.7,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-08-13",
      baseline_complete: 21.3,
      actual_complete: 16.7,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-08-20",
      baseline_complete: 22.5,
      actual_complete: 17.8,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-08-27",
      baseline_complete: 23.8,
      actual_complete: 19.8,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-09-03",
      baseline_complete: 25.2,
      actual_complete: 23.6,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-09-10",
      baseline_complete: 26.6,
      actual_complete: 23.6,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-09-17",
      baseline_complete: 28.0,
      actual_complete: 23.9,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-09-24",
      baseline_complete: 29.5,
      actual_complete: 27.8,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-10-01",
      baseline_complete: 31.0,
      actual_complete: 28.6,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-10-08",
      baseline_complete: 32.6,
      actual_complete: 28.6,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-10-15",
      baseline_complete: 34.2,
      actual_complete: 33.2,
      forecast_complete: 14.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-10-22",
      baseline_complete: 35.9,
      actual_complete: 33.7,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-10-29",
      baseline_complete: 37.6,
      actual_complete: 33.9,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-11-05",
      baseline_complete: 39.3,
      actual_complete: 36.6,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-11-12",
      baseline_complete: 41.0,
      actual_complete: 39.3,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-11-19",
      baseline_complete: 42.8,
      actual_complete: 41.1,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-11-26",
      baseline_complete: 44.6,
      actual_complete: 41.1,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-12-03",
      baseline_complete: 46.4,
      actual_complete: 44.5,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-12-10",
      baseline_complete: 48.2,
      actual_complete: 44.5,
      forecast_complete: 22.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-12-17",
      baseline_complete: 50.0,
      actual_complete: 48.8,
      forecast_complete: 23.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-12-24",
      baseline_complete: 51.8,
      actual_complete: 48.8,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2024-12-31",
      baseline_complete: 53.7,
      actual_complete: 50.4,
      forecast_complete: 25.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-01-07",
      baseline_complete: 55.5,
      actual_complete: 52.1,
      forecast_complete: 26.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-01-14",
      baseline_complete: 57.2,
      actual_complete: 52.9,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-01-21",
      baseline_complete: 59.0,
      actual_complete: 57.0,
      forecast_complete: 29.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-01-28",
      baseline_complete: 60.8,
      actual_complete: 59.6,
      forecast_complete: 30.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-02-04",
      baseline_complete: 62.5,
      actual_complete: 59.6,
      forecast_complete: 31.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-02-11",
      baseline_complete: 64.2,
      actual_complete: 63.8,
      forecast_complete: 32.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-02-18",
      baseline_complete: 65.8,
      actual_complete: 64.2,
      forecast_complete: 34.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-02-25",
      baseline_complete: 67.4,
      actual_complete: 64.2,
      forecast_complete: 35.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-03-04",
      baseline_complete: 69.0,
      actual_complete: 65.4,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-03-11",
      baseline_complete: 70.5,
      actual_complete: 66.7,
      forecast_complete: 37.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-03-18",
      baseline_complete: 72.0,
      actual_complete: 70.0,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-03-25",
      baseline_complete: 73.5,
      actual_complete: 71.5,
      forecast_complete: 40.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-04-01",
      baseline_complete: 74.9,
      actual_complete: 73.9,
      forecast_complete: 41.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-04-08",
      baseline_complete: 76.2,
      actual_complete: 74.4,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-04-15",
      baseline_complete: 77.5,
      actual_complete: 75.3,
      forecast_complete: 43.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-04-22",
      baseline_complete: 78.7,
      actual_complete: 78.3,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-04-29",
      baseline_complete: 79.9,
      actual_complete: 78.8,
      forecast_complete: 45.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-05-06",
      baseline_complete: 81.1,
      actual_complete: 80.3,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-05-13",
      baseline_complete: 82.2,
      actual_complete: 81.6,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-05-20",
      baseline_complete: 83.2,
      actual_complete: 81.6,
      forecast_complete: 49.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-05-27",
      baseline_complete: 84.2,
      actual_complete: 81.6,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-06-03",
      baseline_complete: 85.1,
      actual_complete: 84.6,
      forecast_complete: 51.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-06-10",
      baseline_complete: 86.0,
      actual_complete: 84.6,
      forecast_complete: 52.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-06-17",
      baseline_complete: 86.9,
      actual_complete: 84.6,
      forecast_complete: 53.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-06-24",
      baseline_complete: 87.7,
      actual_complete: 84.6,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-07-01",
      baseline_complete: 88.5,
      actual_complete: 87.2,
      forecast_complete: 55.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-07-08",
      baseline_complete: 89.2,
      actual_complete: 89.0,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-07-15",
      baseline_complete: 89.9,
      actual_complete: 89.0,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-07-22",
      baseline_complete: 90.5,
      actual_complete: 89.2,
      forecast_complete: 57.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-07-29",
      baseline_complete: 91.1,
      actual_complete: 90.1,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-08-05",
      baseline_complete: 91.7,
      actual_complete: 90.1,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-08-12",
      baseline_complete: 92.2,
      actual_complete: 91.7,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-08-19",
      baseline_complete: 92.7,
      actual_complete: 92.7,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-08-26",
      baseline_complete: 93.2,
      actual_complete: 92.7,
      forecast_complete: 62.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-09-02",
      baseline_complete: 93.6,
      actual_complete: 93.5,
      forecast_complete: 63.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-09-09",
      baseline_complete: 94.1,
      actual_complete: 93.5,
      forecast_complete: 63.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-09-16",
      baseline_complete: 94.5,
      actual_complete: 93.5,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-09-23",
      baseline_complete: 94.8,
      actual_complete: 93.5,
      forecast_complete: 65.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-09-30",
      baseline_complete: 95.2,
      actual_complete: 95.0,
      forecast_complete: 66.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-10-07",
      baseline_complete: 95.5,
      actual_complete: 95.0,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-10-14",
      baseline_complete: 95.8,
      actual_complete: 95.9,
      forecast_complete: 67.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-10-21",
      baseline_complete: 96.1,
      actual_complete: 95.9,
      forecast_complete: 68.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-10-28",
      baseline_complete: 96.3,
      actual_complete: 96.2,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-11-04",
      baseline_complete: 96.6,
      actual_complete: 96.2,
      forecast_complete: 69.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-11-11",
      baseline_complete: 96.8,
      actual_complete: 96.5,
      forecast_complete: 70.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-11-18",
      baseline_complete: 97.0,
      actual_complete: 96.5,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-11-25",
      baseline_complete: 97.2,
      actual_complete: 97.0,
      forecast_complete: 71.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-12-02",
      baseline_complete: 97.4,
      actual_complete: 97.0,
      forecast_complete: 72.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-12-09",
      baseline_complete: 97.6,
      actual_complete: 97.0,
      forecast_complete: 73.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-12-16",
      baseline_complete: 97.8,
      actual_complete: 97.3,
      forecast_complete: 74.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-12-23",
      baseline_complete: 97.9,
      actual_complete: 98.2,
      forecast_complete: 75.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2025-12-30",
      baseline_complete: 98.1,
      actual_complete: 98.2,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-01-06",
      baseline_complete: 98.2,
      actual_complete: 98.3,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-01-13",
      baseline_complete: 98.3,
      actual_complete: 98.3,
      forecast_complete: 79.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-01-20",
      baseline_complete: 98.4,
      actual_complete: 98.3,
      forecast_complete: 80.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-01-27",
      baseline_complete: 98.5,
      actual_complete: 98.7,
      forecast_complete: 81.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-02-03",
      baseline_complete: 98.6,
      actual_complete: 99.3,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-02-10",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 83.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-02-17",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-02-24",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 85.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-03-03",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-03-10",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-03-17",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-03-24",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-03-31",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-04-07",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-04-14",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-04-21",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-04-28",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-05-05",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-05-12",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-05-19",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-05-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-06-02",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-06-09",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-06-16",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-06-23",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-06-30",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-07-07",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-07-14",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-07-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-07-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-08-04",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-08-11",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-08-18",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-08-25",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-09-01",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-09-08",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-09-15",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-09-22",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-09-29",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-10-06",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-10-13",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "176df13d-87bc-ae46-4373-2d93129d5f9d",
      reporting_date: "2026-10-16",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "a25b76e9-5b96-7aff-1cb2-98fedb6452d5": [
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-01-02",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-01-09",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-01-16",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-01-23",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-01-30",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-02-06",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-02-13",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-02-20",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-02-27",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-03-05",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-03-12",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-03-19",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-03-26",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-04-02",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-04-09",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-04-16",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-04-23",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-04-30",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-05-07",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-05-14",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-05-21",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-05-28",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-06-04",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-06-11",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-06-18",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-06-25",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-07-02",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-07-09",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-07-16",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-07-23",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-07-30",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-08-06",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-08-13",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-08-20",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-08-27",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-09-03",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-09-10",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-09-17",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-09-24",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-10-01",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-10-08",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-10-15",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-10-22",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-10-29",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-11-05",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-11-12",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-11-19",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-11-26",
      baseline_complete: 3.7,
      actual_complete: 0.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-12-03",
      baseline_complete: 3.9,
      actual_complete: 0.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-12-10",
      baseline_complete: 4.1,
      actual_complete: 1.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-12-17",
      baseline_complete: 4.3,
      actual_complete: 1.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-12-24",
      baseline_complete: 4.6,
      actual_complete: 1.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2024-12-31",
      baseline_complete: 4.8,
      actual_complete: 1.6,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-01-07",
      baseline_complete: 5.1,
      actual_complete: 1.6,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-01-14",
      baseline_complete: 5.3,
      actual_complete: 1.6,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-01-21",
      baseline_complete: 5.6,
      actual_complete: 1.6,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-01-28",
      baseline_complete: 5.9,
      actual_complete: 2.7,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-02-04",
      baseline_complete: 6.3,
      actual_complete: 2.7,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-02-11",
      baseline_complete: 6.6,
      actual_complete: 3.7,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-02-18",
      baseline_complete: 6.9,
      actual_complete: 3.7,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-02-25",
      baseline_complete: 7.3,
      actual_complete: 4.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-03-04",
      baseline_complete: 7.7,
      actual_complete: 4.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-03-11",
      baseline_complete: 8.1,
      actual_complete: 4.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-03-18",
      baseline_complete: 8.5,
      actual_complete: 4.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-03-25",
      baseline_complete: 9.0,
      actual_complete: 4.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-04-01",
      baseline_complete: 9.4,
      actual_complete: 5.6,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-04-08",
      baseline_complete: 9.9,
      actual_complete: 5.6,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-04-15",
      baseline_complete: 10.4,
      actual_complete: 6.7,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-04-22",
      baseline_complete: 11.0,
      actual_complete: 6.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-04-29",
      baseline_complete: 11.5,
      actual_complete: 6.7,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-05-06",
      baseline_complete: 12.1,
      actual_complete: 7.6,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-05-13",
      baseline_complete: 12.7,
      actual_complete: 10.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-05-20",
      baseline_complete: 13.4,
      actual_complete: 10.0,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-05-27",
      baseline_complete: 14.0,
      actual_complete: 10.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-06-03",
      baseline_complete: 14.7,
      actual_complete: 10.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-06-10",
      baseline_complete: 15.4,
      actual_complete: 10.8,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-06-17",
      baseline_complete: 16.2,
      actual_complete: 10.8,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-06-24",
      baseline_complete: 17.0,
      actual_complete: 14.1,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-07-01",
      baseline_complete: 17.8,
      actual_complete: 14.1,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-07-08",
      baseline_complete: 18.6,
      actual_complete: 16.3,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-07-15",
      baseline_complete: 19.4,
      actual_complete: 16.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-07-22",
      baseline_complete: 20.3,
      actual_complete: 18.3,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-07-29",
      baseline_complete: 21.3,
      actual_complete: 18.5,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-08-05",
      baseline_complete: 22.2,
      actual_complete: 18.5,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-08-12",
      baseline_complete: 23.2,
      actual_complete: 18.5,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-08-19",
      baseline_complete: 24.2,
      actual_complete: 19.2,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-08-26",
      baseline_complete: 25.2,
      actual_complete: 22.0,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-09-02",
      baseline_complete: 26.3,
      actual_complete: 22.0,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-09-09",
      baseline_complete: 27.4,
      actual_complete: 22.0,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-09-16",
      baseline_complete: 28.5,
      actual_complete: 25.7,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-09-23",
      baseline_complete: 29.7,
      actual_complete: 25.7,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-09-30",
      baseline_complete: 30.9,
      actual_complete: 27.1,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-10-07",
      baseline_complete: 32.1,
      actual_complete: 27.1,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-10-14",
      baseline_complete: 33.3,
      actual_complete: 29.8,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-10-21",
      baseline_complete: 34.6,
      actual_complete: 29.8,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-10-28",
      baseline_complete: 35.8,
      actual_complete: 32.5,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-11-04",
      baseline_complete: 37.1,
      actual_complete: 32.8,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-11-11",
      baseline_complete: 38.5,
      actual_complete: 36.5,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-11-18",
      baseline_complete: 39.8,
      actual_complete: 36.5,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-11-25",
      baseline_complete: 41.1,
      actual_complete: 38.8,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-12-02",
      baseline_complete: 42.5,
      actual_complete: 40.1,
      forecast_complete: 17.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-12-09",
      baseline_complete: 43.9,
      actual_complete: 40.1,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-12-16",
      baseline_complete: 45.3,
      actual_complete: 40.1,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-12-23",
      baseline_complete: 46.6,
      actual_complete: 45.0,
      forecast_complete: 19.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2025-12-30",
      baseline_complete: 48.0,
      actual_complete: 45.1,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-01-06",
      baseline_complete: 49.4,
      actual_complete: 45.9,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-01-13",
      baseline_complete: 50.8,
      actual_complete: 49.7,
      forecast_complete: 21.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-01-20",
      baseline_complete: 52.2,
      actual_complete: 50.9,
      forecast_complete: 22.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-01-27",
      baseline_complete: 53.6,
      actual_complete: 51.1,
      forecast_complete: 23.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-02-03",
      baseline_complete: 55.0,
      actual_complete: 51.4,
      forecast_complete: 24.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-02-10",
      baseline_complete: 56.4,
      actual_complete: 52.9,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-02-17",
      baseline_complete: 57.8,
      actual_complete: 53.5,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-02-24",
      baseline_complete: 59.1,
      actual_complete: 55.3,
      forecast_complete: 27.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-03-03",
      baseline_complete: 60.5,
      actual_complete: 57.0,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-03-10",
      baseline_complete: 61.8,
      actual_complete: 57.4,
      forecast_complete: 29.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-03-17",
      baseline_complete: 63.1,
      actual_complete: 58.2,
      forecast_complete: 29.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-03-24",
      baseline_complete: 64.4,
      actual_complete: 63.7,
      forecast_complete: 30.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-03-31",
      baseline_complete: 65.7,
      actual_complete: 63.7,
      forecast_complete: 31.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-04-07",
      baseline_complete: 66.9,
      actual_complete: 63.7,
      forecast_complete: 32.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-04-14",
      baseline_complete: 68.1,
      actual_complete: 66.4,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-04-21",
      baseline_complete: 69.3,
      actual_complete: 66.4,
      forecast_complete: 34.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-04-28",
      baseline_complete: 70.5,
      actual_complete: 66.4,
      forecast_complete: 35.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-05-05",
      baseline_complete: 71.7,
      actual_complete: 67.7,
      forecast_complete: 36.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-05-12",
      baseline_complete: 72.8,
      actual_complete: 67.7,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-05-19",
      baseline_complete: 73.9,
      actual_complete: 73.9,
      forecast_complete: 38.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-05-26",
      baseline_complete: 74.9,
      actual_complete: 73.9,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-06-02",
      baseline_complete: 76.0,
      actual_complete: 76.4,
      forecast_complete: 39.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-06-09",
      baseline_complete: 77.0,
      actual_complete: 76.4,
      forecast_complete: 40.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-06-16",
      baseline_complete: 78.0,
      actual_complete: 76.4,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-06-23",
      baseline_complete: 78.9,
      actual_complete: 76.4,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-06-30",
      baseline_complete: 79.8,
      actual_complete: 76.4,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-07-07",
      baseline_complete: 80.7,
      actual_complete: 80.6,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-07-14",
      baseline_complete: 81.6,
      actual_complete: 80.6,
      forecast_complete: 44.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-07-21",
      baseline_complete: 82.4,
      actual_complete: 80.6,
      forecast_complete: 45.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-07-28",
      baseline_complete: 83.2,
      actual_complete: 80.6,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-08-04",
      baseline_complete: 84.0,
      actual_complete: 83.2,
      forecast_complete: 47.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-08-11",
      baseline_complete: 84.7,
      actual_complete: 85.3,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-08-18",
      baseline_complete: 85.4,
      actual_complete: 85.3,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-08-25",
      baseline_complete: 86.1,
      actual_complete: 85.3,
      forecast_complete: 49.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-09-01",
      baseline_complete: 86.7,
      actual_complete: 85.3,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-09-08",
      baseline_complete: 87.4,
      actual_complete: 85.3,
      forecast_complete: 51.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-09-15",
      baseline_complete: 88.0,
      actual_complete: 85.4,
      forecast_complete: 51.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-09-22",
      baseline_complete: 88.6,
      actual_complete: 88.3,
      forecast_complete: 52.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-09-29",
      baseline_complete: 89.1,
      actual_complete: 89.2,
      forecast_complete: 53.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-10-06",
      baseline_complete: 89.6,
      actual_complete: 89.2,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-10-13",
      baseline_complete: 90.2,
      actual_complete: 89.2,
      forecast_complete: 54.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-10-20",
      baseline_complete: 90.6,
      actual_complete: 90.8,
      forecast_complete: 55.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-10-27",
      baseline_complete: 91.1,
      actual_complete: 90.8,
      forecast_complete: 56.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-11-03",
      baseline_complete: 91.5,
      actual_complete: 90.8,
      forecast_complete: 56.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-11-10",
      baseline_complete: 92.0,
      actual_complete: 92.6,
      forecast_complete: 57.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-11-17",
      baseline_complete: 92.4,
      actual_complete: 92.6,
      forecast_complete: 58.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-11-24",
      baseline_complete: 92.8,
      actual_complete: 92.6,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-12-01",
      baseline_complete: 93.1,
      actual_complete: 92.6,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-12-08",
      baseline_complete: 93.5,
      actual_complete: 92.6,
      forecast_complete: 59.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-12-15",
      baseline_complete: 93.8,
      actual_complete: 94.5,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-12-22",
      baseline_complete: 94.1,
      actual_complete: 94.5,
      forecast_complete: 61.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2026-12-29",
      baseline_complete: 94.4,
      actual_complete: 95.3,
      forecast_complete: 61.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-01-05",
      baseline_complete: 94.7,
      actual_complete: 95.3,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-01-12",
      baseline_complete: 95.0,
      actual_complete: 95.3,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-01-19",
      baseline_complete: 95.2,
      actual_complete: 96.0,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-01-26",
      baseline_complete: 95.5,
      actual_complete: 96.0,
      forecast_complete: 64.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-02-02",
      baseline_complete: 95.7,
      actual_complete: 96.0,
      forecast_complete: 64.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-02-09",
      baseline_complete: 96.0,
      actual_complete: 96.4,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-02-16",
      baseline_complete: 96.2,
      actual_complete: 97.4,
      forecast_complete: 65.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-02-23",
      baseline_complete: 96.4,
      actual_complete: 97.4,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-03-02",
      baseline_complete: 96.6,
      actual_complete: 97.4,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-03-09",
      baseline_complete: 96.7,
      actual_complete: 97.4,
      forecast_complete: 67.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-03-16",
      baseline_complete: 96.9,
      actual_complete: 97.6,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-03-23",
      baseline_complete: 97.1,
      actual_complete: 97.6,
      forecast_complete: 68.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-03-30",
      baseline_complete: 97.2,
      actual_complete: 97.6,
      forecast_complete: 68.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-04-06",
      baseline_complete: 97.4,
      actual_complete: 99.4,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-04-13",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 70.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-04-20",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-04-27",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 71.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-05-04",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 71.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-05-11",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-05-18",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 72.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-05-25",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 73.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-06-01",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 74.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-06-08",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 75.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-06-15",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 76.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-06-22",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-06-29",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 77.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-07-06",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 78.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-07-13",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-07-20",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 80.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-07-27",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 80.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-08-03",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 81.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-08-10",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-08-17",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-08-24",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-08-31",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 84.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-09-07",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 85.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-09-14",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-09-21",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 86.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-09-28",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-10-05",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-10-12",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-10-19",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 88.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-10-26",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-11-02",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-11-09",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-11-16",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-11-23",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-11-30",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 91.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-12-07",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-12-14",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-12-21",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2027-12-28",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-01-04",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-01-11",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-01-18",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-01-25",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-02-01",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-02-08",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-02-15",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-02-22",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-02-29",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-03-07",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-03-14",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-03-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-03-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-04-04",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-04-11",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-04-18",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-04-25",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-05-02",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-05-09",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-05-16",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-05-23",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-05-30",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-06-06",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-06-13",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-06-20",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-06-27",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "a25b76e9-5b96-7aff-1cb2-98fedb6452d5",
      reporting_date: "2028-07-02",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
  ],
  "b112cc5a-7e35-091d-7614-bd760a27cf58": [
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-01-04",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-01-11",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-01-18",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-01-25",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-02-01",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-02-08",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-02-15",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-02-22",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-02-29",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-03-07",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-03-14",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-03-21",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-03-28",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-04-04",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-04-11",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-04-18",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-04-25",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-05-02",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-05-09",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-05-16",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-05-23",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-05-30",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-06-06",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-06-13",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-06-20",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-06-27",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-07-04",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-07-11",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-07-18",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-07-25",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-08-01",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-08-08",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-08-15",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-08-22",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-08-29",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-09-05",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-09-12",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-09-19",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-09-26",
      baseline_complete: 3.7,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-10-03",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-10-10",
      baseline_complete: 4.0,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-10-17",
      baseline_complete: 4.2,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-10-24",
      baseline_complete: 4.3,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-10-31",
      baseline_complete: 4.5,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-11-07",
      baseline_complete: 4.6,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-11-14",
      baseline_complete: 4.8,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-11-21",
      baseline_complete: 5.0,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-11-28",
      baseline_complete: 5.2,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-12-05",
      baseline_complete: 5.3,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-12-12",
      baseline_complete: 5.5,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-12-19",
      baseline_complete: 5.7,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2024-12-26",
      baseline_complete: 5.9,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-01-02",
      baseline_complete: 6.2,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-01-09",
      baseline_complete: 6.4,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-01-16",
      baseline_complete: 6.6,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-01-23",
      baseline_complete: 6.8,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-01-30",
      baseline_complete: 7.1,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-02-06",
      baseline_complete: 7.3,
      actual_complete: 1.4,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-02-13",
      baseline_complete: 7.6,
      actual_complete: 1.4,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-02-20",
      baseline_complete: 7.9,
      actual_complete: 1.4,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-02-27",
      baseline_complete: 8.1,
      actual_complete: 3.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-03-06",
      baseline_complete: 8.4,
      actual_complete: 3.0,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-03-13",
      baseline_complete: 8.7,
      actual_complete: 3.9,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-03-20",
      baseline_complete: 9.0,
      actual_complete: 3.9,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-03-27",
      baseline_complete: 9.3,
      actual_complete: 3.9,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-04-03",
      baseline_complete: 9.7,
      actual_complete: 3.9,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-04-10",
      baseline_complete: 10.0,
      actual_complete: 4.7,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-04-17",
      baseline_complete: 10.3,
      actual_complete: 4.8,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-04-24",
      baseline_complete: 10.7,
      actual_complete: 4.9,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-05-01",
      baseline_complete: 11.0,
      actual_complete: 4.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-05-08",
      baseline_complete: 11.4,
      actual_complete: 4.9,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-05-15",
      baseline_complete: 11.8,
      actual_complete: 5.2,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-05-22",
      baseline_complete: 12.2,
      actual_complete: 7.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-05-29",
      baseline_complete: 12.6,
      actual_complete: 7.7,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-06-05",
      baseline_complete: 13.0,
      actual_complete: 7.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-06-12",
      baseline_complete: 13.5,
      actual_complete: 9.4,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-06-19",
      baseline_complete: 13.9,
      actual_complete: 9.5,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-06-26",
      baseline_complete: 14.4,
      actual_complete: 9.5,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-07-03",
      baseline_complete: 14.8,
      actual_complete: 9.5,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-07-10",
      baseline_complete: 15.3,
      actual_complete: 9.5,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-07-17",
      baseline_complete: 15.8,
      actual_complete: 11.0,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-07-24",
      baseline_complete: 16.3,
      actual_complete: 11.0,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-07-31",
      baseline_complete: 16.8,
      actual_complete: 11.0,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-08-07",
      baseline_complete: 17.4,
      actual_complete: 12.6,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-08-14",
      baseline_complete: 17.9,
      actual_complete: 13.8,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-08-21",
      baseline_complete: 18.5,
      actual_complete: 13.8,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-08-28",
      baseline_complete: 19.0,
      actual_complete: 13.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-09-04",
      baseline_complete: 19.6,
      actual_complete: 14.0,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-09-11",
      baseline_complete: 20.2,
      actual_complete: 16.3,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-09-18",
      baseline_complete: 20.8,
      actual_complete: 16.3,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-09-25",
      baseline_complete: 21.5,
      actual_complete: 16.8,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-10-02",
      baseline_complete: 22.1,
      actual_complete: 16.8,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-10-09",
      baseline_complete: 22.8,
      actual_complete: 18.0,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-10-16",
      baseline_complete: 23.4,
      actual_complete: 18.0,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-10-23",
      baseline_complete: 24.1,
      actual_complete: 19.0,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-10-30",
      baseline_complete: 24.8,
      actual_complete: 19.8,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-11-06",
      baseline_complete: 25.5,
      actual_complete: 19.8,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-11-13",
      baseline_complete: 26.2,
      actual_complete: 21.0,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-11-20",
      baseline_complete: 27.0,
      actual_complete: 23.9,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-11-27",
      baseline_complete: 27.7,
      actual_complete: 23.9,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-12-04",
      baseline_complete: 28.5,
      actual_complete: 24.1,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-12-11",
      baseline_complete: 29.2,
      actual_complete: 24.2,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-12-18",
      baseline_complete: 30.0,
      actual_complete: 24.6,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2025-12-25",
      baseline_complete: 30.8,
      actual_complete: 27.1,
      forecast_complete: 12.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-01-01",
      baseline_complete: 31.6,
      actual_complete: 27.1,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-01-08",
      baseline_complete: 32.4,
      actual_complete: 28.2,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-01-15",
      baseline_complete: 33.3,
      actual_complete: 30.0,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-01-22",
      baseline_complete: 34.1,
      actual_complete: 30.0,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-01-29",
      baseline_complete: 34.9,
      actual_complete: 30.0,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-02-05",
      baseline_complete: 35.8,
      actual_complete: 32.9,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-02-12",
      baseline_complete: 36.7,
      actual_complete: 32.9,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-02-19",
      baseline_complete: 37.5,
      actual_complete: 32.9,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-02-26",
      baseline_complete: 38.4,
      actual_complete: 34.6,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-03-05",
      baseline_complete: 39.3,
      actual_complete: 36.3,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-03-12",
      baseline_complete: 40.2,
      actual_complete: 36.5,
      forecast_complete: 18.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-03-19",
      baseline_complete: 41.1,
      actual_complete: 36.5,
      forecast_complete: 18.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-03-26",
      baseline_complete: 42.0,
      actual_complete: 39.3,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-04-02",
      baseline_complete: 43.0,
      actual_complete: 39.4,
      forecast_complete: 20.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-04-09",
      baseline_complete: 43.9,
      actual_complete: 41.2,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-04-16",
      baseline_complete: 44.8,
      actual_complete: 41.2,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-04-23",
      baseline_complete: 45.7,
      actual_complete: 41.2,
      forecast_complete: 21.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-04-30",
      baseline_complete: 46.7,
      actual_complete: 42.5,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-05-07",
      baseline_complete: 47.6,
      actual_complete: 42.5,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-05-14",
      baseline_complete: 48.6,
      actual_complete: 45.1,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-05-21",
      baseline_complete: 49.5,
      actual_complete: 47.5,
      forecast_complete: 24.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-05-28",
      baseline_complete: 50.4,
      actual_complete: 47.5,
      forecast_complete: 25.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-06-04",
      baseline_complete: 51.4,
      actual_complete: 47.7,
      forecast_complete: 25.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-06-11",
      baseline_complete: 52.3,
      actual_complete: 49.7,
      forecast_complete: 26.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-06-18",
      baseline_complete: 53.2,
      actual_complete: 50.8,
      forecast_complete: 27.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-06-25",
      baseline_complete: 54.2,
      actual_complete: 52.3,
      forecast_complete: 27.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-07-02",
      baseline_complete: 55.1,
      actual_complete: 52.3,
      forecast_complete: 28.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-07-09",
      baseline_complete: 56.0,
      actual_complete: 52.3,
      forecast_complete: 29.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-07-16",
      baseline_complete: 57.0,
      actual_complete: 54.9,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-07-23",
      baseline_complete: 57.9,
      actual_complete: 54.9,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-07-30",
      baseline_complete: 58.8,
      actual_complete: 56.2,
      forecast_complete: 31.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-08-06",
      baseline_complete: 59.7,
      actual_complete: 56.2,
      forecast_complete: 32.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-08-13",
      baseline_complete: 60.6,
      actual_complete: 56.2,
      forecast_complete: 32.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-08-20",
      baseline_complete: 61.5,
      actual_complete: 59.8,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-08-27",
      baseline_complete: 62.4,
      actual_complete: 59.8,
      forecast_complete: 34.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-09-03",
      baseline_complete: 63.3,
      actual_complete: 61.3,
      forecast_complete: 35.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-09-10",
      baseline_complete: 64.1,
      actual_complete: 61.3,
      forecast_complete: 35.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-09-17",
      baseline_complete: 65.0,
      actual_complete: 63.1,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-09-24",
      baseline_complete: 65.8,
      actual_complete: 63.1,
      forecast_complete: 37.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-10-01",
      baseline_complete: 66.7,
      actual_complete: 63.1,
      forecast_complete: 37.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-10-08",
      baseline_complete: 67.5,
      actual_complete: 65.2,
      forecast_complete: 38.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-10-15",
      baseline_complete: 68.3,
      actual_complete: 65.2,
      forecast_complete: 39.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-10-22",
      baseline_complete: 69.1,
      actual_complete: 65.9,
      forecast_complete: 40.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-10-29",
      baseline_complete: 69.9,
      actual_complete: 66.0,
      forecast_complete: 40.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-11-05",
      baseline_complete: 70.7,
      actual_complete: 67.9,
      forecast_complete: 41.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-11-12",
      baseline_complete: 71.5,
      actual_complete: 69.8,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-11-19",
      baseline_complete: 72.2,
      actual_complete: 70.9,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-11-26",
      baseline_complete: 73.0,
      actual_complete: 70.9,
      forecast_complete: 43.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-12-03",
      baseline_complete: 73.7,
      actual_complete: 71.0,
      forecast_complete: 44.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-12-10",
      baseline_complete: 74.4,
      actual_complete: 71.6,
      forecast_complete: 45.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-12-17",
      baseline_complete: 75.1,
      actual_complete: 73.8,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-12-24",
      baseline_complete: 75.8,
      actual_complete: 73.8,
      forecast_complete: 46.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2026-12-31",
      baseline_complete: 76.5,
      actual_complete: 73.8,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-01-07",
      baseline_complete: 77.2,
      actual_complete: 76.4,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-01-14",
      baseline_complete: 77.8,
      actual_complete: 76.5,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-01-21",
      baseline_complete: 78.5,
      actual_complete: 76.5,
      forecast_complete: 49.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-01-28",
      baseline_complete: 79.1,
      actual_complete: 76.9,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-02-04",
      baseline_complete: 79.7,
      actual_complete: 77.1,
      forecast_complete: 50.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-02-11",
      baseline_complete: 80.3,
      actual_complete: 79.9,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-02-18",
      baseline_complete: 80.9,
      actual_complete: 80.2,
      forecast_complete: 52.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-02-25",
      baseline_complete: 81.5,
      actual_complete: 80.2,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-03-04",
      baseline_complete: 82.0,
      actual_complete: 81.2,
      forecast_complete: 53.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-03-11",
      baseline_complete: 82.6,
      actual_complete: 81.2,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-03-18",
      baseline_complete: 83.1,
      actual_complete: 81.2,
      forecast_complete: 55.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-03-25",
      baseline_complete: 83.6,
      actual_complete: 81.2,
      forecast_complete: 55.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-04-01",
      baseline_complete: 84.2,
      actual_complete: 82.9,
      forecast_complete: 56.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-04-08",
      baseline_complete: 84.7,
      actual_complete: 83.1,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-04-15",
      baseline_complete: 85.1,
      actual_complete: 85.2,
      forecast_complete: 57.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-04-22",
      baseline_complete: 85.6,
      actual_complete: 85.2,
      forecast_complete: 58.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-04-29",
      baseline_complete: 86.1,
      actual_complete: 85.2,
      forecast_complete: 59.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-05-06",
      baseline_complete: 86.5,
      actual_complete: 85.2,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-05-13",
      baseline_complete: 86.9,
      actual_complete: 85.2,
      forecast_complete: 60.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-05-20",
      baseline_complete: 87.4,
      actual_complete: 85.2,
      forecast_complete: 61.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-05-27",
      baseline_complete: 87.8,
      actual_complete: 86.1,
      forecast_complete: 61.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-06-03",
      baseline_complete: 88.2,
      actual_complete: 88.9,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-06-10",
      baseline_complete: 88.5,
      actual_complete: 88.9,
      forecast_complete: 62.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-06-17",
      baseline_complete: 88.9,
      actual_complete: 88.9,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-06-24",
      baseline_complete: 89.3,
      actual_complete: 88.9,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-07-01",
      baseline_complete: 89.6,
      actual_complete: 89.1,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-07-08",
      baseline_complete: 90.0,
      actual_complete: 89.1,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-07-15",
      baseline_complete: 90.3,
      actual_complete: 89.1,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-07-22",
      baseline_complete: 90.6,
      actual_complete: 89.1,
      forecast_complete: 66.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-07-29",
      baseline_complete: 91.0,
      actual_complete: 89.6,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-08-05",
      baseline_complete: 91.3,
      actual_complete: 89.8,
      forecast_complete: 67.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-08-12",
      baseline_complete: 91.6,
      actual_complete: 91.6,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-08-19",
      baseline_complete: 91.8,
      actual_complete: 91.6,
      forecast_complete: 68.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-08-26",
      baseline_complete: 92.1,
      actual_complete: 91.9,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-09-02",
      baseline_complete: 92.4,
      actual_complete: 91.9,
      forecast_complete: 70.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-09-09",
      baseline_complete: 92.6,
      actual_complete: 93.6,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-09-16",
      baseline_complete: 92.9,
      actual_complete: 93.6,
      forecast_complete: 72.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-09-23",
      baseline_complete: 93.1,
      actual_complete: 93.6,
      forecast_complete: 73.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-09-30",
      baseline_complete: 93.4,
      actual_complete: 93.6,
      forecast_complete: 74.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-10-07",
      baseline_complete: 93.6,
      actual_complete: 93.6,
      forecast_complete: 75.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-10-14",
      baseline_complete: 93.8,
      actual_complete: 94.0,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-10-21",
      baseline_complete: 94.0,
      actual_complete: 94.0,
      forecast_complete: 77.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-10-28",
      baseline_complete: 94.2,
      actual_complete: 94.0,
      forecast_complete: 78.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-11-04",
      baseline_complete: 94.4,
      actual_complete: 95.3,
      forecast_complete: 79.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-11-11",
      baseline_complete: 94.6,
      actual_complete: 95.3,
      forecast_complete: 79.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-11-18",
      baseline_complete: 94.8,
      actual_complete: 95.6,
      forecast_complete: 80.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-11-25",
      baseline_complete: 95.0,
      actual_complete: 95.6,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-12-02",
      baseline_complete: 95.2,
      actual_complete: 95.8,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-12-09",
      baseline_complete: 95.4,
      actual_complete: 96.2,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-12-16",
      baseline_complete: 95.5,
      actual_complete: 96.6,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-12-23",
      baseline_complete: 95.7,
      actual_complete: 96.6,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2027-12-30",
      baseline_complete: 95.8,
      actual_complete: 96.6,
      forecast_complete: 85.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-01-06",
      baseline_complete: 96.0,
      actual_complete: 96.6,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-01-13",
      baseline_complete: 96.1,
      actual_complete: 96.6,
      forecast_complete: 86.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-01-20",
      baseline_complete: 96.3,
      actual_complete: 96.6,
      forecast_complete: 87.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-01-27",
      baseline_complete: 96.4,
      actual_complete: 96.6,
      forecast_complete: 87.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-02-03",
      baseline_complete: 96.5,
      actual_complete: 96.6,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-02-10",
      baseline_complete: 96.6,
      actual_complete: 96.6,
      forecast_complete: 89.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-02-17",
      baseline_complete: 96.8,
      actual_complete: 96.6,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-02-24",
      baseline_complete: 96.9,
      actual_complete: 96.6,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-03-02",
      baseline_complete: 97.0,
      actual_complete: 96.6,
      forecast_complete: 90.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-03-09",
      baseline_complete: 97.1,
      actual_complete: 96.8,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-03-16",
      baseline_complete: 97.2,
      actual_complete: 97.4,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-03-23",
      baseline_complete: 97.3,
      actual_complete: 98.7,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-03-30",
      baseline_complete: 97.4,
      actual_complete: 98.7,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-04-06",
      baseline_complete: 97.5,
      actual_complete: 99.9,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-04-13",
      baseline_complete: 97.6,
      actual_complete: 99.9,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-04-20",
      baseline_complete: 97.7,
      actual_complete: 99.9,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-04-27",
      baseline_complete: 97.8,
      actual_complete: 99.9,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-05-04",
      baseline_complete: 97.8,
      actual_complete: 99.9,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-05-11",
      baseline_complete: 97.9,
      actual_complete: 99.9,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-05-18",
      baseline_complete: 98.0,
      actual_complete: 99.9,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-05-25",
      baseline_complete: 98.1,
      actual_complete: 99.9,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-06-01",
      baseline_complete: 98.1,
      actual_complete: 99.9,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-06-08",
      baseline_complete: 98.2,
      actual_complete: 99.9,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-06-15",
      baseline_complete: 98.3,
      actual_complete: 99.9,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-06-22",
      baseline_complete: 98.3,
      actual_complete: 99.9,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-06-29",
      baseline_complete: 98.4,
      actual_complete: 99.9,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-07-06",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-07-13",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-07-20",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-07-27",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-08-03",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-08-10",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-08-17",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-08-24",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-08-31",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-09-07",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-09-14",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-09-21",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-09-28",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-10-05",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-10-12",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-10-19",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-10-26",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-11-02",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b112cc5a-7e35-091d-7614-bd760a27cf58",
      reporting_date: "2028-11-04",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "5f235cf2-eace-0d96-f75e-c2bad2b01277": [
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2025-12-24",
      baseline_complete: 0.3,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2025-12-31",
      baseline_complete: 0.4,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-01-07",
      baseline_complete: 0.4,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-01-14",
      baseline_complete: 0.4,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-01-21",
      baseline_complete: 0.5,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-01-28",
      baseline_complete: 0.5,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-02-04",
      baseline_complete: 0.6,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-02-11",
      baseline_complete: 0.6,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-02-18",
      baseline_complete: 0.7,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-02-25",
      baseline_complete: 0.7,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-03-04",
      baseline_complete: 0.8,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-03-11",
      baseline_complete: 0.9,
      actual_complete: 1.4,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-03-18",
      baseline_complete: 0.9,
      actual_complete: 2.1,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-03-25",
      baseline_complete: 1.0,
      actual_complete: 2.1,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-04-01",
      baseline_complete: 1.1,
      actual_complete: 2.1,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-04-08",
      baseline_complete: 1.2,
      actual_complete: 3.2,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-04-15",
      baseline_complete: 1.3,
      actual_complete: 3.2,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-04-22",
      baseline_complete: 1.5,
      actual_complete: 3.2,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-04-29",
      baseline_complete: 1.6,
      actual_complete: 3.2,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-05-06",
      baseline_complete: 1.8,
      actual_complete: 3.2,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-05-13",
      baseline_complete: 1.9,
      actual_complete: 3.2,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-05-20",
      baseline_complete: 2.1,
      actual_complete: 3.2,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-05-27",
      baseline_complete: 2.3,
      actual_complete: 3.2,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-06-03",
      baseline_complete: 2.5,
      actual_complete: 3.2,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-06-10",
      baseline_complete: 2.7,
      actual_complete: 3.2,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-06-17",
      baseline_complete: 3.0,
      actual_complete: 4.4,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-06-24",
      baseline_complete: 3.2,
      actual_complete: 4.4,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-07-01",
      baseline_complete: 3.5,
      actual_complete: 5.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-07-08",
      baseline_complete: 3.9,
      actual_complete: 5.2,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-07-15",
      baseline_complete: 4.2,
      actual_complete: 5.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-07-22",
      baseline_complete: 4.6,
      actual_complete: 5.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-07-29",
      baseline_complete: 5.0,
      actual_complete: 5.2,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-08-05",
      baseline_complete: 5.4,
      actual_complete: 5.2,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-08-12",
      baseline_complete: 5.9,
      actual_complete: 5.6,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-08-19",
      baseline_complete: 6.4,
      actual_complete: 8.4,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-08-26",
      baseline_complete: 7.0,
      actual_complete: 9.3,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-09-02",
      baseline_complete: 7.6,
      actual_complete: 9.3,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-09-09",
      baseline_complete: 8.2,
      actual_complete: 9.3,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-09-16",
      baseline_complete: 8.9,
      actual_complete: 9.3,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-09-23",
      baseline_complete: 9.7,
      actual_complete: 10.4,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-09-30",
      baseline_complete: 10.5,
      actual_complete: 10.4,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-10-07",
      baseline_complete: 11.4,
      actual_complete: 13.3,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-10-14",
      baseline_complete: 12.3,
      actual_complete: 13.3,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-10-21",
      baseline_complete: 13.3,
      actual_complete: 13.7,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-10-28",
      baseline_complete: 14.4,
      actual_complete: 17.9,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-11-04",
      baseline_complete: 15.5,
      actual_complete: 18.4,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-11-11",
      baseline_complete: 16.8,
      actual_complete: 18.4,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-11-18",
      baseline_complete: 18.0,
      actual_complete: 19.2,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-11-25",
      baseline_complete: 19.4,
      actual_complete: 21.5,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-12-02",
      baseline_complete: 20.8,
      actual_complete: 23.2,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-12-09",
      baseline_complete: 22.4,
      actual_complete: 23.2,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-12-16",
      baseline_complete: 24.0,
      actual_complete: 25.0,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-12-23",
      baseline_complete: 25.6,
      actual_complete: 25.0,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2026-12-30",
      baseline_complete: 27.4,
      actual_complete: 28.8,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-01-06",
      baseline_complete: 29.2,
      actual_complete: 30.9,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-01-13",
      baseline_complete: 31.1,
      actual_complete: 33.4,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-01-20",
      baseline_complete: 33.0,
      actual_complete: 36.5,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-01-27",
      baseline_complete: 35.1,
      actual_complete: 36.5,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-02-03",
      baseline_complete: 37.1,
      actual_complete: 36.7,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-02-10",
      baseline_complete: 39.2,
      actual_complete: 39.8,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-02-17",
      baseline_complete: 41.4,
      actual_complete: 43.9,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-02-24",
      baseline_complete: 43.6,
      actual_complete: 45.1,
      forecast_complete: 20.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-03-03",
      baseline_complete: 45.8,
      actual_complete: 45.2,
      forecast_complete: 21.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-03-10",
      baseline_complete: 48.0,
      actual_complete: 46.2,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-03-17",
      baseline_complete: 50.3,
      actual_complete: 54.4,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-03-24",
      baseline_complete: 52.5,
      actual_complete: 54.4,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-03-31",
      baseline_complete: 54.8,
      actual_complete: 58.2,
      forecast_complete: 26.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-04-07",
      baseline_complete: 57.0,
      actual_complete: 58.2,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-04-14",
      baseline_complete: 59.2,
      actual_complete: 58.2,
      forecast_complete: 29.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-04-21",
      baseline_complete: 61.3,
      actual_complete: 59.7,
      forecast_complete: 31.1,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-04-28",
      baseline_complete: 63.4,
      actual_complete: 63.0,
      forecast_complete: 32.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-05-05",
      baseline_complete: 65.5,
      actual_complete: 63.4,
      forecast_complete: 34.1,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-05-12",
      baseline_complete: 67.5,
      actual_complete: 69.2,
      forecast_complete: 35.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-05-19",
      baseline_complete: 69.4,
      actual_complete: 71.4,
      forecast_complete: 37.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-05-26",
      baseline_complete: 71.3,
      actual_complete: 71.4,
      forecast_complete: 38.5,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-06-02",
      baseline_complete: 73.1,
      actual_complete: 71.4,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-06-09",
      baseline_complete: 74.8,
      actual_complete: 75.5,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-06-16",
      baseline_complete: 76.5,
      actual_complete: 75.5,
      forecast_complete: 42.9,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-06-23",
      baseline_complete: 78.0,
      actual_complete: 78.2,
      forecast_complete: 44.3,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-06-30",
      baseline_complete: 79.5,
      actual_complete: 78.3,
      forecast_complete: 45.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-07-07",
      baseline_complete: 80.9,
      actual_complete: 83.6,
      forecast_complete: 47.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-07-14",
      baseline_complete: 82.3,
      actual_complete: 83.6,
      forecast_complete: 48.4,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-07-21",
      baseline_complete: 83.6,
      actual_complete: 83.9,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-07-28",
      baseline_complete: 84.8,
      actual_complete: 83.9,
      forecast_complete: 51.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-08-04",
      baseline_complete: 85.9,
      actual_complete: 83.9,
      forecast_complete: 52.3,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-08-11",
      baseline_complete: 86.9,
      actual_complete: 85.2,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-08-18",
      baseline_complete: 87.9,
      actual_complete: 86.4,
      forecast_complete: 54.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-08-25",
      baseline_complete: 88.8,
      actual_complete: 90.9,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-09-01",
      baseline_complete: 89.7,
      actual_complete: 93.4,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-09-08",
      baseline_complete: 90.5,
      actual_complete: 93.4,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-09-15",
      baseline_complete: 91.2,
      actual_complete: 93.4,
      forecast_complete: 59.3,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-09-22",
      baseline_complete: 91.9,
      actual_complete: 94.3,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-09-29",
      baseline_complete: 92.6,
      actual_complete: 94.3,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-10-06",
      baseline_complete: 93.2,
      actual_complete: 95.9,
      forecast_complete: 62.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-10-13",
      baseline_complete: 93.7,
      actual_complete: 95.9,
      forecast_complete: 63.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-10-20",
      baseline_complete: 94.2,
      actual_complete: 95.9,
      forecast_complete: 64.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-10-27",
      baseline_complete: 94.7,
      actual_complete: 98.3,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-11-03",
      baseline_complete: 95.1,
      actual_complete: 100.0,
      forecast_complete: 66.5,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-11-10",
      baseline_complete: 95.5,
      actual_complete: 100.0,
      forecast_complete: 67.5,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-11-17",
      baseline_complete: 95.9,
      actual_complete: 100.0,
      forecast_complete: 68.4,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-11-24",
      baseline_complete: 96.2,
      actual_complete: 100.0,
      forecast_complete: 69.3,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-12-01",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-12-08",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 71.1,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-12-15",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-12-22",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2027-12-29",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 73.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-01-05",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 75.3,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-01-12",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 76.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-01-19",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 78.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-01-26",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-02-02",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 81.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-02-09",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 82.3,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-02-16",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 83.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-02-23",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 84.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-03-01",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 85.9,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-03-08",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-03-15",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-03-22",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-03-29",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 90.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-04-05",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-04-12",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-04-19",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-04-26",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-05-03",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-05-10",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-05-17",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-05-24",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-05-31",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-06-07",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-06-14",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-06-21",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-06-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-07-05",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-07-12",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-07-19",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-07-26",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-08-02",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-08-09",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-08-16",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-08-23",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5f235cf2-eace-0d96-f75e-c2bad2b01277",
      reporting_date: "2028-08-24",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "a0371066-c6ea-e289-d64c-bf33a05a98e7": [
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-06-15",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-06-22",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-06-29",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-07-06",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-07-13",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-07-20",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-07-27",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-08-03",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-08-10",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-08-17",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-08-24",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-08-31",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-09-07",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-09-14",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-09-21",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-09-28",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-10-05",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-10-12",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-10-19",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-10-26",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-11-02",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-11-09",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-11-16",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-11-23",
      baseline_complete: 3.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-11-30",
      baseline_complete: 4.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-12-07",
      baseline_complete: 4.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-12-14",
      baseline_complete: 4.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-12-21",
      baseline_complete: 4.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2023-12-28",
      baseline_complete: 4.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-01-04",
      baseline_complete: 5.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-01-11",
      baseline_complete: 5.5,
      actual_complete: 0.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-01-18",
      baseline_complete: 5.7,
      actual_complete: 0.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-01-25",
      baseline_complete: 6.1,
      actual_complete: 0.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-02-01",
      baseline_complete: 6.4,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-02-08",
      baseline_complete: 6.7,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-02-15",
      baseline_complete: 7.1,
      actual_complete: 0.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-02-22",
      baseline_complete: 7.5,
      actual_complete: 1.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-02-29",
      baseline_complete: 7.8,
      actual_complete: 2.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-03-07",
      baseline_complete: 8.3,
      actual_complete: 2.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-03-14",
      baseline_complete: 8.7,
      actual_complete: 3.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-03-21",
      baseline_complete: 9.1,
      actual_complete: 3.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-03-28",
      baseline_complete: 9.6,
      actual_complete: 5.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-04-04",
      baseline_complete: 10.1,
      actual_complete: 5.1,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-04-11",
      baseline_complete: 10.6,
      actual_complete: 5.1,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-04-18",
      baseline_complete: 11.2,
      actual_complete: 5.2,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-04-25",
      baseline_complete: 11.7,
      actual_complete: 6.7,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-05-02",
      baseline_complete: 12.3,
      actual_complete: 6.7,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-05-09",
      baseline_complete: 12.9,
      actual_complete: 8.7,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-05-16",
      baseline_complete: 13.6,
      actual_complete: 9.1,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-05-23",
      baseline_complete: 14.2,
      actual_complete: 9.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-05-30",
      baseline_complete: 14.9,
      actual_complete: 10.1,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-06-06",
      baseline_complete: 15.6,
      actual_complete: 10.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-06-13",
      baseline_complete: 16.4,
      actual_complete: 11.9,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-06-20",
      baseline_complete: 17.2,
      actual_complete: 11.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-06-27",
      baseline_complete: 18.0,
      actual_complete: 13.3,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-07-04",
      baseline_complete: 18.8,
      actual_complete: 14.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-07-11",
      baseline_complete: 19.7,
      actual_complete: 15.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-07-18",
      baseline_complete: 20.6,
      actual_complete: 15.0,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-07-25",
      baseline_complete: 21.5,
      actual_complete: 16.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-08-01",
      baseline_complete: 22.4,
      actual_complete: 17.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-08-08",
      baseline_complete: 23.4,
      actual_complete: 17.8,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-08-15",
      baseline_complete: 24.4,
      actual_complete: 20.7,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-08-22",
      baseline_complete: 25.5,
      actual_complete: 21.3,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-08-29",
      baseline_complete: 26.5,
      actual_complete: 22.1,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-09-05",
      baseline_complete: 27.6,
      actual_complete: 22.6,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-09-12",
      baseline_complete: 28.8,
      actual_complete: 25.1,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-09-19",
      baseline_complete: 29.9,
      actual_complete: 25.1,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-09-26",
      baseline_complete: 31.1,
      actual_complete: 26.1,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-10-03",
      baseline_complete: 32.3,
      actual_complete: 27.0,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-10-10",
      baseline_complete: 33.5,
      actual_complete: 30.6,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-10-17",
      baseline_complete: 34.8,
      actual_complete: 30.7,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-10-24",
      baseline_complete: 36.1,
      actual_complete: 31.9,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-10-31",
      baseline_complete: 37.3,
      actual_complete: 33.9,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-11-07",
      baseline_complete: 38.7,
      actual_complete: 35.2,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-11-14",
      baseline_complete: 40.0,
      actual_complete: 35.2,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-11-21",
      baseline_complete: 41.3,
      actual_complete: 38.0,
      forecast_complete: 14.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-11-28",
      baseline_complete: 42.7,
      actual_complete: 38.0,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-12-05",
      baseline_complete: 44.0,
      actual_complete: 41.3,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-12-12",
      baseline_complete: 45.4,
      actual_complete: 41.3,
      forecast_complete: 16.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-12-19",
      baseline_complete: 46.8,
      actual_complete: 42.8,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2024-12-26",
      baseline_complete: 48.2,
      actual_complete: 43.9,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-01-02",
      baseline_complete: 49.6,
      actual_complete: 46.2,
      forecast_complete: 19.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-01-09",
      baseline_complete: 51.0,
      actual_complete: 47.7,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-01-16",
      baseline_complete: 52.4,
      actual_complete: 50.3,
      forecast_complete: 21.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-01-23",
      baseline_complete: 53.7,
      actual_complete: 50.5,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-01-30",
      baseline_complete: 55.1,
      actual_complete: 52.1,
      forecast_complete: 22.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-02-06",
      baseline_complete: 56.5,
      actual_complete: 52.1,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-02-13",
      baseline_complete: 57.9,
      actual_complete: 55.3,
      forecast_complete: 24.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-02-20",
      baseline_complete: 59.2,
      actual_complete: 57.0,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-02-27",
      baseline_complete: 60.5,
      actual_complete: 57.1,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-03-06",
      baseline_complete: 61.9,
      actual_complete: 58.8,
      forecast_complete: 27.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-03-13",
      baseline_complete: 63.2,
      actual_complete: 60.9,
      forecast_complete: 28.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-03-20",
      baseline_complete: 64.5,
      actual_complete: 62.5,
      forecast_complete: 29.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-03-27",
      baseline_complete: 65.7,
      actual_complete: 62.9,
      forecast_complete: 30.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-04-03",
      baseline_complete: 67.0,
      actual_complete: 64.7,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-04-10",
      baseline_complete: 68.2,
      actual_complete: 64.7,
      forecast_complete: 32.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-04-17",
      baseline_complete: 69.4,
      actual_complete: 66.3,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-04-24",
      baseline_complete: 70.5,
      actual_complete: 67.4,
      forecast_complete: 34.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-05-01",
      baseline_complete: 71.7,
      actual_complete: 68.9,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-05-08",
      baseline_complete: 72.8,
      actual_complete: 71.2,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-05-15",
      baseline_complete: 73.9,
      actual_complete: 71.2,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-05-22",
      baseline_complete: 74.9,
      actual_complete: 72.1,
      forecast_complete: 38.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-05-29",
      baseline_complete: 76.0,
      actual_complete: 72.1,
      forecast_complete: 39.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-06-05",
      baseline_complete: 77.0,
      actual_complete: 72.8,
      forecast_complete: 40.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-06-12",
      baseline_complete: 77.9,
      actual_complete: 74.3,
      forecast_complete: 41.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-06-19",
      baseline_complete: 78.9,
      actual_complete: 76.7,
      forecast_complete: 42.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-06-26",
      baseline_complete: 79.8,
      actual_complete: 78.6,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-07-03",
      baseline_complete: 80.7,
      actual_complete: 78.6,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-07-10",
      baseline_complete: 81.5,
      actual_complete: 79.3,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-07-17",
      baseline_complete: 82.4,
      actual_complete: 79.9,
      forecast_complete: 45.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-07-24",
      baseline_complete: 83.1,
      actual_complete: 79.9,
      forecast_complete: 46.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-07-31",
      baseline_complete: 83.9,
      actual_complete: 81.7,
      forecast_complete: 47.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-08-07",
      baseline_complete: 84.6,
      actual_complete: 82.2,
      forecast_complete: 48.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-08-14",
      baseline_complete: 85.4,
      actual_complete: 82.2,
      forecast_complete: 49.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-08-21",
      baseline_complete: 86.0,
      actual_complete: 83.8,
      forecast_complete: 50.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-08-28",
      baseline_complete: 86.7,
      actual_complete: 85.6,
      forecast_complete: 51.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-09-04",
      baseline_complete: 87.3,
      actual_complete: 85.6,
      forecast_complete: 51.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-09-11",
      baseline_complete: 87.9,
      actual_complete: 85.7,
      forecast_complete: 52.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-09-18",
      baseline_complete: 88.5,
      actual_complete: 87.4,
      forecast_complete: 53.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-09-25",
      baseline_complete: 89.1,
      actual_complete: 87.4,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-10-02",
      baseline_complete: 89.6,
      actual_complete: 89.0,
      forecast_complete: 55.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-10-09",
      baseline_complete: 90.1,
      actual_complete: 89.0,
      forecast_complete: 56.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-10-16",
      baseline_complete: 90.6,
      actual_complete: 89.1,
      forecast_complete: 56.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-10-23",
      baseline_complete: 91.0,
      actual_complete: 89.8,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-10-30",
      baseline_complete: 91.5,
      actual_complete: 89.9,
      forecast_complete: 58.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-11-06",
      baseline_complete: 91.9,
      actual_complete: 91.2,
      forecast_complete: 59.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-11-13",
      baseline_complete: 92.3,
      actual_complete: 91.2,
      forecast_complete: 59.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-11-20",
      baseline_complete: 92.7,
      actual_complete: 91.2,
      forecast_complete: 60.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-11-27",
      baseline_complete: 93.1,
      actual_complete: 92.2,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-12-04",
      baseline_complete: 93.4,
      actual_complete: 92.2,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-12-11",
      baseline_complete: 93.8,
      actual_complete: 92.2,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-12-18",
      baseline_complete: 94.1,
      actual_complete: 94.4,
      forecast_complete: 63.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2025-12-25",
      baseline_complete: 94.4,
      actual_complete: 94.4,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-01-01",
      baseline_complete: 94.7,
      actual_complete: 94.4,
      forecast_complete: 65.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-01-08",
      baseline_complete: 94.9,
      actual_complete: 94.4,
      forecast_complete: 65.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-01-15",
      baseline_complete: 95.2,
      actual_complete: 95.1,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-01-22",
      baseline_complete: 95.4,
      actual_complete: 95.1,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-01-29",
      baseline_complete: 95.7,
      actual_complete: 95.1,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-02-05",
      baseline_complete: 95.9,
      actual_complete: 95.1,
      forecast_complete: 68.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-02-12",
      baseline_complete: 96.1,
      actual_complete: 95.8,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-02-19",
      baseline_complete: 96.3,
      actual_complete: 95.8,
      forecast_complete: 69.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-02-26",
      baseline_complete: 96.5,
      actual_complete: 96.0,
      forecast_complete: 70.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-03-05",
      baseline_complete: 96.7,
      actual_complete: 96.0,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-03-12",
      baseline_complete: 96.9,
      actual_complete: 96.0,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-03-19",
      baseline_complete: 97.0,
      actual_complete: 96.1,
      forecast_complete: 74.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-03-26",
      baseline_complete: 97.2,
      actual_complete: 97.8,
      forecast_complete: 75.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-04-02",
      baseline_complete: 97.3,
      actual_complete: 97.8,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-04-09",
      baseline_complete: 97.5,
      actual_complete: 97.8,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-04-16",
      baseline_complete: 97.6,
      actual_complete: 97.9,
      forecast_complete: 78.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-04-23",
      baseline_complete: 97.7,
      actual_complete: 97.9,
      forecast_complete: 79.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-04-30",
      baseline_complete: 97.9,
      actual_complete: 99.1,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-05-07",
      baseline_complete: 98.0,
      actual_complete: 99.1,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-05-14",
      baseline_complete: 98.1,
      actual_complete: 99.2,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-05-21",
      baseline_complete: 98.2,
      actual_complete: 99.2,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-05-28",
      baseline_complete: 98.3,
      actual_complete: 99.2,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-06-04",
      baseline_complete: 98.4,
      actual_complete: 99.2,
      forecast_complete: 84.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-06-11",
      baseline_complete: 98.5,
      actual_complete: 99.2,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-06-18",
      baseline_complete: 98.5,
      actual_complete: 99.2,
      forecast_complete: 86.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-06-25",
      baseline_complete: 98.6,
      actual_complete: 99.2,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-07-02",
      baseline_complete: 98.7,
      actual_complete: 99.2,
      forecast_complete: 87.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-07-09",
      baseline_complete: 98.8,
      actual_complete: 99.2,
      forecast_complete: 88.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-07-16",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 89.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-07-23",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 89.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-07-30",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-08-06",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-08-13",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-08-20",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-08-27",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-09-03",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-09-10",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-09-17",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-09-24",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-10-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-10-08",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-10-15",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-10-22",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-10-29",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-11-05",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-11-12",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-11-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-11-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-12-03",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-12-10",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-12-17",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-12-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2026-12-31",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2027-01-07",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2027-01-14",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "a0371066-c6ea-e289-d64c-bf33a05a98e7",
      reporting_date: "2027-01-15",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
  ],
  "29540c4f-0c89-6da9-e056-01eb385d1c8f": [
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-04-16",
      baseline_complete: 0.5,
      actual_complete: 0.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-04-23",
      baseline_complete: 0.5,
      actual_complete: 0.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-04-30",
      baseline_complete: 0.5,
      actual_complete: 0.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-05-07",
      baseline_complete: 0.5,
      actual_complete: 0.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-05-14",
      baseline_complete: 0.6,
      actual_complete: 0.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-05-21",
      baseline_complete: 0.6,
      actual_complete: 2.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-05-28",
      baseline_complete: 0.6,
      actual_complete: 2.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-06-04",
      baseline_complete: 0.6,
      actual_complete: 2.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-06-11",
      baseline_complete: 0.6,
      actual_complete: 2.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-06-18",
      baseline_complete: 0.7,
      actual_complete: 2.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-06-25",
      baseline_complete: 0.7,
      actual_complete: 2.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-07-02",
      baseline_complete: 0.7,
      actual_complete: 2.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-07-09",
      baseline_complete: 0.8,
      actual_complete: 2.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-07-16",
      baseline_complete: 0.8,
      actual_complete: 2.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-07-23",
      baseline_complete: 0.8,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-07-30",
      baseline_complete: 0.9,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-08-06",
      baseline_complete: 0.9,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-08-13",
      baseline_complete: 0.9,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-08-20",
      baseline_complete: 1.0,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-08-27",
      baseline_complete: 1.0,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-09-03",
      baseline_complete: 1.1,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-09-10",
      baseline_complete: 1.1,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-09-17",
      baseline_complete: 1.1,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-09-24",
      baseline_complete: 1.2,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-10-01",
      baseline_complete: 1.2,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-10-08",
      baseline_complete: 1.3,
      actual_complete: 3.1,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-10-15",
      baseline_complete: 1.3,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-10-22",
      baseline_complete: 1.4,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-10-29",
      baseline_complete: 1.4,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-11-05",
      baseline_complete: 1.5,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-11-12",
      baseline_complete: 1.6,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-11-19",
      baseline_complete: 1.6,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-11-26",
      baseline_complete: 1.7,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-12-03",
      baseline_complete: 1.8,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-12-10",
      baseline_complete: 1.8,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-12-17",
      baseline_complete: 1.9,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-12-24",
      baseline_complete: 2.0,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2024-12-31",
      baseline_complete: 2.1,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-01-07",
      baseline_complete: 2.2,
      actual_complete: 3.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-01-14",
      baseline_complete: 2.2,
      actual_complete: 4.9,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-01-21",
      baseline_complete: 2.3,
      actual_complete: 4.9,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-01-28",
      baseline_complete: 2.4,
      actual_complete: 4.9,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-02-04",
      baseline_complete: 2.5,
      actual_complete: 5.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-02-11",
      baseline_complete: 2.6,
      actual_complete: 5.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-02-18",
      baseline_complete: 2.7,
      actual_complete: 5.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-02-25",
      baseline_complete: 2.8,
      actual_complete: 5.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-03-04",
      baseline_complete: 3.0,
      actual_complete: 5.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-03-11",
      baseline_complete: 3.1,
      actual_complete: 5.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-03-18",
      baseline_complete: 3.2,
      actual_complete: 5.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-03-25",
      baseline_complete: 3.3,
      actual_complete: 5.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-04-01",
      baseline_complete: 3.5,
      actual_complete: 5.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-04-08",
      baseline_complete: 3.6,
      actual_complete: 5.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-04-15",
      baseline_complete: 3.7,
      actual_complete: 5.3,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-04-22",
      baseline_complete: 3.9,
      actual_complete: 6.7,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-04-29",
      baseline_complete: 4.0,
      actual_complete: 6.7,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-05-06",
      baseline_complete: 4.2,
      actual_complete: 7.2,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-05-13",
      baseline_complete: 4.4,
      actual_complete: 7.2,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-05-20",
      baseline_complete: 4.5,
      actual_complete: 7.2,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-05-27",
      baseline_complete: 4.7,
      actual_complete: 7.4,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-06-03",
      baseline_complete: 4.9,
      actual_complete: 7.4,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-06-10",
      baseline_complete: 5.1,
      actual_complete: 7.4,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-06-17",
      baseline_complete: 5.3,
      actual_complete: 7.4,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-06-24",
      baseline_complete: 5.5,
      actual_complete: 7.4,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-07-01",
      baseline_complete: 5.7,
      actual_complete: 8.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-07-08",
      baseline_complete: 5.9,
      actual_complete: 8.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-07-15",
      baseline_complete: 6.2,
      actual_complete: 8.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-07-22",
      baseline_complete: 6.4,
      actual_complete: 8.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-07-29",
      baseline_complete: 6.6,
      actual_complete: 10.2,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-08-05",
      baseline_complete: 6.9,
      actual_complete: 10.2,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-08-12",
      baseline_complete: 7.2,
      actual_complete: 10.2,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-08-19",
      baseline_complete: 7.4,
      actual_complete: 10.2,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-08-26",
      baseline_complete: 7.7,
      actual_complete: 10.2,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-09-02",
      baseline_complete: 8.0,
      actual_complete: 10.2,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-09-09",
      baseline_complete: 8.3,
      actual_complete: 10.2,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-09-16",
      baseline_complete: 8.6,
      actual_complete: 11.1,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-09-23",
      baseline_complete: 8.9,
      actual_complete: 12.5,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-09-30",
      baseline_complete: 9.3,
      actual_complete: 12.5,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-10-07",
      baseline_complete: 9.6,
      actual_complete: 12.5,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-10-14",
      baseline_complete: 10.0,
      actual_complete: 12.5,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-10-21",
      baseline_complete: 10.4,
      actual_complete: 12.5,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-10-28",
      baseline_complete: 10.7,
      actual_complete: 12.5,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-11-04",
      baseline_complete: 11.1,
      actual_complete: 12.5,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-11-11",
      baseline_complete: 11.5,
      actual_complete: 12.5,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-11-18",
      baseline_complete: 12.0,
      actual_complete: 14.8,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-11-25",
      baseline_complete: 12.4,
      actual_complete: 14.8,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-12-02",
      baseline_complete: 12.8,
      actual_complete: 14.8,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-12-09",
      baseline_complete: 13.3,
      actual_complete: 14.8,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-12-16",
      baseline_complete: 13.8,
      actual_complete: 15.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-12-23",
      baseline_complete: 14.3,
      actual_complete: 16.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2025-12-30",
      baseline_complete: 14.8,
      actual_complete: 16.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-01-06",
      baseline_complete: 15.3,
      actual_complete: 16.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-01-13",
      baseline_complete: 15.8,
      actual_complete: 16.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-01-20",
      baseline_complete: 16.4,
      actual_complete: 16.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-01-27",
      baseline_complete: 16.9,
      actual_complete: 16.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-02-03",
      baseline_complete: 17.5,
      actual_complete: 18.7,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-02-10",
      baseline_complete: 18.1,
      actual_complete: 18.7,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-02-17",
      baseline_complete: 18.7,
      actual_complete: 20.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-02-24",
      baseline_complete: 19.3,
      actual_complete: 20.4,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-03-03",
      baseline_complete: 19.9,
      actual_complete: 23.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-03-10",
      baseline_complete: 20.6,
      actual_complete: 23.0,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-03-17",
      baseline_complete: 21.3,
      actual_complete: 23.0,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-03-24",
      baseline_complete: 22.0,
      actual_complete: 23.0,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-03-31",
      baseline_complete: 22.7,
      actual_complete: 23.0,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-04-07",
      baseline_complete: 23.4,
      actual_complete: 24.8,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-04-14",
      baseline_complete: 24.1,
      actual_complete: 27.9,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-04-21",
      baseline_complete: 24.9,
      actual_complete: 27.9,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-04-28",
      baseline_complete: 25.6,
      actual_complete: 28.8,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-05-05",
      baseline_complete: 26.4,
      actual_complete: 28.8,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-05-12",
      baseline_complete: 27.2,
      actual_complete: 28.8,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-05-19",
      baseline_complete: 28.0,
      actual_complete: 28.8,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-05-26",
      baseline_complete: 28.8,
      actual_complete: 28.8,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-06-02",
      baseline_complete: 29.7,
      actual_complete: 28.8,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-06-09",
      baseline_complete: 30.5,
      actual_complete: 34.4,
      forecast_complete: 12.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-06-16",
      baseline_complete: 31.4,
      actual_complete: 34.4,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-06-23",
      baseline_complete: 32.3,
      actual_complete: 34.4,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-06-30",
      baseline_complete: 33.1,
      actual_complete: 36.3,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-07-07",
      baseline_complete: 34.0,
      actual_complete: 36.3,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-07-14",
      baseline_complete: 35.0,
      actual_complete: 37.7,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-07-21",
      baseline_complete: 35.9,
      actual_complete: 37.7,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-07-28",
      baseline_complete: 36.8,
      actual_complete: 37.7,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-08-04",
      baseline_complete: 37.8,
      actual_complete: 39.6,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-08-11",
      baseline_complete: 38.7,
      actual_complete: 40.3,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-08-18",
      baseline_complete: 39.7,
      actual_complete: 40.3,
      forecast_complete: 18.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-08-25",
      baseline_complete: 40.7,
      actual_complete: 43.2,
      forecast_complete: 19.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-09-01",
      baseline_complete: 41.6,
      actual_complete: 43.2,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-09-08",
      baseline_complete: 42.6,
      actual_complete: 43.2,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-09-15",
      baseline_complete: 43.6,
      actual_complete: 45.9,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-09-22",
      baseline_complete: 44.6,
      actual_complete: 46.5,
      forecast_complete: 21.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-09-29",
      baseline_complete: 45.6,
      actual_complete: 47.8,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-10-06",
      baseline_complete: 46.6,
      actual_complete: 49.6,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-10-13",
      baseline_complete: 47.6,
      actual_complete: 49.7,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-10-20",
      baseline_complete: 48.6,
      actual_complete: 49.7,
      forecast_complete: 24.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-10-27",
      baseline_complete: 49.6,
      actual_complete: 52.1,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-11-03",
      baseline_complete: 50.7,
      actual_complete: 53.9,
      forecast_complete: 26.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-11-10",
      baseline_complete: 51.7,
      actual_complete: 53.9,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-11-17",
      baseline_complete: 52.7,
      actual_complete: 54.0,
      forecast_complete: 27.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-11-24",
      baseline_complete: 53.7,
      actual_complete: 56.3,
      forecast_complete: 28.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-12-01",
      baseline_complete: 54.7,
      actual_complete: 56.3,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-12-08",
      baseline_complete: 55.7,
      actual_complete: 56.3,
      forecast_complete: 30.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-12-15",
      baseline_complete: 56.7,
      actual_complete: 57.1,
      forecast_complete: 31.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-12-22",
      baseline_complete: 57.7,
      actual_complete: 59.9,
      forecast_complete: 31.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2026-12-29",
      baseline_complete: 58.7,
      actual_complete: 61.2,
      forecast_complete: 32.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-01-05",
      baseline_complete: 59.6,
      actual_complete: 63.7,
      forecast_complete: 33.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-01-12",
      baseline_complete: 60.6,
      actual_complete: 63.7,
      forecast_complete: 34.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-01-19",
      baseline_complete: 61.6,
      actual_complete: 63.7,
      forecast_complete: 35.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-01-26",
      baseline_complete: 62.5,
      actual_complete: 63.7,
      forecast_complete: 35.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-02-02",
      baseline_complete: 63.5,
      actual_complete: 63.7,
      forecast_complete: 36.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-02-09",
      baseline_complete: 64.4,
      actual_complete: 63.9,
      forecast_complete: 37.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-02-16",
      baseline_complete: 65.3,
      actual_complete: 65.9,
      forecast_complete: 38.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-02-23",
      baseline_complete: 66.2,
      actual_complete: 70.1,
      forecast_complete: 39.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-03-02",
      baseline_complete: 67.1,
      actual_complete: 70.5,
      forecast_complete: 40.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-03-09",
      baseline_complete: 68.0,
      actual_complete: 70.5,
      forecast_complete: 40.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-03-16",
      baseline_complete: 68.9,
      actual_complete: 70.5,
      forecast_complete: 41.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-03-23",
      baseline_complete: 69.8,
      actual_complete: 72.0,
      forecast_complete: 42.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-03-30",
      baseline_complete: 70.6,
      actual_complete: 74.8,
      forecast_complete: 43.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-04-06",
      baseline_complete: 71.4,
      actual_complete: 74.8,
      forecast_complete: 44.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-04-13",
      baseline_complete: 72.3,
      actual_complete: 74.8,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-04-20",
      baseline_complete: 73.1,
      actual_complete: 74.9,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-04-27",
      baseline_complete: 73.8,
      actual_complete: 74.9,
      forecast_complete: 46.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-05-04",
      baseline_complete: 74.6,
      actual_complete: 77.0,
      forecast_complete: 47.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-05-11",
      baseline_complete: 75.4,
      actual_complete: 77.7,
      forecast_complete: 48.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-05-18",
      baseline_complete: 76.1,
      actual_complete: 78.4,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-05-25",
      baseline_complete: 76.8,
      actual_complete: 78.4,
      forecast_complete: 50.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-06-01",
      baseline_complete: 77.6,
      actual_complete: 78.4,
      forecast_complete: 50.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-06-08",
      baseline_complete: 78.3,
      actual_complete: 78.4,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-06-15",
      baseline_complete: 78.9,
      actual_complete: 79.0,
      forecast_complete: 52.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-06-22",
      baseline_complete: 79.6,
      actual_complete: 82.7,
      forecast_complete: 53.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-06-29",
      baseline_complete: 80.2,
      actual_complete: 82.7,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-07-06",
      baseline_complete: 80.9,
      actual_complete: 82.7,
      forecast_complete: 54.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-07-13",
      baseline_complete: 81.5,
      actual_complete: 83.7,
      forecast_complete: 55.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-07-20",
      baseline_complete: 82.1,
      actual_complete: 83.7,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-07-27",
      baseline_complete: 82.7,
      actual_complete: 83.7,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-08-03",
      baseline_complete: 83.3,
      actual_complete: 84.9,
      forecast_complete: 57.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-08-10",
      baseline_complete: 83.8,
      actual_complete: 84.9,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-08-17",
      baseline_complete: 84.4,
      actual_complete: 88.7,
      forecast_complete: 59.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-08-24",
      baseline_complete: 84.9,
      actual_complete: 89.6,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-08-31",
      baseline_complete: 85.4,
      actual_complete: 89.6,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-09-07",
      baseline_complete: 85.9,
      actual_complete: 89.6,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-09-14",
      baseline_complete: 86.4,
      actual_complete: 90.5,
      forecast_complete: 62.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-09-21",
      baseline_complete: 86.8,
      actual_complete: 90.5,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-09-28",
      baseline_complete: 87.3,
      actual_complete: 90.5,
      forecast_complete: 63.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-10-05",
      baseline_complete: 87.7,
      actual_complete: 90.5,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-10-12",
      baseline_complete: 88.2,
      actual_complete: 90.5,
      forecast_complete: 66.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-10-19",
      baseline_complete: 88.6,
      actual_complete: 91.5,
      forecast_complete: 67.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-10-26",
      baseline_complete: 89.0,
      actual_complete: 93.4,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-11-02",
      baseline_complete: 89.4,
      actual_complete: 93.4,
      forecast_complete: 69.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-11-09",
      baseline_complete: 89.8,
      actual_complete: 93.4,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-11-16",
      baseline_complete: 90.1,
      actual_complete: 93.4,
      forecast_complete: 71.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-11-23",
      baseline_complete: 90.5,
      actual_complete: 93.4,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-11-30",
      baseline_complete: 90.8,
      actual_complete: 93.4,
      forecast_complete: 73.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-12-07",
      baseline_complete: 91.2,
      actual_complete: 93.5,
      forecast_complete: 74.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-12-14",
      baseline_complete: 91.5,
      actual_complete: 93.5,
      forecast_complete: 75.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-12-21",
      baseline_complete: 91.8,
      actual_complete: 93.5,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2027-12-28",
      baseline_complete: 92.1,
      actual_complete: 93.5,
      forecast_complete: 77.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-01-04",
      baseline_complete: 92.4,
      actual_complete: 95.3,
      forecast_complete: 78.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-01-11",
      baseline_complete: 92.7,
      actual_complete: 95.6,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-01-18",
      baseline_complete: 92.9,
      actual_complete: 95.6,
      forecast_complete: 80.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-01-25",
      baseline_complete: 93.2,
      actual_complete: 96.8,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-02-01",
      baseline_complete: 93.4,
      actual_complete: 96.8,
      forecast_complete: 82.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-02-08",
      baseline_complete: 93.7,
      actual_complete: 96.8,
      forecast_complete: 82.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-02-15",
      baseline_complete: 93.9,
      actual_complete: 98.2,
      forecast_complete: 83.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-02-22",
      baseline_complete: 94.1,
      actual_complete: 98.2,
      forecast_complete: 84.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-02-29",
      baseline_complete: 94.4,
      actual_complete: 98.2,
      forecast_complete: 85.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-03-07",
      baseline_complete: 94.6,
      actual_complete: 98.8,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-03-14",
      baseline_complete: 94.8,
      actual_complete: 98.8,
      forecast_complete: 86.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-03-21",
      baseline_complete: 95.0,
      actual_complete: 98.8,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-03-28",
      baseline_complete: 95.2,
      actual_complete: 98.8,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-04-04",
      baseline_complete: 95.3,
      actual_complete: 98.8,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-04-11",
      baseline_complete: 95.5,
      actual_complete: 98.8,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-04-18",
      baseline_complete: 95.7,
      actual_complete: 98.8,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-04-25",
      baseline_complete: 95.9,
      actual_complete: 98.8,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-05-02",
      baseline_complete: 96.0,
      actual_complete: 98.8,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-05-09",
      baseline_complete: 96.2,
      actual_complete: 100.0,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-05-16",
      baseline_complete: 96.3,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-05-23",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-05-30",
      baseline_complete: 96.6,
      actual_complete: 100.0,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-06-06",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-06-13",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-06-20",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-06-27",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-07-04",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-07-11",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-07-18",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-07-25",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-08-01",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-08-08",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-08-15",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-08-22",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-08-29",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-09-05",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-09-12",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-09-19",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-09-26",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-10-03",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-10-10",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-10-17",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-10-24",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-10-31",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-11-07",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-11-14",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "29540c4f-0c89-6da9-e056-01eb385d1c8f",
      reporting_date: "2028-11-16",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
  ],
  "278ba0df-615b-ed80-b6fd-de88571ba826": [
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-04-22",
      baseline_complete: 0.3,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-04-29",
      baseline_complete: 0.3,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-05-06",
      baseline_complete: 0.3,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-05-13",
      baseline_complete: 0.3,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-05-20",
      baseline_complete: 0.4,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-05-27",
      baseline_complete: 0.4,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-06-03",
      baseline_complete: 0.4,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-06-10",
      baseline_complete: 0.4,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-06-17",
      baseline_complete: 0.4,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-06-24",
      baseline_complete: 0.5,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-07-01",
      baseline_complete: 0.5,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-07-08",
      baseline_complete: 0.5,
      actual_complete: 2.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-07-15",
      baseline_complete: 0.5,
      actual_complete: 3.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-07-22",
      baseline_complete: 0.6,
      actual_complete: 3.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-07-29",
      baseline_complete: 0.6,
      actual_complete: 3.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-08-05",
      baseline_complete: 0.6,
      actual_complete: 3.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-08-12",
      baseline_complete: 0.7,
      actual_complete: 3.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-08-19",
      baseline_complete: 0.7,
      actual_complete: 3.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-08-26",
      baseline_complete: 0.7,
      actual_complete: 3.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-09-02",
      baseline_complete: 0.8,
      actual_complete: 3.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-09-09",
      baseline_complete: 0.8,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-09-16",
      baseline_complete: 0.9,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-09-23",
      baseline_complete: 0.9,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-09-30",
      baseline_complete: 0.9,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-10-07",
      baseline_complete: 1.0,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-10-14",
      baseline_complete: 1.0,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-10-21",
      baseline_complete: 1.1,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-10-28",
      baseline_complete: 1.1,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-11-04",
      baseline_complete: 1.2,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-11-11",
      baseline_complete: 1.3,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-11-18",
      baseline_complete: 1.3,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-11-25",
      baseline_complete: 1.4,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-12-02",
      baseline_complete: 1.5,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-12-09",
      baseline_complete: 1.5,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-12-16",
      baseline_complete: 1.6,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-12-23",
      baseline_complete: 1.7,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2023-12-30",
      baseline_complete: 1.8,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-01-06",
      baseline_complete: 1.9,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-01-13",
      baseline_complete: 2.0,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-01-20",
      baseline_complete: 2.1,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-01-27",
      baseline_complete: 2.2,
      actual_complete: 4.8,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-02-03",
      baseline_complete: 2.3,
      actual_complete: 4.8,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-02-10",
      baseline_complete: 2.4,
      actual_complete: 4.8,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-02-17",
      baseline_complete: 2.5,
      actual_complete: 4.8,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-02-24",
      baseline_complete: 2.6,
      actual_complete: 4.8,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-03-02",
      baseline_complete: 2.8,
      actual_complete: 4.8,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-03-09",
      baseline_complete: 2.9,
      actual_complete: 4.8,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-03-16",
      baseline_complete: 3.1,
      actual_complete: 4.9,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-03-23",
      baseline_complete: 3.2,
      actual_complete: 4.9,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-03-30",
      baseline_complete: 3.4,
      actual_complete: 4.9,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-04-06",
      baseline_complete: 3.5,
      actual_complete: 4.9,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-04-13",
      baseline_complete: 3.7,
      actual_complete: 4.9,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-04-20",
      baseline_complete: 3.9,
      actual_complete: 4.9,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-04-27",
      baseline_complete: 4.1,
      actual_complete: 4.9,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-05-04",
      baseline_complete: 4.3,
      actual_complete: 4.9,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-05-11",
      baseline_complete: 4.5,
      actual_complete: 4.9,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-05-18",
      baseline_complete: 4.7,
      actual_complete: 5.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-05-25",
      baseline_complete: 5.0,
      actual_complete: 5.4,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-06-01",
      baseline_complete: 5.2,
      actual_complete: 5.8,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-06-08",
      baseline_complete: 5.4,
      actual_complete: 5.8,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-06-15",
      baseline_complete: 5.7,
      actual_complete: 5.8,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-06-22",
      baseline_complete: 6.0,
      actual_complete: 5.8,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-06-29",
      baseline_complete: 6.3,
      actual_complete: 6.3,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-07-06",
      baseline_complete: 6.6,
      actual_complete: 6.3,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-07-13",
      baseline_complete: 6.9,
      actual_complete: 7.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-07-20",
      baseline_complete: 7.2,
      actual_complete: 7.2,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-07-27",
      baseline_complete: 7.6,
      actual_complete: 9.5,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-08-03",
      baseline_complete: 7.9,
      actual_complete: 9.5,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-08-10",
      baseline_complete: 8.3,
      actual_complete: 9.5,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-08-17",
      baseline_complete: 8.7,
      actual_complete: 9.5,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-08-24",
      baseline_complete: 9.1,
      actual_complete: 9.5,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-08-31",
      baseline_complete: 9.5,
      actual_complete: 9.5,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-09-07",
      baseline_complete: 9.9,
      actual_complete: 12.5,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-09-14",
      baseline_complete: 10.4,
      actual_complete: 12.5,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-09-21",
      baseline_complete: 10.9,
      actual_complete: 12.5,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-09-28",
      baseline_complete: 11.4,
      actual_complete: 12.5,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-10-05",
      baseline_complete: 11.9,
      actual_complete: 12.5,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-10-12",
      baseline_complete: 12.4,
      actual_complete: 12.5,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-10-19",
      baseline_complete: 13.0,
      actual_complete: 14.3,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-10-26",
      baseline_complete: 13.6,
      actual_complete: 14.3,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-11-02",
      baseline_complete: 14.1,
      actual_complete: 14.8,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-11-09",
      baseline_complete: 14.8,
      actual_complete: 16.4,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-11-16",
      baseline_complete: 15.4,
      actual_complete: 16.4,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-11-23",
      baseline_complete: 16.1,
      actual_complete: 16.4,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-11-30",
      baseline_complete: 16.8,
      actual_complete: 16.4,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-12-07",
      baseline_complete: 17.5,
      actual_complete: 16.4,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-12-14",
      baseline_complete: 18.2,
      actual_complete: 16.9,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-12-21",
      baseline_complete: 19.0,
      actual_complete: 21.1,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2024-12-28",
      baseline_complete: 19.7,
      actual_complete: 21.1,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-01-04",
      baseline_complete: 20.5,
      actual_complete: 23.1,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-01-11",
      baseline_complete: 21.4,
      actual_complete: 23.1,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-01-18",
      baseline_complete: 22.2,
      actual_complete: 23.1,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-01-25",
      baseline_complete: 23.1,
      actual_complete: 24.7,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-02-01",
      baseline_complete: 24.0,
      actual_complete: 24.7,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-02-08",
      baseline_complete: 24.9,
      actual_complete: 24.7,
      forecast_complete: 12.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-02-15",
      baseline_complete: 25.9,
      actual_complete: 24.7,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-02-22",
      baseline_complete: 26.8,
      actual_complete: 27.5,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-03-01",
      baseline_complete: 27.8,
      actual_complete: 31.0,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-03-08",
      baseline_complete: 28.9,
      actual_complete: 31.4,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-03-15",
      baseline_complete: 29.9,
      actual_complete: 32.8,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-03-22",
      baseline_complete: 31.0,
      actual_complete: 32.8,
      forecast_complete: 16.1,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-03-29",
      baseline_complete: 32.0,
      actual_complete: 35.0,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-04-05",
      baseline_complete: 33.1,
      actual_complete: 36.5,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-04-12",
      baseline_complete: 34.2,
      actual_complete: 36.5,
      forecast_complete: 18.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-04-19",
      baseline_complete: 35.4,
      actual_complete: 36.5,
      forecast_complete: 18.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-04-26",
      baseline_complete: 36.5,
      actual_complete: 36.5,
      forecast_complete: 19.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-05-03",
      baseline_complete: 37.7,
      actual_complete: 37.1,
      forecast_complete: 20.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-05-10",
      baseline_complete: 38.9,
      actual_complete: 37.1,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-05-17",
      baseline_complete: 40.1,
      actual_complete: 39.4,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-05-24",
      baseline_complete: 41.3,
      actual_complete: 41.8,
      forecast_complete: 23.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-05-31",
      baseline_complete: 42.5,
      actual_complete: 42.1,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-06-07",
      baseline_complete: 43.7,
      actual_complete: 44.9,
      forecast_complete: 24.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-06-14",
      baseline_complete: 45.0,
      actual_complete: 44.9,
      forecast_complete: 25.6,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-06-21",
      baseline_complete: 46.2,
      actual_complete: 48.4,
      forecast_complete: 26.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-06-28",
      baseline_complete: 47.5,
      actual_complete: 48.4,
      forecast_complete: 27.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-07-05",
      baseline_complete: 48.7,
      actual_complete: 48.4,
      forecast_complete: 28.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-07-12",
      baseline_complete: 50.0,
      actual_complete: 52.0,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-07-19",
      baseline_complete: 51.2,
      actual_complete: 52.9,
      forecast_complete: 30.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-07-26",
      baseline_complete: 52.5,
      actual_complete: 55.0,
      forecast_complete: 31.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-08-02",
      baseline_complete: 53.7,
      actual_complete: 58.2,
      forecast_complete: 32.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-08-09",
      baseline_complete: 54.9,
      actual_complete: 58.2,
      forecast_complete: 33.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-08-16",
      baseline_complete: 56.2,
      actual_complete: 58.2,
      forecast_complete: 34.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-08-23",
      baseline_complete: 57.4,
      actual_complete: 59.5,
      forecast_complete: 35.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-08-30",
      baseline_complete: 58.6,
      actual_complete: 61.2,
      forecast_complete: 36.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-09-06",
      baseline_complete: 59.8,
      actual_complete: 61.2,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-09-13",
      baseline_complete: 61.0,
      actual_complete: 61.2,
      forecast_complete: 38.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-09-20",
      baseline_complete: 62.2,
      actual_complete: 65.2,
      forecast_complete: 39.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-09-27",
      baseline_complete: 63.4,
      actual_complete: 65.2,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-10-04",
      baseline_complete: 64.5,
      actual_complete: 65.2,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-10-11",
      baseline_complete: 65.7,
      actual_complete: 65.2,
      forecast_complete: 42.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-10-18",
      baseline_complete: 66.8,
      actual_complete: 66.6,
      forecast_complete: 43.6,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-10-25",
      baseline_complete: 67.9,
      actual_complete: 70.9,
      forecast_complete: 44.6,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-11-01",
      baseline_complete: 69.0,
      actual_complete: 72.4,
      forecast_complete: 45.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-11-08",
      baseline_complete: 70.0,
      actual_complete: 72.4,
      forecast_complete: 46.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-11-15",
      baseline_complete: 71.1,
      actual_complete: 73.8,
      forecast_complete: 47.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-11-22",
      baseline_complete: 72.1,
      actual_complete: 73.8,
      forecast_complete: 48.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-11-29",
      baseline_complete: 73.1,
      actual_complete: 76.2,
      forecast_complete: 49.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-12-06",
      baseline_complete: 74.1,
      actual_complete: 76.2,
      forecast_complete: 50.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-12-13",
      baseline_complete: 75.0,
      actual_complete: 76.2,
      forecast_complete: 51.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-12-20",
      baseline_complete: 75.9,
      actual_complete: 77.8,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2025-12-27",
      baseline_complete: 76.8,
      actual_complete: 78.2,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-01-03",
      baseline_complete: 77.7,
      actual_complete: 80.5,
      forecast_complete: 54.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-01-10",
      baseline_complete: 78.6,
      actual_complete: 80.5,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-01-17",
      baseline_complete: 79.4,
      actual_complete: 80.5,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-01-24",
      baseline_complete: 80.2,
      actual_complete: 80.5,
      forecast_complete: 57.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-01-31",
      baseline_complete: 81.0,
      actual_complete: 85.8,
      forecast_complete: 58.6,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-02-07",
      baseline_complete: 81.7,
      actual_complete: 85.8,
      forecast_complete: 59.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-02-14",
      baseline_complete: 82.5,
      actual_complete: 85.8,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-02-21",
      baseline_complete: 83.2,
      actual_complete: 85.8,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-02-28",
      baseline_complete: 83.9,
      actual_complete: 85.8,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-03-07",
      baseline_complete: 84.5,
      actual_complete: 87.2,
      forecast_complete: 63.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-03-14",
      baseline_complete: 85.2,
      actual_complete: 87.2,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-03-21",
      baseline_complete: 85.8,
      actual_complete: 88.0,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-03-28",
      baseline_complete: 86.4,
      actual_complete: 89.5,
      forecast_complete: 67.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-04-04",
      baseline_complete: 87.0,
      actual_complete: 91.0,
      forecast_complete: 68.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-04-11",
      baseline_complete: 87.5,
      actual_complete: 91.0,
      forecast_complete: 70.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-04-18",
      baseline_complete: 88.1,
      actual_complete: 91.0,
      forecast_complete: 71.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-04-25",
      baseline_complete: 88.6,
      actual_complete: 91.5,
      forecast_complete: 73.1,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-05-02",
      baseline_complete: 89.1,
      actual_complete: 91.6,
      forecast_complete: 74.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-05-09",
      baseline_complete: 89.6,
      actual_complete: 92.1,
      forecast_complete: 75.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-05-16",
      baseline_complete: 90.0,
      actual_complete: 94.3,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-05-23",
      baseline_complete: 90.5,
      actual_complete: 94.3,
      forecast_complete: 78.1,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-05-30",
      baseline_complete: 90.9,
      actual_complete: 94.3,
      forecast_complete: 79.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-06-06",
      baseline_complete: 91.3,
      actual_complete: 94.3,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-06-13",
      baseline_complete: 91.7,
      actual_complete: 94.3,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-06-20",
      baseline_complete: 92.1,
      actual_complete: 94.3,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-06-27",
      baseline_complete: 92.4,
      actual_complete: 94.3,
      forecast_complete: 83.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-07-04",
      baseline_complete: 92.8,
      actual_complete: 94.3,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-07-11",
      baseline_complete: 93.1,
      actual_complete: 96.6,
      forecast_complete: 85.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-07-18",
      baseline_complete: 93.4,
      actual_complete: 97.3,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-07-25",
      baseline_complete: 93.7,
      actual_complete: 97.3,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-08-01",
      baseline_complete: 94.0,
      actual_complete: 97.3,
      forecast_complete: 87.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-08-08",
      baseline_complete: 94.3,
      actual_complete: 97.3,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-08-15",
      baseline_complete: 94.5,
      actual_complete: 99.7,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-08-22",
      baseline_complete: 94.8,
      actual_complete: 99.7,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-08-29",
      baseline_complete: 95.0,
      actual_complete: 99.7,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-09-05",
      baseline_complete: 95.3,
      actual_complete: 99.7,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-09-12",
      baseline_complete: 95.5,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-09-19",
      baseline_complete: 95.7,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-09-26",
      baseline_complete: 95.9,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-10-03",
      baseline_complete: 96.1,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-10-10",
      baseline_complete: 96.3,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-10-17",
      baseline_complete: 96.4,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-10-24",
      baseline_complete: 96.6,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-10-31",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-11-07",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-11-14",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-11-21",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-11-28",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-12-05",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-12-12",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-12-19",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2026-12-26",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2027-01-02",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2027-01-09",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2027-01-16",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2027-01-23",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2027-01-30",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2027-02-06",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2027-02-13",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2027-02-20",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "278ba0df-615b-ed80-b6fd-de88571ba826",
      reporting_date: "2027-02-22",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
  ],
  "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d": [
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-04-01",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-04-08",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-04-15",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-04-22",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-04-29",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-05-06",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-05-13",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-05-20",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-05-27",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-06-03",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-06-10",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-06-17",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-06-24",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-07-01",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-07-08",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-07-15",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-07-22",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-07-29",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-08-05",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-08-12",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-08-19",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-08-26",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-09-02",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-09-09",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-09-16",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-09-23",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-09-30",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-10-07",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-10-14",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-10-21",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-10-28",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-11-04",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-11-11",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-11-18",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-11-25",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-12-02",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-12-09",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-12-16",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-12-23",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2024-12-30",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-01-06",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-01-13",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-01-20",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-01-27",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-02-03",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-02-10",
      baseline_complete: 3.8,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-02-17",
      baseline_complete: 4.0,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-02-24",
      baseline_complete: 4.2,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-03-03",
      baseline_complete: 4.4,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-03-10",
      baseline_complete: 4.6,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-03-17",
      baseline_complete: 4.8,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-03-24",
      baseline_complete: 5.0,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-03-31",
      baseline_complete: 5.2,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-04-07",
      baseline_complete: 5.5,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-04-14",
      baseline_complete: 5.7,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-04-21",
      baseline_complete: 6.0,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-04-28",
      baseline_complete: 6.2,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-05-05",
      baseline_complete: 6.5,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-05-12",
      baseline_complete: 6.8,
      actual_complete: 0.7,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-05-19",
      baseline_complete: 7.1,
      actual_complete: 0.7,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-05-26",
      baseline_complete: 7.4,
      actual_complete: 0.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-06-02",
      baseline_complete: 7.8,
      actual_complete: 0.7,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-06-09",
      baseline_complete: 8.1,
      actual_complete: 1.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-06-16",
      baseline_complete: 8.5,
      actual_complete: 3.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-06-23",
      baseline_complete: 8.9,
      actual_complete: 3.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-06-30",
      baseline_complete: 9.2,
      actual_complete: 3.2,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-07-07",
      baseline_complete: 9.7,
      actual_complete: 3.2,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-07-14",
      baseline_complete: 10.1,
      actual_complete: 3.2,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-07-21",
      baseline_complete: 10.5,
      actual_complete: 5.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-07-28",
      baseline_complete: 11.0,
      actual_complete: 5.2,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-08-04",
      baseline_complete: 11.4,
      actual_complete: 5.2,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-08-11",
      baseline_complete: 11.9,
      actual_complete: 5.2,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-08-18",
      baseline_complete: 12.4,
      actual_complete: 7.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-08-25",
      baseline_complete: 12.9,
      actual_complete: 7.8,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-09-01",
      baseline_complete: 13.5,
      actual_complete: 7.8,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-09-08",
      baseline_complete: 14.0,
      actual_complete: 8.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-09-15",
      baseline_complete: 14.6,
      actual_complete: 8.7,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-09-22",
      baseline_complete: 15.2,
      actual_complete: 9.6,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-09-29",
      baseline_complete: 15.8,
      actual_complete: 10.3,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-10-06",
      baseline_complete: 16.5,
      actual_complete: 10.5,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-10-13",
      baseline_complete: 17.1,
      actual_complete: 10.7,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-10-20",
      baseline_complete: 17.8,
      actual_complete: 11.5,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-10-27",
      baseline_complete: 18.5,
      actual_complete: 12.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-11-03",
      baseline_complete: 19.3,
      actual_complete: 14.0,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-11-10",
      baseline_complete: 20.0,
      actual_complete: 14.0,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-11-17",
      baseline_complete: 20.8,
      actual_complete: 14.4,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-11-24",
      baseline_complete: 21.6,
      actual_complete: 14.9,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-12-01",
      baseline_complete: 22.4,
      actual_complete: 16.3,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-12-08",
      baseline_complete: 23.2,
      actual_complete: 18.2,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-12-15",
      baseline_complete: 24.1,
      actual_complete: 18.6,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-12-22",
      baseline_complete: 24.9,
      actual_complete: 19.7,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2025-12-29",
      baseline_complete: 25.8,
      actual_complete: 20.1,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-01-05",
      baseline_complete: 26.7,
      actual_complete: 20.9,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-01-12",
      baseline_complete: 27.7,
      actual_complete: 23.2,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-01-19",
      baseline_complete: 28.6,
      actual_complete: 23.2,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-01-26",
      baseline_complete: 29.6,
      actual_complete: 24.5,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-02-02",
      baseline_complete: 30.6,
      actual_complete: 25.8,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-02-09",
      baseline_complete: 31.6,
      actual_complete: 26.1,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-02-16",
      baseline_complete: 32.6,
      actual_complete: 27.6,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-02-23",
      baseline_complete: 33.7,
      actual_complete: 28.7,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-03-02",
      baseline_complete: 34.8,
      actual_complete: 28.8,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-03-09",
      baseline_complete: 35.8,
      actual_complete: 31.9,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-03-16",
      baseline_complete: 36.9,
      actual_complete: 32.1,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-03-23",
      baseline_complete: 38.0,
      actual_complete: 32.4,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-03-30",
      baseline_complete: 39.2,
      actual_complete: 34.9,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-04-06",
      baseline_complete: 40.3,
      actual_complete: 36.9,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-04-13",
      baseline_complete: 41.4,
      actual_complete: 37.5,
      forecast_complete: 19.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-04-20",
      baseline_complete: 42.6,
      actual_complete: 37.5,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-04-27",
      baseline_complete: 43.7,
      actual_complete: 38.6,
      forecast_complete: 20.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-05-04",
      baseline_complete: 44.9,
      actual_complete: 41.0,
      forecast_complete: 21.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-05-11",
      baseline_complete: 46.1,
      actual_complete: 43.2,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-05-18",
      baseline_complete: 47.2,
      actual_complete: 43.2,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-05-25",
      baseline_complete: 48.4,
      actual_complete: 43.3,
      forecast_complete: 24.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-06-01",
      baseline_complete: 49.6,
      actual_complete: 45.8,
      forecast_complete: 24.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-06-08",
      baseline_complete: 50.8,
      actual_complete: 45.9,
      forecast_complete: 25.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-06-15",
      baseline_complete: 52.0,
      actual_complete: 48.3,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-06-22",
      baseline_complete: 53.1,
      actual_complete: 49.6,
      forecast_complete: 27.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-06-29",
      baseline_complete: 54.3,
      actual_complete: 50.6,
      forecast_complete: 28.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-07-06",
      baseline_complete: 55.5,
      actual_complete: 50.7,
      forecast_complete: 29.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-07-13",
      baseline_complete: 56.7,
      actual_complete: 53.7,
      forecast_complete: 30.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-07-20",
      baseline_complete: 57.8,
      actual_complete: 54.9,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-07-27",
      baseline_complete: 59.0,
      actual_complete: 54.9,
      forecast_complete: 31.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-08-03",
      baseline_complete: 60.1,
      actual_complete: 56.6,
      forecast_complete: 32.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-08-10",
      baseline_complete: 61.2,
      actual_complete: 57.2,
      forecast_complete: 33.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-08-17",
      baseline_complete: 62.3,
      actual_complete: 58.8,
      forecast_complete: 34.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-08-24",
      baseline_complete: 63.4,
      actual_complete: 61.5,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-08-31",
      baseline_complete: 64.5,
      actual_complete: 61.9,
      forecast_complete: 36.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-09-07",
      baseline_complete: 65.6,
      actual_complete: 63.5,
      forecast_complete: 37.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-09-14",
      baseline_complete: 66.7,
      actual_complete: 63.5,
      forecast_complete: 38.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-09-21",
      baseline_complete: 67.7,
      actual_complete: 65.3,
      forecast_complete: 39.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-09-28",
      baseline_complete: 68.7,
      actual_complete: 65.3,
      forecast_complete: 39.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-10-05",
      baseline_complete: 69.7,
      actual_complete: 67.2,
      forecast_complete: 40.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-10-12",
      baseline_complete: 70.7,
      actual_complete: 67.4,
      forecast_complete: 41.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-10-19",
      baseline_complete: 71.7,
      actual_complete: 70.6,
      forecast_complete: 42.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-10-26",
      baseline_complete: 72.6,
      actual_complete: 70.6,
      forecast_complete: 43.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-11-02",
      baseline_complete: 73.6,
      actual_complete: 71.5,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-11-09",
      baseline_complete: 74.5,
      actual_complete: 71.5,
      forecast_complete: 45.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-11-16",
      baseline_complete: 75.4,
      actual_complete: 71.5,
      forecast_complete: 46.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-11-23",
      baseline_complete: 76.2,
      actual_complete: 73.0,
      forecast_complete: 47.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-11-30",
      baseline_complete: 77.1,
      actual_complete: 76.2,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-12-07",
      baseline_complete: 77.9,
      actual_complete: 76.2,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-12-14",
      baseline_complete: 78.7,
      actual_complete: 76.7,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-12-21",
      baseline_complete: 79.5,
      actual_complete: 77.2,
      forecast_complete: 50.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2026-12-28",
      baseline_complete: 80.2,
      actual_complete: 77.7,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-01-04",
      baseline_complete: 81.0,
      actual_complete: 78.1,
      forecast_complete: 52.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-01-11",
      baseline_complete: 81.7,
      actual_complete: 80.4,
      forecast_complete: 53.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-01-18",
      baseline_complete: 82.4,
      actual_complete: 80.4,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-01-25",
      baseline_complete: 83.1,
      actual_complete: 82.0,
      forecast_complete: 54.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-02-01",
      baseline_complete: 83.7,
      actual_complete: 82.0,
      forecast_complete: 55.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-02-08",
      baseline_complete: 84.4,
      actual_complete: 83.4,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-02-15",
      baseline_complete: 85.0,
      actual_complete: 84.2,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-02-22",
      baseline_complete: 85.6,
      actual_complete: 84.3,
      forecast_complete: 57.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-03-01",
      baseline_complete: 86.1,
      actual_complete: 84.3,
      forecast_complete: 58.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-03-08",
      baseline_complete: 86.7,
      actual_complete: 84.3,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-03-15",
      baseline_complete: 87.2,
      actual_complete: 86.3,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-03-22",
      baseline_complete: 87.8,
      actual_complete: 86.3,
      forecast_complete: 61.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-03-29",
      baseline_complete: 88.2,
      actual_complete: 87.0,
      forecast_complete: 61.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-04-05",
      baseline_complete: 88.7,
      actual_complete: 87.0,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-04-12",
      baseline_complete: 89.2,
      actual_complete: 88.1,
      forecast_complete: 63.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-04-19",
      baseline_complete: 89.6,
      actual_complete: 89.7,
      forecast_complete: 63.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-04-26",
      baseline_complete: 90.1,
      actual_complete: 90.3,
      forecast_complete: 64.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-05-03",
      baseline_complete: 90.5,
      actual_complete: 90.3,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-05-10",
      baseline_complete: 90.9,
      actual_complete: 90.3,
      forecast_complete: 66.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-05-17",
      baseline_complete: 91.3,
      actual_complete: 90.3,
      forecast_complete: 66.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-05-24",
      baseline_complete: 91.6,
      actual_complete: 90.3,
      forecast_complete: 67.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-05-31",
      baseline_complete: 92.0,
      actual_complete: 92.2,
      forecast_complete: 68.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-06-07",
      baseline_complete: 92.3,
      actual_complete: 92.3,
      forecast_complete: 68.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-06-14",
      baseline_complete: 92.7,
      actual_complete: 92.6,
      forecast_complete: 69.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-06-21",
      baseline_complete: 93.0,
      actual_complete: 92.6,
      forecast_complete: 70.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-06-28",
      baseline_complete: 93.3,
      actual_complete: 92.8,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-07-05",
      baseline_complete: 93.6,
      actual_complete: 92.8,
      forecast_complete: 73.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-07-12",
      baseline_complete: 93.8,
      actual_complete: 93.1,
      forecast_complete: 74.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-07-19",
      baseline_complete: 94.1,
      actual_complete: 93.3,
      forecast_complete: 75.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-07-26",
      baseline_complete: 94.4,
      actual_complete: 93.9,
      forecast_complete: 76.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-08-02",
      baseline_complete: 94.6,
      actual_complete: 93.9,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-08-09",
      baseline_complete: 94.9,
      actual_complete: 95.3,
      forecast_complete: 78.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-08-16",
      baseline_complete: 95.1,
      actual_complete: 95.3,
      forecast_complete: 79.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-08-23",
      baseline_complete: 95.3,
      actual_complete: 95.3,
      forecast_complete: 80.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-08-30",
      baseline_complete: 95.5,
      actual_complete: 96.3,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-09-06",
      baseline_complete: 95.7,
      actual_complete: 96.3,
      forecast_complete: 82.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-09-13",
      baseline_complete: 95.9,
      actual_complete: 96.3,
      forecast_complete: 82.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-09-20",
      baseline_complete: 96.1,
      actual_complete: 96.3,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-09-27",
      baseline_complete: 96.2,
      actual_complete: 96.8,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-10-04",
      baseline_complete: 96.4,
      actual_complete: 96.8,
      forecast_complete: 85.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-10-11",
      baseline_complete: 96.6,
      actual_complete: 98.5,
      forecast_complete: 86.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-10-18",
      baseline_complete: 96.7,
      actual_complete: 98.5,
      forecast_complete: 86.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-10-25",
      baseline_complete: 96.9,
      actual_complete: 98.7,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-11-01",
      baseline_complete: 97.0,
      actual_complete: 98.7,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-11-08",
      baseline_complete: 97.1,
      actual_complete: 98.7,
      forecast_complete: 88.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-11-15",
      baseline_complete: 97.3,
      actual_complete: 98.7,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-11-22",
      baseline_complete: 97.4,
      actual_complete: 99.8,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-11-29",
      baseline_complete: 97.5,
      actual_complete: 99.8,
      forecast_complete: 90.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-12-06",
      baseline_complete: 97.6,
      actual_complete: 99.8,
      forecast_complete: 91.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-12-13",
      baseline_complete: 97.7,
      actual_complete: 99.8,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-12-20",
      baseline_complete: 97.8,
      actual_complete: 99.8,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2027-12-27",
      baseline_complete: 97.9,
      actual_complete: 99.8,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-01-03",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-01-10",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-01-17",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-01-24",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-01-31",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-02-07",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-02-14",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-02-21",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-02-28",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-03-06",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-03-13",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-03-20",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-03-27",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-04-03",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-04-10",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-04-17",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-04-24",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-05-01",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-05-08",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-05-15",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-05-22",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-05-29",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-06-05",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-06-12",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-06-19",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-06-26",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "c1af1cf1-8856-6ce3-d0f2-0cd9dd9a064d",
      reporting_date: "2028-07-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
  ],
  "3b55fe73-9f71-b17b-5d4b-42820517364c": [
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-04-16",
      baseline_complete: 1.4,
      actual_complete: 3.5,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-04-23",
      baseline_complete: 1.5,
      actual_complete: 4.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-04-30",
      baseline_complete: 1.5,
      actual_complete: 4.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-05-07",
      baseline_complete: 1.6,
      actual_complete: 7.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-05-14",
      baseline_complete: 1.7,
      actual_complete: 7.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-05-21",
      baseline_complete: 1.7,
      actual_complete: 7.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-05-28",
      baseline_complete: 1.8,
      actual_complete: 7.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-06-04",
      baseline_complete: 1.9,
      actual_complete: 7.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-06-11",
      baseline_complete: 2.0,
      actual_complete: 7.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-06-18",
      baseline_complete: 2.1,
      actual_complete: 7.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-06-25",
      baseline_complete: 2.1,
      actual_complete: 7.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-07-02",
      baseline_complete: 2.2,
      actual_complete: 7.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-07-09",
      baseline_complete: 2.3,
      actual_complete: 7.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-07-16",
      baseline_complete: 2.4,
      actual_complete: 7.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-07-23",
      baseline_complete: 2.5,
      actual_complete: 7.5,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-07-30",
      baseline_complete: 2.6,
      actual_complete: 7.5,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-08-06",
      baseline_complete: 2.7,
      actual_complete: 7.5,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-08-13",
      baseline_complete: 2.8,
      actual_complete: 7.5,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-08-20",
      baseline_complete: 3.0,
      actual_complete: 7.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-08-27",
      baseline_complete: 3.1,
      actual_complete: 7.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-09-03",
      baseline_complete: 3.2,
      actual_complete: 7.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-09-10",
      baseline_complete: 3.3,
      actual_complete: 7.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-09-17",
      baseline_complete: 3.5,
      actual_complete: 7.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-09-24",
      baseline_complete: 3.6,
      actual_complete: 8.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-10-01",
      baseline_complete: 3.8,
      actual_complete: 8.5,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-10-08",
      baseline_complete: 3.9,
      actual_complete: 8.5,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-10-15",
      baseline_complete: 4.1,
      actual_complete: 9.4,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-10-22",
      baseline_complete: 4.2,
      actual_complete: 9.4,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-10-29",
      baseline_complete: 4.4,
      actual_complete: 9.4,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-11-05",
      baseline_complete: 4.6,
      actual_complete: 9.4,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-11-12",
      baseline_complete: 4.8,
      actual_complete: 9.4,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-11-19",
      baseline_complete: 5.0,
      actual_complete: 9.4,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-11-26",
      baseline_complete: 5.2,
      actual_complete: 9.4,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-12-03",
      baseline_complete: 5.4,
      actual_complete: 9.4,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-12-10",
      baseline_complete: 5.6,
      actual_complete: 9.4,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-12-17",
      baseline_complete: 5.8,
      actual_complete: 9.4,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-12-24",
      baseline_complete: 6.0,
      actual_complete: 10.8,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2023-12-31",
      baseline_complete: 6.3,
      actual_complete: 10.8,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-01-07",
      baseline_complete: 6.5,
      actual_complete: 10.8,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-01-14",
      baseline_complete: 6.8,
      actual_complete: 10.8,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-01-21",
      baseline_complete: 7.1,
      actual_complete: 12.0,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-01-28",
      baseline_complete: 7.3,
      actual_complete: 12.0,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-02-04",
      baseline_complete: 7.6,
      actual_complete: 12.0,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-02-11",
      baseline_complete: 7.9,
      actual_complete: 12.0,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-02-18",
      baseline_complete: 8.2,
      actual_complete: 12.0,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-02-25",
      baseline_complete: 8.5,
      actual_complete: 12.0,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-03-03",
      baseline_complete: 8.9,
      actual_complete: 12.0,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-03-10",
      baseline_complete: 9.2,
      actual_complete: 12.4,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-03-17",
      baseline_complete: 9.6,
      actual_complete: 13.7,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-03-24",
      baseline_complete: 9.9,
      actual_complete: 15.2,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-03-31",
      baseline_complete: 10.3,
      actual_complete: 15.5,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-04-07",
      baseline_complete: 10.7,
      actual_complete: 15.5,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-04-14",
      baseline_complete: 11.1,
      actual_complete: 15.5,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-04-21",
      baseline_complete: 11.5,
      actual_complete: 15.5,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-04-28",
      baseline_complete: 12.0,
      actual_complete: 15.7,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-05-05",
      baseline_complete: 12.4,
      actual_complete: 15.7,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-05-12",
      baseline_complete: 12.9,
      actual_complete: 15.7,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-05-19",
      baseline_complete: 13.3,
      actual_complete: 16.9,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-05-26",
      baseline_complete: 13.8,
      actual_complete: 16.9,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-06-02",
      baseline_complete: 14.3,
      actual_complete: 16.9,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-06-09",
      baseline_complete: 14.8,
      actual_complete: 18.2,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-06-16",
      baseline_complete: 15.4,
      actual_complete: 20.2,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-06-23",
      baseline_complete: 15.9,
      actual_complete: 20.2,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-06-30",
      baseline_complete: 16.5,
      actual_complete: 20.2,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-07-07",
      baseline_complete: 17.1,
      actual_complete: 21.1,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-07-14",
      baseline_complete: 17.7,
      actual_complete: 22.3,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-07-21",
      baseline_complete: 18.3,
      actual_complete: 22.3,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-07-28",
      baseline_complete: 18.9,
      actual_complete: 22.3,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-08-04",
      baseline_complete: 19.5,
      actual_complete: 22.5,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-08-11",
      baseline_complete: 20.2,
      actual_complete: 22.6,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-08-18",
      baseline_complete: 20.9,
      actual_complete: 23.2,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-08-25",
      baseline_complete: 21.6,
      actual_complete: 24.2,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-09-01",
      baseline_complete: 22.3,
      actual_complete: 26.1,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-09-08",
      baseline_complete: 23.0,
      actual_complete: 26.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-09-15",
      baseline_complete: 23.8,
      actual_complete: 28.2,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-09-22",
      baseline_complete: 24.5,
      actual_complete: 28.2,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-09-29",
      baseline_complete: 25.3,
      actual_complete: 29.4,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-10-06",
      baseline_complete: 26.1,
      actual_complete: 30.1,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-10-13",
      baseline_complete: 26.9,
      actual_complete: 30.1,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-10-20",
      baseline_complete: 27.7,
      actual_complete: 32.7,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-10-27",
      baseline_complete: 28.6,
      actual_complete: 32.7,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-11-03",
      baseline_complete: 29.4,
      actual_complete: 32.7,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-11-10",
      baseline_complete: 30.3,
      actual_complete: 34.2,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-11-17",
      baseline_complete: 31.2,
      actual_complete: 34.2,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-11-24",
      baseline_complete: 32.1,
      actual_complete: 34.6,
      forecast_complete: 14.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-12-01",
      baseline_complete: 33.0,
      actual_complete: 34.6,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-12-08",
      baseline_complete: 33.9,
      actual_complete: 34.8,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-12-15",
      baseline_complete: 34.8,
      actual_complete: 38.2,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-12-22",
      baseline_complete: 35.8,
      actual_complete: 40.6,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2024-12-29",
      baseline_complete: 36.7,
      actual_complete: 40.6,
      forecast_complete: 16.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-01-05",
      baseline_complete: 37.7,
      actual_complete: 40.6,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-01-12",
      baseline_complete: 38.7,
      actual_complete: 42.6,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-01-19",
      baseline_complete: 39.7,
      actual_complete: 42.6,
      forecast_complete: 18.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-01-26",
      baseline_complete: 40.7,
      actual_complete: 45.3,
      forecast_complete: 19.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-02-02",
      baseline_complete: 41.7,
      actual_complete: 47.0,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-02-09",
      baseline_complete: 42.7,
      actual_complete: 47.0,
      forecast_complete: 20.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-02-16",
      baseline_complete: 43.7,
      actual_complete: 47.0,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-02-23",
      baseline_complete: 44.7,
      actual_complete: 47.2,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-03-02",
      baseline_complete: 45.8,
      actual_complete: 48.6,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-03-09",
      baseline_complete: 46.8,
      actual_complete: 50.9,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-03-16",
      baseline_complete: 47.8,
      actual_complete: 50.9,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-03-23",
      baseline_complete: 48.9,
      actual_complete: 51.1,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-03-30",
      baseline_complete: 49.9,
      actual_complete: 51.9,
      forecast_complete: 24.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-04-06",
      baseline_complete: 50.9,
      actual_complete: 54.3,
      forecast_complete: 25.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-04-13",
      baseline_complete: 52.0,
      actual_complete: 54.3,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-04-20",
      baseline_complete: 53.0,
      actual_complete: 55.5,
      forecast_complete: 26.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-04-27",
      baseline_complete: 54.1,
      actual_complete: 58.1,
      forecast_complete: 27.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-05-04",
      baseline_complete: 55.1,
      actual_complete: 58.3,
      forecast_complete: 27.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-05-11",
      baseline_complete: 56.1,
      actual_complete: 58.3,
      forecast_complete: 28.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-05-18",
      baseline_complete: 57.1,
      actual_complete: 59.1,
      forecast_complete: 29.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-05-25",
      baseline_complete: 58.1,
      actual_complete: 59.2,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-06-01",
      baseline_complete: 59.1,
      actual_complete: 62.4,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-06-08",
      baseline_complete: 60.1,
      actual_complete: 64.5,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-06-15",
      baseline_complete: 61.1,
      actual_complete: 64.5,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-06-22",
      baseline_complete: 62.1,
      actual_complete: 64.5,
      forecast_complete: 32.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-06-29",
      baseline_complete: 63.1,
      actual_complete: 64.5,
      forecast_complete: 33.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-07-06",
      baseline_complete: 64.1,
      actual_complete: 68.0,
      forecast_complete: 34.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-07-13",
      baseline_complete: 65.0,
      actual_complete: 68.0,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-07-20",
      baseline_complete: 65.9,
      actual_complete: 68.0,
      forecast_complete: 35.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-07-27",
      baseline_complete: 66.9,
      actual_complete: 68.5,
      forecast_complete: 36.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-08-03",
      baseline_complete: 67.8,
      actual_complete: 71.3,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-08-10",
      baseline_complete: 68.7,
      actual_complete: 71.3,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-08-17",
      baseline_complete: 69.6,
      actual_complete: 73.7,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-08-24",
      baseline_complete: 70.4,
      actual_complete: 73.7,
      forecast_complete: 39.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-08-31",
      baseline_complete: 71.3,
      actual_complete: 75.1,
      forecast_complete: 40.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-09-07",
      baseline_complete: 72.1,
      actual_complete: 76.4,
      forecast_complete: 41.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-09-14",
      baseline_complete: 73.0,
      actual_complete: 77.2,
      forecast_complete: 41.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-09-21",
      baseline_complete: 73.8,
      actual_complete: 77.2,
      forecast_complete: 42.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-09-28",
      baseline_complete: 74.6,
      actual_complete: 79.1,
      forecast_complete: 43.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-10-05",
      baseline_complete: 75.4,
      actual_complete: 79.1,
      forecast_complete: 44.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-10-12",
      baseline_complete: 76.1,
      actual_complete: 79.1,
      forecast_complete: 44.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-10-19",
      baseline_complete: 76.9,
      actual_complete: 79.1,
      forecast_complete: 45.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-10-26",
      baseline_complete: 77.6,
      actual_complete: 79.1,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-11-02",
      baseline_complete: 78.3,
      actual_complete: 81.1,
      forecast_complete: 47.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-11-09",
      baseline_complete: 79.0,
      actual_complete: 83.0,
      forecast_complete: 47.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-11-16",
      baseline_complete: 79.7,
      actual_complete: 83.0,
      forecast_complete: 48.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-11-23",
      baseline_complete: 80.3,
      actual_complete: 83.0,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-11-30",
      baseline_complete: 81.0,
      actual_complete: 83.0,
      forecast_complete: 50.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-12-07",
      baseline_complete: 81.6,
      actual_complete: 85.6,
      forecast_complete: 50.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-12-14",
      baseline_complete: 82.2,
      actual_complete: 85.6,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-12-21",
      baseline_complete: 82.8,
      actual_complete: 85.6,
      forecast_complete: 52.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2025-12-28",
      baseline_complete: 83.4,
      actual_complete: 85.7,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-01-04",
      baseline_complete: 84.0,
      actual_complete: 88.5,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-01-11",
      baseline_complete: 84.5,
      actual_complete: 88.5,
      forecast_complete: 54.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-01-18",
      baseline_complete: 85.1,
      actual_complete: 88.5,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-01-25",
      baseline_complete: 85.6,
      actual_complete: 88.5,
      forecast_complete: 55.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-02-01",
      baseline_complete: 86.1,
      actual_complete: 88.5,
      forecast_complete: 56.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-02-08",
      baseline_complete: 86.6,
      actual_complete: 90.1,
      forecast_complete: 56.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-02-15",
      baseline_complete: 87.1,
      actual_complete: 90.1,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-02-22",
      baseline_complete: 87.5,
      actual_complete: 90.1,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-03-01",
      baseline_complete: 88.0,
      actual_complete: 90.1,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-03-08",
      baseline_complete: 88.4,
      actual_complete: 91.1,
      forecast_complete: 59.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-03-15",
      baseline_complete: 88.8,
      actual_complete: 91.1,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-03-22",
      baseline_complete: 89.2,
      actual_complete: 91.5,
      forecast_complete: 60.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-03-29",
      baseline_complete: 89.6,
      actual_complete: 91.5,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-04-05",
      baseline_complete: 90.0,
      actual_complete: 92.8,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-04-12",
      baseline_complete: 90.4,
      actual_complete: 92.8,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-04-19",
      baseline_complete: 90.7,
      actual_complete: 92.8,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-04-26",
      baseline_complete: 91.1,
      actual_complete: 92.8,
      forecast_complete: 63.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-05-03",
      baseline_complete: 91.4,
      actual_complete: 93.8,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-05-10",
      baseline_complete: 91.7,
      actual_complete: 93.8,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-05-17",
      baseline_complete: 92.0,
      actual_complete: 95.0,
      forecast_complete: 65.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-05-24",
      baseline_complete: 92.3,
      actual_complete: 95.0,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-05-31",
      baseline_complete: 92.6,
      actual_complete: 95.0,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-06-07",
      baseline_complete: 92.9,
      actual_complete: 97.0,
      forecast_complete: 67.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-06-14",
      baseline_complete: 93.2,
      actual_complete: 97.0,
      forecast_complete: 68.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-06-21",
      baseline_complete: 93.4,
      actual_complete: 97.0,
      forecast_complete: 68.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-06-28",
      baseline_complete: 93.7,
      actual_complete: 97.0,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-07-05",
      baseline_complete: 93.9,
      actual_complete: 97.0,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-07-12",
      baseline_complete: 94.1,
      actual_complete: 98.5,
      forecast_complete: 70.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-07-19",
      baseline_complete: 94.4,
      actual_complete: 98.5,
      forecast_complete: 70.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-07-26",
      baseline_complete: 94.6,
      actual_complete: 98.5,
      forecast_complete: 71.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-08-02",
      baseline_complete: 94.8,
      actual_complete: 98.5,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-08-09",
      baseline_complete: 95.0,
      actual_complete: 98.5,
      forecast_complete: 72.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-08-16",
      baseline_complete: 95.2,
      actual_complete: 98.5,
      forecast_complete: 73.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-08-23",
      baseline_complete: 95.4,
      actual_complete: 98.8,
      forecast_complete: 74.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-08-30",
      baseline_complete: 95.6,
      actual_complete: 98.8,
      forecast_complete: 75.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-09-06",
      baseline_complete: 95.7,
      actual_complete: 98.8,
      forecast_complete: 76.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-09-13",
      baseline_complete: 95.9,
      actual_complete: 98.9,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-09-20",
      baseline_complete: 96.1,
      actual_complete: 98.9,
      forecast_complete: 78.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-09-27",
      baseline_complete: 96.2,
      actual_complete: 98.9,
      forecast_complete: 79.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-10-04",
      baseline_complete: 96.4,
      actual_complete: 98.9,
      forecast_complete: 80.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-10-11",
      baseline_complete: 96.5,
      actual_complete: 98.9,
      forecast_complete: 80.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-10-18",
      baseline_complete: 96.6,
      actual_complete: 98.9,
      forecast_complete: 81.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-10-25",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 82.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-11-01",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 83.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-11-08",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 84.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-11-15",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-11-22",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 85.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-11-29",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-12-06",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-12-13",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 87.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-12-20",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2026-12-27",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-01-03",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-01-10",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 90.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-01-17",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-01-24",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-01-31",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-02-07",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-02-14",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-02-21",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-02-28",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-03-07",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-03-14",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-03-21",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-03-28",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-04-04",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-04-11",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-04-18",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-04-25",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-05-02",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-05-09",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-05-16",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-05-23",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-05-30",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-06-06",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-06-13",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-06-20",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-06-27",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-07-04",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-07-11",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-07-18",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-07-25",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-08-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-08-08",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-08-15",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-08-22",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-08-29",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-09-05",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-09-12",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "3b55fe73-9f71-b17b-5d4b-42820517364c",
      reporting_date: "2027-09-16",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7": [
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-10-14",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-10-21",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-10-28",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-11-04",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-11-11",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-11-18",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-11-25",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-12-02",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-12-09",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-12-16",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-12-23",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2023-12-30",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-01-06",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-01-13",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-01-20",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-01-27",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-02-03",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-02-10",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-02-17",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-02-24",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-03-02",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-03-09",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-03-16",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-03-23",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-03-30",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-04-06",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-04-13",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-04-20",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-04-27",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-05-04",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-05-11",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-05-18",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-05-25",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-06-01",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-06-08",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-06-15",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-06-22",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-06-29",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-07-06",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-07-13",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-07-20",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-07-27",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-08-03",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-08-10",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-08-17",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-08-24",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-08-31",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-09-07",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-09-14",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-09-21",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-09-28",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-10-05",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-10-12",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-10-19",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-10-26",
      baseline_complete: 3.7,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-11-02",
      baseline_complete: 3.8,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-11-09",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-11-16",
      baseline_complete: 4.1,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-11-23",
      baseline_complete: 4.3,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-11-30",
      baseline_complete: 4.4,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-12-07",
      baseline_complete: 4.6,
      actual_complete: 0.0,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-12-14",
      baseline_complete: 4.8,
      actual_complete: 0.0,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-12-21",
      baseline_complete: 5.0,
      actual_complete: 0.0,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2024-12-28",
      baseline_complete: 5.2,
      actual_complete: 0.0,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-01-04",
      baseline_complete: 5.4,
      actual_complete: 0.3,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-01-11",
      baseline_complete: 5.6,
      actual_complete: 0.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-01-18",
      baseline_complete: 5.8,
      actual_complete: 1.8,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-01-25",
      baseline_complete: 6.0,
      actual_complete: 1.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-02-01",
      baseline_complete: 6.2,
      actual_complete: 1.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-02-08",
      baseline_complete: 6.5,
      actual_complete: 2.0,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-02-15",
      baseline_complete: 6.7,
      actual_complete: 2.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-02-22",
      baseline_complete: 7.0,
      actual_complete: 2.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-03-01",
      baseline_complete: 7.3,
      actual_complete: 2.0,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-03-08",
      baseline_complete: 7.5,
      actual_complete: 2.0,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-03-15",
      baseline_complete: 7.8,
      actual_complete: 2.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-03-22",
      baseline_complete: 8.1,
      actual_complete: 4.8,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-03-29",
      baseline_complete: 8.4,
      actual_complete: 4.8,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-04-05",
      baseline_complete: 8.7,
      actual_complete: 4.8,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-04-12",
      baseline_complete: 9.1,
      actual_complete: 4.8,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-04-19",
      baseline_complete: 9.4,
      actual_complete: 4.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-04-26",
      baseline_complete: 9.7,
      actual_complete: 4.8,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-05-03",
      baseline_complete: 10.1,
      actual_complete: 5.2,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-05-10",
      baseline_complete: 10.5,
      actual_complete: 7.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-05-17",
      baseline_complete: 10.9,
      actual_complete: 7.3,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-05-24",
      baseline_complete: 11.3,
      actual_complete: 7.3,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-05-31",
      baseline_complete: 11.7,
      actual_complete: 7.3,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-06-07",
      baseline_complete: 12.1,
      actual_complete: 7.3,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-06-14",
      baseline_complete: 12.5,
      actual_complete: 7.3,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-06-21",
      baseline_complete: 13.0,
      actual_complete: 7.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-06-28",
      baseline_complete: 13.4,
      actual_complete: 7.3,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-07-05",
      baseline_complete: 13.9,
      actual_complete: 10.1,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-07-12",
      baseline_complete: 14.4,
      actual_complete: 10.5,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-07-19",
      baseline_complete: 14.9,
      actual_complete: 10.5,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-07-26",
      baseline_complete: 15.4,
      actual_complete: 11.0,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-08-02",
      baseline_complete: 16.0,
      actual_complete: 11.5,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-08-09",
      baseline_complete: 16.5,
      actual_complete: 13.5,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-08-16",
      baseline_complete: 17.1,
      actual_complete: 13.5,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-08-23",
      baseline_complete: 17.6,
      actual_complete: 13.5,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-08-30",
      baseline_complete: 18.2,
      actual_complete: 15.5,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-09-06",
      baseline_complete: 18.8,
      actual_complete: 15.5,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-09-13",
      baseline_complete: 19.5,
      actual_complete: 15.5,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-09-20",
      baseline_complete: 20.1,
      actual_complete: 15.5,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-09-27",
      baseline_complete: 20.8,
      actual_complete: 15.5,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-10-04",
      baseline_complete: 21.4,
      actual_complete: 18.2,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-10-11",
      baseline_complete: 22.1,
      actual_complete: 18.2,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-10-18",
      baseline_complete: 22.8,
      actual_complete: 18.2,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-10-25",
      baseline_complete: 23.5,
      actual_complete: 18.2,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-11-01",
      baseline_complete: 24.3,
      actual_complete: 20.4,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-11-08",
      baseline_complete: 25.0,
      actual_complete: 21.2,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-11-15",
      baseline_complete: 25.8,
      actual_complete: 21.2,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-11-22",
      baseline_complete: 26.6,
      actual_complete: 23.8,
      forecast_complete: 14.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-11-29",
      baseline_complete: 27.4,
      actual_complete: 25.3,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-12-06",
      baseline_complete: 28.2,
      actual_complete: 25.3,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-12-13",
      baseline_complete: 29.0,
      actual_complete: 26.7,
      forecast_complete: 15.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-12-20",
      baseline_complete: 29.8,
      actual_complete: 26.7,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2025-12-27",
      baseline_complete: 30.7,
      actual_complete: 26.7,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-01-03",
      baseline_complete: 31.5,
      actual_complete: 28.9,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-01-10",
      baseline_complete: 32.4,
      actual_complete: 28.9,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-01-17",
      baseline_complete: 33.3,
      actual_complete: 30.3,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-01-24",
      baseline_complete: 34.2,
      actual_complete: 32.2,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-01-31",
      baseline_complete: 35.1,
      actual_complete: 32.7,
      forecast_complete: 19.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-02-07",
      baseline_complete: 36.0,
      actual_complete: 33.5,
      forecast_complete: 20.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-02-14",
      baseline_complete: 37.0,
      actual_complete: 33.5,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-02-21",
      baseline_complete: 37.9,
      actual_complete: 33.5,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-02-28",
      baseline_complete: 38.9,
      actual_complete: 34.9,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-03-07",
      baseline_complete: 39.8,
      actual_complete: 37.5,
      forecast_complete: 23.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-03-14",
      baseline_complete: 40.8,
      actual_complete: 37.5,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-03-21",
      baseline_complete: 41.8,
      actual_complete: 37.9,
      forecast_complete: 24.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-03-28",
      baseline_complete: 42.7,
      actual_complete: 40.6,
      forecast_complete: 25.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-04-04",
      baseline_complete: 43.7,
      actual_complete: 41.4,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-04-11",
      baseline_complete: 44.7,
      actual_complete: 43.3,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-04-18",
      baseline_complete: 45.7,
      actual_complete: 43.3,
      forecast_complete: 27.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-04-25",
      baseline_complete: 46.7,
      actual_complete: 43.4,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-05-02",
      baseline_complete: 47.7,
      actual_complete: 43.4,
      forecast_complete: 28.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-05-09",
      baseline_complete: 48.7,
      actual_complete: 44.0,
      forecast_complete: 29.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-05-16",
      baseline_complete: 49.7,
      actual_complete: 44.8,
      forecast_complete: 30.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-05-23",
      baseline_complete: 50.8,
      actual_complete: 46.0,
      forecast_complete: 31.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-05-30",
      baseline_complete: 51.8,
      actual_complete: 46.1,
      forecast_complete: 32.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-06-06",
      baseline_complete: 52.8,
      actual_complete: 49.8,
      forecast_complete: 32.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-06-13",
      baseline_complete: 53.8,
      actual_complete: 52.4,
      forecast_complete: 33.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-06-20",
      baseline_complete: 54.8,
      actual_complete: 52.4,
      forecast_complete: 34.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-06-27",
      baseline_complete: 55.8,
      actual_complete: 55.8,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-07-04",
      baseline_complete: 56.8,
      actual_complete: 55.8,
      forecast_complete: 36.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-07-11",
      baseline_complete: 57.7,
      actual_complete: 55.8,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-07-18",
      baseline_complete: 58.7,
      actual_complete: 58.0,
      forecast_complete: 37.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-07-25",
      baseline_complete: 59.7,
      actual_complete: 58.0,
      forecast_complete: 38.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-08-01",
      baseline_complete: 60.7,
      actual_complete: 60.0,
      forecast_complete: 39.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-08-08",
      baseline_complete: 61.6,
      actual_complete: 60.0,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-08-15",
      baseline_complete: 62.6,
      actual_complete: 61.6,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-08-22",
      baseline_complete: 63.5,
      actual_complete: 61.6,
      forecast_complete: 42.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-08-29",
      baseline_complete: 64.4,
      actual_complete: 61.6,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-09-05",
      baseline_complete: 65.3,
      actual_complete: 63.6,
      forecast_complete: 43.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-09-12",
      baseline_complete: 66.3,
      actual_complete: 63.6,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-09-19",
      baseline_complete: 67.1,
      actual_complete: 66.8,
      forecast_complete: 45.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-09-26",
      baseline_complete: 68.0,
      actual_complete: 66.8,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-10-03",
      baseline_complete: 68.9,
      actual_complete: 66.8,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-10-10",
      baseline_complete: 69.8,
      actual_complete: 70.1,
      forecast_complete: 48.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-10-17",
      baseline_complete: 70.6,
      actual_complete: 70.1,
      forecast_complete: 49.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-10-24",
      baseline_complete: 71.4,
      actual_complete: 70.1,
      forecast_complete: 49.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-10-31",
      baseline_complete: 72.2,
      actual_complete: 71.0,
      forecast_complete: 50.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-11-07",
      baseline_complete: 73.0,
      actual_complete: 72.7,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-11-14",
      baseline_complete: 73.8,
      actual_complete: 72.7,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-11-21",
      baseline_complete: 74.6,
      actual_complete: 72.7,
      forecast_complete: 53.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-11-28",
      baseline_complete: 75.4,
      actual_complete: 72.7,
      forecast_complete: 54.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-12-05",
      baseline_complete: 76.1,
      actual_complete: 76.2,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-12-12",
      baseline_complete: 76.8,
      actual_complete: 76.2,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-12-19",
      baseline_complete: 77.5,
      actual_complete: 76.3,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2026-12-26",
      baseline_complete: 78.2,
      actual_complete: 78.7,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-01-02",
      baseline_complete: 78.9,
      actual_complete: 78.8,
      forecast_complete: 58.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-01-09",
      baseline_complete: 79.6,
      actual_complete: 78.8,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-01-16",
      baseline_complete: 80.2,
      actual_complete: 78.8,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-01-23",
      baseline_complete: 80.8,
      actual_complete: 80.5,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-01-30",
      baseline_complete: 81.5,
      actual_complete: 81.7,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-02-06",
      baseline_complete: 82.1,
      actual_complete: 81.7,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-02-13",
      baseline_complete: 82.6,
      actual_complete: 83.4,
      forecast_complete: 63.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-02-20",
      baseline_complete: 83.2,
      actual_complete: 83.4,
      forecast_complete: 63.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-02-27",
      baseline_complete: 83.8,
      actual_complete: 84.5,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-03-06",
      baseline_complete: 84.3,
      actual_complete: 84.5,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-03-13",
      baseline_complete: 84.8,
      actual_complete: 86.4,
      forecast_complete: 67.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-03-20",
      baseline_complete: 85.3,
      actual_complete: 86.4,
      forecast_complete: 68.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-03-27",
      baseline_complete: 85.8,
      actual_complete: 87.8,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-04-03",
      baseline_complete: 86.3,
      actual_complete: 87.8,
      forecast_complete: 71.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-04-10",
      baseline_complete: 86.8,
      actual_complete: 87.8,
      forecast_complete: 72.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-04-17",
      baseline_complete: 87.3,
      actual_complete: 87.8,
      forecast_complete: 73.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-04-24",
      baseline_complete: 87.7,
      actual_complete: 88.5,
      forecast_complete: 74.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-05-01",
      baseline_complete: 88.1,
      actual_complete: 88.5,
      forecast_complete: 75.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-05-08",
      baseline_complete: 88.5,
      actual_complete: 88.5,
      forecast_complete: 77.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-05-15",
      baseline_complete: 88.9,
      actual_complete: 88.5,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-05-22",
      baseline_complete: 89.3,
      actual_complete: 88.9,
      forecast_complete: 79.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-05-29",
      baseline_complete: 89.7,
      actual_complete: 89.4,
      forecast_complete: 80.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-06-05",
      baseline_complete: 90.1,
      actual_complete: 89.4,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-06-12",
      baseline_complete: 90.4,
      actual_complete: 89.4,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-06-19",
      baseline_complete: 90.8,
      actual_complete: 91.9,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-06-26",
      baseline_complete: 91.1,
      actual_complete: 91.9,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-07-03",
      baseline_complete: 91.4,
      actual_complete: 91.9,
      forecast_complete: 84.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-07-10",
      baseline_complete: 91.7,
      actual_complete: 95.3,
      forecast_complete: 85.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-07-17",
      baseline_complete: 92.0,
      actual_complete: 95.3,
      forecast_complete: 86.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-07-24",
      baseline_complete: 92.3,
      actual_complete: 95.3,
      forecast_complete: 87.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-07-31",
      baseline_complete: 92.6,
      actual_complete: 95.3,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-08-07",
      baseline_complete: 92.9,
      actual_complete: 95.3,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-08-14",
      baseline_complete: 93.1,
      actual_complete: 95.3,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-08-21",
      baseline_complete: 93.4,
      actual_complete: 95.3,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-08-28",
      baseline_complete: 93.6,
      actual_complete: 95.5,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-09-04",
      baseline_complete: 93.9,
      actual_complete: 95.5,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-09-11",
      baseline_complete: 94.1,
      actual_complete: 95.5,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-09-18",
      baseline_complete: 94.3,
      actual_complete: 95.5,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-09-25",
      baseline_complete: 94.5,
      actual_complete: 95.5,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-10-02",
      baseline_complete: 94.7,
      actual_complete: 96.6,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-10-09",
      baseline_complete: 94.9,
      actual_complete: 96.6,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-10-16",
      baseline_complete: 95.1,
      actual_complete: 96.6,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-10-23",
      baseline_complete: 95.3,
      actual_complete: 96.6,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-10-30",
      baseline_complete: 95.5,
      actual_complete: 97.3,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-11-06",
      baseline_complete: 95.7,
      actual_complete: 97.3,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-11-13",
      baseline_complete: 95.8,
      actual_complete: 98.6,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-11-20",
      baseline_complete: 96.0,
      actual_complete: 99.3,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-11-27",
      baseline_complete: 96.1,
      actual_complete: 99.3,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-12-04",
      baseline_complete: 96.3,
      actual_complete: 99.3,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-12-11",
      baseline_complete: 96.4,
      actual_complete: 99.3,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-12-18",
      baseline_complete: 96.6,
      actual_complete: 99.3,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2027-12-25",
      baseline_complete: 96.7,
      actual_complete: 99.3,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-01-01",
      baseline_complete: 96.8,
      actual_complete: 99.3,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-01-08",
      baseline_complete: 96.9,
      actual_complete: 99.3,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-01-15",
      baseline_complete: 97.1,
      actual_complete: 99.3,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-01-22",
      baseline_complete: 97.2,
      actual_complete: 99.3,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-01-29",
      baseline_complete: 97.3,
      actual_complete: 99.3,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-02-05",
      baseline_complete: 97.4,
      actual_complete: 99.4,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-02-12",
      baseline_complete: 97.5,
      actual_complete: 99.4,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-02-19",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-02-26",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-03-04",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-03-11",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-03-18",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-03-25",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-04-01",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-04-08",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2c4ca0da-c1cc-a7f3-ad18-1f94283564f7",
      reporting_date: "2028-04-14",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "1e8aef07-9d90-f203-eef5-01b9fde4203e": [
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-09-17",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-09-24",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-10-01",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-10-08",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-10-15",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-10-22",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-10-29",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-11-05",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-11-12",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-11-19",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-11-26",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-12-03",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-12-10",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-12-17",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-12-24",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2024-12-31",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-01-07",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-01-14",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-01-21",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-01-28",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-02-04",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-02-11",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-02-18",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-02-25",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-03-04",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-03-11",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-03-18",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-03-25",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-04-01",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-04-08",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-04-15",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-04-22",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-04-29",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-05-06",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-05-13",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-05-20",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-05-27",
      baseline_complete: 3.2,
      actual_complete: 0.3,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-06-03",
      baseline_complete: 3.4,
      actual_complete: 0.3,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-06-10",
      baseline_complete: 3.6,
      actual_complete: 0.3,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-06-17",
      baseline_complete: 3.7,
      actual_complete: 0.3,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-06-24",
      baseline_complete: 3.9,
      actual_complete: 0.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-07-01",
      baseline_complete: 4.1,
      actual_complete: 0.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-07-08",
      baseline_complete: 4.4,
      actual_complete: 1.8,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-07-15",
      baseline_complete: 4.6,
      actual_complete: 1.8,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-07-22",
      baseline_complete: 4.8,
      actual_complete: 1.8,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-07-29",
      baseline_complete: 5.1,
      actual_complete: 1.8,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-08-05",
      baseline_complete: 5.3,
      actual_complete: 2.3,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-08-12",
      baseline_complete: 5.6,
      actual_complete: 2.3,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-08-19",
      baseline_complete: 5.9,
      actual_complete: 2.3,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-08-26",
      baseline_complete: 6.2,
      actual_complete: 2.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-09-02",
      baseline_complete: 6.5,
      actual_complete: 2.3,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-09-09",
      baseline_complete: 6.9,
      actual_complete: 4.1,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-09-16",
      baseline_complete: 7.2,
      actual_complete: 4.1,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-09-23",
      baseline_complete: 7.6,
      actual_complete: 4.1,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-09-30",
      baseline_complete: 7.9,
      actual_complete: 5.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-10-07",
      baseline_complete: 8.3,
      actual_complete: 5.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-10-14",
      baseline_complete: 8.8,
      actual_complete: 5.5,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-10-21",
      baseline_complete: 9.2,
      actual_complete: 6.3,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-10-28",
      baseline_complete: 9.6,
      actual_complete: 6.3,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-11-04",
      baseline_complete: 10.1,
      actual_complete: 7.5,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-11-11",
      baseline_complete: 10.6,
      actual_complete: 7.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-11-18",
      baseline_complete: 11.1,
      actual_complete: 7.5,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-11-25",
      baseline_complete: 11.7,
      actual_complete: 7.5,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-12-02",
      baseline_complete: 12.2,
      actual_complete: 7.5,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-12-09",
      baseline_complete: 12.8,
      actual_complete: 8.7,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-12-16",
      baseline_complete: 13.4,
      actual_complete: 8.7,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-12-23",
      baseline_complete: 14.0,
      actual_complete: 9.5,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2025-12-30",
      baseline_complete: 14.7,
      actual_complete: 10.1,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-01-06",
      baseline_complete: 15.4,
      actual_complete: 11.1,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-01-13",
      baseline_complete: 16.1,
      actual_complete: 13.7,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-01-20",
      baseline_complete: 16.8,
      actual_complete: 13.7,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-01-27",
      baseline_complete: 17.6,
      actual_complete: 14.9,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-02-03",
      baseline_complete: 18.3,
      actual_complete: 14.9,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-02-10",
      baseline_complete: 19.1,
      actual_complete: 14.9,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-02-17",
      baseline_complete: 20.0,
      actual_complete: 14.9,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-02-24",
      baseline_complete: 20.8,
      actual_complete: 14.9,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-03-03",
      baseline_complete: 21.7,
      actual_complete: 21.0,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-03-10",
      baseline_complete: 22.7,
      actual_complete: 21.0,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-03-17",
      baseline_complete: 23.6,
      actual_complete: 21.0,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-03-24",
      baseline_complete: 24.6,
      actual_complete: 22.1,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-03-31",
      baseline_complete: 25.6,
      actual_complete: 24.5,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-04-07",
      baseline_complete: 26.6,
      actual_complete: 24.5,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-04-14",
      baseline_complete: 27.6,
      actual_complete: 25.7,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-04-21",
      baseline_complete: 28.7,
      actual_complete: 25.7,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-04-28",
      baseline_complete: 29.8,
      actual_complete: 25.7,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-05-05",
      baseline_complete: 30.9,
      actual_complete: 25.7,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-05-12",
      baseline_complete: 32.1,
      actual_complete: 26.3,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-05-19",
      baseline_complete: 33.3,
      actual_complete: 27.6,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-05-26",
      baseline_complete: 34.4,
      actual_complete: 32.0,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-06-02",
      baseline_complete: 35.7,
      actual_complete: 32.4,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-06-09",
      baseline_complete: 36.9,
      actual_complete: 35.2,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-06-16",
      baseline_complete: 38.1,
      actual_complete: 37.8,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-06-23",
      baseline_complete: 39.4,
      actual_complete: 37.8,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-06-30",
      baseline_complete: 40.7,
      actual_complete: 37.8,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-07-07",
      baseline_complete: 41.9,
      actual_complete: 37.8,
      forecast_complete: 19.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-07-14",
      baseline_complete: 43.2,
      actual_complete: 38.1,
      forecast_complete: 20.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-07-21",
      baseline_complete: 44.6,
      actual_complete: 38.7,
      forecast_complete: 20.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-07-28",
      baseline_complete: 45.9,
      actual_complete: 43.0,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-08-04",
      baseline_complete: 47.2,
      actual_complete: 43.6,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-08-11",
      baseline_complete: 48.5,
      actual_complete: 45.2,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-08-18",
      baseline_complete: 49.8,
      actual_complete: 48.1,
      forecast_complete: 24.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-08-25",
      baseline_complete: 51.2,
      actual_complete: 48.1,
      forecast_complete: 25.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-09-01",
      baseline_complete: 52.5,
      actual_complete: 49.1,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-09-08",
      baseline_complete: 53.8,
      actual_complete: 50.6,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-09-15",
      baseline_complete: 55.1,
      actual_complete: 50.6,
      forecast_complete: 27.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-09-22",
      baseline_complete: 56.4,
      actual_complete: 55.3,
      forecast_complete: 28.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-09-29",
      baseline_complete: 57.7,
      actual_complete: 55.7,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-10-06",
      baseline_complete: 59.0,
      actual_complete: 57.5,
      forecast_complete: 30.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-10-13",
      baseline_complete: 60.3,
      actual_complete: 57.5,
      forecast_complete: 31.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-10-20",
      baseline_complete: 61.6,
      actual_complete: 57.9,
      forecast_complete: 32.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-10-27",
      baseline_complete: 62.8,
      actual_complete: 62.2,
      forecast_complete: 33.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-11-03",
      baseline_complete: 64.1,
      actual_complete: 62.2,
      forecast_complete: 34.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-11-10",
      baseline_complete: 65.3,
      actual_complete: 63.9,
      forecast_complete: 35.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-11-17",
      baseline_complete: 66.5,
      actual_complete: 64.8,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-11-24",
      baseline_complete: 67.6,
      actual_complete: 64.8,
      forecast_complete: 36.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-12-01",
      baseline_complete: 68.8,
      actual_complete: 65.0,
      forecast_complete: 37.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-12-08",
      baseline_complete: 69.9,
      actual_complete: 66.1,
      forecast_complete: 38.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-12-15",
      baseline_complete: 71.0,
      actual_complete: 69.2,
      forecast_complete: 39.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-12-22",
      baseline_complete: 72.1,
      actual_complete: 72.8,
      forecast_complete: 40.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2026-12-29",
      baseline_complete: 73.2,
      actual_complete: 72.8,
      forecast_complete: 41.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-01-05",
      baseline_complete: 74.2,
      actual_complete: 72.8,
      forecast_complete: 42.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-01-12",
      baseline_complete: 75.2,
      actual_complete: 75.8,
      forecast_complete: 43.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-01-19",
      baseline_complete: 76.2,
      actual_complete: 75.8,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-01-26",
      baseline_complete: 77.1,
      actual_complete: 75.8,
      forecast_complete: 45.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-02-02",
      baseline_complete: 78.0,
      actual_complete: 75.8,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-02-09",
      baseline_complete: 78.9,
      actual_complete: 76.6,
      forecast_complete: 47.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-02-16",
      baseline_complete: 79.8,
      actual_complete: 78.9,
      forecast_complete: 47.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-02-23",
      baseline_complete: 80.7,
      actual_complete: 78.9,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-03-02",
      baseline_complete: 81.5,
      actual_complete: 81.6,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-03-09",
      baseline_complete: 82.3,
      actual_complete: 81.6,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-03-16",
      baseline_complete: 83.0,
      actual_complete: 81.6,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-03-23",
      baseline_complete: 83.8,
      actual_complete: 81.6,
      forecast_complete: 52.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-03-30",
      baseline_complete: 84.5,
      actual_complete: 86.0,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-04-06",
      baseline_complete: 85.1,
      actual_complete: 86.0,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-04-13",
      baseline_complete: 85.8,
      actual_complete: 86.0,
      forecast_complete: 54.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-04-20",
      baseline_complete: 86.4,
      actual_complete: 86.0,
      forecast_complete: 55.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-04-27",
      baseline_complete: 87.1,
      actual_complete: 86.0,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-05-04",
      baseline_complete: 87.6,
      actual_complete: 86.7,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-05-11",
      baseline_complete: 88.2,
      actual_complete: 87.6,
      forecast_complete: 57.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-05-18",
      baseline_complete: 88.7,
      actual_complete: 87.6,
      forecast_complete: 58.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-05-25",
      baseline_complete: 89.3,
      actual_complete: 87.6,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-06-01",
      baseline_complete: 89.8,
      actual_complete: 88.7,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-06-08",
      baseline_complete: 90.2,
      actual_complete: 88.7,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-06-15",
      baseline_complete: 90.7,
      actual_complete: 89.7,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-06-22",
      baseline_complete: 91.1,
      actual_complete: 91.0,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-06-29",
      baseline_complete: 91.6,
      actual_complete: 91.0,
      forecast_complete: 63.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-07-06",
      baseline_complete: 92.0,
      actual_complete: 92.0,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-07-13",
      baseline_complete: 92.3,
      actual_complete: 92.0,
      forecast_complete: 64.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-07-20",
      baseline_complete: 92.7,
      actual_complete: 94.8,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-07-27",
      baseline_complete: 93.1,
      actual_complete: 94.8,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-08-03",
      baseline_complete: 93.4,
      actual_complete: 94.8,
      forecast_complete: 66.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-08-10",
      baseline_complete: 93.7,
      actual_complete: 94.8,
      forecast_complete: 67.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-08-17",
      baseline_complete: 94.0,
      actual_complete: 94.8,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-08-24",
      baseline_complete: 94.3,
      actual_complete: 94.8,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-08-31",
      baseline_complete: 94.6,
      actual_complete: 95.4,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-09-07",
      baseline_complete: 94.9,
      actual_complete: 96.5,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-09-14",
      baseline_complete: 95.1,
      actual_complete: 96.5,
      forecast_complete: 70.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-09-21",
      baseline_complete: 95.4,
      actual_complete: 96.5,
      forecast_complete: 71.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-09-28",
      baseline_complete: 95.6,
      actual_complete: 96.5,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-10-05",
      baseline_complete: 95.8,
      actual_complete: 96.5,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-10-12",
      baseline_complete: 96.0,
      actual_complete: 97.6,
      forecast_complete: 73.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-10-19",
      baseline_complete: 96.2,
      actual_complete: 97.6,
      forecast_complete: 74.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-10-26",
      baseline_complete: 96.4,
      actual_complete: 98.0,
      forecast_complete: 75.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-11-02",
      baseline_complete: 96.6,
      actual_complete: 98.4,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-11-09",
      baseline_complete: 96.7,
      actual_complete: 98.4,
      forecast_complete: 77.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-11-16",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 78.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-11-23",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 79.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-11-30",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 80.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-12-07",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-12-14",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 82.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-12-21",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 82.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2027-12-28",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-01-04",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 84.5,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-01-11",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-01-18",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-01-25",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-02-01",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-02-08",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-02-15",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-02-22",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 89.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-02-29",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-03-07",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-03-14",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-03-21",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-03-28",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-04-04",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-04-11",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-04-18",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-04-25",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-05-02",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-05-09",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-05-16",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-05-23",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-05-30",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-06-06",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-06-13",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-06-20",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-06-27",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-07-04",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-07-11",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-07-18",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-07-25",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-08-01",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-08-08",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-08-15",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-08-22",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-08-29",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-09-05",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-09-12",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-09-19",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-09-26",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-10-03",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-10-10",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "1e8aef07-9d90-f203-eef5-01b9fde4203e",
      reporting_date: "2028-10-17",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "e5c5afaa-9030-861f-6b93-09149ef8a82b": [
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-05-17",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-05-24",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-05-31",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-06-07",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-06-14",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-06-21",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-06-28",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-07-05",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-07-12",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-07-19",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-07-26",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-08-02",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-08-09",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-08-16",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-08-23",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-08-30",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-09-06",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-09-13",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-09-20",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-09-27",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-10-04",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-10-11",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-10-18",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-10-25",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-11-01",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-11-08",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-11-15",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-11-22",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-11-29",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-12-06",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-12-13",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-12-20",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2025-12-27",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-01-03",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-01-10",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-01-17",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-01-24",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-01-31",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-02-07",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-02-14",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-02-21",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-02-28",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-03-07",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-03-14",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-03-21",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-03-28",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-04-04",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-04-11",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-04-18",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-04-25",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-05-02",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-05-09",
      baseline_complete: 4.1,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-05-16",
      baseline_complete: 4.4,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-05-23",
      baseline_complete: 4.7,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-05-30",
      baseline_complete: 5.0,
      actual_complete: 0.5,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-06-06",
      baseline_complete: 5.3,
      actual_complete: 0.5,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-06-13",
      baseline_complete: 5.6,
      actual_complete: 1.1,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-06-20",
      baseline_complete: 6.0,
      actual_complete: 1.1,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-06-27",
      baseline_complete: 6.4,
      actual_complete: 1.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-07-04",
      baseline_complete: 6.8,
      actual_complete: 3.3,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-07-11",
      baseline_complete: 7.2,
      actual_complete: 3.3,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-07-18",
      baseline_complete: 7.6,
      actual_complete: 3.3,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-07-25",
      baseline_complete: 8.1,
      actual_complete: 4.7,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-08-01",
      baseline_complete: 8.6,
      actual_complete: 4.7,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-08-08",
      baseline_complete: 9.1,
      actual_complete: 4.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-08-15",
      baseline_complete: 9.7,
      actual_complete: 4.7,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-08-22",
      baseline_complete: 10.3,
      actual_complete: 5.7,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-08-29",
      baseline_complete: 10.9,
      actual_complete: 6.4,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-09-05",
      baseline_complete: 11.6,
      actual_complete: 7.6,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-09-12",
      baseline_complete: 12.2,
      actual_complete: 8.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-09-19",
      baseline_complete: 13.0,
      actual_complete: 9.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-09-26",
      baseline_complete: 13.7,
      actual_complete: 9.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-10-03",
      baseline_complete: 14.5,
      actual_complete: 9.6,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-10-10",
      baseline_complete: 15.4,
      actual_complete: 10.6,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-10-17",
      baseline_complete: 16.2,
      actual_complete: 12.2,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-10-24",
      baseline_complete: 17.1,
      actual_complete: 13.0,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-10-31",
      baseline_complete: 18.1,
      actual_complete: 13.0,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-11-07",
      baseline_complete: 19.1,
      actual_complete: 13.3,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-11-14",
      baseline_complete: 20.1,
      actual_complete: 14.3,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-11-21",
      baseline_complete: 21.2,
      actual_complete: 15.5,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-11-28",
      baseline_complete: 22.3,
      actual_complete: 18.6,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-12-05",
      baseline_complete: 23.5,
      actual_complete: 19.4,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-12-12",
      baseline_complete: 24.7,
      actual_complete: 20.1,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-12-19",
      baseline_complete: 25.9,
      actual_complete: 21.1,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2026-12-26",
      baseline_complete: 27.2,
      actual_complete: 24.2,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-01-02",
      baseline_complete: 28.5,
      actual_complete: 25.8,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-01-09",
      baseline_complete: 29.8,
      actual_complete: 28.2,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-01-16",
      baseline_complete: 31.2,
      actual_complete: 28.2,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-01-23",
      baseline_complete: 32.7,
      actual_complete: 28.2,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-01-30",
      baseline_complete: 34.1,
      actual_complete: 28.2,
      forecast_complete: 15.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-02-06",
      baseline_complete: 35.6,
      actual_complete: 32.4,
      forecast_complete: 16.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-02-13",
      baseline_complete: 37.1,
      actual_complete: 32.4,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-02-20",
      baseline_complete: 38.7,
      actual_complete: 33.3,
      forecast_complete: 18.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-02-27",
      baseline_complete: 40.2,
      actual_complete: 39.1,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-03-06",
      baseline_complete: 41.8,
      actual_complete: 39.3,
      forecast_complete: 20.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-03-13",
      baseline_complete: 43.4,
      actual_complete: 41.4,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-03-20",
      baseline_complete: 45.1,
      actual_complete: 41.4,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-03-27",
      baseline_complete: 46.7,
      actual_complete: 43.7,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-04-03",
      baseline_complete: 48.3,
      actual_complete: 45.3,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-04-10",
      baseline_complete: 50.0,
      actual_complete: 47.8,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-04-17",
      baseline_complete: 51.6,
      actual_complete: 49.4,
      forecast_complete: 27.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-04-24",
      baseline_complete: 53.2,
      actual_complete: 50.6,
      forecast_complete: 29.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-05-01",
      baseline_complete: 54.9,
      actual_complete: 52.1,
      forecast_complete: 30.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-05-08",
      baseline_complete: 56.5,
      actual_complete: 54.2,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-05-15",
      baseline_complete: 58.1,
      actual_complete: 56.8,
      forecast_complete: 32.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-05-22",
      baseline_complete: 59.7,
      actual_complete: 56.8,
      forecast_complete: 34.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-05-29",
      baseline_complete: 61.2,
      actual_complete: 58.4,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-06-05",
      baseline_complete: 62.8,
      actual_complete: 61.1,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-06-12",
      baseline_complete: 64.3,
      actual_complete: 61.1,
      forecast_complete: 37.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-06-19",
      baseline_complete: 65.8,
      actual_complete: 63.7,
      forecast_complete: 39.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-06-26",
      baseline_complete: 67.3,
      actual_complete: 64.2,
      forecast_complete: 40.3,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-07-03",
      baseline_complete: 68.7,
      actual_complete: 67.3,
      forecast_complete: 41.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-07-10",
      baseline_complete: 70.1,
      actual_complete: 67.3,
      forecast_complete: 42.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-07-17",
      baseline_complete: 71.4,
      actual_complete: 69.0,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-07-24",
      baseline_complete: 72.8,
      actual_complete: 71.0,
      forecast_complete: 45.3,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-07-31",
      baseline_complete: 74.0,
      actual_complete: 71.0,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-08-07",
      baseline_complete: 75.3,
      actual_complete: 73.2,
      forecast_complete: 47.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-08-14",
      baseline_complete: 76.5,
      actual_complete: 75.8,
      forecast_complete: 49.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-08-21",
      baseline_complete: 77.6,
      actual_complete: 76.8,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-08-28",
      baseline_complete: 78.8,
      actual_complete: 76.8,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-09-04",
      baseline_complete: 79.8,
      actual_complete: 79.0,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-09-11",
      baseline_complete: 80.9,
      actual_complete: 79.2,
      forecast_complete: 53.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-09-18",
      baseline_complete: 81.9,
      actual_complete: 79.2,
      forecast_complete: 54.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-09-25",
      baseline_complete: 82.8,
      actual_complete: 79.8,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-10-02",
      baseline_complete: 83.7,
      actual_complete: 81.1,
      forecast_complete: 56.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-10-09",
      baseline_complete: 84.6,
      actual_complete: 84.6,
      forecast_complete: 58.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-10-16",
      baseline_complete: 85.4,
      actual_complete: 84.6,
      forecast_complete: 59.1,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-10-23",
      baseline_complete: 86.2,
      actual_complete: 85.0,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-10-30",
      baseline_complete: 87.0,
      actual_complete: 87.7,
      forecast_complete: 61.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-11-06",
      baseline_complete: 87.7,
      actual_complete: 87.7,
      forecast_complete: 62.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-11-13",
      baseline_complete: 88.4,
      actual_complete: 87.7,
      forecast_complete: 63.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-11-20",
      baseline_complete: 89.1,
      actual_complete: 87.7,
      forecast_complete: 64.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-11-27",
      baseline_complete: 89.7,
      actual_complete: 87.7,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-12-04",
      baseline_complete: 90.3,
      actual_complete: 88.1,
      forecast_complete: 66.1,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-12-11",
      baseline_complete: 90.8,
      actual_complete: 91.3,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-12-18",
      baseline_complete: 91.4,
      actual_complete: 91.3,
      forecast_complete: 68.4,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2027-12-25",
      baseline_complete: 91.9,
      actual_complete: 93.0,
      forecast_complete: 70.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-01-01",
      baseline_complete: 92.3,
      actual_complete: 93.1,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-01-08",
      baseline_complete: 92.8,
      actual_complete: 93.1,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-01-15",
      baseline_complete: 93.2,
      actual_complete: 94.0,
      forecast_complete: 74.3,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-01-22",
      baseline_complete: 93.6,
      actual_complete: 94.0,
      forecast_complete: 75.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-01-29",
      baseline_complete: 94.0,
      actual_complete: 94.0,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-02-05",
      baseline_complete: 94.4,
      actual_complete: 95.9,
      forecast_complete: 78.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-02-12",
      baseline_complete: 94.7,
      actual_complete: 95.9,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-02-19",
      baseline_complete: 95.0,
      actual_complete: 96.6,
      forecast_complete: 80.5,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-02-26",
      baseline_complete: 95.3,
      actual_complete: 96.7,
      forecast_complete: 81.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-03-04",
      baseline_complete: 95.6,
      actual_complete: 96.7,
      forecast_complete: 82.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-03-11",
      baseline_complete: 95.9,
      actual_complete: 96.7,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-03-18",
      baseline_complete: 96.1,
      actual_complete: 96.7,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-03-25",
      baseline_complete: 96.4,
      actual_complete: 96.7,
      forecast_complete: 85.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-04-01",
      baseline_complete: 96.6,
      actual_complete: 96.7,
      forecast_complete: 86.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-04-08",
      baseline_complete: 96.8,
      actual_complete: 98.3,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-04-15",
      baseline_complete: 97.0,
      actual_complete: 98.3,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-04-22",
      baseline_complete: 97.2,
      actual_complete: 98.3,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-04-29",
      baseline_complete: 97.4,
      actual_complete: 98.3,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-05-06",
      baseline_complete: 97.5,
      actual_complete: 98.3,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-05-13",
      baseline_complete: 97.7,
      actual_complete: 98.6,
      forecast_complete: 91.3,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-05-20",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-05-27",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-06-03",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-06-10",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-06-17",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-06-24",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-07-01",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-07-08",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-07-15",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-07-22",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-07-29",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-08-05",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-08-12",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-08-19",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-08-26",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-09-02",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-09-09",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-09-16",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-09-23",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-09-30",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-10-07",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-10-14",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "e5c5afaa-9030-861f-6b93-09149ef8a82b",
      reporting_date: "2028-10-17",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
  ],
  "7a4c9383-0cd2-6389-6f3d-5700c924382d": [
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-08-18",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-08-25",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-09-01",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-09-08",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-09-15",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-09-22",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-09-29",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-10-06",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-10-13",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-10-20",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-10-27",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-11-03",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-11-10",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-11-17",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-11-24",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-12-01",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-12-08",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-12-15",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-12-22",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2023-12-29",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-01-05",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-01-12",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-01-19",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-01-26",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-02-02",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-02-09",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-02-16",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-02-23",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-03-01",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-03-08",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-03-15",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-03-22",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-03-29",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-04-05",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-04-12",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-04-19",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-04-26",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-05-03",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-05-10",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-05-17",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-05-24",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-05-31",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-06-07",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-06-14",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-06-21",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-06-28",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-07-05",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-07-12",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-07-19",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-07-26",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-08-02",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-08-09",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-08-16",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-08-23",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-08-30",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-09-06",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-09-13",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-09-20",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-09-27",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-10-04",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-10-11",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-10-18",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-10-25",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-11-01",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-11-08",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-11-15",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-11-22",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-11-29",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-12-06",
      baseline_complete: 2.2,
      actual_complete: 0.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-12-13",
      baseline_complete: 2.3,
      actual_complete: 0.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-12-20",
      baseline_complete: 2.4,
      actual_complete: 0.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2024-12-27",
      baseline_complete: 2.5,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-01-03",
      baseline_complete: 2.6,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-01-10",
      baseline_complete: 2.8,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-01-17",
      baseline_complete: 2.9,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-01-24",
      baseline_complete: 3.1,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-01-31",
      baseline_complete: 3.2,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-02-07",
      baseline_complete: 3.4,
      actual_complete: 0.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-02-14",
      baseline_complete: 3.5,
      actual_complete: 0.8,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-02-21",
      baseline_complete: 3.7,
      actual_complete: 0.8,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-02-28",
      baseline_complete: 3.9,
      actual_complete: 2.2,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-03-07",
      baseline_complete: 4.1,
      actual_complete: 2.2,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-03-14",
      baseline_complete: 4.3,
      actual_complete: 2.8,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-03-21",
      baseline_complete: 4.5,
      actual_complete: 2.8,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-03-28",
      baseline_complete: 4.7,
      actual_complete: 3.2,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-04-04",
      baseline_complete: 4.9,
      actual_complete: 3.2,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-04-11",
      baseline_complete: 5.2,
      actual_complete: 3.2,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-04-18",
      baseline_complete: 5.4,
      actual_complete: 3.2,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-04-25",
      baseline_complete: 5.7,
      actual_complete: 3.2,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-05-02",
      baseline_complete: 6.0,
      actual_complete: 4.4,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-05-09",
      baseline_complete: 6.3,
      actual_complete: 4.4,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-05-16",
      baseline_complete: 6.6,
      actual_complete: 4.4,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-05-23",
      baseline_complete: 6.9,
      actual_complete: 4.4,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-05-30",
      baseline_complete: 7.2,
      actual_complete: 5.1,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-06-06",
      baseline_complete: 7.5,
      actual_complete: 5.2,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-06-13",
      baseline_complete: 7.9,
      actual_complete: 5.4,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-06-20",
      baseline_complete: 8.3,
      actual_complete: 5.4,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-06-27",
      baseline_complete: 8.7,
      actual_complete: 6.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-07-04",
      baseline_complete: 9.1,
      actual_complete: 6.2,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-07-11",
      baseline_complete: 9.5,
      actual_complete: 6.2,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-07-18",
      baseline_complete: 9.9,
      actual_complete: 7.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-07-25",
      baseline_complete: 10.4,
      actual_complete: 8.6,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-08-01",
      baseline_complete: 10.9,
      actual_complete: 9.5,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-08-08",
      baseline_complete: 11.4,
      actual_complete: 9.5,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-08-15",
      baseline_complete: 11.9,
      actual_complete: 9.5,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-08-22",
      baseline_complete: 12.4,
      actual_complete: 10.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-08-29",
      baseline_complete: 13.0,
      actual_complete: 11.9,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-09-05",
      baseline_complete: 13.5,
      actual_complete: 11.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-09-12",
      baseline_complete: 14.1,
      actual_complete: 11.9,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-09-19",
      baseline_complete: 14.8,
      actual_complete: 11.9,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-09-26",
      baseline_complete: 15.4,
      actual_complete: 14.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-10-03",
      baseline_complete: 16.1,
      actual_complete: 14.6,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-10-10",
      baseline_complete: 16.8,
      actual_complete: 14.6,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-10-17",
      baseline_complete: 17.5,
      actual_complete: 14.6,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-10-24",
      baseline_complete: 18.2,
      actual_complete: 14.6,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-10-31",
      baseline_complete: 19.0,
      actual_complete: 14.9,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-11-07",
      baseline_complete: 19.7,
      actual_complete: 18.0,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-11-14",
      baseline_complete: 20.5,
      actual_complete: 19.1,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-11-21",
      baseline_complete: 21.4,
      actual_complete: 20.0,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-11-28",
      baseline_complete: 22.2,
      actual_complete: 20.0,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-12-05",
      baseline_complete: 23.1,
      actual_complete: 22.6,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-12-12",
      baseline_complete: 24.0,
      actual_complete: 22.6,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-12-19",
      baseline_complete: 24.9,
      actual_complete: 22.6,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2025-12-26",
      baseline_complete: 25.9,
      actual_complete: 22.6,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-01-02",
      baseline_complete: 26.9,
      actual_complete: 22.6,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-01-09",
      baseline_complete: 27.9,
      actual_complete: 22.7,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-01-16",
      baseline_complete: 28.9,
      actual_complete: 27.2,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-01-23",
      baseline_complete: 29.9,
      actual_complete: 28.1,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-01-30",
      baseline_complete: 31.0,
      actual_complete: 30.4,
      forecast_complete: 14.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-02-06",
      baseline_complete: 32.1,
      actual_complete: 30.4,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-02-13",
      baseline_complete: 33.2,
      actual_complete: 30.4,
      forecast_complete: 15.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-02-20",
      baseline_complete: 34.3,
      actual_complete: 31.3,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-02-27",
      baseline_complete: 35.4,
      actual_complete: 33.8,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-03-06",
      baseline_complete: 36.6,
      actual_complete: 33.8,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-03-13",
      baseline_complete: 37.7,
      actual_complete: 33.8,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-03-20",
      baseline_complete: 38.9,
      actual_complete: 38.3,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-03-27",
      baseline_complete: 40.1,
      actual_complete: 38.3,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-04-03",
      baseline_complete: 41.3,
      actual_complete: 38.3,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-04-10",
      baseline_complete: 42.6,
      actual_complete: 43.2,
      forecast_complete: 21.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-04-17",
      baseline_complete: 43.8,
      actual_complete: 43.2,
      forecast_complete: 22.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-04-24",
      baseline_complete: 45.0,
      actual_complete: 43.2,
      forecast_complete: 23.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-05-01",
      baseline_complete: 46.3,
      actual_complete: 43.5,
      forecast_complete: 24.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-05-08",
      baseline_complete: 47.5,
      actual_complete: 45.7,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-05-15",
      baseline_complete: 48.8,
      actual_complete: 48.7,
      forecast_complete: 26.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-05-22",
      baseline_complete: 50.0,
      actual_complete: 49.5,
      forecast_complete: 27.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-05-29",
      baseline_complete: 51.3,
      actual_complete: 49.5,
      forecast_complete: 28.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-06-05",
      baseline_complete: 52.5,
      actual_complete: 50.3,
      forecast_complete: 28.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-06-12",
      baseline_complete: 53.8,
      actual_complete: 54.3,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-06-19",
      baseline_complete: 55.0,
      actual_complete: 54.3,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-06-26",
      baseline_complete: 56.3,
      actual_complete: 54.3,
      forecast_complete: 31.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-07-03",
      baseline_complete: 57.5,
      actual_complete: 57.5,
      forecast_complete: 32.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-07-10",
      baseline_complete: 58.7,
      actual_complete: 57.5,
      forecast_complete: 33.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-07-17",
      baseline_complete: 59.9,
      actual_complete: 57.5,
      forecast_complete: 34.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-07-24",
      baseline_complete: 61.1,
      actual_complete: 58.4,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-07-31",
      baseline_complete: 62.3,
      actual_complete: 58.4,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-08-07",
      baseline_complete: 63.5,
      actual_complete: 63.0,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-08-14",
      baseline_complete: 64.6,
      actual_complete: 64.9,
      forecast_complete: 38.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-08-21",
      baseline_complete: 65.8,
      actual_complete: 64.9,
      forecast_complete: 39.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-08-28",
      baseline_complete: 66.9,
      actual_complete: 65.5,
      forecast_complete: 40.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-09-04",
      baseline_complete: 68.0,
      actual_complete: 66.4,
      forecast_complete: 41.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-09-11",
      baseline_complete: 69.1,
      actual_complete: 68.3,
      forecast_complete: 42.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-09-18",
      baseline_complete: 70.1,
      actual_complete: 69.4,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-09-25",
      baseline_complete: 71.2,
      actual_complete: 69.4,
      forecast_complete: 43.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-10-02",
      baseline_complete: 72.2,
      actual_complete: 69.5,
      forecast_complete: 44.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-10-09",
      baseline_complete: 73.2,
      actual_complete: 73.3,
      forecast_complete: 45.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-10-16",
      baseline_complete: 74.1,
      actual_complete: 73.3,
      forecast_complete: 46.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-10-23",
      baseline_complete: 75.1,
      actual_complete: 73.3,
      forecast_complete: 47.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-10-30",
      baseline_complete: 76.0,
      actual_complete: 77.2,
      forecast_complete: 48.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-11-06",
      baseline_complete: 76.9,
      actual_complete: 77.2,
      forecast_complete: 49.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-11-13",
      baseline_complete: 77.8,
      actual_complete: 77.2,
      forecast_complete: 50.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-11-20",
      baseline_complete: 78.7,
      actual_complete: 77.2,
      forecast_complete: 51.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-11-27",
      baseline_complete: 79.5,
      actual_complete: 80.8,
      forecast_complete: 52.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-12-04",
      baseline_complete: 80.3,
      actual_complete: 80.8,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-12-11",
      baseline_complete: 81.1,
      actual_complete: 80.8,
      forecast_complete: 53.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-12-18",
      baseline_complete: 81.8,
      actual_complete: 80.8,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2026-12-25",
      baseline_complete: 82.6,
      actual_complete: 80.8,
      forecast_complete: 55.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-01-01",
      baseline_complete: 83.3,
      actual_complete: 83.4,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-01-08",
      baseline_complete: 84.0,
      actual_complete: 84.7,
      forecast_complete: 56.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-01-15",
      baseline_complete: 84.6,
      actual_complete: 85.1,
      forecast_complete: 57.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-01-22",
      baseline_complete: 85.3,
      actual_complete: 85.1,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-01-29",
      baseline_complete: 85.9,
      actual_complete: 86.1,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-02-05",
      baseline_complete: 86.5,
      actual_complete: 86.1,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-02-12",
      baseline_complete: 87.1,
      actual_complete: 88.6,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-02-19",
      baseline_complete: 87.6,
      actual_complete: 89.4,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-02-26",
      baseline_complete: 88.1,
      actual_complete: 89.4,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-03-05",
      baseline_complete: 88.7,
      actual_complete: 89.4,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-03-12",
      baseline_complete: 89.1,
      actual_complete: 91.3,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-03-19",
      baseline_complete: 89.6,
      actual_complete: 91.3,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-03-26",
      baseline_complete: 90.1,
      actual_complete: 91.3,
      forecast_complete: 65.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-04-02",
      baseline_complete: 90.5,
      actual_complete: 91.3,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-04-09",
      baseline_complete: 90.9,
      actual_complete: 91.3,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-04-16",
      baseline_complete: 91.3,
      actual_complete: 91.3,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-04-23",
      baseline_complete: 91.7,
      actual_complete: 91.6,
      forecast_complete: 67.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-04-30",
      baseline_complete: 92.1,
      actual_complete: 92.8,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-05-07",
      baseline_complete: 92.5,
      actual_complete: 93.3,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-05-14",
      baseline_complete: 92.8,
      actual_complete: 93.7,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-05-21",
      baseline_complete: 93.1,
      actual_complete: 93.7,
      forecast_complete: 71.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-05-28",
      baseline_complete: 93.4,
      actual_complete: 93.7,
      forecast_complete: 72.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-06-04",
      baseline_complete: 93.7,
      actual_complete: 93.7,
      forecast_complete: 73.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-06-11",
      baseline_complete: 94.0,
      actual_complete: 93.7,
      forecast_complete: 74.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-06-18",
      baseline_complete: 94.3,
      actual_complete: 93.7,
      forecast_complete: 75.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-06-25",
      baseline_complete: 94.6,
      actual_complete: 96.5,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-07-02",
      baseline_complete: 94.8,
      actual_complete: 96.5,
      forecast_complete: 77.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-07-09",
      baseline_complete: 95.1,
      actual_complete: 96.5,
      forecast_complete: 78.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-07-16",
      baseline_complete: 95.3,
      actual_complete: 96.5,
      forecast_complete: 79.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-07-23",
      baseline_complete: 95.5,
      actual_complete: 96.5,
      forecast_complete: 79.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-07-30",
      baseline_complete: 95.7,
      actual_complete: 96.5,
      forecast_complete: 80.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-08-06",
      baseline_complete: 95.9,
      actual_complete: 98.8,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-08-13",
      baseline_complete: 96.1,
      actual_complete: 98.8,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-08-20",
      baseline_complete: 96.3,
      actual_complete: 98.8,
      forecast_complete: 82.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-08-27",
      baseline_complete: 96.5,
      actual_complete: 98.8,
      forecast_complete: 83.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-09-03",
      baseline_complete: 96.6,
      actual_complete: 98.8,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-09-10",
      baseline_complete: 96.8,
      actual_complete: 98.8,
      forecast_complete: 84.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-09-17",
      baseline_complete: 97.0,
      actual_complete: 98.8,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-09-24",
      baseline_complete: 97.1,
      actual_complete: 98.8,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-10-01",
      baseline_complete: 97.2,
      actual_complete: 98.8,
      forecast_complete: 86.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-10-08",
      baseline_complete: 97.4,
      actual_complete: 98.8,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-10-15",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-10-22",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-10-29",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 89.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-11-05",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 89.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-11-12",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-11-19",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 90.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-11-26",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-12-03",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-12-10",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-12-17",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-12-24",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2027-12-31",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-01-07",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-01-14",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-01-21",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-01-28",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-02-04",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-02-11",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-02-18",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-02-25",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-03-03",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-03-10",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-03-17",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-03-24",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-03-31",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-04-07",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-04-14",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-04-21",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-04-28",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-05-05",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-05-12",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-05-19",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-05-26",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-06-02",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-06-09",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-06-16",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-06-23",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-06-30",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-07-07",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-07-14",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "7a4c9383-0cd2-6389-6f3d-5700c924382d",
      reporting_date: "2028-07-18",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
  ],
  "2fe72107-f6a5-b565-0a33-9c1dab8e9698": [
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-07-06",
      baseline_complete: 1.2,
      actual_complete: 5.4,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-07-13",
      baseline_complete: 1.3,
      actual_complete: 5.4,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-07-20",
      baseline_complete: 1.3,
      actual_complete: 5.4,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-07-27",
      baseline_complete: 1.4,
      actual_complete: 5.4,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-08-03",
      baseline_complete: 1.5,
      actual_complete: 5.4,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-08-10",
      baseline_complete: 1.6,
      actual_complete: 5.4,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-08-17",
      baseline_complete: 1.7,
      actual_complete: 6.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-08-24",
      baseline_complete: 1.7,
      actual_complete: 6.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-08-31",
      baseline_complete: 1.8,
      actual_complete: 6.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-09-07",
      baseline_complete: 2.0,
      actual_complete: 6.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-09-14",
      baseline_complete: 2.1,
      actual_complete: 6.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-09-21",
      baseline_complete: 2.2,
      actual_complete: 6.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-09-28",
      baseline_complete: 2.3,
      actual_complete: 6.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-10-05",
      baseline_complete: 2.4,
      actual_complete: 7.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-10-12",
      baseline_complete: 2.6,
      actual_complete: 7.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-10-19",
      baseline_complete: 2.7,
      actual_complete: 7.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-10-26",
      baseline_complete: 2.9,
      actual_complete: 7.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-11-02",
      baseline_complete: 3.0,
      actual_complete: 7.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-11-09",
      baseline_complete: 3.2,
      actual_complete: 7.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-11-16",
      baseline_complete: 3.4,
      actual_complete: 7.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-11-23",
      baseline_complete: 3.6,
      actual_complete: 8.3,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-11-30",
      baseline_complete: 3.8,
      actual_complete: 8.3,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-12-07",
      baseline_complete: 4.0,
      actual_complete: 8.3,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-12-14",
      baseline_complete: 4.2,
      actual_complete: 8.3,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-12-21",
      baseline_complete: 4.5,
      actual_complete: 8.3,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2023-12-28",
      baseline_complete: 4.7,
      actual_complete: 8.3,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-01-04",
      baseline_complete: 5.0,
      actual_complete: 9.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-01-11",
      baseline_complete: 5.2,
      actual_complete: 9.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-01-18",
      baseline_complete: 5.5,
      actual_complete: 9.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-01-25",
      baseline_complete: 5.8,
      actual_complete: 9.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-02-01",
      baseline_complete: 6.1,
      actual_complete: 9.9,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-02-08",
      baseline_complete: 6.5,
      actual_complete: 11.0,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-02-15",
      baseline_complete: 6.8,
      actual_complete: 11.0,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-02-22",
      baseline_complete: 7.2,
      actual_complete: 11.0,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-02-29",
      baseline_complete: 7.6,
      actual_complete: 11.0,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-03-07",
      baseline_complete: 8.0,
      actual_complete: 11.0,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-03-14",
      baseline_complete: 8.4,
      actual_complete: 11.9,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-03-21",
      baseline_complete: 8.9,
      actual_complete: 11.9,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-03-28",
      baseline_complete: 9.3,
      actual_complete: 11.9,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-04-04",
      baseline_complete: 9.8,
      actual_complete: 11.9,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-04-11",
      baseline_complete: 10.3,
      actual_complete: 11.9,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-04-18",
      baseline_complete: 10.9,
      actual_complete: 14.1,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-04-25",
      baseline_complete: 11.4,
      actual_complete: 14.1,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-05-02",
      baseline_complete: 12.0,
      actual_complete: 14.1,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-05-09",
      baseline_complete: 12.6,
      actual_complete: 14.1,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-05-16",
      baseline_complete: 13.3,
      actual_complete: 14.1,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-05-23",
      baseline_complete: 13.9,
      actual_complete: 15.9,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-05-30",
      baseline_complete: 14.6,
      actual_complete: 17.9,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-06-06",
      baseline_complete: 15.4,
      actual_complete: 19.3,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-06-13",
      baseline_complete: 16.1,
      actual_complete: 19.3,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-06-20",
      baseline_complete: 16.9,
      actual_complete: 19.5,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-06-27",
      baseline_complete: 17.7,
      actual_complete: 19.5,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-07-04",
      baseline_complete: 18.5,
      actual_complete: 19.5,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-07-11",
      baseline_complete: 19.4,
      actual_complete: 21.9,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-07-18",
      baseline_complete: 20.3,
      actual_complete: 21.9,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-07-25",
      baseline_complete: 21.2,
      actual_complete: 25.3,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-08-01",
      baseline_complete: 22.2,
      actual_complete: 26.7,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-08-08",
      baseline_complete: 23.2,
      actual_complete: 26.7,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-08-15",
      baseline_complete: 24.2,
      actual_complete: 26.7,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-08-22",
      baseline_complete: 25.3,
      actual_complete: 26.7,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-08-29",
      baseline_complete: 26.4,
      actual_complete: 27.4,
      forecast_complete: 16.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-09-05",
      baseline_complete: 27.5,
      actual_complete: 28.0,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-09-12",
      baseline_complete: 28.6,
      actual_complete: 29.9,
      forecast_complete: 17.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-09-19",
      baseline_complete: 29.8,
      actual_complete: 29.9,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-09-26",
      baseline_complete: 31.0,
      actual_complete: 33.0,
      forecast_complete: 18.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-10-03",
      baseline_complete: 32.2,
      actual_complete: 33.0,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-10-10",
      baseline_complete: 33.5,
      actual_complete: 37.8,
      forecast_complete: 19.4,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-10-17",
      baseline_complete: 34.7,
      actual_complete: 37.8,
      forecast_complete: 20.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-10-24",
      baseline_complete: 36.0,
      actual_complete: 40.3,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-10-31",
      baseline_complete: 37.4,
      actual_complete: 40.3,
      forecast_complete: 21.4,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-11-07",
      baseline_complete: 38.7,
      actual_complete: 42.3,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-11-14",
      baseline_complete: 40.0,
      actual_complete: 44.5,
      forecast_complete: 22.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-11-21",
      baseline_complete: 41.4,
      actual_complete: 44.5,
      forecast_complete: 23.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-11-28",
      baseline_complete: 42.8,
      actual_complete: 44.5,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-12-05",
      baseline_complete: 44.2,
      actual_complete: 46.9,
      forecast_complete: 25.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-12-12",
      baseline_complete: 45.6,
      actual_complete: 49.7,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-12-19",
      baseline_complete: 47.0,
      actual_complete: 49.7,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2024-12-26",
      baseline_complete: 48.4,
      actual_complete: 49.7,
      forecast_complete: 27.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-01-02",
      baseline_complete: 49.8,
      actual_complete: 51.2,
      forecast_complete: 28.4,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-01-09",
      baseline_complete: 51.2,
      actual_complete: 53.2,
      forecast_complete: 29.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-01-16",
      baseline_complete: 52.6,
      actual_complete: 53.2,
      forecast_complete: 30.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-01-23",
      baseline_complete: 54.1,
      actual_complete: 57.1,
      forecast_complete: 31.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-01-30",
      baseline_complete: 55.5,
      actual_complete: 57.1,
      forecast_complete: 32.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-02-06",
      baseline_complete: 56.8,
      actual_complete: 57.6,
      forecast_complete: 32.9,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-02-13",
      baseline_complete: 58.2,
      actual_complete: 59.5,
      forecast_complete: 33.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-02-20",
      baseline_complete: 59.6,
      actual_complete: 62.1,
      forecast_complete: 34.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-02-27",
      baseline_complete: 61.0,
      actual_complete: 62.1,
      forecast_complete: 35.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-03-06",
      baseline_complete: 62.3,
      actual_complete: 62.1,
      forecast_complete: 36.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-03-13",
      baseline_complete: 63.6,
      actual_complete: 65.7,
      forecast_complete: 37.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-03-20",
      baseline_complete: 64.9,
      actual_complete: 65.7,
      forecast_complete: 38.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-03-27",
      baseline_complete: 66.2,
      actual_complete: 69.2,
      forecast_complete: 39.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-04-03",
      baseline_complete: 67.5,
      actual_complete: 70.9,
      forecast_complete: 40.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-04-10",
      baseline_complete: 68.7,
      actual_complete: 71.7,
      forecast_complete: 41.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-04-17",
      baseline_complete: 69.9,
      actual_complete: 72.4,
      forecast_complete: 42.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-04-24",
      baseline_complete: 71.1,
      actual_complete: 72.4,
      forecast_complete: 43.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-05-01",
      baseline_complete: 72.2,
      actual_complete: 72.4,
      forecast_complete: 44.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-05-08",
      baseline_complete: 73.3,
      actual_complete: 78.1,
      forecast_complete: 45.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-05-15",
      baseline_complete: 74.4,
      actual_complete: 78.1,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-05-22",
      baseline_complete: 75.5,
      actual_complete: 78.1,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-05-29",
      baseline_complete: 76.5,
      actual_complete: 81.2,
      forecast_complete: 48.4,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-06-05",
      baseline_complete: 77.5,
      actual_complete: 81.2,
      forecast_complete: 49.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-06-12",
      baseline_complete: 78.5,
      actual_complete: 81.2,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-06-19",
      baseline_complete: 79.4,
      actual_complete: 83.2,
      forecast_complete: 51.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-06-26",
      baseline_complete: 80.3,
      actual_complete: 83.2,
      forecast_complete: 52.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-07-03",
      baseline_complete: 81.2,
      actual_complete: 83.2,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-07-10",
      baseline_complete: 82.1,
      actual_complete: 83.2,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-07-17",
      baseline_complete: 82.9,
      actual_complete: 86.4,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-07-24",
      baseline_complete: 83.7,
      actual_complete: 86.4,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-07-31",
      baseline_complete: 84.4,
      actual_complete: 86.4,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-08-07",
      baseline_complete: 85.2,
      actual_complete: 86.4,
      forecast_complete: 57.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-08-14",
      baseline_complete: 85.9,
      actual_complete: 86.9,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-08-21",
      baseline_complete: 86.5,
      actual_complete: 88.6,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-08-28",
      baseline_complete: 87.2,
      actual_complete: 88.6,
      forecast_complete: 60.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-09-04",
      baseline_complete: 87.8,
      actual_complete: 88.6,
      forecast_complete: 61.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-09-11",
      baseline_complete: 88.4,
      actual_complete: 88.6,
      forecast_complete: 61.9,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-09-18",
      baseline_complete: 89.0,
      actual_complete: 90.4,
      forecast_complete: 62.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-09-25",
      baseline_complete: 89.5,
      actual_complete: 90.4,
      forecast_complete: 63.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-10-02",
      baseline_complete: 90.0,
      actual_complete: 93.4,
      forecast_complete: 64.4,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-10-09",
      baseline_complete: 90.5,
      actual_complete: 93.4,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-10-16",
      baseline_complete: 91.0,
      actual_complete: 96.3,
      forecast_complete: 66.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-10-23",
      baseline_complete: 91.5,
      actual_complete: 96.3,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-10-30",
      baseline_complete: 91.9,
      actual_complete: 96.3,
      forecast_complete: 67.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-11-06",
      baseline_complete: 92.3,
      actual_complete: 96.4,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-11-13",
      baseline_complete: 92.7,
      actual_complete: 96.4,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-11-20",
      baseline_complete: 93.1,
      actual_complete: 96.4,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-11-27",
      baseline_complete: 93.4,
      actual_complete: 96.4,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-12-04",
      baseline_complete: 93.8,
      actual_complete: 96.4,
      forecast_complete: 71.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-12-11",
      baseline_complete: 94.1,
      actual_complete: 96.7,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-12-18",
      baseline_complete: 94.4,
      actual_complete: 96.7,
      forecast_complete: 72.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2025-12-25",
      baseline_complete: 94.7,
      actual_complete: 98.3,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-01-01",
      baseline_complete: 95.0,
      actual_complete: 98.3,
      forecast_complete: 74.1,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-01-08",
      baseline_complete: 95.2,
      actual_complete: 99.6,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-01-15",
      baseline_complete: 95.5,
      actual_complete: 99.6,
      forecast_complete: 75.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-01-22",
      baseline_complete: 95.7,
      actual_complete: 99.6,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-01-29",
      baseline_complete: 95.9,
      actual_complete: 100.0,
      forecast_complete: 76.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-02-05",
      baseline_complete: 96.2,
      actual_complete: 100.0,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-02-12",
      baseline_complete: 96.4,
      actual_complete: 100.0,
      forecast_complete: 79.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-02-19",
      baseline_complete: 96.6,
      actual_complete: 100.0,
      forecast_complete: 80.4,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-02-26",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 81.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-03-05",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-03-12",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-03-19",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-03-26",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-04-02",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 86.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-04-09",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 87.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-04-16",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-04-23",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-04-30",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-05-07",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-05-14",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-05-21",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-05-28",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-06-04",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-06-11",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-06-18",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-06-25",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-07-02",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-07-09",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-07-16",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-07-23",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-07-30",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-08-06",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-08-13",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-08-20",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-08-27",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-09-03",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-09-10",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-09-17",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-09-24",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-10-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-10-08",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-10-15",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-10-22",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-10-29",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-11-05",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-11-12",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-11-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-11-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-12-03",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fe72107-f6a5-b565-0a33-9c1dab8e9698",
      reporting_date: "2026-12-06",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "ef775035-e5e8-4cd1-d3d7-b72afff302ea": [
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-07-22",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-07-29",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-08-05",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-08-12",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-08-19",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-08-26",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-09-02",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-09-09",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-09-16",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-09-23",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-09-30",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-10-07",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-10-14",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-10-21",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-10-28",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-11-04",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-11-11",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-11-18",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-11-25",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-12-02",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-12-09",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-12-16",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-12-23",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2023-12-30",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-01-06",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-01-13",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-01-20",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-01-27",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-02-03",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-02-10",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-02-17",
      baseline_complete: 4.2,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-02-24",
      baseline_complete: 4.5,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-03-02",
      baseline_complete: 4.9,
      actual_complete: 0.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-03-09",
      baseline_complete: 5.3,
      actual_complete: 0.9,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-03-16",
      baseline_complete: 5.7,
      actual_complete: 0.9,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-03-23",
      baseline_complete: 6.1,
      actual_complete: 0.9,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-03-30",
      baseline_complete: 6.6,
      actual_complete: 0.9,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-04-06",
      baseline_complete: 7.2,
      actual_complete: 2.8,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-04-13",
      baseline_complete: 7.7,
      actual_complete: 2.8,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-04-20",
      baseline_complete: 8.3,
      actual_complete: 3.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-04-27",
      baseline_complete: 9.0,
      actual_complete: 4.5,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-05-04",
      baseline_complete: 9.7,
      actual_complete: 4.5,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-05-11",
      baseline_complete: 10.4,
      actual_complete: 5.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-05-18",
      baseline_complete: 11.2,
      actual_complete: 5.1,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-05-25",
      baseline_complete: 12.0,
      actual_complete: 7.6,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-06-01",
      baseline_complete: 12.9,
      actual_complete: 8.9,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-06-08",
      baseline_complete: 13.9,
      actual_complete: 9.0,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-06-15",
      baseline_complete: 14.9,
      actual_complete: 9.0,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-06-22",
      baseline_complete: 15.9,
      actual_complete: 12.4,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-06-29",
      baseline_complete: 17.1,
      actual_complete: 12.4,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-07-06",
      baseline_complete: 18.2,
      actual_complete: 16.1,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-07-13",
      baseline_complete: 19.5,
      actual_complete: 16.1,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-07-20",
      baseline_complete: 20.8,
      actual_complete: 17.8,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-07-27",
      baseline_complete: 22.2,
      actual_complete: 20.3,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-08-03",
      baseline_complete: 23.6,
      actual_complete: 21.4,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-08-10",
      baseline_complete: 25.1,
      actual_complete: 21.4,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-08-17",
      baseline_complete: 26.7,
      actual_complete: 22.9,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-08-24",
      baseline_complete: 28.3,
      actual_complete: 23.1,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-08-31",
      baseline_complete: 30.0,
      actual_complete: 24.0,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-09-07",
      baseline_complete: 31.8,
      actual_complete: 29.2,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-09-14",
      baseline_complete: 33.6,
      actual_complete: 32.0,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-09-21",
      baseline_complete: 35.4,
      actual_complete: 33.2,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-09-28",
      baseline_complete: 37.3,
      actual_complete: 33.2,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-10-05",
      baseline_complete: 39.2,
      actual_complete: 34.0,
      forecast_complete: 19.9,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-10-12",
      baseline_complete: 41.2,
      actual_complete: 36.5,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-10-19",
      baseline_complete: 43.2,
      actual_complete: 42.2,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-10-26",
      baseline_complete: 45.2,
      actual_complete: 43.7,
      forecast_complete: 24.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-11-02",
      baseline_complete: 47.2,
      actual_complete: 46.6,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-11-09",
      baseline_complete: 49.3,
      actual_complete: 47.8,
      forecast_complete: 26.9,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-11-16",
      baseline_complete: 51.3,
      actual_complete: 47.8,
      forecast_complete: 28.4,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-11-23",
      baseline_complete: 53.4,
      actual_complete: 51.3,
      forecast_complete: 29.9,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-11-30",
      baseline_complete: 55.4,
      actual_complete: 54.5,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-12-07",
      baseline_complete: 57.4,
      actual_complete: 55.9,
      forecast_complete: 33.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-12-14",
      baseline_complete: 59.4,
      actual_complete: 58.4,
      forecast_complete: 34.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-12-21",
      baseline_complete: 61.3,
      actual_complete: 58.4,
      forecast_complete: 36.2,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2024-12-28",
      baseline_complete: 63.3,
      actual_complete: 60.6,
      forecast_complete: 37.9,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-01-04",
      baseline_complete: 65.1,
      actual_complete: 61.2,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-01-11",
      baseline_complete: 67.0,
      actual_complete: 66.2,
      forecast_complete: 41.1,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-01-18",
      baseline_complete: 68.7,
      actual_complete: 66.2,
      forecast_complete: 42.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-01-25",
      baseline_complete: 70.5,
      actual_complete: 67.5,
      forecast_complete: 44.3,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-02-01",
      baseline_complete: 72.1,
      actual_complete: 70.0,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-02-08",
      baseline_complete: 73.8,
      actual_complete: 71.0,
      forecast_complete: 47.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-02-15",
      baseline_complete: 75.3,
      actual_complete: 76.3,
      forecast_complete: 49.1,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-02-22",
      baseline_complete: 76.8,
      actual_complete: 76.3,
      forecast_complete: 50.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-03-01",
      baseline_complete: 78.2,
      actual_complete: 76.3,
      forecast_complete: 52.2,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-03-08",
      baseline_complete: 79.6,
      actual_complete: 79.6,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-03-15",
      baseline_complete: 80.9,
      actual_complete: 79.6,
      forecast_complete: 55.3,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-03-22",
      baseline_complete: 82.1,
      actual_complete: 79.6,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-03-29",
      baseline_complete: 83.3,
      actual_complete: 80.6,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-04-05",
      baseline_complete: 84.4,
      actual_complete: 81.1,
      forecast_complete: 59.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-04-12",
      baseline_complete: 85.4,
      actual_complete: 83.7,
      forecast_complete: 61.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-04-19",
      baseline_complete: 86.4,
      actual_complete: 87.4,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-04-26",
      baseline_complete: 87.4,
      actual_complete: 89.2,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-05-03",
      baseline_complete: 88.2,
      actual_complete: 90.1,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-05-10",
      baseline_complete: 89.1,
      actual_complete: 90.1,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-05-17",
      baseline_complete: 89.8,
      actual_complete: 90.1,
      forecast_complete: 67.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-05-24",
      baseline_complete: 90.5,
      actual_complete: 90.1,
      forecast_complete: 69.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-05-31",
      baseline_complete: 91.2,
      actual_complete: 92.5,
      forecast_complete: 71.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-06-07",
      baseline_complete: 91.9,
      actual_complete: 93.6,
      forecast_complete: 73.9,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-06-14",
      baseline_complete: 92.4,
      actual_complete: 93.6,
      forecast_complete: 75.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-06-21",
      baseline_complete: 93.0,
      actual_complete: 93.6,
      forecast_complete: 77.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-06-28",
      baseline_complete: 93.5,
      actual_complete: 93.8,
      forecast_complete: 79.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-07-05",
      baseline_complete: 94.0,
      actual_complete: 93.8,
      forecast_complete: 81.2,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-07-12",
      baseline_complete: 94.4,
      actual_complete: 94.8,
      forecast_complete: 82.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-07-19",
      baseline_complete: 94.8,
      actual_complete: 96.2,
      forecast_complete: 84.3,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-07-26",
      baseline_complete: 95.2,
      actual_complete: 97.0,
      forecast_complete: 85.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-08-02",
      baseline_complete: 95.6,
      actual_complete: 97.0,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-08-09",
      baseline_complete: 95.9,
      actual_complete: 97.0,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-08-16",
      baseline_complete: 96.2,
      actual_complete: 97.0,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-08-23",
      baseline_complete: 96.5,
      actual_complete: 97.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-08-30",
      baseline_complete: 96.8,
      actual_complete: 98.9,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-09-06",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-09-13",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-09-20",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-09-27",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-10-04",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-10-11",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-10-18",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-10-25",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-11-01",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-11-08",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-11-15",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-11-22",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-11-29",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-12-06",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-12-13",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-12-20",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ef775035-e5e8-4cd1-d3d7-b72afff302ea",
      reporting_date: "2025-12-22",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a": [
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-06-16",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-06-23",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-06-30",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-07-07",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-07-14",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-07-21",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-07-28",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-08-04",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-08-11",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-08-18",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-08-25",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-09-01",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-09-08",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-09-15",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-09-22",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-09-29",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-10-06",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-10-13",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-10-20",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-10-27",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-11-03",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-11-10",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-11-17",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-11-24",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-12-01",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-12-08",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-12-15",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-12-22",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2024-12-29",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-01-05",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-01-12",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-01-19",
      baseline_complete: 3.8,
      actual_complete: 0.0,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-01-26",
      baseline_complete: 4.2,
      actual_complete: 0.0,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-02-02",
      baseline_complete: 4.7,
      actual_complete: 0.6,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-02-09",
      baseline_complete: 5.2,
      actual_complete: 0.6,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-02-16",
      baseline_complete: 5.7,
      actual_complete: 0.6,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-02-23",
      baseline_complete: 6.3,
      actual_complete: 2.3,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-03-02",
      baseline_complete: 6.9,
      actual_complete: 2.3,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-03-09",
      baseline_complete: 7.6,
      actual_complete: 2.3,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-03-16",
      baseline_complete: 8.3,
      actual_complete: 2.3,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-03-23",
      baseline_complete: 9.1,
      actual_complete: 2.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-03-30",
      baseline_complete: 10.0,
      actual_complete: 6.7,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-04-06",
      baseline_complete: 11.0,
      actual_complete: 6.7,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-04-13",
      baseline_complete: 12.0,
      actual_complete: 6.7,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-04-20",
      baseline_complete: 13.1,
      actual_complete: 7.4,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-04-27",
      baseline_complete: 14.3,
      actual_complete: 9.9,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-05-04",
      baseline_complete: 15.7,
      actual_complete: 9.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-05-11",
      baseline_complete: 17.0,
      actual_complete: 13.6,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-05-18",
      baseline_complete: 18.5,
      actual_complete: 13.6,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-05-25",
      baseline_complete: 20.1,
      actual_complete: 14.6,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-06-01",
      baseline_complete: 21.8,
      actual_complete: 15.5,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-06-08",
      baseline_complete: 23.6,
      actual_complete: 19.4,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-06-15",
      baseline_complete: 25.5,
      actual_complete: 19.4,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-06-22",
      baseline_complete: 27.5,
      actual_complete: 23.4,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-06-29",
      baseline_complete: 29.6,
      actual_complete: 25.6,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-07-06",
      baseline_complete: 31.8,
      actual_complete: 29.6,
      forecast_complete: 16.9,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-07-13",
      baseline_complete: 34.0,
      actual_complete: 29.6,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-07-20",
      baseline_complete: 36.4,
      actual_complete: 30.4,
      forecast_complete: 19.4,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-07-27",
      baseline_complete: 38.8,
      actual_complete: 33.0,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-08-03",
      baseline_complete: 41.2,
      actual_complete: 38.2,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-08-10",
      baseline_complete: 43.7,
      actual_complete: 39.2,
      forecast_complete: 23.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-08-17",
      baseline_complete: 46.2,
      actual_complete: 44.5,
      forecast_complete: 25.1,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-08-24",
      baseline_complete: 48.8,
      actual_complete: 44.5,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-08-31",
      baseline_complete: 51.3,
      actual_complete: 48.2,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-09-07",
      baseline_complete: 53.9,
      actual_complete: 50.3,
      forecast_complete: 29.9,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-09-14",
      baseline_complete: 56.4,
      actual_complete: 50.3,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-09-21",
      baseline_complete: 58.9,
      actual_complete: 53.1,
      forecast_complete: 33.2,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-09-28",
      baseline_complete: 61.4,
      actual_complete: 60.0,
      forecast_complete: 35.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-10-05",
      baseline_complete: 63.8,
      actual_complete: 60.0,
      forecast_complete: 36.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-10-12",
      baseline_complete: 66.1,
      actual_complete: 60.6,
      forecast_complete: 38.4,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-10-19",
      baseline_complete: 68.3,
      actual_complete: 63.7,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-10-26",
      baseline_complete: 70.5,
      actual_complete: 69.6,
      forecast_complete: 41.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-11-02",
      baseline_complete: 72.6,
      actual_complete: 70.3,
      forecast_complete: 43.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-11-09",
      baseline_complete: 74.6,
      actual_complete: 71.5,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-11-16",
      baseline_complete: 76.5,
      actual_complete: 75.2,
      forecast_complete: 46.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-11-23",
      baseline_complete: 78.2,
      actual_complete: 76.6,
      forecast_complete: 48.3,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-11-30",
      baseline_complete: 79.9,
      actual_complete: 77.5,
      forecast_complete: 49.9,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-12-07",
      baseline_complete: 81.5,
      actual_complete: 78.6,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-12-14",
      baseline_complete: 83.0,
      actual_complete: 81.4,
      forecast_complete: 53.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-12-21",
      baseline_complete: 84.4,
      actual_complete: 81.6,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2025-12-28",
      baseline_complete: 85.7,
      actual_complete: 81.7,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-01-04",
      baseline_complete: 86.9,
      actual_complete: 85.4,
      forecast_complete: 57.3,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-01-11",
      baseline_complete: 88.0,
      actual_complete: 86.5,
      forecast_complete: 58.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-01-18",
      baseline_complete: 89.1,
      actual_complete: 88.3,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-01-25",
      baseline_complete: 90.0,
      actual_complete: 88.3,
      forecast_complete: 61.3,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-02-01",
      baseline_complete: 90.9,
      actual_complete: 89.9,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-02-08",
      baseline_complete: 91.7,
      actual_complete: 91.2,
      forecast_complete: 63.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-02-15",
      baseline_complete: 92.5,
      actual_complete: 91.2,
      forecast_complete: 65.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-02-22",
      baseline_complete: 93.1,
      actual_complete: 91.2,
      forecast_complete: 66.1,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-03-01",
      baseline_complete: 93.8,
      actual_complete: 91.2,
      forecast_complete: 67.3,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-03-08",
      baseline_complete: 94.3,
      actual_complete: 92.4,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-03-15",
      baseline_complete: 94.9,
      actual_complete: 92.4,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-03-22",
      baseline_complete: 95.3,
      actual_complete: 92.4,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-03-29",
      baseline_complete: 95.8,
      actual_complete: 96.7,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-04-05",
      baseline_complete: 96.2,
      actual_complete: 96.7,
      forecast_complete: 72.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-04-12",
      baseline_complete: 96.5,
      actual_complete: 96.7,
      forecast_complete: 73.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-04-19",
      baseline_complete: 96.9,
      actual_complete: 96.7,
      forecast_complete: 74.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-04-26",
      baseline_complete: 97.2,
      actual_complete: 96.7,
      forecast_complete: 75.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-05-03",
      baseline_complete: 97.4,
      actual_complete: 99.0,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-05-10",
      baseline_complete: 97.7,
      actual_complete: 99.0,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-05-17",
      baseline_complete: 97.9,
      actual_complete: 99.0,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-05-24",
      baseline_complete: 98.1,
      actual_complete: 99.4,
      forecast_complete: 81.2,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-05-31",
      baseline_complete: 98.3,
      actual_complete: 99.4,
      forecast_complete: 82.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-06-07",
      baseline_complete: 98.4,
      actual_complete: 99.4,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-06-14",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-06-21",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-06-28",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-07-05",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-07-12",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 90.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-07-19",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-07-26",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-08-02",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-08-09",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-08-16",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-08-23",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-08-30",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-09-06",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-09-13",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-09-20",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-09-27",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-10-04",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-10-11",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-10-18",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-10-25",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-11-01",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-11-08",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-11-15",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-11-22",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-11-29",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-12-06",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-12-13",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5e004ad4-bcda-b3d0-4c7b-9dbd441d592a",
      reporting_date: "2026-12-16",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "fb73b9f0-5a4b-2f78-0713-926f532addf8": [
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-02-12",
      baseline_complete: 0.2,
      actual_complete: 1.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-02-19",
      baseline_complete: 0.3,
      actual_complete: 4.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-02-26",
      baseline_complete: 0.3,
      actual_complete: 4.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-03-05",
      baseline_complete: 0.3,
      actual_complete: 4.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-03-12",
      baseline_complete: 0.4,
      actual_complete: 4.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-03-19",
      baseline_complete: 0.4,
      actual_complete: 4.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-03-26",
      baseline_complete: 0.5,
      actual_complete: 4.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-04-02",
      baseline_complete: 0.5,
      actual_complete: 4.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-04-09",
      baseline_complete: 0.6,
      actual_complete: 4.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-04-16",
      baseline_complete: 0.6,
      actual_complete: 4.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-04-23",
      baseline_complete: 0.7,
      actual_complete: 4.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-04-30",
      baseline_complete: 0.7,
      actual_complete: 4.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-05-07",
      baseline_complete: 0.8,
      actual_complete: 4.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-05-14",
      baseline_complete: 0.9,
      actual_complete: 4.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-05-21",
      baseline_complete: 1.0,
      actual_complete: 4.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-05-28",
      baseline_complete: 1.1,
      actual_complete: 4.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-06-04",
      baseline_complete: 1.2,
      actual_complete: 4.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-06-11",
      baseline_complete: 1.3,
      actual_complete: 5.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-06-18",
      baseline_complete: 1.5,
      actual_complete: 5.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-06-25",
      baseline_complete: 1.6,
      actual_complete: 5.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-07-02",
      baseline_complete: 1.8,
      actual_complete: 5.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-07-09",
      baseline_complete: 2.0,
      actual_complete: 5.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-07-16",
      baseline_complete: 2.2,
      actual_complete: 5.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-07-23",
      baseline_complete: 2.4,
      actual_complete: 5.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-07-30",
      baseline_complete: 2.7,
      actual_complete: 5.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-08-06",
      baseline_complete: 2.9,
      actual_complete: 5.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-08-13",
      baseline_complete: 3.2,
      actual_complete: 6.4,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-08-20",
      baseline_complete: 3.6,
      actual_complete: 6.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-08-27",
      baseline_complete: 3.9,
      actual_complete: 6.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-09-03",
      baseline_complete: 4.3,
      actual_complete: 6.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-09-10",
      baseline_complete: 4.8,
      actual_complete: 6.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-09-17",
      baseline_complete: 5.2,
      actual_complete: 7.2,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-09-24",
      baseline_complete: 5.8,
      actual_complete: 7.7,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-10-01",
      baseline_complete: 6.3,
      actual_complete: 10.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-10-08",
      baseline_complete: 7.0,
      actual_complete: 10.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-10-15",
      baseline_complete: 7.6,
      actual_complete: 10.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-10-22",
      baseline_complete: 8.4,
      actual_complete: 10.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-10-29",
      baseline_complete: 9.2,
      actual_complete: 10.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-11-05",
      baseline_complete: 10.0,
      actual_complete: 11.5,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-11-12",
      baseline_complete: 11.0,
      actual_complete: 14.9,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-11-19",
      baseline_complete: 12.0,
      actual_complete: 14.9,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-11-26",
      baseline_complete: 13.1,
      actual_complete: 14.9,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-12-03",
      baseline_complete: 14.3,
      actual_complete: 17.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-12-10",
      baseline_complete: 15.5,
      actual_complete: 17.2,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-12-17",
      baseline_complete: 16.9,
      actual_complete: 20.3,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-12-24",
      baseline_complete: 18.4,
      actual_complete: 20.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2023-12-31",
      baseline_complete: 19.9,
      actual_complete: 22.9,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-01-07",
      baseline_complete: 21.6,
      actual_complete: 23.6,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-01-14",
      baseline_complete: 23.3,
      actual_complete: 25.0,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-01-21",
      baseline_complete: 25.1,
      actual_complete: 27.6,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-01-28",
      baseline_complete: 27.1,
      actual_complete: 27.6,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-02-04",
      baseline_complete: 29.1,
      actual_complete: 31.6,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-02-11",
      baseline_complete: 31.2,
      actual_complete: 32.4,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-02-18",
      baseline_complete: 33.4,
      actual_complete: 35.3,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-02-25",
      baseline_complete: 35.6,
      actual_complete: 37.3,
      forecast_complete: 17.1,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-03-03",
      baseline_complete: 38.0,
      actual_complete: 38.2,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-03-10",
      baseline_complete: 40.4,
      actual_complete: 42.3,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-03-17",
      baseline_complete: 42.8,
      actual_complete: 44.8,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-03-24",
      baseline_complete: 45.3,
      actual_complete: 48.4,
      forecast_complete: 23.7,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-03-31",
      baseline_complete: 47.8,
      actual_complete: 48.4,
      forecast_complete: 25.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-04-07",
      baseline_complete: 50.3,
      actual_complete: 50.2,
      forecast_complete: 27.4,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-04-14",
      baseline_complete: 52.8,
      actual_complete: 52.0,
      forecast_complete: 29.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-04-21",
      baseline_complete: 55.2,
      actual_complete: 56.8,
      forecast_complete: 31.2,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-04-28",
      baseline_complete: 57.7,
      actual_complete: 58.0,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-05-05",
      baseline_complete: 60.1,
      actual_complete: 61.9,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-05-12",
      baseline_complete: 62.5,
      actual_complete: 65.8,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-05-19",
      baseline_complete: 64.8,
      actual_complete: 66.9,
      forecast_complete: 39.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-05-26",
      baseline_complete: 67.1,
      actual_complete: 67.2,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-06-02",
      baseline_complete: 69.2,
      actual_complete: 71.7,
      forecast_complete: 43.4,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-06-09",
      baseline_complete: 71.3,
      actual_complete: 74.6,
      forecast_complete: 45.4,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-06-16",
      baseline_complete: 73.3,
      actual_complete: 74.7,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-06-23",
      baseline_complete: 75.2,
      actual_complete: 78.1,
      forecast_complete: 49.4,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-06-30",
      baseline_complete: 77.1,
      actual_complete: 79.5,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-07-07",
      baseline_complete: 78.8,
      actual_complete: 80.9,
      forecast_complete: 53.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-07-14",
      baseline_complete: 80.4,
      actual_complete: 84.5,
      forecast_complete: 55.1,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-07-21",
      baseline_complete: 81.9,
      actual_complete: 85.2,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-07-28",
      baseline_complete: 83.4,
      actual_complete: 87.6,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-08-04",
      baseline_complete: 84.7,
      actual_complete: 87.6,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-08-11",
      baseline_complete: 86.0,
      actual_complete: 87.6,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-08-18",
      baseline_complete: 87.1,
      actual_complete: 88.4,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-08-25",
      baseline_complete: 88.2,
      actual_complete: 89.6,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-09-01",
      baseline_complete: 89.2,
      actual_complete: 93.2,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-09-08",
      baseline_complete: 90.1,
      actual_complete: 93.2,
      forecast_complete: 72.4,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-09-15",
      baseline_complete: 91.0,
      actual_complete: 93.2,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-09-22",
      baseline_complete: 91.8,
      actual_complete: 95.8,
      forecast_complete: 77.0,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-09-29",
      baseline_complete: 92.5,
      actual_complete: 95.8,
      forecast_complete: 79.1,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-10-06",
      baseline_complete: 93.2,
      actual_complete: 95.8,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-10-13",
      baseline_complete: 93.8,
      actual_complete: 95.9,
      forecast_complete: 82.9,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-10-20",
      baseline_complete: 94.3,
      actual_complete: 96.1,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-10-27",
      baseline_complete: 94.9,
      actual_complete: 96.1,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-11-03",
      baseline_complete: 95.3,
      actual_complete: 97.8,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-11-10",
      baseline_complete: 95.7,
      actual_complete: 99.1,
      forecast_complete: 89.0,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-11-17",
      baseline_complete: 96.1,
      actual_complete: 99.1,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-11-24",
      baseline_complete: 96.5,
      actual_complete: 99.1,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-12-01",
      baseline_complete: 96.8,
      actual_complete: 99.1,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-12-08",
      baseline_complete: 97.1,
      actual_complete: 99.1,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-12-15",
      baseline_complete: 97.4,
      actual_complete: 99.1,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-12-22",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2024-12-29",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2025-01-05",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2025-01-12",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2025-01-19",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2025-01-26",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2025-02-02",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2025-02-09",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "fb73b9f0-5a4b-2f78-0713-926f532addf8",
      reporting_date: "2025-02-12",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
  ],
  "5dda0566-a704-da77-02b9-06d6be0ecaa1": [
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-05-11",
      baseline_complete: 1.7,
      actual_complete: 2.0,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-05-18",
      baseline_complete: 1.8,
      actual_complete: 2.0,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-05-25",
      baseline_complete: 1.9,
      actual_complete: 2.5,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-06-01",
      baseline_complete: 2.0,
      actual_complete: 3.4,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-06-08",
      baseline_complete: 2.2,
      actual_complete: 3.4,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-06-15",
      baseline_complete: 2.3,
      actual_complete: 3.4,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-06-22",
      baseline_complete: 2.4,
      actual_complete: 3.4,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-06-29",
      baseline_complete: 2.5,
      actual_complete: 3.7,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-07-06",
      baseline_complete: 2.7,
      actual_complete: 3.7,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-07-13",
      baseline_complete: 2.8,
      actual_complete: 3.8,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-07-20",
      baseline_complete: 3.0,
      actual_complete: 4.4,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-07-27",
      baseline_complete: 3.2,
      actual_complete: 4.4,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-08-03",
      baseline_complete: 3.3,
      actual_complete: 4.4,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-08-10",
      baseline_complete: 3.5,
      actual_complete: 4.4,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-08-17",
      baseline_complete: 3.7,
      actual_complete: 4.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-08-24",
      baseline_complete: 3.9,
      actual_complete: 4.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-08-31",
      baseline_complete: 4.1,
      actual_complete: 4.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-09-07",
      baseline_complete: 4.4,
      actual_complete: 4.4,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-09-14",
      baseline_complete: 4.6,
      actual_complete: 4.4,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-09-21",
      baseline_complete: 4.9,
      actual_complete: 4.4,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-09-28",
      baseline_complete: 5.1,
      actual_complete: 4.4,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-10-05",
      baseline_complete: 5.4,
      actual_complete: 5.7,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-10-12",
      baseline_complete: 5.7,
      actual_complete: 5.7,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-10-19",
      baseline_complete: 6.0,
      actual_complete: 5.7,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-10-26",
      baseline_complete: 6.3,
      actual_complete: 7.3,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-11-02",
      baseline_complete: 6.7,
      actual_complete: 8.3,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-11-09",
      baseline_complete: 7.0,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-11-16",
      baseline_complete: 7.4,
      actual_complete: 8.3,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-11-23",
      baseline_complete: 7.8,
      actual_complete: 8.3,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-11-30",
      baseline_complete: 8.2,
      actual_complete: 8.3,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-12-07",
      baseline_complete: 8.7,
      actual_complete: 8.7,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-12-14",
      baseline_complete: 9.1,
      actual_complete: 8.9,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-12-21",
      baseline_complete: 9.6,
      actual_complete: 9.1,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2025-12-28",
      baseline_complete: 10.1,
      actual_complete: 11.4,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-01-04",
      baseline_complete: 10.6,
      actual_complete: 12.3,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-01-11",
      baseline_complete: 11.1,
      actual_complete: 12.3,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-01-18",
      baseline_complete: 11.7,
      actual_complete: 13.3,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-01-25",
      baseline_complete: 12.3,
      actual_complete: 14.0,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-02-01",
      baseline_complete: 12.9,
      actual_complete: 14.6,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-02-08",
      baseline_complete: 13.6,
      actual_complete: 14.6,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-02-15",
      baseline_complete: 14.2,
      actual_complete: 15.4,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-02-22",
      baseline_complete: 14.9,
      actual_complete: 15.4,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-03-01",
      baseline_complete: 15.7,
      actual_complete: 16.1,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-03-08",
      baseline_complete: 16.4,
      actual_complete: 17.1,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-03-15",
      baseline_complete: 17.2,
      actual_complete: 18.7,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-03-22",
      baseline_complete: 18.0,
      actual_complete: 19.0,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-03-29",
      baseline_complete: 18.9,
      actual_complete: 20.8,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-04-05",
      baseline_complete: 19.7,
      actual_complete: 20.8,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-04-12",
      baseline_complete: 20.6,
      actual_complete: 20.8,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-04-19",
      baseline_complete: 21.6,
      actual_complete: 23.8,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-04-26",
      baseline_complete: 22.5,
      actual_complete: 23.8,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-05-03",
      baseline_complete: 23.5,
      actual_complete: 23.8,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-05-10",
      baseline_complete: 24.5,
      actual_complete: 23.8,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-05-17",
      baseline_complete: 25.6,
      actual_complete: 24.8,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-05-24",
      baseline_complete: 26.7,
      actual_complete: 27.3,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-05-31",
      baseline_complete: 27.8,
      actual_complete: 28.6,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-06-07",
      baseline_complete: 28.9,
      actual_complete: 31.1,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-06-14",
      baseline_complete: 30.1,
      actual_complete: 31.2,
      forecast_complete: 15.9,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-06-21",
      baseline_complete: 31.3,
      actual_complete: 31.6,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-06-28",
      baseline_complete: 32.5,
      actual_complete: 31.6,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-07-05",
      baseline_complete: 33.8,
      actual_complete: 35.8,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-07-12",
      baseline_complete: 35.0,
      actual_complete: 36.3,
      forecast_complete: 18.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-07-19",
      baseline_complete: 36.3,
      actual_complete: 37.8,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-07-26",
      baseline_complete: 37.6,
      actual_complete: 39.6,
      forecast_complete: 20.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-08-02",
      baseline_complete: 38.9,
      actual_complete: 39.6,
      forecast_complete: 20.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-08-09",
      baseline_complete: 40.3,
      actual_complete: 41.1,
      forecast_complete: 21.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-08-16",
      baseline_complete: 41.6,
      actual_complete: 42.8,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-08-23",
      baseline_complete: 43.0,
      actual_complete: 43.3,
      forecast_complete: 23.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-08-30",
      baseline_complete: 44.4,
      actual_complete: 46.0,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-09-06",
      baseline_complete: 45.8,
      actual_complete: 46.6,
      forecast_complete: 25.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-09-13",
      baseline_complete: 47.2,
      actual_complete: 47.2,
      forecast_complete: 26.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-09-20",
      baseline_complete: 48.6,
      actual_complete: 49.7,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-09-27",
      baseline_complete: 50.0,
      actual_complete: 52.0,
      forecast_complete: 28.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-10-04",
      baseline_complete: 51.4,
      actual_complete: 52.0,
      forecast_complete: 29.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-10-11",
      baseline_complete: 52.8,
      actual_complete: 54.6,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-10-18",
      baseline_complete: 54.2,
      actual_complete: 55.0,
      forecast_complete: 31.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-10-25",
      baseline_complete: 55.5,
      actual_complete: 57.0,
      forecast_complete: 32.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-11-01",
      baseline_complete: 56.9,
      actual_complete: 57.5,
      forecast_complete: 33.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-11-08",
      baseline_complete: 58.3,
      actual_complete: 58.6,
      forecast_complete: 34.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-11-15",
      baseline_complete: 59.6,
      actual_complete: 58.6,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-11-22",
      baseline_complete: 61.0,
      actual_complete: 61.6,
      forecast_complete: 36.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-11-29",
      baseline_complete: 62.3,
      actual_complete: 61.6,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-12-06",
      baseline_complete: 63.6,
      actual_complete: 64.7,
      forecast_complete: 38.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-12-13",
      baseline_complete: 64.9,
      actual_complete: 64.7,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-12-20",
      baseline_complete: 66.2,
      actual_complete: 65.7,
      forecast_complete: 40.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2026-12-27",
      baseline_complete: 67.4,
      actual_complete: 69.4,
      forecast_complete: 41.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-01-03",
      baseline_complete: 68.6,
      actual_complete: 69.4,
      forecast_complete: 42.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-01-10",
      baseline_complete: 69.8,
      actual_complete: 71.7,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-01-17",
      baseline_complete: 71.0,
      actual_complete: 71.7,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-01-24",
      baseline_complete: 72.1,
      actual_complete: 73.8,
      forecast_complete: 46.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-01-31",
      baseline_complete: 73.3,
      actual_complete: 73.8,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-02-07",
      baseline_complete: 74.3,
      actual_complete: 74.4,
      forecast_complete: 48.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-02-14",
      baseline_complete: 75.4,
      actual_complete: 77.6,
      forecast_complete: 49.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-02-21",
      baseline_complete: 76.4,
      actual_complete: 77.6,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-02-28",
      baseline_complete: 77.4,
      actual_complete: 77.6,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-03-07",
      baseline_complete: 78.4,
      actual_complete: 80.8,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-03-14",
      baseline_complete: 79.3,
      actual_complete: 81.8,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-03-21",
      baseline_complete: 80.2,
      actual_complete: 81.8,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-03-28",
      baseline_complete: 81.1,
      actual_complete: 82.3,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-04-04",
      baseline_complete: 81.9,
      actual_complete: 83.1,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-04-11",
      baseline_complete: 82.7,
      actual_complete: 85.1,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-04-18",
      baseline_complete: 83.5,
      actual_complete: 85.1,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-04-25",
      baseline_complete: 84.3,
      actual_complete: 85.1,
      forecast_complete: 60.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-05-02",
      baseline_complete: 85.0,
      actual_complete: 85.1,
      forecast_complete: 61.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-05-09",
      baseline_complete: 85.7,
      actual_complete: 87.8,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-05-16",
      baseline_complete: 86.4,
      actual_complete: 89.3,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-05-23",
      baseline_complete: 87.0,
      actual_complete: 89.3,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-05-30",
      baseline_complete: 87.7,
      actual_complete: 89.3,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-06-06",
      baseline_complete: 88.3,
      actual_complete: 89.3,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-06-13",
      baseline_complete: 88.8,
      actual_complete: 91.6,
      forecast_complete: 67.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-06-20",
      baseline_complete: 89.4,
      actual_complete: 91.6,
      forecast_complete: 68.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-06-27",
      baseline_complete: 89.9,
      actual_complete: 91.6,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-07-04",
      baseline_complete: 90.4,
      actual_complete: 91.6,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-07-11",
      baseline_complete: 90.9,
      actual_complete: 91.6,
      forecast_complete: 71.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-07-18",
      baseline_complete: 91.3,
      actual_complete: 94.3,
      forecast_complete: 71.9,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-07-25",
      baseline_complete: 91.8,
      actual_complete: 94.3,
      forecast_complete: 73.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-08-01",
      baseline_complete: 92.2,
      actual_complete: 95.1,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-08-08",
      baseline_complete: 92.6,
      actual_complete: 95.1,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-08-15",
      baseline_complete: 92.9,
      actual_complete: 95.1,
      forecast_complete: 77.9,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-08-22",
      baseline_complete: 93.3,
      actual_complete: 95.4,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-08-29",
      baseline_complete: 93.6,
      actual_complete: 95.4,
      forecast_complete: 80.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-09-05",
      baseline_complete: 94.0,
      actual_complete: 95.4,
      forecast_complete: 82.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-09-12",
      baseline_complete: 94.3,
      actual_complete: 95.4,
      forecast_complete: 83.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-09-19",
      baseline_complete: 94.6,
      actual_complete: 95.9,
      forecast_complete: 84.9,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-09-26",
      baseline_complete: 94.9,
      actual_complete: 97.0,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-10-03",
      baseline_complete: 95.1,
      actual_complete: 97.8,
      forecast_complete: 87.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-10-10",
      baseline_complete: 95.4,
      actual_complete: 97.8,
      forecast_complete: 88.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-10-17",
      baseline_complete: 95.6,
      actual_complete: 97.8,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-10-24",
      baseline_complete: 95.8,
      actual_complete: 97.8,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-10-31",
      baseline_complete: 96.1,
      actual_complete: 97.8,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-11-07",
      baseline_complete: 96.3,
      actual_complete: 97.8,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-11-14",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-11-21",
      baseline_complete: 96.6,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-11-28",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-12-05",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-12-12",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-12-19",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2027-12-26",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-01-02",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-01-09",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-01-16",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-01-23",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-01-30",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-02-06",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-02-13",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-02-20",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-02-27",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-03-05",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-03-12",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-03-19",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-03-26",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-04-02",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-04-09",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "5dda0566-a704-da77-02b9-06d6be0ecaa1",
      reporting_date: "2028-04-11",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "93ceaf79-3504-618b-3caa-148553fc5ade": [
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-02-27",
      baseline_complete: 0.2,
      actual_complete: 5.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-03-05",
      baseline_complete: 0.2,
      actual_complete: 6.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-03-12",
      baseline_complete: 0.2,
      actual_complete: 6.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-03-19",
      baseline_complete: 0.3,
      actual_complete: 6.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-03-26",
      baseline_complete: 0.3,
      actual_complete: 6.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-04-02",
      baseline_complete: 0.3,
      actual_complete: 6.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-04-09",
      baseline_complete: 0.3,
      actual_complete: 6.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-04-16",
      baseline_complete: 0.3,
      actual_complete: 6.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-04-23",
      baseline_complete: 0.3,
      actual_complete: 6.5,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-04-30",
      baseline_complete: 0.3,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-05-07",
      baseline_complete: 0.4,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-05-14",
      baseline_complete: 0.4,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-05-21",
      baseline_complete: 0.4,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-05-28",
      baseline_complete: 0.4,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-06-04",
      baseline_complete: 0.4,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-06-11",
      baseline_complete: 0.4,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-06-18",
      baseline_complete: 0.5,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-06-25",
      baseline_complete: 0.5,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-07-02",
      baseline_complete: 0.5,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-07-09",
      baseline_complete: 0.5,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-07-16",
      baseline_complete: 0.6,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-07-23",
      baseline_complete: 0.6,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-07-30",
      baseline_complete: 0.6,
      actual_complete: 7.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-08-06",
      baseline_complete: 0.6,
      actual_complete: 8.1,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-08-13",
      baseline_complete: 0.7,
      actual_complete: 8.1,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-08-20",
      baseline_complete: 0.7,
      actual_complete: 8.1,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-08-27",
      baseline_complete: 0.7,
      actual_complete: 8.1,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-09-03",
      baseline_complete: 0.8,
      actual_complete: 8.1,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-09-10",
      baseline_complete: 0.8,
      actual_complete: 8.1,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-09-17",
      baseline_complete: 0.8,
      actual_complete: 8.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-09-24",
      baseline_complete: 0.9,
      actual_complete: 8.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-10-01",
      baseline_complete: 0.9,
      actual_complete: 8.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-10-08",
      baseline_complete: 1.0,
      actual_complete: 8.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-10-15",
      baseline_complete: 1.0,
      actual_complete: 8.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-10-22",
      baseline_complete: 1.0,
      actual_complete: 8.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-10-29",
      baseline_complete: 1.1,
      actual_complete: 8.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-11-05",
      baseline_complete: 1.1,
      actual_complete: 8.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-11-12",
      baseline_complete: 1.2,
      actual_complete: 8.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-11-19",
      baseline_complete: 1.2,
      actual_complete: 8.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-11-26",
      baseline_complete: 1.3,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-12-03",
      baseline_complete: 1.4,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-12-10",
      baseline_complete: 1.4,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-12-17",
      baseline_complete: 1.5,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-12-24",
      baseline_complete: 1.6,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2024-12-31",
      baseline_complete: 1.6,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-01-07",
      baseline_complete: 1.7,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-01-14",
      baseline_complete: 1.8,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-01-21",
      baseline_complete: 1.9,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-01-28",
      baseline_complete: 2.0,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-02-04",
      baseline_complete: 2.0,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-02-11",
      baseline_complete: 2.1,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-02-18",
      baseline_complete: 2.2,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-02-25",
      baseline_complete: 2.3,
      actual_complete: 8.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-03-04",
      baseline_complete: 2.4,
      actual_complete: 8.7,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-03-11",
      baseline_complete: 2.6,
      actual_complete: 8.7,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-03-18",
      baseline_complete: 2.7,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-03-25",
      baseline_complete: 2.8,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-04-01",
      baseline_complete: 2.9,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-04-08",
      baseline_complete: 3.1,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-04-15",
      baseline_complete: 3.2,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-04-22",
      baseline_complete: 3.3,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-04-29",
      baseline_complete: 3.5,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-05-06",
      baseline_complete: 3.6,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-05-13",
      baseline_complete: 3.8,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-05-20",
      baseline_complete: 4.0,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-05-27",
      baseline_complete: 4.2,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-06-03",
      baseline_complete: 4.3,
      actual_complete: 9.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-06-10",
      baseline_complete: 4.5,
      actual_complete: 9.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-06-17",
      baseline_complete: 4.7,
      actual_complete: 10.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-06-24",
      baseline_complete: 4.9,
      actual_complete: 10.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-07-01",
      baseline_complete: 5.2,
      actual_complete: 10.7,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-07-08",
      baseline_complete: 5.4,
      actual_complete: 10.7,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-07-15",
      baseline_complete: 5.6,
      actual_complete: 10.7,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-07-22",
      baseline_complete: 5.9,
      actual_complete: 10.7,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-07-29",
      baseline_complete: 6.1,
      actual_complete: 10.7,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-08-05",
      baseline_complete: 6.4,
      actual_complete: 11.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-08-12",
      baseline_complete: 6.7,
      actual_complete: 11.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-08-19",
      baseline_complete: 7.0,
      actual_complete: 12.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-08-26",
      baseline_complete: 7.3,
      actual_complete: 12.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-09-02",
      baseline_complete: 7.6,
      actual_complete: 12.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-09-09",
      baseline_complete: 7.9,
      actual_complete: 12.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-09-16",
      baseline_complete: 8.3,
      actual_complete: 12.8,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-09-23",
      baseline_complete: 8.6,
      actual_complete: 13.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-09-30",
      baseline_complete: 9.0,
      actual_complete: 13.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-10-07",
      baseline_complete: 9.4,
      actual_complete: 13.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-10-14",
      baseline_complete: 9.7,
      actual_complete: 13.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-10-21",
      baseline_complete: 10.2,
      actual_complete: 13.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-10-28",
      baseline_complete: 10.6,
      actual_complete: 17.4,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-11-04",
      baseline_complete: 11.0,
      actual_complete: 17.4,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-11-11",
      baseline_complete: 11.5,
      actual_complete: 17.4,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-11-18",
      baseline_complete: 11.9,
      actual_complete: 17.4,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-11-25",
      baseline_complete: 12.4,
      actual_complete: 17.4,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-12-02",
      baseline_complete: 12.9,
      actual_complete: 17.4,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-12-09",
      baseline_complete: 13.5,
      actual_complete: 17.4,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-12-16",
      baseline_complete: 14.0,
      actual_complete: 18.2,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-12-23",
      baseline_complete: 14.6,
      actual_complete: 18.2,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2025-12-30",
      baseline_complete: 15.1,
      actual_complete: 20.3,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-01-06",
      baseline_complete: 15.7,
      actual_complete: 20.4,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-01-13",
      baseline_complete: 16.4,
      actual_complete: 21.3,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-01-20",
      baseline_complete: 17.0,
      actual_complete: 21.6,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-01-27",
      baseline_complete: 17.6,
      actual_complete: 21.9,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-02-03",
      baseline_complete: 18.3,
      actual_complete: 21.9,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-02-10",
      baseline_complete: 19.0,
      actual_complete: 22.4,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-02-17",
      baseline_complete: 19.7,
      actual_complete: 24.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-02-24",
      baseline_complete: 20.5,
      actual_complete: 24.1,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-03-03",
      baseline_complete: 21.2,
      actual_complete: 24.1,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-03-10",
      baseline_complete: 22.0,
      actual_complete: 25.9,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-03-17",
      baseline_complete: 22.8,
      actual_complete: 27.7,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-03-24",
      baseline_complete: 23.6,
      actual_complete: 28.4,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-03-31",
      baseline_complete: 24.4,
      actual_complete: 29.8,
      forecast_complete: 12.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-04-07",
      baseline_complete: 25.3,
      actual_complete: 29.8,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-04-14",
      baseline_complete: 26.1,
      actual_complete: 31.7,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-04-21",
      baseline_complete: 27.0,
      actual_complete: 32.5,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-04-28",
      baseline_complete: 28.0,
      actual_complete: 32.5,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-05-05",
      baseline_complete: 28.9,
      actual_complete: 32.5,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-05-12",
      baseline_complete: 29.8,
      actual_complete: 32.5,
      forecast_complete: 15.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-05-19",
      baseline_complete: 30.8,
      actual_complete: 35.7,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-05-26",
      baseline_complete: 31.8,
      actual_complete: 36.7,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-06-02",
      baseline_complete: 32.8,
      actual_complete: 36.7,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-06-09",
      baseline_complete: 33.8,
      actual_complete: 36.7,
      forecast_complete: 18.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-06-16",
      baseline_complete: 34.8,
      actual_complete: 36.7,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-06-23",
      baseline_complete: 35.9,
      actual_complete: 39.6,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-06-30",
      baseline_complete: 36.9,
      actual_complete: 42.3,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-07-07",
      baseline_complete: 38.0,
      actual_complete: 42.3,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-07-14",
      baseline_complete: 39.1,
      actual_complete: 45.6,
      forecast_complete: 21.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-07-21",
      baseline_complete: 40.2,
      actual_complete: 45.6,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-07-28",
      baseline_complete: 41.3,
      actual_complete: 45.6,
      forecast_complete: 23.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-08-04",
      baseline_complete: 42.4,
      actual_complete: 45.6,
      forecast_complete: 24.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-08-11",
      baseline_complete: 43.5,
      actual_complete: 45.9,
      forecast_complete: 24.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-08-18",
      baseline_complete: 44.6,
      actual_complete: 48.0,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-08-25",
      baseline_complete: 45.7,
      actual_complete: 50.8,
      forecast_complete: 26.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-09-01",
      baseline_complete: 46.9,
      actual_complete: 50.8,
      forecast_complete: 27.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-09-08",
      baseline_complete: 48.0,
      actual_complete: 50.8,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-09-15",
      baseline_complete: 49.2,
      actual_complete: 54.9,
      forecast_complete: 29.0,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-09-22",
      baseline_complete: 50.3,
      actual_complete: 54.9,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-09-29",
      baseline_complete: 51.4,
      actual_complete: 54.9,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-10-06",
      baseline_complete: 52.6,
      actual_complete: 57.8,
      forecast_complete: 31.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-10-13",
      baseline_complete: 53.7,
      actual_complete: 57.8,
      forecast_complete: 32.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-10-20",
      baseline_complete: 54.9,
      actual_complete: 57.8,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-10-27",
      baseline_complete: 56.0,
      actual_complete: 57.8,
      forecast_complete: 34.2,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-11-03",
      baseline_complete: 57.1,
      actual_complete: 59.2,
      forecast_complete: 35.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-11-10",
      baseline_complete: 58.2,
      actual_complete: 60.6,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-11-17",
      baseline_complete: 59.3,
      actual_complete: 60.6,
      forecast_complete: 36.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-11-24",
      baseline_complete: 60.4,
      actual_complete: 64.7,
      forecast_complete: 37.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-12-01",
      baseline_complete: 61.5,
      actual_complete: 65.3,
      forecast_complete: 38.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-12-08",
      baseline_complete: 62.6,
      actual_complete: 65.3,
      forecast_complete: 39.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-12-15",
      baseline_complete: 63.6,
      actual_complete: 65.6,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-12-22",
      baseline_complete: 64.7,
      actual_complete: 68.6,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2026-12-29",
      baseline_complete: 65.7,
      actual_complete: 68.6,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-01-05",
      baseline_complete: 66.8,
      actual_complete: 68.6,
      forecast_complete: 43.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-01-12",
      baseline_complete: 67.8,
      actual_complete: 70.1,
      forecast_complete: 44.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-01-19",
      baseline_complete: 68.8,
      actual_complete: 70.1,
      forecast_complete: 45.2,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-01-26",
      baseline_complete: 69.7,
      actual_complete: 71.2,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-02-02",
      baseline_complete: 70.7,
      actual_complete: 74.6,
      forecast_complete: 47.0,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-02-09",
      baseline_complete: 71.6,
      actual_complete: 74.6,
      forecast_complete: 47.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-02-16",
      baseline_complete: 72.5,
      actual_complete: 74.6,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-02-23",
      baseline_complete: 73.4,
      actual_complete: 78.2,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-03-02",
      baseline_complete: 74.3,
      actual_complete: 78.2,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-03-09",
      baseline_complete: 75.2,
      actual_complete: 79.3,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-03-16",
      baseline_complete: 76.0,
      actual_complete: 79.3,
      forecast_complete: 52.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-03-23",
      baseline_complete: 76.8,
      actual_complete: 79.3,
      forecast_complete: 53.2,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-03-30",
      baseline_complete: 77.6,
      actual_complete: 80.7,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-04-06",
      baseline_complete: 78.4,
      actual_complete: 83.5,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-04-13",
      baseline_complete: 79.2,
      actual_complete: 83.5,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-04-20",
      baseline_complete: 79.9,
      actual_complete: 85.3,
      forecast_complete: 56.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-04-27",
      baseline_complete: 80.7,
      actual_complete: 85.3,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-05-04",
      baseline_complete: 81.4,
      actual_complete: 85.3,
      forecast_complete: 58.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-05-11",
      baseline_complete: 82.0,
      actual_complete: 85.8,
      forecast_complete: 59.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-05-18",
      baseline_complete: 82.7,
      actual_complete: 85.8,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-05-25",
      baseline_complete: 83.3,
      actual_complete: 85.8,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-06-01",
      baseline_complete: 84.0,
      actual_complete: 85.8,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-06-08",
      baseline_complete: 84.6,
      actual_complete: 85.8,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-06-15",
      baseline_complete: 85.2,
      actual_complete: 87.7,
      forecast_complete: 63.2,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-06-22",
      baseline_complete: 85.7,
      actual_complete: 87.7,
      forecast_complete: 63.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-06-29",
      baseline_complete: 86.3,
      actual_complete: 87.7,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-07-06",
      baseline_complete: 86.8,
      actual_complete: 90.6,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-07-13",
      baseline_complete: 87.3,
      actual_complete: 90.6,
      forecast_complete: 67.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-07-20",
      baseline_complete: 87.8,
      actual_complete: 90.6,
      forecast_complete: 68.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-07-27",
      baseline_complete: 88.3,
      actual_complete: 90.6,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-08-03",
      baseline_complete: 88.8,
      actual_complete: 90.6,
      forecast_complete: 71.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-08-10",
      baseline_complete: 89.2,
      actual_complete: 90.6,
      forecast_complete: 72.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-08-17",
      baseline_complete: 89.6,
      actual_complete: 92.9,
      forecast_complete: 73.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-08-24",
      baseline_complete: 90.1,
      actual_complete: 92.9,
      forecast_complete: 74.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-08-31",
      baseline_complete: 90.5,
      actual_complete: 92.9,
      forecast_complete: 75.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-09-07",
      baseline_complete: 90.9,
      actual_complete: 92.9,
      forecast_complete: 76.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-09-14",
      baseline_complete: 91.2,
      actual_complete: 92.9,
      forecast_complete: 77.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-09-21",
      baseline_complete: 91.6,
      actual_complete: 92.9,
      forecast_complete: 78.7,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-09-28",
      baseline_complete: 91.9,
      actual_complete: 95.2,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-10-05",
      baseline_complete: 92.3,
      actual_complete: 95.2,
      forecast_complete: 80.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-10-12",
      baseline_complete: 92.6,
      actual_complete: 95.2,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-10-19",
      baseline_complete: 92.9,
      actual_complete: 96.1,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-10-26",
      baseline_complete: 93.2,
      actual_complete: 98.4,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-11-02",
      baseline_complete: 93.5,
      actual_complete: 98.4,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-11-09",
      baseline_complete: 93.7,
      actual_complete: 98.4,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-11-16",
      baseline_complete: 94.0,
      actual_complete: 98.4,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-11-23",
      baseline_complete: 94.3,
      actual_complete: 98.4,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-11-30",
      baseline_complete: 94.5,
      actual_complete: 98.8,
      forecast_complete: 86.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-12-07",
      baseline_complete: 94.7,
      actual_complete: 98.8,
      forecast_complete: 87.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-12-14",
      baseline_complete: 95.0,
      actual_complete: 98.8,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-12-21",
      baseline_complete: 95.2,
      actual_complete: 99.4,
      forecast_complete: 88.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2027-12-28",
      baseline_complete: 95.4,
      actual_complete: 99.4,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-01-04",
      baseline_complete: 95.6,
      actual_complete: 99.4,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-01-11",
      baseline_complete: 95.8,
      actual_complete: 99.4,
      forecast_complete: 90.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-01-18",
      baseline_complete: 95.9,
      actual_complete: 99.4,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-01-25",
      baseline_complete: 96.1,
      actual_complete: 99.4,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-02-01",
      baseline_complete: 96.3,
      actual_complete: 99.4,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-02-08",
      baseline_complete: 96.4,
      actual_complete: 99.4,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-02-15",
      baseline_complete: 96.6,
      actual_complete: 99.4,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-02-22",
      baseline_complete: 96.7,
      actual_complete: 99.4,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-02-29",
      baseline_complete: 96.9,
      actual_complete: 99.7,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-03-07",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-03-14",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-03-21",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-03-28",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-04-04",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-04-11",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-04-18",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-04-25",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-05-02",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-05-09",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-05-16",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-05-23",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-05-30",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-06-06",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-06-13",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-06-20",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-06-27",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-07-04",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-07-11",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-07-18",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-07-25",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "93ceaf79-3504-618b-3caa-148553fc5ade",
      reporting_date: "2028-07-27",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
  ],
  "6413b66b-2de2-7e19-44d3-f4cc43e1a19b": [
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-04-01",
      baseline_complete: 0.3,
      actual_complete: 3.7,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-04-08",
      baseline_complete: 0.4,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-04-15",
      baseline_complete: 0.4,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-04-22",
      baseline_complete: 0.4,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-04-29",
      baseline_complete: 0.5,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-05-06",
      baseline_complete: 0.5,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-05-13",
      baseline_complete: 0.6,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-05-20",
      baseline_complete: 0.6,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-05-27",
      baseline_complete: 0.6,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-06-03",
      baseline_complete: 0.7,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-06-10",
      baseline_complete: 0.8,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-06-17",
      baseline_complete: 0.8,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-06-24",
      baseline_complete: 0.9,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-07-01",
      baseline_complete: 1.0,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-07-08",
      baseline_complete: 1.0,
      actual_complete: 6.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-07-15",
      baseline_complete: 1.1,
      actual_complete: 6.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-07-22",
      baseline_complete: 1.2,
      actual_complete: 6.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-07-29",
      baseline_complete: 1.3,
      actual_complete: 6.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-08-05",
      baseline_complete: 1.4,
      actual_complete: 6.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-08-12",
      baseline_complete: 1.5,
      actual_complete: 6.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-08-19",
      baseline_complete: 1.6,
      actual_complete: 6.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-08-26",
      baseline_complete: 1.8,
      actual_complete: 6.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-09-02",
      baseline_complete: 1.9,
      actual_complete: 6.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-09-09",
      baseline_complete: 2.1,
      actual_complete: 7.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-09-16",
      baseline_complete: 2.2,
      actual_complete: 7.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-09-23",
      baseline_complete: 2.4,
      actual_complete: 7.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-09-30",
      baseline_complete: 2.6,
      actual_complete: 7.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-10-07",
      baseline_complete: 2.8,
      actual_complete: 7.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-10-14",
      baseline_complete: 3.0,
      actual_complete: 8.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-10-21",
      baseline_complete: 3.2,
      actual_complete: 8.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-10-28",
      baseline_complete: 3.5,
      actual_complete: 8.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-11-04",
      baseline_complete: 3.8,
      actual_complete: 8.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-11-11",
      baseline_complete: 4.1,
      actual_complete: 8.5,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-11-18",
      baseline_complete: 4.4,
      actual_complete: 8.6,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-11-25",
      baseline_complete: 4.7,
      actual_complete: 8.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-12-02",
      baseline_complete: 5.1,
      actual_complete: 8.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-12-09",
      baseline_complete: 5.5,
      actual_complete: 8.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-12-16",
      baseline_complete: 5.9,
      actual_complete: 8.6,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-12-23",
      baseline_complete: 6.3,
      actual_complete: 8.6,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2024-12-30",
      baseline_complete: 6.8,
      actual_complete: 11.5,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-01-06",
      baseline_complete: 7.3,
      actual_complete: 11.5,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-01-13",
      baseline_complete: 7.9,
      actual_complete: 11.5,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-01-20",
      baseline_complete: 8.5,
      actual_complete: 13.4,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-01-27",
      baseline_complete: 9.1,
      actual_complete: 14.1,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-02-03",
      baseline_complete: 9.8,
      actual_complete: 14.1,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-02-10",
      baseline_complete: 10.5,
      actual_complete: 15.0,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-02-17",
      baseline_complete: 11.2,
      actual_complete: 15.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-02-24",
      baseline_complete: 12.0,
      actual_complete: 16.1,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-03-03",
      baseline_complete: 12.9,
      actual_complete: 16.3,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-03-10",
      baseline_complete: 13.8,
      actual_complete: 16.3,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-03-17",
      baseline_complete: 14.7,
      actual_complete: 18.0,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-03-24",
      baseline_complete: 15.8,
      actual_complete: 18.0,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-03-31",
      baseline_complete: 16.8,
      actual_complete: 18.9,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-04-07",
      baseline_complete: 17.9,
      actual_complete: 21.6,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-04-14",
      baseline_complete: 19.1,
      actual_complete: 22.2,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-04-21",
      baseline_complete: 20.4,
      actual_complete: 25.3,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-04-28",
      baseline_complete: 21.7,
      actual_complete: 25.3,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-05-05",
      baseline_complete: 23.0,
      actual_complete: 26.4,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-05-12",
      baseline_complete: 24.4,
      actual_complete: 27.1,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-05-19",
      baseline_complete: 25.9,
      actual_complete: 27.1,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-05-26",
      baseline_complete: 27.4,
      actual_complete: 31.5,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-06-02",
      baseline_complete: 29.0,
      actual_complete: 33.3,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-06-09",
      baseline_complete: 30.6,
      actual_complete: 33.3,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-06-16",
      baseline_complete: 32.3,
      actual_complete: 34.8,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-06-23",
      baseline_complete: 34.1,
      actual_complete: 37.1,
      forecast_complete: 18.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-06-30",
      baseline_complete: 35.8,
      actual_complete: 40.3,
      forecast_complete: 20.0,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-07-07",
      baseline_complete: 37.6,
      actual_complete: 40.3,
      forecast_complete: 21.2,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-07-14",
      baseline_complete: 39.5,
      actual_complete: 43.1,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-07-21",
      baseline_complete: 41.4,
      actual_complete: 44.4,
      forecast_complete: 23.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-07-28",
      baseline_complete: 43.3,
      actual_complete: 44.9,
      forecast_complete: 25.1,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-08-04",
      baseline_complete: 45.2,
      actual_complete: 48.0,
      forecast_complete: 26.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-08-11",
      baseline_complete: 47.2,
      actual_complete: 48.1,
      forecast_complete: 27.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-08-18",
      baseline_complete: 49.1,
      actual_complete: 51.1,
      forecast_complete: 29.3,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-08-25",
      baseline_complete: 51.1,
      actual_complete: 54.8,
      forecast_complete: 30.8,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-09-01",
      baseline_complete: 53.0,
      actual_complete: 54.8,
      forecast_complete: 32.3,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-09-08",
      baseline_complete: 54.9,
      actual_complete: 59.7,
      forecast_complete: 33.8,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-09-15",
      baseline_complete: 56.9,
      actual_complete: 59.7,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-09-22",
      baseline_complete: 58.8,
      actual_complete: 59.7,
      forecast_complete: 36.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-09-29",
      baseline_complete: 60.7,
      actual_complete: 63.3,
      forecast_complete: 38.5,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-10-06",
      baseline_complete: 62.5,
      actual_complete: 63.6,
      forecast_complete: 40.1,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-10-13",
      baseline_complete: 64.3,
      actual_complete: 67.6,
      forecast_complete: 41.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-10-20",
      baseline_complete: 66.1,
      actual_complete: 70.8,
      forecast_complete: 43.3,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-10-27",
      baseline_complete: 67.8,
      actual_complete: 70.8,
      forecast_complete: 44.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-11-03",
      baseline_complete: 69.5,
      actual_complete: 71.4,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-11-10",
      baseline_complete: 71.1,
      actual_complete: 71.4,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-11-17",
      baseline_complete: 72.7,
      actual_complete: 76.6,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-11-24",
      baseline_complete: 74.2,
      actual_complete: 76.6,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-12-01",
      baseline_complete: 75.7,
      actual_complete: 80.2,
      forecast_complete: 52.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-12-08",
      baseline_complete: 77.1,
      actual_complete: 80.2,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-12-15",
      baseline_complete: 78.5,
      actual_complete: 81.4,
      forecast_complete: 56.0,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-12-22",
      baseline_complete: 79.7,
      actual_complete: 81.4,
      forecast_complete: 57.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2025-12-29",
      baseline_complete: 81.0,
      actual_complete: 83.5,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-01-05",
      baseline_complete: 82.2,
      actual_complete: 84.2,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-01-12",
      baseline_complete: 83.3,
      actual_complete: 85.1,
      forecast_complete: 61.8,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-01-19",
      baseline_complete: 84.3,
      actual_complete: 86.3,
      forecast_complete: 63.2,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-01-26",
      baseline_complete: 85.3,
      actual_complete: 87.2,
      forecast_complete: 64.6,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-02-02",
      baseline_complete: 86.3,
      actual_complete: 89.7,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-02-09",
      baseline_complete: 87.2,
      actual_complete: 89.7,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-02-16",
      baseline_complete: 88.0,
      actual_complete: 91.6,
      forecast_complete: 71.3,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-02-23",
      baseline_complete: 88.8,
      actual_complete: 91.6,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-03-02",
      baseline_complete: 89.6,
      actual_complete: 92.3,
      forecast_complete: 75.5,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-03-09",
      baseline_complete: 90.3,
      actual_complete: 92.3,
      forecast_complete: 77.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-03-16",
      baseline_complete: 91.0,
      actual_complete: 93.9,
      forecast_complete: 79.2,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-03-23",
      baseline_complete: 91.6,
      actual_complete: 94.8,
      forecast_complete: 80.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-03-30",
      baseline_complete: 92.2,
      actual_complete: 94.8,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-04-06",
      baseline_complete: 92.7,
      actual_complete: 95.8,
      forecast_complete: 84.1,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-04-13",
      baseline_complete: 93.2,
      actual_complete: 95.8,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-04-20",
      baseline_complete: 93.7,
      actual_complete: 96.0,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-04-27",
      baseline_complete: 94.1,
      actual_complete: 98.2,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-05-04",
      baseline_complete: 94.6,
      actual_complete: 98.2,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-05-11",
      baseline_complete: 94.9,
      actual_complete: 99.6,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-05-18",
      baseline_complete: 95.3,
      actual_complete: 99.6,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-05-25",
      baseline_complete: 95.6,
      actual_complete: 99.6,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-06-01",
      baseline_complete: 96.0,
      actual_complete: 99.6,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-06-08",
      baseline_complete: 96.3,
      actual_complete: 99.7,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-06-15",
      baseline_complete: 96.5,
      actual_complete: 99.7,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-06-22",
      baseline_complete: 96.8,
      actual_complete: 99.7,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-06-29",
      baseline_complete: 97.0,
      actual_complete: 99.7,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-07-06",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-07-13",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-07-20",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-07-27",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-08-03",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-08-10",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-08-17",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-08-24",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-08-31",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "6413b66b-2de2-7e19-44d3-f4cc43e1a19b",
      reporting_date: "2026-09-01",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
  ],
  "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2": [
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-03-23",
      baseline_complete: 0.2,
      actual_complete: 1.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-03-30",
      baseline_complete: 0.2,
      actual_complete: 1.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-04-06",
      baseline_complete: 0.2,
      actual_complete: 1.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-04-13",
      baseline_complete: 0.2,
      actual_complete: 1.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-04-20",
      baseline_complete: 0.3,
      actual_complete: 1.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-04-27",
      baseline_complete: 0.3,
      actual_complete: 1.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-05-04",
      baseline_complete: 0.3,
      actual_complete: 1.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-05-11",
      baseline_complete: 0.3,
      actual_complete: 1.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-05-18",
      baseline_complete: 0.3,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-05-25",
      baseline_complete: 0.4,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-06-01",
      baseline_complete: 0.4,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-06-08",
      baseline_complete: 0.4,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-06-15",
      baseline_complete: 0.5,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-06-22",
      baseline_complete: 0.5,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-06-29",
      baseline_complete: 0.5,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-07-06",
      baseline_complete: 0.6,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-07-13",
      baseline_complete: 0.6,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-07-20",
      baseline_complete: 0.7,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-07-27",
      baseline_complete: 0.7,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-08-03",
      baseline_complete: 0.8,
      actual_complete: 2.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-08-10",
      baseline_complete: 0.9,
      actual_complete: 2.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-08-17",
      baseline_complete: 0.9,
      actual_complete: 2.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-08-24",
      baseline_complete: 1.0,
      actual_complete: 2.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-08-31",
      baseline_complete: 1.1,
      actual_complete: 2.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-09-07",
      baseline_complete: 1.2,
      actual_complete: 2.9,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-09-14",
      baseline_complete: 1.3,
      actual_complete: 2.9,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-09-21",
      baseline_complete: 1.4,
      actual_complete: 2.9,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-09-28",
      baseline_complete: 1.5,
      actual_complete: 3.6,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-10-05",
      baseline_complete: 1.6,
      actual_complete: 3.6,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-10-12",
      baseline_complete: 1.7,
      actual_complete: 3.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-10-19",
      baseline_complete: 1.8,
      actual_complete: 3.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-10-26",
      baseline_complete: 2.0,
      actual_complete: 3.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-11-02",
      baseline_complete: 2.1,
      actual_complete: 3.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-11-09",
      baseline_complete: 2.3,
      actual_complete: 3.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-11-16",
      baseline_complete: 2.5,
      actual_complete: 4.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-11-23",
      baseline_complete: 2.7,
      actual_complete: 4.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-11-30",
      baseline_complete: 2.9,
      actual_complete: 4.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-12-07",
      baseline_complete: 3.1,
      actual_complete: 5.2,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-12-14",
      baseline_complete: 3.3,
      actual_complete: 5.2,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-12-21",
      baseline_complete: 3.6,
      actual_complete: 5.8,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2025-12-28",
      baseline_complete: 3.9,
      actual_complete: 5.8,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-01-04",
      baseline_complete: 4.2,
      actual_complete: 5.8,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-01-11",
      baseline_complete: 4.5,
      actual_complete: 5.9,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-01-18",
      baseline_complete: 4.8,
      actual_complete: 5.9,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-01-25",
      baseline_complete: 5.2,
      actual_complete: 5.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-02-01",
      baseline_complete: 5.6,
      actual_complete: 5.9,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-02-08",
      baseline_complete: 6.0,
      actual_complete: 8.2,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-02-15",
      baseline_complete: 6.5,
      actual_complete: 8.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-02-22",
      baseline_complete: 7.0,
      actual_complete: 8.2,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-03-01",
      baseline_complete: 7.5,
      actual_complete: 8.2,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-03-08",
      baseline_complete: 8.0,
      actual_complete: 8.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-03-15",
      baseline_complete: 8.6,
      actual_complete: 8.2,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-03-22",
      baseline_complete: 9.2,
      actual_complete: 8.9,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-03-29",
      baseline_complete: 9.9,
      actual_complete: 12.6,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-04-05",
      baseline_complete: 10.6,
      actual_complete: 12.6,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-04-12",
      baseline_complete: 11.4,
      actual_complete: 13.7,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-04-19",
      baseline_complete: 12.2,
      actual_complete: 13.7,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-04-26",
      baseline_complete: 13.0,
      actual_complete: 13.7,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-05-03",
      baseline_complete: 13.9,
      actual_complete: 13.7,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-05-10",
      baseline_complete: 14.9,
      actual_complete: 14.1,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-05-17",
      baseline_complete: 15.9,
      actual_complete: 19.2,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-05-24",
      baseline_complete: 16.9,
      actual_complete: 19.2,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-05-31",
      baseline_complete: 18.0,
      actual_complete: 20.8,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-06-07",
      baseline_complete: 19.2,
      actual_complete: 20.8,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-06-14",
      baseline_complete: 20.4,
      actual_complete: 21.4,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-06-21",
      baseline_complete: 21.7,
      actual_complete: 24.2,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-06-28",
      baseline_complete: 23.1,
      actual_complete: 24.2,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-07-05",
      baseline_complete: 24.4,
      actual_complete: 27.2,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-07-12",
      baseline_complete: 25.9,
      actual_complete: 28.6,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-07-19",
      baseline_complete: 27.4,
      actual_complete: 28.6,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-07-26",
      baseline_complete: 29.0,
      actual_complete: 31.9,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-08-02",
      baseline_complete: 30.6,
      actual_complete: 32.3,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-08-09",
      baseline_complete: 32.2,
      actual_complete: 32.3,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-08-16",
      baseline_complete: 33.9,
      actual_complete: 37.2,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-08-23",
      baseline_complete: 35.7,
      actual_complete: 37.2,
      forecast_complete: 18.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-08-30",
      baseline_complete: 37.5,
      actual_complete: 37.9,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-09-06",
      baseline_complete: 39.3,
      actual_complete: 40.4,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-09-13",
      baseline_complete: 41.2,
      actual_complete: 42.0,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-09-20",
      baseline_complete: 43.0,
      actual_complete: 42.1,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-09-27",
      baseline_complete: 44.9,
      actual_complete: 47.3,
      forecast_complete: 23.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-10-04",
      baseline_complete: 46.8,
      actual_complete: 49.1,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-10-11",
      baseline_complete: 48.8,
      actual_complete: 50.9,
      forecast_complete: 25.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-10-18",
      baseline_complete: 50.7,
      actual_complete: 52.5,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-10-25",
      baseline_complete: 52.6,
      actual_complete: 52.5,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-11-01",
      baseline_complete: 54.5,
      actual_complete: 53.9,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-11-08",
      baseline_complete: 56.4,
      actual_complete: 57.5,
      forecast_complete: 30.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-11-15",
      baseline_complete: 58.3,
      actual_complete: 58.5,
      forecast_complete: 31.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-11-22",
      baseline_complete: 60.2,
      actual_complete: 59.3,
      forecast_complete: 33.1,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-11-29",
      baseline_complete: 62.0,
      actual_complete: 64.6,
      forecast_complete: 34.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-12-06",
      baseline_complete: 63.8,
      actual_complete: 64.6,
      forecast_complete: 35.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-12-13",
      baseline_complete: 65.6,
      actual_complete: 66.7,
      forecast_complete: 36.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-12-20",
      baseline_complete: 67.3,
      actual_complete: 70.3,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2026-12-27",
      baseline_complete: 69.0,
      actual_complete: 70.3,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-01-03",
      baseline_complete: 70.6,
      actual_complete: 74.0,
      forecast_complete: 40.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-01-10",
      baseline_complete: 72.2,
      actual_complete: 75.4,
      forecast_complete: 42.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-01-17",
      baseline_complete: 73.7,
      actual_complete: 75.4,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-01-24",
      baseline_complete: 75.1,
      actual_complete: 75.4,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-01-31",
      baseline_complete: 76.6,
      actual_complete: 76.2,
      forecast_complete: 45.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-02-07",
      baseline_complete: 77.9,
      actual_complete: 77.5,
      forecast_complete: 46.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-02-14",
      baseline_complete: 79.2,
      actual_complete: 79.6,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-02-21",
      baseline_complete: 80.4,
      actual_complete: 83.8,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-02-28",
      baseline_complete: 81.6,
      actual_complete: 84.6,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-03-07",
      baseline_complete: 82.8,
      actual_complete: 84.6,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-03-14",
      baseline_complete: 83.8,
      actual_complete: 84.9,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-03-21",
      baseline_complete: 84.8,
      actual_complete: 84.9,
      forecast_complete: 53.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-03-28",
      baseline_complete: 85.8,
      actual_complete: 84.9,
      forecast_complete: 54.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-04-04",
      baseline_complete: 86.7,
      actual_complete: 86.4,
      forecast_complete: 55.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-04-11",
      baseline_complete: 87.6,
      actual_complete: 90.2,
      forecast_complete: 56.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-04-18",
      baseline_complete: 88.4,
      actual_complete: 90.2,
      forecast_complete: 57.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-04-25",
      baseline_complete: 89.2,
      actual_complete: 90.2,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-05-02",
      baseline_complete: 89.9,
      actual_complete: 90.2,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-05-09",
      baseline_complete: 90.6,
      actual_complete: 90.4,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-05-16",
      baseline_complete: 91.2,
      actual_complete: 90.4,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-05-23",
      baseline_complete: 91.8,
      actual_complete: 93.7,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-05-30",
      baseline_complete: 92.4,
      actual_complete: 94.4,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-06-06",
      baseline_complete: 92.9,
      actual_complete: 95.2,
      forecast_complete: 64.2,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-06-13",
      baseline_complete: 93.4,
      actual_complete: 95.2,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-06-20",
      baseline_complete: 93.8,
      actual_complete: 96.1,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-06-27",
      baseline_complete: 94.3,
      actual_complete: 96.5,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-07-04",
      baseline_complete: 94.7,
      actual_complete: 96.6,
      forecast_complete: 67.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-07-11",
      baseline_complete: 95.1,
      actual_complete: 96.6,
      forecast_complete: 68.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-07-18",
      baseline_complete: 95.4,
      actual_complete: 96.6,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-07-25",
      baseline_complete: 95.7,
      actual_complete: 97.1,
      forecast_complete: 69.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-08-01",
      baseline_complete: 96.0,
      actual_complete: 97.1,
      forecast_complete: 70.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-08-08",
      baseline_complete: 96.3,
      actual_complete: 98.7,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-08-15",
      baseline_complete: 96.6,
      actual_complete: 98.7,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-08-22",
      baseline_complete: 96.8,
      actual_complete: 99.5,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-08-29",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 73.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-09-05",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 74.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-09-12",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 75.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-09-19",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 75.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-09-26",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 76.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-10-03",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 77.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-10-10",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 79.1,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-10-17",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-10-24",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-10-31",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 82.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-11-07",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 83.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-11-14",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-11-21",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-11-28",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 86.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-12-05",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 87.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-12-12",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 88.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-12-19",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2027-12-26",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-01-02",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-01-09",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-01-16",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-01-23",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-01-30",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-02-06",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-02-13",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-02-20",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-02-27",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-03-05",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-03-12",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-03-19",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-03-26",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-04-02",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-04-09",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-04-16",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-04-23",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-04-30",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-05-07",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-05-14",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-05-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-05-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-06-04",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-06-11",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-06-18",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-06-25",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-07-02",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-07-09",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-07-16",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cbeaaf65-6afb-a1ee-a0cf-0fd4d7f6d5c2",
      reporting_date: "2028-07-23",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "cee95d82-f046-532c-07cb-937090ac28cc": [
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-07-06",
      baseline_complete: 0.2,
      actual_complete: 1.1,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-07-13",
      baseline_complete: 0.2,
      actual_complete: 1.9,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-07-20",
      baseline_complete: 0.2,
      actual_complete: 3.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-07-27",
      baseline_complete: 0.3,
      actual_complete: 3.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-08-03",
      baseline_complete: 0.3,
      actual_complete: 3.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-08-10",
      baseline_complete: 0.3,
      actual_complete: 3.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-08-17",
      baseline_complete: 0.3,
      actual_complete: 3.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-08-24",
      baseline_complete: 0.3,
      actual_complete: 3.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-08-31",
      baseline_complete: 0.3,
      actual_complete: 3.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-09-07",
      baseline_complete: 0.3,
      actual_complete: 3.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-09-14",
      baseline_complete: 0.4,
      actual_complete: 3.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-09-21",
      baseline_complete: 0.4,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-09-28",
      baseline_complete: 0.4,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-10-05",
      baseline_complete: 0.4,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-10-12",
      baseline_complete: 0.4,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-10-19",
      baseline_complete: 0.5,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-10-26",
      baseline_complete: 0.5,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-11-02",
      baseline_complete: 0.5,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-11-09",
      baseline_complete: 0.5,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-11-16",
      baseline_complete: 0.6,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-11-23",
      baseline_complete: 0.6,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-11-30",
      baseline_complete: 0.6,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-12-07",
      baseline_complete: 0.6,
      actual_complete: 3.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-12-14",
      baseline_complete: 0.7,
      actual_complete: 3.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-12-21",
      baseline_complete: 0.7,
      actual_complete: 3.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2023-12-28",
      baseline_complete: 0.8,
      actual_complete: 3.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-01-04",
      baseline_complete: 0.8,
      actual_complete: 3.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-01-11",
      baseline_complete: 0.8,
      actual_complete: 3.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-01-18",
      baseline_complete: 0.9,
      actual_complete: 3.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-01-25",
      baseline_complete: 0.9,
      actual_complete: 3.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-02-01",
      baseline_complete: 1.0,
      actual_complete: 3.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-02-08",
      baseline_complete: 1.0,
      actual_complete: 3.7,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-02-15",
      baseline_complete: 1.1,
      actual_complete: 3.9,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-02-22",
      baseline_complete: 1.1,
      actual_complete: 3.9,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-02-29",
      baseline_complete: 1.2,
      actual_complete: 3.9,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-03-07",
      baseline_complete: 1.2,
      actual_complete: 3.9,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-03-14",
      baseline_complete: 1.3,
      actual_complete: 4.2,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-03-21",
      baseline_complete: 1.3,
      actual_complete: 4.2,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-03-28",
      baseline_complete: 1.4,
      actual_complete: 4.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-04-04",
      baseline_complete: 1.5,
      actual_complete: 4.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-04-11",
      baseline_complete: 1.6,
      actual_complete: 4.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-04-18",
      baseline_complete: 1.6,
      actual_complete: 4.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-04-25",
      baseline_complete: 1.7,
      actual_complete: 4.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-05-02",
      baseline_complete: 1.8,
      actual_complete: 4.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-05-09",
      baseline_complete: 1.9,
      actual_complete: 4.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-05-16",
      baseline_complete: 2.0,
      actual_complete: 4.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-05-23",
      baseline_complete: 2.1,
      actual_complete: 4.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-05-30",
      baseline_complete: 2.2,
      actual_complete: 4.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-06-06",
      baseline_complete: 2.3,
      actual_complete: 4.4,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-06-13",
      baseline_complete: 2.4,
      actual_complete: 5.0,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-06-20",
      baseline_complete: 2.5,
      actual_complete: 5.0,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-06-27",
      baseline_complete: 2.7,
      actual_complete: 5.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-07-04",
      baseline_complete: 2.8,
      actual_complete: 5.2,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-07-11",
      baseline_complete: 2.9,
      actual_complete: 5.2,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-07-18",
      baseline_complete: 3.1,
      actual_complete: 5.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-07-25",
      baseline_complete: 3.2,
      actual_complete: 5.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-08-01",
      baseline_complete: 3.4,
      actual_complete: 5.3,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-08-08",
      baseline_complete: 3.5,
      actual_complete: 6.2,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-08-15",
      baseline_complete: 3.7,
      actual_complete: 6.9,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-08-22",
      baseline_complete: 3.9,
      actual_complete: 6.9,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-08-29",
      baseline_complete: 4.1,
      actual_complete: 6.9,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-09-05",
      baseline_complete: 4.3,
      actual_complete: 7.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-09-12",
      baseline_complete: 4.5,
      actual_complete: 7.2,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-09-19",
      baseline_complete: 4.7,
      actual_complete: 7.2,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-09-26",
      baseline_complete: 4.9,
      actual_complete: 7.2,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-10-03",
      baseline_complete: 5.2,
      actual_complete: 7.4,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-10-10",
      baseline_complete: 5.4,
      actual_complete: 7.4,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-10-17",
      baseline_complete: 5.7,
      actual_complete: 7.4,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-10-24",
      baseline_complete: 5.9,
      actual_complete: 7.4,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-10-31",
      baseline_complete: 6.2,
      actual_complete: 7.4,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-11-07",
      baseline_complete: 6.5,
      actual_complete: 8.2,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-11-14",
      baseline_complete: 6.8,
      actual_complete: 8.5,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-11-21",
      baseline_complete: 7.1,
      actual_complete: 8.7,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-11-28",
      baseline_complete: 7.5,
      actual_complete: 9.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-12-05",
      baseline_complete: 7.8,
      actual_complete: 9.7,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-12-12",
      baseline_complete: 8.2,
      actual_complete: 10.7,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-12-19",
      baseline_complete: 8.6,
      actual_complete: 11.3,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2024-12-26",
      baseline_complete: 8.9,
      actual_complete: 11.3,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-01-02",
      baseline_complete: 9.4,
      actual_complete: 11.3,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-01-09",
      baseline_complete: 9.8,
      actual_complete: 11.3,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-01-16",
      baseline_complete: 10.2,
      actual_complete: 11.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-01-23",
      baseline_complete: 10.7,
      actual_complete: 12.9,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-01-30",
      baseline_complete: 11.2,
      actual_complete: 12.9,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-02-06",
      baseline_complete: 11.7,
      actual_complete: 13.7,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-02-13",
      baseline_complete: 12.2,
      actual_complete: 14.7,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-02-20",
      baseline_complete: 12.7,
      actual_complete: 15.3,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-02-27",
      baseline_complete: 13.3,
      actual_complete: 16.3,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-03-06",
      baseline_complete: 13.9,
      actual_complete: 16.3,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-03-13",
      baseline_complete: 14.5,
      actual_complete: 16.4,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-03-20",
      baseline_complete: 15.1,
      actual_complete: 17.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-03-27",
      baseline_complete: 15.7,
      actual_complete: 17.6,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-04-03",
      baseline_complete: 16.4,
      actual_complete: 17.6,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-04-10",
      baseline_complete: 17.1,
      actual_complete: 18.5,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-04-17",
      baseline_complete: 17.8,
      actual_complete: 19.9,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-04-24",
      baseline_complete: 18.5,
      actual_complete: 20.9,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-05-01",
      baseline_complete: 19.3,
      actual_complete: 21.3,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-05-08",
      baseline_complete: 20.0,
      actual_complete: 23.0,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-05-15",
      baseline_complete: 20.8,
      actual_complete: 23.0,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-05-22",
      baseline_complete: 21.7,
      actual_complete: 23.0,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-05-29",
      baseline_complete: 22.5,
      actual_complete: 24.6,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-06-05",
      baseline_complete: 23.4,
      actual_complete: 24.6,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-06-12",
      baseline_complete: 24.3,
      actual_complete: 25.3,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-06-19",
      baseline_complete: 25.2,
      actual_complete: 27.3,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-06-26",
      baseline_complete: 26.1,
      actual_complete: 28.8,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-07-03",
      baseline_complete: 27.1,
      actual_complete: 30.4,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-07-10",
      baseline_complete: 28.1,
      actual_complete: 30.4,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-07-17",
      baseline_complete: 29.1,
      actual_complete: 31.5,
      forecast_complete: 16.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-07-24",
      baseline_complete: 30.1,
      actual_complete: 31.9,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-07-31",
      baseline_complete: 31.2,
      actual_complete: 33.7,
      forecast_complete: 18.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-08-07",
      baseline_complete: 32.2,
      actual_complete: 33.7,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-08-14",
      baseline_complete: 33.3,
      actual_complete: 35.6,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-08-21",
      baseline_complete: 34.4,
      actual_complete: 35.7,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-08-28",
      baseline_complete: 35.5,
      actual_complete: 35.9,
      forecast_complete: 20.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-09-04",
      baseline_complete: 36.7,
      actual_complete: 38.4,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-09-11",
      baseline_complete: 37.8,
      actual_complete: 40.1,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-09-18",
      baseline_complete: 39.0,
      actual_complete: 40.1,
      forecast_complete: 23.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-09-25",
      baseline_complete: 40.2,
      actual_complete: 42.1,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-10-02",
      baseline_complete: 41.4,
      actual_complete: 42.1,
      forecast_complete: 24.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-10-09",
      baseline_complete: 42.6,
      actual_complete: 44.7,
      forecast_complete: 25.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-10-16",
      baseline_complete: 43.8,
      actual_complete: 47.3,
      forecast_complete: 26.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-10-23",
      baseline_complete: 45.0,
      actual_complete: 47.5,
      forecast_complete: 27.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-10-30",
      baseline_complete: 46.2,
      actual_complete: 49.0,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-11-06",
      baseline_complete: 47.4,
      actual_complete: 49.7,
      forecast_complete: 29.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-11-13",
      baseline_complete: 48.7,
      actual_complete: 49.8,
      forecast_complete: 29.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-11-20",
      baseline_complete: 49.9,
      actual_complete: 52.2,
      forecast_complete: 30.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-11-27",
      baseline_complete: 51.1,
      actual_complete: 53.4,
      forecast_complete: 31.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-12-04",
      baseline_complete: 52.4,
      actual_complete: 54.8,
      forecast_complete: 32.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-12-11",
      baseline_complete: 53.6,
      actual_complete: 54.8,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-12-18",
      baseline_complete: 54.8,
      actual_complete: 56.6,
      forecast_complete: 34.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2025-12-25",
      baseline_complete: 56.0,
      actual_complete: 58.1,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-01-01",
      baseline_complete: 57.3,
      actual_complete: 60.2,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-01-08",
      baseline_complete: 58.5,
      actual_complete: 60.7,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-01-15",
      baseline_complete: 59.6,
      actual_complete: 60.7,
      forecast_complete: 38.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-01-22",
      baseline_complete: 60.8,
      actual_complete: 63.9,
      forecast_complete: 39.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-01-29",
      baseline_complete: 62.0,
      actual_complete: 63.9,
      forecast_complete: 40.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-02-05",
      baseline_complete: 63.1,
      actual_complete: 65.5,
      forecast_complete: 41.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-02-12",
      baseline_complete: 64.3,
      actual_complete: 65.5,
      forecast_complete: 42.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-02-19",
      baseline_complete: 65.4,
      actual_complete: 67.8,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-02-26",
      baseline_complete: 66.5,
      actual_complete: 67.8,
      forecast_complete: 44.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-03-05",
      baseline_complete: 67.6,
      actual_complete: 67.8,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-03-12",
      baseline_complete: 68.7,
      actual_complete: 72.3,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-03-19",
      baseline_complete: 69.7,
      actual_complete: 72.3,
      forecast_complete: 47.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-03-26",
      baseline_complete: 70.8,
      actual_complete: 72.3,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-04-02",
      baseline_complete: 71.8,
      actual_complete: 72.9,
      forecast_complete: 49.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-04-09",
      baseline_complete: 72.8,
      actual_complete: 75.0,
      forecast_complete: 50.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-04-16",
      baseline_complete: 73.7,
      actual_complete: 75.0,
      forecast_complete: 50.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-04-23",
      baseline_complete: 74.7,
      actual_complete: 75.0,
      forecast_complete: 51.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-04-30",
      baseline_complete: 75.6,
      actual_complete: 78.1,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-05-07",
      baseline_complete: 76.5,
      actual_complete: 78.5,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-05-14",
      baseline_complete: 77.4,
      actual_complete: 79.0,
      forecast_complete: 54.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-05-21",
      baseline_complete: 78.2,
      actual_complete: 79.8,
      forecast_complete: 55.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-05-28",
      baseline_complete: 79.0,
      actual_complete: 79.8,
      forecast_complete: 56.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-06-04",
      baseline_complete: 79.8,
      actual_complete: 81.2,
      forecast_complete: 57.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-06-11",
      baseline_complete: 80.6,
      actual_complete: 81.2,
      forecast_complete: 58.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-06-18",
      baseline_complete: 81.4,
      actual_complete: 82.8,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-06-25",
      baseline_complete: 82.1,
      actual_complete: 83.9,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-07-02",
      baseline_complete: 82.8,
      actual_complete: 83.9,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-07-09",
      baseline_complete: 83.5,
      actual_complete: 86.3,
      forecast_complete: 61.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-07-16",
      baseline_complete: 84.2,
      actual_complete: 86.3,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-07-23",
      baseline_complete: 84.8,
      actual_complete: 86.3,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-07-30",
      baseline_complete: 85.5,
      actual_complete: 86.3,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-08-06",
      baseline_complete: 86.1,
      actual_complete: 88.6,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-08-13",
      baseline_complete: 86.6,
      actual_complete: 89.2,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-08-20",
      baseline_complete: 87.2,
      actual_complete: 89.6,
      forecast_complete: 66.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-08-27",
      baseline_complete: 87.7,
      actual_complete: 89.6,
      forecast_complete: 67.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-09-03",
      baseline_complete: 88.3,
      actual_complete: 90.6,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-09-10",
      baseline_complete: 88.8,
      actual_complete: 91.9,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-09-17",
      baseline_complete: 89.2,
      actual_complete: 92.1,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-09-24",
      baseline_complete: 89.7,
      actual_complete: 92.1,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-10-01",
      baseline_complete: 90.2,
      actual_complete: 93.3,
      forecast_complete: 72.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-10-08",
      baseline_complete: 90.6,
      actual_complete: 93.3,
      forecast_complete: 74.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-10-15",
      baseline_complete: 91.0,
      actual_complete: 94.3,
      forecast_complete: 75.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-10-22",
      baseline_complete: 91.4,
      actual_complete: 94.3,
      forecast_complete: 76.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-10-29",
      baseline_complete: 91.8,
      actual_complete: 94.6,
      forecast_complete: 77.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-11-05",
      baseline_complete: 92.1,
      actual_complete: 94.6,
      forecast_complete: 78.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-11-12",
      baseline_complete: 92.5,
      actual_complete: 95.3,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-11-19",
      baseline_complete: 92.8,
      actual_complete: 95.3,
      forecast_complete: 80.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-11-26",
      baseline_complete: 93.1,
      actual_complete: 95.9,
      forecast_complete: 81.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-12-03",
      baseline_complete: 93.4,
      actual_complete: 95.9,
      forecast_complete: 82.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-12-10",
      baseline_complete: 93.7,
      actual_complete: 95.9,
      forecast_complete: 83.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-12-17",
      baseline_complete: 94.0,
      actual_complete: 95.9,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-12-24",
      baseline_complete: 94.3,
      actual_complete: 95.9,
      forecast_complete: 85.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2026-12-31",
      baseline_complete: 94.6,
      actual_complete: 97.2,
      forecast_complete: 86.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-01-07",
      baseline_complete: 94.8,
      actual_complete: 97.2,
      forecast_complete: 87.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-01-14",
      baseline_complete: 95.0,
      actual_complete: 97.2,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-01-21",
      baseline_complete: 95.3,
      actual_complete: 97.2,
      forecast_complete: 88.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-01-28",
      baseline_complete: 95.5,
      actual_complete: 97.9,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-02-04",
      baseline_complete: 95.7,
      actual_complete: 98.3,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-02-11",
      baseline_complete: 95.9,
      actual_complete: 98.3,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-02-18",
      baseline_complete: 96.1,
      actual_complete: 98.3,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-02-25",
      baseline_complete: 96.3,
      actual_complete: 99.6,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-03-04",
      baseline_complete: 96.4,
      actual_complete: 99.6,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-03-11",
      baseline_complete: 96.6,
      actual_complete: 99.6,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-03-18",
      baseline_complete: 96.8,
      actual_complete: 99.6,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-03-25",
      baseline_complete: 96.9,
      actual_complete: 99.6,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-04-01",
      baseline_complete: 97.1,
      actual_complete: 99.6,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-04-08",
      baseline_complete: 97.2,
      actual_complete: 99.6,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-04-15",
      baseline_complete: 97.3,
      actual_complete: 99.6,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-04-22",
      baseline_complete: 97.5,
      actual_complete: 99.6,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-04-29",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-05-06",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-05-13",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-05-20",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-05-27",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-06-03",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-06-10",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-06-17",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-06-24",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-07-01",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-07-08",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-07-15",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-07-22",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-07-29",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-08-05",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-08-12",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-08-19",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-08-26",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-09-02",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-09-09",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-09-16",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-09-23",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-09-30",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "cee95d82-f046-532c-07cb-937090ac28cc",
      reporting_date: "2027-10-06",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "a2d99805-73f0-c858-b709-fbda2482cfcd": [
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-02-03",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-02-10",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-02-17",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-02-24",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-03-03",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-03-10",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-03-17",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-03-24",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-03-31",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-04-07",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-04-14",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-04-21",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-04-28",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-05-05",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-05-12",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-05-19",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-05-26",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-06-02",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-06-09",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-06-16",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-06-23",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-06-30",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-07-07",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-07-14",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-07-21",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-07-28",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-08-04",
      baseline_complete: 2.1,
      actual_complete: 0.4,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-08-11",
      baseline_complete: 2.3,
      actual_complete: 0.4,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-08-18",
      baseline_complete: 2.4,
      actual_complete: 0.4,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-08-25",
      baseline_complete: 2.5,
      actual_complete: 0.4,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-09-01",
      baseline_complete: 2.6,
      actual_complete: 0.7,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-09-08",
      baseline_complete: 2.7,
      actual_complete: 0.7,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-09-15",
      baseline_complete: 2.8,
      actual_complete: 0.7,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-09-22",
      baseline_complete: 3.0,
      actual_complete: 1.3,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-09-29",
      baseline_complete: 3.1,
      actual_complete: 1.3,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-10-06",
      baseline_complete: 3.3,
      actual_complete: 1.7,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-10-13",
      baseline_complete: 3.4,
      actual_complete: 1.7,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-10-20",
      baseline_complete: 3.6,
      actual_complete: 1.7,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-10-27",
      baseline_complete: 3.8,
      actual_complete: 1.7,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-11-03",
      baseline_complete: 3.9,
      actual_complete: 2.5,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-11-10",
      baseline_complete: 4.1,
      actual_complete: 2.5,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-11-17",
      baseline_complete: 4.3,
      actual_complete: 2.5,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-11-24",
      baseline_complete: 4.5,
      actual_complete: 2.5,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-12-01",
      baseline_complete: 4.7,
      actual_complete: 2.5,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-12-08",
      baseline_complete: 4.9,
      actual_complete: 2.5,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-12-15",
      baseline_complete: 5.2,
      actual_complete: 4.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-12-22",
      baseline_complete: 5.4,
      actual_complete: 4.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2023-12-29",
      baseline_complete: 5.7,
      actual_complete: 4.2,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-01-05",
      baseline_complete: 5.9,
      actual_complete: 5.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-01-12",
      baseline_complete: 6.2,
      actual_complete: 5.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-01-19",
      baseline_complete: 6.5,
      actual_complete: 5.0,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-01-26",
      baseline_complete: 6.8,
      actual_complete: 5.8,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-02-02",
      baseline_complete: 7.1,
      actual_complete: 5.8,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-02-09",
      baseline_complete: 7.4,
      actual_complete: 5.8,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-02-16",
      baseline_complete: 7.7,
      actual_complete: 6.2,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-02-23",
      baseline_complete: 8.1,
      actual_complete: 6.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-03-01",
      baseline_complete: 8.5,
      actual_complete: 6.6,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-03-08",
      baseline_complete: 8.8,
      actual_complete: 7.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-03-15",
      baseline_complete: 9.2,
      actual_complete: 7.4,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-03-22",
      baseline_complete: 9.6,
      actual_complete: 7.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-03-29",
      baseline_complete: 10.1,
      actual_complete: 8.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-04-05",
      baseline_complete: 10.5,
      actual_complete: 9.5,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-04-12",
      baseline_complete: 11.0,
      actual_complete: 9.5,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-04-19",
      baseline_complete: 11.4,
      actual_complete: 9.5,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-04-26",
      baseline_complete: 11.9,
      actual_complete: 9.8,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-05-03",
      baseline_complete: 12.4,
      actual_complete: 11.5,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-05-10",
      baseline_complete: 13.0,
      actual_complete: 12.3,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-05-17",
      baseline_complete: 13.5,
      actual_complete: 12.3,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-05-24",
      baseline_complete: 14.1,
      actual_complete: 12.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-05-31",
      baseline_complete: 14.7,
      actual_complete: 12.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-06-07",
      baseline_complete: 15.3,
      actual_complete: 13.5,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-06-14",
      baseline_complete: 15.9,
      actual_complete: 14.9,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-06-21",
      baseline_complete: 16.6,
      actual_complete: 15.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-06-28",
      baseline_complete: 17.2,
      actual_complete: 16.0,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-07-05",
      baseline_complete: 17.9,
      actual_complete: 16.0,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-07-12",
      baseline_complete: 18.7,
      actual_complete: 17.2,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-07-19",
      baseline_complete: 19.4,
      actual_complete: 18.1,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-07-26",
      baseline_complete: 20.2,
      actual_complete: 19.6,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-08-02",
      baseline_complete: 20.9,
      actual_complete: 20.6,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-08-09",
      baseline_complete: 21.7,
      actual_complete: 21.5,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-08-16",
      baseline_complete: 22.6,
      actual_complete: 21.5,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-08-23",
      baseline_complete: 23.4,
      actual_complete: 21.8,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-08-30",
      baseline_complete: 24.3,
      actual_complete: 23.8,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-09-06",
      baseline_complete: 25.2,
      actual_complete: 23.8,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-09-13",
      baseline_complete: 26.1,
      actual_complete: 25.6,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-09-20",
      baseline_complete: 27.0,
      actual_complete: 26.2,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-09-27",
      baseline_complete: 28.0,
      actual_complete: 27.8,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-10-04",
      baseline_complete: 28.9,
      actual_complete: 27.8,
      forecast_complete: 12.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-10-11",
      baseline_complete: 29.9,
      actual_complete: 28.6,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-10-18",
      baseline_complete: 31.0,
      actual_complete: 30.6,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-10-25",
      baseline_complete: 32.0,
      actual_complete: 31.0,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-11-01",
      baseline_complete: 33.0,
      actual_complete: 32.6,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-11-08",
      baseline_complete: 34.1,
      actual_complete: 32.6,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-11-15",
      baseline_complete: 35.2,
      actual_complete: 34.7,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-11-22",
      baseline_complete: 36.3,
      actual_complete: 35.7,
      forecast_complete: 17.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-11-29",
      baseline_complete: 37.4,
      actual_complete: 35.7,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-12-06",
      baseline_complete: 38.5,
      actual_complete: 38.5,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-12-13",
      baseline_complete: 39.7,
      actual_complete: 38.5,
      forecast_complete: 19.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-12-20",
      baseline_complete: 40.8,
      actual_complete: 40.1,
      forecast_complete: 19.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2024-12-27",
      baseline_complete: 42.0,
      actual_complete: 41.3,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-01-03",
      baseline_complete: 43.2,
      actual_complete: 41.7,
      forecast_complete: 21.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-01-10",
      baseline_complete: 44.3,
      actual_complete: 43.5,
      forecast_complete: 22.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-01-17",
      baseline_complete: 45.5,
      actual_complete: 46.1,
      forecast_complete: 23.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-01-24",
      baseline_complete: 46.7,
      actual_complete: 46.1,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-01-31",
      baseline_complete: 47.9,
      actual_complete: 46.1,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-02-07",
      baseline_complete: 49.1,
      actual_complete: 47.0,
      forecast_complete: 25.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-02-14",
      baseline_complete: 50.3,
      actual_complete: 50.3,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-02-21",
      baseline_complete: 51.5,
      actual_complete: 50.3,
      forecast_complete: 27.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-02-28",
      baseline_complete: 52.7,
      actual_complete: 51.8,
      forecast_complete: 28.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-03-07",
      baseline_complete: 53.9,
      actual_complete: 52.3,
      forecast_complete: 28.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-03-14",
      baseline_complete: 55.1,
      actual_complete: 53.6,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-03-21",
      baseline_complete: 56.2,
      actual_complete: 54.7,
      forecast_complete: 30.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-03-28",
      baseline_complete: 57.4,
      actual_complete: 58.3,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-04-04",
      baseline_complete: 58.6,
      actual_complete: 58.3,
      forecast_complete: 32.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-04-11",
      baseline_complete: 59.7,
      actual_complete: 58.9,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-04-18",
      baseline_complete: 60.9,
      actual_complete: 58.9,
      forecast_complete: 34.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-04-25",
      baseline_complete: 62.0,
      actual_complete: 61.4,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-05-02",
      baseline_complete: 63.1,
      actual_complete: 62.7,
      forecast_complete: 36.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-05-09",
      baseline_complete: 64.2,
      actual_complete: 64.5,
      forecast_complete: 37.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-05-16",
      baseline_complete: 65.3,
      actual_complete: 65.2,
      forecast_complete: 38.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-05-23",
      baseline_complete: 66.4,
      actual_complete: 66.5,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-05-30",
      baseline_complete: 67.5,
      actual_complete: 67.2,
      forecast_complete: 39.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-06-06",
      baseline_complete: 68.5,
      actual_complete: 67.2,
      forecast_complete: 40.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-06-13",
      baseline_complete: 69.5,
      actual_complete: 68.5,
      forecast_complete: 41.7,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-06-20",
      baseline_complete: 70.5,
      actual_complete: 70.9,
      forecast_complete: 42.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-06-27",
      baseline_complete: 71.5,
      actual_complete: 72.0,
      forecast_complete: 43.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-07-04",
      baseline_complete: 72.5,
      actual_complete: 72.5,
      forecast_complete: 44.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-07-11",
      baseline_complete: 73.4,
      actual_complete: 72.6,
      forecast_complete: 45.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-07-18",
      baseline_complete: 74.4,
      actual_complete: 74.5,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-07-25",
      baseline_complete: 75.3,
      actual_complete: 76.6,
      forecast_complete: 47.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-08-01",
      baseline_complete: 76.1,
      actual_complete: 76.6,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-08-08",
      baseline_complete: 77.0,
      actual_complete: 76.6,
      forecast_complete: 49.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-08-15",
      baseline_complete: 77.8,
      actual_complete: 77.8,
      forecast_complete: 49.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-08-22",
      baseline_complete: 78.7,
      actual_complete: 78.0,
      forecast_complete: 50.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-08-29",
      baseline_complete: 79.4,
      actual_complete: 78.5,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-09-05",
      baseline_complete: 80.2,
      actual_complete: 81.0,
      forecast_complete: 52.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-09-12",
      baseline_complete: 81.0,
      actual_complete: 81.0,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-09-19",
      baseline_complete: 81.7,
      actual_complete: 81.0,
      forecast_complete: 54.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-09-26",
      baseline_complete: 82.4,
      actual_complete: 83.0,
      forecast_complete: 55.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-10-03",
      baseline_complete: 83.1,
      actual_complete: 83.0,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-10-10",
      baseline_complete: 83.7,
      actual_complete: 83.6,
      forecast_complete: 56.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-10-17",
      baseline_complete: 84.4,
      actual_complete: 83.6,
      forecast_complete: 57.7,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-10-24",
      baseline_complete: 85.0,
      actual_complete: 86.0,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-10-31",
      baseline_complete: 85.6,
      actual_complete: 86.0,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-11-07",
      baseline_complete: 86.2,
      actual_complete: 86.3,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-11-14",
      baseline_complete: 86.7,
      actual_complete: 87.0,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-11-21",
      baseline_complete: 87.3,
      actual_complete: 87.2,
      forecast_complete: 61.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-11-28",
      baseline_complete: 87.8,
      actual_complete: 87.3,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-12-05",
      baseline_complete: 88.3,
      actual_complete: 87.3,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-12-12",
      baseline_complete: 88.8,
      actual_complete: 89.4,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-12-19",
      baseline_complete: 89.3,
      actual_complete: 89.4,
      forecast_complete: 64.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2025-12-26",
      baseline_complete: 89.7,
      actual_complete: 89.9,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-01-02",
      baseline_complete: 90.1,
      actual_complete: 89.9,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-01-09",
      baseline_complete: 90.6,
      actual_complete: 91.0,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-01-16",
      baseline_complete: 91.0,
      actual_complete: 92.1,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-01-23",
      baseline_complete: 91.4,
      actual_complete: 92.1,
      forecast_complete: 68.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-01-30",
      baseline_complete: 91.7,
      actual_complete: 92.1,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-02-06",
      baseline_complete: 92.1,
      actual_complete: 92.1,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-02-13",
      baseline_complete: 92.4,
      actual_complete: 93.6,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-02-20",
      baseline_complete: 92.7,
      actual_complete: 93.6,
      forecast_complete: 72.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-02-27",
      baseline_complete: 93.1,
      actual_complete: 93.6,
      forecast_complete: 73.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-03-06",
      baseline_complete: 93.4,
      actual_complete: 93.6,
      forecast_complete: 75.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-03-13",
      baseline_complete: 93.7,
      actual_complete: 94.2,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-03-20",
      baseline_complete: 93.9,
      actual_complete: 94.9,
      forecast_complete: 77.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-03-27",
      baseline_complete: 94.2,
      actual_complete: 96.8,
      forecast_complete: 78.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-04-03",
      baseline_complete: 94.5,
      actual_complete: 96.8,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-04-10",
      baseline_complete: 94.7,
      actual_complete: 96.8,
      forecast_complete: 80.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-04-17",
      baseline_complete: 94.9,
      actual_complete: 96.8,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-04-24",
      baseline_complete: 95.2,
      actual_complete: 96.8,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-05-01",
      baseline_complete: 95.4,
      actual_complete: 96.8,
      forecast_complete: 83.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-05-08",
      baseline_complete: 95.6,
      actual_complete: 96.8,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-05-15",
      baseline_complete: 95.8,
      actual_complete: 97.3,
      forecast_complete: 85.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-05-22",
      baseline_complete: 96.0,
      actual_complete: 97.3,
      forecast_complete: 85.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-05-29",
      baseline_complete: 96.2,
      actual_complete: 97.3,
      forecast_complete: 86.8,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-06-05",
      baseline_complete: 96.3,
      actual_complete: 97.3,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-06-12",
      baseline_complete: 96.5,
      actual_complete: 97.3,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-06-19",
      baseline_complete: 96.7,
      actual_complete: 99.3,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-06-26",
      baseline_complete: 96.8,
      actual_complete: 99.3,
      forecast_complete: 89.7,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-07-03",
      baseline_complete: 96.9,
      actual_complete: 99.3,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-07-10",
      baseline_complete: 97.1,
      actual_complete: 99.3,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-07-17",
      baseline_complete: 97.2,
      actual_complete: 99.3,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-07-24",
      baseline_complete: 97.3,
      actual_complete: 99.3,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-07-31",
      baseline_complete: 97.5,
      actual_complete: 99.3,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-08-07",
      baseline_complete: 97.6,
      actual_complete: 99.3,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-08-14",
      baseline_complete: 97.7,
      actual_complete: 99.3,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-08-21",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-08-28",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-09-04",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-09-11",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-09-18",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-09-25",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-10-02",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-10-09",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-10-16",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-10-23",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-10-30",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-11-06",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-11-13",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-11-20",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-11-27",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-12-04",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-12-11",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-12-18",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2026-12-25",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2027-01-01",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2027-01-08",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2027-01-15",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2027-01-22",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2027-01-29",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "a2d99805-73f0-c858-b709-fbda2482cfcd",
      reporting_date: "2027-02-03",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e": [
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-08-29",
      baseline_complete: 0.5,
      actual_complete: 1.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-09-05",
      baseline_complete: 0.5,
      actual_complete: 1.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-09-12",
      baseline_complete: 0.6,
      actual_complete: 1.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-09-19",
      baseline_complete: 0.6,
      actual_complete: 1.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-09-26",
      baseline_complete: 0.6,
      actual_complete: 1.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-10-03",
      baseline_complete: 0.7,
      actual_complete: 1.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-10-10",
      baseline_complete: 0.7,
      actual_complete: 1.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-10-17",
      baseline_complete: 0.7,
      actual_complete: 1.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-10-24",
      baseline_complete: 0.8,
      actual_complete: 1.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-10-31",
      baseline_complete: 0.8,
      actual_complete: 2.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-11-07",
      baseline_complete: 0.8,
      actual_complete: 2.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-11-14",
      baseline_complete: 0.9,
      actual_complete: 2.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-11-21",
      baseline_complete: 0.9,
      actual_complete: 2.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-11-28",
      baseline_complete: 1.0,
      actual_complete: 2.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-12-05",
      baseline_complete: 1.0,
      actual_complete: 2.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-12-12",
      baseline_complete: 1.1,
      actual_complete: 2.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-12-19",
      baseline_complete: 1.1,
      actual_complete: 2.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2023-12-26",
      baseline_complete: 1.2,
      actual_complete: 2.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-01-02",
      baseline_complete: 1.2,
      actual_complete: 2.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-01-09",
      baseline_complete: 1.3,
      actual_complete: 2.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-01-16",
      baseline_complete: 1.3,
      actual_complete: 2.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-01-23",
      baseline_complete: 1.4,
      actual_complete: 2.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-01-30",
      baseline_complete: 1.5,
      actual_complete: 2.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-02-06",
      baseline_complete: 1.6,
      actual_complete: 2.8,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-02-13",
      baseline_complete: 1.6,
      actual_complete: 2.8,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-02-20",
      baseline_complete: 1.7,
      actual_complete: 2.8,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-02-27",
      baseline_complete: 1.8,
      actual_complete: 2.8,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-03-05",
      baseline_complete: 1.9,
      actual_complete: 2.8,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-03-12",
      baseline_complete: 2.0,
      actual_complete: 2.8,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-03-19",
      baseline_complete: 2.1,
      actual_complete: 3.5,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-03-26",
      baseline_complete: 2.2,
      actual_complete: 3.5,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-04-02",
      baseline_complete: 2.3,
      actual_complete: 3.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-04-09",
      baseline_complete: 2.4,
      actual_complete: 3.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-04-16",
      baseline_complete: 2.5,
      actual_complete: 3.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-04-23",
      baseline_complete: 2.6,
      actual_complete: 3.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-04-30",
      baseline_complete: 2.7,
      actual_complete: 3.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-05-07",
      baseline_complete: 2.8,
      actual_complete: 3.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-05-14",
      baseline_complete: 3.0,
      actual_complete: 4.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-05-21",
      baseline_complete: 3.1,
      actual_complete: 4.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-05-28",
      baseline_complete: 3.3,
      actual_complete: 4.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-06-04",
      baseline_complete: 3.4,
      actual_complete: 4.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-06-11",
      baseline_complete: 3.6,
      actual_complete: 4.4,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-06-18",
      baseline_complete: 3.7,
      actual_complete: 4.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-06-25",
      baseline_complete: 3.9,
      actual_complete: 4.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-07-02",
      baseline_complete: 4.1,
      actual_complete: 4.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-07-09",
      baseline_complete: 4.3,
      actual_complete: 4.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-07-16",
      baseline_complete: 4.5,
      actual_complete: 4.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-07-23",
      baseline_complete: 4.7,
      actual_complete: 5.2,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-07-30",
      baseline_complete: 4.9,
      actual_complete: 5.2,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-08-06",
      baseline_complete: 5.2,
      actual_complete: 5.2,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-08-13",
      baseline_complete: 5.4,
      actual_complete: 5.2,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-08-20",
      baseline_complete: 5.6,
      actual_complete: 5.2,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-08-27",
      baseline_complete: 5.9,
      actual_complete: 7.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-09-03",
      baseline_complete: 6.2,
      actual_complete: 7.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-09-10",
      baseline_complete: 6.4,
      actual_complete: 8.1,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-09-17",
      baseline_complete: 6.7,
      actual_complete: 8.1,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-09-24",
      baseline_complete: 7.0,
      actual_complete: 8.1,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-10-01",
      baseline_complete: 7.4,
      actual_complete: 8.1,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-10-08",
      baseline_complete: 7.7,
      actual_complete: 9.5,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-10-15",
      baseline_complete: 8.0,
      actual_complete: 9.5,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-10-22",
      baseline_complete: 8.4,
      actual_complete: 9.5,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-10-29",
      baseline_complete: 8.8,
      actual_complete: 10.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-11-05",
      baseline_complete: 9.2,
      actual_complete: 10.6,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-11-12",
      baseline_complete: 9.6,
      actual_complete: 11.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-11-19",
      baseline_complete: 10.0,
      actual_complete: 11.5,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-11-26",
      baseline_complete: 10.4,
      actual_complete: 11.5,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-12-03",
      baseline_complete: 10.9,
      actual_complete: 11.6,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-12-10",
      baseline_complete: 11.3,
      actual_complete: 12.0,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-12-17",
      baseline_complete: 11.8,
      actual_complete: 13.4,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-12-24",
      baseline_complete: 12.3,
      actual_complete: 13.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2024-12-31",
      baseline_complete: 12.9,
      actual_complete: 13.4,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-01-07",
      baseline_complete: 13.4,
      actual_complete: 13.4,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-01-14",
      baseline_complete: 14.0,
      actual_complete: 13.9,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-01-21",
      baseline_complete: 14.6,
      actual_complete: 13.9,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-01-28",
      baseline_complete: 15.2,
      actual_complete: 16.1,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-02-04",
      baseline_complete: 15.8,
      actual_complete: 16.2,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-02-11",
      baseline_complete: 16.4,
      actual_complete: 18.7,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-02-18",
      baseline_complete: 17.1,
      actual_complete: 18.7,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-02-25",
      baseline_complete: 17.8,
      actual_complete: 18.7,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-03-04",
      baseline_complete: 18.5,
      actual_complete: 18.9,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-03-11",
      baseline_complete: 19.2,
      actual_complete: 18.9,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-03-18",
      baseline_complete: 20.0,
      actual_complete: 18.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-03-25",
      baseline_complete: 20.7,
      actual_complete: 21.7,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-04-01",
      baseline_complete: 21.5,
      actual_complete: 21.7,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-04-08",
      baseline_complete: 22.3,
      actual_complete: 22.1,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-04-15",
      baseline_complete: 23.2,
      actual_complete: 24.4,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-04-22",
      baseline_complete: 24.0,
      actual_complete: 24.4,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-04-29",
      baseline_complete: 24.9,
      actual_complete: 26.0,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-05-06",
      baseline_complete: 25.8,
      actual_complete: 26.0,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-05-13",
      baseline_complete: 26.7,
      actual_complete: 26.7,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-05-20",
      baseline_complete: 27.7,
      actual_complete: 26.7,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-05-27",
      baseline_complete: 28.6,
      actual_complete: 27.6,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-06-03",
      baseline_complete: 29.6,
      actual_complete: 30.7,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-06-10",
      baseline_complete: 30.6,
      actual_complete: 30.7,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-06-17",
      baseline_complete: 31.6,
      actual_complete: 30.7,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-06-24",
      baseline_complete: 32.7,
      actual_complete: 35.1,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-07-01",
      baseline_complete: 33.7,
      actual_complete: 35.1,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-07-08",
      baseline_complete: 34.8,
      actual_complete: 36.4,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-07-15",
      baseline_complete: 35.9,
      actual_complete: 37.6,
      forecast_complete: 14.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-07-22",
      baseline_complete: 37.0,
      actual_complete: 37.6,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-07-29",
      baseline_complete: 38.1,
      actual_complete: 38.8,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-08-05",
      baseline_complete: 39.2,
      actual_complete: 41.2,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-08-12",
      baseline_complete: 40.4,
      actual_complete: 41.2,
      forecast_complete: 16.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-08-19",
      baseline_complete: 41.5,
      actual_complete: 41.6,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-08-26",
      baseline_complete: 42.7,
      actual_complete: 43.1,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-09-02",
      baseline_complete: 43.9,
      actual_complete: 45.4,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-09-09",
      baseline_complete: 45.0,
      actual_complete: 45.4,
      forecast_complete: 19.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-09-16",
      baseline_complete: 46.2,
      actual_complete: 48.7,
      forecast_complete: 20.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-09-23",
      baseline_complete: 47.4,
      actual_complete: 48.7,
      forecast_complete: 20.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-09-30",
      baseline_complete: 48.6,
      actual_complete: 48.7,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-10-07",
      baseline_complete: 49.8,
      actual_complete: 48.7,
      forecast_complete: 22.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-10-14",
      baseline_complete: 51.0,
      actual_complete: 53.4,
      forecast_complete: 23.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-10-21",
      baseline_complete: 52.2,
      actual_complete: 53.4,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-10-28",
      baseline_complete: 53.4,
      actual_complete: 53.4,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-11-04",
      baseline_complete: 54.5,
      actual_complete: 53.9,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-11-11",
      baseline_complete: 55.7,
      actual_complete: 55.7,
      forecast_complete: 26.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-11-18",
      baseline_complete: 56.9,
      actual_complete: 57.6,
      forecast_complete: 26.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-11-25",
      baseline_complete: 58.1,
      actual_complete: 59.6,
      forecast_complete: 27.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-12-02",
      baseline_complete: 59.2,
      actual_complete: 59.6,
      forecast_complete: 28.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-12-09",
      baseline_complete: 60.3,
      actual_complete: 62.1,
      forecast_complete: 29.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-12-16",
      baseline_complete: 61.5,
      actual_complete: 62.1,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-12-23",
      baseline_complete: 62.6,
      actual_complete: 63.5,
      forecast_complete: 30.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2025-12-30",
      baseline_complete: 63.7,
      actual_complete: 66.8,
      forecast_complete: 31.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-01-06",
      baseline_complete: 64.8,
      actual_complete: 66.8,
      forecast_complete: 32.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-01-13",
      baseline_complete: 65.9,
      actual_complete: 67.6,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-01-20",
      baseline_complete: 66.9,
      actual_complete: 67.8,
      forecast_complete: 34.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-01-27",
      baseline_complete: 68.0,
      actual_complete: 69.2,
      forecast_complete: 34.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-02-03",
      baseline_complete: 69.0,
      actual_complete: 71.5,
      forecast_complete: 35.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-02-10",
      baseline_complete: 70.0,
      actual_complete: 71.5,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-02-17",
      baseline_complete: 71.0,
      actual_complete: 71.5,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-02-24",
      baseline_complete: 72.0,
      actual_complete: 73.4,
      forecast_complete: 38.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-03-03",
      baseline_complete: 72.9,
      actual_complete: 76.1,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-03-10",
      baseline_complete: 73.9,
      actual_complete: 76.1,
      forecast_complete: 39.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-03-17",
      baseline_complete: 74.8,
      actual_complete: 76.1,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-03-24",
      baseline_complete: 75.7,
      actual_complete: 77.3,
      forecast_complete: 41.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-03-31",
      baseline_complete: 76.5,
      actual_complete: 77.3,
      forecast_complete: 42.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-04-07",
      baseline_complete: 77.4,
      actual_complete: 77.3,
      forecast_complete: 42.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-04-14",
      baseline_complete: 78.2,
      actual_complete: 78.3,
      forecast_complete: 43.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-04-21",
      baseline_complete: 79.0,
      actual_complete: 79.9,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-04-28",
      baseline_complete: 79.8,
      actual_complete: 80.5,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-05-05",
      baseline_complete: 80.5,
      actual_complete: 80.7,
      forecast_complete: 45.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-05-12",
      baseline_complete: 81.3,
      actual_complete: 83.9,
      forecast_complete: 46.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-05-19",
      baseline_complete: 82.0,
      actual_complete: 83.9,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-05-26",
      baseline_complete: 82.7,
      actual_complete: 83.9,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-06-02",
      baseline_complete: 83.3,
      actual_complete: 84.1,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-06-09",
      baseline_complete: 84.0,
      actual_complete: 84.8,
      forecast_complete: 49.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-06-16",
      baseline_complete: 84.6,
      actual_complete: 85.3,
      forecast_complete: 50.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-06-23",
      baseline_complete: 85.2,
      actual_complete: 85.3,
      forecast_complete: 50.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-06-30",
      baseline_complete: 85.8,
      actual_complete: 87.6,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-07-07",
      baseline_complete: 86.4,
      actual_complete: 89.5,
      forecast_complete: 52.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-07-14",
      baseline_complete: 86.9,
      actual_complete: 89.5,
      forecast_complete: 53.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-07-21",
      baseline_complete: 87.5,
      actual_complete: 90.0,
      forecast_complete: 53.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-07-28",
      baseline_complete: 88.0,
      actual_complete: 90.0,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-08-04",
      baseline_complete: 88.5,
      actual_complete: 90.0,
      forecast_complete: 55.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-08-11",
      baseline_complete: 89.0,
      actual_complete: 91.4,
      forecast_complete: 55.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-08-18",
      baseline_complete: 89.4,
      actual_complete: 91.4,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-08-25",
      baseline_complete: 89.9,
      actual_complete: 91.4,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-09-01",
      baseline_complete: 90.3,
      actual_complete: 92.7,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-09-08",
      baseline_complete: 90.7,
      actual_complete: 92.7,
      forecast_complete: 58.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-09-15",
      baseline_complete: 91.1,
      actual_complete: 92.9,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-09-22",
      baseline_complete: 91.5,
      actual_complete: 92.9,
      forecast_complete: 59.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-09-29",
      baseline_complete: 91.8,
      actual_complete: 94.9,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-10-06",
      baseline_complete: 92.2,
      actual_complete: 94.9,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-10-13",
      baseline_complete: 92.5,
      actual_complete: 94.9,
      forecast_complete: 61.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-10-20",
      baseline_complete: 92.8,
      actual_complete: 95.8,
      forecast_complete: 61.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-10-27",
      baseline_complete: 93.2,
      actual_complete: 95.8,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-11-03",
      baseline_complete: 93.4,
      actual_complete: 95.8,
      forecast_complete: 63.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-11-10",
      baseline_complete: 93.7,
      actual_complete: 95.8,
      forecast_complete: 63.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-11-17",
      baseline_complete: 94.0,
      actual_complete: 96.1,
      forecast_complete: 64.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-11-24",
      baseline_complete: 94.3,
      actual_complete: 97.0,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-12-01",
      baseline_complete: 94.5,
      actual_complete: 97.0,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-12-08",
      baseline_complete: 94.8,
      actual_complete: 97.0,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-12-15",
      baseline_complete: 95.0,
      actual_complete: 97.0,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-12-22",
      baseline_complete: 95.2,
      actual_complete: 97.0,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2026-12-29",
      baseline_complete: 95.4,
      actual_complete: 97.0,
      forecast_complete: 67.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-01-05",
      baseline_complete: 95.6,
      actual_complete: 97.0,
      forecast_complete: 68.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-01-12",
      baseline_complete: 95.8,
      actual_complete: 98.6,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-01-19",
      baseline_complete: 96.0,
      actual_complete: 98.6,
      forecast_complete: 69.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-01-26",
      baseline_complete: 96.2,
      actual_complete: 98.6,
      forecast_complete: 69.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-02-02",
      baseline_complete: 96.4,
      actual_complete: 98.6,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-02-09",
      baseline_complete: 96.5,
      actual_complete: 99.7,
      forecast_complete: 70.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-02-16",
      baseline_complete: 96.7,
      actual_complete: 99.7,
      forecast_complete: 71.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-02-23",
      baseline_complete: 96.8,
      actual_complete: 99.7,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-03-02",
      baseline_complete: 97.0,
      actual_complete: 99.7,
      forecast_complete: 72.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-03-09",
      baseline_complete: 97.1,
      actual_complete: 99.7,
      forecast_complete: 73.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-03-16",
      baseline_complete: 97.2,
      actual_complete: 99.7,
      forecast_complete: 73.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-03-23",
      baseline_complete: 97.4,
      actual_complete: 99.7,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-03-30",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 75.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-04-06",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 76.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-04-13",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-04-20",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 78.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-04-27",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 79.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-05-04",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-05-11",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 80.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-05-18",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-05-25",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 82.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-06-01",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-06-08",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 83.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-06-15",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 84.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-06-22",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-06-29",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 85.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-07-06",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 86.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-07-13",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 86.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-07-20",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 87.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-07-27",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 87.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-08-03",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-08-10",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-08-17",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-08-24",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-08-31",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-09-07",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-09-14",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-09-21",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-09-28",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-10-05",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-10-12",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-10-19",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-10-26",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-11-02",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-11-09",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-11-16",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-11-23",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-11-30",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-12-07",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-12-14",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-12-21",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2027-12-28",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-01-04",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-01-11",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-01-18",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-01-25",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-02-01",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-02-08",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-02-15",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-02-22",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-02-29",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-03-07",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-03-14",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-03-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-03-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-04-04",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-04-11",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-04-18",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-04-25",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "1be3ac16-038f-0ef7-5b87-e0cb6bb7f06e",
      reporting_date: "2028-04-29",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
  ],
  "0f1714ac-cc77-e427-da57-3abacd8ef051": [
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-07-16",
      baseline_complete: 0.2,
      actual_complete: 2.1,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-07-23",
      baseline_complete: 0.2,
      actual_complete: 3.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-07-30",
      baseline_complete: 0.2,
      actual_complete: 5.5,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-08-06",
      baseline_complete: 0.2,
      actual_complete: 5.5,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-08-13",
      baseline_complete: 0.3,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-08-20",
      baseline_complete: 0.3,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-08-27",
      baseline_complete: 0.3,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-09-03",
      baseline_complete: 0.3,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-09-10",
      baseline_complete: 0.3,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-09-17",
      baseline_complete: 0.3,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-09-24",
      baseline_complete: 0.4,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-10-01",
      baseline_complete: 0.4,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-10-08",
      baseline_complete: 0.4,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-10-15",
      baseline_complete: 0.4,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-10-22",
      baseline_complete: 0.4,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-10-29",
      baseline_complete: 0.4,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-11-05",
      baseline_complete: 0.5,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-11-12",
      baseline_complete: 0.5,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-11-19",
      baseline_complete: 0.5,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-11-26",
      baseline_complete: 0.5,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-12-03",
      baseline_complete: 0.6,
      actual_complete: 5.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-12-10",
      baseline_complete: 0.6,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-12-17",
      baseline_complete: 0.6,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-12-24",
      baseline_complete: 0.7,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2023-12-31",
      baseline_complete: 0.7,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-01-07",
      baseline_complete: 0.7,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-01-14",
      baseline_complete: 0.8,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-01-21",
      baseline_complete: 0.8,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-01-28",
      baseline_complete: 0.8,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-02-04",
      baseline_complete: 0.9,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-02-11",
      baseline_complete: 0.9,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-02-18",
      baseline_complete: 1.0,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-02-25",
      baseline_complete: 1.0,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-03-03",
      baseline_complete: 1.1,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-03-10",
      baseline_complete: 1.1,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-03-17",
      baseline_complete: 1.2,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-03-24",
      baseline_complete: 1.2,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-03-31",
      baseline_complete: 1.3,
      actual_complete: 5.8,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-04-07",
      baseline_complete: 1.4,
      actual_complete: 6.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-04-14",
      baseline_complete: 1.4,
      actual_complete: 6.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-04-21",
      baseline_complete: 1.5,
      actual_complete: 6.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-04-28",
      baseline_complete: 1.6,
      actual_complete: 6.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-05-05",
      baseline_complete: 1.7,
      actual_complete: 6.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-05-12",
      baseline_complete: 1.7,
      actual_complete: 6.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-05-19",
      baseline_complete: 1.8,
      actual_complete: 6.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-05-26",
      baseline_complete: 1.9,
      actual_complete: 6.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-06-02",
      baseline_complete: 2.0,
      actual_complete: 6.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-06-09",
      baseline_complete: 2.1,
      actual_complete: 6.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-06-16",
      baseline_complete: 2.2,
      actual_complete: 7.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-06-23",
      baseline_complete: 2.3,
      actual_complete: 7.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-06-30",
      baseline_complete: 2.4,
      actual_complete: 7.6,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-07-07",
      baseline_complete: 2.6,
      actual_complete: 7.6,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-07-14",
      baseline_complete: 2.7,
      actual_complete: 7.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-07-21",
      baseline_complete: 2.8,
      actual_complete: 7.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-07-28",
      baseline_complete: 3.0,
      actual_complete: 7.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-08-04",
      baseline_complete: 3.1,
      actual_complete: 7.6,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-08-11",
      baseline_complete: 3.3,
      actual_complete: 7.6,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-08-18",
      baseline_complete: 3.4,
      actual_complete: 7.6,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-08-25",
      baseline_complete: 3.6,
      actual_complete: 7.6,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-09-01",
      baseline_complete: 3.8,
      actual_complete: 7.6,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-09-08",
      baseline_complete: 3.9,
      actual_complete: 7.6,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-09-15",
      baseline_complete: 4.1,
      actual_complete: 7.6,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-09-22",
      baseline_complete: 4.3,
      actual_complete: 8.4,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-09-29",
      baseline_complete: 4.5,
      actual_complete: 8.4,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-10-06",
      baseline_complete: 4.7,
      actual_complete: 8.4,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-10-13",
      baseline_complete: 5.0,
      actual_complete: 8.6,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-10-20",
      baseline_complete: 5.2,
      actual_complete: 8.6,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-10-27",
      baseline_complete: 5.5,
      actual_complete: 8.6,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-11-03",
      baseline_complete: 5.7,
      actual_complete: 9.4,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-11-10",
      baseline_complete: 6.0,
      actual_complete: 10.8,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-11-17",
      baseline_complete: 6.3,
      actual_complete: 10.8,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-11-24",
      baseline_complete: 6.6,
      actual_complete: 10.8,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-12-01",
      baseline_complete: 6.9,
      actual_complete: 10.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-12-08",
      baseline_complete: 7.2,
      actual_complete: 10.8,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-12-15",
      baseline_complete: 7.5,
      actual_complete: 10.8,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-12-22",
      baseline_complete: 7.9,
      actual_complete: 10.8,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2024-12-29",
      baseline_complete: 8.2,
      actual_complete: 10.8,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-01-05",
      baseline_complete: 8.6,
      actual_complete: 11.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-01-12",
      baseline_complete: 9.0,
      actual_complete: 13.3,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-01-19",
      baseline_complete: 9.4,
      actual_complete: 13.3,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-01-26",
      baseline_complete: 9.9,
      actual_complete: 14.1,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-02-02",
      baseline_complete: 10.3,
      actual_complete: 14.6,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-02-09",
      baseline_complete: 10.8,
      actual_complete: 14.7,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-02-16",
      baseline_complete: 11.2,
      actual_complete: 15.5,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-02-23",
      baseline_complete: 11.7,
      actual_complete: 15.5,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-03-02",
      baseline_complete: 12.3,
      actual_complete: 15.5,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-03-09",
      baseline_complete: 12.8,
      actual_complete: 16.7,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-03-16",
      baseline_complete: 13.4,
      actual_complete: 16.7,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-03-23",
      baseline_complete: 13.9,
      actual_complete: 16.7,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-03-30",
      baseline_complete: 14.5,
      actual_complete: 17.1,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-04-06",
      baseline_complete: 15.2,
      actual_complete: 17.1,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-04-13",
      baseline_complete: 15.8,
      actual_complete: 17.6,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-04-20",
      baseline_complete: 16.5,
      actual_complete: 18.6,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-04-27",
      baseline_complete: 17.1,
      actual_complete: 20.0,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-05-04",
      baseline_complete: 17.9,
      actual_complete: 22.5,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-05-11",
      baseline_complete: 18.6,
      actual_complete: 22.5,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-05-18",
      baseline_complete: 19.3,
      actual_complete: 23.5,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-05-25",
      baseline_complete: 20.1,
      actual_complete: 23.5,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-06-01",
      baseline_complete: 20.9,
      actual_complete: 23.5,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-06-08",
      baseline_complete: 21.7,
      actual_complete: 25.4,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-06-15",
      baseline_complete: 22.6,
      actual_complete: 25.9,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-06-22",
      baseline_complete: 23.5,
      actual_complete: 25.9,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-06-29",
      baseline_complete: 24.3,
      actual_complete: 25.9,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-07-06",
      baseline_complete: 25.3,
      actual_complete: 26.5,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-07-13",
      baseline_complete: 26.2,
      actual_complete: 29.8,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-07-20",
      baseline_complete: 27.2,
      actual_complete: 29.9,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-07-27",
      baseline_complete: 28.1,
      actual_complete: 31.0,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-08-03",
      baseline_complete: 29.1,
      actual_complete: 31.0,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-08-10",
      baseline_complete: 30.2,
      actual_complete: 31.5,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-08-17",
      baseline_complete: 31.2,
      actual_complete: 34.4,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-08-24",
      baseline_complete: 32.3,
      actual_complete: 34.4,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-08-31",
      baseline_complete: 33.4,
      actual_complete: 35.7,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-09-07",
      baseline_complete: 34.5,
      actual_complete: 35.7,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-09-14",
      baseline_complete: 35.6,
      actual_complete: 36.5,
      forecast_complete: 18.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-09-21",
      baseline_complete: 36.7,
      actual_complete: 37.9,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-09-28",
      baseline_complete: 37.9,
      actual_complete: 41.5,
      forecast_complete: 20.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-10-05",
      baseline_complete: 39.0,
      actual_complete: 41.5,
      forecast_complete: 20.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-10-12",
      baseline_complete: 40.2,
      actual_complete: 44.6,
      forecast_complete: 21.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-10-19",
      baseline_complete: 41.4,
      actual_complete: 44.6,
      forecast_complete: 22.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-10-26",
      baseline_complete: 42.6,
      actual_complete: 45.6,
      forecast_complete: 23.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-11-02",
      baseline_complete: 43.8,
      actual_complete: 45.6,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-11-09",
      baseline_complete: 45.0,
      actual_complete: 48.2,
      forecast_complete: 24.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-11-16",
      baseline_complete: 46.2,
      actual_complete: 48.5,
      forecast_complete: 25.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-11-23",
      baseline_complete: 47.4,
      actual_complete: 51.3,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-11-30",
      baseline_complete: 48.7,
      actual_complete: 52.1,
      forecast_complete: 27.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-12-07",
      baseline_complete: 49.9,
      actual_complete: 52.5,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-12-14",
      baseline_complete: 51.1,
      actual_complete: 52.5,
      forecast_complete: 28.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-12-21",
      baseline_complete: 52.3,
      actual_complete: 55.7,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2025-12-28",
      baseline_complete: 53.6,
      actual_complete: 58.4,
      forecast_complete: 30.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-01-04",
      baseline_complete: 54.8,
      actual_complete: 58.4,
      forecast_complete: 31.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-01-11",
      baseline_complete: 56.0,
      actual_complete: 58.4,
      forecast_complete: 32.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-01-18",
      baseline_complete: 57.2,
      actual_complete: 59.1,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-01-25",
      baseline_complete: 58.4,
      actual_complete: 60.0,
      forecast_complete: 34.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-02-01",
      baseline_complete: 59.6,
      actual_complete: 61.5,
      forecast_complete: 35.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-02-08",
      baseline_complete: 60.8,
      actual_complete: 62.1,
      forecast_complete: 36.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-02-15",
      baseline_complete: 61.9,
      actual_complete: 66.3,
      forecast_complete: 37.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-02-22",
      baseline_complete: 63.1,
      actual_complete: 66.3,
      forecast_complete: 38.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-03-01",
      baseline_complete: 64.2,
      actual_complete: 66.3,
      forecast_complete: 39.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-03-08",
      baseline_complete: 65.3,
      actual_complete: 66.3,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-03-15",
      baseline_complete: 66.4,
      actual_complete: 71.2,
      forecast_complete: 40.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-03-22",
      baseline_complete: 67.5,
      actual_complete: 71.2,
      forecast_complete: 41.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-03-29",
      baseline_complete: 68.6,
      actual_complete: 71.6,
      forecast_complete: 42.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-04-05",
      baseline_complete: 69.6,
      actual_complete: 71.6,
      forecast_complete: 43.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-04-12",
      baseline_complete: 70.7,
      actual_complete: 74.8,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-04-19",
      baseline_complete: 71.7,
      actual_complete: 74.8,
      forecast_complete: 45.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-04-26",
      baseline_complete: 72.6,
      actual_complete: 74.8,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-05-03",
      baseline_complete: 73.6,
      actual_complete: 78.1,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-05-10",
      baseline_complete: 74.6,
      actual_complete: 78.1,
      forecast_complete: 48.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-05-17",
      baseline_complete: 75.5,
      actual_complete: 78.1,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-05-24",
      baseline_complete: 76.4,
      actual_complete: 80.0,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-05-31",
      baseline_complete: 77.2,
      actual_complete: 80.0,
      forecast_complete: 51.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-06-07",
      baseline_complete: 78.1,
      actual_complete: 80.0,
      forecast_complete: 51.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-06-14",
      baseline_complete: 78.9,
      actual_complete: 81.3,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-06-21",
      baseline_complete: 79.7,
      actual_complete: 81.3,
      forecast_complete: 53.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-06-28",
      baseline_complete: 80.5,
      actual_complete: 81.3,
      forecast_complete: 54.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-07-05",
      baseline_complete: 81.3,
      actual_complete: 83.9,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-07-12",
      baseline_complete: 82.0,
      actual_complete: 85.7,
      forecast_complete: 56.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-07-19",
      baseline_complete: 82.7,
      actual_complete: 85.7,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-07-26",
      baseline_complete: 83.4,
      actual_complete: 86.4,
      forecast_complete: 57.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-08-02",
      baseline_complete: 84.1,
      actual_complete: 87.2,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-08-09",
      baseline_complete: 84.7,
      actual_complete: 87.2,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-08-16",
      baseline_complete: 85.3,
      actual_complete: 89.7,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-08-23",
      baseline_complete: 85.9,
      actual_complete: 89.7,
      forecast_complete: 61.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-08-30",
      baseline_complete: 86.5,
      actual_complete: 89.7,
      forecast_complete: 61.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-09-06",
      baseline_complete: 87.1,
      actual_complete: 89.7,
      forecast_complete: 62.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-09-13",
      baseline_complete: 87.6,
      actual_complete: 89.7,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-09-20",
      baseline_complete: 88.2,
      actual_complete: 91.3,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-09-27",
      baseline_complete: 88.7,
      actual_complete: 91.3,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-10-04",
      baseline_complete: 89.1,
      actual_complete: 92.4,
      forecast_complete: 65.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-10-11",
      baseline_complete: 89.6,
      actual_complete: 92.4,
      forecast_complete: 66.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-10-18",
      baseline_complete: 90.1,
      actual_complete: 92.8,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-10-25",
      baseline_complete: 90.5,
      actual_complete: 92.8,
      forecast_complete: 67.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-11-01",
      baseline_complete: 90.9,
      actual_complete: 92.8,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-11-08",
      baseline_complete: 91.3,
      actual_complete: 93.3,
      forecast_complete: 69.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-11-15",
      baseline_complete: 91.7,
      actual_complete: 94.7,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-11-22",
      baseline_complete: 92.0,
      actual_complete: 95.0,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-11-29",
      baseline_complete: 92.4,
      actual_complete: 95.0,
      forecast_complete: 72.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-12-06",
      baseline_complete: 92.7,
      actual_complete: 95.0,
      forecast_complete: 73.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-12-13",
      baseline_complete: 93.1,
      actual_complete: 95.0,
      forecast_complete: 74.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-12-20",
      baseline_complete: 93.4,
      actual_complete: 95.0,
      forecast_complete: 75.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2026-12-27",
      baseline_complete: 93.7,
      actual_complete: 95.0,
      forecast_complete: 76.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-01-03",
      baseline_complete: 94.0,
      actual_complete: 96.2,
      forecast_complete: 77.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-01-10",
      baseline_complete: 94.2,
      actual_complete: 97.7,
      forecast_complete: 78.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-01-17",
      baseline_complete: 94.5,
      actual_complete: 97.7,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-01-24",
      baseline_complete: 94.7,
      actual_complete: 97.7,
      forecast_complete: 80.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-01-31",
      baseline_complete: 95.0,
      actual_complete: 97.7,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-02-07",
      baseline_complete: 95.2,
      actual_complete: 97.8,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-02-14",
      baseline_complete: 95.4,
      actual_complete: 98.0,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-02-21",
      baseline_complete: 95.6,
      actual_complete: 98.0,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-02-28",
      baseline_complete: 95.8,
      actual_complete: 98.7,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-03-07",
      baseline_complete: 96.0,
      actual_complete: 98.7,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-03-14",
      baseline_complete: 96.2,
      actual_complete: 98.7,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-03-21",
      baseline_complete: 96.4,
      actual_complete: 99.8,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-03-28",
      baseline_complete: 96.6,
      actual_complete: 99.8,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-04-04",
      baseline_complete: 96.7,
      actual_complete: 99.8,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-04-11",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 89.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-04-18",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-04-25",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-05-02",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-05-09",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-05-16",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 91.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-05-23",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-05-30",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-06-06",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-06-13",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-06-20",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-06-27",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-07-04",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-07-11",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-07-18",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-07-25",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-08-01",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-08-08",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-08-15",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-08-22",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-08-29",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-09-05",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-09-12",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-09-19",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-09-26",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-10-03",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-10-10",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-10-17",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-10-24",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-10-31",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-11-07",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-11-14",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-11-21",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-11-28",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-12-05",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-12-12",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f1714ac-cc77-e427-da57-3abacd8ef051",
      reporting_date: "2027-12-16",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "d151cb09-aaac-5f88-b892-3c1b9fff4c18": [
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-05-08",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-05-15",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-05-22",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-05-29",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-06-05",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-06-12",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-06-19",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-06-26",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-07-03",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-07-10",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-07-17",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-07-24",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-07-31",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-08-07",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-08-14",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-08-21",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-08-28",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-09-04",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-09-11",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-09-18",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-09-25",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-10-02",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-10-09",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-10-16",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-10-23",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-10-30",
      baseline_complete: 3.7,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-11-06",
      baseline_complete: 4.1,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-11-13",
      baseline_complete: 4.5,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-11-20",
      baseline_complete: 5.0,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-11-27",
      baseline_complete: 5.5,
      actual_complete: 1.0,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-12-04",
      baseline_complete: 6.1,
      actual_complete: 1.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-12-11",
      baseline_complete: 6.7,
      actual_complete: 1.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-12-18",
      baseline_complete: 7.4,
      actual_complete: 3.8,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2026-12-25",
      baseline_complete: 8.2,
      actual_complete: 3.8,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-01-01",
      baseline_complete: 9.0,
      actual_complete: 3.8,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-01-08",
      baseline_complete: 9.9,
      actual_complete: 4.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-01-15",
      baseline_complete: 10.9,
      actual_complete: 4.9,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-01-22",
      baseline_complete: 11.9,
      actual_complete: 6.4,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-01-29",
      baseline_complete: 13.1,
      actual_complete: 8.2,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-02-05",
      baseline_complete: 14.3,
      actual_complete: 11.2,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-02-12",
      baseline_complete: 15.6,
      actual_complete: 11.2,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-02-19",
      baseline_complete: 17.0,
      actual_complete: 13.4,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-02-26",
      baseline_complete: 18.6,
      actual_complete: 14.4,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-03-05",
      baseline_complete: 20.2,
      actual_complete: 14.5,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-03-12",
      baseline_complete: 21.9,
      actual_complete: 17.7,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-03-19",
      baseline_complete: 23.8,
      actual_complete: 20.5,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-03-26",
      baseline_complete: 25.7,
      actual_complete: 23.1,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-04-02",
      baseline_complete: 27.8,
      actual_complete: 24.5,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-04-09",
      baseline_complete: 29.9,
      actual_complete: 25.3,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-04-16",
      baseline_complete: 32.1,
      actual_complete: 27.0,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-04-23",
      baseline_complete: 34.5,
      actual_complete: 30.3,
      forecast_complete: 16.4,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-04-30",
      baseline_complete: 36.9,
      actual_complete: 34.0,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-05-07",
      baseline_complete: 39.3,
      actual_complete: 36.1,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-05-14",
      baseline_complete: 41.8,
      actual_complete: 38.3,
      forecast_complete: 20.6,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-05-21",
      baseline_complete: 44.4,
      actual_complete: 41.7,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-05-28",
      baseline_complete: 47.0,
      actual_complete: 44.3,
      forecast_complete: 23.7,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-06-04",
      baseline_complete: 49.6,
      actual_complete: 46.5,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-06-11",
      baseline_complete: 52.2,
      actual_complete: 50.1,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-06-18",
      baseline_complete: 54.8,
      actual_complete: 53.5,
      forecast_complete: 28.7,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-06-25",
      baseline_complete: 57.4,
      actual_complete: 53.5,
      forecast_complete: 30.5,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-07-02",
      baseline_complete: 59.9,
      actual_complete: 58.0,
      forecast_complete: 32.3,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-07-09",
      baseline_complete: 62.4,
      actual_complete: 59.9,
      forecast_complete: 34.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-07-16",
      baseline_complete: 64.8,
      actual_complete: 62.0,
      forecast_complete: 35.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-07-23",
      baseline_complete: 67.1,
      actual_complete: 64.4,
      forecast_complete: 37.6,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-07-30",
      baseline_complete: 69.4,
      actual_complete: 66.5,
      forecast_complete: 39.4,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-08-06",
      baseline_complete: 71.6,
      actual_complete: 70.1,
      forecast_complete: 41.2,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-08-13",
      baseline_complete: 73.7,
      actual_complete: 72.2,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-08-20",
      baseline_complete: 75.6,
      actual_complete: 73.3,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-08-27",
      baseline_complete: 77.5,
      actual_complete: 75.3,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-09-03",
      baseline_complete: 79.3,
      actual_complete: 77.6,
      forecast_complete: 48.2,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-09-10",
      baseline_complete: 80.9,
      actual_complete: 78.8,
      forecast_complete: 49.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-09-17",
      baseline_complete: 82.5,
      actual_complete: 80.9,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-09-24",
      baseline_complete: 84.0,
      actual_complete: 80.9,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-10-01",
      baseline_complete: 85.3,
      actual_complete: 81.9,
      forecast_complete: 54.6,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-10-08",
      baseline_complete: 86.6,
      actual_complete: 84.7,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-10-15",
      baseline_complete: 87.7,
      actual_complete: 84.8,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-10-22",
      baseline_complete: 88.8,
      actual_complete: 87.3,
      forecast_complete: 59.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-10-29",
      baseline_complete: 89.8,
      actual_complete: 88.1,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-11-05",
      baseline_complete: 90.7,
      actual_complete: 89.7,
      forecast_complete: 61.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-11-12",
      baseline_complete: 91.6,
      actual_complete: 89.7,
      forecast_complete: 63.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-11-19",
      baseline_complete: 92.3,
      actual_complete: 89.8,
      forecast_complete: 64.4,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-11-26",
      baseline_complete: 93.1,
      actual_complete: 92.5,
      forecast_complete: 65.7,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-12-03",
      baseline_complete: 93.7,
      actual_complete: 92.6,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-12-10",
      baseline_complete: 94.3,
      actual_complete: 93.0,
      forecast_complete: 68.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-12-17",
      baseline_complete: 94.8,
      actual_complete: 94.5,
      forecast_complete: 69.3,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-12-24",
      baseline_complete: 95.3,
      actual_complete: 94.5,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2027-12-31",
      baseline_complete: 95.8,
      actual_complete: 95.7,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-01-07",
      baseline_complete: 96.2,
      actual_complete: 95.7,
      forecast_complete: 72.7,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-01-14",
      baseline_complete: 96.5,
      actual_complete: 95.7,
      forecast_complete: 73.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-01-21",
      baseline_complete: 96.9,
      actual_complete: 95.8,
      forecast_complete: 75.3,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-01-28",
      baseline_complete: 97.2,
      actual_complete: 96.4,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-02-04",
      baseline_complete: 97.4,
      actual_complete: 96.4,
      forecast_complete: 79.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-02-11",
      baseline_complete: 97.7,
      actual_complete: 97.5,
      forecast_complete: 80.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-02-18",
      baseline_complete: 97.9,
      actual_complete: 98.4,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-02-25",
      baseline_complete: 98.1,
      actual_complete: 98.4,
      forecast_complete: 84.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-03-03",
      baseline_complete: 98.3,
      actual_complete: 98.4,
      forecast_complete: 85.5,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-03-10",
      baseline_complete: 98.5,
      actual_complete: 98.4,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-03-17",
      baseline_complete: 98.6,
      actual_complete: 99.7,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-03-24",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-03-31",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-04-07",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-04-14",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-04-21",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-04-28",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-05-05",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-05-12",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-05-19",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-05-26",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-06-02",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-06-09",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-06-16",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-06-23",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-06-30",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-07-07",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-07-14",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-07-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-07-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-08-04",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d151cb09-aaac-5f88-b892-3c1b9fff4c18",
      reporting_date: "2028-08-08",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "c483ece7-c6f9-83c9-1e1a-67a901041a4a": [
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-01-07",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-01-14",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-01-21",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-01-28",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-02-04",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-02-11",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-02-18",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-02-25",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-03-04",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-03-11",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-03-18",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-03-25",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-04-01",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-04-08",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-04-15",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-04-22",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-04-29",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-05-06",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-05-13",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-05-20",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-05-27",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-06-03",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-06-10",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-06-17",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-06-24",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-07-01",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-07-08",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-07-15",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-07-22",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-07-29",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-08-05",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-08-12",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-08-19",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-08-26",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-09-02",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-09-09",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-09-16",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-09-23",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-09-30",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-10-07",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-10-14",
      baseline_complete: 3.8,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-10-21",
      baseline_complete: 4.0,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-10-28",
      baseline_complete: 4.3,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-11-04",
      baseline_complete: 4.5,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-11-11",
      baseline_complete: 4.7,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-11-18",
      baseline_complete: 5.0,
      actual_complete: 0.3,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-11-25",
      baseline_complete: 5.2,
      actual_complete: 0.3,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-12-02",
      baseline_complete: 5.5,
      actual_complete: 0.3,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-12-09",
      baseline_complete: 5.8,
      actual_complete: 0.3,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-12-16",
      baseline_complete: 6.1,
      actual_complete: 2.1,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-12-23",
      baseline_complete: 6.4,
      actual_complete: 2.1,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2023-12-30",
      baseline_complete: 6.8,
      actual_complete: 2.1,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-01-06",
      baseline_complete: 7.1,
      actual_complete: 2.1,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-01-13",
      baseline_complete: 7.5,
      actual_complete: 2.1,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-01-20",
      baseline_complete: 7.9,
      actual_complete: 3.6,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-01-27",
      baseline_complete: 8.3,
      actual_complete: 3.9,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-02-03",
      baseline_complete: 8.7,
      actual_complete: 3.9,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-02-10",
      baseline_complete: 9.1,
      actual_complete: 4.3,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-02-17",
      baseline_complete: 9.6,
      actual_complete: 5.1,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-02-24",
      baseline_complete: 10.1,
      actual_complete: 5.5,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-03-02",
      baseline_complete: 10.6,
      actual_complete: 5.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-03-09",
      baseline_complete: 11.1,
      actual_complete: 8.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-03-16",
      baseline_complete: 11.7,
      actual_complete: 8.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-03-23",
      baseline_complete: 12.2,
      actual_complete: 9.1,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-03-30",
      baseline_complete: 12.8,
      actual_complete: 9.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-04-06",
      baseline_complete: 13.5,
      actual_complete: 9.3,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-04-13",
      baseline_complete: 14.1,
      actual_complete: 9.3,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-04-20",
      baseline_complete: 14.8,
      actual_complete: 9.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-04-27",
      baseline_complete: 15.5,
      actual_complete: 9.6,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-05-04",
      baseline_complete: 16.2,
      actual_complete: 9.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-05-11",
      baseline_complete: 16.9,
      actual_complete: 14.0,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-05-18",
      baseline_complete: 17.7,
      actual_complete: 14.0,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-05-25",
      baseline_complete: 18.5,
      actual_complete: 14.0,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-06-01",
      baseline_complete: 19.4,
      actual_complete: 14.0,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-06-08",
      baseline_complete: 20.2,
      actual_complete: 17.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-06-15",
      baseline_complete: 21.1,
      actual_complete: 17.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-06-22",
      baseline_complete: 22.0,
      actual_complete: 17.9,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-06-29",
      baseline_complete: 23.0,
      actual_complete: 20.4,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-07-06",
      baseline_complete: 24.0,
      actual_complete: 20.4,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-07-13",
      baseline_complete: 25.0,
      actual_complete: 20.4,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-07-20",
      baseline_complete: 26.0,
      actual_complete: 20.4,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-07-27",
      baseline_complete: 27.0,
      actual_complete: 20.6,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-08-03",
      baseline_complete: 28.1,
      actual_complete: 22.9,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-08-10",
      baseline_complete: 29.2,
      actual_complete: 22.9,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-08-17",
      baseline_complete: 30.4,
      actual_complete: 27.3,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-08-24",
      baseline_complete: 31.5,
      actual_complete: 27.3,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-08-31",
      baseline_complete: 32.7,
      actual_complete: 31.0,
      forecast_complete: 12.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-09-07",
      baseline_complete: 33.9,
      actual_complete: 32.4,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-09-14",
      baseline_complete: 35.2,
      actual_complete: 32.4,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-09-21",
      baseline_complete: 36.4,
      actual_complete: 32.4,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-09-28",
      baseline_complete: 37.7,
      actual_complete: 36.6,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-10-05",
      baseline_complete: 39.0,
      actual_complete: 36.6,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-10-12",
      baseline_complete: 40.3,
      actual_complete: 37.8,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-10-19",
      baseline_complete: 41.6,
      actual_complete: 37.8,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-10-26",
      baseline_complete: 42.9,
      actual_complete: 39.7,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-11-02",
      baseline_complete: 44.2,
      actual_complete: 40.0,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-11-09",
      baseline_complete: 45.6,
      actual_complete: 44.9,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-11-16",
      baseline_complete: 46.9,
      actual_complete: 44.9,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-11-23",
      baseline_complete: 48.3,
      actual_complete: 44.9,
      forecast_complete: 21.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-11-30",
      baseline_complete: 49.7,
      actual_complete: 44.9,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-12-07",
      baseline_complete: 51.0,
      actual_complete: 46.7,
      forecast_complete: 22.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-12-14",
      baseline_complete: 52.4,
      actual_complete: 51.5,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-12-21",
      baseline_complete: 53.7,
      actual_complete: 51.5,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2024-12-28",
      baseline_complete: 55.1,
      actual_complete: 54.3,
      forecast_complete: 25.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-01-04",
      baseline_complete: 56.4,
      actual_complete: 54.3,
      forecast_complete: 26.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-01-11",
      baseline_complete: 57.7,
      actual_complete: 54.3,
      forecast_complete: 27.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-01-18",
      baseline_complete: 59.1,
      actual_complete: 56.2,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-01-25",
      baseline_complete: 60.4,
      actual_complete: 57.4,
      forecast_complete: 29.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-02-01",
      baseline_complete: 61.7,
      actual_complete: 57.4,
      forecast_complete: 30.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-02-08",
      baseline_complete: 62.9,
      actual_complete: 62.4,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-02-15",
      baseline_complete: 64.2,
      actual_complete: 62.4,
      forecast_complete: 31.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-02-22",
      baseline_complete: 65.4,
      actual_complete: 62.4,
      forecast_complete: 32.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-03-01",
      baseline_complete: 66.7,
      actual_complete: 65.5,
      forecast_complete: 33.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-03-08",
      baseline_complete: 67.9,
      actual_complete: 67.3,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-03-15",
      baseline_complete: 69.0,
      actual_complete: 67.3,
      forecast_complete: 35.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-03-22",
      baseline_complete: 70.2,
      actual_complete: 69.0,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-03-29",
      baseline_complete: 71.3,
      actual_complete: 69.0,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-04-05",
      baseline_complete: 72.4,
      actual_complete: 70.4,
      forecast_complete: 38.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-04-12",
      baseline_complete: 73.5,
      actual_complete: 70.6,
      forecast_complete: 39.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-04-19",
      baseline_complete: 74.5,
      actual_complete: 72.0,
      forecast_complete: 40.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-04-26",
      baseline_complete: 75.5,
      actual_complete: 72.0,
      forecast_complete: 41.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-05-03",
      baseline_complete: 76.5,
      actual_complete: 74.5,
      forecast_complete: 41.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-05-10",
      baseline_complete: 77.5,
      actual_complete: 75.4,
      forecast_complete: 42.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-05-17",
      baseline_complete: 78.4,
      actual_complete: 75.9,
      forecast_complete: 43.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-05-24",
      baseline_complete: 79.3,
      actual_complete: 76.3,
      forecast_complete: 44.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-05-31",
      baseline_complete: 80.2,
      actual_complete: 76.3,
      forecast_complete: 45.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-06-07",
      baseline_complete: 81.1,
      actual_complete: 76.9,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-06-14",
      baseline_complete: 81.9,
      actual_complete: 81.4,
      forecast_complete: 47.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-06-21",
      baseline_complete: 82.7,
      actual_complete: 81.4,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-06-28",
      baseline_complete: 83.4,
      actual_complete: 81.4,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-07-05",
      baseline_complete: 84.2,
      actual_complete: 82.0,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-07-12",
      baseline_complete: 84.9,
      actual_complete: 82.0,
      forecast_complete: 50.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-07-19",
      baseline_complete: 85.6,
      actual_complete: 83.9,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-07-26",
      baseline_complete: 86.2,
      actual_complete: 85.9,
      forecast_complete: 52.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-08-02",
      baseline_complete: 86.9,
      actual_complete: 85.9,
      forecast_complete: 52.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-08-09",
      baseline_complete: 87.5,
      actual_complete: 85.9,
      forecast_complete: 53.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-08-16",
      baseline_complete: 88.0,
      actual_complete: 85.9,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-08-23",
      baseline_complete: 88.6,
      actual_complete: 88.7,
      forecast_complete: 55.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-08-30",
      baseline_complete: 89.1,
      actual_complete: 88.7,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-09-06",
      baseline_complete: 89.7,
      actual_complete: 88.7,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-09-13",
      baseline_complete: 90.2,
      actual_complete: 90.9,
      forecast_complete: 57.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-09-20",
      baseline_complete: 90.6,
      actual_complete: 90.9,
      forecast_complete: 58.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-09-27",
      baseline_complete: 91.1,
      actual_complete: 91.4,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-10-04",
      baseline_complete: 91.5,
      actual_complete: 91.4,
      forecast_complete: 59.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-10-11",
      baseline_complete: 91.9,
      actual_complete: 93.0,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-10-18",
      baseline_complete: 92.3,
      actual_complete: 93.0,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-10-25",
      baseline_complete: 92.7,
      actual_complete: 94.6,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-11-01",
      baseline_complete: 93.1,
      actual_complete: 94.6,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-11-08",
      baseline_complete: 93.4,
      actual_complete: 94.6,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-11-15",
      baseline_complete: 93.7,
      actual_complete: 94.6,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-11-22",
      baseline_complete: 94.0,
      actual_complete: 94.6,
      forecast_complete: 64.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-11-29",
      baseline_complete: 94.3,
      actual_complete: 95.1,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-12-06",
      baseline_complete: 94.6,
      actual_complete: 95.8,
      forecast_complete: 65.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-12-13",
      baseline_complete: 94.9,
      actual_complete: 95.8,
      forecast_complete: 66.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-12-20",
      baseline_complete: 95.1,
      actual_complete: 95.8,
      forecast_complete: 66.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2025-12-27",
      baseline_complete: 95.4,
      actual_complete: 95.8,
      forecast_complete: 67.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-01-03",
      baseline_complete: 95.6,
      actual_complete: 95.8,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-01-10",
      baseline_complete: 95.8,
      actual_complete: 95.8,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-01-17",
      baseline_complete: 96.1,
      actual_complete: 96.5,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-01-24",
      baseline_complete: 96.3,
      actual_complete: 96.5,
      forecast_complete: 69.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-01-31",
      baseline_complete: 96.4,
      actual_complete: 97.9,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-02-07",
      baseline_complete: 96.6,
      actual_complete: 97.9,
      forecast_complete: 70.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-02-14",
      baseline_complete: 96.8,
      actual_complete: 97.9,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-02-21",
      baseline_complete: 97.0,
      actual_complete: 97.9,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-02-28",
      baseline_complete: 97.1,
      actual_complete: 97.9,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-03-07",
      baseline_complete: 97.3,
      actual_complete: 97.9,
      forecast_complete: 73.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-03-14",
      baseline_complete: 97.4,
      actual_complete: 97.9,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-03-21",
      baseline_complete: 97.5,
      actual_complete: 97.9,
      forecast_complete: 75.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-03-28",
      baseline_complete: 97.7,
      actual_complete: 97.9,
      forecast_complete: 76.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-04-04",
      baseline_complete: 97.8,
      actual_complete: 98.1,
      forecast_complete: 77.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-04-11",
      baseline_complete: 97.9,
      actual_complete: 98.1,
      forecast_complete: 78.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-04-18",
      baseline_complete: 98.0,
      actual_complete: 99.5,
      forecast_complete: 79.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-04-25",
      baseline_complete: 98.1,
      actual_complete: 99.5,
      forecast_complete: 80.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-05-02",
      baseline_complete: 98.2,
      actual_complete: 99.5,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-05-09",
      baseline_complete: 98.3,
      actual_complete: 99.5,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-05-16",
      baseline_complete: 98.4,
      actual_complete: 99.5,
      forecast_complete: 82.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-05-23",
      baseline_complete: 98.5,
      actual_complete: 99.5,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-05-30",
      baseline_complete: 98.6,
      actual_complete: 99.5,
      forecast_complete: 84.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-06-06",
      baseline_complete: 98.6,
      actual_complete: 99.5,
      forecast_complete: 85.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-06-13",
      baseline_complete: 98.7,
      actual_complete: 99.5,
      forecast_complete: 85.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-06-20",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 86.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-06-27",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 87.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-07-04",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-07-11",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-07-18",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 89.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-07-25",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-08-01",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-08-08",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-08-15",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-08-22",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-08-29",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-09-05",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-09-12",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-09-19",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-09-26",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-10-03",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-10-10",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-10-17",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-10-24",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-10-31",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-11-07",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-11-14",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-11-21",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-11-28",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-12-05",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-12-12",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-12-19",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2026-12-26",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2027-01-02",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2027-01-09",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2027-01-16",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2027-01-23",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2027-01-30",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2027-02-06",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2027-02-13",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2027-02-20",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2027-02-27",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2027-03-06",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "c483ece7-c6f9-83c9-1e1a-67a901041a4a",
      reporting_date: "2027-03-07",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
  ],
  "5bcc188b-0578-f637-8984-92ea83d595b9": [
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-03-27",
      baseline_complete: 2.4,
      actual_complete: 2.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-04-03",
      baseline_complete: 2.5,
      actual_complete: 4.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-04-10",
      baseline_complete: 2.6,
      actual_complete: 6.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-04-17",
      baseline_complete: 2.8,
      actual_complete: 7.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-04-24",
      baseline_complete: 2.9,
      actual_complete: 7.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-05-01",
      baseline_complete: 3.0,
      actual_complete: 7.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-05-08",
      baseline_complete: 3.2,
      actual_complete: 7.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-05-15",
      baseline_complete: 3.3,
      actual_complete: 7.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-05-22",
      baseline_complete: 3.4,
      actual_complete: 7.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-05-29",
      baseline_complete: 3.6,
      actual_complete: 7.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-06-05",
      baseline_complete: 3.8,
      actual_complete: 7.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-06-12",
      baseline_complete: 3.9,
      actual_complete: 7.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-06-19",
      baseline_complete: 4.1,
      actual_complete: 7.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-06-26",
      baseline_complete: 4.3,
      actual_complete: 7.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-07-03",
      baseline_complete: 4.5,
      actual_complete: 8.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-07-10",
      baseline_complete: 4.7,
      actual_complete: 8.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-07-17",
      baseline_complete: 4.9,
      actual_complete: 9.3,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-07-24",
      baseline_complete: 5.1,
      actual_complete: 9.3,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-07-31",
      baseline_complete: 5.3,
      actual_complete: 10.3,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-08-07",
      baseline_complete: 5.5,
      actual_complete: 10.3,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-08-14",
      baseline_complete: 5.8,
      actual_complete: 10.3,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-08-21",
      baseline_complete: 6.0,
      actual_complete: 11.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-08-28",
      baseline_complete: 6.3,
      actual_complete: 11.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-09-04",
      baseline_complete: 6.5,
      actual_complete: 11.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-09-11",
      baseline_complete: 6.8,
      actual_complete: 11.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-09-18",
      baseline_complete: 7.1,
      actual_complete: 11.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-09-25",
      baseline_complete: 7.4,
      actual_complete: 11.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-10-02",
      baseline_complete: 7.7,
      actual_complete: 12.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-10-09",
      baseline_complete: 8.1,
      actual_complete: 12.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-10-16",
      baseline_complete: 8.4,
      actual_complete: 13.1,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-10-23",
      baseline_complete: 8.7,
      actual_complete: 13.1,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-10-30",
      baseline_complete: 9.1,
      actual_complete: 13.4,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-11-06",
      baseline_complete: 9.5,
      actual_complete: 13.4,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-11-13",
      baseline_complete: 9.9,
      actual_complete: 13.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-11-20",
      baseline_complete: 10.3,
      actual_complete: 13.4,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-11-27",
      baseline_complete: 10.7,
      actual_complete: 13.4,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-12-04",
      baseline_complete: 11.2,
      actual_complete: 15.6,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-12-11",
      baseline_complete: 11.6,
      actual_complete: 17.1,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-12-18",
      baseline_complete: 12.1,
      actual_complete: 17.1,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2024-12-25",
      baseline_complete: 12.6,
      actual_complete: 17.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-01-01",
      baseline_complete: 13.1,
      actual_complete: 17.1,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-01-08",
      baseline_complete: 13.6,
      actual_complete: 17.1,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-01-15",
      baseline_complete: 14.1,
      actual_complete: 17.1,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-01-22",
      baseline_complete: 14.7,
      actual_complete: 18.7,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-01-29",
      baseline_complete: 15.2,
      actual_complete: 19.5,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-02-05",
      baseline_complete: 15.8,
      actual_complete: 19.5,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-02-12",
      baseline_complete: 16.4,
      actual_complete: 21.4,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-02-19",
      baseline_complete: 17.1,
      actual_complete: 21.4,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-02-26",
      baseline_complete: 17.7,
      actual_complete: 21.4,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-03-05",
      baseline_complete: 18.4,
      actual_complete: 22.3,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-03-12",
      baseline_complete: 19.1,
      actual_complete: 24.3,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-03-19",
      baseline_complete: 19.8,
      actual_complete: 24.3,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-03-26",
      baseline_complete: 20.5,
      actual_complete: 24.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-04-02",
      baseline_complete: 21.2,
      actual_complete: 26.8,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-04-09",
      baseline_complete: 22.0,
      actual_complete: 26.8,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-04-16",
      baseline_complete: 22.8,
      actual_complete: 28.0,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-04-23",
      baseline_complete: 23.6,
      actual_complete: 28.0,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-04-30",
      baseline_complete: 24.4,
      actual_complete: 28.0,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-05-07",
      baseline_complete: 25.2,
      actual_complete: 28.0,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-05-14",
      baseline_complete: 26.1,
      actual_complete: 30.7,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-05-21",
      baseline_complete: 27.0,
      actual_complete: 30.7,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-05-28",
      baseline_complete: 27.9,
      actual_complete: 32.6,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-06-04",
      baseline_complete: 28.8,
      actual_complete: 32.6,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-06-11",
      baseline_complete: 29.7,
      actual_complete: 32.6,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-06-18",
      baseline_complete: 30.7,
      actual_complete: 33.7,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-06-25",
      baseline_complete: 31.6,
      actual_complete: 34.1,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-07-02",
      baseline_complete: 32.6,
      actual_complete: 36.1,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-07-09",
      baseline_complete: 33.6,
      actual_complete: 36.1,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-07-16",
      baseline_complete: 34.6,
      actual_complete: 39.2,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-07-23",
      baseline_complete: 35.6,
      actual_complete: 39.2,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-07-30",
      baseline_complete: 36.7,
      actual_complete: 39.2,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-08-06",
      baseline_complete: 37.7,
      actual_complete: 42.9,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-08-13",
      baseline_complete: 38.8,
      actual_complete: 42.9,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-08-20",
      baseline_complete: 39.9,
      actual_complete: 43.5,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-08-27",
      baseline_complete: 40.9,
      actual_complete: 44.0,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-09-03",
      baseline_complete: 42.0,
      actual_complete: 44.0,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-09-10",
      baseline_complete: 43.1,
      actual_complete: 48.1,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-09-17",
      baseline_complete: 44.2,
      actual_complete: 48.1,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-09-24",
      baseline_complete: 45.4,
      actual_complete: 48.1,
      forecast_complete: 19.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-10-01",
      baseline_complete: 46.5,
      actual_complete: 48.1,
      forecast_complete: 19.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-10-08",
      baseline_complete: 47.6,
      actual_complete: 49.5,
      forecast_complete: 20.6,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-10-15",
      baseline_complete: 48.7,
      actual_complete: 49.5,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-10-22",
      baseline_complete: 49.8,
      actual_complete: 53.4,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-10-29",
      baseline_complete: 51.0,
      actual_complete: 54.3,
      forecast_complete: 22.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-11-05",
      baseline_complete: 52.1,
      actual_complete: 57.0,
      forecast_complete: 23.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-11-12",
      baseline_complete: 53.2,
      actual_complete: 57.0,
      forecast_complete: 24.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-11-19",
      baseline_complete: 54.3,
      actual_complete: 57.0,
      forecast_complete: 25.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-11-26",
      baseline_complete: 55.4,
      actual_complete: 57.0,
      forecast_complete: 25.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-12-03",
      baseline_complete: 56.5,
      actual_complete: 57.0,
      forecast_complete: 26.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-12-10",
      baseline_complete: 57.6,
      actual_complete: 63.1,
      forecast_complete: 27.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-12-17",
      baseline_complete: 58.7,
      actual_complete: 63.1,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-12-24",
      baseline_complete: 59.8,
      actual_complete: 63.1,
      forecast_complete: 28.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2025-12-31",
      baseline_complete: 60.9,
      actual_complete: 65.7,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-01-07",
      baseline_complete: 62.0,
      actual_complete: 65.7,
      forecast_complete: 30.6,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-01-14",
      baseline_complete: 63.0,
      actual_complete: 65.7,
      forecast_complete: 31.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-01-21",
      baseline_complete: 64.1,
      actual_complete: 65.7,
      forecast_complete: 32.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-01-28",
      baseline_complete: 65.1,
      actual_complete: 69.3,
      forecast_complete: 33.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-02-04",
      baseline_complete: 66.1,
      actual_complete: 70.7,
      forecast_complete: 33.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-02-11",
      baseline_complete: 67.1,
      actual_complete: 71.5,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-02-18",
      baseline_complete: 68.1,
      actual_complete: 71.5,
      forecast_complete: 35.6,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-02-25",
      baseline_complete: 69.1,
      actual_complete: 71.5,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-03-04",
      baseline_complete: 70.0,
      actual_complete: 73.1,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-03-11",
      baseline_complete: 70.9,
      actual_complete: 75.7,
      forecast_complete: 38.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-03-18",
      baseline_complete: 71.9,
      actual_complete: 76.9,
      forecast_complete: 39.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-03-25",
      baseline_complete: 72.8,
      actual_complete: 76.9,
      forecast_complete: 39.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-04-01",
      baseline_complete: 73.6,
      actual_complete: 76.9,
      forecast_complete: 40.6,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-04-08",
      baseline_complete: 74.5,
      actual_complete: 79.6,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-04-15",
      baseline_complete: 75.4,
      actual_complete: 79.6,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-04-22",
      baseline_complete: 76.2,
      actual_complete: 79.6,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-04-29",
      baseline_complete: 77.0,
      actual_complete: 80.4,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-05-06",
      baseline_complete: 77.8,
      actual_complete: 80.4,
      forecast_complete: 44.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-05-13",
      baseline_complete: 78.5,
      actual_complete: 80.4,
      forecast_complete: 45.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-05-20",
      baseline_complete: 79.3,
      actual_complete: 84.4,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-05-27",
      baseline_complete: 80.0,
      actual_complete: 84.4,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-06-03",
      baseline_complete: 80.7,
      actual_complete: 84.4,
      forecast_complete: 48.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-06-10",
      baseline_complete: 81.4,
      actual_complete: 86.0,
      forecast_complete: 49.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-06-17",
      baseline_complete: 82.1,
      actual_complete: 86.4,
      forecast_complete: 49.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-06-24",
      baseline_complete: 82.7,
      actual_complete: 86.4,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-07-01",
      baseline_complete: 83.4,
      actual_complete: 86.4,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-07-08",
      baseline_complete: 84.0,
      actual_complete: 88.9,
      forecast_complete: 52.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-07-15",
      baseline_complete: 84.6,
      actual_complete: 88.9,
      forecast_complete: 53.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-07-22",
      baseline_complete: 85.2,
      actual_complete: 88.9,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-07-29",
      baseline_complete: 85.7,
      actual_complete: 88.9,
      forecast_complete: 54.6,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-08-05",
      baseline_complete: 86.3,
      actual_complete: 88.9,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-08-12",
      baseline_complete: 86.8,
      actual_complete: 88.9,
      forecast_complete: 56.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-08-19",
      baseline_complete: 87.3,
      actual_complete: 92.1,
      forecast_complete: 56.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-08-26",
      baseline_complete: 87.8,
      actual_complete: 92.1,
      forecast_complete: 57.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-09-02",
      baseline_complete: 88.3,
      actual_complete: 92.1,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-09-09",
      baseline_complete: 88.7,
      actual_complete: 92.1,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-09-16",
      baseline_complete: 89.2,
      actual_complete: 93.9,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-09-23",
      baseline_complete: 89.6,
      actual_complete: 93.9,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-09-30",
      baseline_complete: 90.0,
      actual_complete: 93.9,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-10-07",
      baseline_complete: 90.4,
      actual_complete: 93.9,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-10-14",
      baseline_complete: 90.8,
      actual_complete: 94.0,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-10-21",
      baseline_complete: 91.1,
      actual_complete: 95.9,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-10-28",
      baseline_complete: 91.5,
      actual_complete: 95.9,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-11-04",
      baseline_complete: 91.8,
      actual_complete: 95.9,
      forecast_complete: 64.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-11-11",
      baseline_complete: 92.2,
      actual_complete: 95.9,
      forecast_complete: 65.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-11-18",
      baseline_complete: 92.5,
      actual_complete: 95.9,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-11-25",
      baseline_complete: 92.8,
      actual_complete: 95.9,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-12-02",
      baseline_complete: 93.1,
      actual_complete: 95.9,
      forecast_complete: 67.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-12-09",
      baseline_complete: 93.4,
      actual_complete: 97.7,
      forecast_complete: 68.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-12-16",
      baseline_complete: 93.7,
      actual_complete: 97.7,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-12-23",
      baseline_complete: 93.9,
      actual_complete: 97.7,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2026-12-30",
      baseline_complete: 94.2,
      actual_complete: 97.7,
      forecast_complete: 70.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-01-06",
      baseline_complete: 94.4,
      actual_complete: 97.7,
      forecast_complete: 71.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-01-13",
      baseline_complete: 94.6,
      actual_complete: 97.7,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-01-20",
      baseline_complete: 94.9,
      actual_complete: 97.7,
      forecast_complete: 74.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-01-27",
      baseline_complete: 95.1,
      actual_complete: 97.7,
      forecast_complete: 75.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-02-03",
      baseline_complete: 95.3,
      actual_complete: 97.7,
      forecast_complete: 76.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-02-10",
      baseline_complete: 95.5,
      actual_complete: 100.0,
      forecast_complete: 77.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-02-17",
      baseline_complete: 95.7,
      actual_complete: 100.0,
      forecast_complete: 78.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-02-24",
      baseline_complete: 95.9,
      actual_complete: 100.0,
      forecast_complete: 79.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-03-03",
      baseline_complete: 96.0,
      actual_complete: 100.0,
      forecast_complete: 80.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-03-10",
      baseline_complete: 96.2,
      actual_complete: 100.0,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-03-17",
      baseline_complete: 96.4,
      actual_complete: 100.0,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-03-24",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 83.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-03-31",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-04-07",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 85.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-04-14",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-04-21",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 86.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-04-28",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 87.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-05-05",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-05-12",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-05-19",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-05-26",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-06-02",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-06-09",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-06-16",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-06-23",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-06-30",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-07-07",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-07-14",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-07-21",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-07-28",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-08-04",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-08-11",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-08-18",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-08-25",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-09-01",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-09-08",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-09-15",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-09-22",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-09-29",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-10-06",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-10-13",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-10-20",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-10-27",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-11-03",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-11-10",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-11-17",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-11-24",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "5bcc188b-0578-f637-8984-92ea83d595b9",
      reporting_date: "2027-11-27",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
  ],
  "46227e4f-080e-401a-1262-5b9fe925eea4": [
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-03-20",
      baseline_complete: 0.4,
      actual_complete: 4.8,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-03-27",
      baseline_complete: 0.5,
      actual_complete: 4.8,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-04-03",
      baseline_complete: 0.5,
      actual_complete: 5.6,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-04-10",
      baseline_complete: 0.5,
      actual_complete: 5.6,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-04-17",
      baseline_complete: 0.6,
      actual_complete: 5.6,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-04-24",
      baseline_complete: 0.6,
      actual_complete: 5.6,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-05-01",
      baseline_complete: 0.7,
      actual_complete: 5.6,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-05-08",
      baseline_complete: 0.7,
      actual_complete: 5.6,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-05-15",
      baseline_complete: 0.8,
      actual_complete: 6.2,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-05-22",
      baseline_complete: 0.8,
      actual_complete: 6.2,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-05-29",
      baseline_complete: 0.9,
      actual_complete: 6.2,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-06-05",
      baseline_complete: 1.0,
      actual_complete: 6.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-06-12",
      baseline_complete: 1.0,
      actual_complete: 6.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-06-19",
      baseline_complete: 1.1,
      actual_complete: 6.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-06-26",
      baseline_complete: 1.2,
      actual_complete: 6.6,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-07-03",
      baseline_complete: 1.3,
      actual_complete: 6.6,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-07-10",
      baseline_complete: 1.4,
      actual_complete: 6.8,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-07-17",
      baseline_complete: 1.5,
      actual_complete: 6.8,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-07-24",
      baseline_complete: 1.6,
      actual_complete: 6.8,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-07-31",
      baseline_complete: 1.7,
      actual_complete: 6.8,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-08-07",
      baseline_complete: 1.8,
      actual_complete: 6.8,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-08-14",
      baseline_complete: 2.0,
      actual_complete: 6.8,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-08-21",
      baseline_complete: 2.1,
      actual_complete: 7.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-08-28",
      baseline_complete: 2.3,
      actual_complete: 7.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-09-04",
      baseline_complete: 2.4,
      actual_complete: 7.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-09-11",
      baseline_complete: 2.6,
      actual_complete: 7.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-09-18",
      baseline_complete: 2.8,
      actual_complete: 7.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-09-25",
      baseline_complete: 3.0,
      actual_complete: 8.1,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-10-02",
      baseline_complete: 3.3,
      actual_complete: 8.1,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-10-09",
      baseline_complete: 3.5,
      actual_complete: 8.1,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-10-16",
      baseline_complete: 3.8,
      actual_complete: 8.1,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-10-23",
      baseline_complete: 4.0,
      actual_complete: 9.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-10-30",
      baseline_complete: 4.3,
      actual_complete: 9.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-11-06",
      baseline_complete: 4.6,
      actual_complete: 9.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-11-13",
      baseline_complete: 5.0,
      actual_complete: 9.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-11-20",
      baseline_complete: 5.3,
      actual_complete: 9.6,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-11-27",
      baseline_complete: 5.7,
      actual_complete: 10.3,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-12-04",
      baseline_complete: 6.1,
      actual_complete: 10.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-12-11",
      baseline_complete: 6.6,
      actual_complete: 10.3,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-12-18",
      baseline_complete: 7.0,
      actual_complete: 10.3,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2023-12-25",
      baseline_complete: 7.5,
      actual_complete: 11.2,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-01-01",
      baseline_complete: 8.1,
      actual_complete: 13.1,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-01-08",
      baseline_complete: 8.6,
      actual_complete: 14.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-01-15",
      baseline_complete: 9.2,
      actual_complete: 14.0,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-01-22",
      baseline_complete: 9.9,
      actual_complete: 14.6,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-01-29",
      baseline_complete: 10.5,
      actual_complete: 15.2,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-02-05",
      baseline_complete: 11.2,
      actual_complete: 15.8,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-02-12",
      baseline_complete: 12.0,
      actual_complete: 16.6,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-02-19",
      baseline_complete: 12.8,
      actual_complete: 17.6,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-02-26",
      baseline_complete: 13.6,
      actual_complete: 18.3,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-03-04",
      baseline_complete: 14.5,
      actual_complete: 18.3,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-03-11",
      baseline_complete: 15.5,
      actual_complete: 19.1,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-03-18",
      baseline_complete: 16.5,
      actual_complete: 20.1,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-03-25",
      baseline_complete: 17.5,
      actual_complete: 20.4,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-04-01",
      baseline_complete: 18.6,
      actual_complete: 22.6,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-04-08",
      baseline_complete: 19.7,
      actual_complete: 22.6,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-04-15",
      baseline_complete: 20.9,
      actual_complete: 24.1,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-04-22",
      baseline_complete: 22.2,
      actual_complete: 26.6,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-04-29",
      baseline_complete: 23.5,
      actual_complete: 27.8,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-05-06",
      baseline_complete: 24.8,
      actual_complete: 28.2,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-05-13",
      baseline_complete: 26.2,
      actual_complete: 29.3,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-05-20",
      baseline_complete: 27.7,
      actual_complete: 32.0,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-05-27",
      baseline_complete: 29.2,
      actual_complete: 32.3,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-06-03",
      baseline_complete: 30.7,
      actual_complete: 33.6,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-06-10",
      baseline_complete: 32.3,
      actual_complete: 36.9,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-06-17",
      baseline_complete: 33.9,
      actual_complete: 36.9,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-06-24",
      baseline_complete: 35.6,
      actual_complete: 39.0,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-07-01",
      baseline_complete: 37.3,
      actual_complete: 40.2,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-07-08",
      baseline_complete: 39.0,
      actual_complete: 41.9,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-07-15",
      baseline_complete: 40.8,
      actual_complete: 44.8,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-07-22",
      baseline_complete: 42.6,
      actual_complete: 47.2,
      forecast_complete: 20.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-07-29",
      baseline_complete: 44.4,
      actual_complete: 47.4,
      forecast_complete: 21.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-08-05",
      baseline_complete: 46.2,
      actual_complete: 49.8,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-08-12",
      baseline_complete: 48.1,
      actual_complete: 50.0,
      forecast_complete: 23.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-08-19",
      baseline_complete: 49.9,
      actual_complete: 52.1,
      forecast_complete: 24.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-08-26",
      baseline_complete: 51.7,
      actual_complete: 54.6,
      forecast_complete: 25.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-09-02",
      baseline_complete: 53.6,
      actual_complete: 58.1,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-09-09",
      baseline_complete: 55.4,
      actual_complete: 58.8,
      forecast_complete: 27.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-09-16",
      baseline_complete: 57.2,
      actual_complete: 61.2,
      forecast_complete: 28.8,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-09-23",
      baseline_complete: 59.0,
      actual_complete: 63.2,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-09-30",
      baseline_complete: 60.8,
      actual_complete: 65.0,
      forecast_complete: 31.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-10-07",
      baseline_complete: 62.5,
      actual_complete: 65.1,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-10-14",
      baseline_complete: 64.2,
      actual_complete: 67.4,
      forecast_complete: 33.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-10-21",
      baseline_complete: 65.9,
      actual_complete: 70.2,
      forecast_complete: 34.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-10-28",
      baseline_complete: 67.5,
      actual_complete: 70.8,
      forecast_complete: 35.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-11-04",
      baseline_complete: 69.1,
      actual_complete: 71.4,
      forecast_complete: 36.8,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-11-11",
      baseline_complete: 70.7,
      actual_complete: 72.9,
      forecast_complete: 37.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-11-18",
      baseline_complete: 72.2,
      actual_complete: 75.9,
      forecast_complete: 39.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-11-25",
      baseline_complete: 73.6,
      actual_complete: 75.9,
      forecast_complete: 40.2,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-12-02",
      baseline_complete: 75.0,
      actual_complete: 79.3,
      forecast_complete: 41.3,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-12-09",
      baseline_complete: 76.4,
      actual_complete: 79.3,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-12-16",
      baseline_complete: 77.7,
      actual_complete: 81.7,
      forecast_complete: 43.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-12-23",
      baseline_complete: 78.9,
      actual_complete: 82.5,
      forecast_complete: 44.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2024-12-30",
      baseline_complete: 80.1,
      actual_complete: 83.0,
      forecast_complete: 45.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-01-06",
      baseline_complete: 81.3,
      actual_complete: 85.1,
      forecast_complete: 46.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-01-13",
      baseline_complete: 82.4,
      actual_complete: 85.1,
      forecast_complete: 47.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-01-20",
      baseline_complete: 83.4,
      actual_complete: 85.4,
      forecast_complete: 48.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-01-27",
      baseline_complete: 84.4,
      actual_complete: 87.1,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-02-03",
      baseline_complete: 85.4,
      actual_complete: 88.0,
      forecast_complete: 50.8,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-02-10",
      baseline_complete: 86.3,
      actual_complete: 89.6,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-02-17",
      baseline_complete: 87.1,
      actual_complete: 89.6,
      forecast_complete: 52.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-02-24",
      baseline_complete: 87.9,
      actual_complete: 90.8,
      forecast_complete: 53.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-03-03",
      baseline_complete: 88.7,
      actual_complete: 90.8,
      forecast_complete: 54.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-03-10",
      baseline_complete: 89.4,
      actual_complete: 91.1,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-03-17",
      baseline_complete: 90.1,
      actual_complete: 92.4,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-03-24",
      baseline_complete: 90.7,
      actual_complete: 94.3,
      forecast_complete: 57.2,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-03-31",
      baseline_complete: 91.3,
      actual_complete: 94.3,
      forecast_complete: 58.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-04-07",
      baseline_complete: 91.9,
      actual_complete: 94.3,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-04-14",
      baseline_complete: 92.4,
      actual_complete: 95.0,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-04-21",
      baseline_complete: 92.9,
      actual_complete: 95.0,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-04-28",
      baseline_complete: 93.4,
      actual_complete: 95.6,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-05-05",
      baseline_complete: 93.8,
      actual_complete: 96.2,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-05-12",
      baseline_complete: 94.2,
      actual_complete: 98.1,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-05-19",
      baseline_complete: 94.6,
      actual_complete: 98.1,
      forecast_complete: 63.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-05-26",
      baseline_complete: 95.0,
      actual_complete: 98.2,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-06-02",
      baseline_complete: 95.3,
      actual_complete: 98.2,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-06-09",
      baseline_complete: 95.6,
      actual_complete: 98.2,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-06-16",
      baseline_complete: 95.9,
      actual_complete: 98.2,
      forecast_complete: 66.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-06-23",
      baseline_complete: 96.2,
      actual_complete: 99.5,
      forecast_complete: 67.3,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-06-30",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 68.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-07-07",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 68.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-07-14",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 69.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-07-21",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-07-28",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-08-04",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-08-11",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 72.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-08-18",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-08-25",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-09-01",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 74.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-09-08",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 74.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-09-15",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 75.3,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-09-22",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-09-29",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-10-06",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 78.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-10-13",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-10-20",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 80.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-10-27",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 81.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-11-03",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 82.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-11-10",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-11-17",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-11-24",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 85.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-12-01",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 86.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-12-08",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 87.3,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-12-15",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-12-22",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2025-12-29",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 89.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-01-05",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-01-12",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-01-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 91.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-01-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-02-02",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-02-09",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-02-16",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-02-23",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-03-02",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-03-09",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-03-16",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-03-23",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-03-30",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-04-06",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-04-13",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-04-20",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-04-27",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-05-04",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-05-11",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-05-18",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-05-25",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-06-01",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-06-08",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-06-15",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-06-22",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-06-29",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-07-06",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-07-13",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "46227e4f-080e-401a-1262-5b9fe925eea4",
      reporting_date: "2026-07-20",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "05a02557-41a2-c677-13d5-a29c38fbb097": [
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-03-15",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-03-22",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-03-29",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-04-05",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-04-12",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-04-19",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-04-26",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-05-03",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-05-10",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-05-17",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-05-24",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-05-31",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-06-07",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-06-14",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-06-21",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-06-28",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-07-05",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-07-12",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-07-19",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-07-26",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-08-02",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-08-09",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-08-16",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-08-23",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-08-30",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-09-06",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-09-13",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-09-20",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-09-27",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-10-04",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-10-11",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-10-18",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-10-25",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-11-01",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-11-08",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-11-15",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-11-22",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-11-29",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-12-06",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-12-13",
      baseline_complete: 4.2,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-12-20",
      baseline_complete: 4.5,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2023-12-27",
      baseline_complete: 4.8,
      actual_complete: 0.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-01-03",
      baseline_complete: 5.1,
      actual_complete: 0.8,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-01-10",
      baseline_complete: 5.5,
      actual_complete: 0.8,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-01-17",
      baseline_complete: 5.9,
      actual_complete: 0.8,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-01-24",
      baseline_complete: 6.3,
      actual_complete: 1.0,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-01-31",
      baseline_complete: 6.8,
      actual_complete: 1.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-02-07",
      baseline_complete: 7.3,
      actual_complete: 1.8,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-02-14",
      baseline_complete: 7.8,
      actual_complete: 3.7,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-02-21",
      baseline_complete: 8.3,
      actual_complete: 4.5,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-02-28",
      baseline_complete: 8.9,
      actual_complete: 4.5,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-03-06",
      baseline_complete: 9.5,
      actual_complete: 4.5,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-03-13",
      baseline_complete: 10.1,
      actual_complete: 5.0,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-03-20",
      baseline_complete: 10.8,
      actual_complete: 6.6,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-03-27",
      baseline_complete: 11.6,
      actual_complete: 8.2,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-04-03",
      baseline_complete: 12.3,
      actual_complete: 8.2,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-04-10",
      baseline_complete: 13.2,
      actual_complete: 9.1,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-04-17",
      baseline_complete: 14.0,
      actual_complete: 9.8,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-04-24",
      baseline_complete: 14.9,
      actual_complete: 10.6,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-05-01",
      baseline_complete: 15.9,
      actual_complete: 13.2,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-05-08",
      baseline_complete: 16.9,
      actual_complete: 13.4,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-05-15",
      baseline_complete: 17.9,
      actual_complete: 13.4,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-05-22",
      baseline_complete: 19.0,
      actual_complete: 15.0,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-05-29",
      baseline_complete: 20.2,
      actual_complete: 15.4,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-06-05",
      baseline_complete: 21.4,
      actual_complete: 16.8,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-06-12",
      baseline_complete: 22.7,
      actual_complete: 18.7,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-06-19",
      baseline_complete: 24.0,
      actual_complete: 20.8,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-06-26",
      baseline_complete: 25.3,
      actual_complete: 21.0,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-07-03",
      baseline_complete: 26.7,
      actual_complete: 24.3,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-07-10",
      baseline_complete: 28.2,
      actual_complete: 25.8,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-07-17",
      baseline_complete: 29.7,
      actual_complete: 25.8,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-07-24",
      baseline_complete: 31.3,
      actual_complete: 26.8,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-07-31",
      baseline_complete: 32.9,
      actual_complete: 29.2,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-08-07",
      baseline_complete: 34.5,
      actual_complete: 30.8,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-08-14",
      baseline_complete: 36.2,
      actual_complete: 34.2,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-08-21",
      baseline_complete: 37.9,
      actual_complete: 34.5,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-08-28",
      baseline_complete: 39.6,
      actual_complete: 36.5,
      forecast_complete: 21.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-09-04",
      baseline_complete: 41.4,
      actual_complete: 37.5,
      forecast_complete: 22.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-09-11",
      baseline_complete: 43.2,
      actual_complete: 38.9,
      forecast_complete: 23.4,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-09-18",
      baseline_complete: 45.0,
      actual_complete: 42.0,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-09-25",
      baseline_complete: 46.8,
      actual_complete: 43.7,
      forecast_complete: 25.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-10-02",
      baseline_complete: 48.6,
      actual_complete: 44.8,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-10-09",
      baseline_complete: 50.5,
      actual_complete: 49.0,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-10-16",
      baseline_complete: 52.3,
      actual_complete: 50.2,
      forecast_complete: 29.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-10-23",
      baseline_complete: 54.1,
      actual_complete: 51.3,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-10-30",
      baseline_complete: 55.9,
      actual_complete: 52.8,
      forecast_complete: 32.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-11-06",
      baseline_complete: 57.7,
      actual_complete: 54.8,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-11-13",
      baseline_complete: 59.5,
      actual_complete: 56.8,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-11-20",
      baseline_complete: 61.3,
      actual_complete: 57.2,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-11-27",
      baseline_complete: 63.0,
      actual_complete: 60.6,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-12-04",
      baseline_complete: 64.7,
      actual_complete: 62.3,
      forecast_complete: 38.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-12-11",
      baseline_complete: 66.3,
      actual_complete: 63.9,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-12-18",
      baseline_complete: 68.0,
      actual_complete: 66.4,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2024-12-25",
      baseline_complete: 69.5,
      actual_complete: 67.6,
      forecast_complete: 42.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-01-01",
      baseline_complete: 71.1,
      actual_complete: 68.7,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-01-08",
      baseline_complete: 72.5,
      actual_complete: 69.1,
      forecast_complete: 45.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-01-15",
      baseline_complete: 74.0,
      actual_complete: 71.6,
      forecast_complete: 46.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-01-22",
      baseline_complete: 75.4,
      actual_complete: 73.6,
      forecast_complete: 47.9,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-01-29",
      baseline_complete: 76.7,
      actual_complete: 75.5,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-02-05",
      baseline_complete: 78.0,
      actual_complete: 76.7,
      forecast_complete: 50.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-02-12",
      baseline_complete: 79.2,
      actual_complete: 77.4,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-02-19",
      baseline_complete: 80.4,
      actual_complete: 78.6,
      forecast_complete: 52.9,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-02-26",
      baseline_complete: 81.5,
      actual_complete: 81.0,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-03-05",
      baseline_complete: 82.6,
      actual_complete: 81.0,
      forecast_complete: 55.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-03-12",
      baseline_complete: 83.6,
      actual_complete: 82.4,
      forecast_complete: 56.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-03-19",
      baseline_complete: 84.6,
      actual_complete: 83.1,
      forecast_complete: 57.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-03-26",
      baseline_complete: 85.5,
      actual_complete: 83.9,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-04-02",
      baseline_complete: 86.4,
      actual_complete: 86.0,
      forecast_complete: 59.9,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-04-09",
      baseline_complete: 87.3,
      actual_complete: 86.0,
      forecast_complete: 61.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-04-16",
      baseline_complete: 88.1,
      actual_complete: 86.3,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-04-23",
      baseline_complete: 88.8,
      actual_complete: 86.3,
      forecast_complete: 63.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-04-30",
      baseline_complete: 89.5,
      actual_complete: 89.7,
      forecast_complete: 64.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-05-07",
      baseline_complete: 90.2,
      actual_complete: 89.9,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-05-14",
      baseline_complete: 90.8,
      actual_complete: 90.6,
      forecast_complete: 66.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-05-21",
      baseline_complete: 91.4,
      actual_complete: 90.6,
      forecast_complete: 67.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-05-28",
      baseline_complete: 92.0,
      actual_complete: 90.6,
      forecast_complete: 68.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-06-04",
      baseline_complete: 92.5,
      actual_complete: 90.6,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-06-11",
      baseline_complete: 93.0,
      actual_complete: 91.8,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-06-18",
      baseline_complete: 93.4,
      actual_complete: 92.8,
      forecast_complete: 71.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-06-25",
      baseline_complete: 93.9,
      actual_complete: 93.2,
      forecast_complete: 71.9,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-07-02",
      baseline_complete: 94.3,
      actual_complete: 93.5,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-07-09",
      baseline_complete: 94.7,
      actual_complete: 93.5,
      forecast_complete: 73.9,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-07-16",
      baseline_complete: 95.0,
      actual_complete: 94.4,
      forecast_complete: 75.4,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-07-23",
      baseline_complete: 95.4,
      actual_complete: 94.7,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-07-30",
      baseline_complete: 95.7,
      actual_complete: 94.7,
      forecast_complete: 78.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-08-06",
      baseline_complete: 96.0,
      actual_complete: 95.9,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-08-13",
      baseline_complete: 96.2,
      actual_complete: 95.9,
      forecast_complete: 81.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-08-20",
      baseline_complete: 96.5,
      actual_complete: 95.9,
      forecast_complete: 82.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-08-27",
      baseline_complete: 96.7,
      actual_complete: 96.8,
      forecast_complete: 83.5,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-09-03",
      baseline_complete: 97.0,
      actual_complete: 96.8,
      forecast_complete: 84.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-09-10",
      baseline_complete: 97.2,
      actual_complete: 96.8,
      forecast_complete: 85.9,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-09-17",
      baseline_complete: 97.4,
      actual_complete: 98.2,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-09-24",
      baseline_complete: 97.5,
      actual_complete: 98.2,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-10-01",
      baseline_complete: 97.7,
      actual_complete: 98.2,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-10-08",
      baseline_complete: 97.9,
      actual_complete: 98.3,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-10-15",
      baseline_complete: 98.0,
      actual_complete: 98.3,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-10-22",
      baseline_complete: 98.2,
      actual_complete: 98.3,
      forecast_complete: 91.9,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-10-29",
      baseline_complete: 98.3,
      actual_complete: 98.9,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-11-05",
      baseline_complete: 98.4,
      actual_complete: 98.9,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-11-12",
      baseline_complete: 98.5,
      actual_complete: 99.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-11-19",
      baseline_complete: 98.6,
      actual_complete: 99.6,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-11-26",
      baseline_complete: 98.7,
      actual_complete: 99.6,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-12-03",
      baseline_complete: 98.8,
      actual_complete: 99.9,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-12-10",
      baseline_complete: 98.9,
      actual_complete: 99.9,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-12-17",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-12-24",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2025-12-31",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-01-07",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-01-14",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-01-21",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-01-28",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-02-04",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-02-11",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-02-18",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-02-25",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-03-04",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-03-11",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-03-18",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-03-25",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-04-01",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-04-08",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "05a02557-41a2-c677-13d5-a29c38fbb097",
      reporting_date: "2026-04-15",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "4add1cb1-307e-c7be-fd76-5a6748bc67e3": [
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-04-30",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-05-07",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-05-14",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-05-21",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-05-28",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-06-04",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-06-11",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-06-18",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-06-25",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-07-02",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-07-09",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-07-16",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-07-23",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-07-30",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-08-06",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-08-13",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-08-20",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-08-27",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-09-03",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-09-10",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-09-17",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-09-24",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-10-01",
      baseline_complete: 3.8,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-10-08",
      baseline_complete: 4.0,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-10-15",
      baseline_complete: 4.3,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-10-22",
      baseline_complete: 4.5,
      actual_complete: 0.2,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-10-29",
      baseline_complete: 4.8,
      actual_complete: 0.2,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-11-05",
      baseline_complete: 5.1,
      actual_complete: 0.7,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-11-12",
      baseline_complete: 5.5,
      actual_complete: 0.7,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-11-19",
      baseline_complete: 5.8,
      actual_complete: 3.2,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-11-26",
      baseline_complete: 6.2,
      actual_complete: 3.6,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-12-03",
      baseline_complete: 6.6,
      actual_complete: 3.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-12-10",
      baseline_complete: 7.0,
      actual_complete: 3.6,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-12-17",
      baseline_complete: 7.4,
      actual_complete: 4.9,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-12-24",
      baseline_complete: 7.9,
      actual_complete: 4.9,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2023-12-31",
      baseline_complete: 8.4,
      actual_complete: 4.9,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-01-07",
      baseline_complete: 8.9,
      actual_complete: 4.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-01-14",
      baseline_complete: 9.5,
      actual_complete: 6.7,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-01-21",
      baseline_complete: 10.1,
      actual_complete: 6.7,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-01-28",
      baseline_complete: 10.7,
      actual_complete: 7.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-02-04",
      baseline_complete: 11.3,
      actual_complete: 7.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-02-11",
      baseline_complete: 12.0,
      actual_complete: 8.1,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-02-18",
      baseline_complete: 12.7,
      actual_complete: 8.4,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-02-25",
      baseline_complete: 13.4,
      actual_complete: 9.3,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-03-03",
      baseline_complete: 14.2,
      actual_complete: 9.7,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-03-10",
      baseline_complete: 15.0,
      actual_complete: 10.4,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-03-17",
      baseline_complete: 15.9,
      actual_complete: 13.0,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-03-24",
      baseline_complete: 16.8,
      actual_complete: 13.8,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-03-31",
      baseline_complete: 17.7,
      actual_complete: 13.8,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-04-07",
      baseline_complete: 18.7,
      actual_complete: 14.2,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-04-14",
      baseline_complete: 19.8,
      actual_complete: 16.5,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-04-21",
      baseline_complete: 20.8,
      actual_complete: 16.5,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-04-28",
      baseline_complete: 21.9,
      actual_complete: 20.0,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-05-05",
      baseline_complete: 23.1,
      actual_complete: 20.0,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-05-12",
      baseline_complete: 24.3,
      actual_complete: 21.8,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-05-19",
      baseline_complete: 25.5,
      actual_complete: 23.5,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-05-26",
      baseline_complete: 26.8,
      actual_complete: 24.3,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-06-02",
      baseline_complete: 28.1,
      actual_complete: 24.3,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-06-09",
      baseline_complete: 29.4,
      actual_complete: 26.6,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-06-16",
      baseline_complete: 30.8,
      actual_complete: 26.6,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-06-23",
      baseline_complete: 32.2,
      actual_complete: 31.0,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-06-30",
      baseline_complete: 33.7,
      actual_complete: 31.0,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-07-07",
      baseline_complete: 35.1,
      actual_complete: 33.8,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-07-14",
      baseline_complete: 36.7,
      actual_complete: 33.9,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-07-21",
      baseline_complete: 38.2,
      actual_complete: 35.7,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-07-28",
      baseline_complete: 39.8,
      actual_complete: 38.2,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-08-04",
      baseline_complete: 41.4,
      actual_complete: 38.6,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-08-11",
      baseline_complete: 43.0,
      actual_complete: 40.4,
      forecast_complete: 18.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-08-18",
      baseline_complete: 44.6,
      actual_complete: 42.1,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-08-25",
      baseline_complete: 46.2,
      actual_complete: 42.8,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-09-01",
      baseline_complete: 47.8,
      actual_complete: 45.4,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-09-08",
      baseline_complete: 49.5,
      actual_complete: 47.3,
      forecast_complete: 22.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-09-15",
      baseline_complete: 51.1,
      actual_complete: 49.0,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-09-22",
      baseline_complete: 52.8,
      actual_complete: 52.4,
      forecast_complete: 24.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-09-29",
      baseline_complete: 54.4,
      actual_complete: 53.2,
      forecast_complete: 25.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-10-06",
      baseline_complete: 56.0,
      actual_complete: 55.2,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-10-13",
      baseline_complete: 57.7,
      actual_complete: 55.2,
      forecast_complete: 27.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-10-20",
      baseline_complete: 59.2,
      actual_complete: 57.0,
      forecast_complete: 28.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-10-27",
      baseline_complete: 60.8,
      actual_complete: 57.4,
      forecast_complete: 29.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-11-03",
      baseline_complete: 62.4,
      actual_complete: 60.4,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-11-10",
      baseline_complete: 63.9,
      actual_complete: 61.5,
      forecast_complete: 31.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-11-17",
      baseline_complete: 65.4,
      actual_complete: 63.5,
      forecast_complete: 32.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-11-24",
      baseline_complete: 66.9,
      actual_complete: 64.5,
      forecast_complete: 34.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-12-01",
      baseline_complete: 68.3,
      actual_complete: 67.8,
      forecast_complete: 35.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-12-08",
      baseline_complete: 69.7,
      actual_complete: 68.2,
      forecast_complete: 36.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-12-15",
      baseline_complete: 71.1,
      actual_complete: 69.7,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-12-22",
      baseline_complete: 72.4,
      actual_complete: 70.3,
      forecast_complete: 38.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2024-12-29",
      baseline_complete: 73.7,
      actual_complete: 71.7,
      forecast_complete: 39.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-01-05",
      baseline_complete: 75.0,
      actual_complete: 74.3,
      forecast_complete: 40.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-01-12",
      baseline_complete: 76.2,
      actual_complete: 74.3,
      forecast_complete: 41.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-01-19",
      baseline_complete: 77.4,
      actual_complete: 78.0,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-01-26",
      baseline_complete: 78.5,
      actual_complete: 78.0,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-02-02",
      baseline_complete: 79.6,
      actual_complete: 78.4,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-02-09",
      baseline_complete: 80.6,
      actual_complete: 80.4,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-02-16",
      baseline_complete: 81.6,
      actual_complete: 82.4,
      forecast_complete: 47.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-02-23",
      baseline_complete: 82.6,
      actual_complete: 82.4,
      forecast_complete: 48.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-03-02",
      baseline_complete: 83.5,
      actual_complete: 82.4,
      forecast_complete: 49.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-03-09",
      baseline_complete: 84.4,
      actual_complete: 83.4,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-03-16",
      baseline_complete: 85.3,
      actual_complete: 84.2,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-03-23",
      baseline_complete: 86.1,
      actual_complete: 84.2,
      forecast_complete: 52.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-03-30",
      baseline_complete: 86.8,
      actual_complete: 84.5,
      forecast_complete: 53.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-04-06",
      baseline_complete: 87.6,
      actual_complete: 84.9,
      forecast_complete: 54.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-04-13",
      baseline_complete: 88.3,
      actual_complete: 86.1,
      forecast_complete: 55.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-04-20",
      baseline_complete: 88.9,
      actual_complete: 88.4,
      forecast_complete: 56.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-04-27",
      baseline_complete: 89.6,
      actual_complete: 89.1,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-05-04",
      baseline_complete: 90.2,
      actual_complete: 90.8,
      forecast_complete: 58.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-05-11",
      baseline_complete: 90.7,
      actual_complete: 90.8,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-05-18",
      baseline_complete: 91.3,
      actual_complete: 90.9,
      forecast_complete: 59.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-05-25",
      baseline_complete: 91.8,
      actual_complete: 91.2,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-06-01",
      baseline_complete: 92.3,
      actual_complete: 93.5,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-06-08",
      baseline_complete: 92.7,
      actual_complete: 93.5,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-06-15",
      baseline_complete: 93.2,
      actual_complete: 93.5,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-06-22",
      baseline_complete: 93.6,
      actual_complete: 94.2,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-06-29",
      baseline_complete: 93.9,
      actual_complete: 94.2,
      forecast_complete: 64.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-07-06",
      baseline_complete: 94.3,
      actual_complete: 94.2,
      forecast_complete: 65.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-07-13",
      baseline_complete: 94.7,
      actual_complete: 94.2,
      forecast_complete: 66.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-07-20",
      baseline_complete: 95.0,
      actual_complete: 95.9,
      forecast_complete: 67.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-07-27",
      baseline_complete: 95.3,
      actual_complete: 95.9,
      forecast_complete: 68.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-08-03",
      baseline_complete: 95.6,
      actual_complete: 97.3,
      forecast_complete: 68.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-08-10",
      baseline_complete: 95.8,
      actual_complete: 97.3,
      forecast_complete: 69.7,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-08-17",
      baseline_complete: 96.1,
      actual_complete: 97.3,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-08-24",
      baseline_complete: 96.3,
      actual_complete: 97.3,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-08-31",
      baseline_complete: 96.6,
      actual_complete: 97.3,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-09-07",
      baseline_complete: 96.8,
      actual_complete: 97.3,
      forecast_complete: 72.7,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-09-14",
      baseline_complete: 97.0,
      actual_complete: 97.4,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-09-21",
      baseline_complete: 97.2,
      actual_complete: 98.6,
      forecast_complete: 74.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-09-28",
      baseline_complete: 97.3,
      actual_complete: 98.6,
      forecast_complete: 75.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-10-05",
      baseline_complete: 97.5,
      actual_complete: 99.5,
      forecast_complete: 77.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-10-12",
      baseline_complete: 97.7,
      actual_complete: 99.5,
      forecast_complete: 78.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-10-19",
      baseline_complete: 97.8,
      actual_complete: 99.5,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-10-26",
      baseline_complete: 97.9,
      actual_complete: 99.5,
      forecast_complete: 80.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-11-02",
      baseline_complete: 98.1,
      actual_complete: 99.5,
      forecast_complete: 81.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-11-09",
      baseline_complete: 98.2,
      actual_complete: 99.5,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-11-16",
      baseline_complete: 98.3,
      actual_complete: 99.5,
      forecast_complete: 84.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-11-23",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 85.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-11-30",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-12-07",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-12-14",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-12-21",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2025-12-28",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 89.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-01-04",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-01-11",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-01-18",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-01-25",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-02-01",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-02-08",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-02-15",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-02-22",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-03-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-03-08",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-03-15",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-03-22",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-03-29",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-04-05",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-04-12",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-04-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-04-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-05-03",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-05-10",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-05-17",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-05-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-05-31",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-06-07",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-06-14",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-06-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-06-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "4add1cb1-307e-c7be-fd76-5a6748bc67e3",
      reporting_date: "2026-06-30",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "b7940cce-c9ca-9264-33f6-2644553c8e1a": [
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-08-15",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-08-22",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-08-29",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-09-05",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-09-12",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-09-19",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-09-26",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-10-03",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-10-10",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-10-17",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-10-24",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-10-31",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-11-07",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-11-14",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-11-21",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-11-28",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-12-05",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-12-12",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-12-19",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2023-12-26",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-01-02",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-01-09",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-01-16",
      baseline_complete: 1.6,
      actual_complete: 0.4,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-01-23",
      baseline_complete: 1.7,
      actual_complete: 0.4,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-01-30",
      baseline_complete: 1.8,
      actual_complete: 0.4,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-02-06",
      baseline_complete: 1.9,
      actual_complete: 0.4,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-02-13",
      baseline_complete: 2.0,
      actual_complete: 0.5,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-02-20",
      baseline_complete: 2.1,
      actual_complete: 0.5,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-02-27",
      baseline_complete: 2.3,
      actual_complete: 0.7,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-03-05",
      baseline_complete: 2.4,
      actual_complete: 0.7,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-03-12",
      baseline_complete: 2.6,
      actual_complete: 0.7,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-03-19",
      baseline_complete: 2.7,
      actual_complete: 0.7,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-03-26",
      baseline_complete: 2.9,
      actual_complete: 0.7,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-04-02",
      baseline_complete: 3.1,
      actual_complete: 2.4,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-04-09",
      baseline_complete: 3.3,
      actual_complete: 2.4,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-04-16",
      baseline_complete: 3.5,
      actual_complete: 2.4,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-04-23",
      baseline_complete: 3.7,
      actual_complete: 2.4,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-04-30",
      baseline_complete: 4.0,
      actual_complete: 2.4,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-05-07",
      baseline_complete: 4.2,
      actual_complete: 2.4,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-05-14",
      baseline_complete: 4.5,
      actual_complete: 2.4,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-05-21",
      baseline_complete: 4.7,
      actual_complete: 2.4,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-05-28",
      baseline_complete: 5.0,
      actual_complete: 2.8,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-06-04",
      baseline_complete: 5.4,
      actual_complete: 4.0,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-06-11",
      baseline_complete: 5.7,
      actual_complete: 4.0,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-06-18",
      baseline_complete: 6.0,
      actual_complete: 4.0,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-06-25",
      baseline_complete: 6.4,
      actual_complete: 4.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-07-02",
      baseline_complete: 6.8,
      actual_complete: 4.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-07-09",
      baseline_complete: 7.2,
      actual_complete: 4.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-07-16",
      baseline_complete: 7.6,
      actual_complete: 4.3,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-07-23",
      baseline_complete: 8.1,
      actual_complete: 4.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-07-30",
      baseline_complete: 8.6,
      actual_complete: 8.3,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-08-06",
      baseline_complete: 9.1,
      actual_complete: 8.3,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-08-13",
      baseline_complete: 9.6,
      actual_complete: 8.3,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-08-20",
      baseline_complete: 10.2,
      actual_complete: 9.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-08-27",
      baseline_complete: 10.8,
      actual_complete: 9.9,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-09-03",
      baseline_complete: 11.4,
      actual_complete: 9.9,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-09-10",
      baseline_complete: 12.1,
      actual_complete: 9.9,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-09-17",
      baseline_complete: 12.8,
      actual_complete: 9.9,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-09-24",
      baseline_complete: 13.5,
      actual_complete: 10.3,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-10-01",
      baseline_complete: 14.2,
      actual_complete: 11.5,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-10-08",
      baseline_complete: 15.0,
      actual_complete: 12.5,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-10-15",
      baseline_complete: 15.9,
      actual_complete: 15.8,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-10-22",
      baseline_complete: 16.7,
      actual_complete: 16.9,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-10-29",
      baseline_complete: 17.6,
      actual_complete: 16.9,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-11-05",
      baseline_complete: 18.6,
      actual_complete: 17.0,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-11-12",
      baseline_complete: 19.5,
      actual_complete: 17.0,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-11-19",
      baseline_complete: 20.6,
      actual_complete: 20.0,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-11-26",
      baseline_complete: 21.6,
      actual_complete: 20.0,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-12-03",
      baseline_complete: 22.7,
      actual_complete: 20.8,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-12-10",
      baseline_complete: 23.8,
      actual_complete: 20.8,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-12-17",
      baseline_complete: 25.0,
      actual_complete: 23.7,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-12-24",
      baseline_complete: 26.2,
      actual_complete: 25.5,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2024-12-31",
      baseline_complete: 27.5,
      actual_complete: 25.5,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-01-07",
      baseline_complete: 28.7,
      actual_complete: 27.6,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-01-14",
      baseline_complete: 30.0,
      actual_complete: 30.8,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-01-21",
      baseline_complete: 31.4,
      actual_complete: 31.2,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-01-28",
      baseline_complete: 32.8,
      actual_complete: 31.2,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-02-04",
      baseline_complete: 34.2,
      actual_complete: 33.1,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-02-11",
      baseline_complete: 35.6,
      actual_complete: 35.8,
      forecast_complete: 16.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-02-18",
      baseline_complete: 37.1,
      actual_complete: 35.8,
      forecast_complete: 16.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-02-25",
      baseline_complete: 38.6,
      actual_complete: 38.5,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-03-04",
      baseline_complete: 40.1,
      actual_complete: 38.5,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-03-11",
      baseline_complete: 41.6,
      actual_complete: 42.7,
      forecast_complete: 19.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-03-18",
      baseline_complete: 43.2,
      actual_complete: 42.7,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-03-25",
      baseline_complete: 44.7,
      actual_complete: 43.1,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-04-01",
      baseline_complete: 46.3,
      actual_complete: 43.1,
      forecast_complete: 22.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-04-08",
      baseline_complete: 47.9,
      actual_complete: 44.3,
      forecast_complete: 23.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-04-15",
      baseline_complete: 49.5,
      actual_complete: 50.1,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-04-22",
      baseline_complete: 51.0,
      actual_complete: 51.3,
      forecast_complete: 24.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-04-29",
      baseline_complete: 52.6,
      actual_complete: 51.5,
      forecast_complete: 25.8,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-05-06",
      baseline_complete: 54.2,
      actual_complete: 51.5,
      forecast_complete: 26.8,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-05-13",
      baseline_complete: 55.8,
      actual_complete: 54.4,
      forecast_complete: 27.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-05-20",
      baseline_complete: 57.3,
      actual_complete: 54.8,
      forecast_complete: 28.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-05-27",
      baseline_complete: 58.9,
      actual_complete: 57.8,
      forecast_complete: 29.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-06-03",
      baseline_complete: 60.4,
      actual_complete: 58.5,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-06-10",
      baseline_complete: 61.9,
      actual_complete: 61.9,
      forecast_complete: 32.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-06-17",
      baseline_complete: 63.4,
      actual_complete: 64.5,
      forecast_complete: 33.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-06-24",
      baseline_complete: 64.8,
      actual_complete: 64.5,
      forecast_complete: 34.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-07-01",
      baseline_complete: 66.3,
      actual_complete: 65.4,
      forecast_complete: 35.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-07-08",
      baseline_complete: 67.7,
      actual_complete: 68.3,
      forecast_complete: 36.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-07-15",
      baseline_complete: 69.0,
      actual_complete: 68.3,
      forecast_complete: 37.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-07-22",
      baseline_complete: 70.4,
      actual_complete: 70.5,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-07-29",
      baseline_complete: 71.7,
      actual_complete: 71.8,
      forecast_complete: 39.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-08-05",
      baseline_complete: 73.0,
      actual_complete: 71.8,
      forecast_complete: 40.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-08-12",
      baseline_complete: 74.2,
      actual_complete: 72.9,
      forecast_complete: 41.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-08-19",
      baseline_complete: 75.4,
      actual_complete: 75.2,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-08-26",
      baseline_complete: 76.5,
      actual_complete: 75.2,
      forecast_complete: 43.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-09-02",
      baseline_complete: 77.7,
      actual_complete: 75.8,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-09-09",
      baseline_complete: 78.7,
      actual_complete: 76.2,
      forecast_complete: 45.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-09-16",
      baseline_complete: 79.8,
      actual_complete: 78.2,
      forecast_complete: 46.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-09-23",
      baseline_complete: 80.8,
      actual_complete: 80.5,
      forecast_complete: 47.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-09-30",
      baseline_complete: 81.7,
      actual_complete: 83.4,
      forecast_complete: 48.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-10-07",
      baseline_complete: 82.7,
      actual_complete: 83.9,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-10-14",
      baseline_complete: 83.6,
      actual_complete: 84.4,
      forecast_complete: 50.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-10-21",
      baseline_complete: 84.4,
      actual_complete: 84.4,
      forecast_complete: 51.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-10-28",
      baseline_complete: 85.2,
      actual_complete: 84.4,
      forecast_complete: 51.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-11-04",
      baseline_complete: 86.0,
      actual_complete: 88.2,
      forecast_complete: 52.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-11-11",
      baseline_complete: 86.8,
      actual_complete: 88.2,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-11-18",
      baseline_complete: 87.5,
      actual_complete: 88.2,
      forecast_complete: 54.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-11-25",
      baseline_complete: 88.1,
      actual_complete: 88.2,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-12-02",
      baseline_complete: 88.8,
      actual_complete: 88.9,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-12-09",
      baseline_complete: 89.4,
      actual_complete: 88.9,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-12-16",
      baseline_complete: 90.0,
      actual_complete: 89.8,
      forecast_complete: 58.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-12-23",
      baseline_complete: 90.5,
      actual_complete: 92.6,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2025-12-30",
      baseline_complete: 91.1,
      actual_complete: 92.6,
      forecast_complete: 59.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-01-06",
      baseline_complete: 91.6,
      actual_complete: 92.6,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-01-13",
      baseline_complete: 92.1,
      actual_complete: 92.6,
      forecast_complete: 61.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-01-20",
      baseline_complete: 92.5,
      actual_complete: 92.6,
      forecast_complete: 61.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-01-27",
      baseline_complete: 92.9,
      actual_complete: 92.7,
      forecast_complete: 62.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-02-03",
      baseline_complete: 93.3,
      actual_complete: 93.5,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-02-10",
      baseline_complete: 93.7,
      actual_complete: 93.5,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-02-17",
      baseline_complete: 94.1,
      actual_complete: 94.6,
      forecast_complete: 64.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-02-24",
      baseline_complete: 94.4,
      actual_complete: 95.4,
      forecast_complete: 65.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-03-03",
      baseline_complete: 94.7,
      actual_complete: 95.4,
      forecast_complete: 66.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-03-10",
      baseline_complete: 95.1,
      actual_complete: 95.4,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-03-17",
      baseline_complete: 95.3,
      actual_complete: 95.9,
      forecast_complete: 67.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-03-24",
      baseline_complete: 95.6,
      actual_complete: 97.3,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-03-31",
      baseline_complete: 95.9,
      actual_complete: 97.3,
      forecast_complete: 69.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-04-07",
      baseline_complete: 96.1,
      actual_complete: 97.6,
      forecast_complete: 69.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-04-14",
      baseline_complete: 96.3,
      actual_complete: 97.6,
      forecast_complete: 70.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-04-21",
      baseline_complete: 96.6,
      actual_complete: 97.6,
      forecast_complete: 71.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-04-28",
      baseline_complete: 96.8,
      actual_complete: 97.6,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-05-05",
      baseline_complete: 97.0,
      actual_complete: 97.6,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-05-12",
      baseline_complete: 97.1,
      actual_complete: 99.3,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-05-19",
      baseline_complete: 97.3,
      actual_complete: 99.7,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-05-26",
      baseline_complete: 97.5,
      actual_complete: 99.7,
      forecast_complete: 74.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-06-02",
      baseline_complete: 97.6,
      actual_complete: 99.7,
      forecast_complete: 74.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-06-09",
      baseline_complete: 97.8,
      actual_complete: 99.7,
      forecast_complete: 75.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-06-16",
      baseline_complete: 97.9,
      actual_complete: 99.7,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-06-23",
      baseline_complete: 98.0,
      actual_complete: 99.7,
      forecast_complete: 77.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-06-30",
      baseline_complete: 98.1,
      actual_complete: 99.7,
      forecast_complete: 78.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-07-07",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-07-14",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 80.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-07-21",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 81.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-07-28",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-08-04",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 83.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-08-11",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 84.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-08-18",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-08-25",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-09-01",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-09-08",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 87.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-09-15",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-09-22",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-09-29",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-10-06",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-10-13",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-10-20",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-10-27",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-11-03",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-11-10",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-11-17",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-11-24",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-12-01",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-12-08",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-12-15",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-12-22",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2026-12-29",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-01-05",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-01-12",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-01-19",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-01-26",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-02-02",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-02-09",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-02-16",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-02-23",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-03-02",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-03-09",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-03-16",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-03-23",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-03-30",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-04-06",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-04-13",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-04-20",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-04-27",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-05-04",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-05-11",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b7940cce-c9ca-9264-33f6-2644553c8e1a",
      reporting_date: "2027-05-15",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "91824670-8112-92d4-207f-6e53e569077e": [
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-05-17",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-05-24",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-05-31",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-06-07",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-06-14",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-06-21",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-06-28",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-07-05",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-07-12",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-07-19",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-07-26",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-08-02",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-08-09",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-08-16",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-08-23",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-08-30",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-09-06",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-09-13",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-09-20",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-09-27",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-10-04",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-10-11",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-10-18",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-10-25",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-11-01",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-11-08",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-11-15",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-11-22",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-11-29",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-12-06",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-12-13",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-12-20",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2025-12-27",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-01-03",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-01-10",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-01-17",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-01-24",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-01-31",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-02-07",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-02-14",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-02-21",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-02-28",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-03-07",
      baseline_complete: 1.6,
      actual_complete: 0.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-03-14",
      baseline_complete: 1.7,
      actual_complete: 0.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-03-21",
      baseline_complete: 1.9,
      actual_complete: 0.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-03-28",
      baseline_complete: 2.0,
      actual_complete: 0.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-04-04",
      baseline_complete: 2.2,
      actual_complete: 0.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-04-11",
      baseline_complete: 2.3,
      actual_complete: 0.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-04-18",
      baseline_complete: 2.5,
      actual_complete: 0.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-04-25",
      baseline_complete: 2.7,
      actual_complete: 1.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-05-02",
      baseline_complete: 2.9,
      actual_complete: 1.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-05-09",
      baseline_complete: 3.2,
      actual_complete: 1.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-05-16",
      baseline_complete: 3.4,
      actual_complete: 1.7,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-05-23",
      baseline_complete: 3.7,
      actual_complete: 1.7,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-05-30",
      baseline_complete: 4.0,
      actual_complete: 1.7,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-06-06",
      baseline_complete: 4.3,
      actual_complete: 1.7,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-06-13",
      baseline_complete: 4.6,
      actual_complete: 1.7,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-06-20",
      baseline_complete: 5.0,
      actual_complete: 1.7,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-06-27",
      baseline_complete: 5.4,
      actual_complete: 1.7,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-07-04",
      baseline_complete: 5.8,
      actual_complete: 1.7,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-07-11",
      baseline_complete: 6.2,
      actual_complete: 4.6,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-07-18",
      baseline_complete: 6.7,
      actual_complete: 4.6,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-07-25",
      baseline_complete: 7.2,
      actual_complete: 4.6,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-08-01",
      baseline_complete: 7.8,
      actual_complete: 5.8,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-08-08",
      baseline_complete: 8.3,
      actual_complete: 6.1,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-08-15",
      baseline_complete: 9.0,
      actual_complete: 7.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-08-22",
      baseline_complete: 9.6,
      actual_complete: 7.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-08-29",
      baseline_complete: 10.3,
      actual_complete: 7.6,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-09-05",
      baseline_complete: 11.1,
      actual_complete: 7.6,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-09-12",
      baseline_complete: 11.9,
      actual_complete: 11.8,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-09-19",
      baseline_complete: 12.7,
      actual_complete: 11.8,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-09-26",
      baseline_complete: 13.6,
      actual_complete: 12.1,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-10-03",
      baseline_complete: 14.6,
      actual_complete: 13.2,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-10-10",
      baseline_complete: 15.6,
      actual_complete: 13.9,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-10-17",
      baseline_complete: 16.7,
      actual_complete: 16.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-10-24",
      baseline_complete: 17.8,
      actual_complete: 18.3,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-10-31",
      baseline_complete: 19.0,
      actual_complete: 18.3,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-11-07",
      baseline_complete: 20.2,
      actual_complete: 18.4,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-11-14",
      baseline_complete: 21.5,
      actual_complete: 21.5,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-11-21",
      baseline_complete: 22.9,
      actual_complete: 21.5,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-11-28",
      baseline_complete: 24.3,
      actual_complete: 21.5,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-12-05",
      baseline_complete: 25.8,
      actual_complete: 25.9,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-12-12",
      baseline_complete: 27.3,
      actual_complete: 26.7,
      forecast_complete: 12.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-12-19",
      baseline_complete: 28.9,
      actual_complete: 26.7,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2026-12-26",
      baseline_complete: 30.5,
      actual_complete: 29.8,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-01-02",
      baseline_complete: 32.2,
      actual_complete: 32.0,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-01-09",
      baseline_complete: 34.0,
      actual_complete: 32.0,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-01-16",
      baseline_complete: 35.8,
      actual_complete: 36.4,
      forecast_complete: 17.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-01-23",
      baseline_complete: 37.6,
      actual_complete: 36.6,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-01-30",
      baseline_complete: 39.4,
      actual_complete: 37.5,
      forecast_complete: 20.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-02-06",
      baseline_complete: 41.3,
      actual_complete: 39.6,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-02-13",
      baseline_complete: 43.3,
      actual_complete: 39.9,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-02-20",
      baseline_complete: 45.2,
      actual_complete: 42.9,
      forecast_complete: 24.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-02-27",
      baseline_complete: 47.2,
      actual_complete: 44.7,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-03-06",
      baseline_complete: 49.1,
      actual_complete: 44.7,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-03-13",
      baseline_complete: 51.1,
      actual_complete: 50.4,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-03-20",
      baseline_complete: 53.1,
      actual_complete: 53.7,
      forecast_complete: 29.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-03-27",
      baseline_complete: 55.0,
      actual_complete: 55.9,
      forecast_complete: 31.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-04-03",
      baseline_complete: 56.9,
      actual_complete: 55.9,
      forecast_complete: 32.5,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-04-10",
      baseline_complete: 58.9,
      actual_complete: 59.2,
      forecast_complete: 34.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-04-17",
      baseline_complete: 60.8,
      actual_complete: 59.2,
      forecast_complete: 35.5,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-04-24",
      baseline_complete: 62.6,
      actual_complete: 61.5,
      forecast_complete: 37.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-05-01",
      baseline_complete: 64.4,
      actual_complete: 62.4,
      forecast_complete: 38.5,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-05-08",
      baseline_complete: 66.2,
      actual_complete: 63.4,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-05-15",
      baseline_complete: 68.0,
      actual_complete: 64.0,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-05-22",
      baseline_complete: 69.6,
      actual_complete: 69.0,
      forecast_complete: 42.9,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-05-29",
      baseline_complete: 71.3,
      actual_complete: 69.0,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-06-05",
      baseline_complete: 72.9,
      actual_complete: 74.1,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-06-12",
      baseline_complete: 74.4,
      actual_complete: 74.1,
      forecast_complete: 47.3,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-06-19",
      baseline_complete: 75.9,
      actual_complete: 76.5,
      forecast_complete: 48.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-06-26",
      baseline_complete: 77.3,
      actual_complete: 76.5,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-07-03",
      baseline_complete: 78.6,
      actual_complete: 76.5,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-07-10",
      baseline_complete: 79.9,
      actual_complete: 80.2,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-07-17",
      baseline_complete: 81.2,
      actual_complete: 80.2,
      forecast_complete: 54.2,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-07-24",
      baseline_complete: 82.3,
      actual_complete: 83.8,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-07-31",
      baseline_complete: 83.4,
      actual_complete: 83.8,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-08-07",
      baseline_complete: 84.5,
      actual_complete: 84.7,
      forecast_complete: 58.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-08-14",
      baseline_complete: 85.5,
      actual_complete: 84.7,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-08-21",
      baseline_complete: 86.5,
      actual_complete: 88.8,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-08-28",
      baseline_complete: 87.4,
      actual_complete: 90.9,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-09-04",
      baseline_complete: 88.2,
      actual_complete: 90.9,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-09-11",
      baseline_complete: 89.0,
      actual_complete: 90.9,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-09-18",
      baseline_complete: 89.7,
      actual_complete: 90.9,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-09-25",
      baseline_complete: 90.4,
      actual_complete: 90.9,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-10-02",
      baseline_complete: 91.1,
      actual_complete: 92.7,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-10-09",
      baseline_complete: 91.7,
      actual_complete: 92.7,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-10-16",
      baseline_complete: 92.3,
      actual_complete: 92.7,
      forecast_complete: 70.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-10-23",
      baseline_complete: 92.8,
      actual_complete: 94.1,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-10-30",
      baseline_complete: 93.3,
      actual_complete: 94.1,
      forecast_complete: 73.2,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-11-06",
      baseline_complete: 93.8,
      actual_complete: 94.1,
      forecast_complete: 74.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-11-13",
      baseline_complete: 94.3,
      actual_complete: 94.1,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-11-20",
      baseline_complete: 94.7,
      actual_complete: 94.1,
      forecast_complete: 77.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-11-27",
      baseline_complete: 95.1,
      actual_complete: 95.0,
      forecast_complete: 78.9,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-12-04",
      baseline_complete: 95.4,
      actual_complete: 95.3,
      forecast_complete: 80.2,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-12-11",
      baseline_complete: 95.7,
      actual_complete: 97.3,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-12-18",
      baseline_complete: 96.1,
      actual_complete: 97.3,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2027-12-25",
      baseline_complete: 96.3,
      actual_complete: 99.8,
      forecast_complete: 83.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-01-01",
      baseline_complete: 96.6,
      actual_complete: 100.0,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-01-08",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-01-15",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 86.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-01-22",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-01-29",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-02-05",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-02-12",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-02-19",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-02-26",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-03-04",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-03-11",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-03-18",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-03-25",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-04-01",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-04-08",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-04-15",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-04-22",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-04-29",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-05-06",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-05-13",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-05-20",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-05-27",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-06-03",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-06-10",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-06-17",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-06-24",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-07-01",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-07-08",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-07-15",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "91824670-8112-92d4-207f-6e53e569077e",
      reporting_date: "2028-07-17",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
  ],
  "e6679fbf-a152-90b6-85af-25a473c75793": [
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-02-05",
      baseline_complete: 1.1,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-02-12",
      baseline_complete: 1.1,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-02-19",
      baseline_complete: 1.2,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-02-26",
      baseline_complete: 1.2,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-03-05",
      baseline_complete: 1.3,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-03-12",
      baseline_complete: 1.4,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-03-19",
      baseline_complete: 1.4,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-03-26",
      baseline_complete: 1.5,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-04-02",
      baseline_complete: 1.6,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-04-09",
      baseline_complete: 1.7,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-04-16",
      baseline_complete: 1.8,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-04-23",
      baseline_complete: 1.8,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-04-30",
      baseline_complete: 1.9,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-05-07",
      baseline_complete: 2.0,
      actual_complete: 4.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-05-14",
      baseline_complete: 2.1,
      actual_complete: 4.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-05-21",
      baseline_complete: 2.2,
      actual_complete: 4.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-05-28",
      baseline_complete: 2.3,
      actual_complete: 4.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-06-04",
      baseline_complete: 2.5,
      actual_complete: 4.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-06-11",
      baseline_complete: 2.6,
      actual_complete: 4.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-06-18",
      baseline_complete: 2.7,
      actual_complete: 4.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-06-25",
      baseline_complete: 2.9,
      actual_complete: 4.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-07-02",
      baseline_complete: 3.0,
      actual_complete: 4.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-07-09",
      baseline_complete: 3.1,
      actual_complete: 4.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-07-16",
      baseline_complete: 3.3,
      actual_complete: 5.0,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-07-23",
      baseline_complete: 3.5,
      actual_complete: 5.0,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-07-30",
      baseline_complete: 3.6,
      actual_complete: 5.0,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-08-06",
      baseline_complete: 3.8,
      actual_complete: 5.0,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-08-13",
      baseline_complete: 4.0,
      actual_complete: 5.6,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-08-20",
      baseline_complete: 4.2,
      actual_complete: 6.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-08-27",
      baseline_complete: 4.4,
      actual_complete: 6.4,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-09-03",
      baseline_complete: 4.6,
      actual_complete: 7.1,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-09-10",
      baseline_complete: 4.8,
      actual_complete: 7.1,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-09-17",
      baseline_complete: 5.1,
      actual_complete: 7.1,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-09-24",
      baseline_complete: 5.3,
      actual_complete: 7.1,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-10-01",
      baseline_complete: 5.5,
      actual_complete: 7.1,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-10-08",
      baseline_complete: 5.8,
      actual_complete: 7.1,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-10-15",
      baseline_complete: 6.1,
      actual_complete: 7.1,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-10-22",
      baseline_complete: 6.4,
      actual_complete: 7.1,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-10-29",
      baseline_complete: 6.7,
      actual_complete: 7.1,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-11-05",
      baseline_complete: 7.0,
      actual_complete: 8.8,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-11-12",
      baseline_complete: 7.3,
      actual_complete: 8.8,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-11-19",
      baseline_complete: 7.7,
      actual_complete: 8.8,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-11-26",
      baseline_complete: 8.0,
      actual_complete: 8.8,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-12-03",
      baseline_complete: 8.4,
      actual_complete: 9.8,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-12-10",
      baseline_complete: 8.8,
      actual_complete: 9.8,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-12-17",
      baseline_complete: 9.2,
      actual_complete: 9.8,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-12-24",
      baseline_complete: 9.6,
      actual_complete: 11.6,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2025-12-31",
      baseline_complete: 10.1,
      actual_complete: 11.6,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-01-07",
      baseline_complete: 10.5,
      actual_complete: 11.6,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-01-14",
      baseline_complete: 11.0,
      actual_complete: 14.3,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-01-21",
      baseline_complete: 11.5,
      actual_complete: 14.3,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-01-28",
      baseline_complete: 12.0,
      actual_complete: 14.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-02-04",
      baseline_complete: 12.5,
      actual_complete: 16.1,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-02-11",
      baseline_complete: 13.1,
      actual_complete: 16.1,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-02-18",
      baseline_complete: 13.7,
      actual_complete: 16.1,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-02-25",
      baseline_complete: 14.3,
      actual_complete: 17.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-03-04",
      baseline_complete: 14.9,
      actual_complete: 17.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-03-11",
      baseline_complete: 15.5,
      actual_complete: 18.1,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-03-18",
      baseline_complete: 16.2,
      actual_complete: 18.1,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-03-25",
      baseline_complete: 16.9,
      actual_complete: 18.1,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-04-01",
      baseline_complete: 17.6,
      actual_complete: 18.1,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-04-08",
      baseline_complete: 18.3,
      actual_complete: 18.1,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-04-15",
      baseline_complete: 19.1,
      actual_complete: 19.0,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-04-22",
      baseline_complete: 19.8,
      actual_complete: 19.0,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-04-29",
      baseline_complete: 20.6,
      actual_complete: 24.3,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-05-06",
      baseline_complete: 21.5,
      actual_complete: 24.3,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-05-13",
      baseline_complete: 22.3,
      actual_complete: 24.3,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-05-20",
      baseline_complete: 23.2,
      actual_complete: 24.4,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-05-27",
      baseline_complete: 24.1,
      actual_complete: 24.4,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-06-03",
      baseline_complete: 25.0,
      actual_complete: 26.7,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-06-10",
      baseline_complete: 25.9,
      actual_complete: 26.7,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-06-17",
      baseline_complete: 26.9,
      actual_complete: 30.1,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-06-24",
      baseline_complete: 27.9,
      actual_complete: 30.1,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-07-01",
      baseline_complete: 28.9,
      actual_complete: 30.1,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-07-08",
      baseline_complete: 29.9,
      actual_complete: 30.1,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-07-15",
      baseline_complete: 31.0,
      actual_complete: 34.3,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-07-22",
      baseline_complete: 32.1,
      actual_complete: 34.3,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-07-29",
      baseline_complete: 33.2,
      actual_complete: 34.3,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-08-05",
      baseline_complete: 34.3,
      actual_complete: 34.3,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-08-12",
      baseline_complete: 35.4,
      actual_complete: 37.9,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-08-19",
      baseline_complete: 36.5,
      actual_complete: 39.1,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-08-26",
      baseline_complete: 37.7,
      actual_complete: 41.2,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-09-02",
      baseline_complete: 38.9,
      actual_complete: 41.2,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-09-09",
      baseline_complete: 40.0,
      actual_complete: 43.0,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-09-16",
      baseline_complete: 41.2,
      actual_complete: 43.0,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-09-23",
      baseline_complete: 42.4,
      actual_complete: 43.0,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-09-30",
      baseline_complete: 43.7,
      actual_complete: 43.0,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-10-07",
      baseline_complete: 44.9,
      actual_complete: 43.0,
      forecast_complete: 23.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-10-14",
      baseline_complete: 46.1,
      actual_complete: 45.9,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-10-21",
      baseline_complete: 47.3,
      actual_complete: 49.5,
      forecast_complete: 25.1,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-10-28",
      baseline_complete: 48.6,
      actual_complete: 49.5,
      forecast_complete: 26.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-11-04",
      baseline_complete: 49.8,
      actual_complete: 53.4,
      forecast_complete: 26.9,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-11-11",
      baseline_complete: 51.1,
      actual_complete: 53.4,
      forecast_complete: 27.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-11-18",
      baseline_complete: 52.3,
      actual_complete: 53.4,
      forecast_complete: 28.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-11-25",
      baseline_complete: 53.5,
      actual_complete: 57.0,
      forecast_complete: 29.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-12-02",
      baseline_complete: 54.8,
      actual_complete: 58.6,
      forecast_complete: 30.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-12-09",
      baseline_complete: 56.0,
      actual_complete: 59.5,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-12-16",
      baseline_complete: 57.2,
      actual_complete: 59.5,
      forecast_complete: 32.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-12-23",
      baseline_complete: 58.4,
      actual_complete: 60.3,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2026-12-30",
      baseline_complete: 59.6,
      actual_complete: 60.8,
      forecast_complete: 34.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-01-06",
      baseline_complete: 60.8,
      actual_complete: 60.8,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-01-13",
      baseline_complete: 62.0,
      actual_complete: 63.6,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-01-20",
      baseline_complete: 63.2,
      actual_complete: 63.6,
      forecast_complete: 37.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-01-27",
      baseline_complete: 64.3,
      actual_complete: 64.8,
      forecast_complete: 38.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-02-03",
      baseline_complete: 65.4,
      actual_complete: 69.1,
      forecast_complete: 39.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-02-10",
      baseline_complete: 66.5,
      actual_complete: 69.1,
      forecast_complete: 40.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-02-17",
      baseline_complete: 67.6,
      actual_complete: 69.1,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-02-24",
      baseline_complete: 68.7,
      actual_complete: 71.3,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-03-03",
      baseline_complete: 69.8,
      actual_complete: 71.4,
      forecast_complete: 43.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-03-10",
      baseline_complete: 70.8,
      actual_complete: 71.4,
      forecast_complete: 44.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-03-17",
      baseline_complete: 71.8,
      actual_complete: 74.6,
      forecast_complete: 45.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-03-24",
      baseline_complete: 72.8,
      actual_complete: 74.6,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-03-31",
      baseline_complete: 73.8,
      actual_complete: 74.6,
      forecast_complete: 47.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-04-07",
      baseline_complete: 74.7,
      actual_complete: 76.3,
      forecast_complete: 48.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-04-14",
      baseline_complete: 75.7,
      actual_complete: 76.3,
      forecast_complete: 49.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-04-21",
      baseline_complete: 76.6,
      actual_complete: 80.6,
      forecast_complete: 50.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-04-28",
      baseline_complete: 77.4,
      actual_complete: 80.6,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-05-05",
      baseline_complete: 78.3,
      actual_complete: 80.6,
      forecast_complete: 52.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-05-12",
      baseline_complete: 79.1,
      actual_complete: 82.2,
      forecast_complete: 53.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-05-19",
      baseline_complete: 79.9,
      actual_complete: 82.2,
      forecast_complete: 54.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-05-26",
      baseline_complete: 80.7,
      actual_complete: 82.2,
      forecast_complete: 55.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-06-02",
      baseline_complete: 81.5,
      actual_complete: 82.2,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-06-09",
      baseline_complete: 82.2,
      actual_complete: 82.2,
      forecast_complete: 57.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-06-16",
      baseline_complete: 82.9,
      actual_complete: 85.2,
      forecast_complete: 58.1,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-06-23",
      baseline_complete: 83.6,
      actual_complete: 85.2,
      forecast_complete: 59.1,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-06-30",
      baseline_complete: 84.3,
      actual_complete: 86.8,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-07-07",
      baseline_complete: 84.9,
      actual_complete: 87.5,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-07-14",
      baseline_complete: 85.6,
      actual_complete: 87.5,
      forecast_complete: 61.9,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-07-21",
      baseline_complete: 86.2,
      actual_complete: 87.5,
      forecast_complete: 62.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-07-28",
      baseline_complete: 86.7,
      actual_complete: 88.8,
      forecast_complete: 63.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-08-04",
      baseline_complete: 87.3,
      actual_complete: 90.3,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-08-11",
      baseline_complete: 87.8,
      actual_complete: 91.2,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-08-18",
      baseline_complete: 88.4,
      actual_complete: 93.0,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-08-25",
      baseline_complete: 88.9,
      actual_complete: 93.0,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-09-01",
      baseline_complete: 89.3,
      actual_complete: 93.0,
      forecast_complete: 68.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-09-08",
      baseline_complete: 89.8,
      actual_complete: 93.0,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-09-15",
      baseline_complete: 90.2,
      actual_complete: 93.0,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-09-22",
      baseline_complete: 90.7,
      actual_complete: 93.0,
      forecast_complete: 72.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-09-29",
      baseline_complete: 91.1,
      actual_complete: 93.1,
      forecast_complete: 74.1,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-10-06",
      baseline_complete: 91.5,
      actual_complete: 93.3,
      forecast_complete: 75.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-10-13",
      baseline_complete: 91.9,
      actual_complete: 93.3,
      forecast_complete: 76.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-10-20",
      baseline_complete: 92.2,
      actual_complete: 96.7,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-10-27",
      baseline_complete: 92.6,
      actual_complete: 96.7,
      forecast_complete: 79.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-11-03",
      baseline_complete: 92.9,
      actual_complete: 96.7,
      forecast_complete: 80.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-11-10",
      baseline_complete: 93.2,
      actual_complete: 96.7,
      forecast_complete: 81.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-11-17",
      baseline_complete: 93.5,
      actual_complete: 96.7,
      forecast_complete: 82.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-11-24",
      baseline_complete: 93.8,
      actual_complete: 96.7,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-12-01",
      baseline_complete: 94.1,
      actual_complete: 96.7,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-12-08",
      baseline_complete: 94.4,
      actual_complete: 96.7,
      forecast_complete: 85.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-12-15",
      baseline_complete: 94.6,
      actual_complete: 96.7,
      forecast_complete: 86.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-12-22",
      baseline_complete: 94.9,
      actual_complete: 98.3,
      forecast_complete: 87.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2027-12-29",
      baseline_complete: 95.1,
      actual_complete: 98.3,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-01-05",
      baseline_complete: 95.3,
      actual_complete: 98.3,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-01-12",
      baseline_complete: 95.6,
      actual_complete: 98.4,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-01-19",
      baseline_complete: 95.8,
      actual_complete: 98.4,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-01-26",
      baseline_complete: 96.0,
      actual_complete: 99.5,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-02-02",
      baseline_complete: 96.1,
      actual_complete: 99.8,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-02-09",
      baseline_complete: 96.3,
      actual_complete: 99.8,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-02-16",
      baseline_complete: 96.5,
      actual_complete: 99.8,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-02-23",
      baseline_complete: 96.7,
      actual_complete: 99.8,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-03-01",
      baseline_complete: 96.8,
      actual_complete: 99.8,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-03-08",
      baseline_complete: 97.0,
      actual_complete: 99.8,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-03-15",
      baseline_complete: 97.1,
      actual_complete: 99.8,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-03-22",
      baseline_complete: 97.2,
      actual_complete: 99.8,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-03-29",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-04-05",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-04-12",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-04-19",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-04-26",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-05-03",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-05-10",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-05-17",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-05-24",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-05-31",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-06-07",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-06-14",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-06-21",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-06-28",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "e6679fbf-a152-90b6-85af-25a473c75793",
      reporting_date: "2028-07-05",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
  ],
  "0f3e99cd-4b01-7991-e96b-46284f930562": [
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-09-13",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-09-20",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-09-27",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-10-04",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-10-11",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-10-18",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-10-25",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-11-01",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-11-08",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-11-15",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-11-22",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-11-29",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-12-06",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-12-13",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-12-20",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2023-12-27",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-01-03",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-01-10",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-01-17",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-01-24",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-01-31",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-02-07",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-02-14",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-02-21",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-02-28",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-03-06",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-03-13",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-03-20",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-03-27",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-04-03",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-04-10",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-04-17",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-04-24",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-05-01",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-05-08",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-05-15",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-05-22",
      baseline_complete: 2.6,
      actual_complete: 0.3,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-05-29",
      baseline_complete: 2.8,
      actual_complete: 0.3,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-06-05",
      baseline_complete: 3.0,
      actual_complete: 0.3,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-06-12",
      baseline_complete: 3.2,
      actual_complete: 0.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-06-19",
      baseline_complete: 3.4,
      actual_complete: 0.3,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-06-26",
      baseline_complete: 3.7,
      actual_complete: 0.3,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-07-03",
      baseline_complete: 3.9,
      actual_complete: 2.1,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-07-10",
      baseline_complete: 4.2,
      actual_complete: 2.1,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-07-17",
      baseline_complete: 4.5,
      actual_complete: 2.1,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-07-24",
      baseline_complete: 4.8,
      actual_complete: 2.1,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-07-31",
      baseline_complete: 5.1,
      actual_complete: 2.1,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-08-07",
      baseline_complete: 5.5,
      actual_complete: 2.1,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-08-14",
      baseline_complete: 5.9,
      actual_complete: 2.7,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-08-21",
      baseline_complete: 6.3,
      actual_complete: 2.7,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-08-28",
      baseline_complete: 6.7,
      actual_complete: 4.6,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-09-04",
      baseline_complete: 7.2,
      actual_complete: 4.6,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-09-11",
      baseline_complete: 7.6,
      actual_complete: 5.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-09-18",
      baseline_complete: 8.2,
      actual_complete: 5.9,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-09-25",
      baseline_complete: 8.7,
      actual_complete: 5.9,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-10-02",
      baseline_complete: 9.3,
      actual_complete: 5.9,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-10-09",
      baseline_complete: 9.9,
      actual_complete: 5.9,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-10-16",
      baseline_complete: 10.5,
      actual_complete: 8.1,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-10-23",
      baseline_complete: 11.2,
      actual_complete: 8.1,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-10-30",
      baseline_complete: 11.9,
      actual_complete: 8.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-11-06",
      baseline_complete: 12.7,
      actual_complete: 8.1,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-11-13",
      baseline_complete: 13.5,
      actual_complete: 8.9,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-11-20",
      baseline_complete: 14.3,
      actual_complete: 13.7,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-11-27",
      baseline_complete: 15.2,
      actual_complete: 13.7,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-12-04",
      baseline_complete: 16.2,
      actual_complete: 14.0,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-12-11",
      baseline_complete: 17.1,
      actual_complete: 14.0,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-12-18",
      baseline_complete: 18.2,
      actual_complete: 14.0,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2024-12-25",
      baseline_complete: 19.2,
      actual_complete: 15.8,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-01-01",
      baseline_complete: 20.4,
      actual_complete: 20.3,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-01-08",
      baseline_complete: 21.5,
      actual_complete: 20.9,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-01-15",
      baseline_complete: 22.7,
      actual_complete: 21.3,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-01-22",
      baseline_complete: 24.0,
      actual_complete: 21.3,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-01-29",
      baseline_complete: 25.3,
      actual_complete: 22.3,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-02-05",
      baseline_complete: 26.7,
      actual_complete: 24.2,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-02-12",
      baseline_complete: 28.1,
      actual_complete: 26.0,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-02-19",
      baseline_complete: 29.5,
      actual_complete: 27.8,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-02-26",
      baseline_complete: 31.0,
      actual_complete: 27.8,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-03-05",
      baseline_complete: 32.5,
      actual_complete: 30.4,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-03-12",
      baseline_complete: 34.1,
      actual_complete: 33.1,
      forecast_complete: 17.6,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-03-19",
      baseline_complete: 35.7,
      actual_complete: 33.1,
      forecast_complete: 18.6,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-03-26",
      baseline_complete: 37.3,
      actual_complete: 33.5,
      forecast_complete: 19.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-04-02",
      baseline_complete: 39.0,
      actual_complete: 37.0,
      forecast_complete: 20.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-04-09",
      baseline_complete: 40.7,
      actual_complete: 40.8,
      forecast_complete: 21.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-04-16",
      baseline_complete: 42.4,
      actual_complete: 41.5,
      forecast_complete: 23.1,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-04-23",
      baseline_complete: 44.1,
      actual_complete: 41.5,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-04-30",
      baseline_complete: 45.9,
      actual_complete: 45.6,
      forecast_complete: 25.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-05-07",
      baseline_complete: 47.6,
      actual_complete: 47.9,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-05-14",
      baseline_complete: 49.4,
      actual_complete: 47.9,
      forecast_complete: 28.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-05-21",
      baseline_complete: 51.2,
      actual_complete: 49.9,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-05-28",
      baseline_complete: 52.9,
      actual_complete: 49.9,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-06-04",
      baseline_complete: 54.7,
      actual_complete: 51.9,
      forecast_complete: 32.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-06-11",
      baseline_complete: 56.4,
      actual_complete: 56.5,
      forecast_complete: 33.4,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-06-18",
      baseline_complete: 58.1,
      actual_complete: 57.2,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-06-25",
      baseline_complete: 59.8,
      actual_complete: 57.8,
      forecast_complete: 36.1,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-07-02",
      baseline_complete: 61.5,
      actual_complete: 59.9,
      forecast_complete: 37.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-07-09",
      baseline_complete: 63.2,
      actual_complete: 63.4,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-07-16",
      baseline_complete: 64.8,
      actual_complete: 63.4,
      forecast_complete: 40.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-07-23",
      baseline_complete: 66.4,
      actual_complete: 67.4,
      forecast_complete: 41.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-07-30",
      baseline_complete: 67.9,
      actual_complete: 67.4,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-08-06",
      baseline_complete: 69.5,
      actual_complete: 67.4,
      forecast_complete: 44.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-08-13",
      baseline_complete: 70.9,
      actual_complete: 71.9,
      forecast_complete: 45.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-08-20",
      baseline_complete: 72.4,
      actual_complete: 71.9,
      forecast_complete: 47.2,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-08-27",
      baseline_complete: 73.8,
      actual_complete: 71.9,
      forecast_complete: 48.6,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-09-03",
      baseline_complete: 75.1,
      actual_complete: 73.1,
      forecast_complete: 49.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-09-10",
      baseline_complete: 76.4,
      actual_complete: 78.1,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-09-17",
      baseline_complete: 77.6,
      actual_complete: 78.1,
      forecast_complete: 52.6,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-09-24",
      baseline_complete: 78.8,
      actual_complete: 78.1,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-10-01",
      baseline_complete: 80.0,
      actual_complete: 79.6,
      forecast_complete: 55.2,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-10-08",
      baseline_complete: 81.1,
      actual_complete: 83.0,
      forecast_complete: 56.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-10-15",
      baseline_complete: 82.2,
      actual_complete: 83.0,
      forecast_complete: 57.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-10-22",
      baseline_complete: 83.2,
      actual_complete: 83.0,
      forecast_complete: 59.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-10-29",
      baseline_complete: 84.1,
      actual_complete: 85.7,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-11-05",
      baseline_complete: 85.0,
      actual_complete: 85.7,
      forecast_complete: 61.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-11-12",
      baseline_complete: 85.9,
      actual_complete: 85.7,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-11-19",
      baseline_complete: 86.8,
      actual_complete: 86.8,
      forecast_complete: 63.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-11-26",
      baseline_complete: 87.5,
      actual_complete: 86.8,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-12-03",
      baseline_complete: 88.3,
      actual_complete: 86.8,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-12-10",
      baseline_complete: 89.0,
      actual_complete: 88.5,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-12-17",
      baseline_complete: 89.7,
      actual_complete: 88.8,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-12-24",
      baseline_complete: 90.3,
      actual_complete: 91.6,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2025-12-31",
      baseline_complete: 90.9,
      actual_complete: 91.7,
      forecast_complete: 71.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-01-07",
      baseline_complete: 91.5,
      actual_complete: 91.9,
      forecast_complete: 73.6,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-01-14",
      baseline_complete: 92.0,
      actual_complete: 92.2,
      forecast_complete: 75.2,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-01-21",
      baseline_complete: 92.5,
      actual_complete: 92.2,
      forecast_complete: 76.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-01-28",
      baseline_complete: 93.0,
      actual_complete: 92.2,
      forecast_complete: 78.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-02-04",
      baseline_complete: 93.4,
      actual_complete: 94.3,
      forecast_complete: 79.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-02-11",
      baseline_complete: 93.9,
      actual_complete: 94.3,
      forecast_complete: 81.2,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-02-18",
      baseline_complete: 94.2,
      actual_complete: 95.9,
      forecast_complete: 82.5,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-02-25",
      baseline_complete: 94.6,
      actual_complete: 95.9,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-03-04",
      baseline_complete: 95.0,
      actual_complete: 95.9,
      forecast_complete: 85.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-03-11",
      baseline_complete: 95.3,
      actual_complete: 96.6,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-03-18",
      baseline_complete: 95.6,
      actual_complete: 96.6,
      forecast_complete: 87.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-03-25",
      baseline_complete: 95.9,
      actual_complete: 96.6,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-04-01",
      baseline_complete: 96.2,
      actual_complete: 97.9,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-04-08",
      baseline_complete: 96.4,
      actual_complete: 97.9,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-04-15",
      baseline_complete: 96.6,
      actual_complete: 97.9,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-04-22",
      baseline_complete: 96.9,
      actual_complete: 98.4,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-04-29",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-05-06",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-05-13",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-05-20",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-05-27",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-06-03",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-06-10",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-06-17",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-06-24",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-07-01",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-07-08",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-07-15",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-07-22",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-07-29",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-08-05",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-08-12",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-08-19",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-08-26",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-09-02",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-09-09",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f3e99cd-4b01-7991-e96b-46284f930562",
      reporting_date: "2026-09-13",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "27b3c82f-0697-2114-a665-88f73dee3105": [
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-07-09",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-07-16",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-07-23",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-07-30",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-08-06",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-08-13",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-08-20",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-08-27",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-09-03",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-09-10",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-09-17",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-09-24",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-10-01",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-10-08",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-10-15",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-10-22",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-10-29",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-11-05",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-11-12",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-11-19",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-11-26",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-12-03",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-12-10",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-12-17",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-12-24",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2024-12-31",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-01-07",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-01-14",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-01-21",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-01-28",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-02-04",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-02-11",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-02-18",
      baseline_complete: 3.7,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-02-25",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-03-04",
      baseline_complete: 4.1,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-03-11",
      baseline_complete: 4.3,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-03-18",
      baseline_complete: 4.5,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-03-25",
      baseline_complete: 4.8,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-04-01",
      baseline_complete: 5.0,
      actual_complete: 0.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-04-08",
      baseline_complete: 5.3,
      actual_complete: 0.0,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-04-15",
      baseline_complete: 5.6,
      actual_complete: 0.0,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-04-22",
      baseline_complete: 5.9,
      actual_complete: 0.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-04-29",
      baseline_complete: 6.2,
      actual_complete: 1.5,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-05-06",
      baseline_complete: 6.5,
      actual_complete: 1.5,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-05-13",
      baseline_complete: 6.8,
      actual_complete: 1.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-05-20",
      baseline_complete: 7.2,
      actual_complete: 2.8,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-05-27",
      baseline_complete: 7.6,
      actual_complete: 4.1,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-06-03",
      baseline_complete: 8.0,
      actual_complete: 4.1,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-06-10",
      baseline_complete: 8.4,
      actual_complete: 4.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-06-17",
      baseline_complete: 8.8,
      actual_complete: 4.1,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-06-24",
      baseline_complete: 9.2,
      actual_complete: 4.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-07-01",
      baseline_complete: 9.7,
      actual_complete: 4.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-07-08",
      baseline_complete: 10.2,
      actual_complete: 4.7,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-07-15",
      baseline_complete: 10.7,
      actual_complete: 4.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-07-22",
      baseline_complete: 11.2,
      actual_complete: 4.7,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-07-29",
      baseline_complete: 11.8,
      actual_complete: 4.7,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-08-05",
      baseline_complete: 12.3,
      actual_complete: 7.2,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-08-12",
      baseline_complete: 12.9,
      actual_complete: 7.2,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-08-19",
      baseline_complete: 13.6,
      actual_complete: 7.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-08-26",
      baseline_complete: 14.2,
      actual_complete: 7.4,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-09-02",
      baseline_complete: 14.9,
      actual_complete: 11.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-09-09",
      baseline_complete: 15.6,
      actual_complete: 11.6,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-09-16",
      baseline_complete: 16.3,
      actual_complete: 12.0,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-09-23",
      baseline_complete: 17.1,
      actual_complete: 12.0,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-09-30",
      baseline_complete: 17.8,
      actual_complete: 12.0,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-10-07",
      baseline_complete: 18.6,
      actual_complete: 13.8,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-10-14",
      baseline_complete: 19.5,
      actual_complete: 13.9,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-10-21",
      baseline_complete: 20.3,
      actual_complete: 14.5,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-10-28",
      baseline_complete: 21.2,
      actual_complete: 15.0,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-11-04",
      baseline_complete: 22.1,
      actual_complete: 17.5,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-11-11",
      baseline_complete: 23.1,
      actual_complete: 18.3,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-11-18",
      baseline_complete: 24.1,
      actual_complete: 20.5,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-11-25",
      baseline_complete: 25.1,
      actual_complete: 21.9,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-12-02",
      baseline_complete: 26.1,
      actual_complete: 21.9,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-12-09",
      baseline_complete: 27.2,
      actual_complete: 22.7,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-12-16",
      baseline_complete: 28.3,
      actual_complete: 22.7,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-12-23",
      baseline_complete: 29.4,
      actual_complete: 22.8,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2025-12-30",
      baseline_complete: 30.5,
      actual_complete: 27.7,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-01-06",
      baseline_complete: 31.7,
      actual_complete: 27.7,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-01-13",
      baseline_complete: 32.8,
      actual_complete: 27.7,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-01-20",
      baseline_complete: 34.0,
      actual_complete: 27.7,
      forecast_complete: 14.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-01-27",
      baseline_complete: 35.3,
      actual_complete: 32.0,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-02-03",
      baseline_complete: 36.5,
      actual_complete: 32.0,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-02-10",
      baseline_complete: 37.8,
      actual_complete: 33.7,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-02-17",
      baseline_complete: 39.1,
      actual_complete: 33.7,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-02-24",
      baseline_complete: 40.4,
      actual_complete: 37.0,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-03-03",
      baseline_complete: 41.7,
      actual_complete: 37.0,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-03-10",
      baseline_complete: 43.0,
      actual_complete: 38.7,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-03-17",
      baseline_complete: 44.3,
      actual_complete: 38.7,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-03-24",
      baseline_complete: 45.7,
      actual_complete: 42.5,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-03-31",
      baseline_complete: 47.0,
      actual_complete: 45.1,
      forecast_complete: 21.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-04-07",
      baseline_complete: 48.4,
      actual_complete: 45.1,
      forecast_complete: 22.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-04-14",
      baseline_complete: 49.7,
      actual_complete: 48.3,
      forecast_complete: 23.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-04-21",
      baseline_complete: 51.1,
      actual_complete: 48.3,
      forecast_complete: 24.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-04-28",
      baseline_complete: 52.4,
      actual_complete: 48.3,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-05-05",
      baseline_complete: 53.8,
      actual_complete: 50.0,
      forecast_complete: 26.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-05-12",
      baseline_complete: 55.1,
      actual_complete: 50.5,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-05-19",
      baseline_complete: 56.5,
      actual_complete: 53.3,
      forecast_complete: 28.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-05-26",
      baseline_complete: 57.8,
      actual_complete: 53.3,
      forecast_complete: 28.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-06-02",
      baseline_complete: 59.1,
      actual_complete: 56.1,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-06-09",
      baseline_complete: 60.4,
      actual_complete: 57.9,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-06-16",
      baseline_complete: 61.7,
      actual_complete: 59.1,
      forecast_complete: 31.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-06-23",
      baseline_complete: 63.0,
      actual_complete: 59.1,
      forecast_complete: 32.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-06-30",
      baseline_complete: 64.2,
      actual_complete: 62.7,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-07-07",
      baseline_complete: 65.5,
      actual_complete: 64.1,
      forecast_complete: 34.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-07-14",
      baseline_complete: 66.7,
      actual_complete: 64.5,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-07-21",
      baseline_complete: 67.9,
      actual_complete: 64.5,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-07-28",
      baseline_complete: 69.0,
      actual_complete: 64.5,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-08-04",
      baseline_complete: 70.2,
      actual_complete: 69.2,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-08-11",
      baseline_complete: 71.3,
      actual_complete: 69.2,
      forecast_complete: 39.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-08-18",
      baseline_complete: 72.4,
      actual_complete: 69.2,
      forecast_complete: 40.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-08-25",
      baseline_complete: 73.5,
      actual_complete: 69.2,
      forecast_complete: 41.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-09-01",
      baseline_complete: 74.5,
      actual_complete: 69.2,
      forecast_complete: 41.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-09-08",
      baseline_complete: 75.5,
      actual_complete: 74.4,
      forecast_complete: 42.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-09-15",
      baseline_complete: 76.5,
      actual_complete: 75.8,
      forecast_complete: 43.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-09-22",
      baseline_complete: 77.5,
      actual_complete: 75.8,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-09-29",
      baseline_complete: 78.4,
      actual_complete: 75.8,
      forecast_complete: 45.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-10-06",
      baseline_complete: 79.3,
      actual_complete: 77.0,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-10-13",
      baseline_complete: 80.2,
      actual_complete: 77.9,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-10-20",
      baseline_complete: 81.0,
      actual_complete: 78.6,
      forecast_complete: 48.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-10-27",
      baseline_complete: 81.8,
      actual_complete: 78.6,
      forecast_complete: 49.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-11-03",
      baseline_complete: 82.6,
      actual_complete: 78.6,
      forecast_complete: 50.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-11-10",
      baseline_complete: 83.4,
      actual_complete: 81.9,
      forecast_complete: 50.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-11-17",
      baseline_complete: 84.1,
      actual_complete: 83.5,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-11-24",
      baseline_complete: 84.8,
      actual_complete: 83.5,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-12-01",
      baseline_complete: 85.5,
      actual_complete: 83.5,
      forecast_complete: 53.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-12-08",
      baseline_complete: 86.2,
      actual_complete: 84.1,
      forecast_complete: 54.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-12-15",
      baseline_complete: 86.8,
      actual_complete: 84.1,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-12-22",
      baseline_complete: 87.4,
      actual_complete: 84.1,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2026-12-29",
      baseline_complete: 88.0,
      actual_complete: 84.6,
      forecast_complete: 56.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-01-05",
      baseline_complete: 88.6,
      actual_complete: 84.9,
      forecast_complete: 57.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-01-12",
      baseline_complete: 89.1,
      actual_complete: 86.1,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-01-19",
      baseline_complete: 89.6,
      actual_complete: 87.3,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-01-26",
      baseline_complete: 90.1,
      actual_complete: 87.3,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-02-02",
      baseline_complete: 90.6,
      actual_complete: 87.8,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-02-09",
      baseline_complete: 91.0,
      actual_complete: 89.9,
      forecast_complete: 61.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-02-16",
      baseline_complete: 91.5,
      actual_complete: 89.9,
      forecast_complete: 61.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-02-23",
      baseline_complete: 91.9,
      actual_complete: 92.2,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-03-02",
      baseline_complete: 92.3,
      actual_complete: 92.2,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-03-09",
      baseline_complete: 92.7,
      actual_complete: 92.2,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-03-16",
      baseline_complete: 93.0,
      actual_complete: 93.8,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-03-23",
      baseline_complete: 93.4,
      actual_complete: 93.8,
      forecast_complete: 65.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-03-30",
      baseline_complete: 93.7,
      actual_complete: 93.8,
      forecast_complete: 66.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-04-06",
      baseline_complete: 94.0,
      actual_complete: 93.8,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-04-13",
      baseline_complete: 94.3,
      actual_complete: 93.8,
      forecast_complete: 67.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-04-20",
      baseline_complete: 94.6,
      actual_complete: 95.5,
      forecast_complete: 68.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-04-27",
      baseline_complete: 94.9,
      actual_complete: 95.5,
      forecast_complete: 68.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-05-04",
      baseline_complete: 95.1,
      actual_complete: 95.5,
      forecast_complete: 69.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-05-11",
      baseline_complete: 95.4,
      actual_complete: 95.7,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-05-18",
      baseline_complete: 95.6,
      actual_complete: 96.8,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-05-25",
      baseline_complete: 95.8,
      actual_complete: 96.8,
      forecast_complete: 71.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-06-01",
      baseline_complete: 96.0,
      actual_complete: 96.8,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-06-08",
      baseline_complete: 96.2,
      actual_complete: 96.8,
      forecast_complete: 72.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-06-15",
      baseline_complete: 96.4,
      actual_complete: 98.2,
      forecast_complete: 73.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-06-22",
      baseline_complete: 96.6,
      actual_complete: 98.2,
      forecast_complete: 73.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-06-29",
      baseline_complete: 96.8,
      actual_complete: 98.2,
      forecast_complete: 75.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-07-06",
      baseline_complete: 96.9,
      actual_complete: 98.2,
      forecast_complete: 76.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-07-13",
      baseline_complete: 97.1,
      actual_complete: 98.2,
      forecast_complete: 77.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-07-20",
      baseline_complete: 97.2,
      actual_complete: 98.2,
      forecast_complete: 78.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-07-27",
      baseline_complete: 97.4,
      actual_complete: 98.2,
      forecast_complete: 79.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-08-03",
      baseline_complete: 97.5,
      actual_complete: 98.5,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-08-10",
      baseline_complete: 97.7,
      actual_complete: 98.5,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-08-17",
      baseline_complete: 97.8,
      actual_complete: 98.5,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-08-24",
      baseline_complete: 97.9,
      actual_complete: 98.5,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-08-31",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 84.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-09-07",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 84.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-09-14",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 85.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-09-21",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 86.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-09-28",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 87.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-10-05",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-10-12",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-10-19",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-10-26",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-11-02",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-11-09",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-11-16",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-11-23",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-11-30",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-12-07",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-12-14",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-12-21",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2027-12-28",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-01-04",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-01-11",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-01-18",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-01-25",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-02-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-02-08",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-02-15",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-02-22",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-02-29",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-03-07",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-03-14",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-03-21",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-03-28",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-04-04",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-04-11",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-04-18",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-04-25",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-05-02",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-05-09",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-05-16",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-05-23",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-05-30",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-06-06",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "27b3c82f-0697-2114-a665-88f73dee3105",
      reporting_date: "2028-06-09",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "4d54ba9a-9d96-b2e7-f9d3-669060e51fea": [
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-04-25",
      baseline_complete: 1.2,
      actual_complete: 4.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-05-02",
      baseline_complete: 1.3,
      actual_complete: 4.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-05-09",
      baseline_complete: 1.4,
      actual_complete: 4.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-05-16",
      baseline_complete: 1.6,
      actual_complete: 4.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-05-23",
      baseline_complete: 1.7,
      actual_complete: 4.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-05-30",
      baseline_complete: 1.8,
      actual_complete: 4.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-06-06",
      baseline_complete: 2.0,
      actual_complete: 4.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-06-13",
      baseline_complete: 2.2,
      actual_complete: 4.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-06-20",
      baseline_complete: 2.3,
      actual_complete: 4.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-06-27",
      baseline_complete: 2.5,
      actual_complete: 4.6,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-07-04",
      baseline_complete: 2.8,
      actual_complete: 5.1,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-07-11",
      baseline_complete: 3.0,
      actual_complete: 5.1,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-07-18",
      baseline_complete: 3.2,
      actual_complete: 5.1,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-07-25",
      baseline_complete: 3.5,
      actual_complete: 5.1,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-08-01",
      baseline_complete: 3.8,
      actual_complete: 5.1,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-08-08",
      baseline_complete: 4.1,
      actual_complete: 5.1,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-08-15",
      baseline_complete: 4.4,
      actual_complete: 6.8,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-08-22",
      baseline_complete: 4.8,
      actual_complete: 6.8,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-08-29",
      baseline_complete: 5.2,
      actual_complete: 8.7,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-09-05",
      baseline_complete: 5.6,
      actual_complete: 8.8,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-09-12",
      baseline_complete: 6.1,
      actual_complete: 8.8,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-09-19",
      baseline_complete: 6.5,
      actual_complete: 8.8,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-09-26",
      baseline_complete: 7.1,
      actual_complete: 9.5,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-10-03",
      baseline_complete: 7.6,
      actual_complete: 9.8,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-10-10",
      baseline_complete: 8.2,
      actual_complete: 9.8,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-10-17",
      baseline_complete: 8.9,
      actual_complete: 11.7,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-10-24",
      baseline_complete: 9.5,
      actual_complete: 11.7,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-10-31",
      baseline_complete: 10.3,
      actual_complete: 11.7,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-11-07",
      baseline_complete: 11.1,
      actual_complete: 11.7,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-11-14",
      baseline_complete: 11.9,
      actual_complete: 11.7,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-11-21",
      baseline_complete: 12.8,
      actual_complete: 15.3,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-11-28",
      baseline_complete: 13.7,
      actual_complete: 16.3,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-12-05",
      baseline_complete: 14.7,
      actual_complete: 17.0,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-12-12",
      baseline_complete: 15.8,
      actual_complete: 17.3,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-12-19",
      baseline_complete: 16.9,
      actual_complete: 17.4,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2023-12-26",
      baseline_complete: 18.1,
      actual_complete: 20.6,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-01-02",
      baseline_complete: 19.4,
      actual_complete: 21.7,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-01-09",
      baseline_complete: 20.7,
      actual_complete: 23.5,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-01-16",
      baseline_complete: 22.1,
      actual_complete: 23.5,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-01-23",
      baseline_complete: 23.5,
      actual_complete: 23.5,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-01-30",
      baseline_complete: 25.0,
      actual_complete: 28.0,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-02-06",
      baseline_complete: 26.6,
      actual_complete: 28.9,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-02-13",
      baseline_complete: 28.2,
      actual_complete: 30.3,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-02-20",
      baseline_complete: 29.9,
      actual_complete: 33.2,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-02-27",
      baseline_complete: 31.7,
      actual_complete: 33.2,
      forecast_complete: 15.9,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-03-05",
      baseline_complete: 33.5,
      actual_complete: 33.2,
      forecast_complete: 16.9,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-03-12",
      baseline_complete: 35.3,
      actual_complete: 38.5,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-03-19",
      baseline_complete: 37.2,
      actual_complete: 38.5,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-03-26",
      baseline_complete: 39.2,
      actual_complete: 38.5,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-04-02",
      baseline_complete: 41.1,
      actual_complete: 43.5,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-04-09",
      baseline_complete: 43.1,
      actual_complete: 44.8,
      forecast_complete: 22.9,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-04-16",
      baseline_complete: 45.2,
      actual_complete: 47.4,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-04-23",
      baseline_complete: 47.2,
      actual_complete: 51.0,
      forecast_complete: 25.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-04-30",
      baseline_complete: 49.2,
      actual_complete: 52.1,
      forecast_complete: 27.1,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-05-07",
      baseline_complete: 51.3,
      actual_complete: 53.1,
      forecast_complete: 28.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-05-14",
      baseline_complete: 53.4,
      actual_complete: 56.7,
      forecast_complete: 30.1,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-05-21",
      baseline_complete: 55.4,
      actual_complete: 56.7,
      forecast_complete: 31.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-05-28",
      baseline_complete: 57.4,
      actual_complete: 58.3,
      forecast_complete: 33.2,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-06-04",
      baseline_complete: 59.4,
      actual_complete: 58.3,
      forecast_complete: 34.8,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-06-11",
      baseline_complete: 61.4,
      actual_complete: 63.9,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-06-18",
      baseline_complete: 63.3,
      actual_complete: 66.4,
      forecast_complete: 38.1,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-06-25",
      baseline_complete: 65.2,
      actual_complete: 66.7,
      forecast_complete: 39.7,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-07-02",
      baseline_complete: 67.0,
      actual_complete: 70.5,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-07-09",
      baseline_complete: 68.8,
      actual_complete: 70.5,
      forecast_complete: 43.1,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-07-16",
      baseline_complete: 70.6,
      actual_complete: 71.9,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-07-23",
      baseline_complete: 72.2,
      actual_complete: 74.3,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-07-30",
      baseline_complete: 73.8,
      actual_complete: 76.6,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-08-06",
      baseline_complete: 75.4,
      actual_complete: 76.6,
      forecast_complete: 49.7,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-08-13",
      baseline_complete: 76.9,
      actual_complete: 80.2,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-08-20",
      baseline_complete: 78.3,
      actual_complete: 82.1,
      forecast_complete: 53.0,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-08-27",
      baseline_complete: 79.7,
      actual_complete: 82.1,
      forecast_complete: 54.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-09-03",
      baseline_complete: 81.0,
      actual_complete: 82.6,
      forecast_complete: 56.2,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-09-10",
      baseline_complete: 82.2,
      actual_complete: 86.4,
      forecast_complete: 57.8,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-09-17",
      baseline_complete: 83.4,
      actual_complete: 86.4,
      forecast_complete: 59.3,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-09-24",
      baseline_complete: 84.5,
      actual_complete: 86.4,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-10-01",
      baseline_complete: 85.5,
      actual_complete: 86.4,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-10-08",
      baseline_complete: 86.5,
      actual_complete: 89.9,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-10-15",
      baseline_complete: 87.5,
      actual_complete: 89.9,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-10-22",
      baseline_complete: 88.3,
      actual_complete: 89.9,
      forecast_complete: 66.7,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-10-29",
      baseline_complete: 89.2,
      actual_complete: 93.2,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-11-05",
      baseline_complete: 89.9,
      actual_complete: 93.2,
      forecast_complete: 71.0,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-11-12",
      baseline_complete: 90.6,
      actual_complete: 94.9,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-11-19",
      baseline_complete: 91.3,
      actual_complete: 95.1,
      forecast_complete: 75.7,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-11-26",
      baseline_complete: 91.9,
      actual_complete: 95.1,
      forecast_complete: 77.8,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-12-03",
      baseline_complete: 92.5,
      actual_complete: 95.7,
      forecast_complete: 79.9,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-12-10",
      baseline_complete: 93.1,
      actual_complete: 96.8,
      forecast_complete: 81.8,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-12-17",
      baseline_complete: 93.6,
      actual_complete: 96.8,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-12-24",
      baseline_complete: 94.1,
      actual_complete: 96.8,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2024-12-31",
      baseline_complete: 94.5,
      actual_complete: 96.8,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-01-07",
      baseline_complete: 94.9,
      actual_complete: 98.4,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-01-14",
      baseline_complete: 95.3,
      actual_complete: 98.4,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-01-21",
      baseline_complete: 95.7,
      actual_complete: 98.4,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-01-28",
      baseline_complete: 96.0,
      actual_complete: 98.4,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-02-04",
      baseline_complete: 96.3,
      actual_complete: 98.7,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-02-11",
      baseline_complete: 96.6,
      actual_complete: 99.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-02-18",
      baseline_complete: 96.8,
      actual_complete: 99.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-02-25",
      baseline_complete: 97.1,
      actual_complete: 99.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-03-04",
      baseline_complete: 97.3,
      actual_complete: 99.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-03-11",
      baseline_complete: 97.5,
      actual_complete: 99.2,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-03-18",
      baseline_complete: 97.7,
      actual_complete: 99.2,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-03-25",
      baseline_complete: 97.9,
      actual_complete: 99.2,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-04-01",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-04-08",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-04-15",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-04-22",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "4d54ba9a-9d96-b2e7-f9d3-669060e51fea",
      reporting_date: "2025-04-25",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
  ],
  "b562b45d-6677-0e21-b5e3-a7a28b974abc": [
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-07-19",
      baseline_complete: 1.0,
      actual_complete: 2.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-07-26",
      baseline_complete: 1.0,
      actual_complete: 2.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-08-02",
      baseline_complete: 1.1,
      actual_complete: 2.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-08-09",
      baseline_complete: 1.1,
      actual_complete: 3.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-08-16",
      baseline_complete: 1.2,
      actual_complete: 3.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-08-23",
      baseline_complete: 1.3,
      actual_complete: 3.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-08-30",
      baseline_complete: 1.3,
      actual_complete: 3.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-09-06",
      baseline_complete: 1.4,
      actual_complete: 3.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-09-13",
      baseline_complete: 1.5,
      actual_complete: 3.7,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-09-20",
      baseline_complete: 1.6,
      actual_complete: 4.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-09-27",
      baseline_complete: 1.7,
      actual_complete: 4.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-10-04",
      baseline_complete: 1.7,
      actual_complete: 4.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-10-11",
      baseline_complete: 1.8,
      actual_complete: 4.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-10-18",
      baseline_complete: 1.9,
      actual_complete: 4.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-10-25",
      baseline_complete: 2.0,
      actual_complete: 4.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-11-01",
      baseline_complete: 2.2,
      actual_complete: 4.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-11-08",
      baseline_complete: 2.3,
      actual_complete: 4.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-11-15",
      baseline_complete: 2.4,
      actual_complete: 4.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-11-22",
      baseline_complete: 2.5,
      actual_complete: 4.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-11-29",
      baseline_complete: 2.7,
      actual_complete: 5.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-12-06",
      baseline_complete: 2.8,
      actual_complete: 5.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-12-13",
      baseline_complete: 2.9,
      actual_complete: 5.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-12-20",
      baseline_complete: 3.1,
      actual_complete: 5.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2024-12-27",
      baseline_complete: 3.3,
      actual_complete: 5.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-01-03",
      baseline_complete: 3.4,
      actual_complete: 5.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-01-10",
      baseline_complete: 3.6,
      actual_complete: 5.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-01-17",
      baseline_complete: 3.8,
      actual_complete: 5.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-01-24",
      baseline_complete: 4.0,
      actual_complete: 5.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-01-31",
      baseline_complete: 4.2,
      actual_complete: 5.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-02-07",
      baseline_complete: 4.4,
      actual_complete: 6.1,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-02-14",
      baseline_complete: 4.7,
      actual_complete: 6.1,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-02-21",
      baseline_complete: 4.9,
      actual_complete: 6.5,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-02-28",
      baseline_complete: 5.2,
      actual_complete: 6.5,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-03-07",
      baseline_complete: 5.4,
      actual_complete: 6.5,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-03-14",
      baseline_complete: 5.7,
      actual_complete: 6.5,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-03-21",
      baseline_complete: 6.0,
      actual_complete: 7.3,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-03-28",
      baseline_complete: 6.3,
      actual_complete: 8.9,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-04-04",
      baseline_complete: 6.7,
      actual_complete: 8.9,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-04-11",
      baseline_complete: 7.0,
      actual_complete: 8.9,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-04-18",
      baseline_complete: 7.3,
      actual_complete: 9.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-04-25",
      baseline_complete: 7.7,
      actual_complete: 9.2,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-05-02",
      baseline_complete: 8.1,
      actual_complete: 10.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-05-09",
      baseline_complete: 8.5,
      actual_complete: 10.7,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-05-16",
      baseline_complete: 8.9,
      actual_complete: 10.7,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-05-23",
      baseline_complete: 9.4,
      actual_complete: 11.1,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-05-30",
      baseline_complete: 9.8,
      actual_complete: 12.2,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-06-06",
      baseline_complete: 10.3,
      actual_complete: 12.2,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-06-13",
      baseline_complete: 10.8,
      actual_complete: 12.3,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-06-20",
      baseline_complete: 11.4,
      actual_complete: 12.3,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-06-27",
      baseline_complete: 11.9,
      actual_complete: 12.3,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-07-04",
      baseline_complete: 12.5,
      actual_complete: 14.0,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-07-11",
      baseline_complete: 13.1,
      actual_complete: 15.3,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-07-18",
      baseline_complete: 13.7,
      actual_complete: 15.7,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-07-25",
      baseline_complete: 14.3,
      actual_complete: 16.2,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-08-01",
      baseline_complete: 15.0,
      actual_complete: 16.4,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-08-08",
      baseline_complete: 15.7,
      actual_complete: 16.4,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-08-15",
      baseline_complete: 16.4,
      actual_complete: 19.3,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-08-22",
      baseline_complete: 17.2,
      actual_complete: 19.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-08-29",
      baseline_complete: 17.9,
      actual_complete: 19.3,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-09-05",
      baseline_complete: 18.7,
      actual_complete: 19.3,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-09-12",
      baseline_complete: 19.6,
      actual_complete: 21.8,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-09-19",
      baseline_complete: 20.4,
      actual_complete: 21.8,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-09-26",
      baseline_complete: 21.3,
      actual_complete: 22.4,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-10-03",
      baseline_complete: 22.2,
      actual_complete: 23.5,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-10-10",
      baseline_complete: 23.1,
      actual_complete: 24.7,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-10-17",
      baseline_complete: 24.1,
      actual_complete: 27.0,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-10-24",
      baseline_complete: 25.1,
      actual_complete: 27.0,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-10-31",
      baseline_complete: 26.1,
      actual_complete: 27.0,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-11-07",
      baseline_complete: 27.1,
      actual_complete: 28.2,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-11-14",
      baseline_complete: 28.2,
      actual_complete: 30.6,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-11-21",
      baseline_complete: 29.3,
      actual_complete: 30.6,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-11-28",
      baseline_complete: 30.4,
      actual_complete: 30.6,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-12-05",
      baseline_complete: 31.6,
      actual_complete: 32.5,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-12-12",
      baseline_complete: 32.7,
      actual_complete: 32.5,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-12-19",
      baseline_complete: 33.9,
      actual_complete: 34.2,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2025-12-26",
      baseline_complete: 35.1,
      actual_complete: 35.1,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-01-02",
      baseline_complete: 36.4,
      actual_complete: 38.7,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-01-09",
      baseline_complete: 37.6,
      actual_complete: 38.8,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-01-16",
      baseline_complete: 38.9,
      actual_complete: 40.9,
      forecast_complete: 18.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-01-23",
      baseline_complete: 40.1,
      actual_complete: 42.5,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-01-30",
      baseline_complete: 41.4,
      actual_complete: 42.5,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-02-06",
      baseline_complete: 42.7,
      actual_complete: 43.5,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-02-13",
      baseline_complete: 44.0,
      actual_complete: 44.6,
      forecast_complete: 21.9,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-02-20",
      baseline_complete: 45.3,
      actual_complete: 45.2,
      forecast_complete: 22.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-02-27",
      baseline_complete: 46.7,
      actual_complete: 49.4,
      forecast_complete: 23.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-03-06",
      baseline_complete: 48.0,
      actual_complete: 49.4,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-03-13",
      baseline_complete: 49.3,
      actual_complete: 49.4,
      forecast_complete: 25.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-03-20",
      baseline_complete: 50.7,
      actual_complete: 53.9,
      forecast_complete: 26.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-03-27",
      baseline_complete: 52.0,
      actual_complete: 53.9,
      forecast_complete: 27.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-04-03",
      baseline_complete: 53.3,
      actual_complete: 56.0,
      forecast_complete: 28.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-04-10",
      baseline_complete: 54.7,
      actual_complete: 56.0,
      forecast_complete: 29.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-04-17",
      baseline_complete: 56.0,
      actual_complete: 57.4,
      forecast_complete: 30.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-04-24",
      baseline_complete: 57.3,
      actual_complete: 58.7,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-05-01",
      baseline_complete: 58.6,
      actual_complete: 60.5,
      forecast_complete: 32.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-05-08",
      baseline_complete: 59.9,
      actual_complete: 61.5,
      forecast_complete: 33.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-05-15",
      baseline_complete: 61.2,
      actual_complete: 61.5,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-05-22",
      baseline_complete: 62.4,
      actual_complete: 62.6,
      forecast_complete: 35.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-05-29",
      baseline_complete: 63.7,
      actual_complete: 66.9,
      forecast_complete: 36.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-06-05",
      baseline_complete: 64.9,
      actual_complete: 66.9,
      forecast_complete: 37.9,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-06-12",
      baseline_complete: 66.1,
      actual_complete: 67.0,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-06-19",
      baseline_complete: 67.3,
      actual_complete: 69.6,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-06-26",
      baseline_complete: 68.4,
      actual_complete: 71.1,
      forecast_complete: 41.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-07-03",
      baseline_complete: 69.6,
      actual_complete: 71.1,
      forecast_complete: 42.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-07-10",
      baseline_complete: 70.7,
      actual_complete: 72.4,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-07-17",
      baseline_complete: 71.8,
      actual_complete: 73.2,
      forecast_complete: 44.3,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-07-24",
      baseline_complete: 72.9,
      actual_complete: 73.2,
      forecast_complete: 45.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-07-31",
      baseline_complete: 73.9,
      actual_complete: 76.9,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-08-07",
      baseline_complete: 74.9,
      actual_complete: 76.9,
      forecast_complete: 47.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-08-14",
      baseline_complete: 75.9,
      actual_complete: 76.9,
      forecast_complete: 48.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-08-21",
      baseline_complete: 76.9,
      actual_complete: 78.2,
      forecast_complete: 49.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-08-28",
      baseline_complete: 77.8,
      actual_complete: 78.8,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-09-04",
      baseline_complete: 78.7,
      actual_complete: 80.3,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-09-11",
      baseline_complete: 79.6,
      actual_complete: 80.3,
      forecast_complete: 52.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-09-18",
      baseline_complete: 80.4,
      actual_complete: 82.1,
      forecast_complete: 53.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-09-25",
      baseline_complete: 81.3,
      actual_complete: 83.3,
      forecast_complete: 54.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-10-02",
      baseline_complete: 82.1,
      actual_complete: 84.5,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-10-09",
      baseline_complete: 82.8,
      actual_complete: 84.8,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-10-16",
      baseline_complete: 83.6,
      actual_complete: 85.9,
      forecast_complete: 57.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-10-23",
      baseline_complete: 84.3,
      actual_complete: 86.3,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-10-30",
      baseline_complete: 85.0,
      actual_complete: 87.1,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-11-06",
      baseline_complete: 85.7,
      actual_complete: 87.7,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-11-13",
      baseline_complete: 86.3,
      actual_complete: 88.9,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-11-20",
      baseline_complete: 86.9,
      actual_complete: 88.9,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-11-27",
      baseline_complete: 87.5,
      actual_complete: 88.9,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-12-04",
      baseline_complete: 88.1,
      actual_complete: 88.9,
      forecast_complete: 64.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-12-11",
      baseline_complete: 88.6,
      actual_complete: 89.6,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-12-18",
      baseline_complete: 89.2,
      actual_complete: 91.0,
      forecast_complete: 66.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2026-12-25",
      baseline_complete: 89.7,
      actual_complete: 91.0,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-01-01",
      baseline_complete: 90.2,
      actual_complete: 91.0,
      forecast_complete: 68.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-01-08",
      baseline_complete: 90.6,
      actual_complete: 91.3,
      forecast_complete: 69.9,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-01-15",
      baseline_complete: 91.1,
      actual_complete: 93.6,
      forecast_complete: 71.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-01-22",
      baseline_complete: 91.5,
      actual_complete: 94.2,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-01-29",
      baseline_complete: 91.9,
      actual_complete: 95.4,
      forecast_complete: 74.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-02-05",
      baseline_complete: 92.3,
      actual_complete: 95.4,
      forecast_complete: 75.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-02-12",
      baseline_complete: 92.7,
      actual_complete: 95.4,
      forecast_complete: 77.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-02-19",
      baseline_complete: 93.0,
      actual_complete: 95.4,
      forecast_complete: 78.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-02-26",
      baseline_complete: 93.4,
      actual_complete: 96.4,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-03-05",
      baseline_complete: 93.7,
      actual_complete: 96.4,
      forecast_complete: 80.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-03-12",
      baseline_complete: 94.0,
      actual_complete: 96.4,
      forecast_complete: 82.0,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-03-19",
      baseline_complete: 94.3,
      actual_complete: 96.4,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-03-26",
      baseline_complete: 94.6,
      actual_complete: 97.6,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-04-02",
      baseline_complete: 94.8,
      actual_complete: 98.4,
      forecast_complete: 85.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-04-09",
      baseline_complete: 95.1,
      actual_complete: 98.4,
      forecast_complete: 86.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-04-16",
      baseline_complete: 95.3,
      actual_complete: 98.4,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-04-23",
      baseline_complete: 95.6,
      actual_complete: 98.4,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-04-30",
      baseline_complete: 95.8,
      actual_complete: 98.6,
      forecast_complete: 89.0,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-05-07",
      baseline_complete: 96.0,
      actual_complete: 98.6,
      forecast_complete: 89.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-05-14",
      baseline_complete: 96.2,
      actual_complete: 98.6,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-05-21",
      baseline_complete: 96.4,
      actual_complete: 98.6,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-05-28",
      baseline_complete: 96.6,
      actual_complete: 99.1,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-06-04",
      baseline_complete: 96.7,
      actual_complete: 99.9,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-06-11",
      baseline_complete: 96.9,
      actual_complete: 99.9,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-06-18",
      baseline_complete: 97.1,
      actual_complete: 99.9,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-06-25",
      baseline_complete: 97.2,
      actual_complete: 99.9,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-07-02",
      baseline_complete: 97.3,
      actual_complete: 99.9,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-07-09",
      baseline_complete: 97.5,
      actual_complete: 99.9,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-07-16",
      baseline_complete: 97.6,
      actual_complete: 99.9,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-07-23",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-07-30",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-08-06",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-08-13",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-08-20",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-08-27",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-09-03",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-09-10",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-09-17",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-09-24",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-10-01",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-10-08",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-10-15",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "b562b45d-6677-0e21-b5e3-a7a28b974abc",
      reporting_date: "2027-10-19",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
  ],
  "abfca0cf-d1ed-f548-187b-ccf4e3779e98": [
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-05-12",
      baseline_complete: 0.6,
      actual_complete: 0.6,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-05-19",
      baseline_complete: 0.7,
      actual_complete: 1.4,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-05-26",
      baseline_complete: 0.7,
      actual_complete: 1.4,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-06-02",
      baseline_complete: 0.8,
      actual_complete: 2.7,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-06-09",
      baseline_complete: 0.8,
      actual_complete: 2.7,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-06-16",
      baseline_complete: 0.9,
      actual_complete: 4.3,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-06-23",
      baseline_complete: 1.0,
      actual_complete: 4.5,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-06-30",
      baseline_complete: 1.1,
      actual_complete: 4.5,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-07-07",
      baseline_complete: 1.1,
      actual_complete: 4.5,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-07-14",
      baseline_complete: 1.2,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-07-21",
      baseline_complete: 1.3,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-07-28",
      baseline_complete: 1.4,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-08-04",
      baseline_complete: 1.5,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-08-11",
      baseline_complete: 1.6,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-08-18",
      baseline_complete: 1.8,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-08-25",
      baseline_complete: 1.9,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-09-01",
      baseline_complete: 2.1,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-09-08",
      baseline_complete: 2.2,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-09-15",
      baseline_complete: 2.4,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-09-22",
      baseline_complete: 2.6,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-09-29",
      baseline_complete: 2.8,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-10-06",
      baseline_complete: 3.0,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-10-13",
      baseline_complete: 3.2,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-10-20",
      baseline_complete: 3.4,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-10-27",
      baseline_complete: 3.7,
      actual_complete: 5.9,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-11-03",
      baseline_complete: 4.0,
      actual_complete: 6.6,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-11-10",
      baseline_complete: 4.3,
      actual_complete: 6.6,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-11-17",
      baseline_complete: 4.6,
      actual_complete: 6.6,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-11-24",
      baseline_complete: 4.9,
      actual_complete: 6.6,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-12-01",
      baseline_complete: 5.3,
      actual_complete: 6.6,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-12-08",
      baseline_complete: 5.7,
      actual_complete: 7.3,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-12-15",
      baseline_complete: 6.1,
      actual_complete: 7.6,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-12-22",
      baseline_complete: 6.6,
      actual_complete: 10.6,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2023-12-29",
      baseline_complete: 7.1,
      actual_complete: 10.6,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-01-05",
      baseline_complete: 7.6,
      actual_complete: 11.9,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-01-12",
      baseline_complete: 8.1,
      actual_complete: 11.9,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-01-19",
      baseline_complete: 8.7,
      actual_complete: 12.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-01-26",
      baseline_complete: 9.3,
      actual_complete: 12.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-02-02",
      baseline_complete: 10.0,
      actual_complete: 12.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-02-09",
      baseline_complete: 10.7,
      actual_complete: 12.7,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-02-16",
      baseline_complete: 11.4,
      actual_complete: 12.7,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-02-23",
      baseline_complete: 12.2,
      actual_complete: 12.7,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-03-01",
      baseline_complete: 13.0,
      actual_complete: 17.8,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-03-08",
      baseline_complete: 13.9,
      actual_complete: 17.8,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-03-15",
      baseline_complete: 14.8,
      actual_complete: 18.4,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-03-22",
      baseline_complete: 15.8,
      actual_complete: 18.4,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-03-29",
      baseline_complete: 16.8,
      actual_complete: 20.0,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-04-05",
      baseline_complete: 17.9,
      actual_complete: 20.0,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-04-12",
      baseline_complete: 19.1,
      actual_complete: 20.0,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-04-19",
      baseline_complete: 20.3,
      actual_complete: 21.5,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-04-26",
      baseline_complete: 21.5,
      actual_complete: 22.3,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-05-03",
      baseline_complete: 22.8,
      actual_complete: 24.4,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-05-10",
      baseline_complete: 24.2,
      actual_complete: 27.3,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-05-17",
      baseline_complete: 25.6,
      actual_complete: 29.7,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-05-24",
      baseline_complete: 27.0,
      actual_complete: 29.7,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-05-31",
      baseline_complete: 28.5,
      actual_complete: 33.3,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-06-07",
      baseline_complete: 30.1,
      actual_complete: 33.3,
      forecast_complete: 12.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-06-14",
      baseline_complete: 31.7,
      actual_complete: 34.5,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-06-21",
      baseline_complete: 33.4,
      actual_complete: 38.0,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-06-28",
      baseline_complete: 35.1,
      actual_complete: 38.0,
      forecast_complete: 15.9,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-07-05",
      baseline_complete: 36.8,
      actual_complete: 38.4,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-07-12",
      baseline_complete: 38.6,
      actual_complete: 40.5,
      forecast_complete: 18.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-07-19",
      baseline_complete: 40.4,
      actual_complete: 40.5,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-07-26",
      baseline_complete: 42.2,
      actual_complete: 43.3,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-08-02",
      baseline_complete: 44.1,
      actual_complete: 47.6,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-08-09",
      baseline_complete: 46.0,
      actual_complete: 48.3,
      forecast_complete: 23.4,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-08-16",
      baseline_complete: 47.8,
      actual_complete: 51.8,
      forecast_complete: 24.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-08-23",
      baseline_complete: 49.7,
      actual_complete: 54.3,
      forecast_complete: 26.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-08-30",
      baseline_complete: 51.6,
      actual_complete: 54.3,
      forecast_complete: 27.7,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-09-06",
      baseline_complete: 53.5,
      actual_complete: 55.5,
      forecast_complete: 29.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-09-13",
      baseline_complete: 55.4,
      actual_complete: 55.5,
      forecast_complete: 30.7,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-09-20",
      baseline_complete: 57.2,
      actual_complete: 60.6,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-09-27",
      baseline_complete: 59.1,
      actual_complete: 60.6,
      forecast_complete: 33.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-10-04",
      baseline_complete: 60.9,
      actual_complete: 64.5,
      forecast_complete: 35.3,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-10-11",
      baseline_complete: 62.7,
      actual_complete: 65.9,
      forecast_complete: 36.9,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-10-18",
      baseline_complete: 64.4,
      actual_complete: 66.3,
      forecast_complete: 38.5,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-10-25",
      baseline_complete: 66.1,
      actual_complete: 66.3,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-11-01",
      baseline_complete: 67.8,
      actual_complete: 68.2,
      forecast_complete: 41.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-11-08",
      baseline_complete: 69.4,
      actual_complete: 69.8,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-11-15",
      baseline_complete: 71.0,
      actual_complete: 74.2,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-11-22",
      baseline_complete: 72.5,
      actual_complete: 74.2,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-11-29",
      baseline_complete: 74.0,
      actual_complete: 74.2,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-12-06",
      baseline_complete: 75.4,
      actual_complete: 77.1,
      forecast_complete: 49.5,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-12-13",
      baseline_complete: 76.8,
      actual_complete: 79.4,
      forecast_complete: 51.1,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-12-20",
      baseline_complete: 78.1,
      actual_complete: 79.4,
      forecast_complete: 52.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2024-12-27",
      baseline_complete: 79.4,
      actual_complete: 81.3,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-01-03",
      baseline_complete: 80.6,
      actual_complete: 81.3,
      forecast_complete: 55.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-01-10",
      baseline_complete: 81.7,
      actual_complete: 81.3,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-01-17",
      baseline_complete: 82.8,
      actual_complete: 81.7,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-01-24",
      baseline_complete: 83.9,
      actual_complete: 85.9,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-01-31",
      baseline_complete: 84.9,
      actual_complete: 85.9,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-02-07",
      baseline_complete: 85.8,
      actual_complete: 87.9,
      forecast_complete: 62.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-02-14",
      baseline_complete: 86.7,
      actual_complete: 87.9,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-02-21",
      baseline_complete: 87.6,
      actual_complete: 87.9,
      forecast_complete: 67.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-02-28",
      baseline_complete: 88.4,
      actual_complete: 88.8,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-03-07",
      baseline_complete: 89.1,
      actual_complete: 90.8,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-03-14",
      baseline_complete: 89.8,
      actual_complete: 90.8,
      forecast_complete: 73.7,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-03-21",
      baseline_complete: 90.5,
      actual_complete: 94.1,
      forecast_complete: 75.7,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-03-28",
      baseline_complete: 91.1,
      actual_complete: 94.1,
      forecast_complete: 77.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-04-04",
      baseline_complete: 91.7,
      actual_complete: 96.0,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-04-11",
      baseline_complete: 92.3,
      actual_complete: 96.0,
      forecast_complete: 81.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-04-18",
      baseline_complete: 92.8,
      actual_complete: 96.0,
      forecast_complete: 82.7,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-04-25",
      baseline_complete: 93.3,
      actual_complete: 96.0,
      forecast_complete: 84.3,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-05-02",
      baseline_complete: 93.7,
      actual_complete: 98.4,
      forecast_complete: 85.7,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-05-09",
      baseline_complete: 94.2,
      actual_complete: 98.4,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-05-16",
      baseline_complete: 94.6,
      actual_complete: 98.4,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-05-23",
      baseline_complete: 95.0,
      actual_complete: 98.4,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-05-30",
      baseline_complete: 95.3,
      actual_complete: 98.4,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-06-06",
      baseline_complete: 95.6,
      actual_complete: 99.3,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-06-13",
      baseline_complete: 95.9,
      actual_complete: 99.3,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-06-20",
      baseline_complete: 96.2,
      actual_complete: 99.3,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-06-27",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-07-04",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-07-11",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-07-18",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-07-25",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-08-01",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-08-08",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-08-15",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-08-22",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-08-29",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-09-05",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "abfca0cf-d1ed-f548-187b-ccf4e3779e98",
      reporting_date: "2025-09-12",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
  ],
  "d679d948-538e-b268-0696-367116749259": [
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-01-19",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-01-26",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-02-02",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-02-09",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-02-16",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-02-23",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-03-01",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-03-08",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-03-15",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-03-22",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-03-29",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-04-05",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-04-12",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-04-19",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-04-26",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-05-03",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-05-10",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-05-17",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-05-24",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-05-31",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-06-07",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-06-14",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-06-21",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-06-28",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-07-05",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-07-12",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-07-19",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-07-26",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-08-02",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-08-09",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-08-16",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-08-23",
      baseline_complete: 3.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-08-30",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-09-06",
      baseline_complete: 4.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-09-13",
      baseline_complete: 4.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-09-20",
      baseline_complete: 4.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-09-27",
      baseline_complete: 4.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-10-04",
      baseline_complete: 5.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-10-11",
      baseline_complete: 5.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-10-18",
      baseline_complete: 5.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-10-25",
      baseline_complete: 5.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-11-01",
      baseline_complete: 6.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-11-08",
      baseline_complete: 6.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-11-15",
      baseline_complete: 6.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-11-22",
      baseline_complete: 7.2,
      actual_complete: 0.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-11-29",
      baseline_complete: 7.6,
      actual_complete: 1.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-12-06",
      baseline_complete: 8.0,
      actual_complete: 3.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-12-13",
      baseline_complete: 8.4,
      actual_complete: 3.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-12-20",
      baseline_complete: 8.8,
      actual_complete: 3.9,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2024-12-27",
      baseline_complete: 9.2,
      actual_complete: 3.9,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-01-03",
      baseline_complete: 9.7,
      actual_complete: 5.6,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-01-10",
      baseline_complete: 10.2,
      actual_complete: 5.6,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-01-17",
      baseline_complete: 10.7,
      actual_complete: 5.6,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-01-24",
      baseline_complete: 11.2,
      actual_complete: 6.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-01-31",
      baseline_complete: 11.8,
      actual_complete: 7.8,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-02-07",
      baseline_complete: 12.3,
      actual_complete: 7.8,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-02-14",
      baseline_complete: 12.9,
      actual_complete: 7.8,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-02-21",
      baseline_complete: 13.6,
      actual_complete: 7.8,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-02-28",
      baseline_complete: 14.2,
      actual_complete: 9.0,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-03-07",
      baseline_complete: 14.9,
      actual_complete: 11.2,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-03-14",
      baseline_complete: 15.6,
      actual_complete: 11.3,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-03-21",
      baseline_complete: 16.3,
      actual_complete: 11.3,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-03-28",
      baseline_complete: 17.1,
      actual_complete: 12.1,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-04-04",
      baseline_complete: 17.9,
      actual_complete: 14.1,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-04-11",
      baseline_complete: 18.7,
      actual_complete: 15.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-04-18",
      baseline_complete: 19.5,
      actual_complete: 15.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-04-25",
      baseline_complete: 20.4,
      actual_complete: 15.3,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-05-02",
      baseline_complete: 21.3,
      actual_complete: 15.4,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-05-09",
      baseline_complete: 22.2,
      actual_complete: 16.0,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-05-16",
      baseline_complete: 23.1,
      actual_complete: 16.6,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-05-23",
      baseline_complete: 24.1,
      actual_complete: 20.8,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-05-30",
      baseline_complete: 25.1,
      actual_complete: 20.9,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-06-06",
      baseline_complete: 26.2,
      actual_complete: 22.2,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-06-13",
      baseline_complete: 27.2,
      actual_complete: 22.5,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-06-20",
      baseline_complete: 28.3,
      actual_complete: 24.9,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-06-27",
      baseline_complete: 29.4,
      actual_complete: 25.3,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-07-04",
      baseline_complete: 30.6,
      actual_complete: 27.6,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-07-11",
      baseline_complete: 31.7,
      actual_complete: 28.2,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-07-18",
      baseline_complete: 32.9,
      actual_complete: 28.2,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-07-25",
      baseline_complete: 34.1,
      actual_complete: 28.2,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-08-01",
      baseline_complete: 35.4,
      actual_complete: 29.7,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-08-08",
      baseline_complete: 36.6,
      actual_complete: 29.8,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-08-15",
      baseline_complete: 37.9,
      actual_complete: 31.0,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-08-22",
      baseline_complete: 39.2,
      actual_complete: 34.9,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-08-29",
      baseline_complete: 40.5,
      actual_complete: 35.7,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-09-05",
      baseline_complete: 41.8,
      actual_complete: 36.8,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-09-12",
      baseline_complete: 43.1,
      actual_complete: 37.6,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-09-19",
      baseline_complete: 44.4,
      actual_complete: 38.8,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-09-26",
      baseline_complete: 45.8,
      actual_complete: 40.4,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-10-03",
      baseline_complete: 47.1,
      actual_complete: 41.5,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-10-10",
      baseline_complete: 48.5,
      actual_complete: 44.1,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-10-17",
      baseline_complete: 49.8,
      actual_complete: 44.1,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-10-24",
      baseline_complete: 51.2,
      actual_complete: 46.1,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-10-31",
      baseline_complete: 52.5,
      actual_complete: 47.0,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-11-07",
      baseline_complete: 53.9,
      actual_complete: 50.1,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-11-14",
      baseline_complete: 55.2,
      actual_complete: 52.7,
      forecast_complete: 22.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-11-21",
      baseline_complete: 56.6,
      actual_complete: 52.7,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-11-28",
      baseline_complete: 57.9,
      actual_complete: 54.9,
      forecast_complete: 24.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-12-05",
      baseline_complete: 59.2,
      actual_complete: 54.9,
      forecast_complete: 25.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-12-12",
      baseline_complete: 60.5,
      actual_complete: 57.2,
      forecast_complete: 26.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-12-19",
      baseline_complete: 61.8,
      actual_complete: 59.9,
      forecast_complete: 27.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2025-12-26",
      baseline_complete: 63.1,
      actual_complete: 59.9,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-01-02",
      baseline_complete: 64.3,
      actual_complete: 61.8,
      forecast_complete: 29.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-01-09",
      baseline_complete: 65.6,
      actual_complete: 61.8,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-01-16",
      baseline_complete: 66.8,
      actual_complete: 63.2,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-01-23",
      baseline_complete: 68.0,
      actual_complete: 63.2,
      forecast_complete: 31.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-01-30",
      baseline_complete: 69.1,
      actual_complete: 63.6,
      forecast_complete: 32.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-02-06",
      baseline_complete: 70.3,
      actual_complete: 66.3,
      forecast_complete: 33.6,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-02-13",
      baseline_complete: 71.4,
      actual_complete: 67.3,
      forecast_complete: 34.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-02-20",
      baseline_complete: 72.5,
      actual_complete: 70.5,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-02-27",
      baseline_complete: 73.6,
      actual_complete: 70.5,
      forecast_complete: 36.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-03-06",
      baseline_complete: 74.6,
      actual_complete: 71.6,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-03-13",
      baseline_complete: 75.6,
      actual_complete: 71.6,
      forecast_complete: 38.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-03-20",
      baseline_complete: 76.6,
      actual_complete: 73.1,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-03-27",
      baseline_complete: 77.6,
      actual_complete: 74.2,
      forecast_complete: 39.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-04-03",
      baseline_complete: 78.5,
      actual_complete: 74.2,
      forecast_complete: 40.6,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-04-10",
      baseline_complete: 79.4,
      actual_complete: 77.2,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-04-17",
      baseline_complete: 80.3,
      actual_complete: 79.1,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-04-24",
      baseline_complete: 81.1,
      actual_complete: 79.1,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-05-01",
      baseline_complete: 81.9,
      actual_complete: 79.1,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-05-08",
      baseline_complete: 82.7,
      actual_complete: 81.7,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-05-15",
      baseline_complete: 83.5,
      actual_complete: 82.5,
      forecast_complete: 45.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-05-22",
      baseline_complete: 84.2,
      actual_complete: 82.5,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-05-29",
      baseline_complete: 84.9,
      actual_complete: 82.5,
      forecast_complete: 47.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-06-05",
      baseline_complete: 85.6,
      actual_complete: 82.5,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-06-12",
      baseline_complete: 86.3,
      actual_complete: 82.7,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-06-19",
      baseline_complete: 86.9,
      actual_complete: 85.9,
      forecast_complete: 49.6,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-06-26",
      baseline_complete: 87.5,
      actual_complete: 86.9,
      forecast_complete: 50.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-07-03",
      baseline_complete: 88.1,
      actual_complete: 86.9,
      forecast_complete: 51.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-07-10",
      baseline_complete: 88.6,
      actual_complete: 86.9,
      forecast_complete: 51.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-07-17",
      baseline_complete: 89.2,
      actual_complete: 87.7,
      forecast_complete: 52.6,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-07-24",
      baseline_complete: 89.7,
      actual_complete: 88.4,
      forecast_complete: 53.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-07-31",
      baseline_complete: 90.2,
      actual_complete: 89.9,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-08-07",
      baseline_complete: 90.7,
      actual_complete: 89.9,
      forecast_complete: 54.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-08-14",
      baseline_complete: 91.1,
      actual_complete: 89.9,
      forecast_complete: 55.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-08-21",
      baseline_complete: 91.5,
      actual_complete: 89.9,
      forecast_complete: 56.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-08-28",
      baseline_complete: 91.9,
      actual_complete: 89.9,
      forecast_complete: 56.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-09-04",
      baseline_complete: 92.3,
      actual_complete: 90.7,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-09-11",
      baseline_complete: 92.7,
      actual_complete: 90.7,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-09-18",
      baseline_complete: 93.1,
      actual_complete: 90.7,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-09-25",
      baseline_complete: 93.4,
      actual_complete: 92.6,
      forecast_complete: 59.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-10-02",
      baseline_complete: 93.7,
      actual_complete: 92.6,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-10-09",
      baseline_complete: 94.0,
      actual_complete: 94.0,
      forecast_complete: 60.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-10-16",
      baseline_complete: 94.3,
      actual_complete: 94.0,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-10-23",
      baseline_complete: 94.6,
      actual_complete: 94.0,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-10-30",
      baseline_complete: 94.9,
      actual_complete: 95.0,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-11-06",
      baseline_complete: 95.2,
      actual_complete: 95.0,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-11-13",
      baseline_complete: 95.4,
      actual_complete: 95.0,
      forecast_complete: 64.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-11-20",
      baseline_complete: 95.6,
      actual_complete: 95.9,
      forecast_complete: 64.6,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-11-27",
      baseline_complete: 95.9,
      actual_complete: 95.9,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-12-04",
      baseline_complete: 96.1,
      actual_complete: 95.9,
      forecast_complete: 65.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-12-11",
      baseline_complete: 96.3,
      actual_complete: 95.9,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-12-18",
      baseline_complete: 96.5,
      actual_complete: 95.9,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2026-12-25",
      baseline_complete: 96.6,
      actual_complete: 95.9,
      forecast_complete: 67.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-01-01",
      baseline_complete: 96.8,
      actual_complete: 95.9,
      forecast_complete: 68.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-01-08",
      baseline_complete: 97.0,
      actual_complete: 95.9,
      forecast_complete: 68.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-01-15",
      baseline_complete: 97.1,
      actual_complete: 95.9,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-01-22",
      baseline_complete: 97.3,
      actual_complete: 95.9,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-01-29",
      baseline_complete: 97.4,
      actual_complete: 95.9,
      forecast_complete: 70.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-02-05",
      baseline_complete: 97.5,
      actual_complete: 97.9,
      forecast_complete: 70.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-02-12",
      baseline_complete: 97.7,
      actual_complete: 97.9,
      forecast_complete: 71.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-02-19",
      baseline_complete: 97.8,
      actual_complete: 97.9,
      forecast_complete: 72.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-02-26",
      baseline_complete: 97.9,
      actual_complete: 97.9,
      forecast_complete: 73.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-03-05",
      baseline_complete: 98.0,
      actual_complete: 97.9,
      forecast_complete: 74.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-03-12",
      baseline_complete: 98.1,
      actual_complete: 97.9,
      forecast_complete: 75.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-03-19",
      baseline_complete: 98.2,
      actual_complete: 97.9,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-03-26",
      baseline_complete: 98.3,
      actual_complete: 99.3,
      forecast_complete: 77.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-04-02",
      baseline_complete: 98.4,
      actual_complete: 99.3,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-04-09",
      baseline_complete: 98.5,
      actual_complete: 99.3,
      forecast_complete: 78.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-04-16",
      baseline_complete: 98.6,
      actual_complete: 99.3,
      forecast_complete: 79.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-04-23",
      baseline_complete: 98.6,
      actual_complete: 99.3,
      forecast_complete: 80.6,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-04-30",
      baseline_complete: 98.7,
      actual_complete: 99.3,
      forecast_complete: 81.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-05-07",
      baseline_complete: 98.8,
      actual_complete: 99.3,
      forecast_complete: 82.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-05-14",
      baseline_complete: 98.8,
      actual_complete: 99.8,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-05-21",
      baseline_complete: 98.9,
      actual_complete: 99.8,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-05-28",
      baseline_complete: 99.0,
      actual_complete: 99.8,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-06-04",
      baseline_complete: 99.0,
      actual_complete: 99.8,
      forecast_complete: 85.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-06-11",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 86.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-06-18",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 86.6,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-06-25",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 87.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-07-02",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 87.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-07-09",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 88.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-07-16",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-07-23",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 89.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-07-30",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-08-06",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-08-13",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 91.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-08-20",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 91.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-08-27",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-09-03",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-09-10",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-09-17",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-09-24",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-10-01",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-10-08",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-10-15",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-10-22",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-10-29",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-11-05",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-11-12",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-11-19",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-11-26",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-12-03",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-12-10",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-12-17",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-12-24",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2027-12-31",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2028-01-07",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2028-01-14",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2028-01-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2028-01-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2028-02-04",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2028-02-11",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2028-02-18",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "d679d948-538e-b268-0696-367116749259",
      reporting_date: "2028-02-19",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
  ],
  "18805689-9839-41a8-1929-4389263c8c14": [
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-08-28",
      baseline_complete: 0.4,
      actual_complete: 3.3,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-09-04",
      baseline_complete: 0.4,
      actual_complete: 3.3,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-09-11",
      baseline_complete: 0.5,
      actual_complete: 4.3,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-09-18",
      baseline_complete: 0.6,
      actual_complete: 4.3,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-09-25",
      baseline_complete: 0.6,
      actual_complete: 4.3,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-10-02",
      baseline_complete: 0.7,
      actual_complete: 4.3,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-10-09",
      baseline_complete: 0.7,
      actual_complete: 4.4,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-10-16",
      baseline_complete: 0.8,
      actual_complete: 4.4,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-10-23",
      baseline_complete: 0.9,
      actual_complete: 4.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-10-30",
      baseline_complete: 1.0,
      actual_complete: 4.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-11-06",
      baseline_complete: 1.1,
      actual_complete: 4.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-11-13",
      baseline_complete: 1.2,
      actual_complete: 4.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-11-20",
      baseline_complete: 1.4,
      actual_complete: 4.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-11-27",
      baseline_complete: 1.5,
      actual_complete: 4.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-12-04",
      baseline_complete: 1.7,
      actual_complete: 4.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-12-11",
      baseline_complete: 1.9,
      actual_complete: 4.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-12-18",
      baseline_complete: 2.0,
      actual_complete: 4.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2026-12-25",
      baseline_complete: 2.3,
      actual_complete: 5.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-01-01",
      baseline_complete: 2.5,
      actual_complete: 5.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-01-08",
      baseline_complete: 2.8,
      actual_complete: 5.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-01-15",
      baseline_complete: 3.0,
      actual_complete: 5.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-01-22",
      baseline_complete: 3.4,
      actual_complete: 6.6,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-01-29",
      baseline_complete: 3.7,
      actual_complete: 6.6,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-02-05",
      baseline_complete: 4.1,
      actual_complete: 7.1,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-02-12",
      baseline_complete: 4.5,
      actual_complete: 7.1,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-02-19",
      baseline_complete: 5.0,
      actual_complete: 8.1,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-02-26",
      baseline_complete: 5.5,
      actual_complete: 8.9,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-03-05",
      baseline_complete: 6.0,
      actual_complete: 9.5,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-03-12",
      baseline_complete: 6.6,
      actual_complete: 9.5,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-03-19",
      baseline_complete: 7.3,
      actual_complete: 11.0,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-03-26",
      baseline_complete: 8.0,
      actual_complete: 11.2,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-04-02",
      baseline_complete: 8.8,
      actual_complete: 11.2,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-04-09",
      baseline_complete: 9.7,
      actual_complete: 11.2,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-04-16",
      baseline_complete: 10.6,
      actual_complete: 12.1,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-04-23",
      baseline_complete: 11.6,
      actual_complete: 12.1,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-04-30",
      baseline_complete: 12.7,
      actual_complete: 12.1,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-05-07",
      baseline_complete: 13.9,
      actual_complete: 17.8,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-05-14",
      baseline_complete: 15.1,
      actual_complete: 17.8,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-05-21",
      baseline_complete: 16.5,
      actual_complete: 17.8,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-05-28",
      baseline_complete: 17.9,
      actual_complete: 20.4,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-06-04",
      baseline_complete: 19.5,
      actual_complete: 21.9,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-06-11",
      baseline_complete: 21.2,
      actual_complete: 22.3,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-06-18",
      baseline_complete: 22.9,
      actual_complete: 23.6,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-06-25",
      baseline_complete: 24.8,
      actual_complete: 24.5,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-07-02",
      baseline_complete: 26.7,
      actual_complete: 27.4,
      forecast_complete: 12.8,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-07-09",
      baseline_complete: 28.8,
      actual_complete: 30.4,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-07-16",
      baseline_complete: 30.9,
      actual_complete: 30.9,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-07-23",
      baseline_complete: 33.1,
      actual_complete: 36.3,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-07-30",
      baseline_complete: 35.4,
      actual_complete: 37.3,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-08-06",
      baseline_complete: 37.8,
      actual_complete: 37.3,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-08-13",
      baseline_complete: 40.2,
      actual_complete: 42.5,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-08-20",
      baseline_complete: 42.7,
      actual_complete: 43.9,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-08-27",
      baseline_complete: 45.2,
      actual_complete: 43.9,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-09-03",
      baseline_complete: 47.7,
      actual_complete: 48.2,
      forecast_complete: 24.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-09-10",
      baseline_complete: 50.3,
      actual_complete: 52.8,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-09-17",
      baseline_complete: 52.8,
      actual_complete: 57.4,
      forecast_complete: 28.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-09-24",
      baseline_complete: 55.4,
      actual_complete: 60.0,
      forecast_complete: 30.1,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-10-01",
      baseline_complete: 57.9,
      actual_complete: 60.0,
      forecast_complete: 31.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-10-08",
      baseline_complete: 60.3,
      actual_complete: 61.5,
      forecast_complete: 33.7,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-10-15",
      baseline_complete: 62.8,
      actual_complete: 64.5,
      forecast_complete: 35.5,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-10-22",
      baseline_complete: 65.1,
      actual_complete: 69.0,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-10-29",
      baseline_complete: 67.4,
      actual_complete: 69.0,
      forecast_complete: 39.2,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-11-05",
      baseline_complete: 69.6,
      actual_complete: 69.0,
      forecast_complete: 41.0,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-11-12",
      baseline_complete: 71.7,
      actual_complete: 73.5,
      forecast_complete: 42.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-11-19",
      baseline_complete: 73.7,
      actual_complete: 74.9,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-11-26",
      baseline_complete: 75.7,
      actual_complete: 80.1,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-12-03",
      baseline_complete: 77.5,
      actual_complete: 81.8,
      forecast_complete: 48.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-12-10",
      baseline_complete: 79.2,
      actual_complete: 82.4,
      forecast_complete: 50.0,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-12-17",
      baseline_complete: 80.9,
      actual_complete: 82.4,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-12-24",
      baseline_complete: 82.4,
      actual_complete: 82.4,
      forecast_complete: 53.4,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2027-12-31",
      baseline_complete: 83.8,
      actual_complete: 85.5,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-01-07",
      baseline_complete: 85.2,
      actual_complete: 85.5,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-01-14",
      baseline_complete: 86.4,
      actual_complete: 86.7,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-01-21",
      baseline_complete: 87.6,
      actual_complete: 89.7,
      forecast_complete: 59.8,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-01-28",
      baseline_complete: 88.6,
      actual_complete: 89.7,
      forecast_complete: 61.2,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-02-04",
      baseline_complete: 89.6,
      actual_complete: 89.7,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-02-11",
      baseline_complete: 90.5,
      actual_complete: 94.0,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-02-18",
      baseline_complete: 91.4,
      actual_complete: 94.0,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-02-25",
      baseline_complete: 92.1,
      actual_complete: 94.0,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-03-03",
      baseline_complete: 92.9,
      actual_complete: 96.0,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-03-10",
      baseline_complete: 93.5,
      actual_complete: 96.0,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-03-17",
      baseline_complete: 94.1,
      actual_complete: 96.5,
      forecast_complete: 70.8,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-03-24",
      baseline_complete: 94.6,
      actual_complete: 96.5,
      forecast_complete: 72.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-03-31",
      baseline_complete: 95.1,
      actual_complete: 99.4,
      forecast_complete: 74.5,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-04-07",
      baseline_complete: 95.6,
      actual_complete: 99.4,
      forecast_complete: 76.6,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-04-14",
      baseline_complete: 96.0,
      actual_complete: 100.0,
      forecast_complete: 78.5,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-04-21",
      baseline_complete: 96.4,
      actual_complete: 100.0,
      forecast_complete: 80.4,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-04-28",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-05-05",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-05-12",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-05-19",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-05-26",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-06-02",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 89.6,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-06-09",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-06-16",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 91.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-06-23",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-06-30",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-07-07",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-07-14",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-07-21",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-07-28",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-08-04",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-08-11",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-08-18",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-08-25",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-09-01",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-09-08",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-09-15",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-09-22",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "18805689-9839-41a8-1929-4389263c8c14",
      reporting_date: "2028-09-28",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0": [
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-02-01",
      baseline_complete: 1.9,
      actual_complete: 2.5,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-02-08",
      baseline_complete: 1.9,
      actual_complete: 3.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-02-15",
      baseline_complete: 2.0,
      actual_complete: 5.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-02-22",
      baseline_complete: 2.0,
      actual_complete: 5.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-03-01",
      baseline_complete: 2.1,
      actual_complete: 5.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-03-08",
      baseline_complete: 2.2,
      actual_complete: 5.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-03-15",
      baseline_complete: 2.3,
      actual_complete: 5.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-03-22",
      baseline_complete: 2.3,
      actual_complete: 5.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-03-29",
      baseline_complete: 2.4,
      actual_complete: 5.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-04-05",
      baseline_complete: 2.5,
      actual_complete: 5.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-04-12",
      baseline_complete: 2.6,
      actual_complete: 5.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-04-19",
      baseline_complete: 2.7,
      actual_complete: 5.2,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-04-26",
      baseline_complete: 2.8,
      actual_complete: 5.2,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-05-03",
      baseline_complete: 2.9,
      actual_complete: 5.7,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-05-10",
      baseline_complete: 3.0,
      actual_complete: 5.7,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-05-17",
      baseline_complete: 3.1,
      actual_complete: 5.7,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-05-24",
      baseline_complete: 3.2,
      actual_complete: 5.7,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-05-31",
      baseline_complete: 3.3,
      actual_complete: 5.7,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-06-07",
      baseline_complete: 3.4,
      actual_complete: 6.3,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-06-14",
      baseline_complete: 3.5,
      actual_complete: 6.3,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-06-21",
      baseline_complete: 3.6,
      actual_complete: 6.3,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-06-28",
      baseline_complete: 3.7,
      actual_complete: 6.3,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-07-05",
      baseline_complete: 3.9,
      actual_complete: 6.3,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-07-12",
      baseline_complete: 4.0,
      actual_complete: 6.3,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-07-19",
      baseline_complete: 4.1,
      actual_complete: 6.3,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-07-26",
      baseline_complete: 4.3,
      actual_complete: 6.3,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-08-02",
      baseline_complete: 4.4,
      actual_complete: 6.3,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-08-09",
      baseline_complete: 4.6,
      actual_complete: 6.3,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-08-16",
      baseline_complete: 4.7,
      actual_complete: 7.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-08-23",
      baseline_complete: 4.9,
      actual_complete: 7.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-08-30",
      baseline_complete: 5.0,
      actual_complete: 7.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-09-06",
      baseline_complete: 5.2,
      actual_complete: 8.7,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-09-13",
      baseline_complete: 5.4,
      actual_complete: 8.7,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-09-20",
      baseline_complete: 5.6,
      actual_complete: 8.7,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-09-27",
      baseline_complete: 5.7,
      actual_complete: 8.7,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-10-04",
      baseline_complete: 5.9,
      actual_complete: 9.1,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-10-11",
      baseline_complete: 6.1,
      actual_complete: 9.1,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-10-18",
      baseline_complete: 6.3,
      actual_complete: 9.1,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-10-25",
      baseline_complete: 6.5,
      actual_complete: 9.1,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-11-01",
      baseline_complete: 6.7,
      actual_complete: 10.2,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-11-08",
      baseline_complete: 7.0,
      actual_complete: 10.2,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-11-15",
      baseline_complete: 7.2,
      actual_complete: 10.2,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-11-22",
      baseline_complete: 7.4,
      actual_complete: 10.2,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-11-29",
      baseline_complete: 7.7,
      actual_complete: 10.2,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-12-06",
      baseline_complete: 7.9,
      actual_complete: 10.2,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-12-13",
      baseline_complete: 8.2,
      actual_complete: 10.2,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-12-20",
      baseline_complete: 8.4,
      actual_complete: 10.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2023-12-27",
      baseline_complete: 8.7,
      actual_complete: 10.2,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-01-03",
      baseline_complete: 9.0,
      actual_complete: 10.2,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-01-10",
      baseline_complete: 9.3,
      actual_complete: 10.2,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-01-17",
      baseline_complete: 9.6,
      actual_complete: 10.2,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-01-24",
      baseline_complete: 9.9,
      actual_complete: 10.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-01-31",
      baseline_complete: 10.2,
      actual_complete: 13.4,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-02-07",
      baseline_complete: 10.5,
      actual_complete: 13.4,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-02-14",
      baseline_complete: 10.8,
      actual_complete: 13.4,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-02-21",
      baseline_complete: 11.2,
      actual_complete: 13.4,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-02-28",
      baseline_complete: 11.5,
      actual_complete: 13.4,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-03-06",
      baseline_complete: 11.9,
      actual_complete: 13.5,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-03-13",
      baseline_complete: 12.2,
      actual_complete: 13.5,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-03-20",
      baseline_complete: 12.6,
      actual_complete: 16.0,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-03-27",
      baseline_complete: 13.0,
      actual_complete: 16.0,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-04-03",
      baseline_complete: 13.4,
      actual_complete: 16.0,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-04-10",
      baseline_complete: 13.8,
      actual_complete: 16.0,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-04-17",
      baseline_complete: 14.2,
      actual_complete: 16.0,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-04-24",
      baseline_complete: 14.6,
      actual_complete: 17.3,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-05-01",
      baseline_complete: 15.0,
      actual_complete: 17.3,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-05-08",
      baseline_complete: 15.5,
      actual_complete: 17.3,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-05-15",
      baseline_complete: 16.0,
      actual_complete: 17.3,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-05-22",
      baseline_complete: 16.4,
      actual_complete: 18.8,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-05-29",
      baseline_complete: 16.9,
      actual_complete: 20.2,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-06-05",
      baseline_complete: 17.4,
      actual_complete: 20.2,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-06-12",
      baseline_complete: 17.9,
      actual_complete: 20.2,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-06-19",
      baseline_complete: 18.4,
      actual_complete: 20.2,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-06-26",
      baseline_complete: 18.9,
      actual_complete: 20.2,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-07-03",
      baseline_complete: 19.5,
      actual_complete: 20.2,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-07-10",
      baseline_complete: 20.0,
      actual_complete: 20.7,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-07-17",
      baseline_complete: 20.6,
      actual_complete: 20.9,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-07-24",
      baseline_complete: 21.1,
      actual_complete: 22.9,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-07-31",
      baseline_complete: 21.7,
      actual_complete: 22.9,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-08-07",
      baseline_complete: 22.3,
      actual_complete: 24.2,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-08-14",
      baseline_complete: 22.9,
      actual_complete: 24.2,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-08-21",
      baseline_complete: 23.5,
      actual_complete: 24.2,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-08-28",
      baseline_complete: 24.1,
      actual_complete: 25.9,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-09-04",
      baseline_complete: 24.8,
      actual_complete: 28.7,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-09-11",
      baseline_complete: 25.4,
      actual_complete: 28.7,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-09-18",
      baseline_complete: 26.1,
      actual_complete: 28.7,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-09-25",
      baseline_complete: 26.8,
      actual_complete: 29.8,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-10-02",
      baseline_complete: 27.4,
      actual_complete: 29.8,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-10-09",
      baseline_complete: 28.1,
      actual_complete: 30.3,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-10-16",
      baseline_complete: 28.8,
      actual_complete: 30.8,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-10-23",
      baseline_complete: 29.5,
      actual_complete: 30.8,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-10-30",
      baseline_complete: 30.3,
      actual_complete: 33.8,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-11-06",
      baseline_complete: 31.0,
      actual_complete: 33.8,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-11-13",
      baseline_complete: 31.7,
      actual_complete: 33.8,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-11-20",
      baseline_complete: 32.5,
      actual_complete: 33.8,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-11-27",
      baseline_complete: 33.3,
      actual_complete: 34.8,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-12-04",
      baseline_complete: 34.0,
      actual_complete: 34.8,
      forecast_complete: 14.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-12-11",
      baseline_complete: 34.8,
      actual_complete: 35.0,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-12-18",
      baseline_complete: 35.6,
      actual_complete: 35.3,
      forecast_complete: 15.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2024-12-25",
      baseline_complete: 36.4,
      actual_complete: 36.8,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-01-01",
      baseline_complete: 37.2,
      actual_complete: 36.8,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-01-08",
      baseline_complete: 38.0,
      actual_complete: 37.5,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-01-15",
      baseline_complete: 38.8,
      actual_complete: 37.5,
      forecast_complete: 17.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-01-22",
      baseline_complete: 39.6,
      actual_complete: 39.6,
      forecast_complete: 17.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-01-29",
      baseline_complete: 40.5,
      actual_complete: 39.6,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-02-05",
      baseline_complete: 41.3,
      actual_complete: 44.5,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-02-12",
      baseline_complete: 42.1,
      actual_complete: 44.5,
      forecast_complete: 19.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-02-19",
      baseline_complete: 43.0,
      actual_complete: 45.9,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-02-26",
      baseline_complete: 43.8,
      actual_complete: 47.6,
      forecast_complete: 20.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-03-05",
      baseline_complete: 44.7,
      actual_complete: 47.6,
      forecast_complete: 20.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-03-12",
      baseline_complete: 45.5,
      actual_complete: 47.6,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-03-19",
      baseline_complete: 46.4,
      actual_complete: 47.6,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-03-26",
      baseline_complete: 47.2,
      actual_complete: 50.1,
      forecast_complete: 22.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-04-02",
      baseline_complete: 48.1,
      actual_complete: 50.1,
      forecast_complete: 22.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-04-09",
      baseline_complete: 49.0,
      actual_complete: 50.1,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-04-16",
      baseline_complete: 49.8,
      actual_complete: 50.1,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-04-23",
      baseline_complete: 50.7,
      actual_complete: 51.4,
      forecast_complete: 24.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-04-30",
      baseline_complete: 51.5,
      actual_complete: 54.7,
      forecast_complete: 24.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-05-07",
      baseline_complete: 52.4,
      actual_complete: 56.6,
      forecast_complete: 25.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-05-14",
      baseline_complete: 53.3,
      actual_complete: 56.6,
      forecast_complete: 26.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-05-21",
      baseline_complete: 54.1,
      actual_complete: 56.6,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-05-28",
      baseline_complete: 55.0,
      actual_complete: 56.6,
      forecast_complete: 27.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-06-04",
      baseline_complete: 55.8,
      actual_complete: 58.7,
      forecast_complete: 27.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-06-11",
      baseline_complete: 56.7,
      actual_complete: 60.1,
      forecast_complete: 28.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-06-18",
      baseline_complete: 57.5,
      actual_complete: 60.1,
      forecast_complete: 29.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-06-25",
      baseline_complete: 58.3,
      actual_complete: 60.1,
      forecast_complete: 29.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-07-02",
      baseline_complete: 59.2,
      actual_complete: 61.4,
      forecast_complete: 30.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-07-09",
      baseline_complete: 60.0,
      actual_complete: 63.2,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-07-16",
      baseline_complete: 60.8,
      actual_complete: 63.2,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-07-23",
      baseline_complete: 61.7,
      actual_complete: 64.2,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-07-30",
      baseline_complete: 62.5,
      actual_complete: 65.5,
      forecast_complete: 32.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-08-06",
      baseline_complete: 63.3,
      actual_complete: 65.5,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-08-13",
      baseline_complete: 64.1,
      actual_complete: 66.3,
      forecast_complete: 34.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-08-20",
      baseline_complete: 64.9,
      actual_complete: 66.3,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-08-27",
      baseline_complete: 65.6,
      actual_complete: 69.7,
      forecast_complete: 35.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-09-03",
      baseline_complete: 66.4,
      actual_complete: 69.7,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-09-10",
      baseline_complete: 67.2,
      actual_complete: 69.7,
      forecast_complete: 36.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-09-17",
      baseline_complete: 67.9,
      actual_complete: 69.7,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-09-24",
      baseline_complete: 68.7,
      actual_complete: 72.1,
      forecast_complete: 37.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-10-01",
      baseline_complete: 69.4,
      actual_complete: 72.1,
      forecast_complete: 38.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-10-08",
      baseline_complete: 70.1,
      actual_complete: 72.1,
      forecast_complete: 39.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-10-15",
      baseline_complete: 70.9,
      actual_complete: 72.1,
      forecast_complete: 39.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-10-22",
      baseline_complete: 71.6,
      actual_complete: 72.8,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-10-29",
      baseline_complete: 72.3,
      actual_complete: 72.8,
      forecast_complete: 41.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-11-05",
      baseline_complete: 72.9,
      actual_complete: 72.8,
      forecast_complete: 41.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-11-12",
      baseline_complete: 73.6,
      actual_complete: 74.2,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-11-19",
      baseline_complete: 74.3,
      actual_complete: 77.0,
      forecast_complete: 43.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-11-26",
      baseline_complete: 74.9,
      actual_complete: 77.0,
      forecast_complete: 43.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-12-03",
      baseline_complete: 75.6,
      actual_complete: 78.6,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-12-10",
      baseline_complete: 76.2,
      actual_complete: 78.6,
      forecast_complete: 45.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-12-17",
      baseline_complete: 76.8,
      actual_complete: 80.8,
      forecast_complete: 45.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-12-24",
      baseline_complete: 77.4,
      actual_complete: 80.8,
      forecast_complete: 46.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2025-12-31",
      baseline_complete: 78.0,
      actual_complete: 80.8,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-01-07",
      baseline_complete: 78.6,
      actual_complete: 80.8,
      forecast_complete: 47.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-01-14",
      baseline_complete: 79.2,
      actual_complete: 80.8,
      forecast_complete: 48.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-01-21",
      baseline_complete: 79.8,
      actual_complete: 80.8,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-01-28",
      baseline_complete: 80.3,
      actual_complete: 80.8,
      forecast_complete: 49.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-02-04",
      baseline_complete: 80.8,
      actual_complete: 83.3,
      forecast_complete: 50.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-02-11",
      baseline_complete: 81.4,
      actual_complete: 83.3,
      forecast_complete: 50.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-02-18",
      baseline_complete: 81.9,
      actual_complete: 83.3,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-02-25",
      baseline_complete: 82.4,
      actual_complete: 83.3,
      forecast_complete: 51.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-03-04",
      baseline_complete: 82.9,
      actual_complete: 83.3,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-03-11",
      baseline_complete: 83.4,
      actual_complete: 83.6,
      forecast_complete: 53.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-03-18",
      baseline_complete: 83.8,
      actual_complete: 87.7,
      forecast_complete: 53.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-03-25",
      baseline_complete: 84.3,
      actual_complete: 87.7,
      forecast_complete: 54.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-04-01",
      baseline_complete: 84.8,
      actual_complete: 88.7,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-04-08",
      baseline_complete: 85.2,
      actual_complete: 88.7,
      forecast_complete: 55.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-04-15",
      baseline_complete: 85.6,
      actual_complete: 88.7,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-04-22",
      baseline_complete: 86.0,
      actual_complete: 88.9,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-04-29",
      baseline_complete: 86.5,
      actual_complete: 88.9,
      forecast_complete: 57.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-05-06",
      baseline_complete: 86.9,
      actual_complete: 88.9,
      forecast_complete: 57.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-05-13",
      baseline_complete: 87.2,
      actual_complete: 90.0,
      forecast_complete: 58.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-05-20",
      baseline_complete: 87.6,
      actual_complete: 90.1,
      forecast_complete: 59.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-05-27",
      baseline_complete: 88.0,
      actual_complete: 90.1,
      forecast_complete: 59.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-06-03",
      baseline_complete: 88.3,
      actual_complete: 90.1,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-06-10",
      baseline_complete: 88.7,
      actual_complete: 90.1,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-06-17",
      baseline_complete: 89.0,
      actual_complete: 91.1,
      forecast_complete: 61.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-06-24",
      baseline_complete: 89.4,
      actual_complete: 93.0,
      forecast_complete: 61.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-07-01",
      baseline_complete: 89.7,
      actual_complete: 93.0,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-07-08",
      baseline_complete: 90.0,
      actual_complete: 93.0,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-07-15",
      baseline_complete: 90.3,
      actual_complete: 93.0,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-07-22",
      baseline_complete: 90.6,
      actual_complete: 93.0,
      forecast_complete: 64.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-07-29",
      baseline_complete: 90.9,
      actual_complete: 93.0,
      forecast_complete: 64.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-08-05",
      baseline_complete: 91.2,
      actual_complete: 93.3,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-08-12",
      baseline_complete: 91.5,
      actual_complete: 93.3,
      forecast_complete: 65.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-08-19",
      baseline_complete: 91.7,
      actual_complete: 95.9,
      forecast_complete: 66.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-08-26",
      baseline_complete: 92.0,
      actual_complete: 95.9,
      forecast_complete: 66.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-09-02",
      baseline_complete: 92.2,
      actual_complete: 95.9,
      forecast_complete: 67.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-09-09",
      baseline_complete: 92.5,
      actual_complete: 95.9,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-09-16",
      baseline_complete: 92.7,
      actual_complete: 95.9,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-09-23",
      baseline_complete: 92.9,
      actual_complete: 95.9,
      forecast_complete: 68.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-09-30",
      baseline_complete: 93.2,
      actual_complete: 95.9,
      forecast_complete: 69.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-10-07",
      baseline_complete: 93.4,
      actual_complete: 95.9,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-10-14",
      baseline_complete: 93.6,
      actual_complete: 95.9,
      forecast_complete: 70.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-10-21",
      baseline_complete: 93.8,
      actual_complete: 95.9,
      forecast_complete: 70.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-10-28",
      baseline_complete: 94.0,
      actual_complete: 95.9,
      forecast_complete: 71.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-11-04",
      baseline_complete: 94.2,
      actual_complete: 98.3,
      forecast_complete: 71.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-11-11",
      baseline_complete: 94.4,
      actual_complete: 98.3,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-11-18",
      baseline_complete: 94.5,
      actual_complete: 98.3,
      forecast_complete: 73.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-11-25",
      baseline_complete: 94.7,
      actual_complete: 98.3,
      forecast_complete: 74.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-12-02",
      baseline_complete: 94.9,
      actual_complete: 98.3,
      forecast_complete: 75.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-12-09",
      baseline_complete: 95.1,
      actual_complete: 98.3,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-12-16",
      baseline_complete: 95.2,
      actual_complete: 98.3,
      forecast_complete: 77.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-12-23",
      baseline_complete: 95.4,
      actual_complete: 98.3,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2026-12-30",
      baseline_complete: 95.5,
      actual_complete: 99.1,
      forecast_complete: 78.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-01-06",
      baseline_complete: 95.7,
      actual_complete: 99.1,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-01-13",
      baseline_complete: 95.8,
      actual_complete: 99.1,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-01-20",
      baseline_complete: 95.9,
      actual_complete: 99.1,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-01-27",
      baseline_complete: 96.1,
      actual_complete: 99.1,
      forecast_complete: 81.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-02-03",
      baseline_complete: 96.2,
      actual_complete: 99.1,
      forecast_complete: 82.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-02-10",
      baseline_complete: 96.3,
      actual_complete: 99.1,
      forecast_complete: 83.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-02-17",
      baseline_complete: 96.4,
      actual_complete: 99.1,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-02-24",
      baseline_complete: 96.6,
      actual_complete: 99.4,
      forecast_complete: 84.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-03-03",
      baseline_complete: 96.7,
      actual_complete: 99.4,
      forecast_complete: 85.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-03-10",
      baseline_complete: 96.8,
      actual_complete: 99.4,
      forecast_complete: 85.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-03-17",
      baseline_complete: 96.9,
      actual_complete: 99.4,
      forecast_complete: 86.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-03-24",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-03-31",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-04-07",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-04-14",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 88.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-04-21",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-04-28",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 90.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-05-05",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 90.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-05-12",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-05-19",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-05-26",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-06-02",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-06-09",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-06-16",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-06-23",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-06-30",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-07-07",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-07-14",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-07-21",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-07-28",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-08-04",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-08-11",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-08-18",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-08-25",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-09-01",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-09-08",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-09-15",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-09-22",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-09-29",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-10-06",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-10-13",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-10-20",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-10-27",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-11-03",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-11-10",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-11-17",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-11-24",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-12-01",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-12-08",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-12-15",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-12-22",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2027-12-29",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2028-01-05",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2028-01-12",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2028-01-19",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2028-01-26",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "2fdc25aa-f1c6-6dcb-79cf-acb50eb165a0",
      reporting_date: "2028-02-01",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "b366af47-9bc5-81eb-177a-23c48fbf7023": [
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-06-06",
      baseline_complete: 1.2,
      actual_complete: 4.7,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-06-13",
      baseline_complete: 1.3,
      actual_complete: 4.7,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-06-20",
      baseline_complete: 1.3,
      actual_complete: 4.7,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-06-27",
      baseline_complete: 1.4,
      actual_complete: 5.5,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-07-04",
      baseline_complete: 1.4,
      actual_complete: 5.5,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-07-11",
      baseline_complete: 1.5,
      actual_complete: 6.1,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-07-18",
      baseline_complete: 1.6,
      actual_complete: 6.6,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-07-25",
      baseline_complete: 1.6,
      actual_complete: 6.6,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-08-01",
      baseline_complete: 1.7,
      actual_complete: 6.6,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-08-08",
      baseline_complete: 1.8,
      actual_complete: 6.6,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-08-15",
      baseline_complete: 1.8,
      actual_complete: 6.6,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-08-22",
      baseline_complete: 1.9,
      actual_complete: 6.6,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-08-29",
      baseline_complete: 2.0,
      actual_complete: 6.6,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-09-05",
      baseline_complete: 2.1,
      actual_complete: 6.6,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-09-12",
      baseline_complete: 2.2,
      actual_complete: 7.1,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-09-19",
      baseline_complete: 2.3,
      actual_complete: 7.1,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-09-26",
      baseline_complete: 2.4,
      actual_complete: 7.1,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-10-03",
      baseline_complete: 2.5,
      actual_complete: 7.1,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-10-10",
      baseline_complete: 2.6,
      actual_complete: 7.1,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-10-17",
      baseline_complete: 2.7,
      actual_complete: 7.4,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-10-24",
      baseline_complete: 2.8,
      actual_complete: 7.4,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-10-31",
      baseline_complete: 2.9,
      actual_complete: 7.4,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-11-07",
      baseline_complete: 3.0,
      actual_complete: 7.4,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-11-14",
      baseline_complete: 3.1,
      actual_complete: 7.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-11-21",
      baseline_complete: 3.3,
      actual_complete: 7.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-11-28",
      baseline_complete: 3.4,
      actual_complete: 7.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-12-05",
      baseline_complete: 3.6,
      actual_complete: 7.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-12-12",
      baseline_complete: 3.7,
      actual_complete: 7.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-12-19",
      baseline_complete: 3.9,
      actual_complete: 7.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2024-12-26",
      baseline_complete: 4.0,
      actual_complete: 8.5,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-01-02",
      baseline_complete: 4.2,
      actual_complete: 8.5,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-01-09",
      baseline_complete: 4.4,
      actual_complete: 9.0,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-01-16",
      baseline_complete: 4.5,
      actual_complete: 9.0,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-01-23",
      baseline_complete: 4.7,
      actual_complete: 9.0,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-01-30",
      baseline_complete: 4.9,
      actual_complete: 9.0,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-02-06",
      baseline_complete: 5.1,
      actual_complete: 9.1,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-02-13",
      baseline_complete: 5.3,
      actual_complete: 9.9,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-02-20",
      baseline_complete: 5.5,
      actual_complete: 9.9,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-02-27",
      baseline_complete: 5.8,
      actual_complete: 10.0,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-03-06",
      baseline_complete: 6.0,
      actual_complete: 10.0,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-03-13",
      baseline_complete: 6.3,
      actual_complete: 10.3,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-03-20",
      baseline_complete: 6.5,
      actual_complete: 10.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-03-27",
      baseline_complete: 6.8,
      actual_complete: 10.3,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-04-03",
      baseline_complete: 7.0,
      actual_complete: 11.4,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-04-10",
      baseline_complete: 7.3,
      actual_complete: 11.5,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-04-17",
      baseline_complete: 7.6,
      actual_complete: 11.5,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-04-24",
      baseline_complete: 7.9,
      actual_complete: 12.1,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-05-01",
      baseline_complete: 8.2,
      actual_complete: 12.2,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-05-08",
      baseline_complete: 8.6,
      actual_complete: 12.2,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-05-15",
      baseline_complete: 8.9,
      actual_complete: 12.3,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-05-22",
      baseline_complete: 9.2,
      actual_complete: 13.1,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-05-29",
      baseline_complete: 9.6,
      actual_complete: 14.1,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-06-05",
      baseline_complete: 10.0,
      actual_complete: 14.1,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-06-12",
      baseline_complete: 10.4,
      actual_complete: 14.1,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-06-19",
      baseline_complete: 10.8,
      actual_complete: 14.1,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-06-26",
      baseline_complete: 11.2,
      actual_complete: 14.1,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-07-03",
      baseline_complete: 11.6,
      actual_complete: 14.1,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-07-10",
      baseline_complete: 12.0,
      actual_complete: 15.0,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-07-17",
      baseline_complete: 12.5,
      actual_complete: 15.0,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-07-24",
      baseline_complete: 13.0,
      actual_complete: 15.7,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-07-31",
      baseline_complete: 13.5,
      actual_complete: 16.8,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-08-07",
      baseline_complete: 14.0,
      actual_complete: 17.8,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-08-14",
      baseline_complete: 14.5,
      actual_complete: 18.4,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-08-21",
      baseline_complete: 15.0,
      actual_complete: 19.0,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-08-28",
      baseline_complete: 15.6,
      actual_complete: 19.8,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-09-04",
      baseline_complete: 16.1,
      actual_complete: 19.8,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-09-11",
      baseline_complete: 16.7,
      actual_complete: 19.8,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-09-18",
      baseline_complete: 17.3,
      actual_complete: 20.3,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-09-25",
      baseline_complete: 17.9,
      actual_complete: 21.4,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-10-02",
      baseline_complete: 18.5,
      actual_complete: 21.4,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-10-09",
      baseline_complete: 19.2,
      actual_complete: 22.9,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-10-16",
      baseline_complete: 19.9,
      actual_complete: 22.9,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-10-23",
      baseline_complete: 20.5,
      actual_complete: 22.9,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-10-30",
      baseline_complete: 21.2,
      actual_complete: 24.6,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-11-06",
      baseline_complete: 22.0,
      actual_complete: 25.8,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-11-13",
      baseline_complete: 22.7,
      actual_complete: 26.7,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-11-20",
      baseline_complete: 23.4,
      actual_complete: 26.7,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-11-27",
      baseline_complete: 24.2,
      actual_complete: 27.5,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-12-04",
      baseline_complete: 25.0,
      actual_complete: 28.3,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-12-11",
      baseline_complete: 25.8,
      actual_complete: 28.3,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-12-18",
      baseline_complete: 26.6,
      actual_complete: 30.8,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2025-12-25",
      baseline_complete: 27.5,
      actual_complete: 30.8,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-01-01",
      baseline_complete: 28.3,
      actual_complete: 30.8,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-01-08",
      baseline_complete: 29.2,
      actual_complete: 33.5,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-01-15",
      baseline_complete: 30.1,
      actual_complete: 33.5,
      forecast_complete: 16.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-01-22",
      baseline_complete: 31.0,
      actual_complete: 33.6,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-01-29",
      baseline_complete: 31.9,
      actual_complete: 33.6,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-02-05",
      baseline_complete: 32.8,
      actual_complete: 36.3,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-02-12",
      baseline_complete: 33.7,
      actual_complete: 38.0,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-02-19",
      baseline_complete: 34.7,
      actual_complete: 38.1,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-02-26",
      baseline_complete: 35.7,
      actual_complete: 38.9,
      forecast_complete: 19.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-03-05",
      baseline_complete: 36.6,
      actual_complete: 38.9,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-03-12",
      baseline_complete: 37.6,
      actual_complete: 41.0,
      forecast_complete: 20.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-03-19",
      baseline_complete: 38.6,
      actual_complete: 42.3,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-03-26",
      baseline_complete: 39.6,
      actual_complete: 43.5,
      forecast_complete: 21.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-04-02",
      baseline_complete: 40.6,
      actual_complete: 43.5,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-04-09",
      baseline_complete: 41.7,
      actual_complete: 45.6,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-04-16",
      baseline_complete: 42.7,
      actual_complete: 45.8,
      forecast_complete: 23.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-04-23",
      baseline_complete: 43.7,
      actual_complete: 46.8,
      forecast_complete: 23.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-04-30",
      baseline_complete: 44.8,
      actual_complete: 47.0,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-05-07",
      baseline_complete: 45.8,
      actual_complete: 48.1,
      forecast_complete: 25.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-05-14",
      baseline_complete: 46.9,
      actual_complete: 50.7,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-05-21",
      baseline_complete: 47.9,
      actual_complete: 51.2,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-05-28",
      baseline_complete: 49.0,
      actual_complete: 52.2,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-06-04",
      baseline_complete: 50.1,
      actual_complete: 53.4,
      forecast_complete: 27.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-06-11",
      baseline_complete: 51.1,
      actual_complete: 53.9,
      forecast_complete: 28.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-06-18",
      baseline_complete: 52.2,
      actual_complete: 55.0,
      forecast_complete: 29.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-06-25",
      baseline_complete: 53.2,
      actual_complete: 57.4,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-07-02",
      baseline_complete: 54.3,
      actual_complete: 57.4,
      forecast_complete: 30.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-07-09",
      baseline_complete: 55.3,
      actual_complete: 58.8,
      forecast_complete: 31.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-07-16",
      baseline_complete: 56.4,
      actual_complete: 58.8,
      forecast_complete: 32.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-07-23",
      baseline_complete: 57.4,
      actual_complete: 60.9,
      forecast_complete: 32.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-07-30",
      baseline_complete: 58.4,
      actual_complete: 60.9,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-08-06",
      baseline_complete: 59.5,
      actual_complete: 62.2,
      forecast_complete: 34.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-08-13",
      baseline_complete: 60.5,
      actual_complete: 63.4,
      forecast_complete: 35.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-08-20",
      baseline_complete: 61.5,
      actual_complete: 63.8,
      forecast_complete: 35.9,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-08-27",
      baseline_complete: 62.5,
      actual_complete: 65.2,
      forecast_complete: 36.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-09-03",
      baseline_complete: 63.5,
      actual_complete: 66.2,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-09-10",
      baseline_complete: 64.5,
      actual_complete: 66.4,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-09-17",
      baseline_complete: 65.4,
      actual_complete: 67.6,
      forecast_complete: 39.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-09-24",
      baseline_complete: 66.4,
      actual_complete: 68.5,
      forecast_complete: 39.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-10-01",
      baseline_complete: 67.3,
      actual_complete: 71.3,
      forecast_complete: 40.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-10-08",
      baseline_complete: 68.2,
      actual_complete: 71.3,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-10-15",
      baseline_complete: 69.1,
      actual_complete: 71.3,
      forecast_complete: 42.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-10-22",
      baseline_complete: 70.0,
      actual_complete: 72.0,
      forecast_complete: 42.9,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-10-29",
      baseline_complete: 70.9,
      actual_complete: 72.8,
      forecast_complete: 43.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-11-05",
      baseline_complete: 71.8,
      actual_complete: 74.7,
      forecast_complete: 44.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-11-12",
      baseline_complete: 72.6,
      actual_complete: 74.7,
      forecast_complete: 45.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-11-19",
      baseline_complete: 73.5,
      actual_complete: 75.7,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-11-26",
      baseline_complete: 74.3,
      actual_complete: 77.0,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-12-03",
      baseline_complete: 75.1,
      actual_complete: 77.5,
      forecast_complete: 47.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-12-10",
      baseline_complete: 75.9,
      actual_complete: 78.1,
      forecast_complete: 48.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-12-17",
      baseline_complete: 76.6,
      actual_complete: 78.5,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-12-24",
      baseline_complete: 77.4,
      actual_complete: 80.1,
      forecast_complete: 50.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2026-12-31",
      baseline_complete: 78.1,
      actual_complete: 81.0,
      forecast_complete: 50.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-01-07",
      baseline_complete: 78.8,
      actual_complete: 81.3,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-01-14",
      baseline_complete: 79.5,
      actual_complete: 81.9,
      forecast_complete: 52.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-01-21",
      baseline_complete: 80.2,
      actual_complete: 82.6,
      forecast_complete: 53.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-01-28",
      baseline_complete: 80.9,
      actual_complete: 82.6,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-02-04",
      baseline_complete: 81.5,
      actual_complete: 85.3,
      forecast_complete: 54.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-02-11",
      baseline_complete: 82.2,
      actual_complete: 85.3,
      forecast_complete: 55.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-02-18",
      baseline_complete: 82.8,
      actual_complete: 85.3,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-02-25",
      baseline_complete: 83.4,
      actual_complete: 85.3,
      forecast_complete: 56.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-03-04",
      baseline_complete: 83.9,
      actual_complete: 86.3,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-03-11",
      baseline_complete: 84.5,
      actual_complete: 86.4,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-03-18",
      baseline_complete: 85.0,
      actual_complete: 87.1,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-03-25",
      baseline_complete: 85.6,
      actual_complete: 87.1,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-04-01",
      baseline_complete: 86.1,
      actual_complete: 88.4,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-04-08",
      baseline_complete: 86.6,
      actual_complete: 88.5,
      forecast_complete: 61.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-04-15",
      baseline_complete: 87.1,
      actual_complete: 89.9,
      forecast_complete: 61.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-04-22",
      baseline_complete: 87.5,
      actual_complete: 91.6,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-04-29",
      baseline_complete: 88.0,
      actual_complete: 91.6,
      forecast_complete: 63.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-05-06",
      baseline_complete: 88.4,
      actual_complete: 91.6,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-05-13",
      baseline_complete: 88.9,
      actual_complete: 92.6,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-05-20",
      baseline_complete: 89.3,
      actual_complete: 92.6,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-05-27",
      baseline_complete: 89.7,
      actual_complete: 92.6,
      forecast_complete: 65.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-06-03",
      baseline_complete: 90.1,
      actual_complete: 94.1,
      forecast_complete: 66.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-06-10",
      baseline_complete: 90.4,
      actual_complete: 94.1,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-06-17",
      baseline_complete: 90.8,
      actual_complete: 94.3,
      forecast_complete: 67.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-06-24",
      baseline_complete: 91.1,
      actual_complete: 94.3,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-07-01",
      baseline_complete: 91.5,
      actual_complete: 94.3,
      forecast_complete: 69.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-07-08",
      baseline_complete: 91.8,
      actual_complete: 95.5,
      forecast_complete: 69.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-07-15",
      baseline_complete: 92.1,
      actual_complete: 95.5,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-07-22",
      baseline_complete: 92.4,
      actual_complete: 95.8,
      forecast_complete: 70.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-07-29",
      baseline_complete: 92.7,
      actual_complete: 95.8,
      forecast_complete: 71.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-08-05",
      baseline_complete: 93.0,
      actual_complete: 95.8,
      forecast_complete: 72.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-08-12",
      baseline_complete: 93.3,
      actual_complete: 95.9,
      forecast_complete: 72.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-08-19",
      baseline_complete: 93.5,
      actual_complete: 95.9,
      forecast_complete: 73.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-08-26",
      baseline_complete: 93.8,
      actual_complete: 95.9,
      forecast_complete: 74.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-09-02",
      baseline_complete: 94.0,
      actual_complete: 97.0,
      forecast_complete: 75.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-09-09",
      baseline_complete: 94.3,
      actual_complete: 97.3,
      forecast_complete: 76.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-09-16",
      baseline_complete: 94.5,
      actual_complete: 97.3,
      forecast_complete: 77.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-09-23",
      baseline_complete: 94.7,
      actual_complete: 97.3,
      forecast_complete: 78.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-09-30",
      baseline_complete: 94.9,
      actual_complete: 97.8,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-10-07",
      baseline_complete: 95.1,
      actual_complete: 97.8,
      forecast_complete: 80.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-10-14",
      baseline_complete: 95.3,
      actual_complete: 97.8,
      forecast_complete: 81.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-10-21",
      baseline_complete: 95.5,
      actual_complete: 97.8,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-10-28",
      baseline_complete: 95.7,
      actual_complete: 97.8,
      forecast_complete: 83.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-11-04",
      baseline_complete: 95.8,
      actual_complete: 97.9,
      forecast_complete: 84.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-11-11",
      baseline_complete: 96.0,
      actual_complete: 97.9,
      forecast_complete: 85.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-11-18",
      baseline_complete: 96.2,
      actual_complete: 98.7,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-11-25",
      baseline_complete: 96.3,
      actual_complete: 98.7,
      forecast_complete: 86.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-12-02",
      baseline_complete: 96.5,
      actual_complete: 98.7,
      forecast_complete: 87.3,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-12-09",
      baseline_complete: 96.6,
      actual_complete: 99.4,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-12-16",
      baseline_complete: 96.7,
      actual_complete: 99.4,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-12-23",
      baseline_complete: 96.9,
      actual_complete: 99.4,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2027-12-30",
      baseline_complete: 97.0,
      actual_complete: 99.4,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-01-06",
      baseline_complete: 97.1,
      actual_complete: 99.4,
      forecast_complete: 90.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-01-13",
      baseline_complete: 97.2,
      actual_complete: 99.4,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-01-20",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-01-27",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-02-03",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-02-10",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-02-17",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-02-24",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-03-02",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-03-09",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-03-16",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-03-23",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-03-30",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-04-06",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-04-13",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-04-20",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-04-27",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-05-04",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-05-11",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-05-18",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-05-25",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-06-01",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-06-08",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-06-15",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-06-22",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-06-29",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-07-06",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-07-13",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-07-20",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-07-27",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-08-03",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-08-10",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-08-17",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-08-24",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-08-31",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "b366af47-9bc5-81eb-177a-23c48fbf7023",
      reporting_date: "2028-09-06",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe": [
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-03-19",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-03-26",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-04-02",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-04-09",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-04-16",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-04-23",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-04-30",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-05-07",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-05-14",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-05-21",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-05-28",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-06-04",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-06-11",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-06-18",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-06-25",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-07-02",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-07-09",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-07-16",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-07-23",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-07-30",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-08-06",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-08-13",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-08-20",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-08-27",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-09-03",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-09-10",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-09-17",
      baseline_complete: 3.8,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-09-24",
      baseline_complete: 4.0,
      actual_complete: 0.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-10-01",
      baseline_complete: 4.1,
      actual_complete: 0.0,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-10-08",
      baseline_complete: 4.3,
      actual_complete: 0.0,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-10-15",
      baseline_complete: 4.6,
      actual_complete: 0.0,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-10-22",
      baseline_complete: 4.8,
      actual_complete: 0.0,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-10-29",
      baseline_complete: 5.0,
      actual_complete: 0.0,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-11-05",
      baseline_complete: 5.3,
      actual_complete: 0.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-11-12",
      baseline_complete: 5.5,
      actual_complete: 0.0,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-11-19",
      baseline_complete: 5.8,
      actual_complete: 0.0,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-11-26",
      baseline_complete: 6.0,
      actual_complete: 1.2,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-12-03",
      baseline_complete: 6.3,
      actual_complete: 1.2,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-12-10",
      baseline_complete: 6.6,
      actual_complete: 1.2,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-12-17",
      baseline_complete: 6.9,
      actual_complete: 1.2,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-12-24",
      baseline_complete: 7.3,
      actual_complete: 1.2,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2024-12-31",
      baseline_complete: 7.6,
      actual_complete: 1.2,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-01-07",
      baseline_complete: 8.0,
      actual_complete: 3.3,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-01-14",
      baseline_complete: 8.3,
      actual_complete: 3.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-01-21",
      baseline_complete: 8.7,
      actual_complete: 3.3,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-01-28",
      baseline_complete: 9.1,
      actual_complete: 3.3,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-02-04",
      baseline_complete: 9.5,
      actual_complete: 3.3,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-02-11",
      baseline_complete: 10.0,
      actual_complete: 3.7,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-02-18",
      baseline_complete: 10.4,
      actual_complete: 3.7,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-02-25",
      baseline_complete: 10.9,
      actual_complete: 3.7,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-03-04",
      baseline_complete: 11.4,
      actual_complete: 6.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-03-11",
      baseline_complete: 11.9,
      actual_complete: 6.2,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-03-18",
      baseline_complete: 12.4,
      actual_complete: 8.3,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-03-25",
      baseline_complete: 13.0,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-04-01",
      baseline_complete: 13.5,
      actual_complete: 8.3,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-04-08",
      baseline_complete: 14.1,
      actual_complete: 10.6,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-04-15",
      baseline_complete: 14.7,
      actual_complete: 10.6,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-04-22",
      baseline_complete: 15.4,
      actual_complete: 10.6,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-04-29",
      baseline_complete: 16.0,
      actual_complete: 12.5,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-05-06",
      baseline_complete: 16.7,
      actual_complete: 12.5,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-05-13",
      baseline_complete: 17.4,
      actual_complete: 12.5,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-05-20",
      baseline_complete: 18.1,
      actual_complete: 14.4,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-05-27",
      baseline_complete: 18.9,
      actual_complete: 14.4,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-06-03",
      baseline_complete: 19.7,
      actual_complete: 14.8,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-06-10",
      baseline_complete: 20.4,
      actual_complete: 14.8,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-06-17",
      baseline_complete: 21.3,
      actual_complete: 17.1,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-06-24",
      baseline_complete: 22.1,
      actual_complete: 17.2,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-07-01",
      baseline_complete: 23.0,
      actual_complete: 18.4,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-07-08",
      baseline_complete: 23.9,
      actual_complete: 18.4,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-07-15",
      baseline_complete: 24.8,
      actual_complete: 22.1,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-07-22",
      baseline_complete: 25.7,
      actual_complete: 23.6,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-07-29",
      baseline_complete: 26.7,
      actual_complete: 23.6,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-08-05",
      baseline_complete: 27.6,
      actual_complete: 23.6,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-08-12",
      baseline_complete: 28.6,
      actual_complete: 23.6,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-08-19",
      baseline_complete: 29.7,
      actual_complete: 25.3,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-08-26",
      baseline_complete: 30.7,
      actual_complete: 25.3,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-09-02",
      baseline_complete: 31.8,
      actual_complete: 27.4,
      forecast_complete: 15.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-09-09",
      baseline_complete: 32.8,
      actual_complete: 28.0,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-09-16",
      baseline_complete: 33.9,
      actual_complete: 29.6,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-09-23",
      baseline_complete: 35.1,
      actual_complete: 29.6,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-09-30",
      baseline_complete: 36.2,
      actual_complete: 29.6,
      forecast_complete: 18.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-10-07",
      baseline_complete: 37.3,
      actual_complete: 30.5,
      forecast_complete: 19.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-10-14",
      baseline_complete: 38.5,
      actual_complete: 35.8,
      forecast_complete: 20.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-10-21",
      baseline_complete: 39.7,
      actual_complete: 35.8,
      forecast_complete: 20.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-10-28",
      baseline_complete: 40.9,
      actual_complete: 35.8,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-11-04",
      baseline_complete: 42.1,
      actual_complete: 39.3,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-11-11",
      baseline_complete: 43.3,
      actual_complete: 41.8,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-11-18",
      baseline_complete: 44.5,
      actual_complete: 41.8,
      forecast_complete: 24.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-11-25",
      baseline_complete: 45.7,
      actual_complete: 41.8,
      forecast_complete: 24.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-12-02",
      baseline_complete: 47.0,
      actual_complete: 41.8,
      forecast_complete: 25.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-12-09",
      baseline_complete: 48.2,
      actual_complete: 43.7,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-12-16",
      baseline_complete: 49.4,
      actual_complete: 47.4,
      forecast_complete: 27.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-12-23",
      baseline_complete: 50.7,
      actual_complete: 49.3,
      forecast_complete: 28.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2025-12-30",
      baseline_complete: 51.9,
      actual_complete: 49.3,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-01-06",
      baseline_complete: 53.1,
      actual_complete: 49.3,
      forecast_complete: 30.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-01-13",
      baseline_complete: 54.4,
      actual_complete: 49.9,
      forecast_complete: 31.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-01-20",
      baseline_complete: 55.6,
      actual_complete: 53.3,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-01-27",
      baseline_complete: 56.8,
      actual_complete: 56.3,
      forecast_complete: 33.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-02-03",
      baseline_complete: 58.0,
      actual_complete: 56.3,
      forecast_complete: 34.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-02-10",
      baseline_complete: 59.2,
      actual_complete: 56.5,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-02-17",
      baseline_complete: 60.4,
      actual_complete: 58.3,
      forecast_complete: 36.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-02-24",
      baseline_complete: 61.6,
      actual_complete: 61.0,
      forecast_complete: 37.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-03-03",
      baseline_complete: 62.8,
      actual_complete: 61.0,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-03-10",
      baseline_complete: 63.9,
      actual_complete: 61.2,
      forecast_complete: 39.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-03-17",
      baseline_complete: 65.0,
      actual_complete: 62.9,
      forecast_complete: 40.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-03-24",
      baseline_complete: 66.2,
      actual_complete: 64.2,
      forecast_complete: 41.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-03-31",
      baseline_complete: 67.3,
      actual_complete: 64.2,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-04-07",
      baseline_complete: 68.3,
      actual_complete: 64.2,
      forecast_complete: 43.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-04-14",
      baseline_complete: 69.4,
      actual_complete: 68.2,
      forecast_complete: 44.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-04-21",
      baseline_complete: 70.4,
      actual_complete: 68.2,
      forecast_complete: 45.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-04-28",
      baseline_complete: 71.5,
      actual_complete: 68.2,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-05-05",
      baseline_complete: 72.5,
      actual_complete: 68.2,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-05-12",
      baseline_complete: 73.4,
      actual_complete: 70.6,
      forecast_complete: 48.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-05-19",
      baseline_complete: 74.4,
      actual_complete: 73.6,
      forecast_complete: 49.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-05-26",
      baseline_complete: 75.3,
      actual_complete: 76.4,
      forecast_complete: 50.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-06-02",
      baseline_complete: 76.2,
      actual_complete: 76.4,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-06-09",
      baseline_complete: 77.1,
      actual_complete: 76.6,
      forecast_complete: 52.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-06-16",
      baseline_complete: 78.0,
      actual_complete: 77.4,
      forecast_complete: 53.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-06-23",
      baseline_complete: 78.8,
      actual_complete: 77.4,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-06-30",
      baseline_complete: 79.6,
      actual_complete: 77.4,
      forecast_complete: 55.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-07-07",
      baseline_complete: 80.4,
      actual_complete: 78.2,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-07-14",
      baseline_complete: 81.2,
      actual_complete: 78.2,
      forecast_complete: 57.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-07-21",
      baseline_complete: 81.9,
      actual_complete: 80.7,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-07-28",
      baseline_complete: 82.7,
      actual_complete: 83.0,
      forecast_complete: 59.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-08-04",
      baseline_complete: 83.3,
      actual_complete: 83.0,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-08-11",
      baseline_complete: 84.0,
      actual_complete: 83.0,
      forecast_complete: 61.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-08-18",
      baseline_complete: 84.7,
      actual_complete: 83.0,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-08-25",
      baseline_complete: 85.3,
      actual_complete: 84.3,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-09-01",
      baseline_complete: 85.9,
      actual_complete: 84.3,
      forecast_complete: 63.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-09-08",
      baseline_complete: 86.5,
      actual_complete: 84.3,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-09-15",
      baseline_complete: 87.1,
      actual_complete: 84.3,
      forecast_complete: 65.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-09-22",
      baseline_complete: 87.6,
      actual_complete: 88.0,
      forecast_complete: 66.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-09-29",
      baseline_complete: 88.1,
      actual_complete: 88.0,
      forecast_complete: 67.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-10-06",
      baseline_complete: 88.7,
      actual_complete: 88.9,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-10-13",
      baseline_complete: 89.1,
      actual_complete: 88.9,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-10-20",
      baseline_complete: 89.6,
      actual_complete: 88.9,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-10-27",
      baseline_complete: 90.1,
      actual_complete: 88.9,
      forecast_complete: 72.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-11-03",
      baseline_complete: 90.5,
      actual_complete: 88.9,
      forecast_complete: 73.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-11-10",
      baseline_complete: 90.9,
      actual_complete: 90.8,
      forecast_complete: 75.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-11-17",
      baseline_complete: 91.3,
      actual_complete: 90.8,
      forecast_complete: 76.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-11-24",
      baseline_complete: 91.7,
      actual_complete: 90.8,
      forecast_complete: 77.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-12-01",
      baseline_complete: 92.1,
      actual_complete: 90.8,
      forecast_complete: 79.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-12-08",
      baseline_complete: 92.4,
      actual_complete: 94.6,
      forecast_complete: 80.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-12-15",
      baseline_complete: 92.8,
      actual_complete: 94.6,
      forecast_complete: 81.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-12-22",
      baseline_complete: 93.1,
      actual_complete: 94.6,
      forecast_complete: 82.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2026-12-29",
      baseline_complete: 93.4,
      actual_complete: 94.6,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-01-05",
      baseline_complete: 93.7,
      actual_complete: 94.6,
      forecast_complete: 85.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-01-12",
      baseline_complete: 94.0,
      actual_complete: 94.9,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-01-19",
      baseline_complete: 94.3,
      actual_complete: 94.9,
      forecast_complete: 87.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-01-26",
      baseline_complete: 94.5,
      actual_complete: 94.9,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-02-02",
      baseline_complete: 94.8,
      actual_complete: 95.2,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-02-09",
      baseline_complete: 95.0,
      actual_complete: 95.2,
      forecast_complete: 90.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-02-16",
      baseline_complete: 95.2,
      actual_complete: 95.2,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-02-23",
      baseline_complete: 95.5,
      actual_complete: 95.2,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-03-02",
      baseline_complete: 95.7,
      actual_complete: 98.6,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-03-09",
      baseline_complete: 95.9,
      actual_complete: 98.6,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-03-16",
      baseline_complete: 96.1,
      actual_complete: 98.6,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-03-23",
      baseline_complete: 96.2,
      actual_complete: 98.6,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-03-30",
      baseline_complete: 96.4,
      actual_complete: 98.6,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-04-06",
      baseline_complete: 96.6,
      actual_complete: 98.6,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-04-13",
      baseline_complete: 96.7,
      actual_complete: 98.6,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-04-20",
      baseline_complete: 96.9,
      actual_complete: 98.8,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-04-27",
      baseline_complete: 97.0,
      actual_complete: 98.8,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-05-04",
      baseline_complete: 97.2,
      actual_complete: 98.8,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-05-11",
      baseline_complete: 97.3,
      actual_complete: 98.8,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-05-18",
      baseline_complete: 97.4,
      actual_complete: 98.8,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-05-25",
      baseline_complete: 97.6,
      actual_complete: 98.8,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-06-01",
      baseline_complete: 97.7,
      actual_complete: 99.1,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-06-08",
      baseline_complete: 97.8,
      actual_complete: 99.2,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-06-15",
      baseline_complete: 97.9,
      actual_complete: 99.2,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-06-22",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-06-29",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-07-06",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-07-13",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-07-20",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-07-27",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-08-03",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-08-10",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-08-17",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0609bf8e-79d6-2de1-fb7b-54d4b5febbbe",
      reporting_date: "2027-08-19",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "6ebb1a90-2435-1b34-fa18-3e42879e0157": [
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-08-26",
      baseline_complete: 0.5,
      actual_complete: 4.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-09-02",
      baseline_complete: 0.5,
      actual_complete: 7.8,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-09-09",
      baseline_complete: 0.5,
      actual_complete: 7.8,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-09-16",
      baseline_complete: 0.5,
      actual_complete: 7.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-09-23",
      baseline_complete: 0.5,
      actual_complete: 7.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-09-30",
      baseline_complete: 0.6,
      actual_complete: 7.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-10-07",
      baseline_complete: 0.6,
      actual_complete: 7.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-10-14",
      baseline_complete: 0.6,
      actual_complete: 7.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-10-21",
      baseline_complete: 0.6,
      actual_complete: 9.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-10-28",
      baseline_complete: 0.7,
      actual_complete: 9.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-11-04",
      baseline_complete: 0.7,
      actual_complete: 9.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-11-11",
      baseline_complete: 0.7,
      actual_complete: 9.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-11-18",
      baseline_complete: 0.8,
      actual_complete: 9.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-11-25",
      baseline_complete: 0.8,
      actual_complete: 9.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-12-02",
      baseline_complete: 0.8,
      actual_complete: 9.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-12-09",
      baseline_complete: 0.9,
      actual_complete: 9.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-12-16",
      baseline_complete: 0.9,
      actual_complete: 9.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-12-23",
      baseline_complete: 0.9,
      actual_complete: 9.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2023-12-30",
      baseline_complete: 1.0,
      actual_complete: 9.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-01-06",
      baseline_complete: 1.0,
      actual_complete: 9.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-01-13",
      baseline_complete: 1.1,
      actual_complete: 9.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-01-20",
      baseline_complete: 1.1,
      actual_complete: 9.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-01-27",
      baseline_complete: 1.1,
      actual_complete: 9.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-02-03",
      baseline_complete: 1.2,
      actual_complete: 9.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-02-10",
      baseline_complete: 1.2,
      actual_complete: 9.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-02-17",
      baseline_complete: 1.3,
      actual_complete: 9.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-02-24",
      baseline_complete: 1.4,
      actual_complete: 9.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-03-02",
      baseline_complete: 1.4,
      actual_complete: 9.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-03-09",
      baseline_complete: 1.5,
      actual_complete: 9.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-03-16",
      baseline_complete: 1.5,
      actual_complete: 9.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-03-23",
      baseline_complete: 1.6,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-03-30",
      baseline_complete: 1.7,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-04-06",
      baseline_complete: 1.7,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-04-13",
      baseline_complete: 1.8,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-04-20",
      baseline_complete: 1.9,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-04-27",
      baseline_complete: 2.0,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-05-04",
      baseline_complete: 2.1,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-05-11",
      baseline_complete: 2.1,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-05-18",
      baseline_complete: 2.2,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-05-25",
      baseline_complete: 2.3,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-06-01",
      baseline_complete: 2.4,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-06-08",
      baseline_complete: 2.5,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-06-15",
      baseline_complete: 2.6,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-06-22",
      baseline_complete: 2.7,
      actual_complete: 11.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-06-29",
      baseline_complete: 2.9,
      actual_complete: 11.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-07-06",
      baseline_complete: 3.0,
      actual_complete: 11.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-07-13",
      baseline_complete: 3.1,
      actual_complete: 11.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-07-20",
      baseline_complete: 3.2,
      actual_complete: 11.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-07-27",
      baseline_complete: 3.4,
      actual_complete: 11.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-08-03",
      baseline_complete: 3.5,
      actual_complete: 11.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-08-10",
      baseline_complete: 3.7,
      actual_complete: 11.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-08-17",
      baseline_complete: 3.8,
      actual_complete: 11.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-08-24",
      baseline_complete: 4.0,
      actual_complete: 11.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-08-31",
      baseline_complete: 4.1,
      actual_complete: 11.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-09-07",
      baseline_complete: 4.3,
      actual_complete: 11.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-09-14",
      baseline_complete: 4.5,
      actual_complete: 11.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-09-21",
      baseline_complete: 4.7,
      actual_complete: 11.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-09-28",
      baseline_complete: 4.9,
      actual_complete: 11.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-10-05",
      baseline_complete: 5.1,
      actual_complete: 11.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-10-12",
      baseline_complete: 5.3,
      actual_complete: 11.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-10-19",
      baseline_complete: 5.5,
      actual_complete: 11.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-10-26",
      baseline_complete: 5.7,
      actual_complete: 12.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-11-02",
      baseline_complete: 6.0,
      actual_complete: 13.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-11-09",
      baseline_complete: 6.2,
      actual_complete: 13.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-11-16",
      baseline_complete: 6.4,
      actual_complete: 13.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-11-23",
      baseline_complete: 6.7,
      actual_complete: 13.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-11-30",
      baseline_complete: 7.0,
      actual_complete: 13.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-12-07",
      baseline_complete: 7.3,
      actual_complete: 13.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-12-14",
      baseline_complete: 7.5,
      actual_complete: 13.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-12-21",
      baseline_complete: 7.8,
      actual_complete: 15.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2024-12-28",
      baseline_complete: 8.2,
      actual_complete: 15.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-01-04",
      baseline_complete: 8.5,
      actual_complete: 15.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-01-11",
      baseline_complete: 8.8,
      actual_complete: 15.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-01-18",
      baseline_complete: 9.2,
      actual_complete: 15.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-01-25",
      baseline_complete: 9.5,
      actual_complete: 15.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-02-01",
      baseline_complete: 9.9,
      actual_complete: 15.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-02-08",
      baseline_complete: 10.3,
      actual_complete: 15.9,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-02-15",
      baseline_complete: 10.7,
      actual_complete: 18.5,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-02-22",
      baseline_complete: 11.1,
      actual_complete: 18.8,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-03-01",
      baseline_complete: 11.5,
      actual_complete: 18.8,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-03-08",
      baseline_complete: 12.0,
      actual_complete: 18.8,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-03-15",
      baseline_complete: 12.4,
      actual_complete: 18.8,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-03-22",
      baseline_complete: 12.9,
      actual_complete: 20.6,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-03-29",
      baseline_complete: 13.4,
      actual_complete: 20.6,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-04-05",
      baseline_complete: 13.9,
      actual_complete: 20.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-04-12",
      baseline_complete: 14.4,
      actual_complete: 20.6,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-04-19",
      baseline_complete: 14.9,
      actual_complete: 20.6,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-04-26",
      baseline_complete: 15.4,
      actual_complete: 21.7,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-05-03",
      baseline_complete: 16.0,
      actual_complete: 21.7,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-05-10",
      baseline_complete: 16.6,
      actual_complete: 21.7,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-05-17",
      baseline_complete: 17.2,
      actual_complete: 24.0,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-05-24",
      baseline_complete: 17.8,
      actual_complete: 24.0,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-05-31",
      baseline_complete: 18.4,
      actual_complete: 24.0,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-06-07",
      baseline_complete: 19.1,
      actual_complete: 24.0,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-06-14",
      baseline_complete: 19.7,
      actual_complete: 24.0,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-06-21",
      baseline_complete: 20.4,
      actual_complete: 25.8,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-06-28",
      baseline_complete: 21.1,
      actual_complete: 25.8,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-07-05",
      baseline_complete: 21.8,
      actual_complete: 25.8,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-07-12",
      baseline_complete: 22.6,
      actual_complete: 28.3,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-07-19",
      baseline_complete: 23.3,
      actual_complete: 28.3,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-07-26",
      baseline_complete: 24.1,
      actual_complete: 30.4,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-08-02",
      baseline_complete: 24.9,
      actual_complete: 30.4,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-08-09",
      baseline_complete: 25.7,
      actual_complete: 30.9,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-08-16",
      baseline_complete: 26.5,
      actual_complete: 34.0,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-08-23",
      baseline_complete: 27.3,
      actual_complete: 34.0,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-08-30",
      baseline_complete: 28.2,
      actual_complete: 34.0,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-09-06",
      baseline_complete: 29.0,
      actual_complete: 34.0,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-09-13",
      baseline_complete: 29.9,
      actual_complete: 34.0,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-09-20",
      baseline_complete: 30.8,
      actual_complete: 34.0,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-09-27",
      baseline_complete: 31.7,
      actual_complete: 34.3,
      forecast_complete: 14.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-10-04",
      baseline_complete: 32.6,
      actual_complete: 34.3,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-10-11",
      baseline_complete: 33.6,
      actual_complete: 39.8,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-10-18",
      baseline_complete: 34.5,
      actual_complete: 39.8,
      forecast_complete: 16.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-10-25",
      baseline_complete: 35.5,
      actual_complete: 39.8,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-11-01",
      baseline_complete: 36.5,
      actual_complete: 40.7,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-11-08",
      baseline_complete: 37.5,
      actual_complete: 42.8,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-11-15",
      baseline_complete: 38.5,
      actual_complete: 42.8,
      forecast_complete: 18.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-11-22",
      baseline_complete: 39.5,
      actual_complete: 42.9,
      forecast_complete: 19.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-11-29",
      baseline_complete: 40.5,
      actual_complete: 48.2,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-12-06",
      baseline_complete: 41.5,
      actual_complete: 48.2,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-12-13",
      baseline_complete: 42.5,
      actual_complete: 48.2,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-12-20",
      baseline_complete: 43.6,
      actual_complete: 48.2,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2025-12-27",
      baseline_complete: 44.6,
      actual_complete: 48.2,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-01-03",
      baseline_complete: 45.7,
      actual_complete: 49.8,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-01-10",
      baseline_complete: 46.7,
      actual_complete: 49.9,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-01-17",
      baseline_complete: 47.8,
      actual_complete: 51.8,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-01-24",
      baseline_complete: 48.9,
      actual_complete: 51.8,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-01-31",
      baseline_complete: 49.9,
      actual_complete: 55.3,
      forecast_complete: 26.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-02-07",
      baseline_complete: 51.0,
      actual_complete: 55.3,
      forecast_complete: 26.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-02-14",
      baseline_complete: 52.0,
      actual_complete: 55.3,
      forecast_complete: 27.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-02-21",
      baseline_complete: 53.1,
      actual_complete: 55.3,
      forecast_complete: 28.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-02-28",
      baseline_complete: 54.1,
      actual_complete: 59.5,
      forecast_complete: 29.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-03-07",
      baseline_complete: 55.2,
      actual_complete: 61.1,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-03-14",
      baseline_complete: 56.2,
      actual_complete: 61.1,
      forecast_complete: 30.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-03-21",
      baseline_complete: 57.3,
      actual_complete: 61.1,
      forecast_complete: 31.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-03-28",
      baseline_complete: 58.3,
      actual_complete: 62.5,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-04-04",
      baseline_complete: 59.3,
      actual_complete: 65.6,
      forecast_complete: 33.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-04-11",
      baseline_complete: 60.4,
      actual_complete: 65.6,
      forecast_complete: 33.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-04-18",
      baseline_complete: 61.4,
      actual_complete: 65.6,
      forecast_complete: 34.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-04-25",
      baseline_complete: 62.4,
      actual_complete: 68.5,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-05-02",
      baseline_complete: 63.4,
      actual_complete: 68.5,
      forecast_complete: 36.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-05-09",
      baseline_complete: 64.3,
      actual_complete: 68.5,
      forecast_complete: 37.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-05-16",
      baseline_complete: 65.3,
      actual_complete: 68.5,
      forecast_complete: 37.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-05-23",
      baseline_complete: 66.3,
      actual_complete: 68.5,
      forecast_complete: 38.7,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-05-30",
      baseline_complete: 67.2,
      actual_complete: 73.5,
      forecast_complete: 39.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-06-06",
      baseline_complete: 68.1,
      actual_complete: 73.5,
      forecast_complete: 40.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-06-13",
      baseline_complete: 69.0,
      actual_complete: 73.5,
      forecast_complete: 41.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-06-20",
      baseline_complete: 69.9,
      actual_complete: 77.4,
      forecast_complete: 41.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-06-27",
      baseline_complete: 70.8,
      actual_complete: 77.4,
      forecast_complete: 42.7,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-07-04",
      baseline_complete: 71.7,
      actual_complete: 77.4,
      forecast_complete: 43.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-07-11",
      baseline_complete: 72.6,
      actual_complete: 77.4,
      forecast_complete: 44.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-07-18",
      baseline_complete: 73.4,
      actual_complete: 77.4,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-07-25",
      baseline_complete: 74.2,
      actual_complete: 79.4,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-08-01",
      baseline_complete: 75.0,
      actual_complete: 81.4,
      forecast_complete: 46.7,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-08-08",
      baseline_complete: 75.8,
      actual_complete: 81.4,
      forecast_complete: 47.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-08-15",
      baseline_complete: 76.6,
      actual_complete: 81.5,
      forecast_complete: 48.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-08-22",
      baseline_complete: 77.3,
      actual_complete: 81.5,
      forecast_complete: 49.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-08-29",
      baseline_complete: 78.1,
      actual_complete: 83.8,
      forecast_complete: 49.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-09-05",
      baseline_complete: 78.8,
      actual_complete: 83.8,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-09-12",
      baseline_complete: 79.5,
      actual_complete: 86.3,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-09-19",
      baseline_complete: 80.2,
      actual_complete: 86.3,
      forecast_complete: 52.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-09-26",
      baseline_complete: 80.8,
      actual_complete: 86.3,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-10-03",
      baseline_complete: 81.5,
      actual_complete: 86.3,
      forecast_complete: 53.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-10-10",
      baseline_complete: 82.1,
      actual_complete: 86.3,
      forecast_complete: 54.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-10-17",
      baseline_complete: 82.7,
      actual_complete: 86.3,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-10-24",
      baseline_complete: 83.3,
      actual_complete: 87.2,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-10-31",
      baseline_complete: 83.9,
      actual_complete: 87.2,
      forecast_complete: 56.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-11-07",
      baseline_complete: 84.5,
      actual_complete: 90.6,
      forecast_complete: 57.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-11-14",
      baseline_complete: 85.0,
      actual_complete: 90.6,
      forecast_complete: 57.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-11-21",
      baseline_complete: 85.5,
      actual_complete: 90.6,
      forecast_complete: 58.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-11-28",
      baseline_complete: 86.1,
      actual_complete: 90.6,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-12-05",
      baseline_complete: 86.6,
      actual_complete: 90.9,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-12-12",
      baseline_complete: 87.0,
      actual_complete: 90.9,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-12-19",
      baseline_complete: 87.5,
      actual_complete: 90.9,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2026-12-26",
      baseline_complete: 88.0,
      actual_complete: 90.9,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-01-02",
      baseline_complete: 88.4,
      actual_complete: 94.0,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-01-09",
      baseline_complete: 88.8,
      actual_complete: 94.0,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-01-16",
      baseline_complete: 89.3,
      actual_complete: 94.0,
      forecast_complete: 64.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-01-23",
      baseline_complete: 89.7,
      actual_complete: 94.0,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-01-30",
      baseline_complete: 90.0,
      actual_complete: 94.0,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-02-06",
      baseline_complete: 90.4,
      actual_complete: 94.0,
      forecast_complete: 65.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-02-13",
      baseline_complete: 90.8,
      actual_complete: 95.6,
      forecast_complete: 66.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-02-20",
      baseline_complete: 91.1,
      actual_complete: 95.6,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-02-27",
      baseline_complete: 91.5,
      actual_complete: 97.9,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-03-06",
      baseline_complete: 91.8,
      actual_complete: 97.9,
      forecast_complete: 68.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-03-13",
      baseline_complete: 92.1,
      actual_complete: 97.9,
      forecast_complete: 69.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-03-20",
      baseline_complete: 92.4,
      actual_complete: 97.9,
      forecast_complete: 70.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-03-27",
      baseline_complete: 92.7,
      actual_complete: 97.9,
      forecast_complete: 72.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-04-03",
      baseline_complete: 93.0,
      actual_complete: 97.9,
      forecast_complete: 73.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-04-10",
      baseline_complete: 93.3,
      actual_complete: 97.9,
      forecast_complete: 74.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-04-17",
      baseline_complete: 93.5,
      actual_complete: 97.9,
      forecast_complete: 74.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-04-24",
      baseline_complete: 93.8,
      actual_complete: 97.9,
      forecast_complete: 75.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-05-01",
      baseline_complete: 94.0,
      actual_complete: 98.2,
      forecast_complete: 76.7,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-05-08",
      baseline_complete: 94.2,
      actual_complete: 98.2,
      forecast_complete: 77.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-05-15",
      baseline_complete: 94.5,
      actual_complete: 98.2,
      forecast_complete: 78.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-05-22",
      baseline_complete: 94.7,
      actual_complete: 98.2,
      forecast_complete: 79.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-05-29",
      baseline_complete: 94.9,
      actual_complete: 98.2,
      forecast_complete: 80.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-06-05",
      baseline_complete: 95.1,
      actual_complete: 98.2,
      forecast_complete: 80.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-06-12",
      baseline_complete: 95.3,
      actual_complete: 98.8,
      forecast_complete: 81.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-06-19",
      baseline_complete: 95.5,
      actual_complete: 98.8,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-06-26",
      baseline_complete: 95.7,
      actual_complete: 100.0,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-07-03",
      baseline_complete: 95.8,
      actual_complete: 100.0,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-07-10",
      baseline_complete: 96.0,
      actual_complete: 100.0,
      forecast_complete: 84.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-07-17",
      baseline_complete: 96.2,
      actual_complete: 100.0,
      forecast_complete: 85.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-07-24",
      baseline_complete: 96.3,
      actual_complete: 100.0,
      forecast_complete: 85.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-07-31",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 86.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-08-07",
      baseline_complete: 96.6,
      actual_complete: 100.0,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-08-14",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 87.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-08-21",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-08-28",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 88.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-09-04",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-09-11",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 89.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-09-18",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-09-25",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-10-02",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 91.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-10-09",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-10-16",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-10-23",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-10-30",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-11-06",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-11-13",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-11-20",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-11-27",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-12-04",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-12-11",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-12-18",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2027-12-25",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-01-01",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-01-08",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-01-15",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-01-22",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 96.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-01-29",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-02-05",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-02-12",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-02-19",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-02-26",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-03-04",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-03-11",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-03-18",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-03-25",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-04-01",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-04-08",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-04-15",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-04-22",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "6ebb1a90-2435-1b34-fa18-3e42879e0157",
      reporting_date: "2028-04-26",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
  ],
  "58a1e0bd-0573-cbf4-5e24-87136a0a4dea": [
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-03-29",
      baseline_complete: 0.4,
      actual_complete: 6.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-04-05",
      baseline_complete: 0.4,
      actual_complete: 6.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-04-12",
      baseline_complete: 0.4,
      actual_complete: 6.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-04-19",
      baseline_complete: 0.4,
      actual_complete: 6.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-04-26",
      baseline_complete: 0.4,
      actual_complete: 6.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-05-03",
      baseline_complete: 0.4,
      actual_complete: 7.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-05-10",
      baseline_complete: 0.5,
      actual_complete: 7.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-05-17",
      baseline_complete: 0.5,
      actual_complete: 7.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-05-24",
      baseline_complete: 0.5,
      actual_complete: 7.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-05-31",
      baseline_complete: 0.5,
      actual_complete: 7.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-06-07",
      baseline_complete: 0.5,
      actual_complete: 7.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-06-14",
      baseline_complete: 0.6,
      actual_complete: 7.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-06-21",
      baseline_complete: 0.6,
      actual_complete: 7.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-06-28",
      baseline_complete: 0.6,
      actual_complete: 7.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-07-05",
      baseline_complete: 0.6,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-07-12",
      baseline_complete: 0.7,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-07-19",
      baseline_complete: 0.7,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-07-26",
      baseline_complete: 0.7,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-08-02",
      baseline_complete: 0.8,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-08-09",
      baseline_complete: 0.8,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-08-16",
      baseline_complete: 0.8,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-08-23",
      baseline_complete: 0.9,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-08-30",
      baseline_complete: 0.9,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-09-06",
      baseline_complete: 0.9,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-09-13",
      baseline_complete: 1.0,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-09-20",
      baseline_complete: 1.0,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-09-27",
      baseline_complete: 1.1,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-10-04",
      baseline_complete: 1.1,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-10-11",
      baseline_complete: 1.2,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-10-18",
      baseline_complete: 1.2,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-10-25",
      baseline_complete: 1.3,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-11-01",
      baseline_complete: 1.3,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-11-08",
      baseline_complete: 1.4,
      actual_complete: 8.2,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-11-15",
      baseline_complete: 1.4,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-11-22",
      baseline_complete: 1.5,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-11-29",
      baseline_complete: 1.6,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-12-06",
      baseline_complete: 1.6,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-12-13",
      baseline_complete: 1.7,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-12-20",
      baseline_complete: 1.8,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2023-12-27",
      baseline_complete: 1.9,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-01-03",
      baseline_complete: 1.9,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-01-10",
      baseline_complete: 2.0,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-01-17",
      baseline_complete: 2.1,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-01-24",
      baseline_complete: 2.2,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-01-31",
      baseline_complete: 2.3,
      actual_complete: 8.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-02-07",
      baseline_complete: 2.4,
      actual_complete: 8.5,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-02-14",
      baseline_complete: 2.5,
      actual_complete: 8.5,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-02-21",
      baseline_complete: 2.6,
      actual_complete: 8.8,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-02-28",
      baseline_complete: 2.7,
      actual_complete: 8.8,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-03-06",
      baseline_complete: 2.8,
      actual_complete: 8.8,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-03-13",
      baseline_complete: 2.9,
      actual_complete: 8.8,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-03-20",
      baseline_complete: 3.0,
      actual_complete: 8.8,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-03-27",
      baseline_complete: 3.2,
      actual_complete: 8.8,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-04-03",
      baseline_complete: 3.3,
      actual_complete: 8.8,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-04-10",
      baseline_complete: 3.4,
      actual_complete: 9.5,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-04-17",
      baseline_complete: 3.6,
      actual_complete: 9.5,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-04-24",
      baseline_complete: 3.7,
      actual_complete: 10.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-05-01",
      baseline_complete: 3.9,
      actual_complete: 10.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-05-08",
      baseline_complete: 4.1,
      actual_complete: 10.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-05-15",
      baseline_complete: 4.2,
      actual_complete: 10.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-05-22",
      baseline_complete: 4.4,
      actual_complete: 10.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-05-29",
      baseline_complete: 4.6,
      actual_complete: 10.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-06-05",
      baseline_complete: 4.8,
      actual_complete: 10.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-06-12",
      baseline_complete: 5.0,
      actual_complete: 10.3,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-06-19",
      baseline_complete: 5.2,
      actual_complete: 11.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-06-26",
      baseline_complete: 5.4,
      actual_complete: 11.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-07-03",
      baseline_complete: 5.6,
      actual_complete: 12.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-07-10",
      baseline_complete: 5.8,
      actual_complete: 12.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-07-17",
      baseline_complete: 6.1,
      actual_complete: 12.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-07-24",
      baseline_complete: 6.3,
      actual_complete: 12.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-07-31",
      baseline_complete: 6.6,
      actual_complete: 12.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-08-07",
      baseline_complete: 6.8,
      actual_complete: 12.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-08-14",
      baseline_complete: 7.1,
      actual_complete: 12.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-08-21",
      baseline_complete: 7.4,
      actual_complete: 12.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-08-28",
      baseline_complete: 7.7,
      actual_complete: 12.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-09-04",
      baseline_complete: 8.0,
      actual_complete: 12.9,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-09-11",
      baseline_complete: 8.3,
      actual_complete: 14.7,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-09-18",
      baseline_complete: 8.6,
      actual_complete: 14.7,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-09-25",
      baseline_complete: 9.0,
      actual_complete: 14.7,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-10-02",
      baseline_complete: 9.3,
      actual_complete: 14.7,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-10-09",
      baseline_complete: 9.7,
      actual_complete: 14.7,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-10-16",
      baseline_complete: 10.1,
      actual_complete: 14.7,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-10-23",
      baseline_complete: 10.5,
      actual_complete: 14.7,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-10-30",
      baseline_complete: 10.9,
      actual_complete: 15.3,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-11-06",
      baseline_complete: 11.3,
      actual_complete: 15.3,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-11-13",
      baseline_complete: 11.7,
      actual_complete: 16.5,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-11-20",
      baseline_complete: 12.2,
      actual_complete: 16.5,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-11-27",
      baseline_complete: 12.6,
      actual_complete: 17.7,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-12-04",
      baseline_complete: 13.1,
      actual_complete: 18.0,
      forecast_complete: 8.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-12-11",
      baseline_complete: 13.6,
      actual_complete: 18.6,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-12-18",
      baseline_complete: 14.1,
      actual_complete: 18.6,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2024-12-25",
      baseline_complete: 14.6,
      actual_complete: 20.2,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-01-01",
      baseline_complete: 15.2,
      actual_complete: 20.2,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-01-08",
      baseline_complete: 15.7,
      actual_complete: 20.2,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-01-15",
      baseline_complete: 16.3,
      actual_complete: 20.2,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-01-22",
      baseline_complete: 16.9,
      actual_complete: 20.2,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-01-29",
      baseline_complete: 17.5,
      actual_complete: 22.9,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-02-05",
      baseline_complete: 18.1,
      actual_complete: 22.9,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-02-12",
      baseline_complete: 18.7,
      actual_complete: 22.9,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-02-19",
      baseline_complete: 19.4,
      actual_complete: 22.9,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-02-26",
      baseline_complete: 20.1,
      actual_complete: 22.9,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-03-05",
      baseline_complete: 20.7,
      actual_complete: 26.0,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-03-12",
      baseline_complete: 21.4,
      actual_complete: 27.0,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-03-19",
      baseline_complete: 22.2,
      actual_complete: 27.0,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-03-26",
      baseline_complete: 22.9,
      actual_complete: 27.0,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-04-02",
      baseline_complete: 23.7,
      actual_complete: 27.0,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-04-09",
      baseline_complete: 24.4,
      actual_complete: 28.4,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-04-16",
      baseline_complete: 25.2,
      actual_complete: 29.4,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-04-23",
      baseline_complete: 26.0,
      actual_complete: 30.0,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-04-30",
      baseline_complete: 26.9,
      actual_complete: 30.0,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-05-07",
      baseline_complete: 27.7,
      actual_complete: 30.9,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-05-14",
      baseline_complete: 28.6,
      actual_complete: 34.8,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-05-21",
      baseline_complete: 29.4,
      actual_complete: 34.8,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-05-28",
      baseline_complete: 30.3,
      actual_complete: 35.5,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-06-04",
      baseline_complete: 31.2,
      actual_complete: 35.8,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-06-11",
      baseline_complete: 32.2,
      actual_complete: 35.8,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-06-18",
      baseline_complete: 33.1,
      actual_complete: 35.8,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-06-25",
      baseline_complete: 34.0,
      actual_complete: 38.7,
      forecast_complete: 19.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-07-02",
      baseline_complete: 35.0,
      actual_complete: 40.5,
      forecast_complete: 19.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-07-09",
      baseline_complete: 36.0,
      actual_complete: 42.0,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-07-16",
      baseline_complete: 36.9,
      actual_complete: 42.0,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-07-23",
      baseline_complete: 37.9,
      actual_complete: 43.1,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-07-30",
      baseline_complete: 38.9,
      actual_complete: 43.1,
      forecast_complete: 22.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-08-06",
      baseline_complete: 40.0,
      actual_complete: 43.1,
      forecast_complete: 23.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-08-13",
      baseline_complete: 41.0,
      actual_complete: 46.6,
      forecast_complete: 23.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-08-20",
      baseline_complete: 42.0,
      actual_complete: 46.6,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-08-27",
      baseline_complete: 43.0,
      actual_complete: 46.6,
      forecast_complete: 25.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-09-03",
      baseline_complete: 44.1,
      actual_complete: 47.4,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-09-10",
      baseline_complete: 45.1,
      actual_complete: 47.7,
      forecast_complete: 26.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-09-17",
      baseline_complete: 46.2,
      actual_complete: 48.7,
      forecast_complete: 27.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-09-24",
      baseline_complete: 47.2,
      actual_complete: 51.7,
      forecast_complete: 27.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-10-01",
      baseline_complete: 48.3,
      actual_complete: 51.7,
      forecast_complete: 28.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-10-08",
      baseline_complete: 49.4,
      actual_complete: 51.7,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-10-15",
      baseline_complete: 50.4,
      actual_complete: 54.6,
      forecast_complete: 30.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-10-22",
      baseline_complete: 51.5,
      actual_complete: 54.8,
      forecast_complete: 31.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-10-29",
      baseline_complete: 52.5,
      actual_complete: 57.3,
      forecast_complete: 31.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-11-05",
      baseline_complete: 53.6,
      actual_complete: 57.3,
      forecast_complete: 32.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-11-12",
      baseline_complete: 54.7,
      actual_complete: 57.6,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-11-19",
      baseline_complete: 55.7,
      actual_complete: 58.6,
      forecast_complete: 34.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-11-26",
      baseline_complete: 56.7,
      actual_complete: 59.9,
      forecast_complete: 34.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-12-03",
      baseline_complete: 57.8,
      actual_complete: 62.4,
      forecast_complete: 35.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-12-10",
      baseline_complete: 58.8,
      actual_complete: 62.4,
      forecast_complete: 36.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-12-17",
      baseline_complete: 59.8,
      actual_complete: 62.9,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-12-24",
      baseline_complete: 60.9,
      actual_complete: 64.4,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2025-12-31",
      baseline_complete: 61.9,
      actual_complete: 65.7,
      forecast_complete: 39.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-01-07",
      baseline_complete: 62.9,
      actual_complete: 68.0,
      forecast_complete: 39.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-01-14",
      baseline_complete: 63.8,
      actual_complete: 68.0,
      forecast_complete: 40.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-01-21",
      baseline_complete: 64.8,
      actual_complete: 68.0,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-01-28",
      baseline_complete: 65.8,
      actual_complete: 68.0,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-02-04",
      baseline_complete: 66.7,
      actual_complete: 70.0,
      forecast_complete: 43.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-02-11",
      baseline_complete: 67.7,
      actual_complete: 70.4,
      forecast_complete: 44.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-02-18",
      baseline_complete: 68.6,
      actual_complete: 71.2,
      forecast_complete: 44.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-02-25",
      baseline_complete: 69.5,
      actual_complete: 73.2,
      forecast_complete: 45.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-03-04",
      baseline_complete: 70.4,
      actual_complete: 73.7,
      forecast_complete: 46.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-03-11",
      baseline_complete: 71.3,
      actual_complete: 75.1,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-03-18",
      baseline_complete: 72.1,
      actual_complete: 75.1,
      forecast_complete: 48.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-03-25",
      baseline_complete: 73.0,
      actual_complete: 76.9,
      forecast_complete: 49.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-04-01",
      baseline_complete: 73.8,
      actual_complete: 76.9,
      forecast_complete: 49.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-04-08",
      baseline_complete: 74.6,
      actual_complete: 78.1,
      forecast_complete: 50.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-04-15",
      baseline_complete: 75.4,
      actual_complete: 78.1,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-04-22",
      baseline_complete: 76.2,
      actual_complete: 78.1,
      forecast_complete: 52.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-04-29",
      baseline_complete: 76.9,
      actual_complete: 79.7,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-05-06",
      baseline_complete: 77.7,
      actual_complete: 79.9,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-05-13",
      baseline_complete: 78.4,
      actual_complete: 80.9,
      forecast_complete: 54.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-05-20",
      baseline_complete: 79.1,
      actual_complete: 80.9,
      forecast_complete: 55.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-05-27",
      baseline_complete: 79.8,
      actual_complete: 82.3,
      forecast_complete: 56.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-06-03",
      baseline_complete: 80.5,
      actual_complete: 83.5,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-06-10",
      baseline_complete: 81.1,
      actual_complete: 86.3,
      forecast_complete: 57.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-06-17",
      baseline_complete: 81.8,
      actual_complete: 86.3,
      forecast_complete: 58.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-06-24",
      baseline_complete: 82.4,
      actual_complete: 86.3,
      forecast_complete: 59.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-07-01",
      baseline_complete: 83.0,
      actual_complete: 87.4,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-07-08",
      baseline_complete: 83.6,
      actual_complete: 88.3,
      forecast_complete: 60.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-07-15",
      baseline_complete: 84.2,
      actual_complete: 88.3,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-07-22",
      baseline_complete: 84.7,
      actual_complete: 88.5,
      forecast_complete: 62.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-07-29",
      baseline_complete: 85.3,
      actual_complete: 88.5,
      forecast_complete: 63.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-08-05",
      baseline_complete: 85.8,
      actual_complete: 90.1,
      forecast_complete: 63.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-08-12",
      baseline_complete: 86.3,
      actual_complete: 90.1,
      forecast_complete: 64.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-08-19",
      baseline_complete: 86.8,
      actual_complete: 90.1,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-08-26",
      baseline_complete: 87.3,
      actual_complete: 91.0,
      forecast_complete: 65.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-09-02",
      baseline_complete: 87.7,
      actual_complete: 91.0,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-09-09",
      baseline_complete: 88.2,
      actual_complete: 91.0,
      forecast_complete: 67.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-09-16",
      baseline_complete: 88.6,
      actual_complete: 91.0,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-09-23",
      baseline_complete: 89.0,
      actual_complete: 94.2,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-09-30",
      baseline_complete: 89.5,
      actual_complete: 94.2,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-10-07",
      baseline_complete: 89.8,
      actual_complete: 94.2,
      forecast_complete: 71.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-10-14",
      baseline_complete: 90.2,
      actual_complete: 94.2,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-10-21",
      baseline_complete: 90.6,
      actual_complete: 95.1,
      forecast_complete: 73.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-10-28",
      baseline_complete: 91.0,
      actual_complete: 95.1,
      forecast_complete: 74.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-11-04",
      baseline_complete: 91.3,
      actual_complete: 95.1,
      forecast_complete: 75.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-11-11",
      baseline_complete: 91.6,
      actual_complete: 95.1,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-11-18",
      baseline_complete: 91.9,
      actual_complete: 95.3,
      forecast_complete: 77.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-11-25",
      baseline_complete: 92.3,
      actual_complete: 95.6,
      forecast_complete: 78.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-12-02",
      baseline_complete: 92.6,
      actual_complete: 95.6,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-12-09",
      baseline_complete: 92.8,
      actual_complete: 95.6,
      forecast_complete: 80.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-12-16",
      baseline_complete: 93.1,
      actual_complete: 95.6,
      forecast_complete: 81.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-12-23",
      baseline_complete: 93.4,
      actual_complete: 95.6,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2026-12-30",
      baseline_complete: 93.6,
      actual_complete: 95.6,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-01-06",
      baseline_complete: 93.9,
      actual_complete: 96.6,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-01-13",
      baseline_complete: 94.1,
      actual_complete: 97.6,
      forecast_complete: 84.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-01-20",
      baseline_complete: 94.4,
      actual_complete: 97.6,
      forecast_complete: 85.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-01-27",
      baseline_complete: 94.6,
      actual_complete: 97.6,
      forecast_complete: 86.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-02-03",
      baseline_complete: 94.8,
      actual_complete: 98.6,
      forecast_complete: 86.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-02-10",
      baseline_complete: 95.0,
      actual_complete: 98.6,
      forecast_complete: 87.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-02-17",
      baseline_complete: 95.2,
      actual_complete: 98.6,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-02-24",
      baseline_complete: 95.4,
      actual_complete: 99.3,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-03-03",
      baseline_complete: 95.6,
      actual_complete: 99.3,
      forecast_complete: 89.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-03-10",
      baseline_complete: 95.7,
      actual_complete: 99.3,
      forecast_complete: 89.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-03-17",
      baseline_complete: 95.9,
      actual_complete: 99.6,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-03-24",
      baseline_complete: 96.1,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-03-31",
      baseline_complete: 96.2,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-04-07",
      baseline_complete: 96.4,
      actual_complete: 100.0,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-04-14",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-04-21",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-04-28",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-05-05",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-05-12",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-05-19",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-05-26",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-06-02",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-06-09",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-06-16",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-06-23",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-06-30",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-07-07",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-07-14",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-07-21",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-07-28",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-08-04",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-08-11",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-08-18",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-08-25",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-09-01",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-09-08",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-09-15",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-09-22",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-09-29",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-10-06",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-10-13",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-10-20",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-10-27",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "58a1e0bd-0573-cbf4-5e24-87136a0a4dea",
      reporting_date: "2027-10-29",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
  ],
  "e4a7e701-4ad9-e591-3968-6eb3d819f77d": [
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-02-11",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-02-18",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-02-25",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-03-03",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-03-10",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-03-17",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-03-24",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-03-31",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-04-07",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-04-14",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-04-21",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-04-28",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-05-05",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-05-12",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-05-19",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-05-26",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-06-02",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-06-09",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-06-16",
      baseline_complete: 1.7,
      actual_complete: 0.3,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-06-23",
      baseline_complete: 1.8,
      actual_complete: 0.3,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-06-30",
      baseline_complete: 1.9,
      actual_complete: 0.7,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-07-07",
      baseline_complete: 2.0,
      actual_complete: 0.7,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-07-14",
      baseline_complete: 2.1,
      actual_complete: 0.7,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-07-21",
      baseline_complete: 2.2,
      actual_complete: 0.7,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-07-28",
      baseline_complete: 2.3,
      actual_complete: 0.7,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-08-04",
      baseline_complete: 2.4,
      actual_complete: 0.7,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-08-11",
      baseline_complete: 2.5,
      actual_complete: 0.7,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-08-18",
      baseline_complete: 2.6,
      actual_complete: 0.7,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-08-25",
      baseline_complete: 2.7,
      actual_complete: 1.6,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-09-01",
      baseline_complete: 2.8,
      actual_complete: 1.6,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-09-08",
      baseline_complete: 3.0,
      actual_complete: 1.6,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-09-15",
      baseline_complete: 3.1,
      actual_complete: 1.6,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-09-22",
      baseline_complete: 3.3,
      actual_complete: 1.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-09-29",
      baseline_complete: 3.4,
      actual_complete: 1.6,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-10-06",
      baseline_complete: 3.6,
      actual_complete: 1.6,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-10-13",
      baseline_complete: 3.7,
      actual_complete: 1.6,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-10-20",
      baseline_complete: 3.9,
      actual_complete: 3.3,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-10-27",
      baseline_complete: 4.1,
      actual_complete: 3.3,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-11-03",
      baseline_complete: 4.3,
      actual_complete: 3.3,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-11-10",
      baseline_complete: 4.5,
      actual_complete: 3.3,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-11-17",
      baseline_complete: 4.7,
      actual_complete: 3.3,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-11-24",
      baseline_complete: 4.9,
      actual_complete: 3.3,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-12-01",
      baseline_complete: 5.1,
      actual_complete: 3.3,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-12-08",
      baseline_complete: 5.3,
      actual_complete: 3.5,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-12-15",
      baseline_complete: 5.6,
      actual_complete: 3.5,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-12-22",
      baseline_complete: 5.8,
      actual_complete: 4.5,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2024-12-29",
      baseline_complete: 6.1,
      actual_complete: 4.5,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-01-05",
      baseline_complete: 6.4,
      actual_complete: 6.1,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-01-12",
      baseline_complete: 6.7,
      actual_complete: 6.1,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-01-19",
      baseline_complete: 7.0,
      actual_complete: 6.1,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-01-26",
      baseline_complete: 7.3,
      actual_complete: 6.1,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-02-02",
      baseline_complete: 7.6,
      actual_complete: 7.3,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-02-09",
      baseline_complete: 7.9,
      actual_complete: 7.3,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-02-16",
      baseline_complete: 8.3,
      actual_complete: 7.4,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-02-23",
      baseline_complete: 8.6,
      actual_complete: 7.4,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-03-02",
      baseline_complete: 9.0,
      actual_complete: 7.5,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-03-09",
      baseline_complete: 9.4,
      actual_complete: 7.8,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-03-16",
      baseline_complete: 9.8,
      actual_complete: 8.8,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-03-23",
      baseline_complete: 10.3,
      actual_complete: 8.8,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-03-30",
      baseline_complete: 10.7,
      actual_complete: 8.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-04-06",
      baseline_complete: 11.2,
      actual_complete: 8.9,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-04-13",
      baseline_complete: 11.6,
      actual_complete: 9.1,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-04-20",
      baseline_complete: 12.1,
      actual_complete: 10.8,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-04-27",
      baseline_complete: 12.6,
      actual_complete: 10.8,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-05-04",
      baseline_complete: 13.2,
      actual_complete: 12.4,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-05-11",
      baseline_complete: 13.7,
      actual_complete: 13.4,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-05-18",
      baseline_complete: 14.3,
      actual_complete: 13.4,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-05-25",
      baseline_complete: 14.9,
      actual_complete: 13.4,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-06-01",
      baseline_complete: 15.5,
      actual_complete: 15.6,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-06-08",
      baseline_complete: 16.1,
      actual_complete: 15.6,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-06-15",
      baseline_complete: 16.7,
      actual_complete: 16.3,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-06-22",
      baseline_complete: 17.4,
      actual_complete: 16.9,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-06-29",
      baseline_complete: 18.1,
      actual_complete: 16.9,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-07-06",
      baseline_complete: 18.8,
      actual_complete: 17.2,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-07-13",
      baseline_complete: 19.5,
      actual_complete: 18.8,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-07-20",
      baseline_complete: 20.3,
      actual_complete: 20.7,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-07-27",
      baseline_complete: 21.0,
      actual_complete: 20.7,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-08-03",
      baseline_complete: 21.8,
      actual_complete: 20.7,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-08-10",
      baseline_complete: 22.6,
      actual_complete: 21.3,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-08-17",
      baseline_complete: 23.5,
      actual_complete: 21.3,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-08-24",
      baseline_complete: 24.3,
      actual_complete: 22.1,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-08-31",
      baseline_complete: 25.2,
      actual_complete: 23.6,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-09-07",
      baseline_complete: 26.1,
      actual_complete: 25.3,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-09-14",
      baseline_complete: 27.0,
      actual_complete: 25.3,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-09-21",
      baseline_complete: 27.9,
      actual_complete: 25.7,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-09-28",
      baseline_complete: 28.9,
      actual_complete: 26.8,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-10-05",
      baseline_complete: 29.9,
      actual_complete: 28.6,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-10-12",
      baseline_complete: 30.9,
      actual_complete: 30.4,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-10-19",
      baseline_complete: 31.9,
      actual_complete: 31.1,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-10-26",
      baseline_complete: 32.9,
      actual_complete: 31.8,
      forecast_complete: 16.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-11-02",
      baseline_complete: 33.9,
      actual_complete: 32.7,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-11-09",
      baseline_complete: 35.0,
      actual_complete: 34.7,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-11-16",
      baseline_complete: 36.1,
      actual_complete: 36.0,
      forecast_complete: 18.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-11-23",
      baseline_complete: 37.2,
      actual_complete: 37.1,
      forecast_complete: 19.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-11-30",
      baseline_complete: 38.3,
      actual_complete: 37.1,
      forecast_complete: 19.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-12-07",
      baseline_complete: 39.4,
      actual_complete: 39.0,
      forecast_complete: 20.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-12-14",
      baseline_complete: 40.5,
      actual_complete: 39.0,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-12-21",
      baseline_complete: 41.7,
      actual_complete: 39.7,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2025-12-28",
      baseline_complete: 42.8,
      actual_complete: 40.7,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-01-04",
      baseline_complete: 44.0,
      actual_complete: 44.0,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-01-11",
      baseline_complete: 45.1,
      actual_complete: 44.0,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-01-18",
      baseline_complete: 46.3,
      actual_complete: 44.4,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-01-25",
      baseline_complete: 47.5,
      actual_complete: 48.1,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-02-01",
      baseline_complete: 48.6,
      actual_complete: 49.5,
      forecast_complete: 26.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-02-08",
      baseline_complete: 49.8,
      actual_complete: 49.5,
      forecast_complete: 26.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-02-15",
      baseline_complete: 51.0,
      actual_complete: 51.0,
      forecast_complete: 27.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-02-22",
      baseline_complete: 52.2,
      actual_complete: 53.0,
      forecast_complete: 28.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-03-01",
      baseline_complete: 53.3,
      actual_complete: 53.0,
      forecast_complete: 29.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-03-08",
      baseline_complete: 54.5,
      actual_complete: 54.4,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-03-15",
      baseline_complete: 55.7,
      actual_complete: 56.8,
      forecast_complete: 30.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-03-22",
      baseline_complete: 56.8,
      actual_complete: 57.7,
      forecast_complete: 31.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-03-29",
      baseline_complete: 58.0,
      actual_complete: 57.7,
      forecast_complete: 32.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-04-05",
      baseline_complete: 59.1,
      actual_complete: 57.7,
      forecast_complete: 33.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-04-12",
      baseline_complete: 60.2,
      actual_complete: 60.9,
      forecast_complete: 34.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-04-19",
      baseline_complete: 61.4,
      actual_complete: 61.5,
      forecast_complete: 34.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-04-26",
      baseline_complete: 62.5,
      actual_complete: 61.5,
      forecast_complete: 35.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-05-03",
      baseline_complete: 63.6,
      actual_complete: 63.6,
      forecast_complete: 36.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-05-10",
      baseline_complete: 64.6,
      actual_complete: 63.6,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-05-17",
      baseline_complete: 65.7,
      actual_complete: 64.3,
      forecast_complete: 38.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-05-24",
      baseline_complete: 66.8,
      actual_complete: 66.2,
      forecast_complete: 39.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-05-31",
      baseline_complete: 67.8,
      actual_complete: 68.0,
      forecast_complete: 39.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-06-07",
      baseline_complete: 68.8,
      actual_complete: 68.0,
      forecast_complete: 40.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-06-14",
      baseline_complete: 69.8,
      actual_complete: 71.2,
      forecast_complete: 41.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-06-21",
      baseline_complete: 70.8,
      actual_complete: 71.2,
      forecast_complete: 42.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-06-28",
      baseline_complete: 71.7,
      actual_complete: 71.2,
      forecast_complete: 43.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-07-05",
      baseline_complete: 72.7,
      actual_complete: 71.3,
      forecast_complete: 44.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-07-12",
      baseline_complete: 73.6,
      actual_complete: 72.3,
      forecast_complete: 45.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-07-19",
      baseline_complete: 74.5,
      actual_complete: 74.2,
      forecast_complete: 45.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-07-26",
      baseline_complete: 75.4,
      actual_complete: 75.0,
      forecast_complete: 46.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-08-02",
      baseline_complete: 76.3,
      actual_complete: 75.2,
      forecast_complete: 47.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-08-09",
      baseline_complete: 77.1,
      actual_complete: 77.1,
      forecast_complete: 48.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-08-16",
      baseline_complete: 77.9,
      actual_complete: 77.2,
      forecast_complete: 49.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-08-23",
      baseline_complete: 78.7,
      actual_complete: 80.3,
      forecast_complete: 49.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-08-30",
      baseline_complete: 79.5,
      actual_complete: 80.3,
      forecast_complete: 50.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-09-06",
      baseline_complete: 80.2,
      actual_complete: 80.3,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-09-13",
      baseline_complete: 81.0,
      actual_complete: 80.3,
      forecast_complete: 52.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-09-20",
      baseline_complete: 81.7,
      actual_complete: 80.8,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-09-27",
      baseline_complete: 82.4,
      actual_complete: 82.4,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-10-04",
      baseline_complete: 83.1,
      actual_complete: 82.7,
      forecast_complete: 54.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-10-11",
      baseline_complete: 83.7,
      actual_complete: 84.5,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-10-18",
      baseline_complete: 84.3,
      actual_complete: 85.9,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-10-25",
      baseline_complete: 85.0,
      actual_complete: 85.9,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-11-01",
      baseline_complete: 85.5,
      actual_complete: 85.9,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-11-08",
      baseline_complete: 86.1,
      actual_complete: 86.8,
      forecast_complete: 58.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-11-15",
      baseline_complete: 86.7,
      actual_complete: 86.8,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-11-22",
      baseline_complete: 87.2,
      actual_complete: 86.8,
      forecast_complete: 59.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-11-29",
      baseline_complete: 87.7,
      actual_complete: 86.8,
      forecast_complete: 60.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-12-06",
      baseline_complete: 88.2,
      actual_complete: 88.7,
      forecast_complete: 61.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-12-13",
      baseline_complete: 88.7,
      actual_complete: 90.0,
      forecast_complete: 62.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-12-20",
      baseline_complete: 89.2,
      actual_complete: 90.0,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2026-12-27",
      baseline_complete: 89.6,
      actual_complete: 90.4,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-01-03",
      baseline_complete: 90.0,
      actual_complete: 90.4,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-01-10",
      baseline_complete: 90.4,
      actual_complete: 91.4,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-01-17",
      baseline_complete: 90.8,
      actual_complete: 92.1,
      forecast_complete: 65.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-01-24",
      baseline_complete: 91.2,
      actual_complete: 92.1,
      forecast_complete: 66.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-01-31",
      baseline_complete: 91.6,
      actual_complete: 92.1,
      forecast_complete: 66.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-02-07",
      baseline_complete: 92.0,
      actual_complete: 93.0,
      forecast_complete: 67.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-02-14",
      baseline_complete: 92.3,
      actual_complete: 93.0,
      forecast_complete: 68.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-02-21",
      baseline_complete: 92.6,
      actual_complete: 94.3,
      forecast_complete: 68.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-02-28",
      baseline_complete: 92.9,
      actual_complete: 94.3,
      forecast_complete: 69.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-03-07",
      baseline_complete: 93.2,
      actual_complete: 94.3,
      forecast_complete: 69.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-03-14",
      baseline_complete: 93.5,
      actual_complete: 94.3,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-03-21",
      baseline_complete: 93.8,
      actual_complete: 94.3,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-03-28",
      baseline_complete: 94.1,
      actual_complete: 95.8,
      forecast_complete: 71.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-04-04",
      baseline_complete: 94.3,
      actual_complete: 95.8,
      forecast_complete: 72.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-04-11",
      baseline_complete: 94.6,
      actual_complete: 96.4,
      forecast_complete: 73.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-04-18",
      baseline_complete: 94.8,
      actual_complete: 97.0,
      forecast_complete: 73.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-04-25",
      baseline_complete: 95.0,
      actual_complete: 97.0,
      forecast_complete: 74.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-05-02",
      baseline_complete: 95.3,
      actual_complete: 97.0,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-05-09",
      baseline_complete: 95.5,
      actual_complete: 97.0,
      forecast_complete: 75.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-05-16",
      baseline_complete: 95.7,
      actual_complete: 97.0,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-05-23",
      baseline_complete: 95.9,
      actual_complete: 97.0,
      forecast_complete: 77.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-05-30",
      baseline_complete: 96.0,
      actual_complete: 97.0,
      forecast_complete: 78.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-06-06",
      baseline_complete: 96.2,
      actual_complete: 98.9,
      forecast_complete: 79.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-06-13",
      baseline_complete: 96.4,
      actual_complete: 98.9,
      forecast_complete: 80.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-06-20",
      baseline_complete: 96.5,
      actual_complete: 98.9,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-06-27",
      baseline_complete: 96.7,
      actual_complete: 98.9,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-07-04",
      baseline_complete: 96.8,
      actual_complete: 98.9,
      forecast_complete: 82.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-07-11",
      baseline_complete: 97.0,
      actual_complete: 98.9,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-07-18",
      baseline_complete: 97.1,
      actual_complete: 99.0,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-07-25",
      baseline_complete: 97.2,
      actual_complete: 99.0,
      forecast_complete: 85.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-08-01",
      baseline_complete: 97.4,
      actual_complete: 99.0,
      forecast_complete: 86.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-08-08",
      baseline_complete: 97.5,
      actual_complete: 99.1,
      forecast_complete: 87.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-08-15",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-08-22",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-08-29",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-09-05",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 90.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-09-12",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-09-19",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-09-26",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-10-03",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-10-10",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-10-17",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-10-24",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-10-31",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-11-07",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-11-14",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-11-21",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-11-28",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-12-05",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-12-12",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-12-19",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2027-12-26",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-01-02",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-01-09",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-01-16",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-01-23",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-01-30",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-02-06",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-02-13",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-02-20",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-02-27",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-03-05",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-03-12",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-03-19",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-03-26",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-04-02",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-04-09",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-04-16",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-04-23",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-04-30",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-05-07",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-05-14",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-05-21",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-05-28",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-06-04",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e4a7e701-4ad9-e591-3968-6eb3d819f77d",
      reporting_date: "2028-06-11",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "193d96e9-e315-d2e9-ee74-9c5188d4b891": [
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-09-07",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-09-14",
      baseline_complete: 1.1,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-09-21",
      baseline_complete: 1.2,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-09-28",
      baseline_complete: 1.3,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-10-05",
      baseline_complete: 1.4,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-10-12",
      baseline_complete: 1.5,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-10-19",
      baseline_complete: 1.6,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-10-26",
      baseline_complete: 1.7,
      actual_complete: 2.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-11-02",
      baseline_complete: 1.9,
      actual_complete: 2.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-11-09",
      baseline_complete: 2.0,
      actual_complete: 2.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-11-16",
      baseline_complete: 2.1,
      actual_complete: 2.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-11-23",
      baseline_complete: 2.3,
      actual_complete: 2.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-11-30",
      baseline_complete: 2.4,
      actual_complete: 2.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-12-07",
      baseline_complete: 2.6,
      actual_complete: 2.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-12-14",
      baseline_complete: 2.8,
      actual_complete: 2.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-12-21",
      baseline_complete: 3.0,
      actual_complete: 2.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2025-12-28",
      baseline_complete: 3.2,
      actual_complete: 2.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-01-04",
      baseline_complete: 3.5,
      actual_complete: 2.9,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-01-11",
      baseline_complete: 3.7,
      actual_complete: 3.5,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-01-18",
      baseline_complete: 4.0,
      actual_complete: 4.4,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-01-25",
      baseline_complete: 4.2,
      actual_complete: 4.4,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-02-01",
      baseline_complete: 4.5,
      actual_complete: 4.4,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-02-08",
      baseline_complete: 4.8,
      actual_complete: 5.8,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-02-15",
      baseline_complete: 5.2,
      actual_complete: 5.8,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-02-22",
      baseline_complete: 5.5,
      actual_complete: 6.1,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-03-01",
      baseline_complete: 5.9,
      actual_complete: 6.1,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-03-08",
      baseline_complete: 6.3,
      actual_complete: 7.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-03-15",
      baseline_complete: 6.7,
      actual_complete: 7.8,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-03-22",
      baseline_complete: 7.2,
      actual_complete: 7.8,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-03-29",
      baseline_complete: 7.7,
      actual_complete: 7.8,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-04-05",
      baseline_complete: 8.2,
      actual_complete: 7.8,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-04-12",
      baseline_complete: 8.8,
      actual_complete: 8.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-04-19",
      baseline_complete: 9.3,
      actual_complete: 8.7,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-04-26",
      baseline_complete: 10.0,
      actual_complete: 10.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-05-03",
      baseline_complete: 10.6,
      actual_complete: 10.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-05-10",
      baseline_complete: 11.3,
      actual_complete: 11.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-05-17",
      baseline_complete: 12.0,
      actual_complete: 13.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-05-24",
      baseline_complete: 12.8,
      actual_complete: 13.0,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-05-31",
      baseline_complete: 13.6,
      actual_complete: 13.0,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-06-07",
      baseline_complete: 14.4,
      actual_complete: 13.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-06-14",
      baseline_complete: 15.3,
      actual_complete: 14.8,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-06-21",
      baseline_complete: 16.3,
      actual_complete: 14.8,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-06-28",
      baseline_complete: 17.3,
      actual_complete: 17.7,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-07-05",
      baseline_complete: 18.3,
      actual_complete: 18.8,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-07-12",
      baseline_complete: 19.4,
      actual_complete: 19.8,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-07-19",
      baseline_complete: 20.5,
      actual_complete: 20.9,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-07-26",
      baseline_complete: 21.7,
      actual_complete: 22.6,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-08-02",
      baseline_complete: 22.9,
      actual_complete: 22.6,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-08-09",
      baseline_complete: 24.2,
      actual_complete: 24.3,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-08-16",
      baseline_complete: 25.5,
      actual_complete: 24.7,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-08-23",
      baseline_complete: 26.8,
      actual_complete: 28.1,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-08-30",
      baseline_complete: 28.2,
      actual_complete: 29.7,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-09-06",
      baseline_complete: 29.7,
      actual_complete: 31.1,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-09-13",
      baseline_complete: 31.2,
      actual_complete: 31.1,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-09-20",
      baseline_complete: 32.7,
      actual_complete: 34.6,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-09-27",
      baseline_complete: 34.3,
      actual_complete: 34.6,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-10-04",
      baseline_complete: 35.9,
      actual_complete: 36.9,
      forecast_complete: 15.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-10-11",
      baseline_complete: 37.5,
      actual_complete: 38.2,
      forecast_complete: 17.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-10-18",
      baseline_complete: 39.2,
      actual_complete: 39.1,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-10-25",
      baseline_complete: 40.9,
      actual_complete: 39.8,
      forecast_complete: 19.2,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-11-01",
      baseline_complete: 42.6,
      actual_complete: 42.4,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-11-08",
      baseline_complete: 44.4,
      actual_complete: 45.9,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-11-15",
      baseline_complete: 46.1,
      actual_complete: 45.9,
      forecast_complete: 22.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-11-22",
      baseline_complete: 47.9,
      actual_complete: 46.3,
      forecast_complete: 24.2,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-11-29",
      baseline_complete: 49.6,
      actual_complete: 50.7,
      forecast_complete: 25.5,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-12-06",
      baseline_complete: 51.4,
      actual_complete: 52.7,
      forecast_complete: 26.8,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-12-13",
      baseline_complete: 53.2,
      actual_complete: 54.7,
      forecast_complete: 28.2,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-12-20",
      baseline_complete: 54.9,
      actual_complete: 56.9,
      forecast_complete: 29.6,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2026-12-27",
      baseline_complete: 56.7,
      actual_complete: 57.0,
      forecast_complete: 31.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-01-03",
      baseline_complete: 58.4,
      actual_complete: 58.0,
      forecast_complete: 32.5,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-01-10",
      baseline_complete: 60.1,
      actual_complete: 61.4,
      forecast_complete: 33.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-01-17",
      baseline_complete: 61.8,
      actual_complete: 61.4,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-01-24",
      baseline_complete: 63.4,
      actual_complete: 64.1,
      forecast_complete: 36.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-01-31",
      baseline_complete: 65.0,
      actual_complete: 65.9,
      forecast_complete: 38.3,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-02-07",
      baseline_complete: 66.6,
      actual_complete: 67.7,
      forecast_complete: 39.8,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-02-14",
      baseline_complete: 68.2,
      actual_complete: 68.5,
      forecast_complete: 41.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-02-21",
      baseline_complete: 69.7,
      actual_complete: 70.9,
      forecast_complete: 42.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-02-28",
      baseline_complete: 71.2,
      actual_complete: 72.4,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-03-07",
      baseline_complete: 72.6,
      actual_complete: 72.6,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-03-14",
      baseline_complete: 74.0,
      actual_complete: 74.3,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-03-21",
      baseline_complete: 75.3,
      actual_complete: 75.0,
      forecast_complete: 48.8,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-03-28",
      baseline_complete: 76.6,
      actual_complete: 76.6,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-04-04",
      baseline_complete: 77.8,
      actual_complete: 79.1,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-04-11",
      baseline_complete: 79.0,
      actual_complete: 79.1,
      forecast_complete: 53.2,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-04-18",
      baseline_complete: 80.2,
      actual_complete: 81.8,
      forecast_complete: 54.7,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-04-25",
      baseline_complete: 81.3,
      actual_complete: 82.2,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-05-02",
      baseline_complete: 82.3,
      actual_complete: 85.3,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-05-09",
      baseline_complete: 83.3,
      actual_complete: 85.3,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-05-16",
      baseline_complete: 84.3,
      actual_complete: 85.3,
      forecast_complete: 60.3,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-05-23",
      baseline_complete: 85.2,
      actual_complete: 86.1,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-05-30",
      baseline_complete: 86.1,
      actual_complete: 86.1,
      forecast_complete: 63.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-06-06",
      baseline_complete: 86.9,
      actual_complete: 86.1,
      forecast_complete: 64.3,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-06-13",
      baseline_complete: 87.7,
      actual_complete: 88.3,
      forecast_complete: 66.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-06-20",
      baseline_complete: 88.4,
      actual_complete: 91.9,
      forecast_complete: 68.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-06-27",
      baseline_complete: 89.1,
      actual_complete: 91.9,
      forecast_complete: 70.7,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-07-04",
      baseline_complete: 89.8,
      actual_complete: 91.9,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-07-11",
      baseline_complete: 90.4,
      actual_complete: 92.7,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-07-18",
      baseline_complete: 91.0,
      actual_complete: 92.7,
      forecast_complete: 76.8,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-07-25",
      baseline_complete: 91.6,
      actual_complete: 92.7,
      forecast_complete: 78.7,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-08-01",
      baseline_complete: 92.1,
      actual_complete: 92.7,
      forecast_complete: 80.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-08-08",
      baseline_complete: 92.6,
      actual_complete: 93.4,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-08-15",
      baseline_complete: 93.1,
      actual_complete: 93.4,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-08-22",
      baseline_complete: 93.5,
      actual_complete: 94.2,
      forecast_complete: 85.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-08-29",
      baseline_complete: 93.9,
      actual_complete: 94.2,
      forecast_complete: 86.5,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-09-05",
      baseline_complete: 94.3,
      actual_complete: 97.3,
      forecast_complete: 87.9,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-09-12",
      baseline_complete: 94.7,
      actual_complete: 97.3,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-09-19",
      baseline_complete: 95.0,
      actual_complete: 97.3,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-09-26",
      baseline_complete: 95.3,
      actual_complete: 98.3,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-10-03",
      baseline_complete: 95.7,
      actual_complete: 98.3,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-10-10",
      baseline_complete: 95.9,
      actual_complete: 98.3,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-10-17",
      baseline_complete: 96.2,
      actual_complete: 98.3,
      forecast_complete: 94.2,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-10-24",
      baseline_complete: 96.5,
      actual_complete: 98.3,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-10-31",
      baseline_complete: 96.7,
      actual_complete: 98.5,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-11-07",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-11-14",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-11-21",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-11-28",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-12-05",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-12-12",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-12-19",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2027-12-26",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2028-01-02",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "193d96e9-e315-d2e9-ee74-9c5188d4b891",
      reporting_date: "2028-01-07",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
  ],
  "206340dc-04d2-206f-a9b1-0e22803e4d09": [
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2023-12-30",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-01-06",
      baseline_complete: 0.9,
      actual_complete: 1.6,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-01-13",
      baseline_complete: 1.0,
      actual_complete: 2.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-01-20",
      baseline_complete: 1.0,
      actual_complete: 2.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-01-27",
      baseline_complete: 1.1,
      actual_complete: 2.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-02-03",
      baseline_complete: 1.1,
      actual_complete: 2.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-02-10",
      baseline_complete: 1.2,
      actual_complete: 2.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-02-17",
      baseline_complete: 1.2,
      actual_complete: 2.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-02-24",
      baseline_complete: 1.3,
      actual_complete: 2.5,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-03-02",
      baseline_complete: 1.3,
      actual_complete: 3.3,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-03-09",
      baseline_complete: 1.4,
      actual_complete: 3.3,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-03-16",
      baseline_complete: 1.5,
      actual_complete: 3.3,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-03-23",
      baseline_complete: 1.5,
      actual_complete: 3.3,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-03-30",
      baseline_complete: 1.6,
      actual_complete: 3.3,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-04-06",
      baseline_complete: 1.7,
      actual_complete: 3.3,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-04-13",
      baseline_complete: 1.8,
      actual_complete: 3.3,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-04-20",
      baseline_complete: 1.8,
      actual_complete: 3.3,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-04-27",
      baseline_complete: 1.9,
      actual_complete: 3.3,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-05-04",
      baseline_complete: 2.0,
      actual_complete: 3.3,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-05-11",
      baseline_complete: 2.1,
      actual_complete: 3.3,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-05-18",
      baseline_complete: 2.2,
      actual_complete: 3.3,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-05-25",
      baseline_complete: 2.3,
      actual_complete: 4.1,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-06-01",
      baseline_complete: 2.4,
      actual_complete: 4.1,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-06-08",
      baseline_complete: 2.6,
      actual_complete: 4.1,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-06-15",
      baseline_complete: 2.7,
      actual_complete: 4.6,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-06-22",
      baseline_complete: 2.8,
      actual_complete: 4.6,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-06-29",
      baseline_complete: 2.9,
      actual_complete: 4.6,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-07-06",
      baseline_complete: 3.1,
      actual_complete: 4.6,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-07-13",
      baseline_complete: 3.2,
      actual_complete: 4.6,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-07-20",
      baseline_complete: 3.4,
      actual_complete: 4.6,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-07-27",
      baseline_complete: 3.5,
      actual_complete: 4.6,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-08-03",
      baseline_complete: 3.7,
      actual_complete: 5.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-08-10",
      baseline_complete: 3.8,
      actual_complete: 5.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-08-17",
      baseline_complete: 4.0,
      actual_complete: 5.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-08-24",
      baseline_complete: 4.2,
      actual_complete: 5.7,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-08-31",
      baseline_complete: 4.4,
      actual_complete: 5.7,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-09-07",
      baseline_complete: 4.6,
      actual_complete: 6.9,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-09-14",
      baseline_complete: 4.8,
      actual_complete: 6.9,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-09-21",
      baseline_complete: 5.0,
      actual_complete: 6.9,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-09-28",
      baseline_complete: 5.3,
      actual_complete: 6.9,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-10-05",
      baseline_complete: 5.5,
      actual_complete: 6.9,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-10-12",
      baseline_complete: 5.8,
      actual_complete: 7.3,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-10-19",
      baseline_complete: 6.0,
      actual_complete: 7.3,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-10-26",
      baseline_complete: 6.3,
      actual_complete: 7.3,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-11-02",
      baseline_complete: 6.6,
      actual_complete: 7.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-11-09",
      baseline_complete: 6.9,
      actual_complete: 7.3,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-11-16",
      baseline_complete: 7.2,
      actual_complete: 7.3,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-11-23",
      baseline_complete: 7.5,
      actual_complete: 8.8,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-11-30",
      baseline_complete: 7.8,
      actual_complete: 9.1,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-12-07",
      baseline_complete: 8.2,
      actual_complete: 9.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-12-14",
      baseline_complete: 8.5,
      actual_complete: 9.4,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-12-21",
      baseline_complete: 8.9,
      actual_complete: 9.4,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2024-12-28",
      baseline_complete: 9.3,
      actual_complete: 9.4,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-01-04",
      baseline_complete: 9.7,
      actual_complete: 9.4,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-01-11",
      baseline_complete: 10.1,
      actual_complete: 10.9,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-01-18",
      baseline_complete: 10.5,
      actual_complete: 12.0,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-01-25",
      baseline_complete: 11.0,
      actual_complete: 12.5,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-02-01",
      baseline_complete: 11.5,
      actual_complete: 12.5,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-02-08",
      baseline_complete: 11.9,
      actual_complete: 12.6,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-02-15",
      baseline_complete: 12.4,
      actual_complete: 12.6,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-02-22",
      baseline_complete: 13.0,
      actual_complete: 12.6,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-03-01",
      baseline_complete: 13.5,
      actual_complete: 14.8,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-03-08",
      baseline_complete: 14.1,
      actual_complete: 14.8,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-03-15",
      baseline_complete: 14.6,
      actual_complete: 16.0,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-03-22",
      baseline_complete: 15.2,
      actual_complete: 17.0,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-03-29",
      baseline_complete: 15.9,
      actual_complete: 17.0,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-04-05",
      baseline_complete: 16.5,
      actual_complete: 17.0,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-04-12",
      baseline_complete: 17.2,
      actual_complete: 18.2,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-04-19",
      baseline_complete: 17.8,
      actual_complete: 18.8,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-04-26",
      baseline_complete: 18.5,
      actual_complete: 19.5,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-05-03",
      baseline_complete: 19.3,
      actual_complete: 21.1,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-05-10",
      baseline_complete: 20.0,
      actual_complete: 21.2,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-05-17",
      baseline_complete: 20.8,
      actual_complete: 22.6,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-05-24",
      baseline_complete: 21.5,
      actual_complete: 22.6,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-05-31",
      baseline_complete: 22.3,
      actual_complete: 23.0,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-06-07",
      baseline_complete: 23.2,
      actual_complete: 24.3,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-06-14",
      baseline_complete: 24.0,
      actual_complete: 26.5,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-06-21",
      baseline_complete: 24.9,
      actual_complete: 27.5,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-06-28",
      baseline_complete: 25.8,
      actual_complete: 27.5,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-07-05",
      baseline_complete: 26.7,
      actual_complete: 27.5,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-07-12",
      baseline_complete: 27.6,
      actual_complete: 29.6,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-07-19",
      baseline_complete: 28.6,
      actual_complete: 29.6,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-07-26",
      baseline_complete: 29.5,
      actual_complete: 31.5,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-08-02",
      baseline_complete: 30.5,
      actual_complete: 31.5,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-08-09",
      baseline_complete: 31.5,
      actual_complete: 31.5,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-08-16",
      baseline_complete: 32.5,
      actual_complete: 34.1,
      forecast_complete: 14.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-08-23",
      baseline_complete: 33.6,
      actual_complete: 34.1,
      forecast_complete: 15.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-08-30",
      baseline_complete: 34.6,
      actual_complete: 36.7,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-09-06",
      baseline_complete: 35.7,
      actual_complete: 36.7,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-09-13",
      baseline_complete: 36.8,
      actual_complete: 38.5,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-09-20",
      baseline_complete: 37.9,
      actual_complete: 40.4,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-09-27",
      baseline_complete: 39.0,
      actual_complete: 40.4,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-10-04",
      baseline_complete: 40.1,
      actual_complete: 42.1,
      forecast_complete: 18.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-10-11",
      baseline_complete: 41.3,
      actual_complete: 43.3,
      forecast_complete: 19.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-10-18",
      baseline_complete: 42.4,
      actual_complete: 45.1,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-10-25",
      baseline_complete: 43.6,
      actual_complete: 45.1,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-11-01",
      baseline_complete: 44.7,
      actual_complete: 45.1,
      forecast_complete: 20.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-11-08",
      baseline_complete: 45.9,
      actual_complete: 47.8,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-11-15",
      baseline_complete: 47.1,
      actual_complete: 49.4,
      forecast_complete: 22.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-11-22",
      baseline_complete: 48.2,
      actual_complete: 49.4,
      forecast_complete: 23.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-11-29",
      baseline_complete: 49.4,
      actual_complete: 49.4,
      forecast_complete: 23.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-12-06",
      baseline_complete: 50.6,
      actual_complete: 49.5,
      forecast_complete: 24.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-12-13",
      baseline_complete: 51.8,
      actual_complete: 50.9,
      forecast_complete: 25.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-12-20",
      baseline_complete: 52.9,
      actual_complete: 51.6,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2025-12-27",
      baseline_complete: 54.1,
      actual_complete: 54.4,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-01-03",
      baseline_complete: 55.3,
      actual_complete: 56.7,
      forecast_complete: 27.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-01-10",
      baseline_complete: 56.4,
      actual_complete: 56.7,
      forecast_complete: 28.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-01-17",
      baseline_complete: 57.6,
      actual_complete: 56.7,
      forecast_complete: 28.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-01-24",
      baseline_complete: 58.7,
      actual_complete: 60.4,
      forecast_complete: 29.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-01-31",
      baseline_complete: 59.8,
      actual_complete: 60.4,
      forecast_complete: 30.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-02-07",
      baseline_complete: 61.0,
      actual_complete: 61.4,
      forecast_complete: 31.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-02-14",
      baseline_complete: 62.1,
      actual_complete: 62.7,
      forecast_complete: 32.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-02-21",
      baseline_complete: 63.2,
      actual_complete: 64.2,
      forecast_complete: 32.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-02-28",
      baseline_complete: 64.3,
      actual_complete: 67.3,
      forecast_complete: 33.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-03-07",
      baseline_complete: 65.3,
      actual_complete: 67.3,
      forecast_complete: 34.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-03-14",
      baseline_complete: 66.4,
      actual_complete: 68.2,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-03-21",
      baseline_complete: 67.4,
      actual_complete: 69.9,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-03-28",
      baseline_complete: 68.5,
      actual_complete: 69.9,
      forecast_complete: 36.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-04-04",
      baseline_complete: 69.5,
      actual_complete: 70.4,
      forecast_complete: 37.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-04-11",
      baseline_complete: 70.5,
      actual_complete: 70.7,
      forecast_complete: 38.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-04-18",
      baseline_complete: 71.4,
      actual_complete: 72.6,
      forecast_complete: 39.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-04-25",
      baseline_complete: 72.4,
      actual_complete: 72.6,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-05-02",
      baseline_complete: 73.3,
      actual_complete: 75.6,
      forecast_complete: 40.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-05-09",
      baseline_complete: 74.2,
      actual_complete: 76.1,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-05-16",
      baseline_complete: 75.1,
      actual_complete: 76.1,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-05-23",
      baseline_complete: 76.0,
      actual_complete: 76.1,
      forecast_complete: 43.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-05-30",
      baseline_complete: 76.8,
      actual_complete: 76.1,
      forecast_complete: 43.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-06-06",
      baseline_complete: 77.6,
      actual_complete: 77.1,
      forecast_complete: 44.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-06-13",
      baseline_complete: 78.5,
      actual_complete: 80.4,
      forecast_complete: 45.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-06-20",
      baseline_complete: 79.2,
      actual_complete: 80.4,
      forecast_complete: 46.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-06-27",
      baseline_complete: 80.0,
      actual_complete: 82.2,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-07-04",
      baseline_complete: 80.7,
      actual_complete: 82.2,
      forecast_complete: 47.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-07-11",
      baseline_complete: 81.5,
      actual_complete: 82.2,
      forecast_complete: 48.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-07-18",
      baseline_complete: 82.2,
      actual_complete: 82.3,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-07-25",
      baseline_complete: 82.8,
      actual_complete: 82.3,
      forecast_complete: 49.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-08-01",
      baseline_complete: 83.5,
      actual_complete: 85.5,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-08-08",
      baseline_complete: 84.1,
      actual_complete: 85.5,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-08-15",
      baseline_complete: 84.8,
      actual_complete: 85.8,
      forecast_complete: 52.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-08-22",
      baseline_complete: 85.3,
      actual_complete: 85.8,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-08-29",
      baseline_complete: 85.9,
      actual_complete: 85.8,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-09-05",
      baseline_complete: 86.5,
      actual_complete: 88.1,
      forecast_complete: 54.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-09-12",
      baseline_complete: 87.0,
      actual_complete: 88.4,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-09-19",
      baseline_complete: 87.5,
      actual_complete: 89.4,
      forecast_complete: 55.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-09-26",
      baseline_complete: 88.0,
      actual_complete: 90.5,
      forecast_complete: 56.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-10-03",
      baseline_complete: 88.5,
      actual_complete: 91.3,
      forecast_complete: 56.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-10-10",
      baseline_complete: 89.0,
      actual_complete: 91.3,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-10-17",
      baseline_complete: 89.5,
      actual_complete: 91.4,
      forecast_complete: 58.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-10-24",
      baseline_complete: 89.9,
      actual_complete: 92.3,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-10-31",
      baseline_complete: 90.3,
      actual_complete: 92.3,
      forecast_complete: 59.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-11-07",
      baseline_complete: 90.7,
      actual_complete: 92.3,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-11-14",
      baseline_complete: 91.1,
      actual_complete: 92.3,
      forecast_complete: 60.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-11-21",
      baseline_complete: 91.5,
      actual_complete: 92.6,
      forecast_complete: 61.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-11-28",
      baseline_complete: 91.8,
      actual_complete: 92.6,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-12-05",
      baseline_complete: 92.2,
      actual_complete: 94.0,
      forecast_complete: 62.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-12-12",
      baseline_complete: 92.5,
      actual_complete: 94.8,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-12-19",
      baseline_complete: 92.8,
      actual_complete: 94.8,
      forecast_complete: 63.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2026-12-26",
      baseline_complete: 93.1,
      actual_complete: 94.8,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-01-02",
      baseline_complete: 93.4,
      actual_complete: 95.2,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-01-09",
      baseline_complete: 93.7,
      actual_complete: 95.2,
      forecast_complete: 65.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-01-16",
      baseline_complete: 94.0,
      actual_complete: 95.2,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-01-23",
      baseline_complete: 94.2,
      actual_complete: 95.2,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-01-30",
      baseline_complete: 94.5,
      actual_complete: 95.2,
      forecast_complete: 67.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-02-06",
      baseline_complete: 94.7,
      actual_complete: 96.3,
      forecast_complete: 68.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-02-13",
      baseline_complete: 95.0,
      actual_complete: 97.1,
      forecast_complete: 68.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-02-20",
      baseline_complete: 95.2,
      actual_complete: 97.1,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-02-27",
      baseline_complete: 95.4,
      actual_complete: 97.1,
      forecast_complete: 69.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-03-06",
      baseline_complete: 95.6,
      actual_complete: 97.2,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-03-13",
      baseline_complete: 95.8,
      actual_complete: 97.2,
      forecast_complete: 70.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-03-20",
      baseline_complete: 96.0,
      actual_complete: 98.8,
      forecast_complete: 71.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-03-27",
      baseline_complete: 96.2,
      actual_complete: 98.8,
      forecast_complete: 71.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-04-03",
      baseline_complete: 96.3,
      actual_complete: 98.8,
      forecast_complete: 72.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-04-10",
      baseline_complete: 96.5,
      actual_complete: 98.8,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-04-17",
      baseline_complete: 96.6,
      actual_complete: 98.8,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-04-24",
      baseline_complete: 96.8,
      actual_complete: 98.8,
      forecast_complete: 73.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-05-01",
      baseline_complete: 96.9,
      actual_complete: 98.8,
      forecast_complete: 74.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-05-08",
      baseline_complete: 97.1,
      actual_complete: 98.8,
      forecast_complete: 75.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-05-15",
      baseline_complete: 97.2,
      actual_complete: 98.8,
      forecast_complete: 75.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-05-22",
      baseline_complete: 97.3,
      actual_complete: 98.8,
      forecast_complete: 76.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-05-29",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 77.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-06-05",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 78.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-06-12",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 79.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-06-19",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 80.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-06-26",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 80.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-07-03",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 81.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-07-10",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 82.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-07-17",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 83.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-07-24",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 84.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-07-31",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 84.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-08-07",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 85.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-08-14",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 86.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-08-21",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 87.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-08-28",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 87.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-09-04",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 88.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-09-11",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-09-18",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 89.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-09-25",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-10-02",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-10-09",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-10-16",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-10-23",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-10-30",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-11-06",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-11-13",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-11-20",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-11-27",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-12-04",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-12-11",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-12-18",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2027-12-25",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-01-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-01-08",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-01-15",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-01-22",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-01-29",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-02-05",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-02-12",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-02-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-02-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-03-04",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-03-11",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-03-18",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-03-25",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-04-01",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-04-08",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-04-15",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-04-22",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-04-29",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-05-06",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-05-13",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-05-20",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-05-27",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-06-03",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-06-10",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-06-17",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-06-24",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "206340dc-04d2-206f-a9b1-0e22803e4d09",
      reporting_date: "2028-06-30",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb": [
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-01-20",
      baseline_complete: 1.5,
      actual_complete: 0.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-01-27",
      baseline_complete: 1.6,
      actual_complete: 0.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-02-03",
      baseline_complete: 1.7,
      actual_complete: 0.4,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-02-10",
      baseline_complete: 1.7,
      actual_complete: 0.9,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-02-17",
      baseline_complete: 1.8,
      actual_complete: 0.9,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-02-24",
      baseline_complete: 1.9,
      actual_complete: 0.9,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-03-03",
      baseline_complete: 2.0,
      actual_complete: 0.9,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-03-10",
      baseline_complete: 2.0,
      actual_complete: 0.9,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-03-17",
      baseline_complete: 2.1,
      actual_complete: 0.9,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-03-24",
      baseline_complete: 2.2,
      actual_complete: 0.9,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-03-31",
      baseline_complete: 2.3,
      actual_complete: 1.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-04-07",
      baseline_complete: 2.4,
      actual_complete: 1.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-04-14",
      baseline_complete: 2.5,
      actual_complete: 1.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-04-21",
      baseline_complete: 2.6,
      actual_complete: 1.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-04-28",
      baseline_complete: 2.7,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-05-05",
      baseline_complete: 2.8,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-05-12",
      baseline_complete: 3.0,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-05-19",
      baseline_complete: 3.1,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-05-26",
      baseline_complete: 3.2,
      actual_complete: 2.4,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-06-02",
      baseline_complete: 3.4,
      actual_complete: 2.4,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-06-09",
      baseline_complete: 3.5,
      actual_complete: 2.4,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-06-16",
      baseline_complete: 3.6,
      actual_complete: 2.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-06-23",
      baseline_complete: 3.8,
      actual_complete: 2.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-06-30",
      baseline_complete: 3.9,
      actual_complete: 2.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-07-07",
      baseline_complete: 4.1,
      actual_complete: 2.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-07-14",
      baseline_complete: 4.3,
      actual_complete: 2.8,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-07-21",
      baseline_complete: 4.5,
      actual_complete: 2.8,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-07-28",
      baseline_complete: 4.6,
      actual_complete: 2.8,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-08-04",
      baseline_complete: 4.8,
      actual_complete: 2.8,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-08-11",
      baseline_complete: 5.0,
      actual_complete: 3.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-08-18",
      baseline_complete: 5.3,
      actual_complete: 4.6,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-08-25",
      baseline_complete: 5.5,
      actual_complete: 4.6,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-09-01",
      baseline_complete: 5.7,
      actual_complete: 5.3,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-09-08",
      baseline_complete: 5.9,
      actual_complete: 5.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-09-15",
      baseline_complete: 6.2,
      actual_complete: 5.3,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-09-22",
      baseline_complete: 6.4,
      actual_complete: 6.1,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-09-29",
      baseline_complete: 6.7,
      actual_complete: 6.1,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-10-06",
      baseline_complete: 7.0,
      actual_complete: 6.1,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-10-13",
      baseline_complete: 7.2,
      actual_complete: 6.4,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-10-20",
      baseline_complete: 7.5,
      actual_complete: 6.4,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-10-27",
      baseline_complete: 7.8,
      actual_complete: 7.9,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-11-03",
      baseline_complete: 8.1,
      actual_complete: 7.9,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-11-10",
      baseline_complete: 8.5,
      actual_complete: 7.9,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-11-17",
      baseline_complete: 8.8,
      actual_complete: 8.5,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-11-24",
      baseline_complete: 9.1,
      actual_complete: 8.5,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-12-01",
      baseline_complete: 9.5,
      actual_complete: 8.8,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-12-08",
      baseline_complete: 9.9,
      actual_complete: 9.1,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-12-15",
      baseline_complete: 10.3,
      actual_complete: 10.2,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-12-22",
      baseline_complete: 10.7,
      actual_complete: 10.4,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2023-12-29",
      baseline_complete: 11.1,
      actual_complete: 10.4,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-01-05",
      baseline_complete: 11.5,
      actual_complete: 10.4,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-01-12",
      baseline_complete: 11.9,
      actual_complete: 10.4,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-01-19",
      baseline_complete: 12.4,
      actual_complete: 11.9,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-01-26",
      baseline_complete: 12.9,
      actual_complete: 13.0,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-02-02",
      baseline_complete: 13.4,
      actual_complete: 13.0,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-02-09",
      baseline_complete: 13.9,
      actual_complete: 13.0,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-02-16",
      baseline_complete: 14.4,
      actual_complete: 14.3,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-02-23",
      baseline_complete: 14.9,
      actual_complete: 14.3,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-03-01",
      baseline_complete: 15.5,
      actual_complete: 15.2,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-03-08",
      baseline_complete: 16.0,
      actual_complete: 16.1,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-03-15",
      baseline_complete: 16.6,
      actual_complete: 16.1,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-03-22",
      baseline_complete: 17.2,
      actual_complete: 17.4,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-03-29",
      baseline_complete: 17.8,
      actual_complete: 17.4,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-04-05",
      baseline_complete: 18.5,
      actual_complete: 17.6,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-04-12",
      baseline_complete: 19.1,
      actual_complete: 19.0,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-04-19",
      baseline_complete: 19.8,
      actual_complete: 19.9,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-04-26",
      baseline_complete: 20.5,
      actual_complete: 19.9,
      forecast_complete: 9.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-05-03",
      baseline_complete: 21.2,
      actual_complete: 19.9,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-05-10",
      baseline_complete: 21.9,
      actual_complete: 20.8,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-05-17",
      baseline_complete: 22.6,
      actual_complete: 21.7,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-05-24",
      baseline_complete: 23.4,
      actual_complete: 24.2,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-05-31",
      baseline_complete: 24.1,
      actual_complete: 24.2,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-06-07",
      baseline_complete: 24.9,
      actual_complete: 25.2,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-06-14",
      baseline_complete: 25.7,
      actual_complete: 26.4,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-06-21",
      baseline_complete: 26.6,
      actual_complete: 26.4,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-06-28",
      baseline_complete: 27.4,
      actual_complete: 27.0,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-07-05",
      baseline_complete: 28.3,
      actual_complete: 27.4,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-07-12",
      baseline_complete: 29.1,
      actual_complete: 27.8,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-07-19",
      baseline_complete: 30.0,
      actual_complete: 30.3,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-07-26",
      baseline_complete: 30.9,
      actual_complete: 30.3,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-08-02",
      baseline_complete: 31.8,
      actual_complete: 30.5,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-08-09",
      baseline_complete: 32.8,
      actual_complete: 32.5,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-08-16",
      baseline_complete: 33.7,
      actual_complete: 32.7,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-08-23",
      baseline_complete: 34.7,
      actual_complete: 33.3,
      forecast_complete: 16.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-08-30",
      baseline_complete: 35.7,
      actual_complete: 34.8,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-09-06",
      baseline_complete: 36.6,
      actual_complete: 37.0,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-09-13",
      baseline_complete: 37.6,
      actual_complete: 38.0,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-09-20",
      baseline_complete: 38.6,
      actual_complete: 38.2,
      forecast_complete: 19.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-09-27",
      baseline_complete: 39.7,
      actual_complete: 40.0,
      forecast_complete: 19.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-10-04",
      baseline_complete: 40.7,
      actual_complete: 40.3,
      forecast_complete: 20.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-10-11",
      baseline_complete: 41.7,
      actual_complete: 41.8,
      forecast_complete: 20.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-10-18",
      baseline_complete: 42.7,
      actual_complete: 42.0,
      forecast_complete: 21.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-10-25",
      baseline_complete: 43.8,
      actual_complete: 42.7,
      forecast_complete: 22.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-11-01",
      baseline_complete: 44.8,
      actual_complete: 44.2,
      forecast_complete: 22.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-11-08",
      baseline_complete: 45.9,
      actual_complete: 46.0,
      forecast_complete: 23.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-11-15",
      baseline_complete: 47.0,
      actual_complete: 46.0,
      forecast_complete: 24.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-11-22",
      baseline_complete: 48.0,
      actual_complete: 46.6,
      forecast_complete: 24.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-11-29",
      baseline_complete: 49.1,
      actual_complete: 49.2,
      forecast_complete: 25.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-12-06",
      baseline_complete: 50.2,
      actual_complete: 49.2,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-12-13",
      baseline_complete: 51.2,
      actual_complete: 52.3,
      forecast_complete: 27.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-12-20",
      baseline_complete: 52.3,
      actual_complete: 52.4,
      forecast_complete: 27.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2024-12-27",
      baseline_complete: 53.4,
      actual_complete: 54.1,
      forecast_complete: 28.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-01-03",
      baseline_complete: 54.4,
      actual_complete: 54.1,
      forecast_complete: 29.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-01-10",
      baseline_complete: 55.5,
      actual_complete: 56.6,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-01-17",
      baseline_complete: 56.5,
      actual_complete: 57.2,
      forecast_complete: 30.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-01-24",
      baseline_complete: 57.6,
      actual_complete: 58.6,
      forecast_complete: 31.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-01-31",
      baseline_complete: 58.6,
      actual_complete: 59.2,
      forecast_complete: 32.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-02-07",
      baseline_complete: 59.6,
      actual_complete: 59.2,
      forecast_complete: 33.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-02-14",
      baseline_complete: 60.7,
      actual_complete: 61.7,
      forecast_complete: 33.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-02-21",
      baseline_complete: 61.7,
      actual_complete: 61.7,
      forecast_complete: 34.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-02-28",
      baseline_complete: 62.7,
      actual_complete: 62.5,
      forecast_complete: 35.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-03-07",
      baseline_complete: 63.7,
      actual_complete: 63.4,
      forecast_complete: 36.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-03-14",
      baseline_complete: 64.6,
      actual_complete: 63.6,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-03-21",
      baseline_complete: 65.6,
      actual_complete: 66.2,
      forecast_complete: 37.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-03-28",
      baseline_complete: 66.6,
      actual_complete: 66.5,
      forecast_complete: 38.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-04-04",
      baseline_complete: 67.5,
      actual_complete: 67.1,
      forecast_complete: 39.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-04-11",
      baseline_complete: 68.4,
      actual_complete: 69.0,
      forecast_complete: 40.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-04-18",
      baseline_complete: 69.3,
      actual_complete: 69.7,
      forecast_complete: 41.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-04-25",
      baseline_complete: 70.2,
      actual_complete: 69.7,
      forecast_complete: 42.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-05-02",
      baseline_complete: 71.1,
      actual_complete: 71.6,
      forecast_complete: 42.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-05-09",
      baseline_complete: 72.0,
      actual_complete: 73.0,
      forecast_complete: 43.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-05-16",
      baseline_complete: 72.8,
      actual_complete: 73.0,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-05-23",
      baseline_complete: 73.7,
      actual_complete: 74.7,
      forecast_complete: 45.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-05-30",
      baseline_complete: 74.5,
      actual_complete: 74.9,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-06-06",
      baseline_complete: 75.3,
      actual_complete: 75.3,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-06-13",
      baseline_complete: 76.1,
      actual_complete: 76.8,
      forecast_complete: 47.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-06-20",
      baseline_complete: 76.9,
      actual_complete: 78.1,
      forecast_complete: 48.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-06-27",
      baseline_complete: 77.6,
      actual_complete: 79.1,
      forecast_complete: 49.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-07-04",
      baseline_complete: 78.3,
      actual_complete: 79.1,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-07-11",
      baseline_complete: 79.1,
      actual_complete: 79.1,
      forecast_complete: 50.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-07-18",
      baseline_complete: 79.7,
      actual_complete: 79.2,
      forecast_complete: 51.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-07-25",
      baseline_complete: 80.4,
      actual_complete: 80.2,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-08-01",
      baseline_complete: 81.1,
      actual_complete: 81.9,
      forecast_complete: 53.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-08-08",
      baseline_complete: 81.7,
      actual_complete: 81.9,
      forecast_complete: 54.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-08-15",
      baseline_complete: 82.4,
      actual_complete: 81.9,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-08-22",
      baseline_complete: 83.0,
      actual_complete: 83.0,
      forecast_complete: 55.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-08-29",
      baseline_complete: 83.6,
      actual_complete: 84.0,
      forecast_complete: 56.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-09-05",
      baseline_complete: 84.1,
      actual_complete: 84.0,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-09-12",
      baseline_complete: 84.7,
      actual_complete: 86.6,
      forecast_complete: 57.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-09-19",
      baseline_complete: 85.3,
      actual_complete: 86.6,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-09-26",
      baseline_complete: 85.8,
      actual_complete: 86.6,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-10-03",
      baseline_complete: 86.3,
      actual_complete: 86.6,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-10-10",
      baseline_complete: 86.8,
      actual_complete: 87.1,
      forecast_complete: 60.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-10-17",
      baseline_complete: 87.3,
      actual_complete: 89.3,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-10-24",
      baseline_complete: 87.7,
      actual_complete: 89.4,
      forecast_complete: 62.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-10-31",
      baseline_complete: 88.2,
      actual_complete: 89.4,
      forecast_complete: 63.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-11-07",
      baseline_complete: 88.6,
      actual_complete: 89.6,
      forecast_complete: 63.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-11-14",
      baseline_complete: 89.0,
      actual_complete: 89.6,
      forecast_complete: 64.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-11-21",
      baseline_complete: 89.5,
      actual_complete: 89.9,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-11-28",
      baseline_complete: 89.9,
      actual_complete: 92.1,
      forecast_complete: 65.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-12-05",
      baseline_complete: 90.2,
      actual_complete: 92.1,
      forecast_complete: 66.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-12-12",
      baseline_complete: 90.6,
      actual_complete: 92.1,
      forecast_complete: 67.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-12-19",
      baseline_complete: 91.0,
      actual_complete: 93.4,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2025-12-26",
      baseline_complete: 91.3,
      actual_complete: 93.4,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-01-02",
      baseline_complete: 91.6,
      actual_complete: 93.4,
      forecast_complete: 69.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-01-09",
      baseline_complete: 92.0,
      actual_complete: 93.8,
      forecast_complete: 69.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-01-16",
      baseline_complete: 92.3,
      actual_complete: 93.8,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-01-23",
      baseline_complete: 92.6,
      actual_complete: 93.8,
      forecast_complete: 71.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-01-30",
      baseline_complete: 92.9,
      actual_complete: 93.8,
      forecast_complete: 71.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-02-06",
      baseline_complete: 93.1,
      actual_complete: 93.9,
      forecast_complete: 72.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-02-13",
      baseline_complete: 93.4,
      actual_complete: 94.3,
      forecast_complete: 73.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-02-20",
      baseline_complete: 93.7,
      actual_complete: 94.8,
      forecast_complete: 74.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-02-27",
      baseline_complete: 93.9,
      actual_complete: 94.8,
      forecast_complete: 75.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-03-06",
      baseline_complete: 94.1,
      actual_complete: 95.5,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-03-13",
      baseline_complete: 94.4,
      actual_complete: 96.7,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-03-20",
      baseline_complete: 94.6,
      actual_complete: 96.7,
      forecast_complete: 78.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-03-27",
      baseline_complete: 94.8,
      actual_complete: 96.7,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-04-03",
      baseline_complete: 95.0,
      actual_complete: 97.5,
      forecast_complete: 80.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-04-10",
      baseline_complete: 95.2,
      actual_complete: 97.5,
      forecast_complete: 81.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-04-17",
      baseline_complete: 95.4,
      actual_complete: 97.7,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-04-24",
      baseline_complete: 95.6,
      actual_complete: 97.7,
      forecast_complete: 83.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-05-01",
      baseline_complete: 95.8,
      actual_complete: 97.7,
      forecast_complete: 84.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-05-08",
      baseline_complete: 95.9,
      actual_complete: 97.7,
      forecast_complete: 85.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-05-15",
      baseline_complete: 96.1,
      actual_complete: 97.7,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-05-22",
      baseline_complete: 96.3,
      actual_complete: 97.7,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-05-29",
      baseline_complete: 96.4,
      actual_complete: 97.7,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-06-05",
      baseline_complete: 96.6,
      actual_complete: 98.9,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-06-12",
      baseline_complete: 96.7,
      actual_complete: 99.2,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-06-19",
      baseline_complete: 96.8,
      actual_complete: 99.2,
      forecast_complete: 90.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-06-26",
      baseline_complete: 97.0,
      actual_complete: 99.2,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-07-03",
      baseline_complete: 97.1,
      actual_complete: 99.2,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-07-10",
      baseline_complete: 97.2,
      actual_complete: 99.5,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-07-17",
      baseline_complete: 97.3,
      actual_complete: 99.5,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-07-24",
      baseline_complete: 97.4,
      actual_complete: 99.5,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-07-31",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-08-07",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-08-14",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-08-21",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-08-28",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-09-04",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-09-11",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-09-18",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-09-25",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-10-02",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-10-09",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-10-16",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-10-23",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-10-30",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-11-06",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-11-13",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-11-20",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-11-27",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-12-04",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-12-11",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-12-18",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2026-12-25",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2027-01-01",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2027-01-08",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2027-01-15",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2027-01-22",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2027-01-29",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2027-02-05",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2027-02-12",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2027-02-19",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "ec82ccd1-c3b6-e4e3-8d7d-c9d6d3e13feb",
      reporting_date: "2027-02-20",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "f37303b1-1037-0ee7-cef3-338328b1cf0b": [
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-06-13",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-06-20",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-06-27",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-07-04",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-07-11",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-07-18",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-07-25",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-08-01",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-08-08",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-08-15",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-08-22",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-08-29",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-09-05",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-09-12",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-09-19",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-09-26",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-10-03",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-10-10",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-10-17",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-10-24",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-10-31",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-11-07",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-11-14",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-11-21",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-11-28",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-12-05",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-12-12",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-12-19",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2023-12-26",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-01-02",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-01-09",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-01-16",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-01-23",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-01-30",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-02-06",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-02-13",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-02-20",
      baseline_complete: 3.3,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-02-27",
      baseline_complete: 3.5,
      actual_complete: 0.0,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-03-05",
      baseline_complete: 3.7,
      actual_complete: 0.4,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-03-12",
      baseline_complete: 4.0,
      actual_complete: 0.4,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-03-19",
      baseline_complete: 4.2,
      actual_complete: 0.4,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-03-26",
      baseline_complete: 4.5,
      actual_complete: 0.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-04-02",
      baseline_complete: 4.7,
      actual_complete: 0.4,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-04-09",
      baseline_complete: 5.0,
      actual_complete: 0.4,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-04-16",
      baseline_complete: 5.3,
      actual_complete: 0.4,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-04-23",
      baseline_complete: 5.7,
      actual_complete: 0.4,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-04-30",
      baseline_complete: 6.0,
      actual_complete: 0.4,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-05-07",
      baseline_complete: 6.4,
      actual_complete: 0.4,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-05-14",
      baseline_complete: 6.8,
      actual_complete: 0.4,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-05-21",
      baseline_complete: 7.2,
      actual_complete: 3.8,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-05-28",
      baseline_complete: 7.6,
      actual_complete: 3.8,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-06-04",
      baseline_complete: 8.0,
      actual_complete: 3.8,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-06-11",
      baseline_complete: 8.5,
      actual_complete: 4.3,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-06-18",
      baseline_complete: 9.0,
      actual_complete: 4.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-06-25",
      baseline_complete: 9.5,
      actual_complete: 5.8,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-07-02",
      baseline_complete: 10.1,
      actual_complete: 5.8,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-07-09",
      baseline_complete: 10.7,
      actual_complete: 8.2,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-07-16",
      baseline_complete: 11.3,
      actual_complete: 8.2,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-07-23",
      baseline_complete: 11.9,
      actual_complete: 8.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-07-30",
      baseline_complete: 12.6,
      actual_complete: 8.2,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-08-06",
      baseline_complete: 13.3,
      actual_complete: 8.2,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-08-13",
      baseline_complete: 14.1,
      actual_complete: 8.2,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-08-20",
      baseline_complete: 14.8,
      actual_complete: 8.5,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-08-27",
      baseline_complete: 15.7,
      actual_complete: 11.5,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-09-03",
      baseline_complete: 16.5,
      actual_complete: 11.5,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-09-10",
      baseline_complete: 17.4,
      actual_complete: 11.5,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-09-17",
      baseline_complete: 18.3,
      actual_complete: 11.5,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-09-24",
      baseline_complete: 19.3,
      actual_complete: 17.4,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-10-01",
      baseline_complete: 20.3,
      actual_complete: 17.4,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-10-08",
      baseline_complete: 21.3,
      actual_complete: 17.6,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-10-15",
      baseline_complete: 22.4,
      actual_complete: 20.9,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-10-22",
      baseline_complete: 23.5,
      actual_complete: 20.9,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-10-29",
      baseline_complete: 24.6,
      actual_complete: 20.9,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-11-05",
      baseline_complete: 25.8,
      actual_complete: 22.7,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-11-12",
      baseline_complete: 27.0,
      actual_complete: 22.7,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-11-19",
      baseline_complete: 28.3,
      actual_complete: 23.4,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-11-26",
      baseline_complete: 29.6,
      actual_complete: 23.4,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-12-03",
      baseline_complete: 30.9,
      actual_complete: 25.7,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-12-10",
      baseline_complete: 32.2,
      actual_complete: 28.6,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-12-17",
      baseline_complete: 33.6,
      actual_complete: 30.1,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-12-24",
      baseline_complete: 35.0,
      actual_complete: 30.1,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2024-12-31",
      baseline_complete: 36.5,
      actual_complete: 33.7,
      forecast_complete: 14.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-01-07",
      baseline_complete: 38.0,
      actual_complete: 35.4,
      forecast_complete: 14.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-01-14",
      baseline_complete: 39.4,
      actual_complete: 35.4,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-01-21",
      baseline_complete: 40.9,
      actual_complete: 35.4,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-01-28",
      baseline_complete: 42.5,
      actual_complete: 38.4,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-02-04",
      baseline_complete: 44.0,
      actual_complete: 38.4,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-02-11",
      baseline_complete: 45.6,
      actual_complete: 38.4,
      forecast_complete: 18.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-02-18",
      baseline_complete: 47.1,
      actual_complete: 44.4,
      forecast_complete: 19.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-02-25",
      baseline_complete: 48.7,
      actual_complete: 44.4,
      forecast_complete: 20.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-03-04",
      baseline_complete: 50.3,
      actual_complete: 48.0,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-03-11",
      baseline_complete: 51.8,
      actual_complete: 49.6,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-03-18",
      baseline_complete: 53.4,
      actual_complete: 49.6,
      forecast_complete: 23.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-03-25",
      baseline_complete: 54.9,
      actual_complete: 51.7,
      forecast_complete: 24.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-04-01",
      baseline_complete: 56.5,
      actual_complete: 52.5,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-04-08",
      baseline_complete: 58.0,
      actual_complete: 53.9,
      forecast_complete: 26.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-04-15",
      baseline_complete: 59.6,
      actual_complete: 53.9,
      forecast_complete: 27.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-04-22",
      baseline_complete: 61.1,
      actual_complete: 56.1,
      forecast_complete: 28.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-04-29",
      baseline_complete: 62.5,
      actual_complete: 61.4,
      forecast_complete: 29.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-05-06",
      baseline_complete: 64.0,
      actual_complete: 61.4,
      forecast_complete: 30.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-05-13",
      baseline_complete: 65.4,
      actual_complete: 64.1,
      forecast_complete: 31.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-05-20",
      baseline_complete: 66.8,
      actual_complete: 64.1,
      forecast_complete: 32.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-05-27",
      baseline_complete: 68.2,
      actual_complete: 67.1,
      forecast_complete: 33.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-06-03",
      baseline_complete: 69.5,
      actual_complete: 67.1,
      forecast_complete: 34.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-06-10",
      baseline_complete: 70.9,
      actual_complete: 67.1,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-06-17",
      baseline_complete: 72.1,
      actual_complete: 70.8,
      forecast_complete: 36.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-06-24",
      baseline_complete: 73.4,
      actual_complete: 70.8,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-07-01",
      baseline_complete: 74.6,
      actual_complete: 70.8,
      forecast_complete: 38.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-07-08",
      baseline_complete: 75.8,
      actual_complete: 71.0,
      forecast_complete: 39.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-07-15",
      baseline_complete: 76.9,
      actual_complete: 76.2,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-07-22",
      baseline_complete: 78.0,
      actual_complete: 77.0,
      forecast_complete: 41.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-07-29",
      baseline_complete: 79.0,
      actual_complete: 77.0,
      forecast_complete: 41.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-08-05",
      baseline_complete: 80.1,
      actual_complete: 77.9,
      forecast_complete: 42.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-08-12",
      baseline_complete: 81.1,
      actual_complete: 78.4,
      forecast_complete: 43.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-08-19",
      baseline_complete: 82.0,
      actual_complete: 83.0,
      forecast_complete: 44.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-08-26",
      baseline_complete: 82.9,
      actual_complete: 83.0,
      forecast_complete: 45.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-09-02",
      baseline_complete: 83.8,
      actual_complete: 83.0,
      forecast_complete: 46.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-09-09",
      baseline_complete: 84.6,
      actual_complete: 83.0,
      forecast_complete: 47.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-09-16",
      baseline_complete: 85.4,
      actual_complete: 83.0,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-09-23",
      baseline_complete: 86.2,
      actual_complete: 83.0,
      forecast_complete: 49.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-09-30",
      baseline_complete: 86.9,
      actual_complete: 87.1,
      forecast_complete: 49.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-10-07",
      baseline_complete: 87.6,
      actual_complete: 87.1,
      forecast_complete: 50.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-10-14",
      baseline_complete: 88.3,
      actual_complete: 87.1,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-10-21",
      baseline_complete: 88.9,
      actual_complete: 87.1,
      forecast_complete: 52.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-10-28",
      baseline_complete: 89.5,
      actual_complete: 89.6,
      forecast_complete: 53.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-11-04",
      baseline_complete: 90.1,
      actual_complete: 89.6,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-11-11",
      baseline_complete: 90.6,
      actual_complete: 89.6,
      forecast_complete: 54.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-11-18",
      baseline_complete: 91.1,
      actual_complete: 89.6,
      forecast_complete: 55.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-11-25",
      baseline_complete: 91.6,
      actual_complete: 90.3,
      forecast_complete: 56.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-12-02",
      baseline_complete: 92.1,
      actual_complete: 91.2,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-12-09",
      baseline_complete: 92.6,
      actual_complete: 91.2,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-12-16",
      baseline_complete: 93.0,
      actual_complete: 94.1,
      forecast_complete: 58.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-12-23",
      baseline_complete: 93.4,
      actual_complete: 94.1,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2025-12-30",
      baseline_complete: 93.8,
      actual_complete: 94.1,
      forecast_complete: 59.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-01-06",
      baseline_complete: 94.1,
      actual_complete: 94.1,
      forecast_complete: 60.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-01-13",
      baseline_complete: 94.4,
      actual_complete: 94.1,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-01-20",
      baseline_complete: 94.8,
      actual_complete: 94.1,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-01-27",
      baseline_complete: 95.1,
      actual_complete: 95.0,
      forecast_complete: 62.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-02-03",
      baseline_complete: 95.4,
      actual_complete: 96.0,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-02-10",
      baseline_complete: 95.6,
      actual_complete: 96.0,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-02-17",
      baseline_complete: 95.9,
      actual_complete: 96.8,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-02-24",
      baseline_complete: 96.1,
      actual_complete: 96.8,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-03-03",
      baseline_complete: 96.3,
      actual_complete: 96.8,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-03-10",
      baseline_complete: 96.6,
      actual_complete: 96.8,
      forecast_complete: 66.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-03-17",
      baseline_complete: 96.8,
      actual_complete: 96.8,
      forecast_complete: 66.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-03-24",
      baseline_complete: 97.0,
      actual_complete: 96.8,
      forecast_complete: 67.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-03-31",
      baseline_complete: 97.1,
      actual_complete: 97.7,
      forecast_complete: 67.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-04-07",
      baseline_complete: 97.3,
      actual_complete: 98.6,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-04-14",
      baseline_complete: 97.5,
      actual_complete: 98.6,
      forecast_complete: 68.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-04-21",
      baseline_complete: 97.6,
      actual_complete: 98.7,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-04-28",
      baseline_complete: 97.8,
      actual_complete: 98.7,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-05-05",
      baseline_complete: 97.9,
      actual_complete: 98.7,
      forecast_complete: 70.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-05-12",
      baseline_complete: 98.0,
      actual_complete: 98.7,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-05-19",
      baseline_complete: 98.1,
      actual_complete: 98.7,
      forecast_complete: 71.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-05-26",
      baseline_complete: 98.2,
      actual_complete: 99.3,
      forecast_complete: 72.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-06-02",
      baseline_complete: 98.4,
      actual_complete: 99.9,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-06-09",
      baseline_complete: 98.4,
      actual_complete: 99.9,
      forecast_complete: 73.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-06-16",
      baseline_complete: 98.5,
      actual_complete: 99.9,
      forecast_complete: 74.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-06-23",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 75.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-06-30",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 76.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-07-07",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 77.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-07-14",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-07-21",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 78.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-07-28",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 79.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-08-04",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 80.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-08-11",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 81.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-08-18",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 82.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-08-25",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 83.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-09-01",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 84.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-09-08",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 84.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-09-15",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-09-22",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 86.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-09-29",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-10-06",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-10-13",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-10-20",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 89.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-10-27",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 89.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-11-03",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-11-10",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 90.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-11-17",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-11-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-12-01",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-12-08",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-12-15",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-12-22",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2026-12-29",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-01-05",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-01-12",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-01-19",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-01-26",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-02-02",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-02-09",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-02-16",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-02-23",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-03-02",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-03-09",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-03-16",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-03-23",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-03-30",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-04-06",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-04-13",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-04-20",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-04-27",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-05-04",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-05-11",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-05-18",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-05-25",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-06-01",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-06-08",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "f37303b1-1037-0ee7-cef3-338328b1cf0b",
      reporting_date: "2027-06-13",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
  ],
  "35ecd415-3f11-96e1-f83e-feff3274d7f1": [
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-03-19",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-03-26",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-04-02",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-04-09",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-04-16",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-04-23",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-04-30",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-05-07",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-05-14",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-05-21",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-05-28",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-06-04",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-06-11",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-06-18",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-06-25",
      baseline_complete: 0.9,
      actual_complete: 0.1,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-07-02",
      baseline_complete: 1.0,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-07-09",
      baseline_complete: 1.0,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-07-16",
      baseline_complete: 1.1,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-07-23",
      baseline_complete: 1.1,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-07-30",
      baseline_complete: 1.2,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-08-06",
      baseline_complete: 1.2,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-08-13",
      baseline_complete: 1.3,
      actual_complete: 0.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-08-20",
      baseline_complete: 1.3,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-08-27",
      baseline_complete: 1.4,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-09-03",
      baseline_complete: 1.5,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-09-10",
      baseline_complete: 1.6,
      actual_complete: 0.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-09-17",
      baseline_complete: 1.6,
      actual_complete: 1.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-09-24",
      baseline_complete: 1.7,
      actual_complete: 1.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-10-01",
      baseline_complete: 1.8,
      actual_complete: 1.2,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-10-08",
      baseline_complete: 1.9,
      actual_complete: 1.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-10-15",
      baseline_complete: 2.0,
      actual_complete: 1.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-10-22",
      baseline_complete: 2.1,
      actual_complete: 1.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-10-29",
      baseline_complete: 2.2,
      actual_complete: 1.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-11-05",
      baseline_complete: 2.3,
      actual_complete: 1.9,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-11-12",
      baseline_complete: 2.4,
      actual_complete: 2.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-11-19",
      baseline_complete: 2.5,
      actual_complete: 2.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-11-26",
      baseline_complete: 2.7,
      actual_complete: 2.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-12-03",
      baseline_complete: 2.8,
      actual_complete: 2.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-12-10",
      baseline_complete: 2.9,
      actual_complete: 2.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-12-17",
      baseline_complete: 3.1,
      actual_complete: 2.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-12-24",
      baseline_complete: 3.2,
      actual_complete: 2.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2024-12-31",
      baseline_complete: 3.4,
      actual_complete: 2.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-01-07",
      baseline_complete: 3.6,
      actual_complete: 3.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-01-14",
      baseline_complete: 3.7,
      actual_complete: 3.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-01-21",
      baseline_complete: 3.9,
      actual_complete: 3.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-01-28",
      baseline_complete: 4.1,
      actual_complete: 3.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-02-04",
      baseline_complete: 4.3,
      actual_complete: 3.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-02-11",
      baseline_complete: 4.5,
      actual_complete: 4.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-02-18",
      baseline_complete: 4.7,
      actual_complete: 4.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-02-25",
      baseline_complete: 5.0,
      actual_complete: 4.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-03-04",
      baseline_complete: 5.2,
      actual_complete: 4.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-03-11",
      baseline_complete: 5.5,
      actual_complete: 5.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-03-18",
      baseline_complete: 5.7,
      actual_complete: 5.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-03-25",
      baseline_complete: 6.0,
      actual_complete: 5.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-04-01",
      baseline_complete: 6.3,
      actual_complete: 5.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-04-08",
      baseline_complete: 6.6,
      actual_complete: 6.2,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-04-15",
      baseline_complete: 6.9,
      actual_complete: 6.8,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-04-22",
      baseline_complete: 7.2,
      actual_complete: 6.8,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-04-29",
      baseline_complete: 7.6,
      actual_complete: 6.8,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-05-06",
      baseline_complete: 7.9,
      actual_complete: 7.8,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-05-13",
      baseline_complete: 8.3,
      actual_complete: 8.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-05-20",
      baseline_complete: 8.7,
      actual_complete: 8.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-05-27",
      baseline_complete: 9.1,
      actual_complete: 8.2,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-06-03",
      baseline_complete: 9.5,
      actual_complete: 8.8,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-06-10",
      baseline_complete: 10.0,
      actual_complete: 8.8,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-06-17",
      baseline_complete: 10.4,
      actual_complete: 9.4,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-06-24",
      baseline_complete: 10.9,
      actual_complete: 9.6,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-07-01",
      baseline_complete: 11.4,
      actual_complete: 10.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-07-08",
      baseline_complete: 11.9,
      actual_complete: 10.8,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-07-15",
      baseline_complete: 12.4,
      actual_complete: 11.8,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-07-22",
      baseline_complete: 13.0,
      actual_complete: 12.4,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-07-29",
      baseline_complete: 13.6,
      actual_complete: 13.3,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-08-05",
      baseline_complete: 14.2,
      actual_complete: 13.6,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-08-12",
      baseline_complete: 14.8,
      actual_complete: 14.1,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-08-19",
      baseline_complete: 15.4,
      actual_complete: 14.1,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-08-26",
      baseline_complete: 16.1,
      actual_complete: 16.3,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-09-02",
      baseline_complete: 16.8,
      actual_complete: 16.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-09-09",
      baseline_complete: 17.5,
      actual_complete: 17.5,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-09-16",
      baseline_complete: 18.2,
      actual_complete: 17.5,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-09-23",
      baseline_complete: 18.9,
      actual_complete: 17.7,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-09-30",
      baseline_complete: 19.7,
      actual_complete: 20.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-10-07",
      baseline_complete: 20.5,
      actual_complete: 20.4,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-10-14",
      baseline_complete: 21.3,
      actual_complete: 20.9,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-10-21",
      baseline_complete: 22.2,
      actual_complete: 20.9,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-10-28",
      baseline_complete: 23.1,
      actual_complete: 23.2,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-11-04",
      baseline_complete: 24.0,
      actual_complete: 23.8,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-11-11",
      baseline_complete: 24.9,
      actual_complete: 23.8,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-11-18",
      baseline_complete: 25.8,
      actual_complete: 26.2,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-11-25",
      baseline_complete: 26.8,
      actual_complete: 26.2,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-12-02",
      baseline_complete: 27.8,
      actual_complete: 27.8,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-12-09",
      baseline_complete: 28.8,
      actual_complete: 28.0,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-12-16",
      baseline_complete: 29.8,
      actual_complete: 28.2,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-12-23",
      baseline_complete: 30.9,
      actual_complete: 31.0,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2025-12-30",
      baseline_complete: 32.0,
      actual_complete: 31.0,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-01-06",
      baseline_complete: 33.1,
      actual_complete: 32.9,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-01-13",
      baseline_complete: 34.2,
      actual_complete: 34.4,
      forecast_complete: 12.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-01-20",
      baseline_complete: 35.3,
      actual_complete: 35.5,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-01-27",
      baseline_complete: 36.4,
      actual_complete: 36.3,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-02-03",
      baseline_complete: 37.6,
      actual_complete: 36.9,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-02-10",
      baseline_complete: 38.8,
      actual_complete: 38.7,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-02-17",
      baseline_complete: 40.0,
      actual_complete: 39.2,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-02-24",
      baseline_complete: 41.2,
      actual_complete: 40.7,
      forecast_complete: 15.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-03-03",
      baseline_complete: 42.4,
      actual_complete: 42.0,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-03-10",
      baseline_complete: 43.6,
      actual_complete: 43.1,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-03-17",
      baseline_complete: 44.8,
      actual_complete: 43.7,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-03-24",
      baseline_complete: 46.1,
      actual_complete: 47.0,
      forecast_complete: 18.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-03-31",
      baseline_complete: 47.3,
      actual_complete: 47.5,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-04-07",
      baseline_complete: 48.6,
      actual_complete: 48.7,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-04-14",
      baseline_complete: 49.8,
      actual_complete: 50.2,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-04-21",
      baseline_complete: 51.1,
      actual_complete: 50.2,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-04-28",
      baseline_complete: 52.3,
      actual_complete: 53.6,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-05-05",
      baseline_complete: 53.5,
      actual_complete: 54.3,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-05-12",
      baseline_complete: 54.8,
      actual_complete: 54.7,
      forecast_complete: 24.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-05-19",
      baseline_complete: 56.0,
      actual_complete: 55.5,
      forecast_complete: 24.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-05-26",
      baseline_complete: 57.2,
      actual_complete: 57.3,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-06-02",
      baseline_complete: 58.5,
      actual_complete: 57.7,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-06-09",
      baseline_complete: 59.7,
      actual_complete: 59.8,
      forecast_complete: 27.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-06-16",
      baseline_complete: 60.9,
      actual_complete: 60.0,
      forecast_complete: 28.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-06-23",
      baseline_complete: 62.0,
      actual_complete: 62.5,
      forecast_complete: 29.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-06-30",
      baseline_complete: 63.2,
      actual_complete: 62.6,
      forecast_complete: 29.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-07-07",
      baseline_complete: 64.4,
      actual_complete: 64.2,
      forecast_complete: 30.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-07-14",
      baseline_complete: 65.5,
      actual_complete: 64.5,
      forecast_complete: 31.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-07-21",
      baseline_complete: 66.6,
      actual_complete: 65.7,
      forecast_complete: 32.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-07-28",
      baseline_complete: 67.7,
      actual_complete: 67.5,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-08-04",
      baseline_complete: 68.8,
      actual_complete: 69.4,
      forecast_complete: 34.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-08-11",
      baseline_complete: 69.9,
      actual_complete: 70.7,
      forecast_complete: 35.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-08-18",
      baseline_complete: 70.9,
      actual_complete: 70.7,
      forecast_complete: 35.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-08-25",
      baseline_complete: 71.9,
      actual_complete: 70.7,
      forecast_complete: 36.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-09-01",
      baseline_complete: 72.9,
      actual_complete: 72.9,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-09-08",
      baseline_complete: 73.9,
      actual_complete: 73.6,
      forecast_complete: 38.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-09-15",
      baseline_complete: 74.8,
      actual_complete: 74.7,
      forecast_complete: 39.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-09-22",
      baseline_complete: 75.8,
      actual_complete: 75.7,
      forecast_complete: 39.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-09-29",
      baseline_complete: 76.7,
      actual_complete: 78.0,
      forecast_complete: 40.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-10-06",
      baseline_complete: 77.5,
      actual_complete: 78.0,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-10-13",
      baseline_complete: 78.4,
      actual_complete: 78.0,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-10-20",
      baseline_complete: 79.2,
      actual_complete: 79.3,
      forecast_complete: 43.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-10-27",
      baseline_complete: 80.0,
      actual_complete: 79.9,
      forecast_complete: 43.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-11-03",
      baseline_complete: 80.8,
      actual_complete: 79.9,
      forecast_complete: 44.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-11-10",
      baseline_complete: 81.6,
      actual_complete: 81.8,
      forecast_complete: 45.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-11-17",
      baseline_complete: 82.3,
      actual_complete: 83.1,
      forecast_complete: 46.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-11-24",
      baseline_complete: 83.0,
      actual_complete: 83.1,
      forecast_complete: 47.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-12-01",
      baseline_complete: 83.7,
      actual_complete: 84.0,
      forecast_complete: 47.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-12-08",
      baseline_complete: 84.4,
      actual_complete: 84.1,
      forecast_complete: 48.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-12-15",
      baseline_complete: 85.0,
      actual_complete: 85.4,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-12-22",
      baseline_complete: 85.7,
      actual_complete: 85.4,
      forecast_complete: 50.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2026-12-29",
      baseline_complete: 86.3,
      actual_complete: 87.3,
      forecast_complete: 50.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-01-05",
      baseline_complete: 86.8,
      actual_complete: 88.8,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-01-12",
      baseline_complete: 87.4,
      actual_complete: 88.8,
      forecast_complete: 52.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-01-19",
      baseline_complete: 87.9,
      actual_complete: 88.8,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-01-26",
      baseline_complete: 88.5,
      actual_complete: 88.8,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-02-02",
      baseline_complete: 89.0,
      actual_complete: 89.4,
      forecast_complete: 54.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-02-09",
      baseline_complete: 89.4,
      actual_complete: 89.4,
      forecast_complete: 54.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-02-16",
      baseline_complete: 89.9,
      actual_complete: 89.4,
      forecast_complete: 55.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-02-23",
      baseline_complete: 90.3,
      actual_complete: 91.5,
      forecast_complete: 56.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-03-02",
      baseline_complete: 90.8,
      actual_complete: 92.6,
      forecast_complete: 56.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-03-09",
      baseline_complete: 91.2,
      actual_complete: 92.6,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-03-16",
      baseline_complete: 91.6,
      actual_complete: 92.6,
      forecast_complete: 58.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-03-23",
      baseline_complete: 92.0,
      actual_complete: 92.6,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-03-30",
      baseline_complete: 92.3,
      actual_complete: 93.5,
      forecast_complete: 59.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-04-06",
      baseline_complete: 92.7,
      actual_complete: 93.5,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-04-13",
      baseline_complete: 93.0,
      actual_complete: 94.8,
      forecast_complete: 60.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-04-20",
      baseline_complete: 93.3,
      actual_complete: 95.2,
      forecast_complete: 61.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-04-27",
      baseline_complete: 93.6,
      actual_complete: 95.2,
      forecast_complete: 61.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-05-04",
      baseline_complete: 93.9,
      actual_complete: 95.9,
      forecast_complete: 62.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-05-11",
      baseline_complete: 94.2,
      actual_complete: 95.9,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-05-18",
      baseline_complete: 94.5,
      actual_complete: 95.9,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-05-25",
      baseline_complete: 94.7,
      actual_complete: 95.9,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-06-01",
      baseline_complete: 95.0,
      actual_complete: 95.9,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-06-08",
      baseline_complete: 95.2,
      actual_complete: 95.9,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-06-15",
      baseline_complete: 95.4,
      actual_complete: 95.9,
      forecast_complete: 65.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-06-22",
      baseline_complete: 95.6,
      actual_complete: 97.1,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-06-29",
      baseline_complete: 95.8,
      actual_complete: 97.7,
      forecast_complete: 66.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-07-06",
      baseline_complete: 96.0,
      actual_complete: 97.7,
      forecast_complete: 67.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-07-13",
      baseline_complete: 96.2,
      actual_complete: 97.7,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-07-20",
      baseline_complete: 96.4,
      actual_complete: 98.6,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-07-27",
      baseline_complete: 96.6,
      actual_complete: 98.6,
      forecast_complete: 69.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-08-03",
      baseline_complete: 96.7,
      actual_complete: 98.6,
      forecast_complete: 69.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-08-10",
      baseline_complete: 96.9,
      actual_complete: 98.6,
      forecast_complete: 70.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-08-17",
      baseline_complete: 97.0,
      actual_complete: 98.6,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-08-24",
      baseline_complete: 97.2,
      actual_complete: 98.6,
      forecast_complete: 71.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-08-31",
      baseline_complete: 97.3,
      actual_complete: 98.6,
      forecast_complete: 71.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-09-07",
      baseline_complete: 97.4,
      actual_complete: 98.6,
      forecast_complete: 72.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-09-14",
      baseline_complete: 97.5,
      actual_complete: 98.9,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-09-21",
      baseline_complete: 97.7,
      actual_complete: 98.9,
      forecast_complete: 74.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-09-28",
      baseline_complete: 97.8,
      actual_complete: 99.7,
      forecast_complete: 75.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-10-05",
      baseline_complete: 97.9,
      actual_complete: 99.7,
      forecast_complete: 76.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-10-12",
      baseline_complete: 98.0,
      actual_complete: 99.7,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-10-19",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 77.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-10-26",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 78.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-11-02",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-11-09",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 80.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-11-16",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 80.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-11-23",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 81.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-11-30",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 82.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-12-07",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-12-14",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-12-21",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2027-12-28",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 85.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-01-04",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 85.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-01-11",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 86.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-01-18",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-01-25",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-02-01",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-02-08",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 88.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-02-15",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 89.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-02-22",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 89.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-02-29",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-03-07",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 90.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-03-14",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-03-21",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-03-28",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-04-04",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-04-11",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-04-18",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-04-25",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-05-02",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-05-09",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-05-16",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-05-23",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-05-30",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-06-06",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-06-13",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-06-20",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-06-27",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-07-04",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-07-11",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-07-18",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-07-25",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-08-01",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-08-08",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-08-15",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-08-22",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-08-29",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-09-05",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-09-12",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-09-19",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-09-26",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-10-03",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-10-10",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-10-17",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "35ecd415-3f11-96e1-f83e-feff3274d7f1",
      reporting_date: "2028-10-19",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
  ],
  "e45d0895-d42d-f1c8-7f77-a5844bea2c32": [
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-07-10",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-07-17",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-07-24",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-07-31",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-08-07",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-08-14",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-08-21",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-08-28",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-09-04",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-09-11",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-09-18",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-09-25",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-10-02",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-10-09",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-10-16",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-10-23",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-10-30",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-11-06",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-11-13",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-11-20",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-11-27",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-12-04",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-12-11",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-12-18",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2024-12-25",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-01-01",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-01-08",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-01-15",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-01-22",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-01-29",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-02-05",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-02-12",
      baseline_complete: 2.4,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-02-19",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-02-26",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-03-05",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-03-12",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-03-19",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-03-26",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-04-02",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-04-09",
      baseline_complete: 3.8,
      actual_complete: 0.0,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-04-16",
      baseline_complete: 4.0,
      actual_complete: 0.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-04-23",
      baseline_complete: 4.3,
      actual_complete: 0.2,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-04-30",
      baseline_complete: 4.5,
      actual_complete: 0.6,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-05-07",
      baseline_complete: 4.8,
      actual_complete: 1.5,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-05-14",
      baseline_complete: 5.1,
      actual_complete: 2.9,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-05-21",
      baseline_complete: 5.4,
      actual_complete: 2.9,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-05-28",
      baseline_complete: 5.7,
      actual_complete: 2.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-06-04",
      baseline_complete: 6.0,
      actual_complete: 2.9,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-06-11",
      baseline_complete: 6.4,
      actual_complete: 2.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-06-18",
      baseline_complete: 6.8,
      actual_complete: 2.9,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-06-25",
      baseline_complete: 7.2,
      actual_complete: 2.9,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-07-02",
      baseline_complete: 7.6,
      actual_complete: 3.4,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-07-09",
      baseline_complete: 8.0,
      actual_complete: 6.2,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-07-16",
      baseline_complete: 8.4,
      actual_complete: 6.2,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-07-23",
      baseline_complete: 8.9,
      actual_complete: 6.2,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-07-30",
      baseline_complete: 9.4,
      actual_complete: 6.2,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-08-06",
      baseline_complete: 10.0,
      actual_complete: 8.9,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-08-13",
      baseline_complete: 10.5,
      actual_complete: 8.9,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-08-20",
      baseline_complete: 11.1,
      actual_complete: 9.4,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-08-27",
      baseline_complete: 11.7,
      actual_complete: 9.4,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-09-03",
      baseline_complete: 12.3,
      actual_complete: 9.4,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-09-10",
      baseline_complete: 13.0,
      actual_complete: 9.5,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-09-17",
      baseline_complete: 13.7,
      actual_complete: 11.5,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-09-24",
      baseline_complete: 14.4,
      actual_complete: 11.5,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-10-01",
      baseline_complete: 15.2,
      actual_complete: 11.5,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-10-08",
      baseline_complete: 16.0,
      actual_complete: 11.5,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-10-15",
      baseline_complete: 16.8,
      actual_complete: 15.5,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-10-22",
      baseline_complete: 17.6,
      actual_complete: 15.5,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-10-29",
      baseline_complete: 18.5,
      actual_complete: 15.7,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-11-05",
      baseline_complete: 19.5,
      actual_complete: 15.7,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-11-12",
      baseline_complete: 20.4,
      actual_complete: 18.3,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-11-19",
      baseline_complete: 21.4,
      actual_complete: 18.3,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-11-26",
      baseline_complete: 22.5,
      actual_complete: 18.3,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-12-03",
      baseline_complete: 23.5,
      actual_complete: 18.9,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-12-10",
      baseline_complete: 24.6,
      actual_complete: 21.8,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-12-17",
      baseline_complete: 25.7,
      actual_complete: 22.9,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-12-24",
      baseline_complete: 26.9,
      actual_complete: 25.6,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2025-12-31",
      baseline_complete: 28.1,
      actual_complete: 25.6,
      forecast_complete: 13.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-01-07",
      baseline_complete: 29.3,
      actual_complete: 27.7,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-01-14",
      baseline_complete: 30.6,
      actual_complete: 28.7,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-01-21",
      baseline_complete: 31.9,
      actual_complete: 31.7,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-01-28",
      baseline_complete: 33.2,
      actual_complete: 32.3,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-02-04",
      baseline_complete: 34.6,
      actual_complete: 33.8,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-02-11",
      baseline_complete: 35.9,
      actual_complete: 33.8,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-02-18",
      baseline_complete: 37.3,
      actual_complete: 34.1,
      forecast_complete: 18.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-02-25",
      baseline_complete: 38.8,
      actual_complete: 37.0,
      forecast_complete: 19.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-03-04",
      baseline_complete: 40.2,
      actual_complete: 39.5,
      forecast_complete: 20.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-03-11",
      baseline_complete: 41.7,
      actual_complete: 39.5,
      forecast_complete: 21.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-03-18",
      baseline_complete: 43.1,
      actual_complete: 39.5,
      forecast_complete: 22.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-03-25",
      baseline_complete: 44.6,
      actual_complete: 41.6,
      forecast_complete: 23.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-04-01",
      baseline_complete: 46.1,
      actual_complete: 44.6,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-04-08",
      baseline_complete: 47.6,
      actual_complete: 46.3,
      forecast_complete: 25.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-04-15",
      baseline_complete: 49.1,
      actual_complete: 46.3,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-04-22",
      baseline_complete: 50.6,
      actual_complete: 50.8,
      forecast_complete: 27.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-04-29",
      baseline_complete: 52.1,
      actual_complete: 52.0,
      forecast_complete: 28.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-05-06",
      baseline_complete: 53.6,
      actual_complete: 52.0,
      forecast_complete: 29.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-05-13",
      baseline_complete: 55.1,
      actual_complete: 53.3,
      forecast_complete: 31.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-05-20",
      baseline_complete: 56.6,
      actual_complete: 56.1,
      forecast_complete: 32.1,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-05-27",
      baseline_complete: 58.1,
      actual_complete: 57.7,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-06-03",
      baseline_complete: 59.5,
      actual_complete: 57.7,
      forecast_complete: 34.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-06-10",
      baseline_complete: 61.0,
      actual_complete: 58.8,
      forecast_complete: 35.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-06-17",
      baseline_complete: 62.4,
      actual_complete: 62.5,
      forecast_complete: 36.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-06-24",
      baseline_complete: 63.8,
      actual_complete: 63.1,
      forecast_complete: 37.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-07-01",
      baseline_complete: 65.2,
      actual_complete: 64.8,
      forecast_complete: 39.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-07-08",
      baseline_complete: 66.5,
      actual_complete: 65.4,
      forecast_complete: 40.1,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-07-15",
      baseline_complete: 67.8,
      actual_complete: 66.3,
      forecast_complete: 41.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-07-22",
      baseline_complete: 69.1,
      actual_complete: 67.5,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-07-29",
      baseline_complete: 70.4,
      actual_complete: 69.1,
      forecast_complete: 43.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-08-05",
      baseline_complete: 71.6,
      actual_complete: 72.4,
      forecast_complete: 44.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-08-12",
      baseline_complete: 72.9,
      actual_complete: 72.4,
      forecast_complete: 45.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-08-19",
      baseline_complete: 74.0,
      actual_complete: 72.4,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-08-26",
      baseline_complete: 75.2,
      actual_complete: 74.1,
      forecast_complete: 48.1,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-09-02",
      baseline_complete: 76.3,
      actual_complete: 74.1,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-09-09",
      baseline_complete: 77.3,
      actual_complete: 76.4,
      forecast_complete: 50.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-09-16",
      baseline_complete: 78.4,
      actual_complete: 77.0,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-09-23",
      baseline_complete: 79.4,
      actual_complete: 80.2,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-09-30",
      baseline_complete: 80.4,
      actual_complete: 80.2,
      forecast_complete: 53.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-10-07",
      baseline_complete: 81.3,
      actual_complete: 82.4,
      forecast_complete: 54.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-10-14",
      baseline_complete: 82.2,
      actual_complete: 82.4,
      forecast_complete: 55.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-10-21",
      baseline_complete: 83.0,
      actual_complete: 82.4,
      forecast_complete: 56.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-10-28",
      baseline_complete: 83.9,
      actual_complete: 84.2,
      forecast_complete: 57.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-11-04",
      baseline_complete: 84.7,
      actual_complete: 84.2,
      forecast_complete: 58.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-11-11",
      baseline_complete: 85.4,
      actual_complete: 86.6,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-11-18",
      baseline_complete: 86.2,
      actual_complete: 86.6,
      forecast_complete: 60.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-11-25",
      baseline_complete: 86.9,
      actual_complete: 87.4,
      forecast_complete: 61.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-12-02",
      baseline_complete: 87.5,
      actual_complete: 87.4,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-12-09",
      baseline_complete: 88.2,
      actual_complete: 87.4,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-12-16",
      baseline_complete: 88.8,
      actual_complete: 88.1,
      forecast_complete: 64.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-12-23",
      baseline_complete: 89.4,
      actual_complete: 90.7,
      forecast_complete: 65.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2026-12-30",
      baseline_complete: 89.9,
      actual_complete: 91.2,
      forecast_complete: 66.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-01-06",
      baseline_complete: 90.5,
      actual_complete: 92.8,
      forecast_complete: 67.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-01-13",
      baseline_complete: 91.0,
      actual_complete: 92.8,
      forecast_complete: 68.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-01-20",
      baseline_complete: 91.5,
      actual_complete: 92.8,
      forecast_complete: 68.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-01-27",
      baseline_complete: 91.9,
      actual_complete: 93.5,
      forecast_complete: 69.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-02-03",
      baseline_complete: 92.4,
      actual_complete: 93.5,
      forecast_complete: 70.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-02-10",
      baseline_complete: 92.8,
      actual_complete: 95.9,
      forecast_complete: 71.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-02-17",
      baseline_complete: 93.2,
      actual_complete: 95.9,
      forecast_complete: 73.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-02-24",
      baseline_complete: 93.5,
      actual_complete: 95.9,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-03-03",
      baseline_complete: 93.9,
      actual_complete: 95.9,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-03-10",
      baseline_complete: 94.2,
      actual_complete: 95.9,
      forecast_complete: 77.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-03-17",
      baseline_complete: 94.5,
      actual_complete: 96.1,
      forecast_complete: 78.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-03-24",
      baseline_complete: 94.8,
      actual_complete: 96.1,
      forecast_complete: 79.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-03-31",
      baseline_complete: 95.1,
      actual_complete: 96.1,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-04-07",
      baseline_complete: 95.4,
      actual_complete: 97.8,
      forecast_complete: 82.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-04-14",
      baseline_complete: 95.7,
      actual_complete: 97.8,
      forecast_complete: 83.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-04-21",
      baseline_complete: 95.9,
      actual_complete: 98.8,
      forecast_complete: 84.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-04-28",
      baseline_complete: 96.1,
      actual_complete: 98.8,
      forecast_complete: 85.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-05-05",
      baseline_complete: 96.4,
      actual_complete: 98.8,
      forecast_complete: 86.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-05-12",
      baseline_complete: 96.6,
      actual_complete: 98.8,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-05-19",
      baseline_complete: 96.8,
      actual_complete: 98.8,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-05-26",
      baseline_complete: 96.9,
      actual_complete: 98.8,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-06-02",
      baseline_complete: 97.1,
      actual_complete: 98.8,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-06-09",
      baseline_complete: 97.3,
      actual_complete: 98.8,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-06-16",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-06-23",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-06-30",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-07-07",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-07-14",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-07-21",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 95.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-07-28",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-08-04",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-08-11",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-08-18",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-08-25",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-09-01",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.2,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-09-08",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-09-15",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-09-22",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-09-29",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-10-06",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-10-13",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-10-20",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-10-27",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-11-03",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-11-10",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-11-17",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-11-24",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-12-01",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-12-08",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e45d0895-d42d-f1c8-7f77-a5844bea2c32",
      reporting_date: "2027-12-10",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "f19bd7c8-05c4-85d0-d2e7-5789d7738686": [
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-01-31",
      baseline_complete: 0.6,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-02-07",
      baseline_complete: 0.6,
      actual_complete: 5.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-02-14",
      baseline_complete: 0.7,
      actual_complete: 5.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-02-21",
      baseline_complete: 0.7,
      actual_complete: 5.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-02-28",
      baseline_complete: 0.7,
      actual_complete: 5.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-03-06",
      baseline_complete: 0.8,
      actual_complete: 5.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-03-13",
      baseline_complete: 0.8,
      actual_complete: 5.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-03-20",
      baseline_complete: 0.9,
      actual_complete: 5.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-03-27",
      baseline_complete: 0.9,
      actual_complete: 5.9,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-04-03",
      baseline_complete: 1.0,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-04-10",
      baseline_complete: 1.0,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-04-17",
      baseline_complete: 1.1,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-04-24",
      baseline_complete: 1.1,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-05-01",
      baseline_complete: 1.2,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-05-08",
      baseline_complete: 1.3,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-05-15",
      baseline_complete: 1.3,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-05-22",
      baseline_complete: 1.4,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-05-29",
      baseline_complete: 1.5,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-06-05",
      baseline_complete: 1.5,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-06-12",
      baseline_complete: 1.6,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-06-19",
      baseline_complete: 1.7,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-06-26",
      baseline_complete: 1.8,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-07-03",
      baseline_complete: 1.9,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-07-10",
      baseline_complete: 2.0,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-07-17",
      baseline_complete: 2.1,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-07-24",
      baseline_complete: 2.2,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-07-31",
      baseline_complete: 2.3,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-08-07",
      baseline_complete: 2.5,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-08-14",
      baseline_complete: 2.6,
      actual_complete: 6.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-08-21",
      baseline_complete: 2.7,
      actual_complete: 6.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-08-28",
      baseline_complete: 2.9,
      actual_complete: 7.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-09-04",
      baseline_complete: 3.0,
      actual_complete: 7.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-09-11",
      baseline_complete: 3.2,
      actual_complete: 7.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-09-18",
      baseline_complete: 3.4,
      actual_complete: 7.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-09-25",
      baseline_complete: 3.5,
      actual_complete: 7.7,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-10-02",
      baseline_complete: 3.7,
      actual_complete: 8.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-10-09",
      baseline_complete: 3.9,
      actual_complete: 8.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-10-16",
      baseline_complete: 4.1,
      actual_complete: 8.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-10-23",
      baseline_complete: 4.3,
      actual_complete: 8.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-10-30",
      baseline_complete: 4.6,
      actual_complete: 8.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-11-06",
      baseline_complete: 4.8,
      actual_complete: 9.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-11-13",
      baseline_complete: 5.0,
      actual_complete: 9.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-11-20",
      baseline_complete: 5.3,
      actual_complete: 9.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-11-27",
      baseline_complete: 5.6,
      actual_complete: 9.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-12-04",
      baseline_complete: 5.9,
      actual_complete: 10.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-12-11",
      baseline_complete: 6.2,
      actual_complete: 10.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-12-18",
      baseline_complete: 6.5,
      actual_complete: 10.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2024-12-25",
      baseline_complete: 6.8,
      actual_complete: 10.1,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-01-01",
      baseline_complete: 7.1,
      actual_complete: 10.1,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-01-08",
      baseline_complete: 7.5,
      actual_complete: 12.1,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-01-15",
      baseline_complete: 7.9,
      actual_complete: 12.1,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-01-22",
      baseline_complete: 8.3,
      actual_complete: 12.6,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-01-29",
      baseline_complete: 8.7,
      actual_complete: 12.6,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-02-05",
      baseline_complete: 9.1,
      actual_complete: 12.6,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-02-12",
      baseline_complete: 9.6,
      actual_complete: 13.8,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-02-19",
      baseline_complete: 10.0,
      actual_complete: 13.8,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-02-26",
      baseline_complete: 10.5,
      actual_complete: 13.8,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-03-05",
      baseline_complete: 11.0,
      actual_complete: 13.8,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-03-12",
      baseline_complete: 11.5,
      actual_complete: 14.6,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-03-19",
      baseline_complete: 12.1,
      actual_complete: 15.5,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-03-26",
      baseline_complete: 12.7,
      actual_complete: 15.5,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-04-02",
      baseline_complete: 13.3,
      actual_complete: 15.5,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-04-09",
      baseline_complete: 13.9,
      actual_complete: 16.7,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-04-16",
      baseline_complete: 14.5,
      actual_complete: 16.7,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-04-23",
      baseline_complete: 15.2,
      actual_complete: 16.7,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-04-30",
      baseline_complete: 15.9,
      actual_complete: 17.0,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-05-07",
      baseline_complete: 16.6,
      actual_complete: 18.1,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-05-14",
      baseline_complete: 17.4,
      actual_complete: 19.3,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-05-21",
      baseline_complete: 18.1,
      actual_complete: 21.7,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-05-28",
      baseline_complete: 18.9,
      actual_complete: 22.0,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-06-04",
      baseline_complete: 19.8,
      actual_complete: 23.2,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-06-11",
      baseline_complete: 20.6,
      actual_complete: 23.2,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-06-18",
      baseline_complete: 21.5,
      actual_complete: 23.5,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-06-25",
      baseline_complete: 22.4,
      actual_complete: 23.5,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-07-02",
      baseline_complete: 23.4,
      actual_complete: 25.9,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-07-09",
      baseline_complete: 24.3,
      actual_complete: 25.9,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-07-16",
      baseline_complete: 25.3,
      actual_complete: 25.9,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-07-23",
      baseline_complete: 26.3,
      actual_complete: 27.2,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-07-30",
      baseline_complete: 27.4,
      actual_complete: 27.4,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-08-06",
      baseline_complete: 28.4,
      actual_complete: 29.5,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-08-13",
      baseline_complete: 29.5,
      actual_complete: 32.9,
      forecast_complete: 14.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-08-20",
      baseline_complete: 30.6,
      actual_complete: 34.6,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-08-27",
      baseline_complete: 31.8,
      actual_complete: 34.6,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-09-03",
      baseline_complete: 32.9,
      actual_complete: 37.2,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-09-10",
      baseline_complete: 34.1,
      actual_complete: 38.6,
      forecast_complete: 17.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-09-17",
      baseline_complete: 35.3,
      actual_complete: 38.6,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-09-24",
      baseline_complete: 36.5,
      actual_complete: 38.6,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-10-01",
      baseline_complete: 37.8,
      actual_complete: 39.0,
      forecast_complete: 19.6,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-10-08",
      baseline_complete: 39.0,
      actual_complete: 41.7,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-10-15",
      baseline_complete: 40.3,
      actual_complete: 42.6,
      forecast_complete: 21.3,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-10-22",
      baseline_complete: 41.6,
      actual_complete: 42.9,
      forecast_complete: 22.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-10-29",
      baseline_complete: 42.8,
      actual_complete: 46.2,
      forecast_complete: 23.0,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-11-05",
      baseline_complete: 44.1,
      actual_complete: 46.9,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-11-12",
      baseline_complete: 45.5,
      actual_complete: 49.2,
      forecast_complete: 24.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-11-19",
      baseline_complete: 46.8,
      actual_complete: 49.2,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-11-26",
      baseline_complete: 48.1,
      actual_complete: 49.2,
      forecast_complete: 26.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-12-03",
      baseline_complete: 49.4,
      actual_complete: 53.4,
      forecast_complete: 27.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-12-10",
      baseline_complete: 50.7,
      actual_complete: 54.4,
      forecast_complete: 28.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-12-17",
      baseline_complete: 52.1,
      actual_complete: 56.2,
      forecast_complete: 29.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-12-24",
      baseline_complete: 53.4,
      actual_complete: 56.2,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2025-12-31",
      baseline_complete: 54.7,
      actual_complete: 57.3,
      forecast_complete: 31.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-01-07",
      baseline_complete: 56.0,
      actual_complete: 59.1,
      forecast_complete: 33.0,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-01-14",
      baseline_complete: 57.3,
      actual_complete: 60.5,
      forecast_complete: 34.0,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-01-21",
      baseline_complete: 58.6,
      actual_complete: 60.5,
      forecast_complete: 35.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-01-28",
      baseline_complete: 59.9,
      actual_complete: 60.5,
      forecast_complete: 36.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-02-04",
      baseline_complete: 61.1,
      actual_complete: 64.1,
      forecast_complete: 37.3,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-02-11",
      baseline_complete: 62.4,
      actual_complete: 65.0,
      forecast_complete: 38.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-02-18",
      baseline_complete: 63.6,
      actual_complete: 66.6,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-02-25",
      baseline_complete: 64.8,
      actual_complete: 66.6,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-03-04",
      baseline_complete: 66.0,
      actual_complete: 69.1,
      forecast_complete: 41.7,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-03-11",
      baseline_complete: 67.2,
      actual_complete: 69.1,
      forecast_complete: 42.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-03-18",
      baseline_complete: 68.4,
      actual_complete: 72.6,
      forecast_complete: 43.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-03-25",
      baseline_complete: 69.5,
      actual_complete: 72.6,
      forecast_complete: 45.0,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-04-01",
      baseline_complete: 70.6,
      actual_complete: 72.6,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-04-08",
      baseline_complete: 71.7,
      actual_complete: 76.8,
      forecast_complete: 47.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-04-15",
      baseline_complete: 72.8,
      actual_complete: 76.8,
      forecast_complete: 48.3,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-04-22",
      baseline_complete: 73.8,
      actual_complete: 76.8,
      forecast_complete: 49.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-04-29",
      baseline_complete: 74.8,
      actual_complete: 76.8,
      forecast_complete: 50.5,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-05-06",
      baseline_complete: 75.8,
      actual_complete: 77.1,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-05-13",
      baseline_complete: 76.8,
      actual_complete: 79.2,
      forecast_complete: 52.6,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-05-20",
      baseline_complete: 77.7,
      actual_complete: 79.2,
      forecast_complete: 53.7,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-05-27",
      baseline_complete: 78.6,
      actual_complete: 79.8,
      forecast_complete: 54.7,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-06-03",
      baseline_complete: 79.5,
      actual_complete: 79.8,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-06-10",
      baseline_complete: 80.3,
      actual_complete: 84.9,
      forecast_complete: 56.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-06-17",
      baseline_complete: 81.1,
      actual_complete: 84.9,
      forecast_complete: 57.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-06-24",
      baseline_complete: 81.9,
      actual_complete: 86.3,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-07-01",
      baseline_complete: 82.7,
      actual_complete: 86.3,
      forecast_complete: 59.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-07-08",
      baseline_complete: 83.5,
      actual_complete: 86.3,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-07-15",
      baseline_complete: 84.2,
      actual_complete: 87.4,
      forecast_complete: 61.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-07-22",
      baseline_complete: 84.9,
      actual_complete: 87.4,
      forecast_complete: 62.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-07-29",
      baseline_complete: 85.5,
      actual_complete: 87.4,
      forecast_complete: 63.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-08-05",
      baseline_complete: 86.2,
      actual_complete: 87.4,
      forecast_complete: 65.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-08-12",
      baseline_complete: 86.8,
      actual_complete: 91.3,
      forecast_complete: 66.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-08-19",
      baseline_complete: 87.4,
      actual_complete: 91.6,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-08-26",
      baseline_complete: 88.0,
      actual_complete: 92.7,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-09-02",
      baseline_complete: 88.5,
      actual_complete: 92.7,
      forecast_complete: 71.7,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-09-09",
      baseline_complete: 89.0,
      actual_complete: 92.7,
      forecast_complete: 73.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-09-16",
      baseline_complete: 89.6,
      actual_complete: 92.7,
      forecast_complete: 74.6,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-09-23",
      baseline_complete: 90.0,
      actual_complete: 92.7,
      forecast_complete: 76.0,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-09-30",
      baseline_complete: 90.5,
      actual_complete: 92.7,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-10-07",
      baseline_complete: 90.9,
      actual_complete: 93.9,
      forecast_complete: 78.6,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-10-14",
      baseline_complete: 91.4,
      actual_complete: 95.6,
      forecast_complete: 79.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-10-21",
      baseline_complete: 91.8,
      actual_complete: 95.6,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-10-28",
      baseline_complete: 92.2,
      actual_complete: 95.6,
      forecast_complete: 82.3,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-11-04",
      baseline_complete: 92.5,
      actual_complete: 96.4,
      forecast_complete: 83.3,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-11-11",
      baseline_complete: 92.9,
      actual_complete: 96.4,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-11-18",
      baseline_complete: 93.2,
      actual_complete: 96.4,
      forecast_complete: 85.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-11-25",
      baseline_complete: 93.6,
      actual_complete: 96.4,
      forecast_complete: 86.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-12-02",
      baseline_complete: 93.9,
      actual_complete: 96.4,
      forecast_complete: 87.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-12-09",
      baseline_complete: 94.2,
      actual_complete: 96.4,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-12-16",
      baseline_complete: 94.5,
      actual_complete: 96.8,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-12-23",
      baseline_complete: 94.7,
      actual_complete: 96.8,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2026-12-30",
      baseline_complete: 95.0,
      actual_complete: 96.8,
      forecast_complete: 90.7,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-01-06",
      baseline_complete: 95.2,
      actual_complete: 97.5,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-01-13",
      baseline_complete: 95.5,
      actual_complete: 97.5,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-01-20",
      baseline_complete: 95.7,
      actual_complete: 97.5,
      forecast_complete: 92.8,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-01-27",
      baseline_complete: 95.9,
      actual_complete: 97.5,
      forecast_complete: 93.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-02-03",
      baseline_complete: 96.1,
      actual_complete: 98.3,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-02-10",
      baseline_complete: 96.3,
      actual_complete: 99.7,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-02-17",
      baseline_complete: 96.5,
      actual_complete: 99.7,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-02-24",
      baseline_complete: 96.7,
      actual_complete: 99.7,
      forecast_complete: 95.6,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-03-03",
      baseline_complete: 96.8,
      actual_complete: 99.7,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-03-10",
      baseline_complete: 97.0,
      actual_complete: 99.7,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-03-17",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-03-24",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-03-31",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-04-07",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-04-14",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-04-21",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-04-28",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-05-05",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-05-12",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-05-19",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-05-26",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "f19bd7c8-05c4-85d0-d2e7-5789d7738686",
      reporting_date: "2027-05-31",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
  ],
  "33574084-6584-9717-a9f7-1488f5d751e6": [
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-01-02",
      baseline_complete: 0.1,
      actual_complete: 2.0,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-01-09",
      baseline_complete: 0.1,
      actual_complete: 4.4,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-01-16",
      baseline_complete: 0.1,
      actual_complete: 4.4,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-01-23",
      baseline_complete: 0.1,
      actual_complete: 6.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-01-30",
      baseline_complete: 0.2,
      actual_complete: 6.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-02-06",
      baseline_complete: 0.2,
      actual_complete: 6.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-02-13",
      baseline_complete: 0.2,
      actual_complete: 6.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-02-20",
      baseline_complete: 0.2,
      actual_complete: 6.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-02-27",
      baseline_complete: 0.2,
      actual_complete: 6.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-03-05",
      baseline_complete: 0.2,
      actual_complete: 6.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-03-12",
      baseline_complete: 0.2,
      actual_complete: 6.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-03-19",
      baseline_complete: 0.2,
      actual_complete: 6.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-03-26",
      baseline_complete: 0.2,
      actual_complete: 6.2,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-04-02",
      baseline_complete: 0.2,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-04-09",
      baseline_complete: 0.3,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-04-16",
      baseline_complete: 0.3,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-04-23",
      baseline_complete: 0.3,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-04-30",
      baseline_complete: 0.3,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-05-07",
      baseline_complete: 0.3,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-05-14",
      baseline_complete: 0.3,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-05-21",
      baseline_complete: 0.3,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-05-28",
      baseline_complete: 0.4,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-06-04",
      baseline_complete: 0.4,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-06-11",
      baseline_complete: 0.4,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-06-18",
      baseline_complete: 0.4,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-06-25",
      baseline_complete: 0.4,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-07-02",
      baseline_complete: 0.5,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-07-09",
      baseline_complete: 0.5,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-07-16",
      baseline_complete: 0.5,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-07-23",
      baseline_complete: 0.5,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-07-30",
      baseline_complete: 0.6,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-08-06",
      baseline_complete: 0.6,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-08-13",
      baseline_complete: 0.6,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-08-20",
      baseline_complete: 0.7,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-08-27",
      baseline_complete: 0.7,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-09-03",
      baseline_complete: 0.7,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-09-10",
      baseline_complete: 0.8,
      actual_complete: 6.8,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-09-17",
      baseline_complete: 0.8,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-09-24",
      baseline_complete: 0.8,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-10-01",
      baseline_complete: 0.9,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-10-08",
      baseline_complete: 0.9,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-10-15",
      baseline_complete: 1.0,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-10-22",
      baseline_complete: 1.0,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-10-29",
      baseline_complete: 1.1,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-11-05",
      baseline_complete: 1.1,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-11-12",
      baseline_complete: 1.2,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-11-19",
      baseline_complete: 1.3,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-11-26",
      baseline_complete: 1.3,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-12-03",
      baseline_complete: 1.4,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-12-10",
      baseline_complete: 1.5,
      actual_complete: 7.1,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-12-17",
      baseline_complete: 1.5,
      actual_complete: 7.5,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-12-24",
      baseline_complete: 1.6,
      actual_complete: 7.5,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2024-12-31",
      baseline_complete: 1.7,
      actual_complete: 8.3,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-01-07",
      baseline_complete: 1.8,
      actual_complete: 8.3,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-01-14",
      baseline_complete: 1.9,
      actual_complete: 8.3,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-01-21",
      baseline_complete: 1.9,
      actual_complete: 8.3,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-01-28",
      baseline_complete: 2.0,
      actual_complete: 8.4,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-02-04",
      baseline_complete: 2.1,
      actual_complete: 8.4,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-02-11",
      baseline_complete: 2.3,
      actual_complete: 8.4,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-02-18",
      baseline_complete: 2.4,
      actual_complete: 8.4,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-02-25",
      baseline_complete: 2.5,
      actual_complete: 8.4,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-03-04",
      baseline_complete: 2.6,
      actual_complete: 8.4,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-03-11",
      baseline_complete: 2.7,
      actual_complete: 8.4,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-03-18",
      baseline_complete: 2.9,
      actual_complete: 8.4,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-03-25",
      baseline_complete: 3.0,
      actual_complete: 8.4,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-04-01",
      baseline_complete: 3.2,
      actual_complete: 8.9,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-04-08",
      baseline_complete: 3.3,
      actual_complete: 8.9,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-04-15",
      baseline_complete: 3.5,
      actual_complete: 8.9,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-04-22",
      baseline_complete: 3.7,
      actual_complete: 9.0,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-04-29",
      baseline_complete: 3.8,
      actual_complete: 9.9,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-05-06",
      baseline_complete: 4.0,
      actual_complete: 9.9,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-05-13",
      baseline_complete: 4.2,
      actual_complete: 9.9,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-05-20",
      baseline_complete: 4.4,
      actual_complete: 9.9,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-05-27",
      baseline_complete: 4.6,
      actual_complete: 9.9,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-06-03",
      baseline_complete: 4.9,
      actual_complete: 9.9,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-06-10",
      baseline_complete: 5.1,
      actual_complete: 9.9,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-06-17",
      baseline_complete: 5.3,
      actual_complete: 10.0,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-06-24",
      baseline_complete: 5.6,
      actual_complete: 10.0,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-07-01",
      baseline_complete: 5.9,
      actual_complete: 10.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-07-08",
      baseline_complete: 6.1,
      actual_complete: 10.0,
      forecast_complete: 6.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-07-15",
      baseline_complete: 6.4,
      actual_complete: 10.7,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-07-22",
      baseline_complete: 6.7,
      actual_complete: 10.7,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-07-29",
      baseline_complete: 7.1,
      actual_complete: 12.9,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-08-05",
      baseline_complete: 7.4,
      actual_complete: 12.9,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-08-12",
      baseline_complete: 7.7,
      actual_complete: 13.8,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-08-19",
      baseline_complete: 8.1,
      actual_complete: 13.8,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-08-26",
      baseline_complete: 8.5,
      actual_complete: 13.8,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-09-02",
      baseline_complete: 8.9,
      actual_complete: 13.8,
      forecast_complete: 7.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-09-09",
      baseline_complete: 9.3,
      actual_complete: 13.9,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-09-16",
      baseline_complete: 9.7,
      actual_complete: 13.9,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-09-23",
      baseline_complete: 10.2,
      actual_complete: 14.5,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-09-30",
      baseline_complete: 10.6,
      actual_complete: 15.5,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-10-07",
      baseline_complete: 11.1,
      actual_complete: 15.6,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-10-14",
      baseline_complete: 11.6,
      actual_complete: 15.6,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-10-21",
      baseline_complete: 12.1,
      actual_complete: 15.6,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-10-28",
      baseline_complete: 12.7,
      actual_complete: 15.6,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-11-04",
      baseline_complete: 13.2,
      actual_complete: 17.3,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-11-11",
      baseline_complete: 13.8,
      actual_complete: 18.1,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-11-18",
      baseline_complete: 14.4,
      actual_complete: 18.1,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-11-25",
      baseline_complete: 15.0,
      actual_complete: 18.1,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-12-02",
      baseline_complete: 15.7,
      actual_complete: 19.2,
      forecast_complete: 10.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-12-09",
      baseline_complete: 16.3,
      actual_complete: 19.2,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-12-16",
      baseline_complete: 17.0,
      actual_complete: 22.4,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-12-23",
      baseline_complete: 17.8,
      actual_complete: 22.4,
      forecast_complete: 11.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2025-12-30",
      baseline_complete: 18.5,
      actual_complete: 22.4,
      forecast_complete: 11.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-01-06",
      baseline_complete: 19.3,
      actual_complete: 22.4,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-01-13",
      baseline_complete: 20.0,
      actual_complete: 25.0,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-01-20",
      baseline_complete: 20.8,
      actual_complete: 25.0,
      forecast_complete: 12.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-01-27",
      baseline_complete: 21.7,
      actual_complete: 26.2,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-02-03",
      baseline_complete: 22.5,
      actual_complete: 26.2,
      forecast_complete: 13.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-02-10",
      baseline_complete: 23.4,
      actual_complete: 26.2,
      forecast_complete: 14.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-02-17",
      baseline_complete: 24.3,
      actual_complete: 26.5,
      forecast_complete: 14.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-02-24",
      baseline_complete: 25.2,
      actual_complete: 26.5,
      forecast_complete: 15.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-03-03",
      baseline_complete: 26.2,
      actual_complete: 30.4,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-03-10",
      baseline_complete: 27.2,
      actual_complete: 30.4,
      forecast_complete: 16.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-03-17",
      baseline_complete: 28.2,
      actual_complete: 30.4,
      forecast_complete: 16.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-03-24",
      baseline_complete: 29.2,
      actual_complete: 31.5,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-03-31",
      baseline_complete: 30.2,
      actual_complete: 33.9,
      forecast_complete: 17.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-04-07",
      baseline_complete: 31.3,
      actual_complete: 36.4,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-04-14",
      baseline_complete: 32.4,
      actual_complete: 36.4,
      forecast_complete: 19.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-04-21",
      baseline_complete: 33.4,
      actual_complete: 36.4,
      forecast_complete: 19.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-04-28",
      baseline_complete: 34.6,
      actual_complete: 36.4,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-05-05",
      baseline_complete: 35.7,
      actual_complete: 38.7,
      forecast_complete: 21.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-05-12",
      baseline_complete: 36.8,
      actual_complete: 41.0,
      forecast_complete: 21.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-05-19",
      baseline_complete: 38.0,
      actual_complete: 42.4,
      forecast_complete: 22.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-05-26",
      baseline_complete: 39.2,
      actual_complete: 42.4,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-06-02",
      baseline_complete: 40.4,
      actual_complete: 44.3,
      forecast_complete: 23.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-06-09",
      baseline_complete: 41.6,
      actual_complete: 45.1,
      forecast_complete: 24.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-06-16",
      baseline_complete: 42.8,
      actual_complete: 45.1,
      forecast_complete: 25.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-06-23",
      baseline_complete: 44.0,
      actual_complete: 45.1,
      forecast_complete: 26.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-06-30",
      baseline_complete: 45.2,
      actual_complete: 49.6,
      forecast_complete: 26.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-07-07",
      baseline_complete: 46.5,
      actual_complete: 49.6,
      forecast_complete: 27.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-07-14",
      baseline_complete: 47.7,
      actual_complete: 50.9,
      forecast_complete: 28.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-07-21",
      baseline_complete: 49.0,
      actual_complete: 51.5,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-07-28",
      baseline_complete: 50.2,
      actual_complete: 53.9,
      forecast_complete: 30.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-08-04",
      baseline_complete: 51.4,
      actual_complete: 53.9,
      forecast_complete: 31.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-08-11",
      baseline_complete: 52.7,
      actual_complete: 56.7,
      forecast_complete: 31.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-08-18",
      baseline_complete: 53.9,
      actual_complete: 56.7,
      forecast_complete: 32.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-08-25",
      baseline_complete: 55.2,
      actual_complete: 57.1,
      forecast_complete: 33.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-09-01",
      baseline_complete: 56.4,
      actual_complete: 60.6,
      forecast_complete: 34.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-09-08",
      baseline_complete: 57.6,
      actual_complete: 63.2,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-09-15",
      baseline_complete: 58.8,
      actual_complete: 63.2,
      forecast_complete: 36.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-09-22",
      baseline_complete: 60.0,
      actual_complete: 63.2,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-09-29",
      baseline_complete: 61.2,
      actual_complete: 66.7,
      forecast_complete: 38.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-10-06",
      baseline_complete: 62.4,
      actual_complete: 67.8,
      forecast_complete: 38.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-10-13",
      baseline_complete: 63.5,
      actual_complete: 67.8,
      forecast_complete: 39.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-10-20",
      baseline_complete: 64.7,
      actual_complete: 69.6,
      forecast_complete: 40.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-10-27",
      baseline_complete: 65.8,
      actual_complete: 70.5,
      forecast_complete: 41.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-11-03",
      baseline_complete: 66.9,
      actual_complete: 70.5,
      forecast_complete: 42.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-11-10",
      baseline_complete: 68.0,
      actual_complete: 72.6,
      forecast_complete: 43.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-11-17",
      baseline_complete: 69.1,
      actual_complete: 72.8,
      forecast_complete: 44.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-11-24",
      baseline_complete: 70.1,
      actual_complete: 74.1,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-12-01",
      baseline_complete: 71.1,
      actual_complete: 74.1,
      forecast_complete: 46.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-12-08",
      baseline_complete: 72.2,
      actual_complete: 75.9,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-12-15",
      baseline_complete: 73.1,
      actual_complete: 75.9,
      forecast_complete: 47.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-12-22",
      baseline_complete: 74.1,
      actual_complete: 79.2,
      forecast_complete: 48.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2026-12-29",
      baseline_complete: 75.1,
      actual_complete: 79.3,
      forecast_complete: 49.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-01-05",
      baseline_complete: 76.0,
      actual_complete: 79.3,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-01-12",
      baseline_complete: 76.9,
      actual_complete: 79.4,
      forecast_complete: 51.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-01-19",
      baseline_complete: 77.7,
      actual_complete: 81.1,
      forecast_complete: 51.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-01-26",
      baseline_complete: 78.6,
      actual_complete: 82.7,
      forecast_complete: 52.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-02-02",
      baseline_complete: 79.4,
      actual_complete: 82.7,
      forecast_complete: 53.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-02-09",
      baseline_complete: 80.2,
      actual_complete: 82.7,
      forecast_complete: 54.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-02-16",
      baseline_complete: 81.0,
      actual_complete: 82.7,
      forecast_complete: 55.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-02-23",
      baseline_complete: 81.7,
      actual_complete: 83.1,
      forecast_complete: 55.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-03-02",
      baseline_complete: 82.5,
      actual_complete: 87.0,
      forecast_complete: 56.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-03-09",
      baseline_complete: 83.2,
      actual_complete: 87.0,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-03-16",
      baseline_complete: 83.9,
      actual_complete: 89.1,
      forecast_complete: 58.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-03-23",
      baseline_complete: 84.5,
      actual_complete: 89.1,
      forecast_complete: 59.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-03-30",
      baseline_complete: 85.2,
      actual_complete: 89.1,
      forecast_complete: 59.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-04-06",
      baseline_complete: 85.8,
      actual_complete: 91.2,
      forecast_complete: 60.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-04-13",
      baseline_complete: 86.4,
      actual_complete: 91.2,
      forecast_complete: 61.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-04-20",
      baseline_complete: 87.0,
      actual_complete: 91.2,
      forecast_complete: 62.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-04-27",
      baseline_complete: 87.5,
      actual_complete: 91.2,
      forecast_complete: 62.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-05-04",
      baseline_complete: 88.0,
      actual_complete: 91.2,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-05-11",
      baseline_complete: 88.6,
      actual_complete: 91.2,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-05-18",
      baseline_complete: 89.0,
      actual_complete: 91.2,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-05-25",
      baseline_complete: 89.5,
      actual_complete: 91.2,
      forecast_complete: 65.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-06-01",
      baseline_complete: 90.0,
      actual_complete: 91.2,
      forecast_complete: 66.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-06-08",
      baseline_complete: 90.4,
      actual_complete: 91.6,
      forecast_complete: 66.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-06-15",
      baseline_complete: 90.8,
      actual_complete: 95.0,
      forecast_complete: 67.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-06-22",
      baseline_complete: 91.2,
      actual_complete: 95.3,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-06-29",
      baseline_complete: 91.6,
      actual_complete: 95.3,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-07-06",
      baseline_complete: 92.0,
      actual_complete: 96.9,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-07-13",
      baseline_complete: 92.4,
      actual_complete: 96.9,
      forecast_complete: 69.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-07-20",
      baseline_complete: 92.7,
      actual_complete: 96.9,
      forecast_complete: 70.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-07-27",
      baseline_complete: 93.0,
      actual_complete: 96.9,
      forecast_complete: 70.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-08-03",
      baseline_complete: 93.4,
      actual_complete: 96.9,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-08-10",
      baseline_complete: 93.7,
      actual_complete: 96.9,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-08-17",
      baseline_complete: 93.9,
      actual_complete: 97.9,
      forecast_complete: 72.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-08-24",
      baseline_complete: 94.2,
      actual_complete: 97.9,
      forecast_complete: 73.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-08-31",
      baseline_complete: 94.5,
      actual_complete: 97.9,
      forecast_complete: 73.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-09-07",
      baseline_complete: 94.7,
      actual_complete: 97.9,
      forecast_complete: 74.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-09-14",
      baseline_complete: 95.0,
      actual_complete: 100.0,
      forecast_complete: 75.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-09-21",
      baseline_complete: 95.2,
      actual_complete: 100.0,
      forecast_complete: 76.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-09-28",
      baseline_complete: 95.4,
      actual_complete: 100.0,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-10-05",
      baseline_complete: 95.6,
      actual_complete: 100.0,
      forecast_complete: 77.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-10-12",
      baseline_complete: 95.8,
      actual_complete: 100.0,
      forecast_complete: 78.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-10-19",
      baseline_complete: 96.0,
      actual_complete: 100.0,
      forecast_complete: 79.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-10-26",
      baseline_complete: 96.2,
      actual_complete: 100.0,
      forecast_complete: 80.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-11-02",
      baseline_complete: 96.4,
      actual_complete: 100.0,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-11-09",
      baseline_complete: 96.6,
      actual_complete: 100.0,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-11-16",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 82.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-11-23",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-11-30",
      baseline_complete: 97.0,
      actual_complete: 100.0,
      forecast_complete: 84.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-12-07",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 85.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-12-14",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 85.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-12-21",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 86.6,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2027-12-28",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 87.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-01-04",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 88.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-01-11",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-01-18",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-01-25",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-02-01",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 90.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-02-08",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 91.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-02-15",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 91.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-02-22",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 92.2,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-02-29",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-03-07",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-03-14",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 93.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-03-21",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 94.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-03-28",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 94.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-04-04",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-04-11",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 95.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-04-18",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 96.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-04-25",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-05-02",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-05-09",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-05-16",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-05-23",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-05-30",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-06-06",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-06-13",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-06-20",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-06-27",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-07-04",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-07-11",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-07-18",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-07-25",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-08-01",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-08-08",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-08-15",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-08-22",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-08-29",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-09-05",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-09-12",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-09-19",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-09-26",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-10-03",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-10-10",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-10-17",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-10-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-10-31",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-11-07",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-11-14",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-11-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-11-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "33574084-6584-9717-a9f7-1488f5d751e6",
      reporting_date: "2028-12-02",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "d2b32f5e-25d8-3ef5-7c00-b5871246330b": [
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-03-12",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-03-19",
      baseline_complete: 0.1,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-03-26",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-04-02",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-04-09",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-04-16",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-04-23",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-04-30",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-05-07",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-05-14",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-05-21",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-05-28",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-06-04",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-06-11",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-06-18",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-06-25",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-07-02",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-07-09",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-07-16",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-07-23",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-07-30",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-08-06",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-08-13",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-08-20",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-08-27",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-09-03",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-09-10",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-09-17",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-09-24",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-10-01",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-10-08",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-10-15",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-10-22",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-10-29",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-11-05",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-11-12",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-11-19",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-11-26",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-12-03",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-12-10",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-12-17",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-12-24",
      baseline_complete: 1.3,
      actual_complete: 0.5,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2024-12-31",
      baseline_complete: 1.4,
      actual_complete: 0.5,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-01-07",
      baseline_complete: 1.4,
      actual_complete: 0.5,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-01-14",
      baseline_complete: 1.5,
      actual_complete: 0.5,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-01-21",
      baseline_complete: 1.6,
      actual_complete: 0.5,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-01-28",
      baseline_complete: 1.7,
      actual_complete: 0.5,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-02-04",
      baseline_complete: 1.8,
      actual_complete: 0.7,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-02-11",
      baseline_complete: 1.9,
      actual_complete: 0.9,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-02-18",
      baseline_complete: 2.0,
      actual_complete: 0.9,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-02-25",
      baseline_complete: 2.1,
      actual_complete: 1.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-03-04",
      baseline_complete: 2.2,
      actual_complete: 1.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-03-11",
      baseline_complete: 2.3,
      actual_complete: 1.6,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-03-18",
      baseline_complete: 2.4,
      actual_complete: 1.6,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-03-25",
      baseline_complete: 2.6,
      actual_complete: 1.6,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-04-01",
      baseline_complete: 2.7,
      actual_complete: 1.7,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-04-08",
      baseline_complete: 2.9,
      actual_complete: 1.7,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-04-15",
      baseline_complete: 3.0,
      actual_complete: 1.7,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-04-22",
      baseline_complete: 3.2,
      actual_complete: 1.7,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-04-29",
      baseline_complete: 3.4,
      actual_complete: 1.7,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-05-06",
      baseline_complete: 3.5,
      actual_complete: 2.8,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-05-13",
      baseline_complete: 3.7,
      actual_complete: 2.8,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-05-20",
      baseline_complete: 3.9,
      actual_complete: 2.8,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-05-27",
      baseline_complete: 4.1,
      actual_complete: 2.8,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-06-03",
      baseline_complete: 4.4,
      actual_complete: 4.0,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-06-10",
      baseline_complete: 4.6,
      actual_complete: 4.0,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-06-17",
      baseline_complete: 4.8,
      actual_complete: 4.0,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-06-24",
      baseline_complete: 5.1,
      actual_complete: 4.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-07-01",
      baseline_complete: 5.4,
      actual_complete: 4.2,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-07-08",
      baseline_complete: 5.7,
      actual_complete: 4.2,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-07-15",
      baseline_complete: 6.0,
      actual_complete: 4.8,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-07-22",
      baseline_complete: 6.3,
      actual_complete: 4.8,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-07-29",
      baseline_complete: 6.6,
      actual_complete: 4.8,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-08-05",
      baseline_complete: 6.9,
      actual_complete: 6.5,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-08-12",
      baseline_complete: 7.3,
      actual_complete: 6.5,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-08-19",
      baseline_complete: 7.7,
      actual_complete: 7.5,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-08-26",
      baseline_complete: 8.1,
      actual_complete: 7.5,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-09-02",
      baseline_complete: 8.5,
      actual_complete: 7.5,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-09-09",
      baseline_complete: 8.9,
      actual_complete: 8.0,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-09-16",
      baseline_complete: 9.4,
      actual_complete: 8.0,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-09-23",
      baseline_complete: 9.8,
      actual_complete: 8.1,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-09-30",
      baseline_complete: 10.3,
      actual_complete: 9.7,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-10-07",
      baseline_complete: 10.9,
      actual_complete: 9.7,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-10-14",
      baseline_complete: 11.4,
      actual_complete: 9.9,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-10-21",
      baseline_complete: 12.0,
      actual_complete: 11.3,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-10-28",
      baseline_complete: 12.5,
      actual_complete: 11.3,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-11-04",
      baseline_complete: 13.1,
      actual_complete: 12.4,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-11-11",
      baseline_complete: 13.8,
      actual_complete: 12.4,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-11-18",
      baseline_complete: 14.4,
      actual_complete: 13.9,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-11-25",
      baseline_complete: 15.1,
      actual_complete: 14.9,
      forecast_complete: 7.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-12-02",
      baseline_complete: 15.8,
      actual_complete: 14.9,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-12-09",
      baseline_complete: 16.6,
      actual_complete: 16.2,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-12-16",
      baseline_complete: 17.3,
      actual_complete: 17.5,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-12-23",
      baseline_complete: 18.1,
      actual_complete: 17.5,
      forecast_complete: 9.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2025-12-30",
      baseline_complete: 19.0,
      actual_complete: 19.3,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-01-06",
      baseline_complete: 19.8,
      actual_complete: 19.3,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-01-13",
      baseline_complete: 20.7,
      actual_complete: 20.5,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-01-20",
      baseline_complete: 21.6,
      actual_complete: 20.5,
      forecast_complete: 11.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-01-27",
      baseline_complete: 22.5,
      actual_complete: 21.5,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-02-03",
      baseline_complete: 23.5,
      actual_complete: 23.8,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-02-10",
      baseline_complete: 24.5,
      actual_complete: 23.8,
      forecast_complete: 12.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-02-17",
      baseline_complete: 25.5,
      actual_complete: 23.9,
      forecast_complete: 13.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-02-24",
      baseline_complete: 26.6,
      actual_complete: 25.3,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-03-03",
      baseline_complete: 27.6,
      actual_complete: 27.6,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-03-10",
      baseline_complete: 28.7,
      actual_complete: 28.8,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-03-17",
      baseline_complete: 29.9,
      actual_complete: 30.0,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-03-24",
      baseline_complete: 31.0,
      actual_complete: 30.0,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-03-31",
      baseline_complete: 32.2,
      actual_complete: 30.2,
      forecast_complete: 16.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-04-07",
      baseline_complete: 33.4,
      actual_complete: 32.6,
      forecast_complete: 17.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-04-14",
      baseline_complete: 34.6,
      actual_complete: 33.5,
      forecast_complete: 18.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-04-21",
      baseline_complete: 35.9,
      actual_complete: 37.1,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-04-28",
      baseline_complete: 37.1,
      actual_complete: 37.1,
      forecast_complete: 19.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-05-05",
      baseline_complete: 38.4,
      actual_complete: 39.0,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-05-12",
      baseline_complete: 39.7,
      actual_complete: 39.7,
      forecast_complete: 21.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-05-19",
      baseline_complete: 41.0,
      actual_complete: 39.7,
      forecast_complete: 22.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-05-26",
      baseline_complete: 42.3,
      actual_complete: 42.1,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-06-02",
      baseline_complete: 43.7,
      actual_complete: 42.4,
      forecast_complete: 24.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-06-09",
      baseline_complete: 45.0,
      actual_complete: 45.3,
      forecast_complete: 24.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-06-16",
      baseline_complete: 46.4,
      actual_complete: 45.3,
      forecast_complete: 25.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-06-23",
      baseline_complete: 47.7,
      actual_complete: 46.8,
      forecast_complete: 26.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-06-30",
      baseline_complete: 49.1,
      actual_complete: 48.9,
      forecast_complete: 27.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-07-07",
      baseline_complete: 50.5,
      actual_complete: 49.8,
      forecast_complete: 28.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-07-14",
      baseline_complete: 51.8,
      actual_complete: 51.2,
      forecast_complete: 29.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-07-21",
      baseline_complete: 53.2,
      actual_complete: 53.4,
      forecast_complete: 30.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-07-28",
      baseline_complete: 54.5,
      actual_complete: 54.3,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-08-04",
      baseline_complete: 55.9,
      actual_complete: 56.6,
      forecast_complete: 32.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-08-11",
      baseline_complete: 57.2,
      actual_complete: 56.6,
      forecast_complete: 33.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-08-18",
      baseline_complete: 58.5,
      actual_complete: 58.2,
      forecast_complete: 34.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-08-25",
      baseline_complete: 59.9,
      actual_complete: 60.7,
      forecast_complete: 35.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-09-01",
      baseline_complete: 61.2,
      actual_complete: 60.7,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-09-08",
      baseline_complete: 62.4,
      actual_complete: 61.7,
      forecast_complete: 37.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-09-15",
      baseline_complete: 63.7,
      actual_complete: 63.9,
      forecast_complete: 38.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-09-22",
      baseline_complete: 65.0,
      actual_complete: 65.1,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-09-29",
      baseline_complete: 66.2,
      actual_complete: 65.1,
      forecast_complete: 40.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-10-06",
      baseline_complete: 67.4,
      actual_complete: 66.5,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-10-13",
      baseline_complete: 68.6,
      actual_complete: 67.7,
      forecast_complete: 42.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-10-20",
      baseline_complete: 69.7,
      actual_complete: 69.8,
      forecast_complete: 43.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-10-27",
      baseline_complete: 70.9,
      actual_complete: 71.7,
      forecast_complete: 44.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-11-03",
      baseline_complete: 72.0,
      actual_complete: 71.7,
      forecast_complete: 45.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-11-10",
      baseline_complete: 73.1,
      actual_complete: 73.1,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-11-17",
      baseline_complete: 74.1,
      actual_complete: 73.7,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-11-24",
      baseline_complete: 75.2,
      actual_complete: 75.4,
      forecast_complete: 48.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-12-01",
      baseline_complete: 76.2,
      actual_complete: 75.4,
      forecast_complete: 49.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-12-08",
      baseline_complete: 77.1,
      actual_complete: 76.6,
      forecast_complete: 50.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-12-15",
      baseline_complete: 78.1,
      actual_complete: 79.0,
      forecast_complete: 51.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-12-22",
      baseline_complete: 79.0,
      actual_complete: 79.6,
      forecast_complete: 52.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2026-12-29",
      baseline_complete: 79.9,
      actual_complete: 81.2,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-01-05",
      baseline_complete: 80.8,
      actual_complete: 81.2,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-01-12",
      baseline_complete: 81.6,
      actual_complete: 82.5,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-01-19",
      baseline_complete: 82.4,
      actual_complete: 82.5,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-01-26",
      baseline_complete: 83.2,
      actual_complete: 84.0,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-02-02",
      baseline_complete: 83.9,
      actual_complete: 84.0,
      forecast_complete: 57.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-02-09",
      baseline_complete: 84.6,
      actual_complete: 84.7,
      forecast_complete: 58.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-02-16",
      baseline_complete: 85.3,
      actual_complete: 84.8,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-02-23",
      baseline_complete: 86.0,
      actual_complete: 87.1,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-03-02",
      baseline_complete: 86.6,
      actual_complete: 87.1,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-03-09",
      baseline_complete: 87.3,
      actual_complete: 87.1,
      forecast_complete: 61.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-03-16",
      baseline_complete: 87.9,
      actual_complete: 87.1,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-03-23",
      baseline_complete: 88.4,
      actual_complete: 89.2,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-03-30",
      baseline_complete: 89.0,
      actual_complete: 89.3,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-04-06",
      baseline_complete: 89.5,
      actual_complete: 89.3,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-04-13",
      baseline_complete: 90.0,
      actual_complete: 90.7,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-04-20",
      baseline_complete: 90.5,
      actual_complete: 91.4,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-04-27",
      baseline_complete: 90.9,
      actual_complete: 92.2,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-05-04",
      baseline_complete: 91.4,
      actual_complete: 92.2,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-05-11",
      baseline_complete: 91.8,
      actual_complete: 93.5,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-05-18",
      baseline_complete: 92.2,
      actual_complete: 93.5,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-05-25",
      baseline_complete: 92.6,
      actual_complete: 93.5,
      forecast_complete: 69.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-06-01",
      baseline_complete: 92.9,
      actual_complete: 94.6,
      forecast_complete: 70.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-06-08",
      baseline_complete: 93.3,
      actual_complete: 95.6,
      forecast_complete: 71.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-06-15",
      baseline_complete: 93.6,
      actual_complete: 95.6,
      forecast_complete: 71.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-06-22",
      baseline_complete: 93.9,
      actual_complete: 95.6,
      forecast_complete: 72.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-06-29",
      baseline_complete: 94.2,
      actual_complete: 95.6,
      forecast_complete: 74.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-07-06",
      baseline_complete: 94.5,
      actual_complete: 95.9,
      forecast_complete: 75.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-07-13",
      baseline_complete: 94.8,
      actual_complete: 96.6,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-07-20",
      baseline_complete: 95.1,
      actual_complete: 96.6,
      forecast_complete: 77.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-07-27",
      baseline_complete: 95.3,
      actual_complete: 96.6,
      forecast_complete: 78.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-08-03",
      baseline_complete: 95.6,
      actual_complete: 96.9,
      forecast_complete: 79.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-08-10",
      baseline_complete: 95.8,
      actual_complete: 96.9,
      forecast_complete: 80.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-08-17",
      baseline_complete: 96.0,
      actual_complete: 96.9,
      forecast_complete: 81.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-08-24",
      baseline_complete: 96.2,
      actual_complete: 97.5,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-08-31",
      baseline_complete: 96.4,
      actual_complete: 98.1,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-09-07",
      baseline_complete: 96.6,
      actual_complete: 98.1,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-09-14",
      baseline_complete: 96.8,
      actual_complete: 98.1,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-09-21",
      baseline_complete: 96.9,
      actual_complete: 98.1,
      forecast_complete: 85.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-09-28",
      baseline_complete: 97.1,
      actual_complete: 98.1,
      forecast_complete: 86.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-10-05",
      baseline_complete: 97.2,
      actual_complete: 98.8,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-10-12",
      baseline_complete: 97.4,
      actual_complete: 98.8,
      forecast_complete: 87.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-10-19",
      baseline_complete: 97.5,
      actual_complete: 99.0,
      forecast_complete: 88.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-10-26",
      baseline_complete: 97.6,
      actual_complete: 99.0,
      forecast_complete: 89.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-11-02",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 89.9,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-11-09",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 90.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-11-16",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-11-23",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 91.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-11-30",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 92.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-12-07",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 93.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-12-14",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 93.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-12-21",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2027-12-28",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 94.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-01-04",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-01-11",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-01-18",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-01-25",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-02-01",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-02-08",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 97.2,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-02-15",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-02-22",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-02-29",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-03-07",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-03-14",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-03-21",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-03-28",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-04-04",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-04-11",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-04-18",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-04-25",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-05-02",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-05-09",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-05-16",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-05-23",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-05-30",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-06-06",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-06-13",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-06-20",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-06-27",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-07-04",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-07-11",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "d2b32f5e-25d8-3ef5-7c00-b5871246330b",
      reporting_date: "2028-07-12",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "69122fa4-ac9d-6433-8920-7dc74fbdf049": [
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-05-07",
      baseline_complete: 0.6,
      actual_complete: 2.5,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-05-14",
      baseline_complete: 0.7,
      actual_complete: 2.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-05-21",
      baseline_complete: 0.7,
      actual_complete: 4.4,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-05-28",
      baseline_complete: 0.7,
      actual_complete: 4.4,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-06-04",
      baseline_complete: 0.8,
      actual_complete: 4.4,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-06-11",
      baseline_complete: 0.8,
      actual_complete: 5.7,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-06-18",
      baseline_complete: 0.8,
      actual_complete: 7.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-06-25",
      baseline_complete: 0.9,
      actual_complete: 7.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-07-02",
      baseline_complete: 0.9,
      actual_complete: 7.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-07-09",
      baseline_complete: 1.0,
      actual_complete: 7.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-07-16",
      baseline_complete: 1.0,
      actual_complete: 7.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-07-23",
      baseline_complete: 1.1,
      actual_complete: 7.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-07-30",
      baseline_complete: 1.1,
      actual_complete: 7.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-08-06",
      baseline_complete: 1.2,
      actual_complete: 7.2,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-08-13",
      baseline_complete: 1.2,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-08-20",
      baseline_complete: 1.3,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-08-27",
      baseline_complete: 1.4,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-09-03",
      baseline_complete: 1.4,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-09-10",
      baseline_complete: 1.5,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-09-17",
      baseline_complete: 1.6,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-09-24",
      baseline_complete: 1.6,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-10-01",
      baseline_complete: 1.7,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-10-08",
      baseline_complete: 1.8,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-10-15",
      baseline_complete: 1.9,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-10-22",
      baseline_complete: 2.0,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-10-29",
      baseline_complete: 2.1,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-11-05",
      baseline_complete: 2.2,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-11-12",
      baseline_complete: 2.3,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-11-19",
      baseline_complete: 2.4,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-11-26",
      baseline_complete: 2.5,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-12-03",
      baseline_complete: 2.6,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-12-10",
      baseline_complete: 2.7,
      actual_complete: 7.9,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-12-17",
      baseline_complete: 2.9,
      actual_complete: 7.9,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-12-24",
      baseline_complete: 3.0,
      actual_complete: 8.9,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2024-12-31",
      baseline_complete: 3.1,
      actual_complete: 8.9,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-01-07",
      baseline_complete: 3.3,
      actual_complete: 9.9,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-01-14",
      baseline_complete: 3.4,
      actual_complete: 9.9,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-01-21",
      baseline_complete: 3.6,
      actual_complete: 9.9,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-01-28",
      baseline_complete: 3.8,
      actual_complete: 9.9,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-02-04",
      baseline_complete: 3.9,
      actual_complete: 10.3,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-02-11",
      baseline_complete: 4.1,
      actual_complete: 10.3,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-02-18",
      baseline_complete: 4.3,
      actual_complete: 10.3,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-02-25",
      baseline_complete: 4.5,
      actual_complete: 10.3,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-03-04",
      baseline_complete: 4.7,
      actual_complete: 10.3,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-03-11",
      baseline_complete: 4.9,
      actual_complete: 10.3,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-03-18",
      baseline_complete: 5.2,
      actual_complete: 10.3,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-03-25",
      baseline_complete: 5.4,
      actual_complete: 10.3,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-04-01",
      baseline_complete: 5.6,
      actual_complete: 11.2,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-04-08",
      baseline_complete: 5.9,
      actual_complete: 11.2,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-04-15",
      baseline_complete: 6.2,
      actual_complete: 11.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-04-22",
      baseline_complete: 6.5,
      actual_complete: 11.2,
      forecast_complete: 5.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-04-29",
      baseline_complete: 6.7,
      actual_complete: 11.2,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-05-06",
      baseline_complete: 7.0,
      actual_complete: 11.2,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-05-13",
      baseline_complete: 7.4,
      actual_complete: 11.2,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-05-20",
      baseline_complete: 7.7,
      actual_complete: 11.2,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-05-27",
      baseline_complete: 8.0,
      actual_complete: 11.2,
      forecast_complete: 6.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-06-03",
      baseline_complete: 8.4,
      actual_complete: 12.9,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-06-10",
      baseline_complete: 8.8,
      actual_complete: 12.9,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-06-17",
      baseline_complete: 9.2,
      actual_complete: 12.9,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-06-24",
      baseline_complete: 9.6,
      actual_complete: 15.1,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-07-01",
      baseline_complete: 10.0,
      actual_complete: 15.1,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-07-08",
      baseline_complete: 10.4,
      actual_complete: 15.1,
      forecast_complete: 6.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-07-15",
      baseline_complete: 10.9,
      actual_complete: 15.1,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-07-22",
      baseline_complete: 11.3,
      actual_complete: 15.1,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-07-29",
      baseline_complete: 11.8,
      actual_complete: 18.1,
      forecast_complete: 7.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-08-05",
      baseline_complete: 12.3,
      actual_complete: 18.1,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-08-12",
      baseline_complete: 12.8,
      actual_complete: 18.1,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-08-19",
      baseline_complete: 13.4,
      actual_complete: 18.1,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-08-26",
      baseline_complete: 13.9,
      actual_complete: 18.1,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-09-02",
      baseline_complete: 14.5,
      actual_complete: 18.1,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-09-09",
      baseline_complete: 15.1,
      actual_complete: 18.1,
      forecast_complete: 8.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-09-16",
      baseline_complete: 15.7,
      actual_complete: 18.1,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-09-23",
      baseline_complete: 16.4,
      actual_complete: 20.4,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-09-30",
      baseline_complete: 17.0,
      actual_complete: 20.4,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-10-07",
      baseline_complete: 17.7,
      actual_complete: 20.4,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-10-14",
      baseline_complete: 18.4,
      actual_complete: 21.3,
      forecast_complete: 10.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-10-21",
      baseline_complete: 19.2,
      actual_complete: 22.7,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-10-28",
      baseline_complete: 19.9,
      actual_complete: 22.7,
      forecast_complete: 10.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-11-04",
      baseline_complete: 20.7,
      actual_complete: 22.7,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-11-11",
      baseline_complete: 21.5,
      actual_complete: 22.7,
      forecast_complete: 11.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-11-18",
      baseline_complete: 22.3,
      actual_complete: 22.7,
      forecast_complete: 12.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-11-25",
      baseline_complete: 23.1,
      actual_complete: 23.4,
      forecast_complete: 12.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-12-02",
      baseline_complete: 24.0,
      actual_complete: 28.7,
      forecast_complete: 12.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-12-09",
      baseline_complete: 24.8,
      actual_complete: 29.8,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-12-16",
      baseline_complete: 25.7,
      actual_complete: 29.8,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-12-23",
      baseline_complete: 26.6,
      actual_complete: 33.2,
      forecast_complete: 14.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2025-12-30",
      baseline_complete: 27.6,
      actual_complete: 33.2,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-01-06",
      baseline_complete: 28.5,
      actual_complete: 33.2,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-01-13",
      baseline_complete: 29.5,
      actual_complete: 33.2,
      forecast_complete: 15.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-01-20",
      baseline_complete: 30.5,
      actual_complete: 33.2,
      forecast_complete: 16.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-01-27",
      baseline_complete: 31.5,
      actual_complete: 33.2,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-02-03",
      baseline_complete: 32.6,
      actual_complete: 38.4,
      forecast_complete: 17.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-02-10",
      baseline_complete: 33.6,
      actual_complete: 38.4,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-02-17",
      baseline_complete: 34.7,
      actual_complete: 38.4,
      forecast_complete: 18.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-02-24",
      baseline_complete: 35.8,
      actual_complete: 39.7,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-03-03",
      baseline_complete: 36.9,
      actual_complete: 39.7,
      forecast_complete: 19.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-03-10",
      baseline_complete: 38.0,
      actual_complete: 39.7,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-03-17",
      baseline_complete: 39.1,
      actual_complete: 41.7,
      forecast_complete: 21.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-03-24",
      baseline_complete: 40.2,
      actual_complete: 42.0,
      forecast_complete: 21.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-03-31",
      baseline_complete: 41.4,
      actual_complete: 46.5,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-04-07",
      baseline_complete: 42.5,
      actual_complete: 46.5,
      forecast_complete: 23.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-04-14",
      baseline_complete: 43.7,
      actual_complete: 46.5,
      forecast_complete: 23.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-04-21",
      baseline_complete: 44.9,
      actual_complete: 47.6,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-04-28",
      baseline_complete: 46.1,
      actual_complete: 51.4,
      forecast_complete: 25.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-05-05",
      baseline_complete: 47.2,
      actual_complete: 51.4,
      forecast_complete: 26.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-05-12",
      baseline_complete: 48.4,
      actual_complete: 51.4,
      forecast_complete: 26.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-05-19",
      baseline_complete: 49.6,
      actual_complete: 52.5,
      forecast_complete: 27.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-05-26",
      baseline_complete: 50.8,
      actual_complete: 52.5,
      forecast_complete: 28.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-06-02",
      baseline_complete: 52.0,
      actual_complete: 58.4,
      forecast_complete: 29.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-06-09",
      baseline_complete: 53.2,
      actual_complete: 58.4,
      forecast_complete: 30.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-06-16",
      baseline_complete: 54.3,
      actual_complete: 58.4,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-06-23",
      baseline_complete: 55.5,
      actual_complete: 58.4,
      forecast_complete: 31.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-06-30",
      baseline_complete: 56.7,
      actual_complete: 58.6,
      forecast_complete: 32.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-07-07",
      baseline_complete: 57.8,
      actual_complete: 58.6,
      forecast_complete: 33.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-07-14",
      baseline_complete: 59.0,
      actual_complete: 58.6,
      forecast_complete: 34.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-07-21",
      baseline_complete: 60.1,
      actual_complete: 63.6,
      forecast_complete: 35.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-07-28",
      baseline_complete: 61.3,
      actual_complete: 67.4,
      forecast_complete: 36.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-08-04",
      baseline_complete: 62.4,
      actual_complete: 67.4,
      forecast_complete: 36.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-08-11",
      baseline_complete: 63.5,
      actual_complete: 67.4,
      forecast_complete: 37.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-08-18",
      baseline_complete: 64.6,
      actual_complete: 70.9,
      forecast_complete: 38.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-08-25",
      baseline_complete: 65.7,
      actual_complete: 70.9,
      forecast_complete: 39.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-09-01",
      baseline_complete: 66.7,
      actual_complete: 70.9,
      forecast_complete: 40.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-09-08",
      baseline_complete: 67.8,
      actual_complete: 73.9,
      forecast_complete: 41.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-09-15",
      baseline_complete: 68.8,
      actual_complete: 73.9,
      forecast_complete: 42.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-09-22",
      baseline_complete: 69.8,
      actual_complete: 73.9,
      forecast_complete: 43.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-09-29",
      baseline_complete: 70.8,
      actual_complete: 73.9,
      forecast_complete: 43.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-10-06",
      baseline_complete: 71.8,
      actual_complete: 73.9,
      forecast_complete: 44.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-10-13",
      baseline_complete: 72.7,
      actual_complete: 77.6,
      forecast_complete: 45.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-10-20",
      baseline_complete: 73.7,
      actual_complete: 77.6,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-10-27",
      baseline_complete: 74.6,
      actual_complete: 77.6,
      forecast_complete: 47.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-11-03",
      baseline_complete: 75.5,
      actual_complete: 77.6,
      forecast_complete: 48.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-11-10",
      baseline_complete: 76.3,
      actual_complete: 77.6,
      forecast_complete: 49.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-11-17",
      baseline_complete: 77.2,
      actual_complete: 78.1,
      forecast_complete: 50.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-11-24",
      baseline_complete: 78.0,
      actual_complete: 81.5,
      forecast_complete: 50.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-12-01",
      baseline_complete: 78.8,
      actual_complete: 81.6,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-12-08",
      baseline_complete: 79.6,
      actual_complete: 81.6,
      forecast_complete: 52.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-12-15",
      baseline_complete: 80.4,
      actual_complete: 84.2,
      forecast_complete: 53.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-12-22",
      baseline_complete: 81.1,
      actual_complete: 84.2,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2026-12-29",
      baseline_complete: 81.8,
      actual_complete: 84.3,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-01-05",
      baseline_complete: 82.5,
      actual_complete: 84.3,
      forecast_complete: 55.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-01-12",
      baseline_complete: 83.2,
      actual_complete: 84.3,
      forecast_complete: 56.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-01-19",
      baseline_complete: 83.8,
      actual_complete: 84.7,
      forecast_complete: 57.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-01-26",
      baseline_complete: 84.5,
      actual_complete: 84.7,
      forecast_complete: 58.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-02-02",
      baseline_complete: 85.1,
      actual_complete: 86.5,
      forecast_complete: 58.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-02-09",
      baseline_complete: 85.7,
      actual_complete: 86.5,
      forecast_complete: 59.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-02-16",
      baseline_complete: 86.2,
      actual_complete: 88.1,
      forecast_complete: 60.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-02-23",
      baseline_complete: 86.8,
      actual_complete: 88.1,
      forecast_complete: 61.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-03-02",
      baseline_complete: 87.3,
      actual_complete: 91.6,
      forecast_complete: 61.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-03-09",
      baseline_complete: 87.8,
      actual_complete: 91.6,
      forecast_complete: 62.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-03-16",
      baseline_complete: 88.3,
      actual_complete: 93.5,
      forecast_complete: 63.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-03-23",
      baseline_complete: 88.8,
      actual_complete: 93.5,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-03-30",
      baseline_complete: 89.3,
      actual_complete: 93.5,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-04-06",
      baseline_complete: 89.7,
      actual_complete: 94.4,
      forecast_complete: 65.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-04-13",
      baseline_complete: 90.2,
      actual_complete: 94.4,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-04-20",
      baseline_complete: 90.6,
      actual_complete: 94.4,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-04-27",
      baseline_complete: 91.0,
      actual_complete: 94.4,
      forecast_complete: 67.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-05-04",
      baseline_complete: 91.4,
      actual_complete: 94.4,
      forecast_complete: 68.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-05-11",
      baseline_complete: 91.7,
      actual_complete: 94.4,
      forecast_complete: 69.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-05-18",
      baseline_complete: 92.1,
      actual_complete: 94.4,
      forecast_complete: 69.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-05-25",
      baseline_complete: 92.4,
      actual_complete: 94.4,
      forecast_complete: 70.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-06-01",
      baseline_complete: 92.7,
      actual_complete: 96.2,
      forecast_complete: 70.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-06-08",
      baseline_complete: 93.1,
      actual_complete: 96.2,
      forecast_complete: 71.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-06-15",
      baseline_complete: 93.4,
      actual_complete: 96.3,
      forecast_complete: 72.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-06-22",
      baseline_complete: 93.6,
      actual_complete: 96.3,
      forecast_complete: 72.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-06-29",
      baseline_complete: 93.9,
      actual_complete: 97.0,
      forecast_complete: 73.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-07-06",
      baseline_complete: 94.2,
      actual_complete: 98.1,
      forecast_complete: 74.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-07-13",
      baseline_complete: 94.4,
      actual_complete: 98.1,
      forecast_complete: 76.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-07-20",
      baseline_complete: 94.7,
      actual_complete: 98.1,
      forecast_complete: 77.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-07-27",
      baseline_complete: 94.9,
      actual_complete: 98.2,
      forecast_complete: 78.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-08-03",
      baseline_complete: 95.1,
      actual_complete: 98.2,
      forecast_complete: 79.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-08-10",
      baseline_complete: 95.4,
      actual_complete: 98.2,
      forecast_complete: 80.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-08-17",
      baseline_complete: 95.6,
      actual_complete: 98.2,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-08-24",
      baseline_complete: 95.8,
      actual_complete: 100.0,
      forecast_complete: 82.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-08-31",
      baseline_complete: 95.9,
      actual_complete: 100.0,
      forecast_complete: 82.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-09-07",
      baseline_complete: 96.1,
      actual_complete: 100.0,
      forecast_complete: 83.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-09-14",
      baseline_complete: 96.3,
      actual_complete: 100.0,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-09-21",
      baseline_complete: 96.5,
      actual_complete: 100.0,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-09-28",
      baseline_complete: 96.6,
      actual_complete: 100.0,
      forecast_complete: 86.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-10-05",
      baseline_complete: 96.8,
      actual_complete: 100.0,
      forecast_complete: 87.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-10-12",
      baseline_complete: 96.9,
      actual_complete: 100.0,
      forecast_complete: 87.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-10-19",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 88.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-10-26",
      baseline_complete: 97.2,
      actual_complete: 100.0,
      forecast_complete: 89.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-11-02",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-11-09",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-11-16",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-11-23",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-11-30",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 92.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-12-07",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-12-14",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 93.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-12-21",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2027-12-28",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-01-04",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-01-11",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 96.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-01-18",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-01-25",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-02-01",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-02-08",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-02-15",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-02-22",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-02-29",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-03-07",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-03-14",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-03-21",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-03-28",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-04-04",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-04-11",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-04-18",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-04-25",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-05-02",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-05-09",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-05-16",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-05-23",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-05-30",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-06-06",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-06-13",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-06-20",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-06-27",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-07-04",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "69122fa4-ac9d-6433-8920-7dc74fbdf049",
      reporting_date: "2028-07-07",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9": [
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-04-07",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-04-14",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-04-21",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-04-28",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-05-05",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-05-12",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-05-19",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-05-26",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-06-02",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-06-09",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-06-16",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-06-23",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-06-30",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-07-07",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-07-14",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-07-21",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-07-28",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-08-04",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-08-11",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 1.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-08-18",
      baseline_complete: 3.1,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-08-25",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-09-01",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-09-08",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-09-15",
      baseline_complete: 3.8,
      actual_complete: 0.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-09-22",
      baseline_complete: 4.0,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-09-29",
      baseline_complete: 4.2,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-10-06",
      baseline_complete: 4.4,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-10-13",
      baseline_complete: 4.7,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-10-20",
      baseline_complete: 4.9,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-10-27",
      baseline_complete: 5.2,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-11-03",
      baseline_complete: 5.4,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-11-10",
      baseline_complete: 5.7,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-11-17",
      baseline_complete: 6.0,
      actual_complete: 0.0,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-11-24",
      baseline_complete: 6.3,
      actual_complete: 0.5,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-12-01",
      baseline_complete: 6.7,
      actual_complete: 1.2,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-12-08",
      baseline_complete: 7.0,
      actual_complete: 1.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-12-15",
      baseline_complete: 7.4,
      actual_complete: 1.2,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-12-22",
      baseline_complete: 7.8,
      actual_complete: 1.2,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2024-12-29",
      baseline_complete: 8.2,
      actual_complete: 1.7,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-01-05",
      baseline_complete: 8.6,
      actual_complete: 1.9,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-01-12",
      baseline_complete: 9.0,
      actual_complete: 1.9,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-01-19",
      baseline_complete: 9.5,
      actual_complete: 3.2,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-01-26",
      baseline_complete: 10.0,
      actual_complete: 3.2,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-02-02",
      baseline_complete: 10.5,
      actual_complete: 5.7,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-02-09",
      baseline_complete: 11.0,
      actual_complete: 5.7,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-02-16",
      baseline_complete: 11.6,
      actual_complete: 5.7,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-02-23",
      baseline_complete: 12.1,
      actual_complete: 5.7,
      forecast_complete: 4.2,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-03-02",
      baseline_complete: 12.7,
      actual_complete: 5.8,
      forecast_complete: 4.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-03-09",
      baseline_complete: 13.3,
      actual_complete: 8.6,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-03-16",
      baseline_complete: 14.0,
      actual_complete: 8.9,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-03-23",
      baseline_complete: 14.7,
      actual_complete: 8.9,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-03-30",
      baseline_complete: 15.4,
      actual_complete: 8.9,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-04-06",
      baseline_complete: 16.1,
      actual_complete: 9.1,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-04-13",
      baseline_complete: 16.8,
      actual_complete: 10.5,
      forecast_complete: 6.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-04-20",
      baseline_complete: 17.6,
      actual_complete: 10.5,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-04-27",
      baseline_complete: 18.4,
      actual_complete: 14.0,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-05-04",
      baseline_complete: 19.3,
      actual_complete: 14.0,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-05-11",
      baseline_complete: 20.1,
      actual_complete: 14.9,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-05-18",
      baseline_complete: 21.0,
      actual_complete: 16.1,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-05-25",
      baseline_complete: 21.9,
      actual_complete: 17.0,
      forecast_complete: 8.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-06-01",
      baseline_complete: 22.9,
      actual_complete: 17.0,
      forecast_complete: 9.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-06-08",
      baseline_complete: 23.9,
      actual_complete: 18.5,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-06-15",
      baseline_complete: 24.9,
      actual_complete: 20.3,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-06-22",
      baseline_complete: 25.9,
      actual_complete: 21.1,
      forecast_complete: 11.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-06-29",
      baseline_complete: 27.0,
      actual_complete: 21.1,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-07-06",
      baseline_complete: 28.1,
      actual_complete: 21.8,
      forecast_complete: 12.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-07-13",
      baseline_complete: 29.2,
      actual_complete: 24.5,
      forecast_complete: 13.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-07-20",
      baseline_complete: 30.3,
      actual_complete: 24.5,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-07-27",
      baseline_complete: 31.5,
      actual_complete: 27.0,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-08-03",
      baseline_complete: 32.7,
      actual_complete: 27.1,
      forecast_complete: 15.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-08-10",
      baseline_complete: 33.9,
      actual_complete: 27.3,
      forecast_complete: 15.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-08-17",
      baseline_complete: 35.1,
      actual_complete: 29.0,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-08-24",
      baseline_complete: 36.4,
      actual_complete: 32.9,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-08-31",
      baseline_complete: 37.6,
      actual_complete: 32.9,
      forecast_complete: 18.2,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-09-07",
      baseline_complete: 38.9,
      actual_complete: 33.4,
      forecast_complete: 19.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-09-14",
      baseline_complete: 40.2,
      actual_complete: 36.3,
      forecast_complete: 19.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-09-21",
      baseline_complete: 41.6,
      actual_complete: 37.4,
      forecast_complete: 20.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-09-28",
      baseline_complete: 42.9,
      actual_complete: 37.4,
      forecast_complete: 21.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-10-05",
      baseline_complete: 44.2,
      actual_complete: 39.5,
      forecast_complete: 22.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-10-12",
      baseline_complete: 45.6,
      actual_complete: 42.6,
      forecast_complete: 23.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-10-19",
      baseline_complete: 47.0,
      actual_complete: 42.6,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-10-26",
      baseline_complete: 48.3,
      actual_complete: 44.6,
      forecast_complete: 25.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-11-02",
      baseline_complete: 49.7,
      actual_complete: 44.6,
      forecast_complete: 26.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-11-09",
      baseline_complete: 51.1,
      actual_complete: 48.4,
      forecast_complete: 27.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-11-16",
      baseline_complete: 52.4,
      actual_complete: 48.4,
      forecast_complete: 28.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-11-23",
      baseline_complete: 53.8,
      actual_complete: 50.2,
      forecast_complete: 29.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-11-30",
      baseline_complete: 55.1,
      actual_complete: 50.6,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-12-07",
      baseline_complete: 56.5,
      actual_complete: 54.3,
      forecast_complete: 32.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-12-14",
      baseline_complete: 57.8,
      actual_complete: 55.8,
      forecast_complete: 33.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-12-21",
      baseline_complete: 59.2,
      actual_complete: 56.5,
      forecast_complete: 34.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2025-12-28",
      baseline_complete: 60.5,
      actual_complete: 56.5,
      forecast_complete: 35.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-01-04",
      baseline_complete: 61.8,
      actual_complete: 59.4,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-01-11",
      baseline_complete: 63.0,
      actual_complete: 59.4,
      forecast_complete: 37.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-01-18",
      baseline_complete: 64.3,
      actual_complete: 59.4,
      forecast_complete: 38.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-01-25",
      baseline_complete: 65.6,
      actual_complete: 60.8,
      forecast_complete: 40.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-02-01",
      baseline_complete: 66.8,
      actual_complete: 65.4,
      forecast_complete: 41.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-02-08",
      baseline_complete: 68.0,
      actual_complete: 65.4,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-02-15",
      baseline_complete: 69.2,
      actual_complete: 65.6,
      forecast_complete: 43.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-02-22",
      baseline_complete: 70.3,
      actual_complete: 66.7,
      forecast_complete: 44.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-03-01",
      baseline_complete: 71.4,
      actual_complete: 70.3,
      forecast_complete: 45.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-03-08",
      baseline_complete: 72.5,
      actual_complete: 70.3,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-03-15",
      baseline_complete: 73.6,
      actual_complete: 70.3,
      forecast_complete: 48.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-03-22",
      baseline_complete: 74.7,
      actual_complete: 73.0,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-03-29",
      baseline_complete: 75.7,
      actual_complete: 73.0,
      forecast_complete: 50.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-04-05",
      baseline_complete: 76.7,
      actual_complete: 75.5,
      forecast_complete: 51.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-04-12",
      baseline_complete: 77.6,
      actual_complete: 75.5,
      forecast_complete: 52.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-04-19",
      baseline_complete: 78.6,
      actual_complete: 78.1,
      forecast_complete: 53.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-04-26",
      baseline_complete: 79.5,
      actual_complete: 78.4,
      forecast_complete: 54.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-05-03",
      baseline_complete: 80.4,
      actual_complete: 78.4,
      forecast_complete: 56.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-05-10",
      baseline_complete: 81.2,
      actual_complete: 80.1,
      forecast_complete: 57.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-05-17",
      baseline_complete: 82.0,
      actual_complete: 81.5,
      forecast_complete: 58.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-05-24",
      baseline_complete: 82.8,
      actual_complete: 82.3,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-05-31",
      baseline_complete: 83.6,
      actual_complete: 82.3,
      forecast_complete: 60.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-06-07",
      baseline_complete: 84.3,
      actual_complete: 82.3,
      forecast_complete: 61.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-06-14",
      baseline_complete: 85.0,
      actual_complete: 84.1,
      forecast_complete: 62.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-06-21",
      baseline_complete: 85.7,
      actual_complete: 85.2,
      forecast_complete: 63.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-06-28",
      baseline_complete: 86.4,
      actual_complete: 87.0,
      forecast_complete: 64.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-07-05",
      baseline_complete: 87.0,
      actual_complete: 87.3,
      forecast_complete: 65.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-07-12",
      baseline_complete: 87.6,
      actual_complete: 87.3,
      forecast_complete: 66.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-07-19",
      baseline_complete: 88.2,
      actual_complete: 87.5,
      forecast_complete: 68.6,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-07-26",
      baseline_complete: 88.7,
      actual_complete: 89.3,
      forecast_complete: 70.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-08-02",
      baseline_complete: 89.3,
      actual_complete: 89.3,
      forecast_complete: 72.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-08-09",
      baseline_complete: 89.8,
      actual_complete: 89.3,
      forecast_complete: 73.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-08-16",
      baseline_complete: 90.3,
      actual_complete: 89.3,
      forecast_complete: 75.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-08-23",
      baseline_complete: 90.8,
      actual_complete: 89.3,
      forecast_complete: 76.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-08-30",
      baseline_complete: 91.2,
      actual_complete: 89.3,
      forecast_complete: 78.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-09-06",
      baseline_complete: 91.6,
      actual_complete: 90.0,
      forecast_complete: 79.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-09-13",
      baseline_complete: 92.0,
      actual_complete: 93.4,
      forecast_complete: 81.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-09-20",
      baseline_complete: 92.4,
      actual_complete: 93.4,
      forecast_complete: 82.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-09-27",
      baseline_complete: 92.8,
      actual_complete: 93.4,
      forecast_complete: 83.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-10-04",
      baseline_complete: 93.2,
      actual_complete: 93.4,
      forecast_complete: 85.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-10-11",
      baseline_complete: 93.5,
      actual_complete: 93.4,
      forecast_complete: 86.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-10-18",
      baseline_complete: 93.8,
      actual_complete: 93.4,
      forecast_complete: 87.2,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-10-25",
      baseline_complete: 94.1,
      actual_complete: 95.6,
      forecast_complete: 88.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-11-01",
      baseline_complete: 94.4,
      actual_complete: 95.6,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-11-08",
      baseline_complete: 94.7,
      actual_complete: 95.8,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-11-15",
      baseline_complete: 95.0,
      actual_complete: 95.8,
      forecast_complete: 91.2,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-11-22",
      baseline_complete: 95.2,
      actual_complete: 95.8,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-11-29",
      baseline_complete: 95.5,
      actual_complete: 95.8,
      forecast_complete: 92.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-12-06",
      baseline_complete: 95.7,
      actual_complete: 95.9,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-12-13",
      baseline_complete: 95.9,
      actual_complete: 95.9,
      forecast_complete: 94.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-12-20",
      baseline_complete: 96.1,
      actual_complete: 97.2,
      forecast_complete: 95.1,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2026-12-27",
      baseline_complete: 96.3,
      actual_complete: 97.2,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-01-03",
      baseline_complete: 96.5,
      actual_complete: 97.2,
      forecast_complete: 96.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-01-10",
      baseline_complete: 96.7,
      actual_complete: 97.5,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-01-17",
      baseline_complete: 96.9,
      actual_complete: 97.5,
      forecast_complete: 97.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-01-24",
      baseline_complete: 97.0,
      actual_complete: 97.5,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-01-31",
      baseline_complete: 97.2,
      actual_complete: 98.4,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-02-07",
      baseline_complete: 97.3,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-02-14",
      baseline_complete: 97.5,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-02-21",
      baseline_complete: 97.6,
      actual_complete: 100.0,
      forecast_complete: 99.5,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-02-28",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-03-07",
      baseline_complete: 97.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-03-14",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-03-21",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-03-28",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-04-04",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "e1925f82-bb3a-9b5e-1711-1d1944fbc3a9",
      reporting_date: "2027-04-07",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "7073121b-3d14-c0b2-3032-607f156aca93": [
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-07-12",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-07-19",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-07-26",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-08-02",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-08-09",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-08-16",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-08-23",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-08-30",
      baseline_complete: 1.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-09-06",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-09-13",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-09-20",
      baseline_complete: 1.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-09-27",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-10-04",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-10-11",
      baseline_complete: 2.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-10-18",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-10-25",
      baseline_complete: 2.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-11-01",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-11-08",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-11-15",
      baseline_complete: 2.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-11-22",
      baseline_complete: 2.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-11-29",
      baseline_complete: 2.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-12-06",
      baseline_complete: 3.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-12-13",
      baseline_complete: 3.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-12-20",
      baseline_complete: 3.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2023-12-27",
      baseline_complete: 3.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-01-03",
      baseline_complete: 3.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-01-10",
      baseline_complete: 3.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-01-17",
      baseline_complete: 4.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-01-24",
      baseline_complete: 4.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-01-31",
      baseline_complete: 4.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-02-07",
      baseline_complete: 4.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-02-14",
      baseline_complete: 5.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-02-21",
      baseline_complete: 5.4,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-02-28",
      baseline_complete: 5.7,
      actual_complete: 0.0,
      forecast_complete: 0.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-03-06",
      baseline_complete: 6.0,
      actual_complete: 0.0,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-03-13",
      baseline_complete: 6.3,
      actual_complete: 0.6,
      forecast_complete: 0.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-03-20",
      baseline_complete: 6.6,
      actual_complete: 1.3,
      forecast_complete: 0.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-03-27",
      baseline_complete: 7.0,
      actual_complete: 1.3,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-04-03",
      baseline_complete: 7.3,
      actual_complete: 3.0,
      forecast_complete: 0.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-04-10",
      baseline_complete: 7.7,
      actual_complete: 3.0,
      forecast_complete: 0.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-04-17",
      baseline_complete: 8.1,
      actual_complete: 3.0,
      forecast_complete: 0.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-04-24",
      baseline_complete: 8.5,
      actual_complete: 3.0,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-05-01",
      baseline_complete: 9.0,
      actual_complete: 4.5,
      forecast_complete: 1.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-05-08",
      baseline_complete: 9.4,
      actual_complete: 5.0,
      forecast_complete: 1.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-05-15",
      baseline_complete: 9.9,
      actual_complete: 5.2,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-05-22",
      baseline_complete: 10.4,
      actual_complete: 6.7,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-05-29",
      baseline_complete: 10.9,
      actual_complete: 6.7,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-06-05",
      baseline_complete: 11.5,
      actual_complete: 6.7,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-06-12",
      baseline_complete: 12.0,
      actual_complete: 8.4,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-06-19",
      baseline_complete: 12.6,
      actual_complete: 8.4,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-06-26",
      baseline_complete: 13.2,
      actual_complete: 8.4,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-07-03",
      baseline_complete: 13.9,
      actual_complete: 8.6,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-07-10",
      baseline_complete: 14.5,
      actual_complete: 10.3,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-07-17",
      baseline_complete: 15.2,
      actual_complete: 10.3,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-07-24",
      baseline_complete: 15.9,
      actual_complete: 10.3,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-07-31",
      baseline_complete: 16.7,
      actual_complete: 12.7,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-08-07",
      baseline_complete: 17.4,
      actual_complete: 12.9,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-08-14",
      baseline_complete: 18.2,
      actual_complete: 13.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-08-21",
      baseline_complete: 19.1,
      actual_complete: 14.5,
      forecast_complete: 4.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-08-28",
      baseline_complete: 19.9,
      actual_complete: 14.6,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-09-04",
      baseline_complete: 20.8,
      actual_complete: 16.0,
      forecast_complete: 5.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-09-11",
      baseline_complete: 21.7,
      actual_complete: 18.2,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-09-18",
      baseline_complete: 22.7,
      actual_complete: 18.8,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-09-25",
      baseline_complete: 23.6,
      actual_complete: 19.7,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-10-02",
      baseline_complete: 24.6,
      actual_complete: 20.2,
      forecast_complete: 7.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-10-09",
      baseline_complete: 25.7,
      actual_complete: 21.2,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-10-16",
      baseline_complete: 26.7,
      actual_complete: 21.8,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-10-23",
      baseline_complete: 27.8,
      actual_complete: 24.6,
      forecast_complete: 8.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-10-30",
      baseline_complete: 28.9,
      actual_complete: 24.8,
      forecast_complete: 9.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-11-06",
      baseline_complete: 30.1,
      actual_complete: 25.5,
      forecast_complete: 9.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-11-13",
      baseline_complete: 31.2,
      actual_complete: 27.8,
      forecast_complete: 10.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-11-20",
      baseline_complete: 32.4,
      actual_complete: 28.2,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-11-27",
      baseline_complete: 33.6,
      actual_complete: 28.2,
      forecast_complete: 11.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-12-04",
      baseline_complete: 34.8,
      actual_complete: 32.1,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-12-11",
      baseline_complete: 36.1,
      actual_complete: 32.1,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-12-18",
      baseline_complete: 37.4,
      actual_complete: 33.4,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2024-12-25",
      baseline_complete: 38.6,
      actual_complete: 36.2,
      forecast_complete: 13.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-01-01",
      baseline_complete: 39.9,
      actual_complete: 36.2,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-01-08",
      baseline_complete: 41.3,
      actual_complete: 38.2,
      forecast_complete: 15.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-01-15",
      baseline_complete: 42.6,
      actual_complete: 39.6,
      forecast_complete: 16.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-01-22",
      baseline_complete: 43.9,
      actual_complete: 41.2,
      forecast_complete: 16.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-01-29",
      baseline_complete: 45.3,
      actual_complete: 43.0,
      forecast_complete: 17.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-02-05",
      baseline_complete: 46.6,
      actual_complete: 43.7,
      forecast_complete: 18.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-02-12",
      baseline_complete: 48.0,
      actual_complete: 44.2,
      forecast_complete: 19.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-02-19",
      baseline_complete: 49.4,
      actual_complete: 45.1,
      forecast_complete: 19.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-02-26",
      baseline_complete: 50.7,
      actual_complete: 46.9,
      forecast_complete: 20.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-03-05",
      baseline_complete: 52.1,
      actual_complete: 48.0,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-03-12",
      baseline_complete: 53.4,
      actual_complete: 49.2,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-03-19",
      baseline_complete: 54.8,
      actual_complete: 51.1,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-03-26",
      baseline_complete: 56.2,
      actual_complete: 53.0,
      forecast_complete: 24.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-04-02",
      baseline_complete: 57.5,
      actual_complete: 54.2,
      forecast_complete: 25.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-04-09",
      baseline_complete: 58.8,
      actual_complete: 55.7,
      forecast_complete: 26.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-04-16",
      baseline_complete: 60.1,
      actual_complete: 57.3,
      forecast_complete: 26.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-04-23",
      baseline_complete: 61.4,
      actual_complete: 57.9,
      forecast_complete: 27.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-04-30",
      baseline_complete: 62.7,
      actual_complete: 60.7,
      forecast_complete: 28.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-05-07",
      baseline_complete: 64.0,
      actual_complete: 62.6,
      forecast_complete: 29.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-05-14",
      baseline_complete: 65.2,
      actual_complete: 62.6,
      forecast_complete: 30.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-05-21",
      baseline_complete: 66.5,
      actual_complete: 62.6,
      forecast_complete: 31.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-05-28",
      baseline_complete: 67.7,
      actual_complete: 64.7,
      forecast_complete: 32.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-06-04",
      baseline_complete: 68.9,
      actual_complete: 67.1,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-06-11",
      baseline_complete: 70.0,
      actual_complete: 67.1,
      forecast_complete: 34.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-06-18",
      baseline_complete: 71.1,
      actual_complete: 68.3,
      forecast_complete: 35.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-06-25",
      baseline_complete: 72.3,
      actual_complete: 68.7,
      forecast_complete: 36.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-07-02",
      baseline_complete: 73.3,
      actual_complete: 69.2,
      forecast_complete: 36.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-07-09",
      baseline_complete: 74.4,
      actual_complete: 71.9,
      forecast_complete: 37.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-07-16",
      baseline_complete: 75.4,
      actual_complete: 73.8,
      forecast_complete: 38.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-07-23",
      baseline_complete: 76.4,
      actual_complete: 75.6,
      forecast_complete: 39.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-07-30",
      baseline_complete: 77.4,
      actual_complete: 75.6,
      forecast_complete: 40.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-08-06",
      baseline_complete: 78.3,
      actual_complete: 75.6,
      forecast_complete: 41.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-08-13",
      baseline_complete: 79.2,
      actual_complete: 76.7,
      forecast_complete: 42.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-08-20",
      baseline_complete: 80.1,
      actual_complete: 77.8,
      forecast_complete: 43.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-08-27",
      baseline_complete: 81.0,
      actual_complete: 79.2,
      forecast_complete: 44.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-09-03",
      baseline_complete: 81.8,
      actual_complete: 79.2,
      forecast_complete: 45.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-09-10",
      baseline_complete: 82.6,
      actual_complete: 81.6,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-09-17",
      baseline_complete: 83.4,
      actual_complete: 81.6,
      forecast_complete: 46.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-09-24",
      baseline_complete: 84.1,
      actual_complete: 81.6,
      forecast_complete: 47.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-10-01",
      baseline_complete: 84.8,
      actual_complete: 82.9,
      forecast_complete: 48.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-10-08",
      baseline_complete: 85.5,
      actual_complete: 83.5,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-10-15",
      baseline_complete: 86.2,
      actual_complete: 83.9,
      forecast_complete: 50.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-10-22",
      baseline_complete: 86.8,
      actual_complete: 85.3,
      forecast_complete: 50.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-10-29",
      baseline_complete: 87.4,
      actual_complete: 85.3,
      forecast_complete: 51.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-11-05",
      baseline_complete: 88.0,
      actual_complete: 86.4,
      forecast_complete: 52.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-11-12",
      baseline_complete: 88.6,
      actual_complete: 86.5,
      forecast_complete: 53.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-11-19",
      baseline_complete: 89.1,
      actual_complete: 86.5,
      forecast_complete: 54.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-11-26",
      baseline_complete: 89.6,
      actual_complete: 87.5,
      forecast_complete: 54.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-12-03",
      baseline_complete: 90.1,
      actual_complete: 88.0,
      forecast_complete: 55.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-12-10",
      baseline_complete: 90.6,
      actual_complete: 88.6,
      forecast_complete: 56.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-12-17",
      baseline_complete: 91.1,
      actual_complete: 89.7,
      forecast_complete: 57.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-12-24",
      baseline_complete: 91.5,
      actual_complete: 91.3,
      forecast_complete: 57.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2025-12-31",
      baseline_complete: 91.9,
      actual_complete: 91.3,
      forecast_complete: 58.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-01-07",
      baseline_complete: 92.3,
      actual_complete: 91.3,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-01-14",
      baseline_complete: 92.7,
      actual_complete: 91.3,
      forecast_complete: 59.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-01-21",
      baseline_complete: 93.1,
      actual_complete: 91.3,
      forecast_complete: 60.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-01-28",
      baseline_complete: 93.4,
      actual_complete: 91.3,
      forecast_complete: 61.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-02-04",
      baseline_complete: 93.7,
      actual_complete: 91.5,
      forecast_complete: 62.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-02-11",
      baseline_complete: 94.0,
      actual_complete: 93.1,
      forecast_complete: 62.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-02-18",
      baseline_complete: 94.3,
      actual_complete: 93.1,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-02-25",
      baseline_complete: 94.6,
      actual_complete: 93.1,
      forecast_complete: 64.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-03-04",
      baseline_complete: 94.9,
      actual_complete: 93.1,
      forecast_complete: 64.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-03-11",
      baseline_complete: 95.2,
      actual_complete: 93.1,
      forecast_complete: 65.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-03-18",
      baseline_complete: 95.4,
      actual_complete: 93.4,
      forecast_complete: 66.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-03-25",
      baseline_complete: 95.6,
      actual_complete: 96.3,
      forecast_complete: 66.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-04-01",
      baseline_complete: 95.9,
      actual_complete: 96.3,
      forecast_complete: 67.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-04-08",
      baseline_complete: 96.1,
      actual_complete: 96.3,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-04-15",
      baseline_complete: 96.3,
      actual_complete: 96.3,
      forecast_complete: 68.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-04-22",
      baseline_complete: 96.5,
      actual_complete: 96.3,
      forecast_complete: 69.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-04-29",
      baseline_complete: 96.6,
      actual_complete: 96.3,
      forecast_complete: 69.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-05-06",
      baseline_complete: 96.8,
      actual_complete: 96.8,
      forecast_complete: 70.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-05-13",
      baseline_complete: 97.0,
      actual_complete: 96.8,
      forecast_complete: 71.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-05-20",
      baseline_complete: 97.1,
      actual_complete: 96.8,
      forecast_complete: 71.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-05-27",
      baseline_complete: 97.3,
      actual_complete: 96.8,
      forecast_complete: 72.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-06-03",
      baseline_complete: 97.4,
      actual_complete: 97.4,
      forecast_complete: 73.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-06-10",
      baseline_complete: 97.6,
      actual_complete: 97.4,
      forecast_complete: 74.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-06-17",
      baseline_complete: 97.7,
      actual_complete: 97.5,
      forecast_complete: 75.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-06-24",
      baseline_complete: 97.8,
      actual_complete: 97.7,
      forecast_complete: 76.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-07-01",
      baseline_complete: 97.9,
      actual_complete: 98.3,
      forecast_complete: 77.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-07-08",
      baseline_complete: 98.0,
      actual_complete: 98.5,
      forecast_complete: 78.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-07-15",
      baseline_complete: 98.1,
      actual_complete: 98.5,
      forecast_complete: 79.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-07-22",
      baseline_complete: 98.2,
      actual_complete: 99.8,
      forecast_complete: 80.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-07-29",
      baseline_complete: 98.3,
      actual_complete: 99.8,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-08-05",
      baseline_complete: 98.4,
      actual_complete: 99.8,
      forecast_complete: 82.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-08-12",
      baseline_complete: 98.5,
      actual_complete: 99.8,
      forecast_complete: 83.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-08-19",
      baseline_complete: 98.6,
      actual_complete: 99.8,
      forecast_complete: 83.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-08-26",
      baseline_complete: 98.6,
      actual_complete: 99.8,
      forecast_complete: 84.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-09-02",
      baseline_complete: 98.7,
      actual_complete: 99.8,
      forecast_complete: 85.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-09-09",
      baseline_complete: 98.8,
      actual_complete: 99.8,
      forecast_complete: 86.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-09-16",
      baseline_complete: 98.8,
      actual_complete: 99.8,
      forecast_complete: 87.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-09-23",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 87.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-09-30",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 88.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-10-07",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 89.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-10-14",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 89.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-10-21",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 90.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-10-28",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 91.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-11-04",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 91.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-11-11",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 92.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-11-18",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 92.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-11-25",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-12-02",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 93.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-12-09",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-12-16",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-12-23",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2026-12-30",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-01-06",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 95.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-01-13",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-01-20",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-01-27",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-02-03",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-02-10",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-02-17",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-02-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-03-03",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-03-10",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-03-17",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.5,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-03-24",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.7,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-03-31",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 98.8,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-04-07",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-04-14",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.0,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-04-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-04-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-05-05",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
    {
      project_GUID: "7073121b-3d14-c0b2-3032-607f156aca93",
      reporting_date: "2027-05-12",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.2,
    },
  ],
  "6e15a75e-b38a-eff8-4279-0bfe1fe7e631": [
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-08-28",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-09-04",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-09-11",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-09-18",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-09-25",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-10-02",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-10-09",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-10-16",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-10-23",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-10-30",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-11-06",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-11-13",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-11-20",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-11-27",
      baseline_complete: 1.4,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-12-04",
      baseline_complete: 1.6,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-12-11",
      baseline_complete: 1.8,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-12-18",
      baseline_complete: 2.0,
      actual_complete: 1.8,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2026-12-25",
      baseline_complete: 2.2,
      actual_complete: 2.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-01-01",
      baseline_complete: 2.5,
      actual_complete: 2.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-01-08",
      baseline_complete: 2.8,
      actual_complete: 2.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-01-15",
      baseline_complete: 3.2,
      actual_complete: 2.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-01-22",
      baseline_complete: 3.6,
      actual_complete: 2.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-01-29",
      baseline_complete: 4.0,
      actual_complete: 2.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-02-05",
      baseline_complete: 4.5,
      actual_complete: 2.4,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-02-12",
      baseline_complete: 5.1,
      actual_complete: 3.3,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-02-19",
      baseline_complete: 5.7,
      actual_complete: 4.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-02-26",
      baseline_complete: 6.4,
      actual_complete: 5.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-03-05",
      baseline_complete: 7.1,
      actual_complete: 5.6,
      forecast_complete: 0.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-03-12",
      baseline_complete: 8.0,
      actual_complete: 5.6,
      forecast_complete: 0.2,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-03-19",
      baseline_complete: 8.9,
      actual_complete: 7.9,
      forecast_complete: 0.5,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-03-26",
      baseline_complete: 10.0,
      actual_complete: 8.8,
      forecast_complete: 0.9,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-04-02",
      baseline_complete: 11.1,
      actual_complete: 11.3,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-04-09",
      baseline_complete: 12.4,
      actual_complete: 11.3,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-04-16",
      baseline_complete: 13.8,
      actual_complete: 11.3,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-04-23",
      baseline_complete: 15.3,
      actual_complete: 12.7,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-04-30",
      baseline_complete: 16.9,
      actual_complete: 17.2,
      forecast_complete: 3.6,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-05-07",
      baseline_complete: 18.7,
      actual_complete: 18.9,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-05-14",
      baseline_complete: 20.6,
      actual_complete: 19.7,
      forecast_complete: 5.1,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-05-21",
      baseline_complete: 22.6,
      actual_complete: 22.6,
      forecast_complete: 6.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-05-28",
      baseline_complete: 24.8,
      actual_complete: 26.2,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-06-04",
      baseline_complete: 27.2,
      actual_complete: 26.9,
      forecast_complete: 8.1,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-06-11",
      baseline_complete: 29.6,
      actual_complete: 26.9,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-06-18",
      baseline_complete: 32.2,
      actual_complete: 27.7,
      forecast_complete: 10.5,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-06-25",
      baseline_complete: 34.9,
      actual_complete: 31.9,
      forecast_complete: 11.9,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-07-02",
      baseline_complete: 37.7,
      actual_complete: 38.2,
      forecast_complete: 13.3,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-07-09",
      baseline_complete: 40.6,
      actual_complete: 42.4,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-07-16",
      baseline_complete: 43.6,
      actual_complete: 42.4,
      forecast_complete: 16.5,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-07-23",
      baseline_complete: 46.6,
      actual_complete: 47.6,
      forecast_complete: 18.2,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-07-30",
      baseline_complete: 49.6,
      actual_complete: 48.6,
      forecast_complete: 20.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-08-06",
      baseline_complete: 52.6,
      actual_complete: 51.6,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-08-13",
      baseline_complete: 55.7,
      actual_complete: 51.6,
      forecast_complete: 23.7,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-08-20",
      baseline_complete: 58.6,
      actual_complete: 56.5,
      forecast_complete: 25.5,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-08-27",
      baseline_complete: 61.5,
      actual_complete: 58.6,
      forecast_complete: 27.5,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-09-03",
      baseline_complete: 64.4,
      actual_complete: 66.4,
      forecast_complete: 29.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-09-10",
      baseline_complete: 67.1,
      actual_complete: 66.4,
      forecast_complete: 31.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-09-17",
      baseline_complete: 69.7,
      actual_complete: 70.1,
      forecast_complete: 33.3,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-09-24",
      baseline_complete: 72.2,
      actual_complete: 72.6,
      forecast_complete: 35.2,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-10-01",
      baseline_complete: 74.6,
      actual_complete: 76.0,
      forecast_complete: 37.1,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-10-08",
      baseline_complete: 76.8,
      actual_complete: 76.0,
      forecast_complete: 39.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-10-15",
      baseline_complete: 78.9,
      actual_complete: 77.2,
      forecast_complete: 40.8,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-10-22",
      baseline_complete: 80.9,
      actual_complete: 79.0,
      forecast_complete: 42.7,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-10-29",
      baseline_complete: 82.7,
      actual_complete: 83.0,
      forecast_complete: 44.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-11-05",
      baseline_complete: 84.3,
      actual_complete: 83.7,
      forecast_complete: 46.1,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-11-12",
      baseline_complete: 85.9,
      actual_complete: 85.5,
      forecast_complete: 47.8,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-11-19",
      baseline_complete: 87.3,
      actual_complete: 85.5,
      forecast_complete: 49.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-11-26",
      baseline_complete: 88.6,
      actual_complete: 85.5,
      forecast_complete: 51.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-12-03",
      baseline_complete: 89.7,
      actual_complete: 86.5,
      forecast_complete: 52.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-12-10",
      baseline_complete: 90.8,
      actual_complete: 93.3,
      forecast_complete: 53.9,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-12-17",
      baseline_complete: 91.8,
      actual_complete: 93.3,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-12-24",
      baseline_complete: 92.6,
      actual_complete: 93.3,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2027-12-31",
      baseline_complete: 93.4,
      actual_complete: 93.3,
      forecast_complete: 58.1,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-01-07",
      baseline_complete: 94.1,
      actual_complete: 94.9,
      forecast_complete: 59.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-01-14",
      baseline_complete: 94.8,
      actual_complete: 95.0,
      forecast_complete: 60.8,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-01-21",
      baseline_complete: 95.3,
      actual_complete: 99.1,
      forecast_complete: 62.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-01-28",
      baseline_complete: 95.9,
      actual_complete: 99.1,
      forecast_complete: 63.2,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-02-04",
      baseline_complete: 96.3,
      actual_complete: 99.1,
      forecast_complete: 64.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-02-11",
      baseline_complete: 96.7,
      actual_complete: 100.0,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-02-18",
      baseline_complete: 97.1,
      actual_complete: 100.0,
      forecast_complete: 66.7,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-02-25",
      baseline_complete: 97.4,
      actual_complete: 100.0,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-03-03",
      baseline_complete: 97.7,
      actual_complete: 100.0,
      forecast_complete: 68.9,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-03-10",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 70.1,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-03-17",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 71.1,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-03-24",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 72.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-03-31",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 74.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-04-07",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 76.2,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-04-14",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-04-21",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 79.7,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-04-28",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 81.3,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-05-05",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 82.8,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-05-12",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 84.2,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-05-19",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 85.6,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-05-26",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 86.9,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-06-02",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 88.1,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-06-09",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 89.3,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-06-16",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 90.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-06-23",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-06-30",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 92.3,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-07-07",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 93.2,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-07-14",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 94.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-07-21",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 94.7,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-07-28",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 95.3,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-08-04",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-08-11",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 96.5,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-08-18",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 96.9,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-08-25",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 97.3,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-09-01",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 97.6,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-09-08",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 97.8,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-09-15",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-09-22",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
    {
      project_GUID: "6e15a75e-b38a-eff8-4279-0bfe1fe7e631",
      reporting_date: "2028-09-28",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 98.1,
    },
  ],
  "0763b796-9b92-694a-3f48-e184c55865df": [
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-03-08",
      baseline_complete: 0.2,
      actual_complete: 0.6,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-03-15",
      baseline_complete: 0.2,
      actual_complete: 1.4,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-03-22",
      baseline_complete: 0.2,
      actual_complete: 1.4,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-03-29",
      baseline_complete: 0.2,
      actual_complete: 1.5,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-04-05",
      baseline_complete: 0.2,
      actual_complete: 1.5,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-04-12",
      baseline_complete: 0.2,
      actual_complete: 2.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-04-19",
      baseline_complete: 0.2,
      actual_complete: 2.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-04-26",
      baseline_complete: 0.2,
      actual_complete: 2.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-05-03",
      baseline_complete: 0.3,
      actual_complete: 2.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-05-10",
      baseline_complete: 0.3,
      actual_complete: 2.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-05-17",
      baseline_complete: 0.3,
      actual_complete: 2.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-05-24",
      baseline_complete: 0.3,
      actual_complete: 2.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-05-31",
      baseline_complete: 0.3,
      actual_complete: 2.1,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-06-07",
      baseline_complete: 0.3,
      actual_complete: 2.7,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-06-14",
      baseline_complete: 0.3,
      actual_complete: 2.7,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-06-21",
      baseline_complete: 0.4,
      actual_complete: 2.7,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-06-28",
      baseline_complete: 0.4,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-07-05",
      baseline_complete: 0.4,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-07-12",
      baseline_complete: 0.4,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-07-19",
      baseline_complete: 0.4,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-07-26",
      baseline_complete: 0.5,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-08-02",
      baseline_complete: 0.5,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-08-09",
      baseline_complete: 0.5,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-08-16",
      baseline_complete: 0.5,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-08-23",
      baseline_complete: 0.6,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-08-30",
      baseline_complete: 0.6,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-09-06",
      baseline_complete: 0.6,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-09-13",
      baseline_complete: 0.6,
      actual_complete: 3.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-09-20",
      baseline_complete: 0.7,
      actual_complete: 3.2,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-09-27",
      baseline_complete: 0.7,
      actual_complete: 3.2,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-10-04",
      baseline_complete: 0.7,
      actual_complete: 3.2,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-10-11",
      baseline_complete: 0.8,
      actual_complete: 3.2,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-10-18",
      baseline_complete: 0.8,
      actual_complete: 3.2,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-10-25",
      baseline_complete: 0.9,
      actual_complete: 3.2,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-11-01",
      baseline_complete: 0.9,
      actual_complete: 3.2,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-11-08",
      baseline_complete: 0.9,
      actual_complete: 3.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-11-15",
      baseline_complete: 1.0,
      actual_complete: 3.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-11-22",
      baseline_complete: 1.0,
      actual_complete: 3.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-11-29",
      baseline_complete: 1.1,
      actual_complete: 3.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-12-06",
      baseline_complete: 1.1,
      actual_complete: 3.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-12-13",
      baseline_complete: 1.2,
      actual_complete: 3.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-12-20",
      baseline_complete: 1.2,
      actual_complete: 3.6,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2023-12-27",
      baseline_complete: 1.3,
      actual_complete: 3.6,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-01-03",
      baseline_complete: 1.4,
      actual_complete: 3.6,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-01-10",
      baseline_complete: 1.4,
      actual_complete: 3.6,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-01-17",
      baseline_complete: 1.5,
      actual_complete: 3.6,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-01-24",
      baseline_complete: 1.6,
      actual_complete: 3.6,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-01-31",
      baseline_complete: 1.7,
      actual_complete: 3.6,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-02-07",
      baseline_complete: 1.7,
      actual_complete: 4.3,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-02-14",
      baseline_complete: 1.8,
      actual_complete: 4.3,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-02-21",
      baseline_complete: 1.9,
      actual_complete: 4.3,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-02-28",
      baseline_complete: 2.0,
      actual_complete: 4.3,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-03-06",
      baseline_complete: 2.1,
      actual_complete: 4.3,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-03-13",
      baseline_complete: 2.2,
      actual_complete: 4.3,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-03-20",
      baseline_complete: 2.3,
      actual_complete: 4.3,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-03-27",
      baseline_complete: 2.4,
      actual_complete: 4.3,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-04-03",
      baseline_complete: 2.5,
      actual_complete: 4.3,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-04-10",
      baseline_complete: 2.6,
      actual_complete: 4.3,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-04-17",
      baseline_complete: 2.8,
      actual_complete: 4.3,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-04-24",
      baseline_complete: 2.9,
      actual_complete: 4.5,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-05-01",
      baseline_complete: 3.0,
      actual_complete: 5.5,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-05-08",
      baseline_complete: 3.2,
      actual_complete: 5.5,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-05-15",
      baseline_complete: 3.3,
      actual_complete: 5.6,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-05-22",
      baseline_complete: 3.5,
      actual_complete: 6.2,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-05-29",
      baseline_complete: 3.7,
      actual_complete: 6.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-06-05",
      baseline_complete: 3.8,
      actual_complete: 6.2,
      forecast_complete: 2.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-06-12",
      baseline_complete: 4.0,
      actual_complete: 6.2,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-06-19",
      baseline_complete: 4.2,
      actual_complete: 6.2,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-06-26",
      baseline_complete: 4.4,
      actual_complete: 6.2,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-07-03",
      baseline_complete: 4.6,
      actual_complete: 6.8,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-07-10",
      baseline_complete: 4.8,
      actual_complete: 6.8,
      forecast_complete: 2.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-07-17",
      baseline_complete: 5.0,
      actual_complete: 6.9,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-07-24",
      baseline_complete: 5.3,
      actual_complete: 6.9,
      forecast_complete: 2.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-07-31",
      baseline_complete: 5.5,
      actual_complete: 7.2,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-08-07",
      baseline_complete: 5.8,
      actual_complete: 8.1,
      forecast_complete: 3.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-08-14",
      baseline_complete: 6.1,
      actual_complete: 8.1,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-08-21",
      baseline_complete: 6.3,
      actual_complete: 8.5,
      forecast_complete: 3.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-08-28",
      baseline_complete: 6.6,
      actual_complete: 9.2,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-09-04",
      baseline_complete: 6.9,
      actual_complete: 9.2,
      forecast_complete: 3.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-09-11",
      baseline_complete: 7.2,
      actual_complete: 9.2,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-09-18",
      baseline_complete: 7.6,
      actual_complete: 9.9,
      forecast_complete: 3.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-09-25",
      baseline_complete: 7.9,
      actual_complete: 10.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-10-02",
      baseline_complete: 8.3,
      actual_complete: 10.0,
      forecast_complete: 4.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-10-09",
      baseline_complete: 8.6,
      actual_complete: 10.0,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-10-16",
      baseline_complete: 9.0,
      actual_complete: 11.2,
      forecast_complete: 4.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-10-23",
      baseline_complete: 9.4,
      actual_complete: 11.7,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-10-30",
      baseline_complete: 9.9,
      actual_complete: 11.7,
      forecast_complete: 4.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-11-06",
      baseline_complete: 10.3,
      actual_complete: 11.7,
      forecast_complete: 5.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-11-13",
      baseline_complete: 10.7,
      actual_complete: 13.3,
      forecast_complete: 5.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-11-20",
      baseline_complete: 11.2,
      actual_complete: 13.3,
      forecast_complete: 5.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-11-27",
      baseline_complete: 11.7,
      actual_complete: 13.7,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-12-04",
      baseline_complete: 12.2,
      actual_complete: 13.7,
      forecast_complete: 5.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-12-11",
      baseline_complete: 12.7,
      actual_complete: 13.7,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-12-18",
      baseline_complete: 13.3,
      actual_complete: 13.7,
      forecast_complete: 6.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2024-12-25",
      baseline_complete: 13.8,
      actual_complete: 16.2,
      forecast_complete: 6.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-01-01",
      baseline_complete: 14.4,
      actual_complete: 16.2,
      forecast_complete: 7.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-01-08",
      baseline_complete: 15.0,
      actual_complete: 16.3,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-01-15",
      baseline_complete: 15.6,
      actual_complete: 16.8,
      forecast_complete: 7.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-01-22",
      baseline_complete: 16.3,
      actual_complete: 16.9,
      forecast_complete: 8.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-01-29",
      baseline_complete: 16.9,
      actual_complete: 18.5,
      forecast_complete: 8.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-02-05",
      baseline_complete: 17.6,
      actual_complete: 18.6,
      forecast_complete: 8.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-02-12",
      baseline_complete: 18.3,
      actual_complete: 20.3,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-02-19",
      baseline_complete: 19.1,
      actual_complete: 20.3,
      forecast_complete: 9.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-02-26",
      baseline_complete: 19.8,
      actual_complete: 20.6,
      forecast_complete: 9.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-03-05",
      baseline_complete: 20.6,
      actual_complete: 22.5,
      forecast_complete: 10.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-03-12",
      baseline_complete: 21.4,
      actual_complete: 22.7,
      forecast_complete: 10.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-03-19",
      baseline_complete: 22.2,
      actual_complete: 22.8,
      forecast_complete: 11.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-03-26",
      baseline_complete: 23.1,
      actual_complete: 25.1,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-04-02",
      baseline_complete: 23.9,
      actual_complete: 25.7,
      forecast_complete: 12.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-04-09",
      baseline_complete: 24.8,
      actual_complete: 26.5,
      forecast_complete: 12.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-04-16",
      baseline_complete: 25.7,
      actual_complete: 29.0,
      forecast_complete: 13.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-04-23",
      baseline_complete: 26.6,
      actual_complete: 29.1,
      forecast_complete: 13.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-04-30",
      baseline_complete: 27.6,
      actual_complete: 29.1,
      forecast_complete: 14.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-05-07",
      baseline_complete: 28.6,
      actual_complete: 29.1,
      forecast_complete: 14.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-05-14",
      baseline_complete: 29.5,
      actual_complete: 29.8,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-05-21",
      baseline_complete: 30.6,
      actual_complete: 31.2,
      forecast_complete: 16.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-05-28",
      baseline_complete: 31.6,
      actual_complete: 32.6,
      forecast_complete: 16.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-06-04",
      baseline_complete: 32.6,
      actual_complete: 33.9,
      forecast_complete: 17.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-06-11",
      baseline_complete: 33.7,
      actual_complete: 33.9,
      forecast_complete: 18.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-06-18",
      baseline_complete: 34.8,
      actual_complete: 36.2,
      forecast_complete: 18.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-06-25",
      baseline_complete: 35.9,
      actual_complete: 38.3,
      forecast_complete: 19.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-07-02",
      baseline_complete: 37.0,
      actual_complete: 38.6,
      forecast_complete: 20.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-07-09",
      baseline_complete: 38.1,
      actual_complete: 38.6,
      forecast_complete: 20.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-07-16",
      baseline_complete: 39.2,
      actual_complete: 41.2,
      forecast_complete: 21.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-07-23",
      baseline_complete: 40.4,
      actual_complete: 41.2,
      forecast_complete: 22.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-07-30",
      baseline_complete: 41.6,
      actual_complete: 41.9,
      forecast_complete: 23.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-08-06",
      baseline_complete: 42.7,
      actual_complete: 45.0,
      forecast_complete: 24.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-08-13",
      baseline_complete: 43.9,
      actual_complete: 45.0,
      forecast_complete: 24.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-08-20",
      baseline_complete: 45.1,
      actual_complete: 46.6,
      forecast_complete: 25.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-08-27",
      baseline_complete: 46.3,
      actual_complete: 46.6,
      forecast_complete: 26.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-09-03",
      baseline_complete: 47.5,
      actual_complete: 49.6,
      forecast_complete: 27.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-09-10",
      baseline_complete: 48.7,
      actual_complete: 50.4,
      forecast_complete: 28.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-09-17",
      baseline_complete: 49.9,
      actual_complete: 50.5,
      forecast_complete: 29.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-09-24",
      baseline_complete: 51.1,
      actual_complete: 52.7,
      forecast_complete: 30.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-10-01",
      baseline_complete: 52.3,
      actual_complete: 54.0,
      forecast_complete: 30.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-10-08",
      baseline_complete: 53.5,
      actual_complete: 54.0,
      forecast_complete: 31.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-10-15",
      baseline_complete: 54.7,
      actual_complete: 57.3,
      forecast_complete: 32.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-10-22",
      baseline_complete: 55.9,
      actual_complete: 57.3,
      forecast_complete: 33.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-10-29",
      baseline_complete: 57.0,
      actual_complete: 57.9,
      forecast_complete: 34.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-11-05",
      baseline_complete: 58.2,
      actual_complete: 58.8,
      forecast_complete: 35.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-11-12",
      baseline_complete: 59.4,
      actual_complete: 60.7,
      forecast_complete: 36.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-11-19",
      baseline_complete: 60.5,
      actual_complete: 61.5,
      forecast_complete: 37.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-11-26",
      baseline_complete: 61.7,
      actual_complete: 62.8,
      forecast_complete: 38.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-12-03",
      baseline_complete: 62.8,
      actual_complete: 65.9,
      forecast_complete: 39.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-12-10",
      baseline_complete: 63.9,
      actual_complete: 65.9,
      forecast_complete: 40.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-12-17",
      baseline_complete: 65.0,
      actual_complete: 65.9,
      forecast_complete: 41.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-12-24",
      baseline_complete: 66.1,
      actual_complete: 66.5,
      forecast_complete: 42.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2025-12-31",
      baseline_complete: 67.2,
      actual_complete: 70.0,
      forecast_complete: 43.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-01-07",
      baseline_complete: 68.2,
      actual_complete: 71.0,
      forecast_complete: 44.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-01-14",
      baseline_complete: 69.2,
      actual_complete: 72.7,
      forecast_complete: 44.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-01-21",
      baseline_complete: 70.3,
      actual_complete: 72.7,
      forecast_complete: 45.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-01-28",
      baseline_complete: 71.3,
      actual_complete: 72.7,
      forecast_complete: 46.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-02-04",
      baseline_complete: 72.2,
      actual_complete: 72.7,
      forecast_complete: 47.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-02-11",
      baseline_complete: 73.2,
      actual_complete: 73.4,
      forecast_complete: 48.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-02-18",
      baseline_complete: 74.1,
      actual_complete: 76.0,
      forecast_complete: 49.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-02-25",
      baseline_complete: 75.0,
      actual_complete: 76.7,
      forecast_complete: 50.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-03-04",
      baseline_complete: 75.9,
      actual_complete: 77.0,
      forecast_complete: 51.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-03-11",
      baseline_complete: 76.8,
      actual_complete: 79.0,
      forecast_complete: 52.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-03-18",
      baseline_complete: 77.6,
      actual_complete: 80.6,
      forecast_complete: 53.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-03-25",
      baseline_complete: 78.4,
      actual_complete: 80.6,
      forecast_complete: 54.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-04-01",
      baseline_complete: 79.2,
      actual_complete: 81.1,
      forecast_complete: 55.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-04-08",
      baseline_complete: 80.0,
      actual_complete: 82.9,
      forecast_complete: 55.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-04-15",
      baseline_complete: 80.8,
      actual_complete: 84.5,
      forecast_complete: 56.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-04-22",
      baseline_complete: 81.5,
      actual_complete: 84.5,
      forecast_complete: 57.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-04-29",
      baseline_complete: 82.2,
      actual_complete: 84.5,
      forecast_complete: 58.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-05-06",
      baseline_complete: 82.9,
      actual_complete: 84.5,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-05-13",
      baseline_complete: 83.6,
      actual_complete: 85.4,
      forecast_complete: 60.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-05-20",
      baseline_complete: 84.2,
      actual_complete: 85.4,
      forecast_complete: 60.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-05-27",
      baseline_complete: 84.9,
      actual_complete: 86.5,
      forecast_complete: 61.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-06-03",
      baseline_complete: 85.5,
      actual_complete: 88.0,
      forecast_complete: 62.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-06-10",
      baseline_complete: 86.1,
      actual_complete: 88.0,
      forecast_complete: 63.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-06-17",
      baseline_complete: 86.6,
      actual_complete: 88.3,
      forecast_complete: 64.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-06-24",
      baseline_complete: 87.2,
      actual_complete: 88.4,
      forecast_complete: 64.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-07-01",
      baseline_complete: 87.7,
      actual_complete: 88.4,
      forecast_complete: 65.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-07-08",
      baseline_complete: 88.2,
      actual_complete: 88.4,
      forecast_complete: 66.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-07-15",
      baseline_complete: 88.7,
      actual_complete: 90.8,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-07-22",
      baseline_complete: 89.2,
      actual_complete: 90.8,
      forecast_complete: 67.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-07-29",
      baseline_complete: 89.6,
      actual_complete: 90.8,
      forecast_complete: 68.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-08-05",
      baseline_complete: 90.1,
      actual_complete: 91.7,
      forecast_complete: 70.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-08-12",
      baseline_complete: 90.5,
      actual_complete: 92.7,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-08-19",
      baseline_complete: 90.9,
      actual_complete: 93.2,
      forecast_complete: 72.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-08-26",
      baseline_complete: 91.3,
      actual_complete: 93.2,
      forecast_complete: 73.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-09-02",
      baseline_complete: 91.7,
      actual_complete: 93.2,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-09-09",
      baseline_complete: 92.0,
      actual_complete: 93.8,
      forecast_complete: 75.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-09-16",
      baseline_complete: 92.4,
      actual_complete: 93.8,
      forecast_complete: 77.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-09-23",
      baseline_complete: 92.7,
      actual_complete: 93.8,
      forecast_complete: 78.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-09-30",
      baseline_complete: 93.0,
      actual_complete: 93.9,
      forecast_complete: 78.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-10-07",
      baseline_complete: 93.3,
      actual_complete: 93.9,
      forecast_complete: 79.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-10-14",
      baseline_complete: 93.6,
      actual_complete: 96.8,
      forecast_complete: 80.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-10-21",
      baseline_complete: 93.9,
      actual_complete: 97.0,
      forecast_complete: 81.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-10-28",
      baseline_complete: 94.2,
      actual_complete: 97.0,
      forecast_complete: 82.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-11-04",
      baseline_complete: 94.4,
      actual_complete: 97.0,
      forecast_complete: 83.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-11-11",
      baseline_complete: 94.7,
      actual_complete: 97.0,
      forecast_complete: 84.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-11-18",
      baseline_complete: 94.9,
      actual_complete: 97.0,
      forecast_complete: 85.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-11-25",
      baseline_complete: 95.1,
      actual_complete: 97.0,
      forecast_complete: 85.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-12-02",
      baseline_complete: 95.4,
      actual_complete: 97.1,
      forecast_complete: 86.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-12-09",
      baseline_complete: 95.6,
      actual_complete: 97.2,
      forecast_complete: 87.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-12-16",
      baseline_complete: 95.8,
      actual_complete: 97.2,
      forecast_complete: 88.2,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-12-23",
      baseline_complete: 95.9,
      actual_complete: 97.2,
      forecast_complete: 88.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2026-12-30",
      baseline_complete: 96.1,
      actual_complete: 97.2,
      forecast_complete: 89.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-01-06",
      baseline_complete: 96.3,
      actual_complete: 98.4,
      forecast_complete: 90.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-01-13",
      baseline_complete: 96.5,
      actual_complete: 98.4,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-01-20",
      baseline_complete: 96.6,
      actual_complete: 98.4,
      forecast_complete: 91.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-01-27",
      baseline_complete: 96.8,
      actual_complete: 99.4,
      forecast_complete: 92.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-02-03",
      baseline_complete: 96.9,
      actual_complete: 99.5,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-02-10",
      baseline_complete: 97.1,
      actual_complete: 99.5,
      forecast_complete: 93.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-02-17",
      baseline_complete: 97.2,
      actual_complete: 99.5,
      forecast_complete: 93.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-02-24",
      baseline_complete: 97.3,
      actual_complete: 99.7,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-03-03",
      baseline_complete: 97.5,
      actual_complete: 99.7,
      forecast_complete: 94.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-03-10",
      baseline_complete: 97.6,
      actual_complete: 99.7,
      forecast_complete: 95.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-03-17",
      baseline_complete: 97.7,
      actual_complete: 99.7,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-03-24",
      baseline_complete: 97.8,
      actual_complete: 99.7,
      forecast_complete: 95.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-03-31",
      baseline_complete: 97.9,
      actual_complete: 100.0,
      forecast_complete: 96.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-04-07",
      baseline_complete: 98.0,
      actual_complete: 100.0,
      forecast_complete: 96.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-04-14",
      baseline_complete: 98.1,
      actual_complete: 100.0,
      forecast_complete: 97.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-04-21",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-04-28",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 97.7,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-05-05",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-05-12",
      baseline_complete: 98.4,
      actual_complete: 100.0,
      forecast_complete: 98.3,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-05-19",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 98.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-05-26",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-06-02",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 99.1,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-06-09",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.4,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-06-16",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 99.6,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-06-23",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 99.8,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-06-30",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 99.9,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-07-07",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-07-14",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-07-21",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-07-28",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-08-04",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-08-11",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-08-18",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-08-25",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-09-01",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0763b796-9b92-694a-3f48-e184c55865df",
      reporting_date: "2027-09-08",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "0f7474ce-ea7a-95f9-aa51-343f4943c3bd": [
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-08-24",
      baseline_complete: 0.2,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-08-31",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-09-07",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-09-14",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-09-21",
      baseline_complete: 0.3,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-09-28",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-10-05",
      baseline_complete: 0.4,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-10-12",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-10-19",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-10-26",
      baseline_complete: 0.5,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-11-02",
      baseline_complete: 0.6,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-11-09",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-11-16",
      baseline_complete: 0.7,
      actual_complete: 0.0,
      forecast_complete: 1.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-11-23",
      baseline_complete: 0.8,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-11-30",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-12-07",
      baseline_complete: 0.9,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-12-14",
      baseline_complete: 1.0,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-12-21",
      baseline_complete: 1.1,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2024-12-28",
      baseline_complete: 1.2,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-01-04",
      baseline_complete: 1.3,
      actual_complete: 0.0,
      forecast_complete: 1.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-01-11",
      baseline_complete: 1.5,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-01-18",
      baseline_complete: 1.6,
      actual_complete: 0.0,
      forecast_complete: 1.5,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-01-25",
      baseline_complete: 1.8,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-02-01",
      baseline_complete: 1.9,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-02-08",
      baseline_complete: 2.1,
      actual_complete: 0.0,
      forecast_complete: 1.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-02-15",
      baseline_complete: 2.3,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-02-22",
      baseline_complete: 2.5,
      actual_complete: 0.0,
      forecast_complete: 1.7,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-03-01",
      baseline_complete: 2.8,
      actual_complete: 0.0,
      forecast_complete: 1.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-03-08",
      baseline_complete: 3.0,
      actual_complete: 0.7,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-03-15",
      baseline_complete: 3.3,
      actual_complete: 0.7,
      forecast_complete: 1.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-03-22",
      baseline_complete: 3.6,
      actual_complete: 0.8,
      forecast_complete: 2.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-03-29",
      baseline_complete: 4.0,
      actual_complete: 1.3,
      forecast_complete: 2.1,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-04-05",
      baseline_complete: 4.3,
      actual_complete: 1.3,
      forecast_complete: 2.2,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-04-12",
      baseline_complete: 4.7,
      actual_complete: 1.3,
      forecast_complete: 2.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-04-19",
      baseline_complete: 5.2,
      actual_complete: 1.8,
      forecast_complete: 2.5,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-04-26",
      baseline_complete: 5.6,
      actual_complete: 2.9,
      forecast_complete: 2.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-05-03",
      baseline_complete: 6.1,
      actual_complete: 3.7,
      forecast_complete: 2.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-05-10",
      baseline_complete: 6.7,
      actual_complete: 4.4,
      forecast_complete: 3.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-05-17",
      baseline_complete: 7.3,
      actual_complete: 4.4,
      forecast_complete: 3.2,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-05-24",
      baseline_complete: 7.9,
      actual_complete: 5.0,
      forecast_complete: 3.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-05-31",
      baseline_complete: 8.6,
      actual_complete: 5.1,
      forecast_complete: 3.7,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-06-07",
      baseline_complete: 9.4,
      actual_complete: 6.0,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-06-14",
      baseline_complete: 10.2,
      actual_complete: 7.5,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-06-21",
      baseline_complete: 11.1,
      actual_complete: 8.0,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-06-28",
      baseline_complete: 12.0,
      actual_complete: 9.1,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-07-05",
      baseline_complete: 13.0,
      actual_complete: 9.7,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-07-12",
      baseline_complete: 14.1,
      actual_complete: 12.2,
      forecast_complete: 5.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-07-19",
      baseline_complete: 15.2,
      actual_complete: 12.2,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-07-26",
      baseline_complete: 16.5,
      actual_complete: 14.3,
      forecast_complete: 6.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-08-02",
      baseline_complete: 17.8,
      actual_complete: 15.9,
      forecast_complete: 7.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-08-09",
      baseline_complete: 19.1,
      actual_complete: 17.4,
      forecast_complete: 7.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-08-16",
      baseline_complete: 20.6,
      actual_complete: 18.5,
      forecast_complete: 8.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-08-23",
      baseline_complete: 22.2,
      actual_complete: 21.3,
      forecast_complete: 9.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-08-30",
      baseline_complete: 23.8,
      actual_complete: 22.1,
      forecast_complete: 10.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-09-06",
      baseline_complete: 25.5,
      actual_complete: 22.5,
      forecast_complete: 10.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-09-13",
      baseline_complete: 27.3,
      actual_complete: 25.1,
      forecast_complete: 11.7,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-09-20",
      baseline_complete: 29.1,
      actual_complete: 26.7,
      forecast_complete: 12.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-09-27",
      baseline_complete: 31.1,
      actual_complete: 28.2,
      forecast_complete: 13.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-10-04",
      baseline_complete: 33.1,
      actual_complete: 31.8,
      forecast_complete: 14.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-10-11",
      baseline_complete: 35.1,
      actual_complete: 33.2,
      forecast_complete: 15.7,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-10-18",
      baseline_complete: 37.3,
      actual_complete: 35.6,
      forecast_complete: 16.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-10-25",
      baseline_complete: 39.4,
      actual_complete: 36.7,
      forecast_complete: 18.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-11-01",
      baseline_complete: 41.7,
      actual_complete: 40.8,
      forecast_complete: 19.2,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-11-08",
      baseline_complete: 43.9,
      actual_complete: 42.5,
      forecast_complete: 20.5,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-11-15",
      baseline_complete: 46.2,
      actual_complete: 45.0,
      forecast_complete: 21.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-11-22",
      baseline_complete: 48.5,
      actual_complete: 47.3,
      forecast_complete: 23.2,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-11-29",
      baseline_complete: 50.8,
      actual_complete: 48.2,
      forecast_complete: 24.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-12-06",
      baseline_complete: 53.1,
      actual_complete: 51.7,
      forecast_complete: 26.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-12-13",
      baseline_complete: 55.4,
      actual_complete: 53.6,
      forecast_complete: 27.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-12-20",
      baseline_complete: 57.6,
      actual_complete: 56.4,
      forecast_complete: 28.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2025-12-27",
      baseline_complete: 59.9,
      actual_complete: 57.9,
      forecast_complete: 30.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-01-03",
      baseline_complete: 62.0,
      actual_complete: 62.0,
      forecast_complete: 31.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-01-10",
      baseline_complete: 64.2,
      actual_complete: 62.6,
      forecast_complete: 33.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-01-17",
      baseline_complete: 66.3,
      actual_complete: 65.0,
      forecast_complete: 34.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-01-24",
      baseline_complete: 68.3,
      actual_complete: 67.1,
      forecast_complete: 36.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-01-31",
      baseline_complete: 70.2,
      actual_complete: 69.3,
      forecast_complete: 37.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-02-07",
      baseline_complete: 72.1,
      actual_complete: 71.4,
      forecast_complete: 39.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-02-14",
      baseline_complete: 73.9,
      actual_complete: 72.3,
      forecast_complete: 40.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-02-21",
      baseline_complete: 75.7,
      actual_complete: 75.0,
      forecast_complete: 42.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-02-28",
      baseline_complete: 77.3,
      actual_complete: 75.9,
      forecast_complete: 43.7,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-03-07",
      baseline_complete: 78.9,
      actual_complete: 78.6,
      forecast_complete: 45.1,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-03-14",
      baseline_complete: 80.4,
      actual_complete: 78.6,
      forecast_complete: 46.5,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-03-21",
      baseline_complete: 81.8,
      actual_complete: 80.9,
      forecast_complete: 47.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-03-28",
      baseline_complete: 83.1,
      actual_complete: 82.8,
      forecast_complete: 49.2,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-04-04",
      baseline_complete: 84.4,
      actual_complete: 82.8,
      forecast_complete: 50.5,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-04-11",
      baseline_complete: 85.6,
      actual_complete: 84.5,
      forecast_complete: 51.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-04-18",
      baseline_complete: 86.7,
      actual_complete: 84.6,
      forecast_complete: 53.1,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-04-25",
      baseline_complete: 87.7,
      actual_complete: 87.0,
      forecast_complete: 54.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-05-02",
      baseline_complete: 88.6,
      actual_complete: 87.9,
      forecast_complete: 55.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-05-09",
      baseline_complete: 89.5,
      actual_complete: 88.9,
      forecast_complete: 56.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-05-16",
      baseline_complete: 90.4,
      actual_complete: 91.4,
      forecast_complete: 57.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-05-23",
      baseline_complete: 91.1,
      actual_complete: 92.1,
      forecast_complete: 58.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-05-30",
      baseline_complete: 91.9,
      actual_complete: 92.1,
      forecast_complete: 60.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-06-06",
      baseline_complete: 92.5,
      actual_complete: 92.1,
      forecast_complete: 61.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-06-13",
      baseline_complete: 93.1,
      actual_complete: 93.2,
      forecast_complete: 62.1,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-06-20",
      baseline_complete: 93.7,
      actual_complete: 93.4,
      forecast_complete: 63.1,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-06-27",
      baseline_complete: 94.2,
      actual_complete: 94.5,
      forecast_complete: 64.1,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-07-04",
      baseline_complete: 94.7,
      actual_complete: 95.5,
      forecast_complete: 65.1,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-07-11",
      baseline_complete: 95.1,
      actual_complete: 95.5,
      forecast_complete: 66.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-07-18",
      baseline_complete: 95.6,
      actual_complete: 96.3,
      forecast_complete: 67.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-07-25",
      baseline_complete: 95.9,
      actual_complete: 96.3,
      forecast_complete: 67.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-08-01",
      baseline_complete: 96.3,
      actual_complete: 97.3,
      forecast_complete: 68.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-08-08",
      baseline_complete: 96.6,
      actual_complete: 97.3,
      forecast_complete: 69.7,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-08-15",
      baseline_complete: 96.9,
      actual_complete: 97.3,
      forecast_complete: 70.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-08-22",
      baseline_complete: 97.1,
      actual_complete: 97.5,
      forecast_complete: 71.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-08-29",
      baseline_complete: 97.4,
      actual_complete: 97.5,
      forecast_complete: 72.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-09-05",
      baseline_complete: 97.6,
      actual_complete: 97.5,
      forecast_complete: 73.1,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-09-12",
      baseline_complete: 97.8,
      actual_complete: 97.5,
      forecast_complete: 73.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-09-19",
      baseline_complete: 98.0,
      actual_complete: 97.5,
      forecast_complete: 74.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-09-26",
      baseline_complete: 98.2,
      actual_complete: 100.0,
      forecast_complete: 76.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-10-03",
      baseline_complete: 98.3,
      actual_complete: 100.0,
      forecast_complete: 77.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-10-10",
      baseline_complete: 98.5,
      actual_complete: 100.0,
      forecast_complete: 79.2,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-10-17",
      baseline_complete: 98.6,
      actual_complete: 100.0,
      forecast_complete: 80.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-10-24",
      baseline_complete: 98.7,
      actual_complete: 100.0,
      forecast_complete: 81.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-10-31",
      baseline_complete: 98.8,
      actual_complete: 100.0,
      forecast_complete: 83.1,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-11-07",
      baseline_complete: 98.9,
      actual_complete: 100.0,
      forecast_complete: 84.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-11-14",
      baseline_complete: 99.0,
      actual_complete: 100.0,
      forecast_complete: 85.5,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-11-21",
      baseline_complete: 99.1,
      actual_complete: 100.0,
      forecast_complete: 86.7,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-11-28",
      baseline_complete: 99.2,
      actual_complete: 100.0,
      forecast_complete: 87.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-12-05",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 88.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-12-12",
      baseline_complete: 99.3,
      actual_complete: 100.0,
      forecast_complete: 89.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-12-19",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 90.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2026-12-26",
      baseline_complete: 99.4,
      actual_complete: 100.0,
      forecast_complete: 91.6,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-01-02",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 92.5,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-01-09",
      baseline_complete: 99.5,
      actual_complete: 100.0,
      forecast_complete: 93.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-01-16",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.1,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-01-23",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 94.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-01-30",
      baseline_complete: 99.6,
      actual_complete: 100.0,
      forecast_complete: 95.5,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-02-06",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.2,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-02-13",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 96.8,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-02-20",
      baseline_complete: 99.7,
      actual_complete: 100.0,
      forecast_complete: 97.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-02-27",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-03-06",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.4,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-03-13",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 98.9,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-03-20",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.3,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-03-27",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 99.7,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-04-03",
      baseline_complete: 99.8,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-04-10",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-04-17",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-04-24",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-05-01",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-05-08",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-05-15",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-05-22",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
    {
      project_GUID: "0f7474ce-ea7a-95f9-aa51-343f4943c3bd",
      reporting_date: "2027-05-24",
      baseline_complete: 99.9,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
  "8bb673f5-3df8-71f5-c36f-11d4652ccd19": [
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-05-09",
      baseline_complete: 0.4,
      actual_complete: 3.9,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-05-16",
      baseline_complete: 0.4,
      actual_complete: 5.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-05-23",
      baseline_complete: 0.5,
      actual_complete: 5.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-05-30",
      baseline_complete: 0.5,
      actual_complete: 5.7,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-06-06",
      baseline_complete: 0.5,
      actual_complete: 5.7,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-06-13",
      baseline_complete: 0.6,
      actual_complete: 5.7,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-06-20",
      baseline_complete: 0.7,
      actual_complete: 5.7,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-06-27",
      baseline_complete: 0.7,
      actual_complete: 7.4,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-07-04",
      baseline_complete: 0.8,
      actual_complete: 7.4,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-07-11",
      baseline_complete: 0.9,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-07-18",
      baseline_complete: 0.9,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-07-25",
      baseline_complete: 1.0,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-08-01",
      baseline_complete: 1.1,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-08-08",
      baseline_complete: 1.2,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-08-15",
      baseline_complete: 1.4,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-08-22",
      baseline_complete: 1.5,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-08-29",
      baseline_complete: 1.6,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-09-05",
      baseline_complete: 1.8,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-09-12",
      baseline_complete: 1.9,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-09-19",
      baseline_complete: 2.1,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-09-26",
      baseline_complete: 2.3,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-10-03",
      baseline_complete: 2.6,
      actual_complete: 9.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-10-10",
      baseline_complete: 2.8,
      actual_complete: 9.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-10-17",
      baseline_complete: 3.1,
      actual_complete: 9.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-10-24",
      baseline_complete: 3.3,
      actual_complete: 9.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-10-31",
      baseline_complete: 3.7,
      actual_complete: 9.1,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-11-07",
      baseline_complete: 4.0,
      actual_complete: 10.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-11-14",
      baseline_complete: 4.4,
      actual_complete: 11.0,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-11-21",
      baseline_complete: 4.8,
      actual_complete: 11.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-11-28",
      baseline_complete: 5.2,
      actual_complete: 11.3,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-12-05",
      baseline_complete: 5.7,
      actual_complete: 13.2,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-12-12",
      baseline_complete: 6.2,
      actual_complete: 13.2,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-12-19",
      baseline_complete: 6.7,
      actual_complete: 13.2,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2025-12-26",
      baseline_complete: 7.3,
      actual_complete: 14.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-01-02",
      baseline_complete: 8.0,
      actual_complete: 14.6,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-01-09",
      baseline_complete: 8.7,
      actual_complete: 14.9,
      forecast_complete: 3.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-01-16",
      baseline_complete: 9.5,
      actual_complete: 14.9,
      forecast_complete: 4.0,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-01-23",
      baseline_complete: 10.3,
      actual_complete: 14.9,
      forecast_complete: 4.3,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-01-30",
      baseline_complete: 11.2,
      actual_complete: 14.9,
      forecast_complete: 4.6,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-02-06",
      baseline_complete: 12.1,
      actual_complete: 16.8,
      forecast_complete: 4.9,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-02-13",
      baseline_complete: 13.1,
      actual_complete: 16.8,
      forecast_complete: 5.3,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-02-20",
      baseline_complete: 14.2,
      actual_complete: 21.6,
      forecast_complete: 5.7,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-02-27",
      baseline_complete: 15.4,
      actual_complete: 21.6,
      forecast_complete: 6.2,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-03-06",
      baseline_complete: 16.6,
      actual_complete: 22.4,
      forecast_complete: 6.6,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-03-13",
      baseline_complete: 17.9,
      actual_complete: 22.4,
      forecast_complete: 7.2,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-03-20",
      baseline_complete: 19.3,
      actual_complete: 24.7,
      forecast_complete: 7.8,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-03-27",
      baseline_complete: 20.8,
      actual_complete: 24.7,
      forecast_complete: 8.4,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-04-03",
      baseline_complete: 22.4,
      actual_complete: 28.8,
      forecast_complete: 9.1,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-04-10",
      baseline_complete: 24.0,
      actual_complete: 28.8,
      forecast_complete: 9.8,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-04-17",
      baseline_complete: 25.7,
      actual_complete: 28.8,
      forecast_complete: 10.6,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-04-24",
      baseline_complete: 27.5,
      actual_complete: 33.0,
      forecast_complete: 11.5,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-05-01",
      baseline_complete: 29.4,
      actual_complete: 35.1,
      forecast_complete: 12.4,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-05-08",
      baseline_complete: 31.4,
      actual_complete: 37.1,
      forecast_complete: 13.4,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-05-15",
      baseline_complete: 33.4,
      actual_complete: 37.1,
      forecast_complete: 14.4,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-05-22",
      baseline_complete: 35.5,
      actual_complete: 38.0,
      forecast_complete: 15.5,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-05-29",
      baseline_complete: 37.6,
      actual_complete: 43.6,
      forecast_complete: 16.6,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-06-05",
      baseline_complete: 39.8,
      actual_complete: 43.6,
      forecast_complete: 17.8,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-06-12",
      baseline_complete: 42.0,
      actual_complete: 46.6,
      forecast_complete: 19.0,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-06-19",
      baseline_complete: 44.3,
      actual_complete: 50.5,
      forecast_complete: 20.4,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-06-26",
      baseline_complete: 46.6,
      actual_complete: 50.5,
      forecast_complete: 21.7,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-07-03",
      baseline_complete: 48.9,
      actual_complete: 54.3,
      forecast_complete: 23.1,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-07-10",
      baseline_complete: 51.2,
      actual_complete: 54.3,
      forecast_complete: 24.5,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-07-17",
      baseline_complete: 53.5,
      actual_complete: 56.3,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-07-24",
      baseline_complete: 55.8,
      actual_complete: 59.2,
      forecast_complete: 59.2,
    },
    {
      project_GUID: "8bb673f5-3df8-71f5-c36f-11d4652ccd19",
      reporting_date: "2026-07-31",
      baseline_complete: 58.0,
      actual_complete: 100.0,
      forecast_complete: 100.0,
    },
  ],
};

export const projectGUIDs: string[] = Object.keys(progressByProjectGUID);
export const allProgressPoints: ProgressPoint[] = Object.values(
  progressByProjectGUID
).flat();

// --- Compatibility exports for UI components ---
export type ScheduleProgressPoint = ProgressPoint;

/** Flattened list of all progress points across projects (convenient for filtering) */
export const scheduleProgressData: ScheduleProgressPoint[] = Object.values(
  progressByProjectGUID
).flat();

/** Get a single project's series, sorted by reporting_date ascending (YYYY-MM-DD). */
export function getScheduleProgressSeries(
  projectGUID: string
): ScheduleProgressPoint[] {
  // Case-insensitive GUID lookup (CLAUDE.md convention)
  const key = String(projectGUID || "").trim();
  const rows =
    progressByProjectGUID[key] ??
    progressByProjectGUID[key.toLowerCase()] ??
    progressByProjectGUID[key.toUpperCase()] ??
    scheduleProgressData.filter((r) => String(r.project_GUID || "").toUpperCase() === key.toUpperCase());
  // reporting_date is YYYY-MM-DD; lexical sort works, but keep a Date.parse fallback.
  return [...rows].sort((a, b) => {
    const ta = Date.parse(a.reporting_date);
    const tb = Date.parse(b.reporting_date);
    if (Number.isFinite(ta) && Number.isFinite(tb)) return ta - tb;
    return a.reporting_date.localeCompare(b.reporting_date);
  });
}
